import React, { createElement, createContext, useState, useContext, useEffect, Fragment, useRef, Children, useReducer, useMemo, useCallback } from 'react';
import { LoginWizard } from '@digital-retail/falabella-unified-login';
export { LoginWizard } from '@digital-retail/falabella-unified-login';
import PropTypes from 'prop-types';
import createContainer from 'constate';
import unset from 'lodash.unset';
import { isSodimacRetail as isSodimacRetail$1, isSodimacStandalone as isSodimacStandalone$1 } from '@digital-retail/store-manager';
import axios from 'axios';
import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';
import ReactDom, { createPortal } from 'react-dom';
import { useLoadScript, GoogleMap, Marker } from '@react-google-maps/api';
import { stringify } from 'query-string';
import LazyLoad from 'react-lazyload';
import Carousel from '@digital-retail/recommended-products';
import { CSSTransition } from 'react-transition-group';
import { CmrPuntosCategoryItem, useCmrPoints, CmrPuntosMenuMobile } from '@digital-retail/falabella-cmr-components';
import DOMPurify from 'isomorphic-dompurify';
import { agentLogout, logout } from '@digital-retail/fa-auth-sdk';
import SearchByImage from '@digital-retail/search-by-image';
import Quagga from 'quagga';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(o) {
  "@babel/helpers - typeof";
  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _typeof = unwrapExports(_typeof_1);

var toPrimitive_1 = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(toPrimitive_1);

var toPrimitive = toPrimitive_1;

var toPropertyKey_1 = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(toPropertyKey_1);

var toPropertyKey = toPropertyKey_1;

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _defineProperty = unwrapExports(defineProperty);

var _TENANT$CL, _TENANT$PE;
var TENANT = {
  CL: 'cl',
  PE: 'pe',
  CO: 'co',
  MX: 'mx'
};
var STORE = {
  FA_COM: 'fa_com',
  SO_COM: 'so_com',
  TO_COM: 'to_com',
  SODIMAC: 'sodimac',
  HOMECENTER: 'homecenter',
  TOTTUS: 'tottus',
  LINIO: 'linio',
  FA_CARTERS: 'fa_carters',
  FA_CRABARR: 'fa_crabarr',
  FA_ALDO: 'fa_aldo',
  FA_AMERICA: 'fa_america',
  FA_THEDROP: 'fa_thedrop',
  SO_RETAIL: 'so_retail'
};
var FALABELLA_ICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt1e527cb20edce8ff/falabella.com@16px.png',
  type: 'image/png'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt9c1b614e3006bfb4/falabella.com@32px.png',
  type: 'image/png'
}, {
  sizes: '48x48',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt06938395943d7be0/falabella.com@48px.png',
  type: 'image/png'
}, {
  sizes: '96x96',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blte19a4714338abfee/falabella.com@96px.png',
  type: 'image/png'
}, {
  sizes: '144x144',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltde5263bea5336415/Logo%20favicon@144px.png',
  type: 'image/png'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt6d5f10c547b6b474/falabella.com@180x.png',
  type: 'image/png'
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4e202d131dc5d31e/falabella.com@192px.png',
  type: 'image/png'
}, {
  sizes: '256x256',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltfac68fec040ae50d/falabella.com@256px.png',
  type: 'image/png'
}];
var SODIMAC_FAVICONS = [{
  sizes: '48x48',
  rel: 'icon',
  href: 'https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blta6bf10a4c1cac4da/Sodimac48.png',
  type: 'image/png'
}, {
  sizes: '96x96',
  rel: 'icon',
  href: 'https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt2208fa5442c384b3/Sodimac96.png',
  type: 'image/png'
}, {
  sizes: '144x144',
  rel: 'icon',
  href: 'https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt49a6f6934ded3134/Sodimac144.png',
  type: 'image/png'
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/bltcf215412183f0b18/Sodimac192.png',
  type: 'image/png'
}];
var TOTTUS_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc717242d6e3cb40e/Tottus@16px.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7cea2811922a2fb8/Tottus@32px.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt12137dde9c3944ce/Tottus@180x.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt731539d15505e022/Tottus@192px.png',
  type: 'image/svg+xml'
}];
var LINIO_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt5895e6819aea46b4/Linio@16px.png',
  type: 'image/svg+xml'
}, {
  sizes: '16x16',
  rel: 'alternate icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt5895e6819aea46b4/Linio@16px.png',
  type: 'image/png'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc00cf0d95916e89f/Linio@32px.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'alternate icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc00cf0d95916e89f/Linio@32px.png',
  type: 'image/png'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4995fbc240a6d726/Linio@180x.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt74633fecc79cb482/Linio@192px.png',
  type: 'image/svg+xml'
}, {
  sizes: '192x192',
  rel: 'alternate icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt74633fecc79cb482/Linio@192px.png',
  type: 'image/png'
}, {
  sizes: '256x256',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt953944608a731c85/Linio@256px.png',
  type: 'image/svg+xml'
}, {
  sizes: '256x256',
  rel: 'alternate icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt953944608a731c85/Linio@256px.png',
  type: 'image/png'
}];
var CARTERS_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/bltda651110224c91f1/67bc17d8eca79088e329ed9f/carters-16x16.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt0f8e3b763c746a6e/67bc17d85aed499388f7ddc5/carters-32x32.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt95eaa90cb8f61c25/67bc17d99570312b5690453d/carters-180x180.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blta7dee384d54a9c47/67bc17d8c8662648d2c73bc9/carters-192x192.png',
  type: 'image/svg+xml'
}];
var CRABARR_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt69f450d615472b82/67bc1acb9570316f1c904556/crabarr-16x16.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt910ad5153952b8ab/67bc1acbaff4753a5beed630/crabarr-32x32.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt641c17ca50dad7cd/67bc1acbe1c143da5796b73d/crabarr-180x180.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/bltd53e161eac4fa476/67bc1acbeca79047a929edac/crabarr-192x192.png',
  type: 'image/svg+xml'
}];
var ALDO_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/bltd79378f2c328e071/67bc19b0d4f68bf0c59cae28/aldo-16x16.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt3e62b694abe458e3/67bc19b01ce4bd0bb64b7455/aldo-32x32.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt93e47b7073eb0525/67bc19b17259055779b7a0bc/aldo-180x180.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt09308f714f4e6a4e/67bc19b03cf087d41c85febe/aldo-192x192.png',
  type: 'image/svg+xml'
}];
var AMERICANINO_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt7e4f7a76a8c42b56/67bc1b5dc86626df8bc73bdb/americanino-16x16.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt8e3e3ae5a574043f/67bc1b5dd4f68b814a9cae2f/americanino-32x32.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt755cb88f10a88184/67bc1b5d55356963914ff074/americanino-180x180.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blte5f5d9bfadadb5c4/67bc1b5e4c7ca4154bcb2046/americanino-192x192.png',
  type: 'image/svg+xml'
}];
var THEDROPZONE_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt0baba19ee88ca34f/68f79e4ec42a3d71d45cad8f/favicon-16x16.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/bltbb31dd8015ff197c/68f79e4e1ecf826c8028b259/favicon-32x32.png',
  type: 'image/svg+xml'
}, {
  sizes: '48x48',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt839153e0b0736dc4/68f7a0c0546d426e97d742df/favicon-48x48.png',
  type: 'image/png'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blta9fbced76b2f1cbd/68f79e4ff70b62593ce7561f/apple-touch-icon.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt9d612a858ec4c070/68f79e4e63452b80211f10f2/android-chrome-192x192.png',
  type: 'image/svg+xml'
}, {
  sizes: '512x512',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/bltb22f76363551368b/68f79e4ec6270aebcbfdf998/android-chrome-512x512.png',
  type: 'image/svg+xml'
}];
var SIS_SODIMAC_FAVICONS = [{
  sizes: '48x48',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt34d59f5b52e53f95/blt6ed9b37e8ee77f78/sis-so-x48.png',
  type: 'image/png'
}, {
  sizes: '96x96',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt34d59f5b52e53f95/bltb10493209a9a7545/sis-so-x96.png',
  type: 'image/png'
}, {
  sizes: '144x144',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt34d59f5b52e53f95/blt5392113a0e949586/sis-so-x144.png',
  type: 'image/png'
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt34d59f5b52e53f95/bltb7c977de854777a9/sis-so-x192.png',
  type: 'image/png'
}];
var FAVICONS = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, TENANT.CL, (_TENANT$CL = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_TENANT$CL, STORE.FA_COM, FALABELLA_ICONS), STORE.SODIMAC, SIS_SODIMAC_FAVICONS), STORE.TOTTUS, TOTTUS_FAVICONS), STORE.LINIO, LINIO_FAVICONS), STORE.SO_COM, SODIMAC_FAVICONS), STORE.TO_COM, TOTTUS_FAVICONS), STORE.FA_CARTERS, CARTERS_FAVICONS), STORE.FA_CRABARR, CRABARR_FAVICONS), STORE.FA_ALDO, ALDO_FAVICONS), STORE.FA_AMERICA, AMERICANINO_FAVICONS), _defineProperty(_TENANT$CL, STORE.FA_THEDROP, THEDROPZONE_FAVICONS))), TENANT.PE, (_TENANT$PE = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_TENANT$PE, STORE.FA_COM, FALABELLA_ICONS), STORE.SODIMAC, SIS_SODIMAC_FAVICONS), STORE.TOTTUS, TOTTUS_FAVICONS), STORE.LINIO, LINIO_FAVICONS), STORE.SO_COM, SODIMAC_FAVICONS), STORE.TO_COM, TOTTUS_FAVICONS), STORE.FA_CARTERS, CARTERS_FAVICONS), STORE.FA_CRABARR, CRABARR_FAVICONS), STORE.FA_ALDO, ALDO_FAVICONS), STORE.FA_AMERICA, AMERICANINO_FAVICONS), _defineProperty(_TENANT$PE, STORE.FA_THEDROP, THEDROPZONE_FAVICONS))), TENANT.CO, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, STORE.FA_COM, FALABELLA_ICONS), STORE.HOMECENTER, FALABELLA_ICONS), STORE.LINIO, LINIO_FAVICONS), STORE.FA_CARTERS, CARTERS_FAVICONS), STORE.FA_CRABARR, CRABARR_FAVICONS), STORE.FA_ALDO, ALDO_FAVICONS), STORE.FA_AMERICA, AMERICANINO_FAVICONS), STORE.FA_THEDROP, THEDROPZONE_FAVICONS)), TENANT.MX, _defineProperty(_defineProperty({}, STORE.SO_RETAIL, SODIMAC_FAVICONS), "SO_RETAIL", SODIMAC_FAVICONS));

function ownKeys$M(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$M(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$M(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$M(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_STORE = STORE.FA_COM;
function isValid(value, validValuesMap) {
  return Object.values(validValuesMap).includes(value);
}
function getRawData(args) {
  var _FAVICONS$args$tenant, _FAVICONS$args$tenant2;
  if (!args || !args.tenant || !isValid(args.tenant, TENANT)) {
    return [];
  }
  var selectedStore = !isValid(args.store, STORE) ? DEFAULT_STORE : args.store;
  return (_FAVICONS$args$tenant = FAVICONS === null || FAVICONS === void 0 || (_FAVICONS$args$tenant2 = FAVICONS[args.tenant]) === null || _FAVICONS$args$tenant2 === void 0 ? void 0 : _FAVICONS$args$tenant2[selectedStore]) !== null && _FAVICONS$args$tenant !== void 0 ? _FAVICONS$args$tenant : [];
}
function render(props) {
  if (!props) {
    return null;
  }
  var favicons = getRawData(props);
  var renderFavicon = function renderFavicon(attrs, index) {
    return createElement('link', _objectSpread$M({
      key: "".concat(attrs.href, "-").concat(index)
    }, attrs));
  };
  var renderFavicons = function renderFavicons(faviconList) {
    return faviconList.map(renderFavicon);
  };
  if (!favicons.length) {
    return null;
  }
  return renderFavicons(favicons);
}
var Favicons = {
  get: getRawData,
  render: render
};

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _asyncToGenerator = unwrapExports(asyncToGenerator);

var arrayWithHoles$1 = createCommonjsModule(function (module) {
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(arrayWithHoles$1);

var iterableToArrayLimit$1 = createCommonjsModule(function (module) {
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(iterableToArrayLimit$1);

var arrayLikeToArray$1 = createCommonjsModule(function (module) {
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(arrayLikeToArray$1);

var arrayLikeToArray = arrayLikeToArray$1;

var unsupportedIterableToArray$1 = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(unsupportedIterableToArray$1);

var nonIterableRest$1 = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(nonIterableRest$1);

var arrayWithHoles = arrayWithHoles$1;

var iterableToArrayLimit = iterableToArrayLimit$1;

var unsupportedIterableToArray = unsupportedIterableToArray$1;

var nonIterableRest = nonIterableRest$1;

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(r, e) {
  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _slicedToArray = unwrapExports(slicedToArray);

var OverloadYield$1 = createCommonjsModule(function (module) {
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(OverloadYield$1);

var regeneratorDefine$1 = createCommonjsModule(function (module) {
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
}
module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(regeneratorDefine$1);

var regeneratorDefine = regeneratorDefine$1;

var regenerator$2 = createCommonjsModule(function (module) {
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
    return this;
  }), regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (module.exports = _regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(regenerator$2);

var OverloadYield = OverloadYield$1;

var regeneratorAsyncIterator$1 = createCommonjsModule(function (module) {
function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(regeneratorAsyncIterator$1);

var regenerator$1 = regenerator$2;

var regeneratorAsyncIterator = regeneratorAsyncIterator$1;

var regeneratorAsyncGen$1 = createCommonjsModule(function (module) {
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new regeneratorAsyncIterator(regenerator$1().w(r, e, t, o), n || Promise);
}
module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(regeneratorAsyncGen$1);

var regeneratorAsyncGen = regeneratorAsyncGen$1;

var regeneratorAsync$1 = createCommonjsModule(function (module) {
function _regeneratorAsync(n, e, r, t, o) {
  var a = regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(regeneratorAsync$1);

var regeneratorKeys$1 = createCommonjsModule(function (module) {
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(regeneratorKeys$1);

var regeneratorValues$1 = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(regeneratorValues$1);

var regeneratorAsync = regeneratorAsync$1;

var regeneratorKeys = regeneratorKeys$1;

var regeneratorValues = regeneratorValues$1;

var regeneratorRuntime$1 = createCommonjsModule(function (module) {
function _regeneratorRuntime() {
  var r = regenerator$1(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new OverloadYield(r, e);
      },
      AsyncIterator: regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: regeneratorKeys,
      values: regeneratorValues
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(regeneratorRuntime$1);

var require$$0 = regeneratorRuntime$1;

var runtime = require$$0();
var regenerator = runtime;
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
var _regeneratorRuntime = regenerator;

var isWindow$2 = function isWindow() {
  return process.browser;
};
var DEFAULT_COOKIE_DOMAIN = '.falabella.com';
var CookieSchema = {
  zoneData: {
    type: 'object',
    encoded: true
  },
  zones: {
    type: 'string',
    encoded: false
  },
  locationData: {
    type: 'object',
    encoded: true
  },
  customerData: {
    type: 'object',
    encoded: true
  },
  DYN_USER_ID: {
    type: 'string',
    encoded: false
  },
  DYNAMIC_DATA_COOKIE: {
    type: 'string',
    encoded: false
  },
  VENDOR_DATA: {
    type: 'string',
    encoded: false
  },
  AGENT_DATA: {
    type: 'string',
    encoded: false
  },
  CATALYST_DATA_COOKIE: {
    type: 'string',
    encoded: false
  },
  IS_PRESSURE_MODAL_INTERACTED: {
    type: 'string',
    encoded: false
  },
  IS_ZONE_SELECTED: {
    type: 'string',
    encoded: false
  },
  NAVIGATION_TAGS: {
    type: 'object',
    encoded: true
  },
  priceGroupId: {
    type: 'string',
    encoded: false
  },
  politicalId: {
    type: 'string',
    encoded: false
  },
  contextID: {
    type: 'string',
    endcoded: false
  },
  isPoliticalIdExists: {
    type: 'bool',
    encoded: false
  },
  SIS_NAVIGATION_TAGS: {
    type: 'object',
    encoded: true
  },
  HEADER_TAGS: {
    type: 'object',
    encoded: true
  },
  FOOTER_TAGS: {
    type: 'object',
    encoded: true
  },
  KIOSKO_STORE_ID: {
    type: 'string',
    encoded: false
  },
  KIOSKO_MODULO: {
    type: 'string',
    encoded: false
  },
  userSegments: {
    type: 'object',
    encoded: true
  },
  SEARCH_BY_IMAGE_TAGS: {
    type: 'object',
    encoded: true
  }
};
var getTagFromCookie = function getTagFromCookie() {
  var cookies = document.cookie;
  var tagName = cookies.match(/(NAVIGATION_TAGS|SIS_NAVIGATION_TAGS|HEADER_TAGS|FOOTER_TAGS|SEARCH_BY_IMAGE_TAGS)/);
  return tagName && tagName[0] || '';
};
var isSodimacSite = function isSodimacSite() {
  return /sodimac\.(cl|com\.pe|com\.mx)/.test(window.location.origin);
};
var isTottusSite = function isTottusSite() {
  return /tottus\.(cl|com\.pe)/.test(window.location.origin);
};
var isWhitelabelSite = function isWhitelabelSite() {
  return /(americanino|carters|crateandbarrel|aldo|aldoshoes|thedropzone)\.(cl|com\.pe|com\.co)/.test(window.location.origin);
};
var getCookie = function getCookie(cookieName) {
  var result = document.cookie.match("(^|;)\\s*".concat(cookieName, "\\s*=\\s*([^;]+)"));
  return result ? result.pop() : '';
};
var isCatalyst = function isCatalyst() {
  var experience = getCookie('experience');
  return experience === 'CATALYST';
};
var encode = function encode(raw) {
  return isWindow$2() ? btoa(unescape(encodeURIComponent(raw))) : Buffer.from(raw).toString('base64');
};
function getWhitelabelCookieDomain() {
  var _window$location$host = window.location.hostname,
    hostname = _window$location$host === void 0 ? '' : _window$location$host;
  var prefixes = ['www.', 'beta.', 'staging.'];
  var cleanedHostname = prefixes.reduce(function (acc, prefix) {
    if (acc.startsWith(prefix)) {
      return acc.substring(prefix.length);
    }
    return acc;
  }, hostname);
  return ".".concat(cleanedHostname);
}
var getHost$1 = function getHost(regionCode) {
  var sodimacHosts = {
    cl: '.sodimac.cl',
    pe: '.sodimac.com.pe',
    mx: '.sodimac.com.mx'
  };
  var tottusHosts = {
    cl: '.tottus.cl',
    pe: '.tottus.com.pe'
  };
  if (isSodimacSite()) {
    return sodimacHosts[regionCode];
  }
  if (isTottusSite()) {
    return tottusHosts[regionCode];
  }
  if (isWhitelabelSite()) {
    return getWhitelabelCookieDomain();
  }
  var domain = DEFAULT_COOKIE_DOMAIN;
  var region = '';
  if (regionCode === 'cl' || !regionCode) {
    region = '';
  } else {
    region = ".".concat(regionCode);
  }
  return "".concat(domain).concat(region);
};
var setCookie = function setCookie(_ref) {
  var name = _ref.name,
    value = _ref.value,
    _ref$expiryDays = _ref.expiryDays,
    expiryDays = _ref$expiryDays === void 0 ? 1000 : _ref$expiryDays,
    domain = _ref.domain,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/' : _ref$path,
    _ref$addQuotes = _ref.addQuotes,
    addQuotes = _ref$addQuotes === void 0 ? false : _ref$addQuotes,
    regionCode = _ref.regionCode,
    maxAge = _ref.maxAge;
  var cookie = value;
  var expiration = '';
  var domainStr = ";domain=".concat(domain || getHost$1(regionCode));
  var pathStr = ";path=".concat(path);
  var schema = CookieSchema[name];
  if (schema) {
    if (schema.type === 'object') {
      cookie = JSON.stringify(cookie);
    }
    cookie = schema.encoded ? encode(cookie) : cookie;
  }
  if (maxAge) {
    expiration = "; max-age=".concat(maxAge);
  } else {
    var date = new Date();
    var DAY = 24 * 60 * 60 * 1000;
    date.setTime(date.getTime() + expiryDays * DAY);
    expiration = "; expires=".concat(date.toGMTString());
  }
  var cookieStr = "".concat(name, "=").concat(cookie).concat(domainStr).concat(pathStr).concat(expiration, "; Priority=High");
  if (addQuotes) {
    cookieStr = "\"".concat(cookieStr, "\"");
  }
  if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
    document.cookie = cookieStr;
    return cookieStr;
  }
  return false;
};
var setHostOnlySessionCookie = function setHostOnlySessionCookie(_ref2) {
  var name = _ref2.name,
    value = _ref2.value,
    _ref2$path = _ref2.path,
    path = _ref2$path === void 0 ? '/' : _ref2$path;
  var cookie = value;
  var pathStr = ";path=".concat(path);
  var schema = CookieSchema[name];
  if (schema) {
    if (schema.type === 'object') {
      cookie = JSON.stringify(cookie);
    }
    cookie = schema.encoded ? encode(cookie) : cookie;
  }
  var cookieStr = "".concat(name, "=").concat(cookie).concat(pathStr);
  if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
    document.cookie = cookieStr;
    return cookieStr;
  }
  return false;
};
var setHostOnlyCookie = function setHostOnlyCookie(_ref3) {
  var name = _ref3.name,
    value = _ref3.value,
    _ref3$expiryDays = _ref3.expiryDays,
    expiryDays = _ref3$expiryDays === void 0 ? 1000 : _ref3$expiryDays,
    _ref3$path = _ref3.path,
    path = _ref3$path === void 0 ? '/' : _ref3$path;
  var cookie = value;
  var expiration = '';
  var pathStr = ";path=".concat(path);
  var schema = CookieSchema[name];
  if (schema) {
    if (schema.type === 'object') {
      cookie = JSON.stringify(cookie);
    }
    cookie = schema.encoded ? encode(cookie) : cookie;
  }
  if (expiryDays) {
    var date = new Date();
    var DAY = 24 * 60 * 60 * 1000;
    date.setTime(date.getTime() + expiryDays * DAY);
    expiration = "; expires=".concat(date.toGMTString());
  }
  var cookieStr = "".concat(name, "=").concat(cookie).concat(pathStr).concat(expiration);
  if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
    document.cookie = cookieStr;
    return cookieStr;
  }
  return false;
};
var removeCookie = function removeCookie(_ref4) {
  var name = _ref4.name;
  if (isWindow$2()) {
    document.cookie = "".concat(name, "= ; expires=Thu, 01 Jan 1970 00:00:01 GMT;");
  }
};
var removeCookieByDomain = function removeCookieByDomain(_ref5) {
  var name = _ref5.name,
    _ref5$domain = _ref5.domain,
    domain = _ref5$domain === void 0 ? DEFAULT_COOKIE_DOMAIN : _ref5$domain;
  if (typeof window !== 'undefined') {
    document.cookie = "".concat(name, "= ; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=").concat(domain, "; path=/;");
  }
};
var unescapeATGCookies = function unescapeATGCookies(str) {
  return decodeURIComponent(str).replace('+', ' ');
};
var escapeATGCookies = function escapeATGCookies(str) {
  return encodeURIComponent(str.replace('', '+'));
};
var getUserDataCookieName = function getUserDataCookieName() {
  return isCatalyst() ? 'CATALYST_DATA_COOKIE' : 'DYNAMIC_DATA_COOKIE';
};
var getAgentDataCookie = function getAgentDataCookie() {
  return isCatalyst() ? 'AGENT_INFO' : 'AGENT_DATA';
};
var getVendorDataCookie = function getVendorDataCookie() {
  return isCatalyst() ? 'KIOSKO_INFO' : 'VENDOR_DATA';
};
var decode = function decode(raw) {
  var regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  try {
    if (regex.test(raw)) {
      return isWindow$2() ? decodeURIComponent(escape(window.atob(raw.replace(/"/g, '')))) : Buffer.from(raw, 'base64').toString();
    }
    return false;
  } catch (err) {
    return false;
  }
};
var parseCookieValue = function parseCookieValue(name, value) {
  if (!value) return undefined;
  var _ref6 = CookieSchema[name] || {},
    encoded = _ref6.encoded,
    type = _ref6.type;
  var decodedValue = encoded ? decode(value) : value;
  if (type === 'object') {
    try {
      return JSON.parse(decodedValue);
    } catch (e) {
      return undefined;
    }
  }
  return decodedValue;
};
var parseCookies = function parseCookies(str) {
  if (!str || str === '') {
    return {};
  }
  var cookies = {};
  str.split(';').forEach(function (cookie) {
    var c = cookie.split('=');
    var name = c[0].trim();
    var value = c[1];
    cookies[name] = parseCookieValue(name, value);
  });
  return cookies;
};
var getKioskoModuleCookieName = function getKioskoModuleCookieName() {
  return 'KIOSKO_MODULO';
};
var getKioskoStoreCookieName = function getKioskoStoreCookieName() {
  return 'KIOSKO_STORE_ID';
};
var CookieStorage = {
  setCookie: setCookie,
  getCookie: getCookie,
  removeCookie: removeCookie,
  removeCookieByDomain: removeCookieByDomain,
  unescapeATGCookies: unescapeATGCookies,
  escapeATGCookies: escapeATGCookies,
  getUserDataCookieName: getUserDataCookieName,
  parseCookies: parseCookies,
  getAgentDataCookie: getAgentDataCookie,
  isCatalyst: isCatalyst,
  setHostOnlyCookie: setHostOnlyCookie,
  setHostOnlySessionCookie: setHostOnlySessionCookie,
  getVendorDataCookie: getVendorDataCookie,
  parseCookieValue: parseCookieValue,
  getHost: getHost$1,
  isWindow: isWindow$2,
  encode: encode,
  decode: decode,
  getTagFromCookie: getTagFromCookie,
  getKioskoModuleCookieName: getKioskoModuleCookieName,
  getKioskoStoreCookieName: getKioskoStoreCookieName
};
var CookieStorage$1 = CookieStorage;

var getNestedValue = function getNestedValue(obj, path) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  if (!obj || _typeof(obj) !== 'object' || !path) {
    return defaultValue;
  }
  try {
    return path.split('.').reduce(function (current, key) {
      return current && _typeof(current) === 'object' && key in current ? current[key] : defaultValue;
    }, obj);
  } catch (error) {
    return defaultValue;
  }
};

function ownKeys$L(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$L(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$L(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$L(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var countriesCode = {
  FACL: 'cl',
  FAAR: 'ar',
  FACO: 'co',
  FAPE: 'pe',
  CORP: 'corp',
  SOMX: 'mx'
};
_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, countriesCode.FACL, [{
  title: 'HORARIO DE TIENDAS',
  url: 'https://www.falabella.com/falabella-cl/page/HoraSIS_NAVIGATIONrios-especiales?sid=HO_HH_APE_27&amp;staticPageId=38100001&amp;uxref=horarios'
}, {
  title: 'MARKETPLACE',
  url: 'https://www.falabella.com/falabella-cl/page/Market-Place?staticPageId=42100009&amp;uxref=marketplace'
}, {
  title: 'FALABELLA SOSTENIBLE',
  url: 'https://www.falabella.com/falabella-cl/page/Falabella-Sostenible?staticPageId=22500003&amp;uxref=sostenible'
}, {
  title: 'CLUB BEBÉ',
  url: 'https://www.celebracionesfalabella.com/bebe/?uxref=bebe'
}, {
  title: 'NOVIOS',
  url: 'https://www.noviosfalabella.com/noviosclpr/public/inicio.do?uxref=novios'
}, {
  title: 'CMR PUNTOS',
  url: 'https://www.falabella.com/falabella-cl/page/Puntos-CMR?staticPageId=40200001&amp;uxref=cmrpuntos'
}]), countriesCode.FAAR, [{
  title: 'NUESTRAS TIENDAS',
  url: 'https://www.falabella.com.ar/falabella-ar/page/Nuestras-tiendas?staticPageId=10200005&amp;uxref=tiendas'
}, {
  title: 'EVENTOS ONLINE',
  url: 'https://falabellabeautyweeks.com.ar/?uxref=eventos'
}, {
  title: 'SERVICIO AL CLIENTE',
  url: 'https://www.falabella.com.ar/falabella-ar/page/Servicio-al-cliente?staticPageId=10200044&amp;uxref=sac'
}, {
  title: 'MARKETPLACE',
  url: 'https://www.falabella.com.ar/falabella-ar/page/Market-Place?staticPageId=11900001&amp;uxref=marketplace'
}, {
  title: 'NOVIOS',
  url: 'https://www.falabellanovios.com.ar/novios-ar/public/inicio.do?uxref=novios'
}, {
  title: 'CMR',
  url: 'https://www.cmrfalabella.com.ar/home?uxref=cmr'
}]), countriesCode.FAPE, [{
  title: 'NUESTRAS TIENDAS',
  url: 'https://www.falabella.com.pe/falabella-pe/category/cat50668/Hoy-en-tiendas'
}, {
  title: 'NOVIOS',
  url: 'https://www.noviosfalabella.com.pe/novios-pe/public/inicio.do'
}, {
  title: 'CMR PUNTOS',
  url: 'https://cmr-points-pe.azurewebsites.net/'
}, {
  title: 'PAGA TU CMR',
  url: 'https://pagorapido.bancofalabella.pe/?utm_source=falabella&amp;utm_medium=web&amp;utm_campaign=001cmr_pagorapidocmr_falabella_conversiones&amp;utm_term=pagorapidocmr_audienciaabierta&amp;utm_content=web_bannerpagorapidocmr'
}]), countriesCode.FACO, []), countriesCode.SOMX, []);
var footerData = {
  linkStyles: {
    backgroundColor: '#1a1a1a',
    fontSize: 12,
    fontColor: '#bbb',
    textAlign: 'left'
  },
  countryStyles: {
    enabled: true,
    textAlign: 'center',
    fontSize: 13,
    fontColor: '#888'
  }
};
({
  country_flags: [{
    tenant: countriesCode.FAAR,
    flag: 'https://image.flaticon.com/icons/svg/323/323346.svg'
  }, {
    tenant: countriesCode.FACO,
    flag: 'https://image.flaticon.com/icons/svg/197/197575.svg'
  }, {
    tenant: countriesCode.FACL,
    flag: 'https://image.flaticon.com/icons/svg/197/197586.svg'
  }, {
    tenant: countriesCode.FAPE,
    flag: 'https://image.flaticon.com/icons/svg/197/197563.svg'
  }, {
    tenant: countriesCode.CORP,
    flag: 'https://logoeps.com/wp-content/uploads/2012/12/saga-falabella-vector-logo.png'
  }, {
    tenant: countriesCode.SOMX,
    flag: ''
  }]
});
var analyticsInfo = {
  tagManager: {
    CL: {
      dev: 'https://assets.adobedtm.com/68ade2efaac6/05d444b949be/launch-1bb58d6e7e5d-staging.min.js',
      staging: 'https://assets.adobedtm.com/68ade2efaac6/05d444b949be/launch-1bb58d6e7e5d-staging.min.js',
      beta: 'https://assets.adobedtm.com/68ade2efaac6/05d444b949be/launch-e4e4d4b7b172.min.js',
      production: 'https://assets.adobedtm.com/68ade2efaac6/05d444b949be/launch-e4e4d4b7b172.min.js',
      sodimac: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/50ed25745533/launch-8ae7b195ca2b-development.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/50ed25745533/launch-19f3e45a2aa6-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/50ed25745533/launch-e75c8f9f59e6.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/50ed25745533/launch-e75c8f9f59e6.min.js'
      },
      tottus: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/04ae81e3c783/launch-b0e6a4c8ed33-staging.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/04ae81e3c783/launch-b0e6a4c8ed33-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/04ae81e3c783/launch-5782fcdb04f2-development.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/04ae81e3c783/launch-e9900040a231.min.js'
      }
    },
    CO: {
      dev: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-2d8fb54d95f7-staging.min.js',
      staging: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-2d8fb54d95f7-staging.min.js',
      beta: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-329acd7108ae.min.js',
      production: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-329acd7108ae.min.js',
      sodimac: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-2d8fb54d95f7-staging.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-2d8fb54d95f7-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-329acd7108ae.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-329acd7108ae.min.js'
      }
    },
    PE: {
      dev: 'https://assets.adobedtm.com/68ade2efaac6/5617a0aafdc7/launch-029a964ec6d1-staging.min.js',
      staging: 'https://assets.adobedtm.com/68ade2efaac6/5617a0aafdc7/launch-029a964ec6d1-staging.min.js',
      beta: 'https://assets.adobedtm.com/68ade2efaac6/5617a0aafdc7/launch-d384ece6950a.min.js',
      production: 'https://assets.adobedtm.com/68ade2efaac6/5617a0aafdc7/launch-d384ece6950a.min.js',
      sodimac: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/9c1be53b5ebb/launch-7673274bc3ed-development.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/9c1be53b5ebb/launch-7c1626f7c981-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/9c1be53b5ebb/launch-495f63f5a78b.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/9c1be53b5ebb/launch-495f63f5a78b.min.js'
      },
      tottus: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/5503e49298c7/launch-af969c0b201a-staging.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/5503e49298c7/launch-af969c0b201a-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/5503e49298c7/launch-b254bc97d74b-development.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/5503e49298c7/launch-20dd96aac0dc.min.js'
      }
    },
    AR: {
      dev: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
      staging: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
      beta: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
      production: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
      sodimac: {
        dev: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
        staging: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
        beta: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
        production: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js'
      }
    },
    MX: {
      dev: 'https://assets.adobedtm.com/68ade2efaac6/4cee1e32e989/launch-EN291ef67686c446228c94b18d361a92ad-development.min.js',
      staging: 'https://assets.adobedtm.com/68ade2efaac6/4cee1e32e989/launch-EN48f10d51a2394b8ab069a8e9d3dc463e-staging.min.js',
      beta: 'https://assets.adobedtm.com/68ade2efaac6/4cee1e32e989/launch-ENbc7294164f2b455db31702c1cb5fc02b.min.js',
      production: 'https://assets.adobedtm.com/68ade2efaac6/4cee1e32e989/launch-ENbc7294164f2b455db31702c1cb5fc02b.min.js',
      sodimac: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/4cee1e32e989/launch-EN291ef67686c446228c94b18d361a92ad-development.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/4cee1e32e989/launch-EN48f10d51a2394b8ab069a8e9d3dc463e-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/4cee1e32e989/launch-ENbc7294164f2b455db31702c1cb5fc02b.min.js',
        production: '//assets.adobedtm.com/68ade2efaac6/4cee1e32e989/launch-ENbc7294164f2b455db31702c1cb5fc02b.min.js'
      }
    }
  },
  DIGITAL_DATA_STORAGE_NAME: 'analyticsInfo',
  searchTerm: 'Ntt',
  medallia: {
    falabella: {},
    sodimac: {},
    tottus: {
      CL: 'https://nebula-cdn.kampyle.com/us/wu/1335606/onsite/embed.js',
      PE: 'https://nebula-cdn.kampyle.com/us/wu/1335606/onsite/embed.js',
      CO: ''
    }
  }
};
({
  linkStyles: _objectSpread$L({}, footerData.linkStyles),
  countryStyles: _objectSpread$L({}, footerData.countryStyles)
});
var STORE_NAMES_REGEX = new RegExp(/(sodimac|linio|tottus|homecenter|so_com|so_retail|to_com)/, 'g');
var STORE_MAP = {
  MARKETPLACE: 'falabella',
  cl: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_america: 'americanino',
    fa_carters: 'carters',
    fa_aldo: 'aldo',
    fa_crabarr: 'crateandbarrel',
    fa_thedrop: 'thedropzone'
  },
  pe: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_carters: 'carters',
    fa_aldo: 'aldoshoes',
    fa_crabarr: 'crateandbarrel',
    fa_thedrop: 'thedropzone'
  },
  co: {
    homecenter: 'homecenter',
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_crabarr: 'crateandbarrel',
    fa_thedrop: 'thedropzone'
  },
  ar: {},
  mx: {
    so_retail: 'sodimac'
  }
};
var getAccountPath = function getAccountPath(store) {
  if (isSodimacRetail$1(store)) {
    return 'myaccount';
  }
  return 'account';
};
var apiEndpoints = {
  getRegion: function getRegion(tenant) {
    var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var version = isSodimacRetail$1(store) ? 'v3' : 'v2';
    return "".concat(baseUrl, "/s/geo/").concat(version, "/states/").concat(tenant);
  },
  getCitylist: function getCitylist(politicalId, tenant) {
    var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var store = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var version = isSodimacRetail$1(store) ? 'v3' : 'v2';
    return "".concat(baseUrl, "/s/geo/").concat(version, "/districts/").concat(tenant, "?statePoliticalId=").concat(politicalId);
  },
  getProvinceList: function getProvinceList(politicalId, tenant) {
    var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var store = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var version = isSodimacRetail$1(store) ? 'v3' : 'v2';
    return "".concat(baseUrl, "/s/geo/").concat(version, "/counties/").concat(tenant, "?statePoliticalId=").concat(politicalId);
  },
  getDistrictList: function getDistrictList(statePoliticalId, countyPoliticalId, tenant) {
    var baseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var store = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var version = isSodimacRetail$1(store) ? 'v3' : 'v2';
    return "".concat(baseUrl, "/s/geo/").concat(version, "/districts/").concat(tenant, "?statePoliticalId=").concat(statePoliticalId, "&countyPoliticalId=").concat(countyPoliticalId);
  },
  getComunaDetails: function getComunaDetails(politicalId) {
    var tenant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cl';
    var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var store = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var version = isSodimacRetail$1(store) ? 'v3' : 'v2';
    var url = "".concat(baseUrl, "/s/geo/").concat(version, "/districts/").concat(tenant, "?politicalId=").concat(politicalId);
    if (store) {
      url += "&store=".concat(store);
    }
    return url;
  },
  getPostalCodeDetails: function getPostalCodeDetails(postalCode) {
    var tenant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mx';
    var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var store = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var version = isSodimacRetail$1(store) ? 'v3' : 'v2';
    return "".concat(baseUrl, "/s/geo/").concat(version, "/infoByPostalCode/").concat(tenant, "?postalCode=").concat(postalCode);
  },
  getUserAddresses: function getUserAddresses(baseUrl, store) {
    var accountPath = getAccountPath(store);
    return "".concat(baseUrl, "/s/").concat(accountPath, "/v2/addresses");
  },
  saveUserAddresses: function saveUserAddresses(baseUrl, store) {
    var accountPath = getAccountPath(store);
    return "".concat(baseUrl, "/s/").concat(accountPath, "/v2/addresses");
  },
  deleteUserAddresses: function deleteUserAddresses(baseUrl, addressID, store) {
    var accountPath = getAccountPath(store);
    return "".concat(baseUrl, "/s/").concat(accountPath, "/v2/addresses/").concat(addressID);
  }
};
var deviceTypes = {
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile'
};
var platforms = {
  MOBILE: {
    IOS: 'mobile_ios',
    ANDROID: 'mobile_android'
  }
};
var ENVIRONMENT = {
  LOCAL: 'local',
  DEVELOPMEMT: 'dev',
  STAGING: 'staging',
  UAT: 'beta',
  PRODUCTION: 'www'
};
var ENV_SUBDOMAIN_MAPPING = {
  dev: {
    LINIO: 'dev-linio',
    TOTTUS: 'dev-tottus',
    SODIMAC: 'dev-sodimac',
    HOMECENTER: 'dev-homecenter',
    FALABELLA: 'dev',
    SO_COM: 'dev',
    SO_RETAIL: 'dev',
    TO_COM: 'dev',
    FA_AMERICA: 'dev',
    FA_ALDO: 'dev',
    FA_CRABARR: 'dev',
    FA_CARTERS: 'dev',
    FA_THEDROP: 'dev'
  },
  staging: {
    LINIO: 'staging-linio',
    TOTTUS: 'staging-tottus',
    SODIMAC: 'staging-sodimac',
    HOMECENTER: 'staging-homecenter',
    FALABELLA: 'staging',
    SO_COM: 'staging',
    SO_RETAIL: 'staging',
    TO_COM: 'staging',
    FA_AMERICA: 'staging',
    FA_ALDO: 'staging',
    FA_CRABARR: 'staging',
    FA_CARTERS: 'staging',
    FA_THEDROP: 'staging'
  },
  beta: {
    LINIO: 'beta-linio',
    TOTTUS: 'beta-tottus',
    SODIMAC: 'beta-sodimac',
    HOMECENTER: 'beta-homecenter',
    FALABELLA: 'beta',
    SO_COM: 'beta',
    SO_RETAIL: 'beta',
    TO_COM: 'beta',
    FA_AMERICA: 'beta',
    FA_ALDO: 'beta',
    FA_CRABARR: 'beta',
    FA_CARTERS: 'beta',
    FA_THEDROP: 'beta'
  },
  production: {
    LINIO: 'linio',
    TOTTUS: 'tottus',
    SODIMAC: 'sodimac',
    HOMECENTER: 'homecenter',
    FALABELLA: 'www',
    SO_COM: 'www',
    SO_RETAIL: 'www',
    TO_COM: 'www',
    FA_AMERICA: 'www',
    FA_ALDO: 'www',
    FA_CRABARR: 'www',
    FA_CARTERS: 'www',
    FA_THEDROP: 'www'
  }
};
var STORES = {
  LINIO: 'linio',
  TOTTUS: 'tottus',
  SODIMAC: 'sodimac',
  HOMECENTER: 'homecenter',
  FALABELLA: 'falabella',
  SO_COM: 'so_com',
  SO_RETAIL: 'so_retail',
  TO_COM: 'to_com',
  FA_AMERICA: 'fa_america',
  FA_ALDO: 'fa_aldo',
  FA_CRABARR: 'fa_crabarr',
  FA_CARTERS: 'fa_carters',
  FA_THEDROP: 'fa_thedrop'
};
var STANDALONE_STORES = [STORES.SO_COM, STORES.SO_RETAIL, STORES.TO_COM];
var WHITELABEL_STORES = [STORES.FA_AMERICA, STORES.FA_ALDO, STORES.FA_CRABARR, STORES.FA_CARTERS, STORES.FA_THEDROP];
var SIS_PAGE_FILTER = {
  LINIO: 'linio',
  TOTTUS: 'tottus',
  SODIMAC: 'sodimac',
  HOMECENTER: 'homecenter'
};
var SIS_STORE_MAP = {
  linio: 'Linio',
  tottus: 'Tottus',
  sodimac: 'Sodimac',
  homecenter: 'Homecenter',
  so_com: 'Sodimac',
  so_retail: 'Sodimac',
  to_com: 'Tottus'
};
var HOME_ICON_WIDTH = '91.572';
var SIS_ICON_WIDTH = {
  LINIO: 48,
  TOTTUS: 75,
  SODIMAC: 80,
  HOMECENTER: 117
};
var NAVIGATION = 'NAVIGATION_TAGS';
var SIS_NAVIGATION = 'SIS_NAVIGATION_TAGS';
var HEADER = 'HEADER_TAGS';
var FOOTER = 'FOOTER_TAGS';
var SEARCH_BY_IMAGE = 'SEARCH_BY_IMAGE_TAGS';
var DIGITALDATA_TAGS = {
  NAVIGATION_TAGS: {
    NESTED: 'tag.header.tlm_head'
  },
  SIS_NAVIGATION_TAGS: {
    PREFIX: 'MS-MenuSis_',
    NESTED: 'tag.TLMS.TlmsisTag'
  },
  HEADER_TAGS: {
    NESTED: 'tag.header.buttons'
  },
  FOOTER_TAGS: {
    NESTED: 'tag.FT.FooterTag'
  },
  SEARCH_BY_IMAGE_TAGS: {
    NESTED: 'page.searchByImage'
  }
};
var DIGITALDATA_CMS_URL = {
  dev: 'https://assets-staging.falabella.com/v3/assets/blt07d653b53a07a055/blt09f2beda72d907db/cross-components.cjs',
  staging: 'https://assets-staging.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltac852fe85bca6e67/cross-components.cjs',
  beta: 'https://assets-uat.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3a018881108be146/cross-components.cjs',
  production: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc531eda557c63411/cross-components.cjs'
};
var defaultAnalyticsResponse = {
  analyticsInfo: {
    page: {},
    login: {}
  }
};
var PREPOSITIONS = {
  una: true,
  y: true,
  de: true,
  la: true,
  del: true,
  es: true
};
var SID_STATUS = {
  SOFTLOGIN: 'Soft',
  HARDLOGIN: 'Authenticated'
};
var ICONS = {
  F_LOGO: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltabc2a9c42c4d5b36/falabella.com-256x256.png'
};
var gtmInfo = {
  FALABELLA: {
    CL: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-NJX6QWJ',
      production: 'GTM-NJX6QWJ'
    },
    PE: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-T29WRLG',
      production: 'GTM-T29WRLG'
    },
    CO: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-PQRB5NV',
      production: 'GTM-PQRB5NV'
    },
    MX: {
      staging: '',
      beta: '',
      production: ''
    }
  },
  SODIMAC: {
    CL: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-WGGFJP',
      production: 'GTM-WGGFJP'
    },
    PE: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-5M8VN5',
      production: 'GTM-5M8VN5'
    },
    CO: {
      staging: '',
      beta: '',
      production: ''
    },
    MX: {
      staging: '',
      beta: '',
      production: ''
    }
  },
  TOTTUS: {
    CL: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-MJQ3SH25',
      production: 'GTM-MJQ3SH25'
    },
    PE: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-W5DHXDR7',
      production: 'GTM-W5DHXDR7'
    }
  },
  WHITELABEL: {
    CL: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-NZJJ9R4',
      production: 'GTM-NZJJ9R4'
    },
    PE: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-T4MPK453',
      production: 'GTM-T4MPK453'
    },
    CO: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-M7VZ8LD7',
      production: 'GTM-M7VZ8LD7'
    }
  }
};
var metaTagsApp = {
  FALABELLA: [{
    property: 'al:ios:url',
    content: 'https://apps.apple.com/cl/app/falabella/id947145705'
  }, {
    property: 'al:ios:app_store_id',
    content: '947145705'
  }, {
    property: 'al:ios:app_name',
    content: 'Falabella'
  }, {
    property: 'al:android:url',
    content: 'https://play.google.com/store/apps/details?id=com.falabella.falabellaApp'
  }, {
    property: 'al:android:app_name',
    content: 'Falabella'
  }, {
    property: 'al:android:package',
    content: 'com.falabella.falabellaApp'
  }, {
    property: 'al:ios:package',
    content: 'com.falabella.app'
  }],
  SO_COM: [{
    property: 'al:ios:url',
    content: 'https://apps.apple.com/cl/app/sodimac-hogar-y-construcci%C3%B3n/id532353705'
  }, {
    property: 'al:ios:app_store_id',
    content: '532353705'
  }, {
    property: 'al:ios:app_name',
    content: 'Sodimac: Hogar y Construcción'
  }, {
    property: 'al:android:url',
    content: 'https://play.google.com/store/apps/details?id=com.falabella.falabellaApp'
  }, {
    property: 'al:android:app_name',
    content: 'Sodimac: Hogar y Construcción'
  }, {
    property: 'al:android:package',
    content: 'cl.sodimac'
  }, {
    property: 'al:ios:package',
    content: 'GerenciaSistemas.SubgerenciaIngenieriaSoftware.Francisco'
  }],
  SO_RETAIL: [],
  TO_COM: [{
    property: 'al:ios:url',
    content: 'https://apps.apple.com/cl/app/tottus/id1476096203'
  }, {
    property: 'al:ios:app_store_id',
    content: '1476096203'
  }, {
    property: 'al:ios:app_name',
    content: 'Tottus'
  }, {
    property: 'al:android:url',
    content: 'https://play.google.com/store/apps/details?id=com.tottus'
  }, {
    property: 'al:android:app_name',
    content: 'Tottus'
  }, {
    property: 'al:android:package',
    content: 'com.tottus'
  }, {
    property: 'al:ios:package',
    content: 'com.tottus'
  }]
};
var WHITELABELS_SEARCH_PATH = {
  fa_america: 'search',
  fa_aldo: 'search',
  fa_crabarr: 'search',
  fa_carters: 'search',
  fa_thedrop: 'search'
};
var SEARCH_PATH = _objectSpread$L({
  fa_com: 'search',
  so_com: 'buscar',
  so_retail: 'search',
  to_com: 'buscar',
  sodimac: 'search',
  homecenter: 'search',
  tottus: 'search',
  linio: 'search'
}, WHITELABELS_SEARCH_PATH);
var HOME_URL = {
  '': 'https://www.falabella.com/falabella-cl',
  cl: 'https://www.falabella.com/falabella-cl',
  cl__sodimac: 'https://sodimac.falabella.com/sodimac-cl',
  cl__tottus: 'https://tottus.falabella.com/tottus-cl',
  cl__linio: 'https://linio.falabella.com/linio-cl',
  cl__so_com: 'https://www.sodimac.cl/sodimac-cl',
  cl__to_com: 'https://www.tottus.cl/tottus-cl',
  pe: 'https://www.falabella.com.pe/falabella-pe',
  pe__sodimac: 'https://sodimac.falabella.com.pe/sodimac-pe',
  pe__tottus: 'https://tottus.falabella.com.pe/tottus-pe',
  pe__linio: 'https://linio.falabella.com.pe/linio-pe',
  pe__so_com: 'https://www.sodimac.com.pe/sodimac-pe',
  pe__to_com: 'https://www.tottus.com.pe/tottus-pe',
  co: 'https://www.falabella.com.co/falabella-co',
  co__sodimac: 'https://sodimac.falabella.com.co/sodimac-co',
  co__tottus: 'https://tottus.falabella.com.co/tottus-co',
  co__linio: 'https://linio.falabella.com.co/linio-co',
  co__so_com: 'https://www.sodimac.com.co/sodimac-co',
  co__to_com: 'https://www.tottus.com.co/tottus-co',
  mx__so_retail: 'https://www.sodimac.com.mx/sodimac-mx'
};
var SCRIPT_URL$1 = {
  falabella: {
    cl: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ae1beb67525ed26/vwo.js',
    pe: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf1762da3c97b64e4/vwo.js',
    co: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf0b1376d26dd28cc/vwo.js'
  },
  sodimac: {
    cl: 'https://assets.falabella.com/v3/assets/blt6a203fe6c6a9b6dd/blt705a6b1a4bf4cea6/vwo.js',
    pe: 'https://assets.falabella.com/v3/assets/blt6a82e9c0570891fd/blt1e8af8be1dce2321/vwo.js',
    mx: ''
  },
  tottus: {
    cl: 'https://assets.falabella.com/v3/assets/blt72431f7a08fe765a/blt571db869516aebeb/vwo.js',
    pe: 'https://assets.falabella.com/v3/assets/blt422ac29cebae1d64/blt9b9f051e8c878b44/vwo.js'
  }
};
var WHITELABEL_SITES = new Set(['fa_aldo', 'fa_america', 'fa_carters', 'fa_crabarr', 'fa_thedrop']);
var USER_SEGMENT_COOKIE = 'userSegments';
var TLDS = {
  cl: 'cl',
  pe: 'com.pe',
  co: 'com.co',
  mx: 'com.mx',
  br: 'com.br',
  ar: 'com.ar',
  uy: 'com.uy'
};
var GOOGLE_VERIFICATION_CODES = {
  pe: {
    fa_thedrop: 'mnNNrpmfd7BLtQfDty1K_BAf-U00NssHGnuW_zkjOQo'
  }
};

var getItem = function getItem(_ref) {
  var name = _ref.name,
    fromPersistence = _ref.fromPersistence;
  return fromPersistence ? localStorage.getItem(name) : sessionStorage.getItem(name);
};
var setItem = function setItem(_ref2) {
  var name = _ref2.name,
    value = _ref2.value,
    shouldPersist = _ref2.shouldPersist;
  return shouldPersist ? localStorage.setItem(name, value) : sessionStorage.setItem(name, value);
};
var WebStorage = {
  getItem: getItem,
  setItem: setItem,
  removeItem: function removeItem(_ref3) {
    var name = _ref3.name,
      fromPersistence = _ref3.fromPersistence;
    return fromPersistence ? localStorage.removeItem(name) : sessionStorage.removeItem(name);
  },
  getItemWithTTL: function getItemWithTTL(_ref4) {
    var name = _ref4.name,
      fromPersistence = _ref4.fromPersistence;
    var data = getItem({
      name: name,
      fromPersistence: fromPersistence
    });
    if (data) {
      var _JSON$parse = JSON.parse(data),
        ttl = _JSON$parse.ttl,
        value = _JSON$parse.value;
      var now = new Date().getTime();
      if (ttl > now) {
        return value;
      }
    }
    return undefined;
  },
  setItemWithTTL: function setItemWithTTL(_ref5) {
    var name = _ref5.name,
      value = _ref5.value,
      fromPersistence = _ref5.fromPersistence,
      _ref5$ttl = _ref5.ttl,
      ttl = _ref5$ttl === void 0 ? 0 : _ref5$ttl;
    var now = new Date().getTime();
    var data = {
      ttl: now + ttl,
      value: value
    };
    setItem({
      name: name,
      value: JSON.stringify(data),
      fromPersistence: fromPersistence
    });
  }
};
var WebStorage$1 = WebStorage;

var isEmpty = function isEmpty(obj) {
  if (!obj || Object.keys(obj).length === 0) {
    return true;
  }
  return false;
};
var isWindow$1 = function isWindow() {
  return process && process.browser;
};
var noop$2 = function noop() {};
var formatPoints = function formatPoints() {
  var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var tenant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cl';
  if (tenant === 'pe') {
    return points.toLocaleString('en');
  }
  return points.toLocaleString('en').replace(/,/g, '.');
};
var toggleBodyClass = function toggleBodyClass(condition, name) {
  condition ? document.body.classList.add("".concat(name)) : document.body.classList.remove("".concat(name));
};
var getParameterByName = function getParameterByName(key, url) {
  if (!url && isWindow$1()) {
    url = window.location.href;
  }
  var name = key.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
  var results = regex.exec(url);
  if (!results || !results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
var getCurrentLocation = function getCurrentLocation() {
  var _cookies$zoneData$zon, _cookies$zoneData;
  if (!isWindow$1()) {
    return;
  }
  var cookies = CookieStorage$1.parseCookies(document.cookie);
  var zoneName = (_cookies$zoneData$zon = cookies === null || cookies === void 0 || (_cookies$zoneData = cookies.zoneData) === null || _cookies$zoneData === void 0 ? void 0 : _cookies$zoneData.zoneName) !== null && _cookies$zoneData$zon !== void 0 ? _cookies$zoneData$zon : 'SELECCIONAR UBICACIÓN';
  return zoneName;
};
var svgToDataUri = function svgToDataUri(svgStr) {
  var encoded = encodeURIComponent(svgStr).replace(/'/g, '%27').replace(/"/g, '%22');
  var header = 'data:image/svg+xml;charset=utf8,';
  var dataUrl = header + encoded;
  return dataUrl;
};
var matchStoreName = function matchStoreName() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var result = text.match(STORE_NAMES_REGEX);
  return result ? result[0] : false;
};
var getSISPageName = function getSISPageName() {
  var baseUrl = '';
  if (typeof global.window !== 'undefined') {
    baseUrl = window.location.origin;
  }
  return matchStoreName(baseUrl);
};
var getEXPParam = function getEXPParam() {
  var queryParams = '';
  if (typeof global.window !== 'undefined') {
    queryParams = window.location.search.substring(1);
  }
  var params = new URLSearchParams(queryParams);
  if (params.get('exp')) {
    var exp = params.get('exp');
    return matchStoreName(exp);
  }
  return false;
};
var isPdpPage = function isPdpPage() {
  var pathUrl = '';
  if (typeof global.window !== 'undefined') {
    pathUrl = window.location.pathname;
  }
  return pathUrl.includes('/product/');
};
var isLandingPage = function isLandingPage() {
  var baseUrl = '';
  if (typeof global.window !== 'undefined') {
    baseUrl = window.location.pathname;
  }
  return baseUrl.includes('/page');
};
var isXLPPage = function isXLPPage() {
  var baseUrl = '';
  if (typeof global.window !== 'undefined') {
    baseUrl = window.location.pathname;
  }
  return baseUrl.includes('/search') || baseUrl.includes('/buscar') || baseUrl.includes('/category/') || baseUrl.includes('/lista/') || baseUrl.includes('/collection/') || baseUrl.includes('/seleccion/') || baseUrl.includes('/seller/') || baseUrl.includes('/vendedor/') || baseUrl.includes('/brand/') || baseUrl.includes('/marca/');
};
var filterStoresFromCurrentStore = function filterStoresFromCurrentStore() {
  var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentStoreName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return stores && stores.length > 0 && stores.filter(function (_ref) {
    var title = _ref.icon.title;
    return !title.includes(currentStoreName);
  });
};
var getStoreNameFromSisPage = function getStoreNameFromSisPage(stores, sisPageName) {
  if (stores) {
    var result;
    switch (sisPageName) {
      case 'sodimac':
        result = filterStoresFromCurrentStore(stores, SIS_PAGE_FILTER.SODIMAC);
        break;
      case 'homecenter':
        result = filterStoresFromCurrentStore(stores, SIS_PAGE_FILTER.HOMECENTER);
        break;
      case 'linio':
        result = filterStoresFromCurrentStore(stores, SIS_PAGE_FILTER.LINIO);
        break;
      case 'tottus':
        result = filterStoresFromCurrentStore(stores, SIS_PAGE_FILTER.TOTTUS);
        break;
      default:
        result = filterStoresFromCurrentStore(stores, 'main');
        break;
    }
    return {
      stores: result,
      title: ''
    };
  } else {
    return null;
  }
};
var getWidthForStoreIcon = function getWidthForStoreIcon() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (title.includes(SIS_PAGE_FILTER.SODIMAC)) {
    return SIS_ICON_WIDTH.SODIMAC;
  } else if (title.includes(SIS_PAGE_FILTER.HOMECENTER)) {
    return SIS_ICON_WIDTH.HOMECENTER;
  } else if (title.includes(SIS_PAGE_FILTER.TOTTUS)) {
    return SIS_ICON_WIDTH.TOTTUS;
  } else if (title.includes(SIS_PAGE_FILTER.LINIO)) {
    return SIS_ICON_WIDTH.LINIO;
  } else return HOME_ICON_WIDTH;
};
var isElementInViewport = function isElementInViewport(el) {
  if (!el) {
    return false;
  }
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var getFromLocalStorage = function getFromLocalStorage(keyName) {
  var keyValue = WebStorage$1.getItem({
    name: keyName,
    fromPersistence: true
  });
  return keyValue && JSON.parse(keyValue) ? JSON.parse(keyValue) : undefined;
};
var setToLocalStorage = function setToLocalStorage(name, value) {
  var isString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (value) {
    var data = isString ? value : JSON.stringify(value);
    WebStorage$1.setItem({
      name: name,
      value: data,
      shouldPersist: true
    });
  }
};
var buildRegex = function buildRegex(isTottusStandalone) {
  var baseAndSpecials = 'a-zA-Z0-9\xf1\xd1\xe1\xe9\xed\xf3\xfa\xc1\xc9\xcd\xd3\xda\xfc\xdc\xc0\xc8\xcc\xd2\xd9\xe0\xe8\xec\xf2\xf9\\s_\\-\\/"';
  var allowed = baseAndSpecials + (isTottusStandalone ? '.+' : '');
  return new RegExp("[^".concat(allowed, "]"), 'g');
};
var processSearchQuery = function processSearchQuery(searchQuery) {
  var isSearchSpecialCharactersEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var storeSelected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var newSearchTerm;
  var baseSpecialChars = ['\\.', '\\,', '\\&', '\\"', '\\/'];
  var specialChars = storeSelected !== null && storeSelected !== void 0 && storeSelected.isTottusStandalone ? [].concat(baseSpecialChars, ['\\+']) : baseSpecialChars;
  var specialCharsRegex = specialChars.join('');
  if (isSearchSpecialCharactersEnabled) {
    newSearchTerm = searchQuery.trim().replace(/\s+/g, ' ').replace(new RegExp(
    "[^a-zA-Z0-9\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\xFC\xDC\xC0\xC8\xCC\xD2\xD9\xE0\xE8\xEC\xF2\xF9\\s\\_\\-".concat(specialCharsRegex, "]"), 'g'), '').trim();
  } else {
    newSearchTerm = searchQuery.trim();
    if (storeSelected !== null && storeSelected !== void 0 && storeSelected.isSodimacStandalone) {
      newSearchTerm = newSearchTerm.replace(/,/g, ' ');
    }
    newSearchTerm = newSearchTerm.replace(/\s+/g, ' ').replace(/&/g, ' ').replace(buildRegex(storeSelected === null || storeSelected === void 0 ? void 0 : storeSelected.isTottusStandalone), '').replace(/[/]+/g, ' ').trim();
  }
  return newSearchTerm;
};
var _merge = function merge(target) {
  if (!target) target = {};
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  sources.forEach(function (source) {
    if (!source || _typeof(source) !== 'object') {
      return;
    }
    var sourceKeys = Object.keys(source);
    sourceKeys.forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (source[key] && _typeof(source[key]) === 'object' && !Array.isArray(source[key])) {
          var existingTarget = target[key] || {};
          target[key] = _merge(existingTarget, source[key]);
        } else {
          target[key] = source[key];
        }
      }
    });
  });
  return target;
};

function ownKeys$K(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$K(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$K(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$K(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isClientSide = function isClientSide() {
  return typeof window !== 'undefined';
};
var getBusinessUnit = function getBusinessUnit() {
  var isSodimacStandAloneSite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isTottusStandAloneSite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isSodimacStandAloneSite) return 'sodimac';
  if (isTottusStandAloneSite) return 'tottus';
  return 'falabella';
};
var isSodimacStandalone = function isSodimacStandalone(store) {
  return store === STORES.SO_COM;
};
var isSodimacRetail = function isSodimacRetail(store) {
  return store === STORES.SO_RETAIL;
};
var isTottusStandalone = function isTottusStandalone(store) {
  return store === STORES.TO_COM;
};
var isWhitelabel = function isWhitelabel() {
  var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return WHITELABEL_SITES.has(store);
};
var getStandaloneSite = function getStandaloneSite() {
  var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var result = {
    isStandaloneSite: false,
    isSodimacStandalone: isSodimacStandalone(store) || isSodimacRetail(store),
    isTottusStandalone: isTottusStandalone(store),
    isWhitelabelSite: isWhitelabel(store)
  };
  if (result.isSodimacStandalone || result.isTottusStandalone) {
    result.isStandaloneSite = true;
  }
  return result;
};
var getHeaderDataUrl = function getHeaderDataUrl(url, countryCode, version, store) {
  var baseVersion = version || 'v3';
  var basePath = "".concat(url, "/").concat(baseVersion, "/header/").concat(countryCode);
  if (isWhitelabel(store)) {
    return "".concat(url, "/").concat(baseVersion, "/header/").concat(countryCode, "/whitelabel/").concat(store);
  }
  if (getStandaloneSite(store).isStandaloneSite) {
    return "".concat(url, "/").concat(baseVersion, "/header/").concat(countryCode, "?site=").concat(store);
  }
  var finalStore = getStandaloneSite(store).isStandaloneSite || isSodimacRetail(store) ? store : 'fa_com';
  var siteQueryParam = finalStore ? "?site=".concat(finalStore) : '';
  return "".concat(basePath).concat(siteQueryParam);
};
var getFooterDataUrl = function getFooterDataUrl(url, countryCode, version, store) {
  var baseVersion = version || 'v3';
  var basePath = "".concat(url, "/").concat(baseVersion, "/footer/").concat(countryCode);
  if (isWhitelabel(store)) {
    return "".concat(url, "/").concat(baseVersion, "/footer/").concat(countryCode, "/whitelabel/").concat(store);
  }
  if (getStandaloneSite(store).isStandaloneSite) {
    return "".concat(url, "/").concat(baseVersion, "/footer/").concat(countryCode, "?site=").concat(store);
  }
  var finalStore = getStandaloneSite(store).isStandaloneSite || isSodimacRetail(store) || isWhitelabel(store) ? store : 'fa_com';
  var siteQueryParam = finalStore ? "?site=".concat(finalStore) : '';
  return "".concat(basePath).concat(siteQueryParam);
};
var getTransversalDataUrl = function getTransversalDataUrl(url, countryCode, version) {
  var baseVersion = version || 'v3';
  return "".concat(url, "/").concat(baseVersion, "/transversal/").concat(countryCode);
};
var getSisNavigationMenuUrl = function getSisNavigationMenuUrl(url, countryCode, version, store) {
  var baseVersion = version || 'v2';
  var basePath = "".concat(url, "/").concat(baseVersion, "/sisMenu/").concat(countryCode);
  if (isWhitelabel(store)) {
    return "".concat(url, "/").concat(baseVersion, "/menu/").concat(countryCode, "/whitelabel/").concat(store);
  }
  if (getStandaloneSite(store).isStandaloneSite) {
    var sisMenuStore = STORE_MAP[countryCode][store];
    return "".concat(url, "/").concat(baseVersion, "/sisMenu/").concat(countryCode, "/").concat(sisMenuStore, "?site=").concat(store);
  }
  return "".concat(basePath, "/").concat(store !== null && store !== void 0 ? store : 'tienda', "?site=fa_com");
};
var getTaxonomyDataUrl = function getTaxonomyDataUrl(url, countryCode, version) {
  var baseVersion = version || 'v2';
  return "".concat(url, "/").concat(baseVersion, "/taxonomy/").concat(countryCode);
};
var isValidTenant = function isValidTenant(tenant) {
  var tenantList = Object.values(countriesCode);
  return tenantList.includes(tenant);
};
var getCountry = function getCountry() {
  var pathName = window.location.pathname;
  var pathArray = pathName.split('/');
  var tenant = pathArray.length > 1 ? pathArray[1] : 'falabella-cl';
  var countryArray = tenant.split('-');
  var country = countryArray.length > 1 ? countryArray[1] : 'cl';
  return country.toUpperCase();
};
var getLocation = function getLocation(uri) {
  var regex = new RegExp(['^(https?:)//',
  '(([^:/?#]*)(?::([0-9]+))?)',
  '(/{0,1}[^?#]*)',
  '(\\?[^#]*|)',
  '(#.*|)$'
  ].join(''));
  var match = uri.match(regex);
  return match && {
    href: uri,
    protocol: match[1].replace(':', ''),
    host: match[2],
    hostname: match[3],
    port: match[4] || '80',
    pathname: match[5] || '/',
    search: match[6],
    hash: match[7]
  };
};
var getPage = function getPage(uri) {
  var errorPage = document.getElementsByClassName('error-page');
  if (errorPage.length > 0) {
    return 'error';
  }
  var path = getLocation(uri);
  var paths = path.pathname.split('/');
  return paths.length > 2 ? paths[2] : '';
};
var createScriptTag = function createScriptTag(_ref) {
  var src = _ref.src,
    _ref$async = _ref.async,
    async = _ref$async === void 0 ? false : _ref$async,
    _ref$defer = _ref.defer,
    defer = _ref$defer === void 0 ? false : _ref$defer,
    onLoad = _ref.onLoad,
    integrity = _ref.integrity,
    crossOrigin = _ref.crossOrigin,
    onError = _ref.onError;
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (src) {
    script.src = src;
  }
  script.defer = defer;
  script.async = async;
  script.onload = onLoad;
  script.onerror = onError;
  if (integrity) {
    script.integrity = integrity;
  }
  if (crossOrigin) {
    script.crossOrigin = crossOrigin;
  }
  return script;
};
var createLinkTag = function createLinkTag(_ref2) {
  var linkOptions = _ref2.linkOptions;
  var link = document.createElement('link');
  Object.keys(linkOptions).forEach(function (k) {
    link[k] = linkOptions[k];
  });
  return link;
};
var appendNodeToHead = function appendNodeToHead(script) {
  var _document = document,
    head = _document.head;
  var documentFragment = document.createDocumentFragment();
  documentFragment.appendChild(script);
  head.appendChild(documentFragment);
};
var getRegion = function getRegion(regionCode) {
  if (regionCode === 'cl' || !regionCode) {
    return '';
  }
  return ".".concat(regionCode);
};
var getHost = function getHost(regionCode, store) {
  var env = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ENVIRONMENT.PRODUCTION;
  var region = getRegion(regionCode);
  var _getStandaloneSite = getStandaloneSite(store),
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite,
    isStandaloneSite = _getStandaloneSite.isStandaloneSite;
  if (isWhitelabelSite) {
    var tenantPrefix = regionCode === 'cl' ? 'cl' : "com".concat(region);
    var domain = STORE_MAP[regionCode][store];
    return "https://".concat(env, ".").concat(domain, ".").concat(tenantPrefix);
  }
  if (isStandaloneSite) {
    var _tenantPrefix = regionCode === 'cl' ? 'cl' : "com".concat(region);
    var _domain = STORE_MAP[regionCode][store];
    return "https://".concat(env, ".").concat(_domain, ".").concat(_tenantPrefix);
  }
  var host = "https://".concat(env, ".falabella.com").concat(region);
  if (store && store !== 'falabella') {
    return env !== ENVIRONMENT.PRODUCTION ? host.replace("".concat(env, "."), "".concat(env, "-").concat(store, ".")) : host.replace("".concat(env, "."), "".concat(store, "."));
  }
  return host;
};
var buildFooterData = function buildFooterData(footer) {
  var _footer$entry, _footerData$copyright, _footerData$copyright2, _footerData$copyright3, _footerData$copyright4, _footerData$copyright5, _footerData$copyright6, _footerData$footer_co, _footerData$horizonta, _footerData$security$, _footerData$security, _footerData$security$2, _footerData$security2, _footerData$security$3, _footerData$security3, _footerData$security$4, _footerData$security4, _footerData$security$5, _footerData$security5, _footerData$security$6, _footerData$security6, _footerData$security$7, _footerData$security7, _footerData$security$8, _footerData$security8, _footerData$security$9, _footerData$security9, _footerData$security$0, _footerData$security0, _footerData$security$1, _footerData$security1, _footerData$security$10, _footerData$security10, _footerData$security$11, _footerData$security11, _footerData$security$12, _footerData$security12, _footerData$security$13, _footerData$security13, _footerData$social_ic, _footerData$security$14, _footerData$security14, _footerData$security$15, _footerData$security15, _footerData$bottom_ba, _footerData$bottom_ba2, _footerData$bottom_ba3, _footerData$bottom_ba4, _footerData$bottom_ba5, _footerData$bottom_ba6, _footerData$bottom_ba7, _footerData$bottom_ba8, _footerData$bottom_ba9, _footerData$bottom_ba0, _footerData$bottom_ba1, _footerData$bottom_ba10, _footerData$bottom_ba11, _footerData$bottom_ba12, _footerData$footer_th, _footerData$footer_th2, _footerData$footer_th3, _footerData$footer_th4, _footerData$footer_th5, _footerData$footer_th6, _footerData$footer_th7, _footerData$footer_th8, _footerData$powered_b, _footerData$powered_b2, _footerData$powered_b3, _footerData$powered_b4, _footerData$powered_b5, _footerData$powered_b6;
  var footerData = (_footer$entry = footer === null || footer === void 0 ? void 0 : footer.entry) !== null && _footer$entry !== void 0 ? _footer$entry : null;
  if (!footerData) {
    return footerData;
  }
  return {
    copyright: {
      title: (_footerData$copyright = footerData === null || footerData === void 0 || (_footerData$copyright2 = footerData.copyright) === null || _footerData$copyright2 === void 0 ? void 0 : _footerData$copyright2.title) !== null && _footerData$copyright !== void 0 ? _footerData$copyright : '',
      description: (_footerData$copyright3 = footerData === null || footerData === void 0 || (_footerData$copyright4 = footerData.copyright) === null || _footerData$copyright4 === void 0 ? void 0 : _footerData$copyright4.description) !== null && _footerData$copyright3 !== void 0 ? _footerData$copyright3 : '',
      textColor: (_footerData$copyright5 = footerData === null || footerData === void 0 || (_footerData$copyright6 = footerData.copyright) === null || _footerData$copyright6 === void 0 ? void 0 : _footerData$copyright6.text_color) !== null && _footerData$copyright5 !== void 0 ? _footerData$copyright5 : ''
    },
    footerColumns: (_footerData$footer_co = footerData === null || footerData === void 0 ? void 0 : footerData.footer_columns) !== null && _footerData$footer_co !== void 0 ? _footerData$footer_co : [],
    horizontalLinks: (_footerData$horizonta = footerData === null || footerData === void 0 ? void 0 : footerData.horizontal_links) !== null && _footerData$horizonta !== void 0 ? _footerData$horizonta : [],
    security: {
      iconDesktopRebrandingOn: {
        filename: (_footerData$security$ = footerData === null || footerData === void 0 || (_footerData$security = footerData.security) === null || _footerData$security === void 0 || (_footerData$security = _footerData$security.icon_desktop_rebranding_on) === null || _footerData$security === void 0 ? void 0 : _footerData$security.filename) !== null && _footerData$security$ !== void 0 ? _footerData$security$ : '',
        title: (_footerData$security$2 = footerData === null || footerData === void 0 || (_footerData$security2 = footerData.security) === null || _footerData$security2 === void 0 || (_footerData$security2 = _footerData$security2.icon_desktop_rebranding_on) === null || _footerData$security2 === void 0 ? void 0 : _footerData$security2.title) !== null && _footerData$security$2 !== void 0 ? _footerData$security$2 : '',
        tags: (_footerData$security$3 = footerData === null || footerData === void 0 || (_footerData$security3 = footerData.security) === null || _footerData$security3 === void 0 || (_footerData$security3 = _footerData$security3.icon_desktop_rebranding_on) === null || _footerData$security3 === void 0 ? void 0 : _footerData$security3.tags) !== null && _footerData$security$3 !== void 0 ? _footerData$security$3 : [],
        url: (_footerData$security$4 = footerData === null || footerData === void 0 || (_footerData$security4 = footerData.security) === null || _footerData$security4 === void 0 || (_footerData$security4 = _footerData$security4.icon_desktop_rebranding_on) === null || _footerData$security4 === void 0 ? void 0 : _footerData$security4.url) !== null && _footerData$security$4 !== void 0 ? _footerData$security$4 : ''
      },
      iconMobileRebrandingOn: {
        filename: (_footerData$security$5 = footerData === null || footerData === void 0 || (_footerData$security5 = footerData.security) === null || _footerData$security5 === void 0 || (_footerData$security5 = _footerData$security5.icon_mobile_rebranding_on) === null || _footerData$security5 === void 0 ? void 0 : _footerData$security5.filename) !== null && _footerData$security$5 !== void 0 ? _footerData$security$5 : '',
        title: (_footerData$security$6 = footerData === null || footerData === void 0 || (_footerData$security6 = footerData.security) === null || _footerData$security6 === void 0 || (_footerData$security6 = _footerData$security6.icon_mobile_rebranding_on) === null || _footerData$security6 === void 0 ? void 0 : _footerData$security6.title) !== null && _footerData$security$6 !== void 0 ? _footerData$security$6 : '',
        tags: (_footerData$security$7 = footerData === null || footerData === void 0 || (_footerData$security7 = footerData.security) === null || _footerData$security7 === void 0 || (_footerData$security7 = _footerData$security7.icon_mobile_rebranding_on) === null || _footerData$security7 === void 0 ? void 0 : _footerData$security7.tags) !== null && _footerData$security$7 !== void 0 ? _footerData$security$7 : [],
        url: (_footerData$security$8 = footerData === null || footerData === void 0 || (_footerData$security8 = footerData.security) === null || _footerData$security8 === void 0 || (_footerData$security8 = _footerData$security8.icon_mobile_rebranding_on) === null || _footerData$security8 === void 0 ? void 0 : _footerData$security8.url) !== null && _footerData$security$8 !== void 0 ? _footerData$security$8 : ''
      },
      iconRebrandingOff: {
        filename: (_footerData$security$9 = footerData === null || footerData === void 0 || (_footerData$security9 = footerData.security) === null || _footerData$security9 === void 0 || (_footerData$security9 = _footerData$security9.icon_rebranding_off) === null || _footerData$security9 === void 0 ? void 0 : _footerData$security9.filename) !== null && _footerData$security$9 !== void 0 ? _footerData$security$9 : '',
        title: (_footerData$security$0 = footerData === null || footerData === void 0 || (_footerData$security0 = footerData.security) === null || _footerData$security0 === void 0 || (_footerData$security0 = _footerData$security0.icon_rebranding_off) === null || _footerData$security0 === void 0 ? void 0 : _footerData$security0.title) !== null && _footerData$security$0 !== void 0 ? _footerData$security$0 : '',
        tags: (_footerData$security$1 = footerData === null || footerData === void 0 || (_footerData$security1 = footerData.security) === null || _footerData$security1 === void 0 || (_footerData$security1 = _footerData$security1.icon_rebranding_off) === null || _footerData$security1 === void 0 ? void 0 : _footerData$security1.tags) !== null && _footerData$security$1 !== void 0 ? _footerData$security$1 : [],
        url: (_footerData$security$10 = footerData === null || footerData === void 0 || (_footerData$security10 = footerData.security) === null || _footerData$security10 === void 0 || (_footerData$security10 = _footerData$security10.icon_rebranding_off) === null || _footerData$security10 === void 0 ? void 0 : _footerData$security10.url) !== null && _footerData$security$10 !== void 0 ? _footerData$security$10 : ''
      },
      text: (_footerData$security$11 = footerData === null || footerData === void 0 || (_footerData$security11 = footerData.security) === null || _footerData$security11 === void 0 ? void 0 : _footerData$security11.text) !== null && _footerData$security$11 !== void 0 ? _footerData$security$11 : '',
      url: (_footerData$security$12 = footerData === null || footerData === void 0 || (_footerData$security12 = footerData.security) === null || _footerData$security12 === void 0 ? void 0 : _footerData$security12.url) !== null && _footerData$security$12 !== void 0 ? _footerData$security$12 : '',
      isNewTab: (_footerData$security$13 = footerData === null || footerData === void 0 || (_footerData$security13 = footerData.security) === null || _footerData$security13 === void 0 ? void 0 : _footerData$security13.is_new_tab) !== null && _footerData$security$13 !== void 0 ? _footerData$security$13 : false
    },
    socialIcons: (_footerData$social_ic = footerData === null || footerData === void 0 ? void 0 : footerData.social_icons) !== null && _footerData$social_ic !== void 0 ? _footerData$social_ic : [],
    tags: (_footerData$security$14 = footerData === null || footerData === void 0 || (_footerData$security14 = footerData.security) === null || _footerData$security14 === void 0 ? void 0 : _footerData$security14.tags) !== null && _footerData$security$14 !== void 0 ? _footerData$security$14 : [],
    title: (_footerData$security$15 = footerData === null || footerData === void 0 || (_footerData$security15 = footerData.security) === null || _footerData$security15 === void 0 ? void 0 : _footerData$security15.title) !== null && _footerData$security$15 !== void 0 ? _footerData$security$15 : '',
    bottom_banner: {
      enabled: (_footerData$bottom_ba = footerData === null || footerData === void 0 || (_footerData$bottom_ba2 = footerData.bottom_banner) === null || _footerData$bottom_ba2 === void 0 ? void 0 : _footerData$bottom_ba2.enabled) !== null && _footerData$bottom_ba !== void 0 ? _footerData$bottom_ba : '',
      banner: {
        content: (_footerData$bottom_ba3 = footerData === null || footerData === void 0 || (_footerData$bottom_ba4 = footerData.bottom_banner) === null || _footerData$bottom_ba4 === void 0 || (_footerData$bottom_ba4 = _footerData$bottom_ba4.banner) === null || _footerData$bottom_ba4 === void 0 ? void 0 : _footerData$bottom_ba4.content) !== null && _footerData$bottom_ba3 !== void 0 ? _footerData$bottom_ba3 : '',
        bgColor: (_footerData$bottom_ba5 = footerData === null || footerData === void 0 || (_footerData$bottom_ba6 = footerData.bottom_banner) === null || _footerData$bottom_ba6 === void 0 || (_footerData$bottom_ba6 = _footerData$bottom_ba6.banner) === null || _footerData$bottom_ba6 === void 0 ? void 0 : _footerData$bottom_ba6.background_color) !== null && _footerData$bottom_ba5 !== void 0 ? _footerData$bottom_ba5 : '',
        txtColor: (_footerData$bottom_ba7 = footerData === null || footerData === void 0 || (_footerData$bottom_ba8 = footerData.bottom_banner) === null || _footerData$bottom_ba8 === void 0 || (_footerData$bottom_ba8 = _footerData$bottom_ba8.banner) === null || _footerData$bottom_ba8 === void 0 ? void 0 : _footerData$bottom_ba8.text_color) !== null && _footerData$bottom_ba7 !== void 0 ? _footerData$bottom_ba7 : ''
      },
      button: {
        title: (_footerData$bottom_ba9 = footerData === null || footerData === void 0 || (_footerData$bottom_ba0 = footerData.bottom_banner) === null || _footerData$bottom_ba0 === void 0 || (_footerData$bottom_ba0 = _footerData$bottom_ba0.button) === null || _footerData$bottom_ba0 === void 0 ? void 0 : _footerData$bottom_ba0.title) !== null && _footerData$bottom_ba9 !== void 0 ? _footerData$bottom_ba9 : '',
        txtColor: (_footerData$bottom_ba1 = footerData === null || footerData === void 0 || (_footerData$bottom_ba10 = footerData.bottom_banner) === null || _footerData$bottom_ba10 === void 0 || (_footerData$bottom_ba10 = _footerData$bottom_ba10.button) === null || _footerData$bottom_ba10 === void 0 ? void 0 : _footerData$bottom_ba10.text_color) !== null && _footerData$bottom_ba1 !== void 0 ? _footerData$bottom_ba1 : '',
        bgColor: (_footerData$bottom_ba11 = footerData === null || footerData === void 0 || (_footerData$bottom_ba12 = footerData.bottom_banner) === null || _footerData$bottom_ba12 === void 0 || (_footerData$bottom_ba12 = _footerData$bottom_ba12.button) === null || _footerData$bottom_ba12 === void 0 ? void 0 : _footerData$bottom_ba12.background_color) !== null && _footerData$bottom_ba11 !== void 0 ? _footerData$bottom_ba11 : ''
      }
    },
    logo: (_footerData$footer_th = footerData === null || footerData === void 0 || (_footerData$footer_th2 = footerData.footer_themes) === null || _footerData$footer_th2 === void 0 || (_footerData$footer_th2 = _footerData$footer_th2.footer_logo) === null || _footerData$footer_th2 === void 0 ? void 0 : _footerData$footer_th2.url) !== null && _footerData$footer_th !== void 0 ? _footerData$footer_th : '',
    primaryBackgroundColor: (_footerData$footer_th3 = footerData === null || footerData === void 0 || (_footerData$footer_th4 = footerData.footer_themes) === null || _footerData$footer_th4 === void 0 ? void 0 : _footerData$footer_th4.footer_primary_background_color) !== null && _footerData$footer_th3 !== void 0 ? _footerData$footer_th3 : '',
    secondaryBackgroundColor: (_footerData$footer_th5 = footerData === null || footerData === void 0 || (_footerData$footer_th6 = footerData.footer_themes) === null || _footerData$footer_th6 === void 0 ? void 0 : _footerData$footer_th6.footer_secondary_background_color) !== null && _footerData$footer_th5 !== void 0 ? _footerData$footer_th5 : '',
    tertiaryBackgroundColor: (_footerData$footer_th7 = footerData === null || footerData === void 0 || (_footerData$footer_th8 = footerData.footer_themes) === null || _footerData$footer_th8 === void 0 ? void 0 : _footerData$footer_th8.footer_tertiary_background_color) !== null && _footerData$footer_th7 !== void 0 ? _footerData$footer_th7 : '',
    poweredBy: {
      icon: (_footerData$powered_b = footerData === null || footerData === void 0 || (_footerData$powered_b2 = footerData.powered_by) === null || _footerData$powered_b2 === void 0 ? void 0 : _footerData$powered_b2.icon) !== null && _footerData$powered_b !== void 0 ? _footerData$powered_b : '',
      label: (_footerData$powered_b3 = footerData === null || footerData === void 0 || (_footerData$powered_b4 = footerData.powered_by) === null || _footerData$powered_b4 === void 0 ? void 0 : _footerData$powered_b4.label) !== null && _footerData$powered_b3 !== void 0 ? _footerData$powered_b3 : '',
      labelColor: (_footerData$powered_b5 = footerData === null || footerData === void 0 || (_footerData$powered_b6 = footerData.powered_by) === null || _footerData$powered_b6 === void 0 ? void 0 : _footerData$powered_b6.label_color) !== null && _footerData$powered_b5 !== void 0 ? _footerData$powered_b5 : ''
    }
  };
};
var getEnvironment = function getEnvironment() {
  if (!isClientSide()) return;
  var origin = window.location.origin;
  if (origin.includes('staging')) {
    return 'staging';
  } else if (origin.includes('beta') || origin.includes('local')) {
    return 'beta';
  } else if (origin.includes('dev')) {
    return 'dev';
  } else {
    return 'production';
  }
};
var getSubdomain = function getSubdomain() {
  var _window$location$host = window.location.hostname.split('.'),
    _window$location$host2 = _slicedToArray(_window$location$host, 2),
    hostname1 = _window$location$host2[0],
    hostname2 = _window$location$host2[1];
  var hostname = hostname1;
  var subdomain = null;
  if (hostname1 === 'www') {
    hostname = hostname2;
  }
  if (hostname.includes('linio')) {
    subdomain = 'linio';
  } else if (hostname.includes('sodimac')) {
    subdomain = 'sodimac';
  } else if (hostname.includes('tottus')) {
    subdomain = 'tottus';
  } else if (hostname.includes('homecenter')) {
    subdomain = 'homecenter';
  }
  return subdomain;
};
var getTenantTopLevelDomain = function getTenantTopLevelDomain() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  return tenant === 'cl' ? '' : ".".concat(tenant);
};
var getWhitelabelTenantTopLevelDomain = function getWhitelabelTenantTopLevelDomain() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  return tenant === 'cl' ? 'cl' : "com.".concat(tenant);
};
var getDomain = function getDomain(hostname) {
  return hostname && hostname.split('.').length > 1 ? hostname.split('.').slice(1, 3).join('.') : 'falabella.com';
};
var getEnvBaseUrl = function getEnvBaseUrl() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  var env = getEnvironment();
  var subdomain = env === 'production' ? 'www' : env;
  var tenantTLD = getTenantTopLevelDomain(tenant);
  var _ref3 = isWindow$1() ? window.location : {},
    _ref3$hostname = _ref3.hostname,
    hostname = _ref3$hostname === void 0 ? '' : _ref3$hostname;
  var domain = getDomain(hostname);
  return "https://".concat(subdomain, ".").concat(domain).concat(tenantTLD);
};
var getStoreBaseUrl = function getStoreBaseUrl() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  var rawStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'falabella';
  var store = rawStore || 'falabella';
  var env = getEnvironment();
  var subDomain = ENV_SUBDOMAIN_MAPPING[env][store.toUpperCase()] || 'www';
  var tenantTLD = getTenantTopLevelDomain(tenant);
  return "https://".concat(subDomain, ".falabella.com").concat(tenantTLD);
};
var getStandaloneSiteBaseUrl = function getStandaloneSiteBaseUrl() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  var store = arguments.length > 1 ? arguments[1] : undefined;
  var env = getEnvironment();
  if (!env || !STANDALONE_STORES.includes(store)) {
    return;
  }
  var subDomain = ENV_SUBDOMAIN_MAPPING[env][store.toUpperCase()];
  var domain = STORE_MAP[tenant][store];
  var tenantTLD = TLDS[tenant];
  return "https://".concat(subDomain, ".").concat(domain, ".").concat(tenantTLD);
};
var getWhitelabelSiteBaseUrl = function getWhitelabelSiteBaseUrl() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  var store = arguments.length > 1 ? arguments[1] : undefined;
  var env = getEnvironment();
  if (!env || !WHITELABEL_STORES.includes(store)) {
    return;
  }
  var subDomain = ENV_SUBDOMAIN_MAPPING[env][store.toUpperCase()];
  var domain = STORE_MAP[tenant][store];
  var tenantTLD = getWhitelabelTenantTopLevelDomain(tenant);
  return "https://".concat(subDomain, ".").concat(domain, ".").concat(tenantTLD);
};
var isLocalhost = function isLocalhost() {
  return isClientSide() ? window.location.origin.includes('localhost') : false;
};
var getAuthBaseUrl = function getAuthBaseUrl(endpoint, tenant) {
  var host = isLocalhost() ? 'https://dev.falabella.com' : getEnvBaseUrl(tenant);
  return "".concat(host, "/s/auth/v1/").concat(endpoint);
};
var toggleNotificationsPopUpVisibilty = function toggleNotificationsPopUpVisibilty() {
  var AirshipHtmlPromptShadow = document.querySelector('.airship-html-prompt-shadow');
  if (!AirshipHtmlPromptShadow) {
    return;
  }
  var AirshipPromptContainer = AirshipHtmlPromptShadow.shadowRoot.querySelector('.airship-prompt-container');
  if (!AirshipPromptContainer) {
    return;
  }
  if (AirshipPromptContainer.style.display !== 'none') {
    AirshipPromptContainer.style.display = 'none';
  } else {
    AirshipPromptContainer.style.display = 'block';
  }
};
var capitalizeSelectedOption = function capitalizeSelectedOption(option) {
  var _option$name;
  var name = ((_option$name = option === null || option === void 0 ? void 0 : option.name) !== null && _option$name !== void 0 ? _option$name : '').split(' ');
  var mutatedWords = name.map(function (word, index) {
    var wordLowerCase = word.toLowerCase();
    if (wordLowerCase in PREPOSITIONS && index !== 0) {
      return wordLowerCase;
    }
    return wordLowerCase.charAt(0).toUpperCase() + wordLowerCase.substr(1).toLowerCase();
  });
  mutatedWords = mutatedWords.join(' ');
  return _objectSpread$K(_objectSpread$K({}, option), {}, {
    name: mutatedWords
  });
};
var capitalizeList = function capitalizeList(list) {
  return list.map(function (listElement) {
    return capitalizeSelectedOption(listElement);
  });
};
var capitalizeWord = function capitalizeWord(str) {
  if (typeof str !== 'string') {
    return '';
  }
  var trimmedStr = str.trim();
  if (trimmedStr.length === 0) {
    return '';
  }
  var words = trimmedStr.split(/\s+/);
  var capitalizedWords = words.map(function (word) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  });
  return capitalizedWords.join(' ');
};
var getDomainName = function getDomainName(pageHostNameArray) {
  var homePageMapping = ['staging', 'beta', 'www'];
  var pageDomain = pageHostNameArray[0].includes('-') ? pageHostNameArray[0].split('-') : [homePageMapping.includes(pageHostNameArray[0]) ? pageHostNameArray[1] : pageHostNameArray[0]];
  return Array.isArray(pageDomain) && pageDomain.length === 2 ? pageDomain[1] : pageDomain[0];
};
var getPageTitle = function getPageTitle(href) {
  var pageHostNameArray = getLocation(href).hostname.split('.');
  var pageDomain = getDomainName(pageHostNameArray);
  return pageDomain;
};
var pageNameMapping = function pageNameMapping(page, href) {
  switch (page) {
    case 'noResult':
      return 'noSearchResult';
    case 'notFound':
      return 'notFound';
    case 'search':
    case 'buscar':
      return 'search';
    case 'category':
    case 'collection':
    case 'seller':
    case 'brand':
    case 'lista':
    case 'seleccion':
    case 'vendedor':
    case 'marca':
      return 'plp';
    case 'product':
    case 'articulo':
      return 'pdp';
    case 'page':
      return 'page';
    case 'myaccount':
      return 'myAccount';
    case 'myorders':
      return 'myOrders';
    default:
      {
        var pageHome = getPageTitle(href);
        return "".concat(pageHome, " home");
      }
  }
};
var getPageName = function getPageName() {
  var href = window.location.href;
  var page = getPage(href);
  var pageName = pageNameMapping(page, href);
  return pageName;
};
var SODIMAC_STANDALONE_DOMAIN_NAME = {
  pe: '.sodimac.com.pe',
  cl: '.sodimac.cl',
  mx: '.sodimac.com.mx'
};
var TOTTUS_STANDALONE_DOMAIN_NAME = {
  pe: '.tottus.com.pe',
  cl: '.tottus.cl'
};
var SODIMAC_RETAIL_DOMAIN_NAME = {
  mx: '.sodimac.com.mx'
};
var MARKETPLACE_DOMAIN_NAME = {
  cl: '.falabella.com',
  pe: '.falabella.com.pe',
  co: '.falabella.com.co'
};
var getEcommerceName = function getEcommerceName(store, tenant) {
  var standaloneSite = getStandaloneSite(store);
  if (standaloneSite.isSodimacStandalone) {
    if (isSodimacRetail(store)) {
      return "sodimac-".concat(tenant);
    }
    return "marketplacesodimac-".concat(tenant);
  }
  if (standaloneSite.isTottusStandalone) {
    return "marketplacetottus-".concat(tenant);
  }
  if (standaloneSite.isWhitelabelSite && STORE_MAP[tenant] && STORE_MAP[tenant][store]) {
    return "".concat(STORE_MAP[tenant][store], "-").concat(tenant);
  }
  return "marketplace-".concat(tenant);
};
var getWhitelabelSiteDomainName = function getWhitelabelSiteDomainName(tenant, store) {
  var siteName = STORE_MAP[tenant] ? STORE_MAP[tenant][store] : 'default';
  var region = tenant === 'cl' ? '.cl' : ".com.".concat(tenant);
  var domainName = siteName === 'default' ? MARKETPLACE_DOMAIN_NAME[tenant] : ".".concat(siteName).concat(region);
  return {
    siteName: siteName,
    domainName: domainName
  };
};
var generateWhiteLabelProps = function generateWhiteLabelProps(store, tenant) {
  var props = {
    enabled: true,
    siteName: 'default',
    ecommName: getEcommerceName(store, tenant),
    domainName: MARKETPLACE_DOMAIN_NAME[tenant],
    multiSite: true
  };
  var standaloneSite = getStandaloneSite(store);
  if (standaloneSite.isSodimacStandalone) {
    props.siteName = 'sodimac';
    props.domainName = SODIMAC_STANDALONE_DOMAIN_NAME[tenant];
    return props;
  }
  if (standaloneSite.isTottusStandalone) {
    props.siteName = 'tottus';
    props.domainName = TOTTUS_STANDALONE_DOMAIN_NAME[tenant];
    return props;
  }
  if (standaloneSite.isWhitelabelSite) {
    var _getWhitelabelSiteDom = getWhitelabelSiteDomainName(tenant, store),
      siteName = _getWhitelabelSiteDom.siteName,
      domainName = _getWhitelabelSiteDom.domainName;
    props.siteName = siteName;
    props.domainName = domainName;
    props.multiSite = false;
    return props;
  }
  return props;
};
var buildBaseUrlBetaEnv = function buildBaseUrlBetaEnv(baseHostUrl) {
  var env = getEnvironment();
  if (env === 'beta') {
    var _window$location$host3 = window.location.hostname.split('.'),
      _window$location$host4 = _slicedToArray(_window$location$host3, 2),
      hostname1 = _window$location$host4[0];
      _window$location$host4[1];
    return baseHostUrl.replace(/\/\/(.*?\.)?(sodimac|falabella)\.(cl|com(\.pe|\.co)?)/, "//".concat(hostname1, ".$2.$3"));
  }
  return baseHostUrl;
};
var isCurrentUrlSodimacStandAlone = function isCurrentUrlSodimacStandAlone() {
  if (isClientSide()) {
    var sodimacRegex = /https?:\/\/(?:[^.]+\.)?sodimac\.(?:cl|com\.(?:pe|mx))/;
    return sodimacRegex.test(window.location.origin);
  }
  return false;
};
var isCurrentUrlTottusStandAlone = function isCurrentUrlTottusStandAlone() {
  if (isClientSide()) {
    var tottusRegex = /https?:\/\/(?:[^.]+\.)?tottus\.(cl|com\.pe)/;
    return tottusRegex.test(window.location.origin);
  }
  return false;
};
var addMetaTag = function addMetaTag(property, content) {
  var head = document.getElementsByTagName('head')[0];
  var metaElement = document.createElement('meta');
  metaElement.setAttribute('property', property);
  metaElement.setAttribute('content', content);
  head.insertBefore(metaElement, head.firstChild);
};
var generateMetaTagsAPP = function generateMetaTagsAPP(isSodimacStandAlone, isTottusStandAloneSite) {
  var metaTags;
  if (isSodimacStandAlone) metaTags = metaTagsApp.SO_COM;else if (isTottusStandAloneSite) metaTags = metaTagsApp.TO_COM;else metaTags = metaTagsApp.FALABELLA;
  addMetaTag('al:web:url', window.location.href);
  metaTags.map(function (meta) {
    return addMetaTag(meta.property, meta.content);
  });
};
var getStoreName = function getStoreName() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var storeName = matchStoreName(text);
  if (isWhitelabel(text)) {
    return text;
  }
  if (storeName) {
    return storeName;
  }
  return STORE_MAP.MARKETPLACE;
};
var getTottusAddress = function getTottusAddress(address) {
  var _address$landmark;
  var isTottusStandAlone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!isTottusStandAlone) {
    return address.comuna;
  }
  var fields = ['landmark', 'addressLine1', 'addressLine2', 'comuna', 'region'];
  address.landmark = (_address$landmark = address.landmark) !== null && _address$landmark !== void 0 ? _address$landmark : address.departmentNumber;
  return fields.map(function (a, i) {
    var indent = i !== 0 ? ' ' : '';
    if (!address[a] || address[a] === 'undefined') return;
    var value = capitalizeWord(address[a]);
    return "".concat(indent).concat(value.replaceAll('#', '*'));
  }).filter(Boolean).join(',');
};
var getHeaderHeight = function getHeaderHeight(_ref4) {
  var isVendorLoggedIn = _ref4.isVendorLoggedIn,
    isAgentLoggedIn = _ref4.isAgentLoggedIn;
  var result = {
    totalVisibleHeight: 0,
    sisHeaderHeight: 0,
    searchHeaderHeight: 0,
    ternaryNavBarHeight: 0,
    transversalBannerHeight: 0,
    vendorHeaderHeight: 0,
    agentHeaderHeight: 0,
    crossBannerHeight: 0
  };
  if (!isClientSide()) {
    return result;
  }
  var agentHeader = document.getElementById('guided-selling-header-agent');
  result.agentHeaderHeight = agentHeader ? agentHeader.offsetHeight : 0;
  if (isAgentLoggedIn && result.agentHeaderHeight > 0 && isElementInViewport(agentHeader)) {
    result.totalVisibleHeight += result.agentHeaderHeight;
  }
  var vendorHeader = document.getElementById('guided-selling-header-vendor');
  result.vendorHeaderHeight = vendorHeader ? vendorHeader.offsetHeight : 0;
  if (isVendorLoggedIn && result.vendorHeaderHeight > 0 && isElementInViewport(vendorHeader)) {
    result.totalVisibleHeight += result.vendorHeaderHeight;
  }
  var searchHeader = document.getElementById('scrollable-content');
  result.searchHeaderHeight = searchHeader ? searchHeader.offsetHeight : 0;
  if (result.searchHeaderHeight > 0 && isElementInViewport(searchHeader)) {
    result.totalVisibleHeight += result.searchHeaderHeight;
  }
  var ternaryNavBar = document.getElementById('bottom-header');
  result.ternaryNavBarHeight = isElementInViewport(ternaryNavBar) ? ternaryNavBar.offsetHeight : 0;
  if (result.ternaryNavBarHeight > 0 && isElementInViewport(ternaryNavBar)) {
    result.totalVisibleHeight += result.ternaryNavBarHeight;
  }
  var sisHeader = document.getElementById('header-sis-links');
  result.sisHeaderHeight = sisHeader ? sisHeader.offsetHeight : 0;
  if (result.sisHeaderHeight > 0 && isElementInViewport(sisHeader)) {
    result.totalVisibleHeight += result.sisHeaderHeight;
  }
  var transversalBanner = document.getElementById('testId-transversalBanner');
  result.transversalBannerHeight = transversalBanner ? transversalBanner.offsetHeight : 0;
  if (result.transversalBannerHeight > 0 && isElementInViewport(transversalBanner)) {
    result.totalVisibleHeight += result.transversalBannerHeight;
  }
  var crossBanner = document.getElementById('cross-banner');
  result.crossBannerHeight = crossBanner ? crossBanner.offsetHeight : 0;
  if (result.crossBannerHeight > 0 && isElementInViewport(crossBanner)) {
    result.totalVisibleHeight += result.crossBannerHeight;
  }
  return result;
};
var getCategoryColor = function getCategoryColor(defaultCategoryColor, itemColor) {
  return itemColor || defaultCategoryColor;
};

var setNestedValue = function setNestedValue(obj, path, value) {
  var keys = path.split('.');
  var result = JSON.parse(JSON.stringify(obj));
  var current = result;
  keys.forEach(function (key, index) {
    if (index === keys.length - 1) {
      current[key] = value;
    } else {
      current[key] = current[key] || {};
      current = current[key];
    }
  });
  return result;
};

function ownKeys$J(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$J(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$J(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$J(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getDigitalDataFromStorage = function getDigitalDataFromStorage() {
  try {
    var data = JSON.parse(WebStorage$1.getItem({
      name: analyticsInfo.DIGITAL_DATA_STORAGE_NAME,
      fromPersistence: true
    }));
    return data;
  } catch (err) {
    return defaultAnalyticsResponse;
  }
};
var saveDigitalData = function saveDigitalData(digitalData) {
  WebStorage$1.setItem({
    name: analyticsInfo.DIGITAL_DATA_STORAGE_NAME,
    shouldPersist: true,
    value: JSON.stringify(digitalData)
  });
};
var saveTypeaheadMetrics = function saveTypeaheadMetrics(value) {
  var _window$digitalData$t, _window$digitalData, _window$digitalData$t2, _window$digitalData2;
  window.digitalData = _objectSpread$J(_objectSpread$J({}, window.digitalData), {}, {
    tag: _objectSpread$J(_objectSpread$J({}, (_window$digitalData$t = (_window$digitalData = window.digitalData) === null || _window$digitalData === void 0 ? void 0 : _window$digitalData.tag) !== null && _window$digitalData$t !== void 0 ? _window$digitalData$t : {}), {}, {
      XLP: _objectSpread$J(_objectSpread$J({}, (_window$digitalData$t2 = (_window$digitalData2 = window.digitalData) === null || _window$digitalData2 === void 0 || (_window$digitalData2 = _window$digitalData2.tag) === null || _window$digitalData2 === void 0 ? void 0 : _window$digitalData2.XLP) !== null && _window$digitalData$t2 !== void 0 ? _window$digitalData$t2 : {}), {}, {
        busqueda_TA: value
      })
    })
  });
  var lsDigitalData = getDigitalDataFromStorage();
  var modifiedDigitalData = _merge(lsDigitalData, {
    tag: {
      XLP: {
        busqueda_TA: value
      }
    }
  });
  saveDigitalData(modifiedDigitalData);
};
var saveSearchByImageMetrics = function saveSearchByImageMetrics(value) {
  window.digitalData = _objectSpread$J(_objectSpread$J({}, window.digitalData), {}, {
    ciamError: value
  });
  var lsDigitalData = getDigitalDataFromStorage();
  var modifiedDigitalData = _merge(lsDigitalData, {
    ciamError: value
  });
  saveDigitalData(modifiedDigitalData);
};
var saveDigitalDataCookies = function saveDigitalDataCookies() {
  var tagName = CookieStorage$1.getTagFromCookie();
  var _ref = tagName ? DIGITALDATA_TAGS[tagName] : {},
    _ref$NESTED = _ref.NESTED,
    NESTED = _ref$NESTED === void 0 ? '' : _ref$NESTED;
  var navigationTagData = tagName && CookieStorage$1.parseCookieValue(tagName, CookieStorage$1.getCookie(tagName));
  if (navigationTagData) {
    var countryCode = getCountry().toLowerCase();
    var domain = CookieStorage$1.getHost(countryCode);
    CookieStorage$1.removeCookieByDomain({
      name: tagName,
      domain: domain
    });
    var lsDigitalData = getDigitalDataFromStorage();
    var modifiedDigitalData = _merge(lsDigitalData, navigationTagData);
    saveDigitalData(modifiedDigitalData);
    window.digitalData = _merge(window.digitalData, modifiedDigitalData);
  } else {
    var _lsDigitalData = getDigitalDataFromStorage();
    if (getNestedValue(_lsDigitalData, NESTED)) {
      unset(_lsDigitalData, NESTED);
      saveDigitalData(_lsDigitalData);
      window.digitalData = _objectSpread$J(_objectSpread$J({}, window.digitalData), _lsDigitalData);
    }
  }
};
var updateDigitalDataCookies = function updateDigitalDataCookies(_ref2) {
  var _DIGITALDATA_TAGS$tag;
  var _ref2$firstLevelItem = _ref2.firstLevelItem,
    firstLevelItem = _ref2$firstLevelItem === void 0 ? '' : _ref2$firstLevelItem,
    _ref2$secondLevelItem = _ref2.secondLevelItem,
    secondLevelItem = _ref2$secondLevelItem === void 0 ? '' : _ref2$secondLevelItem,
    _ref2$thirdLevelItem = _ref2.thirdLevelItem,
    thirdLevelItem = _ref2$thirdLevelItem === void 0 ? '' : _ref2$thirdLevelItem,
    _ref2$positionOne = _ref2.positionOne,
    positionOne = _ref2$positionOne === void 0 ? '' : _ref2$positionOne,
    _ref2$positionTwo = _ref2.positionTwo,
    positionTwo = _ref2$positionTwo === void 0 ? '' : _ref2$positionTwo,
    _ref2$positionThree = _ref2.positionThree,
    positionThree = _ref2$positionThree === void 0 ? '' : _ref2$positionThree,
    _ref2$tag = _ref2.tag,
    tag = _ref2$tag === void 0 ? '' : _ref2$tag,
    _ref2$dataWrapper = _ref2.dataWrapper,
    dataWrapper = _ref2$dataWrapper === void 0 ? '' : _ref2$dataWrapper;
  var existingTag = CookieStorage$1.getTagFromCookie();
  var countryCode = getCountry().toLowerCase();
  if (existingTag) {
    var domain = CookieStorage$1.getHost(countryCode);
    CookieStorage$1.removeCookieByDomain({
      name: existingTag,
      domain: domain
    });
  }
  var _ref3 = (_DIGITALDATA_TAGS$tag = DIGITALDATA_TAGS === null || DIGITALDATA_TAGS === void 0 ? void 0 : DIGITALDATA_TAGS[tag]) !== null && _DIGITALDATA_TAGS$tag !== void 0 ? _DIGITALDATA_TAGS$tag : {},
    _ref3$NESTED = _ref3.NESTED,
    NESTED = _ref3$NESTED === void 0 ? '' : _ref3$NESTED,
    _ref3$PREFIX = _ref3.PREFIX,
    PREFIX = _ref3$PREFIX === void 0 ? '' : _ref3$PREFIX;
  if (NESTED) {
    var tagObject = [PREFIX + dataWrapper, firstLevelItem, secondLevelItem, thirdLevelItem, positionOne, positionTwo, positionThree].filter(function (e) {
      return e !== '';
    }).join('|');
    var nestedTagObject = setNestedValue({}, NESTED, tagObject);
    CookieStorage$1.setCookie({
      name: tag,
      value: nestedTagObject,
      regionCode: countryCode
    });
  }
};
var updateDigitalData = function updateDigitalData() {
  var _window$digitalData$m, _window;
  var update = (_window$digitalData$m = (_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 || (_window = _window.methods) === null || _window === void 0 ? void 0 : _window.update) !== null && _window$digitalData$m !== void 0 ? _window$digitalData$m : noop$2;
  update();
};
var initDigitalData = function () {
  var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
    var _window$digitalData$m2, _window2;
    var initialize;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          initialize = (_window$digitalData$m2 = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.digitalData) === null || _window2 === void 0 || (_window2 = _window2.methods) === null || _window2 === void 0 ? void 0 : _window2.init) !== null && _window$digitalData$m2 !== void 0 ? _window$digitalData$m2 : noop$2;
          _context.next = 1;
          return initialize();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initDigitalData() {
    return _ref4.apply(this, arguments);
  };
}();
var sendSatelliteTrackEvent = function () {
  var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(eventName, payload) {
    var _window$digitalData$m3, _window3;
    var sendSateliteTrack;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          sendSateliteTrack = (_window$digitalData$m3 = (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.digitalData) === null || _window3 === void 0 || (_window3 = _window3.methods) === null || _window3 === void 0 ? void 0 : _window3.sateliteTrack) !== null && _window$digitalData$m3 !== void 0 ? _window$digitalData$m3 : noop$2;
          _context2.next = 1;
          return sendSateliteTrack(eventName, payload);
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function sendSatelliteTrackEvent(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();

var classCallCheck = createCommonjsModule(function (module) {
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _classCallCheck = unwrapExports(classCallCheck);

var createClass = createCommonjsModule(function (module) {
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _createClass = unwrapExports(createClass);

var assertThisInitialized$1 = createCommonjsModule(function (module) {
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(assertThisInitialized$1);

var assertThisInitialized = assertThisInitialized$1;

var possibleConstructorReturn = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

var getPrototypeOf$1 = createCommonjsModule(function (module) {
function _getPrototypeOf(t) {
  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _getPrototypeOf = unwrapExports(getPrototypeOf$1);

var setPrototypeOf$1 = createCommonjsModule(function (module) {
function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(setPrototypeOf$1);

var setPrototypeOf = setPrototypeOf$1;

var inherits = createCommonjsModule(function (module) {
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _inherits = unwrapExports(inherits);

var isNativeFunction$1 = createCommonjsModule(function (module) {
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(isNativeFunction$1);

var isNativeReflectConstruct$1 = createCommonjsModule(function (module) {
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(isNativeReflectConstruct$1);

var isNativeReflectConstruct = isNativeReflectConstruct$1;

var construct$1 = createCommonjsModule(function (module) {
function _construct(t, e, r) {
  if (isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && setPrototypeOf(p, r.prototype), p;
}
module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(construct$1);

var getPrototypeOf = getPrototypeOf$1;

var isNativeFunction = isNativeFunction$1;

var construct = construct$1;

var wrapNativeSuper = createCommonjsModule(function (module) {
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return module.exports = _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return construct(t, arguments, getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), setPrototypeOf(Wrapper, t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _wrapNativeSuper(t);
}
module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _wrapNativeSuper = unwrapExports(wrapNativeSuper);

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HTTPError = function (_Error) {
  function HTTPError(statusCode) {
    var _this;
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    _classCallCheck(this, HTTPError);
    _this = _callSuper(this, HTTPError, [message]);
    _this.statusCode = statusCode;
    return _this;
  }
  _inherits(HTTPError, _Error);
  return _createClass(HTTPError, [{
    key: "getStatusCode",
    value: function getStatusCode() {
      return this.statusCode;
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      return this.message;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Error ".concat(this.statusCode, ": ").concat(this.message);
    }
  }]);
}(_wrapNativeSuper(Error));
var HTTPError$1 = HTTPError;

function ownKeys$I(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$I(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$I(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$I(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var handleFallback = function handleFallback(fallback, error) {
  if (fallback && fallback.data) {
    return fallback.data;
  }
  throw error;
};
var doFetch = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(url) {
    var options,
      fallbackOptions,
      fallback,
      response,
      error,
      _args = arguments,
      _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          fallbackOptions = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          fallback = _objectSpread$I({
            triggerOnResponseError: false,
            triggerOnNetworkError: false
          }, fallbackOptions);
          _context.prev = 1;
          _context.next = 2;
          return axios(_objectSpread$I({
            url: url,
            method: 'get',
            validateStatus: function validateStatus() {
              return true;
            }
          }, options));
        case 2:
          response = _context.sent;
          if (!(response.status >= 200 && response.status < 300)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", response.data);
        case 3:
          error = new HTTPError$1(response.status.toString(), JSON.stringify(response.data));
          if (!fallback.triggerOnResponseError) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", handleFallback(fallback, error));
        case 4:
          throw error;
        case 5:
          _context.prev = 5;
          _t = _context["catch"](1);
          if (!fallback.triggerOnNetworkError) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", handleFallback(fallback, _t));
        case 6:
          console.log("Error fetching: ".concat(JSON.stringify(url)));
          throw _t;
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 5]]);
  }));
  return function doFetch(_x) {
    return _ref.apply(this, arguments);
  };
}();
(function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(url) {
    var options,
      fallbackOptions,
      fallback,
      response,
      error,
      _args2 = arguments,
      _t2;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          fallbackOptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          fallback = _objectSpread$I({
            triggerOnResponseError: false,
            triggerOnNetworkError: false
          }, fallbackOptions);
          _context2.prev = 1;
          _context2.next = 2;
          return axios(_objectSpread$I({
            url: url,
            method: 'get',
            validateStatus: function validateStatus() {
              return true;
            }
          }, options));
        case 2:
          response = _context2.sent;
          if (!(response.status >= 200 && response.status < 300)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", {
            headers: response.headers,
            data: response.data,
            error: false
          });
        case 3:
          error = new HTTPError$1(response.status.toString(), JSON.stringify(response.data));
          return _context2.abrupt("return", {
            error: true,
            headers: response.headers,
            data: error
          });
        case 4:
          _context2.prev = 4;
          _t2 = _context2["catch"](1);
          if (!fallback.triggerOnNetworkError) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", handleFallback(fallback, _t2));
        case 5:
          console.log("Error fetching: ".concat(JSON.stringify(url)));
          throw _t2;
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 4]]);
  }));
  return function doFetchResponse(_x2) {
    return _ref2.apply(this, arguments);
  };
})();
var doPost = function () {
  var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(url, body, options) {
    var isTottusStandAlone,
      isFormData,
      response,
      _args3 = arguments,
      _t3;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          isTottusStandAlone = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
          _context3.prev = 1;
          isFormData = body instanceof FormData;
          _context3.next = 2;
          return axios(_objectSpread$I({
            url: url,
            method: 'post',
            data: isFormData ? body : JSON.stringify(body),
            headers: _objectSpread$I({
              'Content-Type': 'application/json'
            }, options === null || options === void 0 ? void 0 : options.headers),
            validateStatus: function validateStatus() {
              return true;
            }
          }, options));
        case 2:
          response = _context3.sent;
          if (!(isTottusStandAlone && (response.status >= 200 && response.status < 300 || response.status === 204))) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", true);
        case 3:
          if (!(response.status >= 200 && response.status < 300)) {
            _context3.next = 4;
            break;
          }
          console.log('returning true');
          return _context3.abrupt("return", response.data);
        case 4:
          throw new HTTPError$1(response.status.toString(), JSON.stringify(response.data));
        case 5:
          _context3.prev = 5;
          _t3 = _context3["catch"](1);
          console.log("Error doing post to ".concat(JSON.stringify(url)));
          throw _t3;
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 5]]);
  }));
  return function doPost(_x3, _x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
var doDelete = function () {
  var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(url) {
    var options,
      isTottusStandAlone,
      response,
      _args4 = arguments,
      _t4;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
          isTottusStandAlone = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : false;
          _context4.prev = 1;
          _context4.next = 2;
          return axios(_objectSpread$I({
            url: url,
            method: 'delete',
            data: {},
            headers: _objectSpread$I({
              'Content-Type': 'application/json'
            }, options === null || options === void 0 ? void 0 : options.headers),
            validateStatus: function validateStatus() {
              return true;
            }
          }, options));
        case 2:
          response = _context4.sent;
          if (!(isTottusStandAlone && (response.status >= 200 && response.status < 300 || response.status === 204))) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return", true);
        case 3:
          if (!(response.status >= 200 && response.status < 300)) {
            _context4.next = 4;
            break;
          }
          return _context4.abrupt("return", response.data);
        case 4:
          throw new HTTPError$1(response.status.toString(), JSON.stringify(response.data));
        case 5:
          _context4.prev = 5;
          _t4 = _context4["catch"](1);
          console.log("Error doing delete to ".concat(JSON.stringify(url)));
          throw _t4;
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 5]]);
  }));
  return function doDelete(_x6) {
    return _ref4.apply(this, arguments);
  };
}();

var pattern = {
  ios: new RegExp(/iPad|iPhone|iPod/),
  android: new RegExp(/android/i),
  webview: new RegExp(/wv|Version\/4\.0|; wv/i)
};
var getPlatformType = function getPlatformType(userAgent) {
  if (pattern.ios.test(userAgent)) {
    return platforms.MOBILE.IOS;
  }
  if (pattern.android.test(userAgent)) {
    return platforms.MOBILE.ANDROID;
  }
  return 'unknown';
};
var isInWebView = function isInWebView() {
  var userAgent = window.navigator.userAgent || '';
  var isAndroidWebView = pattern.webview.test(userAgent);
  var isIOSWebView = pattern.ios.test(userAgent) && !/Safari/.test(userAgent);
  return isAndroidWebView || isIOSWebView;
};
var detectDeviceType = function detectDeviceType() {
  var userAgent = window.navigator.userAgent;
  var platform = getPlatformType(userAgent);
  if (isInWebView()) {
    return 'APP';
  }
  if (platform !== 'unknown') {
    return 'MOBILE';
  }
  return 'WEB';
};
var isWindow = function isWindow() {
  return process.browser;
};
var compareViewPort = function compareViewPort(size) {
  return isWindow() && window.matchMedia && window.matchMedia("(max-width: ".concat(size, "px)")).matches;
};
var isMobile = function isMobile() {
  return compareViewPort('767');
};
var isIpadPotrait = function isIpadPotrait() {
  return compareViewPort('1024');
};

var getHeaders = function getHeaders(_ref) {
  var store = _ref.store,
    tenant = _ref.tenant;
  return {
    'x-channel-id': detectDeviceType(),
    'x-ecomm-name': getEcommerceName(store, tenant)
  };
};
var Catalyst = {
  getHeaders: getHeaders
};

function ownKeys$H(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$H(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$H(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$H(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getSodimacStoreFromTenant = function getSodimacStoreFromTenant(tenant) {
  var soComSet = new Set([TENANT.CL, TENANT.PE]);
  if (soComSet.has(tenant)) {
    return STORE.SO_COM;
  }
  return STORE.SO_RETAIL;
};
var getStoreFromContext = function getStoreFromContext(context, tenant) {
  if (!(context !== null && context !== void 0 && context.isSodimacStandAloneSite)) {
    return 'falabella';
  }
  var store = getSodimacStoreFromTenant(tenant);
  if (isSodimacStandalone$1(store)) {
    return 'falabella';
  }
  return store;
};
var validateSid = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(cookieSID, tenant, commerceOriginData, context) {
    var url, response;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = getAuthBaseUrl('validate', tenant);
          _context.next = 1;
          return doPost(url, {
            sessionId: cookieSID
          }, {
            headers: _objectSpread$H(_objectSpread$H(_objectSpread$H({}, Catalyst.getHeaders({
              store: getStoreFromContext(context, tenant),
              tenant: tenant
            })), {}, {
              'Content-Type': 'application/json',
              'x-commerce': 'FCM'
            }, commerceOriginData && commerceOriginData.name && {
              'x-origin-name': commerceOriginData.name
            }), commerceOriginData && commerceOriginData.view && {
              'x-origin-view': commerceOriginData.view
            })
          });
        case 1:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function validateSid(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var getUserEmail = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(userId, tenant, context) {
    var url, response;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = "".concat(getEnvBaseUrl(tenant), "/s/checkout/v1/users/").concat(userId, "/email");
          _context2.next = 1;
          return doFetch(url, {
            headers: Catalyst.getHeaders({
              store: getStoreFromContext(context, tenant),
              tenant: tenant
            })
          });
        case 1:
          response = _context2.sent;
          return _context2.abrupt("return", response.data.user);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getUserEmail(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();
var softLogin = function () {
  var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(emailId, tenant, context) {
    var url, response;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          url = getAuthBaseUrl('soft/login', tenant);
          _context3.next = 1;
          return doPost(url, {
            emailAddress: emailId
          }, {
            headers: _objectSpread$H(_objectSpread$H({}, Catalyst.getHeaders({
              store: getStoreFromContext(context, tenant),
              tenant: tenant
            })), {}, {
              'Content-Type': 'application/json'
            })
          });
        case 1:
          response = _context3.sent;
          return _context3.abrupt("return", response);
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function softLogin(_x8, _x9, _x0) {
    return _ref3.apply(this, arguments);
  };
}();
var refreshUserSession = function () {
  var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(cookieSID, tenant, setUserLoggedIn, commerceOriginData, context) {
    var _yield$validateSid, active, status, remainingSessionTime, sidValue, userId, _yield$getUserEmail, emailId, _yield$softLogin, sessionId, expires;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!cookieSID) {
            _context4.next = 5;
            break;
          }
          _context4.next = 1;
          return validateSid(cookieSID, tenant, commerceOriginData, context);
        case 1:
          _yield$validateSid = _context4.sent;
          active = _yield$validateSid.active;
          status = _yield$validateSid.status;
          remainingSessionTime = _yield$validateSid.remainingSessionTime;
          CookieStorage$1.setCookie({
            name: 'sidStatus',
            value: status || 'Soft',
            regionCode: tenant
          });
          if (remainingSessionTime) {
            sidValue = CookieStorage$1.getCookie('sid');
            CookieStorage$1.setCookie({
              name: 'sid',
              value: sidValue,
              regionCode: tenant,
              maxAge: remainingSessionTime,
              priority: 'High'
            });
          }
          if (active) {
            _context4.next = 5;
            break;
          }
          setUserLoggedIn(false);
          userId = CookieStorage$1.getCookie('USER_ID');
          if (userId) {
            _context4.next = 2;
            break;
          }
          throw new Error('User UserId not found cookies');
        case 2:
          CookieStorage$1.removeCookie({
            name: 'sid'
          });
          _context4.next = 3;
          return getUserEmail(userId, tenant, context);
        case 3:
          _yield$getUserEmail = _context4.sent;
          emailId = _yield$getUserEmail.emailId;
          _context4.next = 4;
          return softLogin(emailId, tenant, context);
        case 4:
          _yield$softLogin = _context4.sent;
          sessionId = _yield$softLogin.sessionId;
          expires = _yield$softLogin.expires;
          CookieStorage$1.setCookie({
            name: 'sid',
            value: sessionId,
            regionCode: tenant,
            expiryDays: expires,
            priority: 'High'
          });
          setUserLoggedIn(true);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function refreshUserSession(_x1, _x10, _x11, _x12, _x13) {
    return _ref4.apply(this, arguments);
  };
}();
var getUserAddressesCheckout = function () {
  var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee5(newSessionId, tenant, store) {
    var CHECKOUT_URL, response, dataSorted;
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          CHECKOUT_URL = "".concat(getEnvBaseUrl(tenant), "/s/checkout/v1/users/addresses");
          _context5.next = 1;
          return doFetch(CHECKOUT_URL, {
            headers: _objectSpread$H(_objectSpread$H({}, Catalyst.getHeaders({
              store: store,
              tenant: tenant
            })), {}, {
              Authorization: newSessionId
            })
          });
        case 1:
          response = _context5.sent;
          dataSorted = response.data.addresses.map(function (address) {
            var newStateCode = address.customInfo.find(function (item) {
              return item.name === 'stateCode';
            }).values[0];
            var newMunicipalCode = address.customInfo.find(function (item) {
              return item.name === 'municipalCode';
            }).values[0];
            var customInfo = [{
              name: 'department',
              value: ''
            }, {
              name: 'municipalCode',
              value: newMunicipalCode
            }, {
              name: 'stateCode',
              value: newStateCode
            }, {
              name: 'municipalPoliticalAreaId',
              value: address.municipalCode
            }, {
              name: 'statePoliticalAreaId',
              value: address.stateCode
            }];
            var mappedAddress = {
              id: address.id,
              addressName: '',
              isShippingAddress: false,
              isBillingAddress: false,
              isDefaultAddress: address.isDefaultAddress,
              addressLine1: address.addressLine2,
              addressLine2: address.addressLine1,
              addressLine3: address.addressLine3,
              municipal: address.municipalName,
              municipalCode: newMunicipalCode,
              departmentNumber: '',
              city: address.cityName,
              state: address.stateName,
              stateCode: newStateCode,
              country: address.countryName,
              postcode: '',
              latitude: address.latitude,
              longitude: address.longitude,
              customInfo: customInfo
            };
            if (tenant === 'pe') {
              var newCityCode = address.customInfo.find(function (item) {
                return item.name === 'cityCode';
              }).values[0];
              mappedAddress.cityCode = newCityCode;
              customInfo.push({
                name: 'cityPoliticalAreaId',
                value: address.cityCode
              });
              mappedAddress.customInfo = customInfo;
            }
            return mappedAddress;
          });
          return _context5.abrupt("return", {
            addresses: dataSorted
          });
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getUserAddressesCheckout(_x14, _x15, _x16) {
    return _ref5.apply(this, arguments);
  };
}();
var getUserAddresses = function () {
  var _ref6 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee6(cookieSID, tenant, store) {
    var baseUrl, response, _t;
    return _regeneratorRuntime.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          baseUrl = getEnvBaseUrl(tenant);
          _context6.next = 1;
          return doFetch(apiEndpoints.getUserAddresses(baseUrl, store), {
            headers: _objectSpread$H(_objectSpread$H({}, Catalyst.getHeaders({
              store: store,
              tenant: tenant
            })), {}, {
              Authorization: cookieSID
            })
          });
        case 1:
          response = _context6.sent;
          return _context6.abrupt("return", response);
        case 2:
          _context6.prev = 2;
          _t = _context6["catch"](0);
          return _context6.abrupt("return", JSON.parse(_t.message));
        case 3:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 2]]);
  }));
  return function getUserAddresses(_x17, _x18, _x19) {
    return _ref6.apply(this, arguments);
  };
}();
var saveUserAddresses = function () {
  var _ref7 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee7(cookieSID, tenant, store, data) {
    var baseUrl, response, _t2;
    return _regeneratorRuntime.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          baseUrl = getEnvBaseUrl(tenant);
          _context7.next = 1;
          return doPost(apiEndpoints.saveUserAddresses(baseUrl, store), data, {
            headers: _objectSpread$H(_objectSpread$H({
              'Content-Type': 'application/json'
            }, Catalyst.getHeaders({
              store: store,
              tenant: tenant
            })), {}, {
              Authorization: cookieSID
            })
          }, true);
        case 1:
          response = _context7.sent;
          return _context7.abrupt("return", response);
        case 2:
          _context7.prev = 2;
          _t2 = _context7["catch"](0);
          return _context7.abrupt("return", JSON.parse(_t2.message));
        case 3:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 2]]);
  }));
  return function saveUserAddresses(_x20, _x21, _x22, _x23) {
    return _ref7.apply(this, arguments);
  };
}();
var deleteUserAddresses = function () {
  var _ref8 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee8(cookieSID, tenant, store, addressID) {
    var baseUrl, response, _t3;
    return _regeneratorRuntime.wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          baseUrl = getEnvBaseUrl(tenant);
          _context8.next = 1;
          return doDelete(apiEndpoints.deleteUserAddresses(baseUrl, addressID, store), {
            headers: _objectSpread$H(_objectSpread$H({
              'Content-Type': 'application/json'
            }, Catalyst.getHeaders({
              store: store,
              tenant: tenant
            })), {}, {
              Authorization: cookieSID
            })
          }, true);
        case 1:
          response = _context8.sent;
          return _context8.abrupt("return", response);
        case 2:
          _context8.prev = 2;
          _t3 = _context8["catch"](0);
          return _context8.abrupt("return", JSON.parse(_t3.message));
        case 3:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 2]]);
  }));
  return function deleteUserAddresses(_x24, _x25, _x26, _x27) {
    return _ref8.apply(this, arguments);
  };
}();

var AppContext = createContext(null);
var AppContext$1 = AppContext;

function ownKeys$G(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$G(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$G(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$G(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useUserContextHook() {
  var FIRST_NAME_POSITION = 0;
  var CART_COUNT_POSITION = 1;
  var LAST_NAME_POSITION = 2;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    firstName = _useState2[0],
    setFirstName = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    lastName = _useState4[0],
    setLastName = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isUserLoggedIn = _useState6[0],
    setUserLoggedIn = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    cartCount = _useState8[0],
    setCartCount = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isOverlayEnabled = _useState0[0],
    setOverlayEnabled = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isVendorLogin = _useState10[0],
    setIsVendorLoggedIn = _useState10[1];
  var _useState11 = useState({}),
    _useState12 = _slicedToArray(_useState11, 2),
    vendorData = _useState12[0],
    setVendorData = _useState12[1];
  var unescapeATGCookies = CookieStorage$1.unescapeATGCookies,
    getCookie = CookieStorage$1.getCookie,
    parseCookieValue = CookieStorage$1.parseCookieValue;
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    enableAnalytics = _useState14[0],
    setAnalyticsInfo = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    userSegments = _useState16[0],
    setUserSegments = _useState16[1];
  var _useContext = useContext(AppContext$1),
    tenant = _useContext.tenant,
    commerceOriginData = _useContext.commerceOriginData,
    isSodimacStandAloneSite = _useContext.isSodimacStandAloneSite;
  var refreshUserData = function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var userCookie, dynDataCookie, dynDataParts, cookieFirstName, cookieCartCount, cookieLastName, vendorDataCookie, _vendorDataCookie$spl, _vendorDataCookie$spl2, vendorId, storeName, storeId, vendorCode, cartProductsCount, cookieSID, context;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            userCookie = CookieStorage$1.getUserDataCookieName();
            dynDataCookie = unescapeATGCookies(getCookie(userCookie));
            dynDataParts = dynDataCookie.split('*');
            cookieFirstName = decodeURIComponent(dynDataParts[FIRST_NAME_POSITION]);
            cookieCartCount = dynDataParts[CART_COUNT_POSITION];
            cookieLastName = decodeURIComponent(dynDataParts[LAST_NAME_POSITION]);
            vendorDataCookie = unescapeATGCookies(getCookie('VENDOR_DATA'));
            if (!vendorDataCookie) {
              _context.next = 2;
              break;
            }
            vendorDataCookie = vendorDataCookie.replace(/"/g, '');
            _vendorDataCookie$spl = vendorDataCookie.split('*'), _vendorDataCookie$spl2 = _slicedToArray(_vendorDataCookie$spl, 4), vendorId = _vendorDataCookie$spl2[0], storeName = _vendorDataCookie$spl2[1], storeId = _vendorDataCookie$spl2[2], vendorCode = _vendorDataCookie$spl2[3];
            setIsVendorLoggedIn(true);
            if (!(!vendorId || !storeId || !vendorCode)) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return", null);
          case 1:
            setVendorData({
              vendorId: vendorId,
              storeName: storeName,
              storeId: storeId,
              vendorCode: vendorCode
            });
          case 2:
            cartProductsCount = !Number.isNaN(parseInt(cookieCartCount, 10)) ? cookieCartCount : '0';
            cookieSID = unescapeATGCookies(getCookie('sid'));
            context = {
              isSodimacStandAloneSite: isSodimacStandAloneSite
            };
            _context.next = 3;
            return refreshUserSession(cookieSID, tenant, setUserLoggedIn, commerceOriginData, context);
          case 3:
            if (CookieStorage$1.isCatalyst()) {
              setUserLoggedIn(!!cookieFirstName && !!cookieSID);
            } else {
              setUserLoggedIn(!!cookieFirstName);
            }
            setFirstName(cookieFirstName);
            setCartCount(cartProductsCount);
            setLastName(cookieLastName);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function refreshUserData() {
      return _ref.apply(this, arguments);
    };
  }();
  var getUserSegments = function getUserSegments() {
    var userSegmentValue = getCookie(USER_SEGMENT_COOKIE);
    var cookieSegmentValue = decodeURIComponent(userSegmentValue);
    var userSegmentDecode = parseCookieValue(USER_SEGMENT_COOKIE, cookieSegmentValue);
    setUserSegments(userSegmentDecode);
  };
  useEffect(function () {
    refreshUserData();
  }, []);
  return {
    firstName: firstName || '',
    setFirstName: setFirstName,
    isUserLoggedIn: isUserLoggedIn,
    setUserLoggedIn: setUserLoggedIn,
    cartCount: cartCount,
    setCartCount: setCartCount,
    lastName: lastName,
    isVendorLogin: isVendorLogin,
    vendorData: vendorData,
    refreshUserData: refreshUserData,
    initDigitalData: initDigitalData,
    enableAnalytics: enableAnalytics,
    setAnalyticsInfo: setAnalyticsInfo,
    isOverlayEnabled: isOverlayEnabled,
    setOverlayEnabled: setOverlayEnabled,
    userSegments: userSegments,
    setUserSegments: setUserSegments,
    getUserSegments: getUserSegments
  };
}
var UserContext = createContainer(useUserContextHook);
var _UserContext = _slicedToArray(UserContext, 2),
  UserProvider = _UserContext[0],
  useUsercontext = _UserContext[1];
var withUser = function withUser(WrappedComponent) {
  var getInitialProps = WrappedComponent.getInitialProps;
  var ComponentWithUser = function ComponentWithUser(props) {
    var user = useUsercontext();
    return jsx(WrappedComponent, _objectSpread$G(_objectSpread$G({}, props), user));
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithUser.getInitialProps = getInitialProps;
  }
  return ComponentWithUser;
};
var UserContext$1 = UserContext;

var UnifiedLoginModal = function UnifiedLoginModal(_ref) {
  var atgBaseUrl = _ref.atgBaseUrl,
    catalystBaseUrl = _ref.catalystBaseUrl,
    onUserLogin = _ref.onUserLogin,
    setUserLoggedIn = _ref.setUserLoggedIn,
    showLoginForm = _ref.showLoginForm,
    onClose = _ref.onClose,
    tenant = _ref.tenant,
    initDigitalData = _ref.initDigitalData,
    enableAnalytics = _ref.enableAnalytics,
    isRebrandingEnabled = _ref.isRebrandingEnabled,
    onComplete = _ref.onComplete,
    onConsentsUpdate = _ref.onConsentsUpdate,
    onPasswordUpdate = _ref.onPasswordUpdate,
    baseUrl = _ref.baseUrl;
  var _useState = useState({
      enabled: false,
      cartId: '',
      siteName: '',
      ecommName: '',
      defaultColor: '',
      multiSite: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    whiteLabelProp = _useState2[0],
    setWhiteLabelProp = _useState2[1];
  var onLogin = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(response) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!response.loginStatus) {
              _context.next = 2;
              break;
            }
            setUserLoggedIn(true);
            _context.next = 1;
            return onUserLogin(response);
          case 1:
            if (enableAnalytics) {
              initDigitalData();
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onLogin(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var setInitialWhiteLabelProps = function setInitialWhiteLabelProps() {
    if (!isClientSide()) return;
    var _URL = new URL(window.location.href),
      host = _URL.host;
    var sodimacStandaloneRegExp = /(sodimac)\.(cl|com(\.pe)?)$/;
    var tottusStandaloneRegExp = /(tottus)\.(cl|com(\.pe)?)$/;
    var isSodimacStandalone = sodimacStandaloneRegExp.test(host);
    var isTottusStandalone = tottusStandaloneRegExp.test(host);
    var store;
    if (isSodimacStandalone) store = STORES.SO_COM;
    if (isTottusStandalone) store = STORES.TO_COM;
    if (STANDALONE_STORES.includes(store)) {
      var whiteLabelProps = generateWhiteLabelProps(store, tenant.toLowerCase());
      setWhiteLabelProp(whiteLabelProps);
    }
  };
  useEffect(function () {
    setInitialWhiteLabelProps();
  }, []);
  return jsx(Fragment, {
    children: jsx(LoginWizard, {
      atgBaseUrl: atgBaseUrl,
      catalystBaseUrl: catalystBaseUrl,
      onLogin: onLogin,
      onClose: onClose,
      show: showLoginForm,
      tenant: tenant,
      flowType: "header",
      doMergeCart: true,
      id: "testId-cc",
      isRebrandingEnabled: isRebrandingEnabled,
      onComplete: onComplete,
      onConsentsUpdate: onConsentsUpdate,
      onPasswordUpdate: onPasswordUpdate,
      baseUrl: baseUrl,
      whitelabel: whiteLabelProp
    })
  });
};
UnifiedLoginModal.propTypes = {
  atgBaseUrl: PropTypes.string.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  onUserLogin: PropTypes.func.isRequired,
  initDigitalData: PropTypes.func,
  setUserLoggedIn: PropTypes.func.isRequired,
  showLoginForm: PropTypes.bool.isRequired,
  enableAnalytics: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired,
  isRebrandingEnabled: PropTypes.bool,
  onComplete: PropTypes.func,
  onConsentsUpdate: PropTypes.func,
  onPasswordUpdate: PropTypes.func,
  baseUrl: PropTypes.string
};
UnifiedLoginModal.defaultProps = {
  onUserLogin: noop$2,
  initDigitalData: noop$2,
  tenant: countriesCode.FACL,
  enableAnalytics: false,
  isRebrandingEnabled: false,
  onComplete: noop$2,
  onConsentsUpdate: noop$2,
  onPasswordUpdate: noop$2,
  baseUrl: undefined
};
var LoginModal = withUser(UnifiedLoginModal);
var LoginModal$1 = LoginModal;

var arrayWithoutHoles$1 = createCommonjsModule(function (module) {
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(arrayWithoutHoles$1);

var iterableToArray$1 = createCommonjsModule(function (module) {
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(iterableToArray$1);

var nonIterableSpread$1 = createCommonjsModule(function (module) {
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(nonIterableSpread$1);

var arrayWithoutHoles = arrayWithoutHoles$1;

var iterableToArray = iterableToArray$1;

var nonIterableSpread = nonIterableSpread$1;

var toConsumableArray = createCommonjsModule(function (module) {
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _toConsumableArray = unwrapExports(toConsumableArray);

var getBaseUrl$1 = function getBaseUrl(tenant) {
  var _window;
  var envPrefix = 'www';
  var baseUrl = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin;
  if (baseUrl && (baseUrl.includes(ENVIRONMENT.DEVELOPMEMT) || baseUrl.includes(ENVIRONMENT.STAGING))) {
    envPrefix = 'staging';
  }
  if (baseUrl && baseUrl.includes(ENVIRONMENT.UAT)) {
    envPrefix = 'beta';
  }
  return "https://".concat(envPrefix).concat(SODIMAC_RETAIL_DOMAIN_NAME[tenant], "/s/geo/v1/geo/").concat(tenant, "/virtual-zones");
};
var getVirtualZones = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_ref) {
    var tenant, politicalId, response, baseUrl, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          tenant = _ref.tenant, politicalId = _ref.politicalId;
          response = {};
          _context.prev = 1;
          baseUrl = getBaseUrl$1(tenant);
          _context.next = 2;
          return doFetch("".concat(baseUrl, "?politicalAreaId=").concat(politicalId));
        case 2:
          response = _context.sent;
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          console.error('Zone fetch failed', _t.message);
        case 4:
          return _context.abrupt("return", response || {});
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function getVirtualZones(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getVirtualZones$1 = getVirtualZones;

var postalCodesMX = [{
  politicalId: 'a92f8c66-04a3-4280-bb5f-9f59182f5d61',
  name: 'SANTA CRUZ ACATLAN',
  parentPoliticalId: '53ad525b-fcbe-4991-83a0-a548fe895e01',
  parentStateId: 'e439e42a-485b-457a-b176-5acf645f452c',
  parentStateName: 'MÉXICO',
  active: true,
  zones: [],
  type: 'DISTRICT',
  priceGroupId: '',
  latitude: -34.818075,
  longitude: -56.213737,
  code: '',
  postalCode: '53150',
  parentCountyName: 'NAUCALPAN DE JUÁREZ'
}];

var geoFallbacks = {
  postalCode: {
    mx: postalCodesMX
  }
};

function classNames() {
  var hasOwn = {}.hasOwnProperty;
  var classes = [];
  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];
    if (!arg) continue;
    var argType = _typeof(arg);
    if (argType === 'string' || argType === 'number') {
      classes.push(arg);
    } else if (Array.isArray(arg)) {
      if (arg.length) {
        var inner = classNames.apply(null, arg);
        if (inner) {
          classes.push(inner);
        }
      }
    } else if (argType === 'object') {
      if (arg.toString === Object.prototype.toString) {
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      } else {
        classes.push(arg.toString());
      }
    }
  }
  return classes.join(' ');
}

var getTopScroll = function getTopScroll() {
  if (document.body.style.top) {
    return document.body.style.top;
  }
  var scrollY = window.scrollY || document.documentElement.scrollTop;
  return "-".concat(scrollY, "px");
};
var disableScroll = function disableScroll() {
  document.body.style.top = getTopScroll();
};
var enableScroll = function enableScroll() {
  var scrollY = document.body.style.top;
  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
};

var WithOutsideClick = function WithOutsideClick(_ref) {
  var children = _ref.children,
    onOutsideClick = _ref.onOutsideClick,
    className = _ref.className,
    styles = _ref.styles,
    id = _ref.id,
    style = _ref.style;
  var node = useRef();
  var handleClick = function handleClick(e) {
    if (!(node.current && node.current.contains(e.target))) {
      onOutsideClick(e);
    }
  };
  useEffect(function () {
    document.addEventListener('mousedown', handleClick, true);
    return function () {
      document.removeEventListener('mousedown', handleClick, true);
    };
  }, []);
  return jsx("div", {
    id: id,
    className: styles["".concat(className || 'doc-click-overlay')],
    ref: function ref(r) {
      node.current = r;
    },
    style: style,
    children: children
  });
};
WithOutsideClick.defaultProps = {
  className: '',
  id: '',
  style: {}
};
WithOutsideClick.propTypes = {
  children: PropTypes.any.isRequired,
  onOutsideClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  styles: PropTypes.object.isRequired,
  id: PropTypes.string,
  style: PropTypes.object
};
var WithOutsideClick$1 = WithOutsideClick;

var nameHOC$3 = function nameHOC(Component) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "".concat(Component.originalName || Component.displayName || Component.name || 'Component').concat(suffix);
};
var hocUtils = {
  nameHOC: nameHOC$3
};
var hocUtils$1 = hocUtils;

function ownKeys$F(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$F(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$F(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$F(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var nameHOC$2 = hocUtils$1.nameHOC;
var WithTogggle = function WithTogggle(WrappedComponent) {
  var ComponentWithToggle = function ComponentWithToggle(props) {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      toggle = _useState2[0],
      setToggle = _useState2[1];
    var toggleState = {
      visible: toggle,
      setVisible: function setVisible(bool) {
        return setToggle(bool);
      }
    };
    return jsx(WrappedComponent, _objectSpread$F(_objectSpread$F({}, props), {}, {
      toggleState: toggleState
    }));
  };
  ComponentWithToggle.originalName = nameHOC$2(WrappedComponent);
  ComponentWithToggle.displayName = nameHOC$2(WrappedComponent, 'WithToggle');
  return ComponentWithToggle;
};
var WithToggle$2 = WithTogggle;

var styles$1m = {"background-overlay":"BackgroundOverlay-module_background-overlay__l9baK","shade-lighter":"BackgroundOverlay-module_shade-lighter__5zVLP"};

var BackgroundOverlay = function BackgroundOverlay(_ref) {
  var shade = _ref.shade,
    setOverlayEnabled = _ref.setOverlayEnabled;
  var overlayRef = useRef();
  React.useEffect(function () {
    setOverlayEnabled(true);
    return function () {
      setOverlayEnabled(false);
    };
  }, []);
  return createPortal(jsx("div", {
    ref: overlayRef,
    onKeyDown: noop$2,
    tabIndex: "0",
    role: "button",
    className: classNames(styles$1m['background-overlay'], _defineProperty({}, styles$1m["shade-".concat(shade)], shade && typeof shade === 'string'))
  }), document.body);
};
BackgroundOverlay.defaultProps = {
  shade: null,
  setOverlayEnabled: function setOverlayEnabled() {}
};
BackgroundOverlay.propTypes = {
  shade: PropTypes.oneOf(['lighter']),
  setOverlayEnabled: PropTypes.func.isRequired
};
var BackgroundOverlay$1 = withUser(BackgroundOverlay);

var styles$1l = {"spinner":"Spinner-module_spinner__L8Y-E","rotate":"Spinner-module_rotate__f6LiW","medium":"Spinner-module_medium__c8-Yt","small":"Spinner-module_small__IbhIz","spinner__svg":"Spinner-module_spinner__svg__Ik0JH","white":"Spinner-module_white__SzC8f","path_circle":"Spinner-module_path_circle__KGi5w","spinner-ie":"Spinner-module_spinner-ie__OuXyl","collapse":"Spinner-module_collapse__6AQVi","green":"Spinner-module_green__M-zlV","orange":"Spinner-module_orange__dKS4F"};

var MarketplaceSpinner = function MarketplaceSpinner(_ref) {
  var size = _ref.size,
    color = _ref.color;
  return jsx("div", {
    className: classNames(styles$1l.spinner, styles$1l["".concat(size)], styles$1l["".concat(color)]),
    children: jsxs("svg", {
      width: "49",
      height: "49",
      viewBox: "0 0 49 49",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: styles$1l.spinner__svg,
      children: [jsx("path", {
        d: "M24.4378 2C36.7207 2.05798 46.66 12.0332 46.66 24.33C46.66 36.6628 36.6628 46.66 24.33 46.66C12.039 46.66 2.0661 36.7265 2 24.4494",
        stroke: "#F0F0F0",
        strokeWidth: "3"
      }), jsx("path", {
        d: "M46.66 24.4378C46.602 36.7207 36.628 46.66 24.33 46.66C11.9972 46.66 2 36.6628 2 24.33C2 12.0378 11.9335 2.06494 24.2106 2",
        stroke: "#343E49",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })
  });
};
MarketplaceSpinner.propTypes = {
  size: PropTypes.oneOf(['medium', 'small']),
  color: PropTypes.oneOf(['orange', 'green'])
};
MarketplaceSpinner.defaultProps = {
  size: 'medium',
  color: 'orange'
};
var MarketplaceSpinner$1 = MarketplaceSpinner;

var RetailSpinner = function RetailSpinner(_ref) {
  var size = _ref.size,
    color = _ref.color;
  return jsx("div", {
    className: classNames(styles$1l.spinner, styles$1l["".concat(size)], styles$1l["".concat(color)]),
    children: jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      className: styles$1l.spinner__svg,
      viewBox: "-2.5 -2.5 49 49",
      children: jsx("circle", {
        className: styles$1l['spinner-ie'],
        fill: "none",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "4",
        cx: "22",
        cy: "22",
        r: "22"
      })
    })
  });
};
RetailSpinner.propTypes = {
  size: PropTypes.oneOf(['medium', 'small']),
  color: PropTypes.oneOf(['white', 'green'])
};
RetailSpinner.defaultProps = {
  size: 'medium',
  color: 'green'
};
var RetailSpinner$1 = RetailSpinner;

var Spinner = function Spinner(props) {
  var _useContext = useContext(AppContext$1),
    isRebrandingEnabled = _useContext.isRebrandingEnabled;
  return jsx(React.Fragment, {
    children: isRebrandingEnabled ? jsx(MarketplaceSpinner$1, {}) : jsx(RetailSpinner$1, {})
  });
};
var Spinner$1 = Spinner;

var styles$1k = {"modal-container":"Modal-module_modal-container__c0qqt","modal":"Modal-module_modal__DYZcT","floatBottom":"Modal-module_floatBottom__1MCV1","floatBottomTransition":"Modal-module_floatBottomTransition__6Iope","frombottom":"Modal-module_frombottom__7IfHW","floatBottomEndTransition":"Modal-module_floatBottomEndTransition__mJJRG","tobottom":"Modal-module_tobottom__AHb2V","floatBottomEndTransitionOnboarding":"Modal-module_floatBottomEndTransitionOnboarding__cQBCB","tobottomOnboarding":"Modal-module_tobottomOnboarding__VbODb","floatBottomEnd":"Modal-module_floatBottomEnd__4v0zu","withPadding":"Modal-module_withPadding__Z4tUk","modal-busy-overlay":"Modal-module_modal-busy-overlay__0ZJ7S","modal-close":"Modal-module_modal-close__A5nxD","marginRight5":"Modal-module_marginRight5__Yu6ZY","modal-header":"Modal-module_modal-header__zGShV","noBorder":"Modal-module_noBorder__iJoRk","modal-body":"Modal-module_modal-body__hw6EB","zone-modal-body-retail":"Modal-module_zone-modal-body-retail__N0n2y","zone-modal-body-marketplace":"Modal-module_zone-modal-body-marketplace__DsioF","no-result-modal-body":"Modal-module_no-result-modal-body__hQib3","full-screen":"Modal-module_full-screen__kei2L","with-header":"Modal-module_with-header__yPY6C","flex":"Modal-module_flex__jr-HR","doc-click-overlay":"Modal-module_doc-click-overlay__-lMFC","click-element":"Modal-module_click-element__EhvxD","icon-danger":"Modal-module_icon-danger__VVgf0","icon-big":"Modal-module_icon-big__nFuRb"};

function ownKeys$E(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$E(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$E(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$E(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Modal = function Modal(_ref) {
  var children = _ref.children,
    toggleState = _ref.toggleState,
    content = _ref.content,
    options = _ref.options,
    header = _ref.header,
    visible = _ref.visible,
    withPadding = _ref.withPadding,
    showCloseButton = _ref.showCloseButton,
    fullScreen = _ref.fullScreen,
    appendClickElement = _ref.appendClickElement,
    deviceType = _ref.deviceType,
    showSpinner = _ref.showSpinner,
    resetHandler = _ref.resetHandler,
    closeOtherModals = _ref.closeOtherModals,
    fullWidth = _ref.fullWidth,
    customClass = _ref.customClass,
    customID = _ref.customID,
    customBodyClass = _ref.customBodyClass,
    customHeaderClass = _ref.customHeaderClass,
    isOverlayEnabled = _ref.isOverlayEnabled,
    modalTranslateStyle = _ref.modalTranslateStyle,
    customCloseIconClass = _ref.customCloseIconClass,
    modalAnimationClass = _ref.modalAnimationClass,
    zoneModalWrapStyles = _ref.zoneModalWrapStyles,
    buttonOpenModalID = _ref.buttonOpenModalID,
    modalContainerZIndex = _ref.modalContainerZIndex,
    keepNoScroll = _ref.keepNoScroll;
    _ref.isNewDeliveryOptionModal;
  if (visible) {
    toggleState.setVisible(true);
  }
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    customHeader = _useState2[0],
    setCustomHeader = _useState2[1];
  var config = _objectSpread$E({
    width: undefined,
    height: undefined,
    disableOutsideClick: false
  }, options);
  var _useState3 = useState(showSpinner),
    _useState4 = _slicedToArray(_useState3, 2),
    modalBusy = _useState4[0],
    setModalBusy = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isModalVisible = _useState6[0],
    setModalVisible = _useState6[1];
  var removeClasses = function removeClasses() {
    if (!customBodyClass) {
      return;
    }
    if (!keepNoScroll) {
      toggleBodyClass(false, 'no-scroll');
    }
    if (deviceType !== 'desktop') {
      enableScroll();
    }
    setModalVisible(false);
  };
  useEffect(function () {
    if (toggleState.visible) {
      setModalVisible(true);
      toggleBodyClass(true, 'no-scroll');
      if (deviceType !== 'desktop') {
        disableScroll();
      }
    } else if (isModalVisible) {
      removeClasses();
    }
    if (!toggleState.visible) {
      resetHandler();
    }
    return removeClasses;
  }, [toggleState.visible]);
  var actions = {
    close: function close() {
      toggleState.setVisible(false);
    },
    setCustomHeader: setCustomHeader,
    setBusy: function setBusy(toggle) {
      return setModalBusy(toggle);
    }
  };
  var newChildren = Children.map(children, function (element) {
    return appendClickElement ? jsx("div", {
      onClick: function onClick() {
        toggleState.setVisible(true);
        closeOtherModals();
      },
      onKeyDown: noop$2,
      role: "button",
      tabIndex: 0,
      className: "click-element",
      children: children
    }) : jsx(element.type, _objectSpread$E({
      onClick: function onClick() {
        toggleState.setVisible(true);
        closeOtherModals();
      },
      id: buttonOpenModalID
    }, element.props));
  });
  var height = options.height,
    width = options.width,
    _options$overflow = options.overflow,
    overflow = _options$overflow === void 0 ? 'auto' : _options$overflow,
    borderRadius = options.borderRadius;
  var heightWithUnits = height ? height.toString().includes('vh', '%') ? height : "".concat(height, "px") : 'auto';
  var widthUnits = width ? "".concat(width, "px") : 'auto';
  var getModalContainerStyles = function getModalContainerStyles() {
    var modalContainerStyles = {};
    if (!isEmpty(modalTranslateStyle)) {
      modalContainerStyles = _objectSpread$E({}, modalTranslateStyle);
    }
    if (modalContainerZIndex) {
      modalContainerStyles.zIndex = modalContainerZIndex;
    }
    return modalContainerStyles;
  };
  return jsxs(Fragment, {
    children: [newChildren, toggleState.visible && jsxs("div", {
      style: getModalContainerStyles(),
      className: classNames(styles$1k['modal-container'], _defineProperty(_defineProperty({}, styles$1k['full-screen'], fullScreen), modalAnimationClass, modalAnimationClass)),
      children: [jsx(WithOutsideClick$1, {
        id: 'zone_modal_wrap',
        onOutsideClick: function onOutsideClick(e) {
          if (!config.disableOutsideClick && toggleState.visible) {
            e.stopPropagation();
            actions.close();
          }
        },
        styles: {
          'doc-click-overlay': config.disableOutsideClick ? styles$1k['doc-click-overlay'] : ''
        },
        style: zoneModalWrapStyles,
        children: jsxs("div", {
          style: _objectSpread$E(_objectSpread$E({}, options), {}, {
            height: fullScreen ? '100vh' : heightWithUnits,
            width: fullScreen || fullWidth ? '100vw' : widthUnits,
            overflow: overflow
          }),
          className: classNames(styles$1k.modal, _defineProperty({}, styles$1k.withPadding, withPadding), styles$1k["".concat(customClass)]),
          id: customID,
          children: [modalBusy && jsx("div", {
            className: styles$1k['modal-busy-overlay'],
            children: jsx(Spinner$1, {})
          }), showCloseButton && jsx("button", {
            type: "button",
            className: classNames(styles$1k['modal-close'], _defineProperty({}, styles$1k["".concat(customCloseIconClass)], customCloseIconClass)),
            id: "testId-modal-close",
            onClick: actions.close,
            children: jsx("i", {
              className: classNames(styles$1k['icon-danger'], fullWidth ? styles$1k['icon-big'] : '')
            })
          }), header && jsxs("div", {
            style: {
              borderBottom: borderRadius === 0 ? 'none' : null
            },
            className: classNames(styles$1k['modal-header'], _defineProperty(_defineProperty({}, styles$1k.withPadding, withPadding), styles$1k["".concat(customHeaderClass)], customHeaderClass)),
            children: [jsx("i", {
              className: "csicon-".concat(header.icon)
            }), " ", header.title]
          }), !header && customHeader && jsx("div", {
            className: classNames(styles$1k['modal-header'], _defineProperty(_defineProperty({}, styles$1k.withPadding, withPadding), styles$1k["".concat(customHeaderClass)], customHeaderClass)),
            children: customHeader
          }), jsx("div", {
            className: classNames(styles$1k['modal-body'], _defineProperty(_defineProperty(_defineProperty({}, styles$1k['with-header'], header || customHeader), styles$1k['full-screen'], fullScreen), styles$1k.withPadding, withPadding), styles$1k["".concat(customBodyClass)]),
            children: content(actions)
          })]
        })
      }), isOverlayEnabled && jsx(BackgroundOverlay$1, {}), jsx("style", {
        children: "\n          .no-scroll {\n            overflow: hidden;\n            pointer-events: none;\n          }\n        "
      })]
    })]
  });
};
Modal.propTypes = {
  children: PropTypes.node,
  toggleState: PropTypes.object.isRequired,
  content: PropTypes.func.isRequired,
  options: PropTypes.object,
  header: PropTypes.objectOf({
    icon: PropTypes.string,
    title: PropTypes.string
  }),
  visible: PropTypes.bool,
  withPadding: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  fullScreen: PropTypes.bool,
  appendClickElement: PropTypes.bool,
  deviceType: PropTypes.string,
  showSpinner: PropTypes.bool,
  resetHandler: PropTypes.func,
  closeOtherModals: PropTypes.func,
  fullWidth: PropTypes.bool,
  isOverlayEnabled: PropTypes.bool,
  customClass: PropTypes.string,
  customID: PropTypes.string,
  modalTranslateStyle: PropTypes.object,
  customBodyClass: PropTypes.string,
  modalAnimationClass: PropTypes.string,
  customHeaderClass: PropTypes.string,
  customCloseIconClass: PropTypes.string,
  zoneModalWrapStyles: PropTypes.object,
  buttonOpenModalID: PropTypes.string,
  modalContainerZIndex: PropTypes.number,
  keepNoScroll: PropTypes.bool
};
Modal.defaultProps = {
  children: [],
  options: {},
  header: null,
  visible: false,
  isOverlayEnabled: true,
  withPadding: true,
  showCloseButton: true,
  fullScreen: false,
  appendClickElement: false,
  deviceType: 'desktop',
  showSpinner: false,
  resetHandler: noop$2,
  closeOtherModals: noop$2,
  fullWidth: false,
  customClass: '',
  customID: '',
  customBodyClass: '',
  modalTranslateStyle: {},
  modalAnimationClass: '',
  customHeaderClass: '',
  customCloseIconClass: '',
  zoneModalWrapStyles: {},
  buttonOpenModalID: '',
  keepNoScroll: false
};
WithToggle$2(Modal);

var executeDataCallbacks = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(comunaData, getStockEnTiendaData, getDeliveryEstimatesV2Data) {
    var promises, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          promises = [];
          if (typeof getStockEnTiendaData === 'function') {
            promises.push(Promise.resolve(getStockEnTiendaData(comunaData)));
          }
          if (typeof getDeliveryEstimatesV2Data === 'function') {
            promises.push(Promise.resolve(getDeliveryEstimatesV2Data(comunaData)));
          }
          _context.prev = 1;
          _context.next = 2;
          return Promise.all(promises);
        case 2:
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          console.error('Error ejecutando callbacks:', _t);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function executeDataCallbacks(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var executeDataCallbacks$1 = executeDataCallbacks;

var styles$1j = {"autocomplete-input-wrapper":"Autocomplete-module_autocomplete-input-wrapper__tHpkD","autocomplete-input":"Autocomplete-module_autocomplete-input__Mg01d","so-retail-wrapper":"Autocomplete-module_so-retail-wrapper__0GrB3","autocomplete-input-2":"Autocomplete-module_autocomplete-input-2__GTgWk","type2":"Autocomplete-module_type2__iXatU","suggestions-list":"Autocomplete-module_suggestions-list__TOUiO","arrow-icon":"Autocomplete-module_arrow-icon__fX667","scroll":"Autocomplete-module_scroll__F3Nt2","suggestion":"Autocomplete-module_suggestion__y3cWm","selected":"Autocomplete-module_selected__5T5ec","new-delivery-suggestions-list":"Autocomplete-module_new-delivery-suggestions-list__yWHGK","new-delivery-suggestion":"Autocomplete-module_new-delivery-suggestion__czLba","new-delivery-content":"Autocomplete-module_new-delivery-content__wtfU5","new-delivery-selected":"Autocomplete-module_new-delivery-selected__lERj-","floating-label":"Autocomplete-module_floating-label__r0t-V","retail":"Autocomplete-module_retail__xS2ht","marketplace":"Autocomplete-module_marketplace__bP3s1","floating-label-new-delivery":"Autocomplete-module_floating-label-new-delivery__Z5efK","floating-icon":"Autocomplete-module_floating-icon__6v-R0","postalIcon":"Autocomplete-module_postalIcon__8VT8O","icon-search":"Autocomplete-module_icon-search__TOIWL","icon-close":"Autocomplete-module_icon-close__lCSBb","error-notification":"Autocomplete-module_error-notification__tZMJU","postal-notification":"Autocomplete-module_postal-notification__sEkmO","postal-information":"Autocomplete-module_postal-information__7PW4q","inactive-postal-notification":"Autocomplete-module_inactive-postal-notification__F5f3s","postal-notification-text":"Autocomplete-module_postal-notification-text__LZo4O","postal-notification-text-mobile":"Autocomplete-module_postal-notification-text-mobile__nQ6X3","error-notification-text":"Autocomplete-module_error-notification-text__1hgKx","error-notification-text-mobile":"Autocomplete-module_error-notification-text-mobile__IxqXn","postal-information-text":"Autocomplete-module_postal-information-text__b3rrL","postal-information-text-mobile":"Autocomplete-module_postal-information-text-mobile__c84Pb","error-notification-container":"Autocomplete-module_error-notification-container__3gEsu","warning-icon":"Autocomplete-module_warning-icon__UzqWn","warning-icon-postal":"Autocomplete-module_warning-icon-postal__y0y0k","warning-icon-inactive-postal":"Autocomplete-module_warning-icon-inactive-postal__65ml4","information-icon-postal":"Autocomplete-module_information-icon-postal__WpVY0","postal-information-body":"Autocomplete-module_postal-information-body__NctRw","postal-notification-body":"Autocomplete-module_postal-notification-body__udIHF","bold-text":"Autocomplete-module_bold-text__o8oRn","autocomplete-new-delivery":"Autocomplete-module_autocomplete-new-delivery__Iqgbm","arrow-icon-new-delivery":"Autocomplete-module_arrow-icon-new-delivery__itEdm"};

var LABELS = {
  WRONG_SELECTION_TEXT: 'No se encontraron resultados para',
  RECOMMEND_TEXT: '. Te recomendamos ',
  PLEASE_SELECT_TEXT: 'seleccionar una opción de la lista',
  OR_TEXT: 'o',
  REENTER_TEXT: 'volver a ingresarla.',
  WRONG_POSTAL_CODE_TEXT: 'Ingresa un código postal válido.',
  INACTIVE_POSTAL_CODE_TEXT: 'En esta zona no tenemos cobertura. Intenta con otro código postal.',
  POSTAL_INFO_TEXT: 'Solo te mostraremos las zonas con productos disponibles en tu ubicación.'
};
var config = {
  LABELS: LABELS
};
var config$1 = config;

var ErrorNotification = function ErrorNotification(_ref) {
  var message = _ref.message,
    isPostalInput = _ref.isPostalInput,
    deviceType = _ref.deviceType,
    isPostalExist = _ref.isPostalExist,
    isPostalActive = _ref.isPostalActive,
    isPostalInfo = _ref.isPostalInfo;
  var LABELS = config$1.LABELS;
  var WRONG_SELECTION_TEXT = LABELS.WRONG_SELECTION_TEXT,
    RECOMMEND_TEXT = LABELS.RECOMMEND_TEXT,
    PLEASE_SELECT_TEXT = LABELS.PLEASE_SELECT_TEXT,
    OR_TEXT = LABELS.OR_TEXT,
    REENTER_TEXT = LABELS.REENTER_TEXT,
    WRONG_POSTAL_CODE_TEXT = LABELS.WRONG_POSTAL_CODE_TEXT,
    INACTIVE_POSTAL_CODE_TEXT = LABELS.INACTIVE_POSTAL_CODE_TEXT,
    POSTAL_INFO_TEXT = LABELS.POSTAL_INFO_TEXT;
  var containerClass = "".concat(styles$1j['error-notification'], " ").concat(isPostalInput ? styles$1j['postal-notification'] : '', " ").concat(isPostalInfo ? styles$1j['postal-information'] : '', " ").concat(!isPostalActive && isPostalExist && styles$1j['inactive-postal-notification']);
  var content;
  if (isPostalInput) {
    content = jsxs("div", {
      className: styles$1j['postal-notification-body'],
      children: [jsx("div", {
        className: "".concat(styles$1j['warning-icon-postal'], " ").concat(deviceType === 'mobile' && styles$1j['warning-icon-postal-mobile'], " ").concat(!isPostalActive && isPostalExist && styles$1j['warning-icon-inactive-postal'])
      }), jsxs("div", {
        className: "".concat(styles$1j['postal-notification-text'], " ").concat(deviceType === 'mobile' && styles$1j['postal-notification-text-mobile'], " "),
        children: [!isPostalActive && isPostalExist && jsx("span", {
          children: INACTIVE_POSTAL_CODE_TEXT
        }), ' ', !isPostalActive && !isPostalExist && jsx("span", {
          children: WRONG_POSTAL_CODE_TEXT
        })]
      })]
    });
  } else if (isPostalInfo) {
    content = jsxs("div", {
      className: styles$1j['postal-information-body'],
      children: [jsx("div", {
        className: "".concat(styles$1j['information-icon-postal'], " ").concat(deviceType === 'mobile' && styles$1j['information-icon-postal-mobile'])
      }), jsx("div", {
        className: "".concat(styles$1j['postal-information-text'], " ").concat(deviceType === 'mobile' && styles$1j['postal-information-text-mobile'], " "),
        children: jsx("span", {
          children: POSTAL_INFO_TEXT
        })
      })]
    });
  } else {
    content = jsxs("div", {
      children: [jsx("div", {
        className: styles$1j['warning-icon'],
        children: "!"
      }), jsxs("div", {
        className: styles$1j['error-notification-text'],
        children: [jsx("span", {
          children: WRONG_SELECTION_TEXT
        }), "\xA0", jsx("span", {
          className: styles$1j['bold-text'],
          children: message
        }), jsx("span", {
          children: RECOMMEND_TEXT
        }), "\xA0", jsx("span", {
          className: styles$1j['bold-text'],
          children: PLEASE_SELECT_TEXT
        }), "\xA0", jsx("span", {
          children: OR_TEXT
        }), "\xA0", jsx("span", {
          className: styles$1j['bold-text'],
          children: REENTER_TEXT
        })]
      })]
    });
  }
  return jsx("div", {
    className: containerClass,
    children: content
  });
};
ErrorNotification.propTypes = {
  message: PropTypes.string
};
ErrorNotification.defaultProps = {
  isPostalInput: false,
  isPostalInfo: false
};
var ErrorNotification$1 = ErrorNotification;

var SuggestionsList = function SuggestionsList(_ref) {
  var suggestions = _ref.suggestions,
    onSelectSuggestion = _ref.onSelectSuggestion,
    displaySuggestions = _ref.displaySuggestions,
    selectedSuggestion = _ref.selectedSuggestion,
    inputValue = _ref.inputValue,
    showEmptyResult = _ref.showEmptyResult,
    suggestionContainerRef = _ref.suggestionContainerRef,
    currState = _ref.currState,
    onHover = _ref.onHover,
    branding = _ref.branding,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder,
    isNewDeliveryOptionModal = _ref.isNewDeliveryOptionModal,
    deviceType = _ref.deviceType;
  if (displaySuggestions && suggestions.length > 0) {
    var currSelectionRef = useRef(null);
    useEffect(function () {
      if (currSelectionRef.current !== null && !currState.hovering) {
        if (currState.direction === 1 && currState.cursor % 3 === 2) {
          suggestionContainerRef.current.scroll(0, currSelectionRef.current.offsetHeight * currState.cursor);
        }
        if (currState.direction === -1 && (suggestions.length - currState.cursor) % 3 === 0) {
          suggestionContainerRef.current.scroll(0, currSelectionRef.current.offsetHeight * (currState.cursor - 2));
        }
      }
    });
    var isSelected = function isSelected(i) {
      return selectedSuggestion === inputValue || currState.cursor === i;
    };
    return jsx("ul", {
      className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$1j['suggestions-list'], !isNewDeliveryOptionModal), styles$1j['new-delivery-suggestions-list'], isNewDeliveryOptionModal), styles$1j.scroll, suggestions.length > 3)),
      ref: suggestionContainerRef,
      children: suggestions.map(function (suggestion, i) {
        var selected = isSelected(i);
        var isExplicitSelected = selectedSuggestion === suggestion;
        return jsx("li", {
          className: classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$1j.suggestion, !isNewDeliveryOptionModal), styles$1j['new-delivery-suggestion'], isNewDeliveryOptionModal), styles$1j.selected, selected && !isNewDeliveryOptionModal), styles$1j.storeBorder, isStore), styles$1j.enableSisThemedBorder, isStore && enableSisThemedBorder), styles$1j[branding]),
          onMouseDown: function onMouseDown() {
            return onSelectSuggestion(suggestion);
          },
          onMouseOver: function onMouseOver() {
            return onHover(i);
          },
          ref: i === currState.cursor ? currSelectionRef : null,
          children: isNewDeliveryOptionModal ? jsx("div", {
            className: classNames(styles$1j['new-delivery-content'], _defineProperty({}, styles$1j['new-delivery-selected'], isExplicitSelected)),
            children: suggestion
          }) : suggestion
        }, suggestion);
      })
    });
  } else if (showEmptyResult && displaySuggestions) {
    return jsx("ul", {
      className: classNames(styles$1j['error-notification-container'], styles$1j['suggestions-list']),
      children: jsx("li", {
        children: jsx(ErrorNotification$1, {
          message: "\"".concat(inputValue, "\""),
          deviceType: deviceType
        })
      })
    });
  }
  return jsx(React.Fragment, {});
};
SuggestionsList.propTypes = {
  suggestions: PropTypes.array.isRequired,
  onSelectSuggestion: PropTypes.func.isRequired,
  displaySuggestions: PropTypes.bool.isRequired,
  selectedSuggestion: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  showEmptyResult: PropTypes.bool,
  suggestionContainerRef: PropTypes.object,
  currState: PropTypes.object.isRequired,
  onHover: PropTypes.func.isRequired,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  enableSisThemedBorder: PropTypes.bool
};
var SuggestionsList$1 = SuggestionsList;

var Autocomplete = function Autocomplete(_ref) {
  var inputLabel = _ref.inputLabel,
    placeholder = _ref.placeholder,
    suggestions = _ref.suggestions,
    onChangeHandler = _ref.onChangeHandler,
    disabled = _ref.disabled,
    selectedOption = _ref.selectedOption,
    InputValue = _ref.InputValue,
    setInputValue = _ref.setInputValue,
    showEmptyResult = _ref.showEmptyResult,
    onFocus = _ref.onFocus,
    resetOnFocus = _ref.resetOnFocus,
    branding = _ref.branding,
    inputId = _ref.inputId,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder,
    type = _ref.type,
    isNewDeliveryOptionModal = _ref.isNewDeliveryOptionModal,
    isPostalInput = _ref.isPostalInput,
    postalCodeStatus = _ref.postalCodeStatus,
    deviceType = _ref.deviceType,
    isSodimacRe = _ref.isSodimacRe,
    setPostalWarning = _ref.setPostalWarning,
    isPostalActive = _ref.isPostalActive,
    isPostalExist = _ref.isPostalExist;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    filteredSuggestions = _useState2[0],
    setFilteredSuggestions = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSuggestion = _useState4[0],
    setSelectedSuggestion = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    displaySuggestions = _useState6[0],
    setDisplaySuggestions = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showLabel = _useState8[0],
    setLabel = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isFocused = _useState0[0],
    setFocus = _useState0[1];
  var suggestionContainerRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(function (currState, action) {
      var cursor = currState.cursor,
        direction = currState.direction,
        hovering = currState.hovering;
      switch (action.type) {
        case 'NEXT':
          direction = 1;
          if (cursor < suggestions.length - 1) {
            cursor += 1;
          }
          hovering = false;
          return {
            cursor: cursor,
            direction: direction,
            hovering: hovering
          };
        case 'PREV':
          direction = -1;
          if (cursor > 0) {
            cursor -= 1;
          }
          hovering = false;
          return {
            cursor: cursor,
            direction: direction,
            hovering: hovering
          };
        case 'SET_CURR':
          hovering = true;
          return {
            cursor: action.payload,
            direction: direction,
            hovering: hovering
          };
        case 'RESET':
          return {
            cursor: -1,
            direction: 1,
            hovering: false
          };
        default:
          return currState;
      }
    }, {
      cursor: -1,
      direction: 1,
      hovering: false
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(function () {
    if (selectedOption) {
      setSelectedSuggestion(selectedOption.name);
    }
  }, [selectedOption]);
  useEffect(function () {
    var shouldShow = postalCodeStatus === false;
    setDisplaySuggestions(shouldShow);
  }, [postalCodeStatus]);
  var resetInput = function resetInput() {
    setSelectedSuggestion(undefined);
    onChangeHandler(undefined);
    setFilteredSuggestions(suggestions);
    setInputValue('');
    dispatch({
      type: 'RESET'
    });
  };
  var renderPostalWarning = function renderPostalWarning() {
    if (isPostalInput && displaySuggestions && showEmptyResult) {
      setPostalWarning(true);
      return jsx(ErrorNotification$1, {
        isPostalInput: isPostalInput,
        deviceType: deviceType,
        isPostalExist: isPostalExist,
        isPostalActive: isPostalActive
      });
    }
  };
  var onChange = function onChange(event) {
    var value = event.target.value;
    if (isPostalInput) {
      var regex = /^$|^[0-9\b]+$/;
      if (regex.test(value)) {
        setInputValue(value);
      }
      return;
    }
    setInputValue(value);
    var filteredSuggestion = suggestions.filter(function (suggestion) {
      return suggestion.toLowerCase().includes(value.toLowerCase());
    });
    setFilteredSuggestions(filteredSuggestion);
    setDisplaySuggestions(true);
    if (!value) {
      resetInput();
    }
  };
  var discardSuggestions = function discardSuggestions() {
    setFilteredSuggestions([]);
    if (!(isPostalInput && showEmptyResult)) {
      setDisplaySuggestions(false);
    }
    setLabel(false);
    setFocus(false);
  };
  var onSelectSuggestion = function onSelectSuggestion(suggestion) {
    setSelectedSuggestion(suggestion);
    onChangeHandler(suggestion);
    discardSuggestions();
  };
  var setSuggestions = function setSuggestions() {
    if (!resetOnFocus && InputValue) {
      var filteredSuggestion = suggestions.filter(function (suggestion) {
        return suggestion.toLowerCase().includes(InputValue.toLowerCase());
      });
      setFilteredSuggestions(filteredSuggestion);
    } else {
      if (resetOnFocus) {
        resetInput();
      }
      setFilteredSuggestions(suggestions);
    }
    setDisplaySuggestions(true);
    setLabel(true);
    setFocus(true);
    if (onFocus) {
      onFocus();
    }
  };
  var setPostalLabel = function setPostalLabel() {
    setLabel(true);
  };
  var CrossIcon = function CrossIcon() {
    return isFocused && jsx("i", {
      onClick: resetInput,
      className: styles$1j['icon-close']
    });
  };
  var SearchIcon = function SearchIcon() {
    return !isNewDeliveryOptionModal ? jsx("i", {
      className: styles$1j['icon-search']
    }) : jsx("span", {
      className: classNames(styles$1j['arrow-icon'], _defineProperty({}, styles$1j['arrow-icon-new-delivery'], isNewDeliveryOptionModal))
    });
  };
  var handleKeyDown = function handleKeyDown(e) {
    var selectedIndex = state.cursor === -1 ? 0 : state.cursor;
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        dispatch({
          type: 'NEXT'
        });
        break;
      case 'ArrowUp':
        e.preventDefault();
        dispatch({
          type: 'PREV'
        });
        break;
      case 'Enter':
        e.preventDefault();
        if (InputValue) {
          if (filteredSuggestions.length > 0) {
            onSelectSuggestion(filteredSuggestions[selectedIndex]);
          }
        } else {
          onSelectSuggestion(suggestions[selectedIndex]);
        }
        break;
    }
  };
  var showInputLabel = type === 1 ? showLabel || InputValue : true;
  return jsxs(WithOutsideClick$1, {
    onOutsideClick: discardSuggestions,
    styles: {
      'doc-click-overlay': styles$1j['doc-click-overlay']
    },
    children: [renderPostalWarning(), jsxs("div", {
      className: classNames(styles$1j['autocomplete-input-wrapper'], styles$1j["type".concat(type)]),
      children: [showInputLabel && jsxs("label", {
        className: classNames(_defineProperty(_defineProperty({}, styles$1j[branding], !isNewDeliveryOptionModal), styles$1j['floating-label-new-delivery'], isNewDeliveryOptionModal), styles$1j['floating-label']),
        children: [' ', inputLabel, ' ']
      }), jsx("input", {
        className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$1j['autocomplete-input'], !isNewDeliveryOptionModal), styles$1j['autocomplete-new-delivery'], isNewDeliveryOptionModal), styles$1j['so-retail-wrapper'], isSodimacRe)),
        type: "text",
        ref: inputRef,
        onChange: onChange,
        onFocus: isPostalInput ? setPostalLabel : setSuggestions,
        value: InputValue,
        placeholder: placeholder,
        disabled: disabled,
        autoComplete: "off",
        maxLength: isPostalInput ? 5 : 33,
        onKeyDown: handleKeyDown,
        id: inputId
      }), type === 1 ? jsx("span", {
        className: classNames(styles$1j['floating-icon'], _defineProperty({}, styles$1j.postalIcon, isPostalInput)),
        children: InputValue ? jsx(CrossIcon, {}) : jsx(SearchIcon, {})
      }) : jsx("span", {
        className: classNames(styles$1j['arrow-icon'], _defineProperty({}, styles$1j['arrow-icon-new-delivery'], isNewDeliveryOptionModal))
      }), !isPostalInput && jsx(SuggestionsList$1, {
        inputValue: InputValue,
        selectedSuggestion: selectedSuggestion,
        onSelectSuggestion: onSelectSuggestion,
        displaySuggestions: displaySuggestions,
        suggestions: filteredSuggestions,
        showEmptyResult: showEmptyResult,
        suggestionContainerRef: suggestionContainerRef,
        currState: state,
        onHover: function onHover(i) {
          dispatch({
            type: 'SET_CURR',
            payload: i
          });
        },
        branding: branding,
        isStore: isStore,
        enableSisThemedBorder: enableSisThemedBorder,
        isNewDeliveryOptionModal: isNewDeliveryOptionModal,
        deviceType: deviceType
      })]
    })]
  });
};
Autocomplete.defaultProps = {
  disabled: false,
  defaultOption: undefined,
  showEmptyResult: false,
  resetOnFocus: false,
  inputId: '',
  type: 1,
  isPostalInput: false
};
Autocomplete.propTypes = {
  placeholder: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  suggestions: PropTypes.array.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  selectedOption: PropTypes.object.isRequired,
  defaultOption: PropTypes.object,
  InputValue: PropTypes.string.isRequired,
  setInputValue: PropTypes.func.isRequired,
  showEmptyResult: PropTypes.bool,
  onFocus: PropTypes.func,
  resetOnFocus: PropTypes.bool,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  inputId: PropTypes.string,
  enableSisThemedBorder: PropTypes.bool,
  type: PropTypes.number,
  setPostalWarning: PropTypes.func
};
var Autocomplete$1 = Autocomplete;

var styles$1i = {"input-wrapper":"Select-module_input-wrapper__-LKJM","select-input":"Select-module_select-input__jOdjp","retail":"Select-module_retail__It7kW","blur":"Select-module_blur__dT4P1","new-delivery-select":"Select-module_new-delivery-select__4er54","select-input-2":"Select-module_select-input-2__njf6Y","type2":"Select-module_type2__Ygsrf","suggestions-list":"Select-module_suggestions-list__N7VMh","arrow-icon":"Select-module_arrow-icon__-ZgJH","suggestion":"Select-module_suggestion__6LLUF","selected":"Select-module_selected__39f-A","floating-label":"Select-module_floating-label__Fvpx8","marketplace":"Select-module_marketplace__Iaccr","new-delivery-label":"Select-module_new-delivery-label__5JtYu","arrow-icon-new-delivery":"Select-module_arrow-icon-new-delivery__UqXJC"};

var Select = function Select(_ref) {
  var onSelectChange = _ref.onSelectChange,
    fieldName = _ref.fieldName,
    defaultValue = _ref.defaultValue,
    fieldOptions = _ref.fieldOptions,
    disabled = _ref.disabled,
    placeholder = _ref.placeholder,
    branding = _ref.branding,
    selectId = _ref.selectId,
    type = _ref.type,
    isNewDeliveryOptionModal = _ref.isNewDeliveryOptionModal;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    selected = _useState4[0],
    setSelected = _useState4[1];
  var inputRef = useRef(null);
  var onChangeHandler = function onChangeHandler(e) {
    var selctedOption = fieldOptions.find(function (item) {
      return item.toString() === e.target.value.toString();
    });
    onSelectChange(selctedOption);
    setSelected(selctedOption);
  };
  var handleLabels = function handleLabels() {
    setFocus(false);
  };
  var showLabel = function showLabel() {
    if (type === 1) {
      setFocus(true);
    }
  };
  var handleIconClick = function handleIconClick(e) {
    inputRef.current.focus();
    inputRef.current.click();
  };
  var isLabelVisible = isFocused || defaultValue && defaultValue !== 'default' || selected;
  return jsx(WithOutsideClick$1, {
    onOutsideClick: handleLabels,
    styles: {
      'doc-click-overlay': styles$1i['doc-click-overlay']
    },
    children: jsxs("div", {
      className: classNames(styles$1i['input-wrapper'], _defineProperty({}, styles$1i["type".concat(2)], type === 2)),
      children: [isLabelVisible && jsx("label", {
        className: classNames(styles$1i['floating-label'], styles$1i[branding], _defineProperty({}, styles$1i['new-delivery-label'], isNewDeliveryOptionModal)),
        children: fieldName
      }), jsxs("select", {
        name: fieldName,
        value: defaultValue,
        ref: inputRef,
        tabIndex: "0",
        onChange: onChangeHandler,
        onFocus: showLabel,
        disabled: disabled,
        className: classNames(styles$1i['select-input'], styles$1i[branding], styles$1i[defaultValue ? '' : 'blur'], _defineProperty(_defineProperty({}, styles$1i['select-input-2'], type === 2), styles$1i['new-delivery-select'], isNewDeliveryOptionModal)),
        id: selectId,
        children: [jsx("option", {
          className: styles$1i.suggestion,
          value: "",
          disabled: true,
          hidden: true,
          children: placeholder
        }), fieldOptions.map(function (field) {
          return jsx("option", {
            className: styles$1i.suggestion,
            value: field,
            children: field
          }, field);
        })]
      }, "".concat(fieldName, "-select-box")), isNewDeliveryOptionModal && jsx("span", {
        className: styles$1i['arrow-icon-new-delivery']
      }), type === 2 && jsx("span", {
        onTouchStart: handleIconClick,
        className: styles$1i['arrow-icon']
      })]
    })
  });
};
Select.defaultProps = {
  fieldName: '',
  fieldOptions: [],
  defaultValue: '',
  onSelectChange: noop$2,
  disabled: false,
  placeholder: '',
  selectId: '',
  type: 1
};
Select.propTypes = {
  fieldName: PropTypes.string,
  fieldOptions: PropTypes.array,
  defaultValue: PropTypes.string,
  onSelectChange: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  type: PropTypes.number,
  selectId: PropTypes.string
};
var Select$1 = Select;

var styles$1h = {"modal-wrapper":"Zone-module_modal-wrapper__JkKVx","retail":"Zone-module_retail__l5oox","marketplace":"Zone-module_marketplace__3CV06","store":"Zone-module_store__NDpLJ","zone-modal-container":"Zone-module_zone-modal-container__Z4wsO","zone-select-wrapper":"Zone-module_zone-select-wrapper__Ohdp9","mr-4":"Zone-module_mr-4__hxEVi","modal-zone-name":"Zone-module_modal-zone-name__YD470","icon-location":"Zone-module_icon-location__HDj6c","remove-icon":"Zone-module_remove-icon__gBc-q","postal-info":"Zone-module_postal-info__I5YW8","icon-header":"Zone-module_icon-header__c0yHd","icon":"Zone-module_icon__HBR9I","storeIcon":"Zone-module_storeIcon__8DzbV","sr-only":"Zone-module_sr-only__9304N","zone-modal-body":"Zone-module_zone-modal-body__pbxYA","modal-btn-close":"Zone-module_modal-btn-close__h3vh3","icon-close":"Zone-module_icon-close__LGUiQ","modal-header":"Zone-module_modal-header__SJoDV","so-retail-modal-header":"Zone-module_so-retail-modal-header__fBHcN","modal-heading":"Zone-module_modal-heading__lkVHq","modal-content":"Zone-module_modal-content__J2cnF","banner-text":"Zone-module_banner-text__qPm2A","so-retail-banner-text":"Zone-module_so-retail-banner-text__i2rFd","so-retail-banner-text-error":"Zone-module_so-retail-banner-text-error__qoE8O","input-wrapper":"Zone-module_input-wrapper__okYOT","postal-wrapper":"Zone-module_postal-wrapper__zAPUq","postal-seperator":"Zone-module_postal-seperator__oBYb2","postal-seperator-line":"Zone-module_postal-seperator-line__ZAjyA","postal-seperator-circle":"Zone-module_postal-seperator-circle__jiiIz","provincia-wrapper":"Zone-module_provincia-wrapper__aCh1X","comuna-wrapper":"Zone-module_comuna-wrapper__Vg35C","btn-zone-select-retail":"Zone-module_btn-zone-select-retail__0OA3E","btn-zone-select-marketplace":"Zone-module_btn-zone-select-marketplace__Z-cFf","btn-zone-select-stock-en-tienda":"Zone-module_btn-zone-select-stock-en-tienda__AzQ2z","storeButton":"Zone-module_storeButton__CDjnk","so_com":"Zone-module_so_com__TYvAX","so_retail":"Zone-module_so_retail__xmpHP","retailSaveButton":"Zone-module_retailSaveButton__EBQ1W","tottus-comuna":"Zone-module_tottus-comuna__tQslt","comuna":"Zone-module_comuna__Cr-r1","tottus-span":"Zone-module_tottus-span__BlI42","bold":"Zone-module_bold__3ZZTO","zone-lable":"Zone-module_zone-lable__sQwnH","standalone":"Zone-module_standalone__85TA9","new-zone-modal":"Zone-module_new-zone-modal__XdUQs","flex-align-center":"Zone-module_flex-align-center__chtF3","success-message-parent":"Zone-module_success-message-parent__NnVSs","justify-from-start":"Zone-module_justify-from-start__TdFKs","justify-space-around":"Zone-module_justify-space-around__ZCtym","flex-column":"Zone-module_flex-column__hHHzF","flex-row":"Zone-module_flex-row__zUMHg","zone-popover":"Zone-module_zone-popover__VFDKt","large":"Zone-module_large__-4A9t","medium":"Zone-module_medium__afBfR","small":"Zone-module_small__Fgrbf","success-modal":"Zone-module_success-modal__zoE1U","warning-modal":"Zone-module_warning-modal__KfMX0","pressure-modal":"Zone-module_pressure-modal__epn4a","reminder-modal":"Zone-module_reminder-modal__6bjkg","text-label":"Zone-module_text-label__Yh7fR","highlighted":"Zone-module_highlighted__qdrQ-","banner":"Zone-module_banner__tLnRS","modal-close":"Zone-module_modal-close__bMqkK","icon-danger":"Zone-module_icon-danger__oH339","icon-success":"Zone-module_icon-success__RcFEI","sucess-icon-wrapper":"Zone-module_sucess-icon-wrapper__u-HDm","sucess-message-wrapper":"Zone-module_sucess-message-wrapper__424z4","message-wrapper":"Zone-module_message-wrapper__xXIGZ","btn-wrapper":"Zone-module_btn-wrapper__1gFyl","btn-underline":"Zone-module_btn-underline__3v66-","btn-outline":"Zone-module_btn-outline__OTq-E","stockEnTiendaWrapper":"Zone-module_stockEnTiendaWrapper__5P-WA","stockEnTienda":"Zone-module_stockEnTienda__mPjcg","deliveryOptions":"Zone-module_deliveryOptions__nq8Og","checkboxRebranding":"Zone-module_checkboxRebranding__o50m1","save-location-checkbox":"Zone-module_save-location-checkbox__1E0p9","rebrandIcon":"Zone-module_rebrandIcon__w5NOp","hideIcon":"Zone-module_hideIcon__lL4NK","save-current-location":"Zone-module_save-current-location__esnYx","btn-zone-select-cancel":"Zone-module_btn-zone-select-cancel__88-QK","pickupInStore":"Zone-module_pickupInStore__zZI0r","scroll":"Zone-module_scroll__PuS9z","deliveryOptionsError":"Zone-module_deliveryOptionsError__b-rdv","homeDelivery":"Zone-module_homeDelivery__odRFd","stock-en-tienda-footer":"Zone-module_stock-en-tienda-footer__gEIPC","display-none":"Zone-module_display-none__IMG5i","pickup-in-store-container":"Zone-module_pickup-in-store-container__m1MUu","pickup-in-store-data-header":"Zone-module_pickup-in-store-data-header__dqZmM","pickup-in-store-list":"Zone-module_pickup-in-store-list__-0Fo4","selected":"Zone-module_selected__160PZ","store-logo":"Zone-module_store-logo__kNV8T","pickup-in-store-falabella":"Zone-module_pickup-in-store-falabella__4mmoT","pickup-in-store-sodimac":"Zone-module_pickup-in-store-sodimac__AKPZW","pickup-in-store-tottus":"Zone-module_pickup-in-store-tottus__ubq3i","pickup-in-store-default":"Zone-module_pickup-in-store-default__b9Fyy","pickup-in-store-list-content":"Zone-module_pickup-in-store-list-content__qymeu","store-name":"Zone-module_store-name__xsd3t","store-addressline":"Zone-module_store-addressline__kTgU5","store-available-slot":"Zone-module_store-available-slot__QpGdZ","delivery-options-error-container":"Zone-module_delivery-options-error-container__XCp7e","delivery-options-error":"Zone-module_delivery-options-error__NDm4F","delivery-options-location-icon":"Zone-module_delivery-options-location-icon__yeNbP","delivery-options-error-heading":"Zone-module_delivery-options-error-heading__grijS","normal":"Zone-module_normal__l5TfP","capitalise":"Zone-module_capitalise__4GIym","delivery-options-error-subheading-container":"Zone-module_delivery-options-error-subheading-container__cGl6P","delivery-options-error-subheading":"Zone-module_delivery-options-error-subheading__nX1CD","zone-select-wrapper-sis-level-header":"Zone-module_zone-select-wrapper-sis-level-header__ltvVm","storeIconWhite":"Zone-module_storeIconWhite__-ApeO","new-zone-modal-container":"Zone-module_new-zone-modal-container__o5HkD","draggable-bar":"Zone-module_draggable-bar__-8JdE","gap":"Zone-module_gap__yiSnY","no-padding":"Zone-module_no-padding__yB3TN","modal-header-text":"Zone-module_modal-header-text__d7CyM","warning-section":"Zone-module_warning-section__tUcpo","warning-icon":"Zone-module_warning-icon__nDptj","input-section":"Zone-module_input-section__KhJNj","save-location":"Zone-module_save-location__jR04-","edit-icon":"Zone-module_edit-icon__eVZN9","zone-selection-body":"Zone-module_zone-selection-body__oJhVX","modal-label":"Zone-module_modal-label__J7toM","btn-zone-select":"Zone-module_btn-zone-select__GxTlt","no-coverage-body":"Zone-module_no-coverage-body__0Ay7-","no-address":"Zone-module_no-address__rmP3J","modal-body":"Zone-module_modal-body__iURXW","selected-address":"Zone-module_selected-address__-sPG8","close-nocoverage":"Zone-module_close-nocoverage__PzTZF","see-coverage":"Zone-module_see-coverage__zT6-G","new-address":"Zone-module_new-address__6ecj2","savezone-container":"Zone-module_savezone-container__yviKu","address-container":"Zone-module_address-container__iEhgI","address-selection":"Zone-module_address-selection__Wy485","lwrapper":"Zone-module_lwrapper__YhtHs","active":"Zone-module_active__VnlJe","radio-icon":"Zone-module_radio-icon__LDf-P","remove-button":"Zone-module_remove-button__lx0w5","button-container":"Zone-module_button-container__UR6fk","directions-link":"Zone-module_directions-link__dQwbD","save-button":"Zone-module_save-button__xOItT","delete-address-container":"Zone-module_delete-address-container__eXVgW","modal-buttons":"Zone-module_modal-buttons__inTkM","cancel-link":"Zone-module_cancel-link__wUhR6","delete-button":"Zone-module_delete-button__yGxsl"};

var constants$2 = {
  REG_ID: 'regionData',
  COM_ID: 'comunaData',
  PROV_ID: 'provinceData',
  IS_ZONE_SELECTED: 'IS_ZONE_SELECTED',
  IS_PRESSURE_MODAL_INTERACTED: 'IS_PRESSURE_MODAL_INTERACTED',
  PRICE_GROUP_ID: 'priceGroupId',
  ZONES: 'zones',
  ZONE_DATA: 'zoneData',
  POLITICAL_ID: 'politicalId',
  POLITICAL_ID_EXISTS: 'isPoliticalIdExists',
  ADDRESS_LINES: 'addressLines',
  ADDRESS_IDS: 'addressId',
  MODAL_CLOSE_TIME: 350,
  USER_ZONE: 'userSelectedZone',
  PICKUP_IN_STORE: 'PickupInStore',
  HOME_DELIVERY: 'HomeDelivery',
  REMINDER_MODAL_TYPE: {
    USER_LOGGED_IN: 'USER_LOGGED_IN',
    INACTIVE: 'INACTIVE'
  },
  USER_LAST_SESSION: 'USER_LAST_SESSION',
  REACT_APP_GOOGLE_MAPS_API_KEY: 'AIzaSyDQcjKFGIhNTPtmcWyxCl_EcFvGbM3d7KM',
  ERROR_CODES: {
    INVALID_SESSION: 'INVALID_SESSION'
  },
  ZONES_LIST: 'zonesList'
};
var labels$4 = {
  PRESSURE_DESKTOP_LABLE: 'Ingresa tu ubicación',
  PRESSURE_MOBILE_LABLE: 'Ingresa tu ubicación',
  SELECTED_REGION_LABLE: 'Entrega en',
  SELECTED_REGION_LABLE_TOTTUS: 'Envío a:',
  MODAL_BANNER_TEXT: {
    cl: 'Ingresa tu ubicación y te mostraremos los productos disponibles con tiempos y costos de entrega precisos.',
    pe: 'Ingresa tu ubicación y te mostraremos los productos disponibles con tiempos y costos de entrega precisos.',
    co: 'Ingresa tu ubicación y te mostraremos los productos disponibles con tiempos y costos de entrega precisos.',
    mx: 'Ingresa tu ubicación y te mostraremos los productos disponibles con tiempos y costos de entrega precisos.'
  },
  SELECT_BUTTON_MARKETPLACE: 'Guardar',
  SELECT_BUTTON_RETAIL: {
    desktop: 'GUARDAR UBICACIÓN',
    mobile: 'GUARDAR',
    tablet: 'GUARDAR'
  },
  MODAL_DESKTOP_HEADER: {
    cl: '¿Dónde quieres recibir tu compra?',
    pe: 'Ingresa tu ubicación',
    co: 'Ingresa tu ubicación',
    mx: '¿Dónde quieres recibir tu compra?'
  },
  MODAL_MOBILE_HEADER: {
    cl: '¿Dónde quieres recibir tu compra?',
    pe: 'Ingresa tu ubicación',
    co: 'Ingresa tu ubicación',
    mx: '¿Dónde quieres recibir tu compra?'
  },
  NEW_ZONE_MODAL_LABELS: {
    VIEW2: {
      HEADER: 'Confirma la dirección',
      WARNING_LABEL: 'Fija la ubicación exacta en el mapa',
      SAVE: 'Confirmar y guardar'
    },
    VIEW1: {
      HEADER: '¿Dónde quieres recibir tu compra?',
      BODY: 'Ingresa tu dirección y te mostraremos los productos disponibles para envío',
      SAVE: 'Continuar',
      GET_LAT_LONG_API_URL: "https://maps.googleapis.com/maps/api/geocode/json?key=".concat(constants$2.REACT_APP_GOOGLE_MAPS_API_KEY, "&address="),
      VALID_LOCALTION_TYPES: ['street_number', 'route']
    },
    VIEW3: {
      HEADER: '',
      BODY: 'Lo sentimos, aún no tenemos cobertura para esta dirección',
      URL: {
        cl: 'https://www.tottus.cl/tottus-cl/content/zonas-de-cobertura',
        pe: 'https://firebasestorage.googleapis.com/v0/b/tottus-orion-prod.appspot.com/o/helpline_peru%2Fhtmls%2Ffaq.html?alt=media&token=bd82f2f4-bb39-450b-8018-e02a601fc562'
      },
      LINK_TEXT1: 'Ver zonas de cobertura',
      LINK_TEXT2: 'Intentar con otra dirección',
      BUTTON: 'Seguir navegando'
    },
    VIEW4: {
      HEADER: '¿Dónde quieres recibir tu compra?',
      BODY: 'Ingresa tu dirección y te mostraremos los productos disponibles, para envío a tu dirección.',
      ACTION: 'Guardar',
      URL: {
        cl: 'https://www.tottus.cl/tottus-cl/content/zonas-de-cobertura',
        pe: 'https://firebasestorage.googleapis.com/v0/b/tottus-orion-prod.appspot.com/o/helpline_peru%2Fhtmls%2Ffaq.html?alt=media&token=bd82f2f4-bb39-450b-8018-e02a601fc562'
      },
      LINK_TEXT: 'Agregar otra dirección'
    },
    VIEW5: {
      HEADER: 'Eliminar dirección',
      BODY: '¿Estás seguro que quieres eliminar esta dirección? Al eliminarla, dejará de aparecer en tu lista de direcciones.',
      SAVE: 'Eliminar',
      CANCEL: 'Cancelar',
      LINK_TEXT: 'Agregar otra dirección'
    }
  },
  CANCEL: 'Cancelar',
  REVISAR_STOCK: 'Revisar',
  SEE_AVAILABILITY: 'Revisar',
  KEEP_IT_TEXT: 'Mantener',
  SAVE_AS_PRIMARY_ADDRESS: 'Guardar como dirección principal.',
  USE_CURRENT_LOCATION: 'O <p>usa tu ubicación actual</p>',
  CHANGE_IT_TEXT: 'Cambiar',
  LOCATION_DETECTED_TEXT_PART_1: 'En tu última visita te mostramos productos para recibir en',
  LOCATION_DETECTED_TEXT_PART_2: 'Elige si quieres mantener la ubicación o cambiarla.',
  SUCCESS_LABEL_1: 'Ubicación guardada',
  SUCCESS_LABEL_2: 'Puedes cambiarla cuando quieras.',
  PRESSURE_LABEL_1: 'Elige dónde recibir tus productos',
  PRESSURE_LABEL_2: 'Podrás ver la disponibilidad y tiempos de entrega para tu despacho o retiro en tienda.',
  REMINDER_USER_LOGGED_IN: '¡Esta es tu ubicación favorita! La puedes cambiar para revisar productos disponibles en otros lugares.',
  REMINDER_USER_INACTIVE: '¡Está es tu última ubicación! La puedes cambiar para revisar productos disponibles en otros lugares.',
  DE_ERROR_LABEL: {
    co: 'Intenta con otro barrio',
    pe: 'Intenta con otro distrito',
    cl: 'Intenta con otra comuna'
  },
  ERROR_LOADING_MAPS: 'Error al cargar mapas'
};
var DEFAULT_ZONES_VALUE = {
  staging: {
    cl: {
      politicalId: '4856187d-c035-45ac-9f4e-9290b9e9f85f',
      priceGroupId: 96,
      zones: 'FAHD,PCL1169,CHILEXPRESS_8,PCL1310,BX_R13_BASE,PCL388,PCL1340,3045,PCL1339,IMKP,PCL1209,PCL63,13,PCL1207,PCL1493,ZL_CERRILLOS,PCL1103,PLUGINS1,PCL1294,ALHU,PCL268,STGZ,PCL2581,TOTTUS_001,PCL161,PCL1234,PCL2579,130617,PCL645,123,PCL67,LOSC,PCL138,PCL1208,ZONA_STARKEN,PCL1393,PCL1362,PCL1184,PCL773,PCL37,PCL1233,PCL2588'
    },
    pe: {
      politicalId: 'c6b7a50c-60f3-4687-91d0-9461d538812a',
      priceGroupId: 49,
      zones: 'IBIS_21,PPE2671,PPE4410,INTERNACIONAL,PPE4273,912_LIMA_2,PPE2526,912_LIMA_1,PPE2525,100,PPE4400,PPE46,SCADFBD_DIRECTO,PPE3883,PPE4023,PLUGINSPE1,PPE3884,PPE48,OLVAA_81,PPE4105,PPE49,150000,PPE14,IBIS_3PL_83,PPE4357,150101,PPE320,PPE47,ZONA1,PPE3882,09876,PPE44,URBANO_83,PPE3967'
    },
    co: {
      politicalId: '59a6aec4-fc51-4f3b-ab5e-62fd7a1076c0',
      priceGroupId: '19',
      zones: 'SERVIENTREGA_35,TCC_35,IBIS_02,DEPRISA_26,14,SERVI_CO,PLUGINS1CO,TEST_1'
    }
  },
  beta: {
    cl: {
      politicalId: '15c37b0b-a392-41a9-8b3b-978376c700d5',
      priceGroupId: 96,
      zones: 'FALABELLA_FBY_BT_SDD,PCL2829,REVERSE_RM_REDPROPIA,PCL2998,PCL3128,PCL2808,1234,PCL1223,PCL2802,PCL2826,PCL3019,PCL2281,PCL3009,HUB_SALIDA_DIRECTA_RM,PCL2120,PCL3043,PCL3025,BLUE_RM_URBANO,PCL115,3045,PCL1486,PCL2980,PCL1736,PCL1923,PCL2981,PCL2792,PCL3006,BX_R13_BASE,PCL226,PCL2847,PCL2901,PCL2827,PCL2979,PCL1389,PCL2843,ZL_CERRILLOS,PCL1135,PCL2977,SCD9039_FLEX,PCL105,FBY_RM_M,PCL2380,PCL2442,2020,PCL1186,PCL2864,FALABELLA_FBY_SDD,PCL2269,PCL2846,13,PCL861,PCL3015,FEDEX_RM_URB,PCL2520,LOSC,PCL540,CHILEXPRESS_8,PCL1839,FBY_BT_SALIDA_DIRECTA,PCL2288,PCL2978,PCL2862,PCL2803,PCL2890,PCL2838,RM,PCL108,PCL94,CHILE_INTERNATIONAL,PCL1364,PCL2801,PCL3011,PCL3017,13_MAIPU,PCL2830,PCL3026,PCL2845,PCL2982,PCL109,PCL3136,130617,PCL25,PCL2441,PCL184,PCL3012,PCL1336,STARKEN_R13,PCL3041,PCL2825,PCL2511,PCL3042'
    },
    pe: {
      politicalId: '799c102f-9b4c-44be-a421-23e366a63b82',
      priceGroupId: 2,
      zones: 'IBIS_51,PPE3342,PPE3361,PPE1112,PPE3384,912_LIMA_2,PPE1280,150000,PPE4,912_LIMA_1,PPE1279,150101,PPE344,PPE3059,PPE2492,IMP_2,PPE3331,PPE3357,PPE1091,PERF_TEST,PPE1653,PPE2486,OLVAA_81,PPE2815,IMP_1,PPE3164,PPE2918,URBANO_83,PPE2429,PPE3152,PPE3479,PPE3483,PPE3394,LIMA_URB1_DIRECTO,PPE2511,IBIS_19,PPE1382,IBIS_3PL_83,PPE3248'
    },
    co: {
      politicalId: 'bbea9a06-99b1-44de-bc6e-d314bca4fad3',
      priceGroupId: 10,
      zones: 'SERVIENTREGA_6,PCO137,SERVIENTREGA_83,PCO214,ENVIA_9,PCO618,DEPRISA_55,PCO96,DEPRISA_52,PCO93,PCO739,DEPRISA_46,PCO87,TCC_9,PCO234,DEPRISA_39,PCO80,PCO516,PCO522,SERVIENTREGA_76,PCO207,SERVIENTREGA_0,PCO31,COORDINADORA_87,PCO609,ENVIA_1,PCO610,ENVIA_71,PCO680,TCC_86,PCO311,ENVIA_65,PCO674,14,PCO14,SERVIENTREGA_15,PCO146,PCO726,99,PCO326,ENVIA_59,PCO668,TCC_66,PCO291,PCO746,SERVIENTREGA_61,PCO192,ENVIA_46,PCO655,TCC_73,PCO298,PCO745,DEPRISA_24,PCO65,TCC_78,PCO303,PCO710,TCC_19,PCO244,ENVIA_74,PCO683,PCO703,IBIS_DIRECTO_BO,PCO704,IBIS_6,PCO38,SERVIENTREGA_80,PCO211,DEPRISA_3,PCO44,DEPRISA_34,PCO75,TCC_3,PCO228,TCC_24,PCO249,SERVIENTREGA_21,PCO152,PCO32,ENVIA_54,PCO663,PCO714'
    }
  },
  production: {
    cl: {
      politicalId: '15c37b0b-a392-41a9-8b3b-978376c700d5',
      priceGroupId: 96,
      zones: 'FALABELLA_FBY_BT_SDD,PCL2829,REVERSE_RM_REDPROPIA,PCL2998,PCL3128,PCL2808,1234,PCL1223,PCL2802,PCL2826,PCL3019,PCL2281,PCL3009,HUB_SALIDA_DIRECTA_RM,PCL2120,PCL3043,PCL3025,BLUE_RM_URBANO,PCL115,3045,PCL1486,PCL2980,PCL1736,PCL1923,PCL2981,PCL2792,PCL3006,BX_R13_BASE,PCL226,PCL2847,PCL2901,PCL2827,PCL2979,PCL1389,PCL2843,ZL_CERRILLOS,PCL1135,PCL2977,SCD9039_FLEX,PCL105,FBY_RM_M,PCL2380,PCL2442,2020,PCL1186,PCL2864,FALABELLA_FBY_SDD,PCL2269,PCL2846,13,PCL861,PCL3015,FEDEX_RM_URB,PCL2520,LOSC,PCL540,CHILEXPRESS_8,PCL1839,FBY_BT_SALIDA_DIRECTA,PCL2288,PCL2978,PCL2862,PCL2803,PCL2890,PCL2838,RM,PCL108,PCL94,CHILE_INTERNATIONAL,PCL1364,PCL2801,PCL3011,PCL3017,13_MAIPU,PCL2830,PCL3026,PCL2845,PCL2982,PCL109,PCL3136,130617,PCL25,PCL2441,PCL184,PCL3012,PCL1336,STARKEN_R13,PCL3041,PCL2825,PCL2511,PCL3042'
    },
    pe: {
      politicalId: '799c102f-9b4c-44be-a421-23e366a63b82',
      priceGroupId: 2,
      zones: 'IBIS_51,PPE3342,PPE3361,PPE1112,PPE3384,912_LIMA_2,PPE1280,150000,PPE4,912_LIMA_1,PPE1279,150101,PPE344,PPE3059,PPE2492,IMP_2,PPE3331,PPE3357,PPE1091,PERF_TEST,PPE1653,PPE2486,OLVAA_81,PPE2815,IMP_1,PPE3164,PPE2918,URBANO_83,PPE2429,PPE3152,PPE3479,PPE3483,PPE3394,LIMA_URB1_DIRECTO,PPE2511,IBIS_19,PPE1382,IBIS_3PL_83,PPE3248'
    },
    co: {
      politicalId: 'bbea9a06-99b1-44de-bc6e-d314bca4fad3',
      priceGroupId: 10,
      zones: 'SERVIENTREGA_6,PCO137,SERVIENTREGA_83,PCO214,ENVIA_9,PCO618,DEPRISA_55,PCO96,DEPRISA_52,PCO93,PCO739,DEPRISA_46,PCO87,TCC_9,PCO234,DEPRISA_39,PCO80,PCO516,PCO522,SERVIENTREGA_76,PCO207,SERVIENTREGA_0,PCO31,COORDINADORA_87,PCO609,ENVIA_1,PCO610,ENVIA_71,PCO680,TCC_86,PCO311,ENVIA_65,PCO674,14,PCO14,SERVIENTREGA_15,PCO146,PCO726,99,PCO326,ENVIA_59,PCO668,TCC_66,PCO291,PCO746,SERVIENTREGA_61,PCO192,ENVIA_46,PCO655,TCC_73,PCO298,PCO745,DEPRISA_24,PCO65,TCC_78,PCO303,PCO710,TCC_19,PCO244,ENVIA_74,PCO683,PCO703,IBIS_DIRECTO_BO,PCO704,IBIS_6,PCO38,SERVIENTREGA_80,PCO211,DEPRISA_3,PCO44,DEPRISA_34,PCO75,TCC_3,PCO228,TCC_24,PCO249,SERVIENTREGA_21,PCO152,PCO32,ENVIA_54,PCO663,PCO714'
    }
  }
};
var configs$2 = {
  labels: labels$4,
  constants: constants$2,
  DEFAULT_ZONES_VALUE: DEFAULT_ZONES_VALUE
};
var configs$3 = configs$2;

function DeliveryOptionsError(_ref) {
  var deliveryOptions = _ref.deliveryOptions,
    stockEnTienda = _ref.stockEnTienda,
    tenant = _ref.tenant;
  var labels = configs$3.labels;
  var type = (deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.type) || (stockEnTienda === null || stockEnTienda === void 0 ? void 0 : stockEnTienda.type) || '';
  var comunaName = (deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.comunaName) || (stockEnTienda === null || stockEnTienda === void 0 ? void 0 : stockEnTienda.comunaName) || '';
  var getMessage = function getMessage() {
    if (type === 'StockinStore') {
      return jsxs(Fragment$1, {
        children: ["Puedes cambiar la ubicaci\xF3n o aprovechar que a\xFAn", ' ', jsx("span", {
          className: styles$1h.bold,
          children: "tenemos stock online en falabella.com"
        }), "."]
      });
    }
    var message = type === 'HomeDelivery' ? 'retiro en un punto.' : 'envío a domicilio.';
    return jsxs(Fragment$1, {
      children: [jsx("span", {
        className: styles$1h.bold,
        children: labels.DE_ERROR_LABEL[tenant]
      }), " o revisa la disponibilidad del ".concat(message)]
    });
  };
  return jsxs("div", {
    className: styles$1h['delivery-options-error-container'],
    children: [jsxs("div", {
      className: classNames(styles$1h['delivery-options-error'], _defineProperty({}, styles$1h.homeDelivery, type === 'HomeDelivery')),
      children: [jsx("i", {
        className: styles$1h['delivery-options-location-icon']
      }), jsxs("p", {
        className: classNames(styles$1h['delivery-options-error-heading'], _defineProperty({}, styles$1h.homeDelivery, type === 'HomeDelivery')),
        children: [type === 'StockinStore' ? 'Sin stock' : 'No disponible', jsx("span", {
          className: styles$1h.normal,
          children: " ".concat(type === 'HomeDelivery' ? 'en' : 'en puntos de retiro en', " ")
        }), jsx("span", {
          className: styles$1h.capitalise,
          children: comunaName.toLowerCase()
        })]
      })]
    }), jsx("div", {
      className: styles$1h['delivery-options-error-subheading-container'],
      children: jsxs("p", {
        className: styles$1h['delivery-options-error-subheading'],
        children: ['Lo sentimos.', " ", getMessage()]
      })
    })]
  });
}
DeliveryOptionsError.defaultProps = {
  deliveryOptions: {},
  stockEnTienda: {}
};
DeliveryOptionsError.propTypes = {
  deliveryOptions: PropTypes.object,
  stockEnTienda: PropTypes.object,
  tenant: PropTypes.string.isRequired
};

var inputLabel = {
  states: {
    desktop: {
      cl: 'Región',
      pe: 'Departamento',
      co: 'Departamento',
      mx: 'Estado'
    },
    mobile: {
      cl: 'Región',
      pe: 'Departamento',
      co: 'Departamento',
      mx: 'Estado'
    }
  },
  communa: {
    desktop: {
      cl: '',
      pe: 'Provincia',
      co: 'Ciudad',
      mx: 'Municipio'
    },
    mobile: {
      cl: '',
      pe: 'Provincia',
      co: 'Ciudad',
      mx: 'Municipio'
    }
  },
  districts: {
    desktop: {
      cl: 'Comuna',
      pe: 'Distrito',
      co: 'Barrio',
      mx: 'Colonia'
    },
    mobile: {
      cl: 'Comuna',
      pe: 'Distrito',
      co: 'Barrio',
      mx: 'Colonia'
    }
  },
  postalCode: {
    mx: 'Código postal (opcional)'
  }
};
var placeholder = {
  states: {
    desktop: {
      cl: 'Ingresa una Región',
      pe: 'Ingresa una departamento',
      co: 'Ingresa un departamento',
      mx: 'Busca o selecciona una opción'
    },
    mobile: {
      cl: 'Selecciona una Región',
      pe: 'Selecciona una departamento',
      co: 'Selecciona un departamento',
      mx: 'Selecciona una opción'
    }
  },
  communa: {
    desktop: {
      cl: '',
      pe: 'Ingresa una provincia',
      co: 'Ingresa una ciudad',
      mx: 'Busca o selecciona una opción'
    },
    mobile: {
      cl: '',
      pe: 'Selecciona una provincia',
      co: 'Selecciona una ciudad',
      mx: 'Busca o selecciona una opción'
    }
  },
  districts: {
    desktop: {
      cl: 'Ingresa una Comuna',
      pe: 'Ingresa un distrito',
      co: 'Ingresa un barrio',
      mx: 'Busca o selecciona una opción'
    },
    mobile: {
      cl: 'Selecciona una Comuna',
      pe: 'Selecciona un distrito',
      co: 'Selecciona un barrio',
      mx: 'Busca o selecciona una opción'
    }
  },
  postalCode: {
    mx: 'Ingresa un código postal'
  }
};

var ModalContent$2 = function ModalContent(_ref) {
  var regionsSuggestion = _ref.regionsSuggestion,
    comunaSuggestion = _ref.comunaSuggestion,
    regionChangeHandler = _ref.regionChangeHandler,
    selectedRegion = _ref.selectedRegion,
    comunaChangeHandler = _ref.comunaChangeHandler,
    selectedComuna = _ref.selectedComuna,
    deviceType = _ref.deviceType,
    saveZone = _ref.saveZone,
    getSavedZone = _ref.getSavedZone,
    regionInputValue = _ref.regionInputValue,
    setRegionInputValue = _ref.setRegionInputValue,
    comunaInputValue = _ref.comunaInputValue,
    setComunaInputValue = _ref.setComunaInputValue,
    setModalVisible = _ref.setModalVisible,
    enableEnter = _ref.enableEnter,
    onFocus = _ref.onFocus,
    branding = _ref.branding,
    tenant = _ref.tenant,
    provinceSuggestion = _ref.provinceSuggestion,
    provinceChangeHandler = _ref.provinceChangeHandler,
    selectedProvince = _ref.selectedProvince,
    provinceInputValue = _ref.provinceInputValue,
    setProvinceInputValue = _ref.setProvinceInputValue,
    stockEnTienda = _ref.stockEnTienda,
    deliveryOptions = _ref.deliveryOptions,
    isDefaultComuna = _ref.isDefaultComuna,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder,
    isSodimacStandAlone = _ref.isSodimacStandAlone,
    selectedZone = _ref.selectedZone,
    getStockEnTiendaData = _ref.getStockEnTiendaData,
    getDeliveryEstimatesV2Data = _ref.getDeliveryEstimatesV2Data,
    postalCodeInputValue = _ref.postalCodeInputValue,
    setPostalCodeInputValue = _ref.setPostalCodeInputValue,
    isSodimacRe = _ref.isSodimacRe,
    postalCodeStatus = _ref.postalCodeStatus,
    isSettingFromPostal = _ref.isSettingFromPostal,
    isPostalCodeEnabled = _ref.isPostalCodeEnabled,
    setPostalWarning = _ref.setPostalWarning,
    isPostalActive = _ref.isPostalActive,
    isCambiar = _ref.isCambiar,
    isErrorNotification = _ref.isErrorNotification,
    isPostalExist = _ref.isPostalExist;
  var labels = configs$3.labels,
    constants = configs$3.constants;
  var HOME_DELIVERY = constants.HOME_DELIVERY,
    PICKUP_IN_STORE = constants.PICKUP_IN_STORE;
  var SELECTED_REGION_LABLE = labels.SELECTED_REGION_LABLE,
    MODAL_DESKTOP_HEADER = labels.MODAL_DESKTOP_HEADER,
    MODAL_MOBILE_HEADER = labels.MODAL_MOBILE_HEADER,
    SELECT_BUTTON_MARKETPLACE = labels.SELECT_BUTTON_MARKETPLACE,
    SEE_AVAILABILITY = labels.SEE_AVAILABILITY,
    CANCEL = labels.CANCEL,
    REVISAR_STOCK = labels.REVISAR_STOCK,
    SELECT_BUTTON_RETAIL = labels.SELECT_BUTTON_RETAIL,
    MODAL_BANNER_TEXT = labels.MODAL_BANNER_TEXT;
  var isStockEnTiendaModal = !!Object.keys(stockEnTienda).length;
  var isDeliveryOptionsModal = !isEmpty(deliveryOptions);
  var isNewDeliveryOptionModal = isStockEnTiendaModal || isDeliveryOptionsModal;
  var _ref2 = deliveryOptions || {},
    type = _ref2.type,
    _ref2$error = _ref2.error,
    deliveryError = _ref2$error === void 0 ? false : _ref2$error,
    _ref2$disableButton = _ref2.disableButton,
    deliveryDisableButton = _ref2$disableButton === void 0 ? false : _ref2$disableButton,
    deliveryComunaName = _ref2.comunaName;
  var _ref3 = stockEnTienda || {},
    _ref3$error = _ref3.error,
    stockEnTiendaError = _ref3$error === void 0 ? false : _ref3$error,
    _ref3$disableButton = _ref3.disableButton,
    stockEnTiendaDisableButton = _ref3$disableButton === void 0 ? false : _ref3$disableButton,
    stockEnTiendaComunaName = _ref3.comunaName;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    regions = _useState2[0],
    setRegions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    comunas = _useState4[0],
    setComunas = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    provinces = _useState6[0],
    setProvinces = _useState6[1];
  var geofinderLevel3Id = tenant === 'cl' ? 'geofinder-input-level2' : 'geofinder-input-level3';
  var onPressEnter = function onPressEnter(e) {
    var shouldSaveZone = tenant !== 'cl' ? selectedRegion && selectedProvince && selectedComuna : selectedRegion && selectedComuna;
    if (e.key === 'Enter' && shouldSaveZone && enableEnter) {
      saveZone();
    }
  };
  var getModalHeader = function getModalHeader() {
    if (selectedComuna && regionInputValue) {
      return jsxs("p", {
        className: styles$1h['modal-heading'],
        children: [jsx("span", {
          className: styles$1h['mr-4'],
          children: SELECTED_REGION_LABLE
        }), jsx("span", {
          className: styles$1h['modal-zone-name'],
          children: " ".concat(selectedComuna.name, " ")
        })]
      });
    }
    return jsx("p", {
      className: classNames(styles$1h['modal-heading'], styles$1h.bold),
      children: deviceType === 'desktop' ? MODAL_DESKTOP_HEADER[tenant] : MODAL_MOBILE_HEADER[tenant]
    });
  };
  useEffect(function () {
    if (!isCambiar) {
      var fetchData = function () {
        var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (isEmpty(selectedZone)) {
                  _context.next = 1;
                  break;
                }
                if (!(getDeliveryEstimatesV2Data && getDeliveryEstimatesV2Data instanceof Function)) {
                  _context.next = 1;
                  break;
                }
                _context.next = 1;
                return executeDataCallbacks$1(selectedZone, getStockEnTiendaData, getDeliveryEstimatesV2Data);
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function fetchData() {
          return _ref4.apply(this, arguments);
        };
      }();
      fetchData();
    }
  }, []);
  useEffect(function () {
    if (isSettingFromPostal) return;
    getSavedZone();
    setRegions(regionsSuggestion.map(function (item) {
      return item.name;
    }));
  }, [regionsSuggestion, postalCodeStatus]);
  useEffect(function () {
    setProvinces(provinceSuggestion.map(function (item) {
      return item.name;
    }));
  }, [provinceSuggestion]);
  useEffect(function () {
    setComunas(comunaSuggestion.map(function (item) {
      return item.name;
    }));
  }, [comunaSuggestion]);
  useEffect(function () {
    window.addEventListener('keydown', onPressEnter);
    return function () {
      window.removeEventListener('keydown', onPressEnter);
    };
  }, [enableEnter]);
  var shouldButtonDisable = function shouldButtonDisable() {
    if (tenant !== 'cl') {
      return !(selectedRegion && selectedComuna && selectedProvince && regionInputValue && provinceInputValue && comunaInputValue);
    }
    return !(selectedRegion && selectedComuna && regionInputValue && comunaInputValue);
  };
  var getDeliveryOptionsButtonLabel = function getDeliveryOptionsButtonLabel() {
    if (isDefaultComuna && deliveryError) {
      return "".concat(SELECT_BUTTON_MARKETPLACE, " comuna");
    }
    return SEE_AVAILABILITY;
  };
  var shouldDeliveryButtonBeDisabled = function shouldDeliveryButtonBeDisabled() {
    if (isStockEnTiendaModal) {
      return !(selectedRegion && selectedComuna && regionInputValue && comunaInputValue && !stockEnTiendaError && !stockEnTiendaDisableButton);
    }
    return !(selectedRegion && selectedComuna && regionInputValue && comunaInputValue && !deliveryError && !deliveryDisableButton);
  };
  var hasDeliveryOptionsError = isDeliveryOptionsModal && deliveryError && deliveryComunaName;
  var hasStockEnTiendaError = isStockEnTiendaModal && stockEnTiendaError && stockEnTiendaComunaName;
  var showPostal = isSodimacRe && isPostalCodeEnabled;
  var renderPostalCode = function renderPostalCode() {
    if (!showPostal) return null;
    return jsxs("div", {
      className: styles$1h['postal-wrapper'],
      children: [jsx(Autocomplete$1, {
        inputLabel: inputLabel.postalCode[tenant],
        placeholder: placeholder.postalCode[tenant],
        isPostalInput: true,
        onFocus: onFocus,
        resetOnFocus: true,
        branding: branding,
        showEmptyResult: true,
        InputValue: postalCodeInputValue,
        setInputValue: setPostalCodeInputValue,
        postalCodeStatus: postalCodeStatus,
        deviceType: deviceType,
        setPostalWarning: setPostalWarning,
        isPostalActive: isPostalActive,
        isPostalExist: isPostalExist,
        isSodimacRe: isSodimacRe
      }), jsxs("div", {
        className: styles$1h['postal-seperator'],
        children: [jsx("div", {
          className: styles$1h['postal-seperator-line'],
          children: jsx("hr", {})
        }), jsx("div", {
          className: styles$1h['postal-seperator-circle']
        }), jsx("div", {
          className: styles$1h['postal-seperator-line'],
          children: jsx("hr", {})
        })]
      })]
    }, "postal-region");
  };
  var renderPostalInfo = function renderPostalInfo() {
    if (!showPostal) return null;
    return jsx(ErrorNotification$1, {
      deviceType: deviceType,
      isPostalInfo: true
    });
  };
  return jsxs("div", {
    className: classNames(styles$1h['zone-modal-body'], styles$1h[branding], _defineProperty(_defineProperty({}, styles$1h.stockEnTienda, !!isStockEnTiendaModal || !!isDeliveryOptionsModal), styles$1h.deliveryOptions, !!isDeliveryOptionsModal)),
    children: [!isNewDeliveryOptionModal && jsxs(Fragment$1, {
      children: [jsxs("div", {
        className: classNames(styles$1h['modal-header'], styles$1h[branding], _defineProperty({}, styles$1h['so-retail-modal-header'], isSodimacRe)),
        children: [jsx("i", {
          className: classNames(styles$1h['icon-location'], styles$1h['icon-header'], styles$1h[branding], _defineProperty(_defineProperty({}, styles$1h.homeDelivery, isDeliveryOptionsModal && type === HOME_DELIVERY), styles$1h.pickupInStore, isDeliveryOptionsModal && type === PICKUP_IN_STORE)),
          children: jsx("span", {
            className: styles$1h['sr-only'],
            children: "location-icon"
          })
        }), getModalHeader()]
      }), jsx("button", {
        type: "button",
        className: "".concat(styles$1h['modal-btn-close'], "\n          ").concat(styles$1h[branding]),
        id: "testId-zone-modal-close",
        onClick: function onClick() {
          return setModalVisible(false);
        },
        children: jsx("div", {
          className: "".concat(styles$1h['icon-close'])
        })
      })]
    }), jsxs("div", {
      className: classNames(styles$1h['modal-content'], _defineProperty({}, styles$1h.deliveryOptions, isNewDeliveryOptionModal)),
      children: [!isNewDeliveryOptionModal && jsx("p", {
        className: classNames(styles$1h['banner-text'], _defineProperty({}, styles$1h['so-retail-banner-text'], isSodimacRe), _defineProperty({}, styles$1h['so-retail-banner-text-error'], isErrorNotification)),
        children: MODAL_BANNER_TEXT[tenant]
      }), renderPostalCode(), renderPostalInfo(), jsx("div", {
        className: classNames(styles$1h['input-wrapper'], _defineProperty({}, styles$1h['postal-wrapper'], showPostal)),
        children: deviceType === 'desktop' ? jsx(Autocomplete$1, {
          inputLabel: inputLabel.states.desktop[tenant],
          placeholder: placeholder.states.desktop[tenant],
          suggestions: regions,
          onChangeHandler: regionChangeHandler,
          disabled: !(regions.length > 0),
          selectedOption: selectedRegion,
          InputValue: regionInputValue,
          setInputValue: setRegionInputValue,
          showEmptyResult: true,
          onFocus: onFocus,
          resetOnFocus: true,
          branding: branding,
          inputId: "geofinder-input-level1",
          isStore: isStore,
          enableSisThemedBorder: enableSisThemedBorder,
          isSodimacStandAlone: isSodimacStandAlone,
          isNewDeliveryOptionModal: isNewDeliveryOptionModal,
          isSettingFromPostal: isSettingFromPostal,
          setPostalWarning: setPostalWarning,
          isSodimacRe: isSodimacRe
        }, "Ingresa una Región") : jsx(Select$1, {
          fieldName: inputLabel.states.mobile[tenant],
          placeholder: placeholder.states.mobile[tenant],
          onSelectChange: regionChangeHandler,
          fieldOptions: regions,
          disabled: !(regions.length > 0),
          defaultValue: selectedRegion ? selectedRegion.name : '',
          branding: branding,
          selectId: "geofinder-input-level1",
          isNewDeliveryOptionModal: isNewDeliveryOptionModal
        }, "Selecciona una región")
      }, "wrapper-region"), tenant !== 'cl' && jsx("div", {
        className: styles$1h['provincia-wrapper'],
        children: deviceType === 'desktop' ? jsx(Autocomplete$1, {
          inputLabel: inputLabel.communa.desktop[tenant],
          placeholder: placeholder.communa.desktop[tenant],
          suggestions: provinces,
          onChangeHandler: provinceChangeHandler,
          disabled: !(selectedRegion && provinces.length > 0),
          selectedOption: selectedProvince,
          InputValue: provinceInputValue,
          setInputValue: setProvinceInputValue,
          showEmptyResult: true,
          onFocus: onFocus,
          resetOnFocus: true,
          branding: branding,
          inputId: "geofinder-input-level2",
          isStore: isStore,
          enableSisThemedBorder: enableSisThemedBorder,
          isNewDeliveryOptionModal: isNewDeliveryOptionModal,
          isSettingFromPostal: isSettingFromPostal,
          isSodimacRe: isSodimacRe
        }, "Ingresa una provincia") : jsx(Select$1, {
          fieldName: inputLabel.communa.mobile[tenant],
          placeholder: placeholder.communa.mobile[tenant],
          onSelectChange: provinceChangeHandler,
          fieldOptions: provinces,
          disabled: !(selectedRegion && provinces.length > 0),
          defaultValue: selectedProvince ? selectedProvince.name : '',
          branding: branding,
          selectId: "geofinder-input-level2",
          isNewDeliveryOptionModal: isNewDeliveryOptionModal
        }, "Selecciona una provincia")
      }, "wrapper-provincia"), jsx("div", {
        className: classNames(styles$1h['comuna-wrapper'], _defineProperty({}, styles$1h.deliveryOptionsError, deliveryError)),
        children: deviceType === 'desktop' ? jsx(Autocomplete$1, {
          inputLabel: inputLabel.districts.desktop[tenant],
          placeholder: placeholder.districts.desktop[tenant],
          suggestions: comunas,
          onChangeHandler: comunaChangeHandler,
          disabled: tenant !== 'cl' ? !(selectedRegion && selectedProvince && comunas.length > 0) : !(selectedRegion && comunas.length > 0),
          selectedOption: selectedComuna,
          InputValue: comunaInputValue,
          setInputValue: setComunaInputValue,
          onFocus: onFocus,
          showEmptyResult: true,
          resetOnFocus: true,
          branding: branding,
          inputId: geofinderLevel3Id,
          isStore: isStore,
          enableSisThemedBorder: enableSisThemedBorder,
          isNewDeliveryOptionModal: isNewDeliveryOptionModal,
          isSettingFromPostal: isSettingFromPostal,
          setPostalWarning: setPostalWarning,
          isSodimacRe: isSodimacRe
        }, "Ingresa una Comuna") : jsx(Select$1, {
          fieldName: inputLabel.districts.mobile[tenant],
          placeholder: placeholder.districts.mobile[tenant],
          onSelectChange: comunaChangeHandler,
          fieldOptions: comunas,
          disabled: tenant !== 'cl' ? !(selectedRegion && selectedProvince && comunas.length > 0) : !(selectedRegion && comunas.length > 0),
          defaultValue: selectedComuna ? selectedComuna.name : '',
          branding: branding,
          selectId: geofinderLevel3Id,
          isNewDeliveryOptionModal: isNewDeliveryOptionModal
        }, "Selecciona una comuna")
      }, "wrapper-comuna"), jsx(React.Fragment, {
        children: (hasDeliveryOptionsError || hasStockEnTiendaError) && jsx(DeliveryOptionsError, {
          deliveryOptions: deliveryOptions,
          stockEnTienda: stockEnTienda,
          tenant: tenant
        })
      })]
    }), isNewDeliveryOptionModal ? jsxs("div", {
      className: styles$1h['stock-en-tienda-footer'],
      children: [jsx("button", {
        type: "button",
        className: styles$1h['btn-zone-select-cancel'],
        onClick: function onClick() {
          return setModalVisible(false);
        },
        children: CANCEL
      }), jsx("button", {
        id: "testId-select-stock",
        type: "button",
        className: classNames(styles$1h['btn-zone-select-stock-en-tienda'], _defineProperty(_defineProperty({}, styles$1h.deliveryOptions, isDeliveryOptionsModal), styles$1h.so_com, isSodimacStandAlone)),
        disabled: shouldDeliveryButtonBeDisabled(),
        onClick: saveZone,
        children: isDeliveryOptionsModal ? getDeliveryOptionsButtonLabel() : REVISAR_STOCK
      })]
    }) : jsx("button", {
      type: "button",
      className: classNames(styles$1h["btn-zone-select-".concat(branding)], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$1h.storeButton, isStore), styles$1h.so_com, isSodimacStandAlone && !isSodimacRe), styles$1h.so_retail, isSodimacRe), styles$1h.retailSaveButton, deviceType === 'mobile')),
      disabled: shouldButtonDisable(),
      onClick: saveZone,
      id: "geofinder-button-save",
      children: branding === 'marketplace' ? SELECT_BUTTON_MARKETPLACE : SELECT_BUTTON_RETAIL[deviceType]
    })]
  });
};
ModalContent$2.propTypes = {
  regionsSuggestion: PropTypes.array.isRequired,
  regionChangeHandler: PropTypes.func.isRequired,
  selectedRegion: PropTypes.object.isRequired,
  comunaSuggestion: PropTypes.array.isRequired,
  comunaChangeHandler: PropTypes.func.isRequired,
  selectedComuna: PropTypes.object.isRequired,
  deviceType: PropTypes.string.isRequired,
  saveZone: PropTypes.func.isRequired,
  getSavedZone: PropTypes.func.isRequired,
  regionInputValue: PropTypes.string.isRequired,
  setRegionInputValue: PropTypes.func.isRequired,
  comunaInputValue: PropTypes.string.isRequired,
  setComunaInputValue: PropTypes.func.isRequired,
  setModalVisible: PropTypes.func.isRequired,
  enableEnter: PropTypes.bool,
  onFocus: PropTypes.func,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  tenant: PropTypes.string.isRequired,
  provinceSuggestion: PropTypes.array.isRequired,
  provinceChangeHandler: PropTypes.func.isRequired,
  selectedProvince: PropTypes.object.isRequired,
  provinceInputValue: PropTypes.string.isRequired,
  setProvinceInputValue: PropTypes.func.isRequired,
  stockEnTienda: PropTypes.object,
  selectedZone: PropTypes.object,
  deliveryOptions: PropTypes.object,
  isDefaultComuna: PropTypes.bool,
  enableSisThemedBorder: PropTypes.bool,
  isSodimacStandAlone: PropTypes.bool
};
ModalContent$2.defaultProps = {
  stockEnTienda: {},
  deliveryOptions: {},
  selectedZone: {},
  isDefaultComuna: false,
  enableSisThemedBorder: false,
  isSodimacStandAlone: false
};
var ModalContentLegacy = ModalContent$2;

var mapMarker = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M7.09637 14.7234L11.5964 20.2234L14.0964 17.7234L16.0964 15.2234C16.5964 14.0567 17.5964 11.6234 17.5964 11.2234V8.72339L16.5964 5.72339L15.5964 4.22339L10.5964 3.22339L8.59637 3.72339L7.09637 5.22339L5.59637 7.22339L5.09637 9.72339L7.09637 14.7234Z\" fill=\"white\" stroke=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.5964 3.4468C8.19992 3.4468 5.4468 6.19992 5.4468 9.5964V9.7684C5.4468 10.493 5.67953 11.363 6.09882 12.3249C6.51467 13.2789 7.09358 14.2775 7.73759 15.2463C9.02572 17.1841 10.5363 18.9468 11.4088 19.9152C11.5105 20.0281 11.6822 20.0282 11.7838 19.9153C12.6564 18.947 14.1671 17.1841 15.4552 15.2463C16.0992 14.2775 16.6781 13.2789 17.094 12.3249C17.5133 11.363 17.746 10.493 17.746 9.7684V9.5964C17.746 6.19992 14.9929 3.4468 11.5964 3.4468ZM4 9.5964C4 5.40088 7.40088 2 11.5964 2C15.7919 2 19.1928 5.40088 19.1928 9.5964V9.7684C19.1928 10.7743 18.8778 11.8534 18.4203 12.903C17.9593 13.9605 17.3323 15.0359 16.6601 16.0472C15.3157 18.0697 13.7523 19.892 12.8588 20.8836V20.8836C12.1825 21.6345 11.0103 21.6345 10.334 20.8836V20.8836C9.4405 19.892 7.87708 18.0697 6.53271 16.0472C5.86047 15.0359 5.2335 13.9605 4.77254 12.903C4.31502 11.8534 4 10.7743 4 9.7684V9.5964Z\" fill=\"#333333\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.873 9.6414C8.873 8.13688 10.0919 6.918 11.5964 6.918C13.1009 6.918 14.3198 8.13688 14.3198 9.6414V9.6784C14.3198 11.1829 13.1009 12.4018 11.5964 12.4018C10.0919 12.4018 8.873 11.1829 8.873 9.6784C8.873 9.67221 8.87308 9.66605 8.87323 9.6599C8.87308 9.65375 8.873 9.64759 8.873 9.6414ZM10.3196 9.6599C10.3197 9.66605 10.3198 9.67221 10.3198 9.6784C10.3198 10.3839 10.8909 10.955 11.5964 10.955C12.3019 10.955 12.873 10.3839 12.873 9.6784V9.6414C12.873 8.93592 12.3019 8.3648 11.5964 8.3648C10.8909 8.3648 10.3198 8.93592 10.3198 9.6414C10.3198 9.64759 10.3197 9.65375 10.3196 9.6599Z\" fill=\"#333333\"/>\n<circle cx=\"11.6464\" cy=\"9.67336\" r=\"1.35\" fill=\"white\"/>\n</svg>\n";

var styles$1g = {"map-container":"GoogleMaps-module_map-container__fBIEh","skeleton-placeholder":"GoogleMaps-module_skeleton-placeholder__EnT6j","skeleton-box":"GoogleMaps-module_skeleton-box__loVUt","shimmer":"GoogleMaps-module_shimmer__JqgZw","skeleton-map":"GoogleMaps-module_skeleton-map__b4FZz"};

var getSisNavigationMenu = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_ref) {
    var tenant, baseUrl, store, validTenant;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          tenant = _ref.tenant, baseUrl = _ref.baseUrl, store = _ref.store;
          if (store) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", Promise.resolve({}));
        case 1:
          validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
          return _context.abrupt("return", doFetch(getSisNavigationMenuUrl(baseUrl, validTenant, 'v2', store), {}, {
            triggerOnResponseError: true,
            triggerOnNetworkError: true
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSisNavigationMenu(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getHeaderData = function () {
  var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_ref3) {
    var tenant, baseUrl, store, validTenant;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          tenant = _ref3.tenant, baseUrl = _ref3.baseUrl, store = _ref3.store;
          validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
          return _context2.abrupt("return", doFetch(getHeaderDataUrl(baseUrl, validTenant, 'v3', store), {}, {
            triggerOnResponseError: true,
            triggerOnNetworkError: true
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getHeaderData(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var getTransversalData = function () {
  var _ref6 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_ref5) {
    var tenant, baseUrl, validTenant;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          tenant = _ref5.tenant, baseUrl = _ref5.baseUrl;
          validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
          return _context3.abrupt("return", doFetch(getTransversalDataUrl(baseUrl, validTenant, 'v3'), {}, {
            triggerOnResponseError: true,
            triggerOnNetworkError: true
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getTransversalData(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var checkMobileApp = function checkMobileApp() {
  var urlSearchParams = new URLSearchParams(window.location.search);
  var _Object$fromEntries = Object.fromEntries(urlSearchParams.entries()),
    externalSiteName = _Object$fromEntries.externalSiteName,
    sid = _Object$fromEntries.sid;
  return externalSiteName === 'MobileApp' && sid === 'APPMOBILE';
};
var siteValue = function siteValue(store) {
  var subDomain = getSubdomain();
  var expParam = getEXPParam();
  var isValidExpParam = function isValidExpParam() {
    return (isPdpPage() || !subDomain && isLandingPage()) && expParam;
  };
  var currentSiteValue = isPdpPage() ? null : subDomain;
  return store || (isValidExpParam() ? expParam : currentSiteValue);
};
var shouldStickyActivate = function shouldStickyActivate(currScroll) {
  var _worldsMenuBar$offset, _filterSection$offset;
  var worldsMenuBar = document.querySelector('[data-wrapper="EM-Worldsapp"]');
  var filterSection = document.getElementById('testId-facets-mobile-container');
  return !!worldsMenuBar && currScroll + 70 > ((_worldsMenuBar$offset = worldsMenuBar === null || worldsMenuBar === void 0 ? void 0 : worldsMenuBar.offsetTop) !== null && _worldsMenuBar$offset !== void 0 ? _worldsMenuBar$offset : null) || !!filterSection && currScroll + 70 > ((_filterSection$offset = filterSection === null || filterSection === void 0 ? void 0 : filterSection.offsetTop) !== null && _filterSection$offset !== void 0 ? _filterSection$offset : null);
};
var toggleHeader = function toggleHeader(currDirection, currScroll, threshold, styles) {
  var toggledValue = true;
  var headerElement = document.getElementById('scrollable-content');
  var bottomHeaderElement = document.getElementById('bottom-header');
  headerElement.classList.remove("".concat(styles['header-scroll-styles']));
  bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
  if (currDirection === 2) {
    headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
  }
  if (currDirection === 2 && currScroll > threshold && !shouldStickyActivate(currScroll)) {
    headerElement.classList.add("".concat(styles.hide));
  } else if (currDirection === 1 && currScroll > threshold && !shouldStickyActivate(currScroll)
  ) {
    headerElement.classList.remove("".concat(styles.hide));
    headerElement.classList.add("".concat(styles['header-scroll-styles']));
    bottomHeaderElement.classList.add("".concat(styles['bottom-header']));
  } else {
    toggledValue = false;
    if (headerElement.classList.contains("".concat(styles.hide))) {
      headerElement.classList.remove("".concat(styles.hide));
    }
  }
  return toggledValue;
};
var getMapCentroid = function getMapCentroid(data, selectedId) {
  if (data.length) {
    if (selectedId) {
      var selectedItem = data.find(function (_ref7) {
        var id = _ref7.id;
        return id === selectedId;
      });
      return {
        lat: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.latitude,
        lng: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.longitude
      };
    } else {
      var _data$, _data$2;
      return {
        lat: data === null || data === void 0 || (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.latitude,
        lng: data === null || data === void 0 || (_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : _data$2.longitude
      };
    }
  } else {
    return {
      lat: 0,
      lng: 0
    };
  }
};

var GoogleMaps = function GoogleMaps(_ref) {
  var markersData = _ref.markersData,
    containerStyle = _ref.containerStyle,
    handleDragEnd = _ref.handleDragEnd,
    zoom = _ref.zoom,
    handleMarkerClick = _ref.handleMarkerClick,
    isMarkerInteractive = _ref.isMarkerInteractive,
    selectedPinId = _ref.selectedPinId,
    externalMapRef = _ref.mapRef,
    zoomControl = _ref.zoomControl,
    isSingleFingerScrollEnabled = _ref.isSingleFingerScrollEnabled;
  var internalMapRef = React.useRef(null);
  var mapRef = externalMapRef || internalMapRef;
  var labels = configs$3.labels,
    constants = configs$3.constants;
  var _useLoadScript = useLoadScript({
      googleMapsApiKey: constants.REACT_APP_GOOGLE_MAPS_API_KEY
    }),
    isLoaded = _useLoadScript.isLoaded,
    loadError = _useLoadScript.loadError;
  var _React$useState = React.useState(function () {
      return getMapCentroid(markersData, selectedPinId);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mapCenter = _React$useState2[0],
    setMapCenter = _React$useState2[1];
  React.useEffect(function () {
    var _getMapCentroid = getMapCentroid(markersData, selectedPinId),
      lat = _getMapCentroid.lat,
      lng = _getMapCentroid.lng;
    setMapCenter({
      lat: lat,
      lng: lng
    });
  }, [selectedPinId, markersData]);
  var handleMarkerClickState = function handleMarkerClickState(index) {
    if (!isMarkerInteractive) return;
    handleMarkerClick(index);
  };
  if (loadError) return jsx("div", {
    children: labels.ERROR_LOADING_MAPS
  });
  if (!isLoaded) {
    return jsx("div", {
      style: {
        height: containerStyle.height
      },
      className: styles$1g['map-container'],
      children: jsx("div", {
        className: styles$1g['skeleton-placeholder'],
        children: jsx("div", {
          className: classNames(styles$1g['skeleton-box'], styles$1g['skeleton-map'])
        })
      })
    });
  }
  var onMapDragEnd = function onMapDragEnd() {
    if (mapRef.current) {
      var newCenter = mapRef.current.getCenter();
      setMapCenter({
        lat: newCenter.lat(),
        lng: newCenter.lng()
      });
      if (handleDragEnd) {
        handleDragEnd({
          lat: newCenter.lat(),
          lng: newCenter.lng()
        });
      }
    }
  };
  return jsx(GoogleMap, {
    mapContainerStyle: containerStyle,
    center: mapCenter,
    zoom: zoom,
    onLoad: function onLoad(map) {
      mapRef.current = map;
    },
    onDragEnd: onMapDragEnd,
    options: {
      disableDefaultUI: true,
      zoomControl: zoomControl,
      gestureHandling: isSingleFingerScrollEnabled ? 'greedy' : ''
    },
    children: markersData.map(function (marker, index) {
      return jsx(Marker, {
        onClick: function onClick() {
          return handleMarkerClickState(marker === null || marker === void 0 ? void 0 : marker.id);
        },
        position: {
          lat: Number(marker.latitude),
          lng: Number(marker.longitude)
        },
        draggable: marker.draggable || false,
        icon: {
          url: marker.icon || svgToDataUri(mapMarker),
          scaledSize: new window.google.maps.Size(marker !== null && marker !== void 0 && marker.selected ? 70 : 50,
          marker !== null && marker !== void 0 && marker.selected ? 70 : 50),
          origin: new window.google.maps.Point(0, 0),
          anchor: new window.google.maps.Point((marker !== null && marker !== void 0 && marker.selected ? 70 : 50) / 2,
          marker !== null && marker !== void 0 && marker.selected ? 70 : 50)
        }
      }, index);
    })
  });
};
GoogleMaps.defaultProps = {
  markersData: [],
  zoom: 15,
  containerStyle: {
    width: '100%',
    height: '400px'
  },
  handleDragEnd: function handleDragEnd() {},
  handleMarkerClick: noop$2,
  isMarkerInteractive: false,
  selectedPinId: '',
  zoomControl: true,
  isSingleFingerScrollEnabled: false
};
GoogleMaps.propTypes = {
  mapRef: PropTypes.shape({
    current: PropTypes.object
  }),
  markersData: PropTypes.arrayOf(PropTypes.shape({
    latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    draggable: PropTypes.bool,
    icon: PropTypes.string
  })),
  containerStyle: PropTypes.object,
  handleDragEnd: PropTypes.func,
  handleMarkerClick: PropTypes.func,
  isMarkerInteractive: PropTypes.bool,
  zoomControl: PropTypes.bool,
  zoom: PropTypes.number,
  selectedPinId: PropTypes.string,
  isSingleFingerScrollEnabled: PropTypes.bool
};
var GoogleMaps$1 = GoogleMaps;

var styles$1f = {"input-container":"InputBox-module_input-container__n5N4x","inputBox":"InputBox-module_inputBox__4xEvc","icon":"InputBox-module_icon__RjpQq","ellipsis":"InputBox-module_ellipsis__Slju2"};

var InputBox = function InputBox(props) {
  var label = props.label,
    hideLabel = props.hideLabel,
    type = props.type,
    id = props.id,
    placeholder = props.placeholder,
    icon = props.icon,
    handleChange = props.handleChange,
    name = props.name,
    value = props.value,
    hasEllipsis = props.hasEllipsis,
    readOnly = props.readOnly,
    onClick = props.onClick,
    maxLength = props.maxLength;
  return jsxs("div", {
    className: styles$1f['input-container'],
    children: [!hideLabel && jsx("label", {
      htmlFor: id,
      children: label
    }), jsx("input", {
      className: classNames(styles$1f.inputBox, _defineProperty({}, styles$1f.ellipsis, hasEllipsis)),
      type: type,
      readOnly: readOnly,
      name: name,
      maxLength: maxLength,
      onClick: onClick,
      placeholder: placeholder,
      onChange: handleChange,
      id: id,
      value: value
    }), !!icon && jsx("div", {
      className: styles$1f.icon,
      children: icon
    })]
  });
};
InputBox.defaultProps = {
  placeholder: '',
  type: 'text',
  hideLabel: false,
  hasEllipsis: false,
  readOnly: false,
  onClick: function onClick() {},
  maxLength: 50
};
InputBox.propTypes = {
  label: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  maxLength: PropTypes.number
};
var InputBox$1 = InputBox;

var getBaseUrl = function getBaseUrl(tenant) {
  var _window;
  var envPrefix = 'www';
  var baseUrl = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin;
  if (baseUrl && (baseUrl.includes(ENVIRONMENT.DEVELOPMEMT) || baseUrl.includes(ENVIRONMENT.STAGING))) {
    envPrefix = 'staging';
  }
  if (baseUrl && baseUrl.includes(ENVIRONMENT.UAT)) {
    envPrefix = 'beta';
  }
  return "https://".concat(envPrefix).concat(TOTTUS_STANDALONE_DOMAIN_NAME[tenant], "/s/geo/v1/geo/").concat(tenant);
};
var getTottusZones = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_ref) {
    var latitude, longitude, tenant, politicalId, response, baseUrl, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          latitude = _ref.latitude, longitude = _ref.longitude, tenant = _ref.tenant, politicalId = _ref.politicalId;
          response = {};
          _context.prev = 1;
          baseUrl = getBaseUrl(tenant);
          _context.next = 2;
          return doFetch("".concat(baseUrl, "?lat=").concat(latitude, "&lng=").concat(longitude, "&politicalId=").concat(politicalId), {
            headers: {
              source: 'tottusya'
            }
          });
        case 2:
          response = _context.sent;
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          console.error('Zone validation failed', _t.message);
        case 4:
          return _context.abrupt("return", response || {});
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function getTottusZones(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getTottusZones$1 = getTottusZones;

function ownKeys$D(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$D(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$D(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$D(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MapSelection = function MapSelection(_ref) {
  var setCurrentView = _ref.setCurrentView,
    saveZone = _ref.saveZone,
    selectedComuna = _ref.selectedComuna,
    handleChange = _ref.handleChange,
    addressLinesData = _ref.addressLinesData,
    setBusy = _ref.setBusy,
    setAddressLinesData = _ref.setAddressLinesData,
    isUserLoggedIn = _ref.isUserLoggedIn,
    tenant = _ref.tenant,
    store = _ref.store,
    selectedRegion = _ref.selectedRegion,
    saveAdressData = _ref.saveAdressData,
    setShowLoginForm = _ref.setShowLoginForm,
    setModalVisible = _ref.setModalVisible;
  var labels = configs$3.labels,
    constants = configs$3.constants;
  var mapLabels = labels.NEW_ZONE_MODAL_LABELS.VIEW2;
  var onMarkerDragEnd = React.useCallback(function (event) {
    var newLat = event.latLng.lat();
    var newLng = event.latLng.lng();
    setAddressLinesData(_objectSpread$D(_objectSpread$D({}, addressLinesData), {}, {
      latitude: newLat,
      longitude: newLng
    }));
  }, []);
  var validateZones = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var response, response2, unescapeATGCookies, getCookie, cookieSID, data, error, domain, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setBusy(true);
            _context.next = 1;
            return getTottusZones$1({
              latitude: addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.latitude,
              longitude: addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.longitude,
              tenant: tenant,
              politicalId: selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.politicalId
            });
          case 1:
            response = _context.sent;
            setBusy(false);
            if (!(response && Object.keys(response).length > 0 && (response === null || response === void 0 ? void 0 : response.zones.length) > 0)) {
              _context.next = 8;
              break;
            }
            if (isUserLoggedIn) {
              _context.next = 2;
              break;
            }
            saveAdressData(_objectSpread$D({}, addressLinesData), response, selectedComuna);
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            unescapeATGCookies = CookieStorage$1.unescapeATGCookies, getCookie = CookieStorage$1.getCookie;
            cookieSID = process.env.ENVIRONMENT === 'dev' ? process.env.TEST_COOKIE_SID : unescapeATGCookies(getCookie('sid'));
            data = {
              state: selectedComuna.parentStateName,
              customInfo: [{
                name: 'stateCode',
                value: selectedRegion.code
              }, {
                name: 'statePoliticalAreaId',
                value: selectedComuna.parentStateId
              }, {
                name: 'municipalCode',
                value: selectedComuna.code
              }, {
                name: 'municipalPoliticalAreaId',
                value: selectedComuna.politicalId
              }, {
                name: 'department',
                value: addressLinesData.landmark
              }],
              municipal: selectedComuna.name,
              addressLine1: addressLinesData.addressLine1,
              addressLine2: addressLinesData.addressLine2,
              latitude: addressLinesData.latitude,
              longitude: addressLinesData.longitude
            };
            if (tenant === 'pe') {
              data.city = selectedComuna.parentCountyName;
              data.customInfo.push({
                name: 'cityCode',
                value: selectedComuna.parentPoliticalId
              });
            }
            _context.next = 3;
            return saveUserAddresses(cookieSID, tenant, store, data);
          case 3:
            response2 = _context.sent;
            if (!(response2.errors && response2.errors.length > 0)) {
              _context.next = 4;
              break;
            }
            error = new Error("".concat(response2.errors[0].message, " (").concat(response2.errors[0].code, ")"));
            error.code = response2.errors[0].code;
            throw error;
          case 4:
            _context.next = 7;
            break;
          case 5:
            _context.prev = 5;
            _t = _context["catch"](2);
            if (!(_t.code === constants.ERROR_CODES.INVALID_SESSION)) {
              _context.next = 6;
              break;
            }
            setModalVisible(false);
            setShowLoginForm(true);
            return _context.abrupt("return");
          case 6:
            console.log(_t);
            saveZone(response === null || response === void 0 ? void 0 : response.zones);
          case 7:
            if (response2) {
              setCurrentView('view4');
              domain = CookieStorage$1.getHost(tenant);
              CookieStorage$1.removeCookieByDomain({
                name: constants.ADDRESS_IDS,
                domain: domain
              });
            }
            _context.next = 9;
            break;
          case 8:
            setCurrentView('view3');
          case 9:
            setBusy(false);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 5]]);
    }));
    return function validateZones() {
      return _ref2.apply(this, arguments);
    };
  }();
  return jsxs("div", {
    children: [jsxs("div", {
      className: styles$1h['warning-section'],
      children: [jsx("span", {
        className: styles$1h['warning-icon']
      }), jsx("p", {
        children: mapLabels.WARNING_LABEL
      })]
    }), jsx(GoogleMaps$1, {
      markersData: [{
        latitude: addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.latitude,
        longitude: addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.longitude,
        draggable: true,
        icon: svgToDataUri(mapMarker)
      }],
      containerStyle: {
        width: '100%',
        height: '45vh'
      },
      onMarkerDragEnd: onMarkerDragEnd,
      zoom: 15
    }), jsxs("div", {
      className: styles$1h['input-section'],
      children: [jsx(InputBox$1, {
        label: "Direcci\xF3n",
        hasEllipsis: true,
        readOnly: true,
        onClick: function onClick() {
          return setCurrentView('view1');
        },
        value: getTottusAddress(_objectSpread$D(_objectSpread$D({}, addressLinesData), {}, {
          comuna: selectedComuna.name,
          region: selectedComuna.parentStateName
        })),
        icon: jsx("span", {
          onClick: function onClick() {
            return setCurrentView('view1');
          },
          className: styles$1h['edit-icon']
        })
      }), jsx(InputBox$1, {
        placeholder: 'Ej; Casa 10',
        value: addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.landmark,
        handleChange: handleChange,
        name: "landmark",
        label: "Dpto./Casa/Oficina/Condominio (opcional)"
      }), jsx("button", {
        onClick: _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 1;
                return validateZones();
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })),
        className: styles$1h['save-location'],
        children: mapLabels.SAVE
      })]
    })]
  });
};
var MapSelection$1 = MapSelection;

function ownKeys$C(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$C(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$C(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$C(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ZoneSelection = function ZoneSelection(_ref) {
  var regionsSuggestion = _ref.regionsSuggestion,
    comunaSuggestion = _ref.comunaSuggestion,
    regionChangeHandler = _ref.regionChangeHandler,
    selectedRegion = _ref.selectedRegion,
    comunaChangeHandler = _ref.comunaChangeHandler,
    selectedComuna = _ref.selectedComuna,
    deviceType = _ref.deviceType;
    _ref.saveZone;
    _ref.getSavedZone;
    var regionInputValue = _ref.regionInputValue,
    setRegionInputValue = _ref.setRegionInputValue,
    comunaInputValue = _ref.comunaInputValue,
    setComunaInputValue = _ref.setComunaInputValue;
    _ref.enableEnter;
    var onFocus = _ref.onFocus,
    branding = _ref.branding,
    tenant = _ref.tenant,
    provinceSuggestion = _ref.provinceSuggestion,
    provinceChangeHandler = _ref.provinceChangeHandler,
    selectedProvince = _ref.selectedProvince,
    provinceInputValue = _ref.provinceInputValue,
    setProvinceInputValue = _ref.setProvinceInputValue,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder,
    isSodimacStandAlone = _ref.isSodimacStandAlone,
    addressLinesData = _ref.addressLinesData,
    setCurrentView = _ref.setCurrentView,
    handleChange = _ref.handleChange,
    isClearForm = _ref.isClearForm,
    setIsClearForm = _ref.setIsClearForm,
    setAddressLinesData = _ref.setAddressLinesData,
    setBusy = _ref.actions.setBusy,
    resetHandler = _ref.resetHandler;
  var labels = configs$3.labels;
  var zoneLabel = labels.NEW_ZONE_MODAL_LABELS.VIEW1;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    regions = _useState2[0],
    setRegions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    comunas = _useState4[0],
    setComunas = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    provinces = _useState6[0],
    setProvinces = _useState6[1];
  var _addressLinesData$add = addressLinesData.addressLine1,
    addressLine1 = _addressLinesData$add === void 0 ? '' : _addressLinesData$add,
    _addressLinesData$add2 = addressLinesData.addressLine2,
    addressLine2 = _addressLinesData$add2 === void 0 ? '' : _addressLinesData$add2;
  var geofinderLevel3Id = tenant === 'cl' ? 'geofinder-input-level2' : 'geofinder-input-level3';
  useEffect(function () {
    setRegions(regionsSuggestion.map(function (item) {
      return item.name;
    }));
  }, [regionsSuggestion]);
  useEffect(function () {
    setProvinces(provinceSuggestion.map(function (item) {
      return item.name;
    }));
  }, [provinceSuggestion]);
  useEffect(function () {
    setComunas(comunaSuggestion.map(function (item) {
      return item.name;
    }));
  }, [comunaSuggestion]);
  var shouldButtonDisable = function shouldButtonDisable() {
    if (tenant !== 'cl') {
      return !(selectedRegion && selectedComuna && selectedProvince && regionInputValue && provinceInputValue && comunaInputValue && addressLine1 && addressLine2);
    }
    return !(selectedRegion && selectedComuna && regionInputValue && comunaInputValue && addressLine1 && addressLine2);
  };
  var goToNextScreen = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var address, _response$results, _response$results2, response, geometry, addressComponents, hasStreetNumber, hasRoute, _geometry$location, _geometry$location2, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(selectedRegion && selectedComuna && regionInputValue && comunaInputValue && addressLine1 && addressLine2)) {
              _context.next = 5;
              break;
            }
            setBusy(true);
            address = tenant === 'pe' ? "".concat(addressLine1, "+").concat(addressLine2, "+").concat(selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.name, "+").concat(selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.name, "+").concat(selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.name) : "".concat(addressLine1, "+").concat(addressLine2, "+").concat(selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.name, "+").concat(selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.name);
            _context.prev = 1;
            _context.next = 2;
            return doFetch("".concat(zoneLabel.GET_LAT_LONG_API_URL).concat(address, "&components=country:").concat(tenant));
          case 2:
            response = _context.sent;
            geometry = response === null || response === void 0 || (_response$results = response.results) === null || _response$results === void 0 || (_response$results = _response$results[0]) === null || _response$results === void 0 ? void 0 : _response$results.geometry;
            addressComponents = response === null || response === void 0 || (_response$results2 = response.results) === null || _response$results2 === void 0 || (_response$results2 = _response$results2[0]) === null || _response$results2 === void 0 ? void 0 : _response$results2.address_components;
            hasStreetNumber = addressComponents.some(function (item) {
              var _item$types;
              return zoneLabel.VALID_LOCALTION_TYPES[0] === (item === null || item === void 0 || (_item$types = item.types) === null || _item$types === void 0 ? void 0 : _item$types[0]);
            });
            hasRoute = addressComponents.some(function (item) {
              var _item$types2;
              return zoneLabel.VALID_LOCALTION_TYPES[1] === (item === null || item === void 0 || (_item$types2 = item.types) === null || _item$types2 === void 0 ? void 0 : _item$types2[0]);
            });
            if (hasStreetNumber && hasRoute) {
              setAddressLinesData(_objectSpread$C(_objectSpread$C({}, addressLinesData), {}, {
                latitude: geometry === null || geometry === void 0 || (_geometry$location = geometry.location) === null || _geometry$location === void 0 ? void 0 : _geometry$location.lat,
                longitude: geometry === null || geometry === void 0 || (_geometry$location2 = geometry.location) === null || _geometry$location2 === void 0 ? void 0 : _geometry$location2.lng
              }));
            } else {
              setAddressLinesData(_objectSpread$C(_objectSpread$C({}, addressLinesData), {}, {
                latitude: selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude,
                longitude: selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.longitude
              }));
            }
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            console.error(_t);
          case 4:
            setBusy(false);
            setCurrentView('view2');
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function goToNextScreen() {
      return _ref2.apply(this, arguments);
    };
  }();
  var setInputValue = function setInputValue(inputValue, customReturn) {
    if (isClearForm) {
      setRegionInputValue('');
      setComunaInputValue('');
      return customReturn || '';
    }
    return inputValue;
  };
  useEffect(function () {
    if (isClearForm) {
      resetHandler();
      setIsClearForm(false);
    }
  }, [isClearForm]);
  return jsxs("div", {
    className: classNames(styles$1h['zone-selection-body'], styles$1h[branding]),
    children: [jsx("p", {
      className: styles$1h['modal-label'],
      children: zoneLabel.BODY
    }), jsxs("div", {
      className: classNames(styles$1h['modal-content']),
      children: [jsx("div", {
        className: styles$1h['input-wrapper'],
        children: deviceType === 'desktop' ? jsx(Autocomplete$1, {
          inputLabel: inputLabel.states.desktop[tenant],
          placeholder: placeholder.states.desktop[tenant],
          type: 2,
          suggestions: regions,
          onChangeHandler: regionChangeHandler,
          disabled: !(regions.length > 0),
          selectedOption: selectedRegion,
          InputValue: setInputValue(regionInputValue),
          setInputValue: setRegionInputValue,
          showEmptyResult: true,
          onFocus: onFocus,
          resetOnFocus: true,
          branding: branding,
          inputId: "geofinder-input-level1",
          isStore: isStore,
          enableSisThemedBorder: enableSisThemedBorder,
          isSodimacStandAlone: isSodimacStandAlone
        }, "Ingresa una Región") : jsx(Select$1, {
          fieldName: inputLabel.states.mobile[tenant],
          placeholder: placeholder.states.mobile[tenant],
          onSelectChange: regionChangeHandler,
          fieldOptions: regions,
          disabled: !(regions.length > 0),
          defaultValue: setInputValue((selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.name) || ''),
          branding: branding,
          selectId: "geofinder-input-level1",
          type: 2
        }, "Selecciona una región")
      }, "wrapper-region"), tenant !== 'cl' && jsx("div", {
        className: styles$1h['provincia-wrapper'],
        children: deviceType === 'desktop' ? jsx(Autocomplete$1, {
          inputLabel: inputLabel.communa.desktop[tenant],
          placeholder: placeholder.communa.desktop[tenant],
          suggestions: provinces,
          type: 2,
          onChangeHandler: provinceChangeHandler,
          disabled: !(selectedRegion && provinces.length > 0),
          selectedOption: selectedProvince,
          InputValue: provinceInputValue,
          setInputValue: setProvinceInputValue,
          showEmptyResult: true,
          onFocus: onFocus,
          resetOnFocus: true,
          branding: branding,
          inputId: "geofinder-input-level2",
          isStore: isStore,
          enableSisThemedBorder: enableSisThemedBorder
        }, "Ingresa una provincia") : jsx(Select$1, {
          fieldName: inputLabel.communa.mobile[tenant],
          placeholder: placeholder.communa.mobile[tenant],
          onSelectChange: provinceChangeHandler,
          fieldOptions: provinces,
          disabled: !(selectedRegion && provinces.length > 0),
          defaultValue: selectedProvince ? selectedProvince.name : '',
          branding: branding,
          selectId: "geofinder-input-level2",
          type: 2
        }, "Selecciona una provincia")
      }, "wrapper-provincia"), jsx("div", {
        className: classNames(styles$1h['comuna-wrapper']),
        children: deviceType === 'desktop' ? jsx(Autocomplete$1, {
          inputLabel: inputLabel.districts.desktop[tenant],
          placeholder: placeholder.districts.desktop[tenant],
          suggestions: comunas,
          type: 2,
          onChangeHandler: comunaChangeHandler,
          disabled: tenant !== 'cl' ? !(selectedRegion && selectedProvince && comunas.length > 0) : !(selectedRegion && comunas.length > 0),
          selectedOption: selectedComuna,
          InputValue: setInputValue(comunaInputValue),
          setInputValue: setComunaInputValue,
          onFocus: onFocus,
          showEmptyResult: true,
          resetOnFocus: true,
          branding: branding,
          inputId: geofinderLevel3Id,
          isStore: isStore,
          enableSisThemedBorder: enableSisThemedBorder
        }, "Ingresa una Comuna") : jsx(Select$1, {
          fieldName: inputLabel.districts.mobile[tenant],
          placeholder: placeholder.districts.mobile[tenant],
          onSelectChange: comunaChangeHandler,
          fieldOptions: comunas,
          disabled: tenant !== 'cl' ? !(selectedRegion && selectedProvince && comunas.length > 0) : !(selectedRegion && comunas.length > 0),
          defaultValue: setInputValue((selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.name) || ''),
          branding: branding,
          selectId: geofinderLevel3Id,
          type: 2
        }, "Selecciona una comuna")
      }, "wrapper-comuna"), jsx(InputBox$1, {
        placeholder: '2 de Mayo',
        label: "Calle",
        name: "addressLine2",
        value: setInputValue(addressLinesData.addressLine2, undefined),
        handleChange: handleChange
      }), jsx(InputBox$1, {
        placeholder: '123',
        label: "N\xFAmero",
        maxLength: 8,
        type: "number",
        name: "addressLine1",
        value: setInputValue(addressLinesData.addressLine1, undefined),
        handleChange: handleChange
      }), jsx(InputBox$1, {
        placeholder: 'Ej: Casa 10',
        name: "landmark",
        value: setInputValue(addressLinesData.landmark, undefined),
        label: "Dpto./Casa/Oficina/Condominio (opcional)",
        handleChange: handleChange
      })]
    }), jsx("button", {
      type: "button",
      className: classNames(styles$1h['btn-zone-select'], _defineProperty(_defineProperty({}, styles$1h.storeButton, isStore), styles$1h.so_com, isSodimacStandAlone)),
      disabled: shouldButtonDisable(),
      onClick: goToNextScreen,
      id: "geofinder-button-save",
      children: zoneLabel.SAVE
    })]
  });
};
ZoneSelection.propTypes = {
  regionsSuggestion: PropTypes.array.isRequired,
  regionChangeHandler: PropTypes.func.isRequired,
  selectedRegion: PropTypes.object.isRequired,
  comunaSuggestion: PropTypes.array.isRequired,
  comunaChangeHandler: PropTypes.func.isRequired,
  selectedComuna: PropTypes.object.isRequired,
  deviceType: PropTypes.string.isRequired,
  saveZone: PropTypes.func.isRequired,
  getSavedZone: PropTypes.func.isRequired,
  regionInputValue: PropTypes.string.isRequired,
  setRegionInputValue: PropTypes.func.isRequired,
  comunaInputValue: PropTypes.string.isRequired,
  setComunaInputValue: PropTypes.func.isRequired,
  setModalVisible: PropTypes.func.isRequired,
  enableEnter: PropTypes.bool,
  onFocus: PropTypes.func,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  tenant: PropTypes.string.isRequired,
  provinceSuggestion: PropTypes.array.isRequired,
  provinceChangeHandler: PropTypes.func.isRequired,
  selectedProvince: PropTypes.object.isRequired,
  provinceInputValue: PropTypes.string.isRequired,
  setProvinceInputValue: PropTypes.func.isRequired,
  stockEnTienda: PropTypes.object,
  deliveryOptions: PropTypes.object,
  isDefaultComuna: PropTypes.bool,
  enableSisThemedBorder: PropTypes.bool,
  isSodimacStandAlone: PropTypes.bool,
  setAddressLinesData: PropTypes.func.isRequired,
  addressLinesData: PropTypes.object.isRequired
};
ZoneSelection.defaultProps = {
  stockEnTienda: {},
  deliveryOptions: {},
  isDefaultComuna: false,
  enableSisThemedBorder: false,
  isSodimacStandAlone: false
};
var ZoneSelection$1 = ZoneSelection;

function ownKeys$B(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$B(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$B(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$B(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SaveAddress = function SaveAddress(_ref) {
  var setCurrentView = _ref.setCurrentView,
    tenant = _ref.tenant,
    store = _ref.store,
    resetHandler = _ref.resetHandler,
    setGeofinderProgramatically = _ref.setGeofinderProgramatically,
    setModalVisible = _ref.setModalVisible,
    setBusy = _ref.setBusy,
    setDeleteAddressID = _ref.setDeleteAddressID,
    saveAdressData = _ref.saveAdressData,
    setIsClearForm = _ref.setIsClearForm,
    addressLinesData = _ref.addressLinesData,
    setSelectedComuna = _ref.setSelectedComuna,
    setAddressLinesData = _ref.setAddressLinesData,
    selectedComuna = _ref.selectedComuna,
    fetchComunaDefault = _ref.fetchComunaDefault;
    _ref.setShowLoginForm;
  var labels = configs$3.labels,
    constants = configs$3.constants;
  var screenLabels = labels.NEW_ZONE_MODAL_LABELS.VIEW4;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    addressList = _useState2[0],
    setAddressList = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAddressId = _useState4[0],
    setSelectedAddressId = _useState4[1];
  var addNewAddress = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsClearForm(true);
            resetHandler();
            setCurrentView('view1');
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function addNewAddress() {
      return _ref2.apply(this, arguments);
    };
  }();
  var saveAddress = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
      var _addressLinesData$zon;
      var addr, _addr$addressLine, addressLine1, _addr$addressLine2, addressLine2, _addr$departmentNumbe, departmentNumber, _addr$latitude, latitude, _addr$longitude, longitude, addData, response, _response;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setBusy(true);
            addr = addressList.find(function (item) {
              return item.id === selectedAddressId;
            });
            if (addr) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return");
          case 1:
            _addr$addressLine = addr.addressLine1, addressLine1 = _addr$addressLine === void 0 ? '' : _addr$addressLine, _addr$addressLine2 = addr.addressLine2, addressLine2 = _addr$addressLine2 === void 0 ? '' : _addr$addressLine2, _addr$departmentNumbe = addr.departmentNumber, departmentNumber = _addr$departmentNumbe === void 0 ? '' : _addr$departmentNumbe, _addr$latitude = addr.latitude, latitude = _addr$latitude === void 0 ? '' : _addr$latitude, _addr$longitude = addr.longitude, longitude = _addr$longitude === void 0 ? '' : _addr$longitude;
            addData = {
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              landmark: departmentNumber,
              latitude: latitude,
              longitude: longitude,
              id: selectedAddressId
            };
            response = addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.zones;
            if (!(addressLinesData !== null && addressLinesData !== void 0 && (_addressLinesData$zon = addressLinesData.zones) !== null && _addressLinesData$zon !== void 0 && _addressLinesData$zon.length)) {
              _context2.next = 2;
              break;
            }
            saveAdressData(addData, addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.zones, selectedComuna);
            _context2.next = 6;
            break;
          case 2:
            _context2.next = 3;
            return getTottusZones$1({
              latitude: latitude,
              longitude: longitude,
              tenant: tenant,
              politicalId: selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.politicalId
            });
          case 3:
            response = _context2.sent;
            if (!(response && Object.keys(response).length > 0 && ((_response = response) === null || _response === void 0 ? void 0 : _response.zones.length) > 0)) {
              _context2.next = 5;
              break;
            }
            _context2.next = 4;
            return setGeofinderProgramatically(_objectSpread$B({}, addr));
          case 4:
            setModalVisible(false);
            _context2.next = 6;
            break;
          case 5:
            setSelectedComuna({
              name: addr === null || addr === void 0 ? void 0 : addr.municipal,
              parentStateName: addr === null || addr === void 0 ? void 0 : addr.state
            });
            setAddressLinesData(_objectSpread$B({}, addData));
            setCurrentView('view3');
          case 6:
            setBusy(false);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function saveAddress() {
      return _ref3.apply(this, arguments);
    };
  }();
  var selectAddress = function selectAddress(id) {
    setSelectedAddressId(id);
  };
  var fetchAddresses = function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
      var unescapeATGCookies, getCookie, cookieSID, cookieSIDStatus, _addresses$, response, _response2, addresses, isUserZone, shouldForceDefault, selectedAddress, _t;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            unescapeATGCookies = CookieStorage$1.unescapeATGCookies, getCookie = CookieStorage$1.getCookie;
            cookieSID = process.env.ENVIRONMENT === 'dev' ? process.env.TEST_COOKIE_SID : unescapeATGCookies(getCookie('sid'));
            cookieSIDStatus = getCookie('sidStatus');
            _context3.prev = 1;
            setBusy(true);
            if (!(cookieSIDStatus === SID_STATUS.SOFTLOGIN)) {
              _context3.next = 3;
              break;
            }
            _context3.next = 2;
            return getUserAddressesCheckout(cookieSID, tenant, store);
          case 2:
            response = _context3.sent;
            _context3.next = 5;
            break;
          case 3:
            _context3.next = 4;
            return getUserAddresses(cookieSID, tenant, store);
          case 4:
            response = _context3.sent;
          case 5:
            if (!(response.errors && response.errors.length > 0)) {
              _context3.next = 6;
              break;
            }
            throw new Error("".concat(response.errors[0].message, " (").concat(response.errors[0].code, ")"));
          case 6:
            _response2 = response, addresses = _response2.addresses;
            if (!(addresses && addresses.length === 0)) {
              _context3.next = 8;
              break;
            }
            isUserZone = CookieStorage$1.getCookie(constants.USER_ZONE) === 'userselected';
            if (!isUserZone) {
              _context3.next = 7;
              break;
            }
            shouldForceDefault = true;
            _context3.next = 7;
            return fetchComunaDefault(shouldForceDefault);
          case 7:
            addNewAddress();
          case 8:
            setAddressList(addresses);
            selectedAddress = CookieStorage$1.getCookie(constants.ADDRESS_IDS);
            setSelectedAddressId(selectedAddress || ((_addresses$ = addresses[0]) === null || _addresses$ === void 0 ? void 0 : _addresses$.id) || '');
            setBusy(false);
            _context3.next = 10;
            break;
          case 9:
            _context3.prev = 9;
            _t = _context3["catch"](1);
            console.log(_t);
            setBusy(false);
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 9]]);
    }));
    return function fetchAddresses() {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    fetchAddresses();
  }, [tenant]);
  var deleteUserAddress = function () {
    var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(addressID) {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setDeleteAddressID(addressID);
            setCurrentView('view5');
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function deleteUserAddress(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  return jsxs("div", {
    className: styles$1h['savezone-container'],
    children: [jsx("p", {
      className: styles$1h['modal-content'],
      children: screenLabels.BODY
    }), jsx("div", {
      className: styles$1h['address-container'],
      children: addressList.map(function (addr, index) {
        return jsxs("div", {
          onClick: function onClick() {
            return selectAddress(addr.id);
          },
          className: classNames(styles$1h['address-selection'], _defineProperty({}, styles$1h.active, selectedAddressId ? selectedAddressId === addr.id : index === 0)),
          children: [jsxs("div", {
            className: styles$1h.lwrapper,
            children: [jsx("div", {
              className: styles$1h['radio-icon']
            }), jsx("div", {
              className: styles$1h.address,
              children: getTottusAddress({
                addressLine1: addr.addressLine1,
                addressLine2: addr.addressLine2,
                landmark: addr.landmark,
                latitude: addr.latitude,
                longitude: addr.longitude,
                comuna: addr.municipal,
                region: addr.state
              })
            })]
          }), jsx("span", {
            className: styles$1h['remove-button'],
            onClick: function onClick() {
              return deleteUserAddress(addr.id);
            },
            children: "Eliminar"
          })]
        }, addr.id);
      })
    }), jsxs("div", {
      className: styles$1h['button-container'],
      children: [jsx("div", {
        onClick: addNewAddress,
        className: styles$1h['directions-link'],
        children: screenLabels.LINK_TEXT
      }), jsx("button", {
        onClick: saveAddress,
        className: styles$1h['save-button'],
        children: screenLabels.ACTION
      })]
    })]
  });
};
var SaveAddress$1 = SaveAddress;

function ownKeys$A(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$A(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$A(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$A(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NoCoverage = function NoCoverage(_ref) {
  var setCurrentView = _ref.setCurrentView,
    addressLinesData = _ref.addressLinesData,
    selectedComuna = _ref.selectedComuna,
    close = _ref.close,
    setIsClearForm = _ref.setIsClearForm,
    tenant = _ref.tenant;
  var redirectToScreen1 = function redirectToScreen1() {
    setIsClearForm(true);
    setCurrentView('view1');
  };
  var labels = configs$3.labels;
  var screenLabels = labels.NEW_ZONE_MODAL_LABELS.VIEW3;
  return jsxs("div", {
    className: styles$1h['no-coverage-body'],
    children: [jsx("span", {
      className: styles$1h['no-address']
    }), jsx("p", {
      className: styles$1h['modal-body'],
      children: screenLabels.BODY
    }), jsx("p", {
      className: styles$1h['selected-address'],
      children: getTottusAddress(_objectSpread$A(_objectSpread$A({}, addressLinesData), {}, {
        comuna: selectedComuna.name,
        region: selectedComuna.parentStateName
      }))
    }), jsx("button", {
      onClick: redirectToScreen1,
      className: styles$1h['new-address'],
      children: screenLabels.LINK_TEXT2
    }), jsx("a", {
      target: "blank",
      href: screenLabels.URL[tenant],
      className: styles$1h['see-coverage'],
      children: screenLabels.LINK_TEXT1
    }), jsx("button", {
      onClick: close,
      className: styles$1h['close-nocoverage'],
      children: screenLabels.BUTTON
    })]
  });
};
var NoCoverage$1 = NoCoverage;

var DeleteAddress = function DeleteAddress(_ref) {
  var setCurrentView = _ref.setCurrentView,
    tenant = _ref.tenant,
    store = _ref.store,
    setBusy = _ref.setBusy,
    deleteAddressID = _ref.deleteAddressID,
    setShowLoginForm = _ref.setShowLoginForm,
    setModalVisible = _ref.setModalVisible;
  var setCancel = function setCancel() {
    return setCurrentView('view4');
  };
  var constants = configs$3.constants,
    labels = configs$3.labels;
  var deleteAddresse = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var _response$errors, unescapeATGCookies, getCookie, cookieSID, response, savedAddressId, domain, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setBusy(true);
            _context.prev = 1;
            unescapeATGCookies = CookieStorage$1.unescapeATGCookies, getCookie = CookieStorage$1.getCookie;
            cookieSID = process.env.ENVIRONMENT === 'dev' ? process.env.TEST_COOKIE_SID : unescapeATGCookies(getCookie('sid'));
            _context.next = 2;
            return deleteUserAddresses(cookieSID, tenant, store, deleteAddressID);
          case 2:
            response = _context.sent;
            if (!((response === null || response === void 0 || (_response$errors = response.errors) === null || _response$errors === void 0 || (_response$errors = _response$errors[0]) === null || _response$errors === void 0 ? void 0 : _response$errors.code) === constants.ERROR_CODES.INVALID_SESSION)) {
              _context.next = 3;
              break;
            }
            setModalVisible(false);
            setShowLoginForm(true);
            return _context.abrupt("return");
          case 3:
            setCurrentView('view4');
            savedAddressId = CookieStorage$1.getCookie(constants.ADDRESS_IDS);
            if (savedAddressId === deleteAddressID) {
              domain = CookieStorage$1.getHost(tenant);
              CookieStorage$1.removeCookieByDomain({
                name: constants.ADDRESS_IDS,
                domain: domain
              });
              CookieStorage$1.removeCookieByDomain({
                name: constants.ADDRESS_LINES,
                domain: domain
              });
            }
            setBusy(false);
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](1);
            console.error('Error deleting address:', _t);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function deleteAddresse() {
      return _ref2.apply(this, arguments);
    };
  }();
  var screenLabels = labels.NEW_ZONE_MODAL_LABELS.VIEW5;
  return jsxs("div", {
    className: styles$1h['delete-address-container'],
    children: [jsx("p", {
      className: styles$1h['modal-content'],
      children: screenLabels.BODY
    }), jsxs("div", {
      className: styles$1h['modal-buttons'],
      children: [jsx("div", {
        onClick: setCancel,
        className: styles$1h['cancel-link'],
        children: screenLabels.CANCEL
      }), jsx("button", {
        onClick: deleteAddresse,
        className: styles$1h['delete-button'],
        children: screenLabels.SAVE
      })]
    })]
  });
};
var DeleteAddress$1 = DeleteAddress;

function ownKeys$z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$z(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ModelContentWithMaps = function ModelContentWithMaps(props) {
  var view = props.isUserLoggedIn ? 'view4' : 'view1';
  var _React$useState = React.useState(view),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    currentView = _React$useState2[0],
    setCurrentView = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isDragging = _React$useState4[0],
    setIsDragging = _React$useState4[1];
  var _React$useState5 = React.useState({
      x: 0,
      y: 0
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    offset = _React$useState6[0],
    setOffset = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    startY = _React$useState8[0],
    setStartY = _React$useState8[1];
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    deleteAddressID = _useState2[0],
    setDeleteAddressID = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isClearForm = _useState4[0],
    setIsClearForm = _useState4[1];
  var modalRef = React.useRef(null);
  var saveZone = props.saveZone,
    actions = props.actions,
    addressLinesData = props.addressLinesData,
    setAddressLinesData = props.setAddressLinesData,
    selectedComuna = props.selectedComuna,
    isUserLoggedIn = props.isUserLoggedIn,
    tenant = props.tenant,
    store = props.store,
    selectedRegion = props.selectedRegion,
    addNewAddress = props.addNewAddress,
    resetHandler = props.resetHandler,
    setGeofinderProgramatically = props.setGeofinderProgramatically,
    setModalVisible = props.setModalVisible,
    setSavedAddressLinesData = props.setSavedAddressLinesData,
    saveAdressData = props.saveAdressData,
    setSelectedComuna = props.setSelectedComuna,
    getSavedZone = props.getSavedZone,
    fetchComunaDefault = props.fetchComunaDefault,
    setShowLoginForm = props.setShowLoginForm;
  var labels = configs$3.labels;
  var handleChange = function handleChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    props.setAddressLinesData(function (prevData) {
      return _objectSpread$z(_objectSpread$z({}, prevData), {}, _defineProperty({}, name, value));
    });
  };
  React.useEffect(function () {
    if (!(addressLinesData !== null && addressLinesData !== void 0 && addressLinesData.addressLine1)) {
      getSavedZone();
    }
  }, []);
  var getScreenView = function getScreenView() {
    switch (currentView) {
      case 'view1':
        return jsx(ZoneSelection$1, _objectSpread$z(_objectSpread$z({}, props), {}, {
          branding: '',
          handleChange: handleChange,
          setCurrentView: setCurrentView,
          isClearForm: isClearForm,
          setIsClearForm: setIsClearForm
        }));
      case 'view2':
        return jsx(MapSelection$1, {
          setCurrentView: setCurrentView,
          saveZone: saveZone,
          addressLinesData: addressLinesData,
          setAddressLinesData: setAddressLinesData,
          selectedComuna: selectedComuna,
          handleChange: handleChange,
          setBusy: actions.setBusy,
          isUserLoggedIn: isUserLoggedIn,
          tenant: tenant,
          selectedRegion: selectedRegion,
          saveAdressData: saveAdressData,
          setModalVisible: setModalVisible,
          setShowLoginForm: setShowLoginForm
        });
      case 'view3':
        return jsx(NoCoverage$1, {
          setCurrentView: setCurrentView,
          addressLinesData: addressLinesData,
          selectedComuna: selectedComuna,
          close: actions.close,
          tenant: tenant,
          setIsClearForm: setIsClearForm
        });
      case 'view4':
        return jsx(SaveAddress$1, {
          setCurrentView: setCurrentView,
          addressLinesData: addressLinesData,
          selectedComuna: selectedComuna,
          addNewAddress: addNewAddress,
          tenant: tenant,
          store: store,
          resetHandler: resetHandler,
          setGeofinderProgramatically: setGeofinderProgramatically,
          setModalVisible: setModalVisible,
          setAddressLinesData: setAddressLinesData,
          setSavedAddressLinesData: setSavedAddressLinesData,
          saveZone: saveZone,
          setBusy: actions.setBusy,
          setDeleteAddressID: setDeleteAddressID,
          saveAdressData: saveAdressData,
          setIsClearForm: setIsClearForm,
          setSelectedComuna: setSelectedComuna,
          fetchComunaDefault: fetchComunaDefault,
          setShowLoginForm: setShowLoginForm
        });
      case 'view5':
        return jsx(DeleteAddress$1, {
          setCurrentView: setCurrentView,
          tenant: props.tenant,
          store: store,
          setBusy: actions.setBusy,
          deleteAddressID: deleteAddressID,
          setShowLoginForm: setShowLoginForm,
          setModalVisible: setModalVisible
        });
      default:
        return null;
    }
  };
  var handleTouchStart = function handleTouchStart(e) {
    setIsDragging(true);
    var touch = e.touches[0];
    var rect = modalRef.current.getBoundingClientRect();
    setOffset({
      x: touch.clientX - rect.left,
      y: touch.clientY - rect.top
    });
    setStartY(touch.clientY);
  };
  var handleTouchMove = function handleTouchMove(e) {
    if (!isDragging) return;
    var touch = e.touches[0];
    var newLeft = touch.clientX - offset.x;
    var newTop = touch.clientY - offset.y;
    modalRef.current.style.left = "".concat(newLeft, "px");
    modalRef.current.style.top = "".concat(newTop, "px");
  };
  var handleTouchEnd = function handleTouchEnd(e) {
    setIsDragging(false);
    var touch = e.changedTouches[0];
    var dragDistance = touch.clientY - startY;
    if (dragDistance > 10) {
      actions.close();
    }
  };
  return jsxs("div", {
    ref: modalRef,
    className: styles$1h['new-zone-modal-container'],
    children: [jsx("div", {
      onTouchStart: handleTouchStart,
      onTouchMove: handleTouchMove,
      onTouchEnd: handleTouchEnd,
      className: styles$1h['draggable-bar']
    }), jsxs("div", {
      className: classNames(styles$1h['modal-header'], styles$1h.marketplace, styles$1h.gap, _defineProperty({}, styles$1h['no-padding'], currentView === 'view3')),
      children: [currentView !== 'view3' && jsxs(Fragment, {
        children: [jsx("i", {
          className: classNames(styles$1h['icon-location'], styles$1h['icon-header'], styles$1h.marketplace, _defineProperty({}, styles$1h['remove-icon'], currentView === 'view5')),
          children: jsx("span", {
            className: styles$1h['sr-only'],
            children: "location-icon"
          })
        }), jsx("span", {
          className: styles$1h['modal-header-text'],
          children: labels.NEW_ZONE_MODAL_LABELS[currentView.toUpperCase()].HEADER
        })]
      }), jsx("button", {
        type: "button",
        className: "".concat(styles$1h['modal-btn-close']),
        id: "testId-zone-modal-close",
        onClick: function onClick() {
          return actions.close();
        },
        children: jsx("div", {
          className: "".concat(styles$1h['icon-close'])
        })
      })]
    }), getScreenView()]
  });
};
ModelContentWithMaps.defaultProps = {};
ModelContentWithMaps.propTypes = {
  tenant: PropTypes.string.isRequired
};
var ModelContentWithMaps$1 = ModelContentWithMaps;

function ownKeys$y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$y(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ModalContent = function ModalContent(props) {
  var store = props.store;
  if (store === 'to_com') {
    return jsx(ModelContentWithMaps$1, _objectSpread$y({}, props));
  }
  return jsx(ModalContentLegacy, _objectSpread$y({}, props));
};
var ModalContent$1 = ModalContent;

var notificationTimeOut = function notificationTimeOut(dismissHandler, notificationLife) {
  var time = Number(notificationLife);
  setTimeout(function () {
    dismissHandler(false);
  }, time);
};
var PopOverWrapper = function PopOverWrapper(_ref) {
  var children = _ref.children,
    dismissHandler = _ref.dismissHandler,
    hideCrossButton = _ref.hideCrossButton,
    size = _ref.size,
    customClass = _ref.customClass,
    isBrandingMarketplace = _ref.isBrandingMarketplace;
  return jsxs("div", {
    className: classNames(styles$1h['zone-popover'], styles$1h["".concat(size)], styles$1h["".concat(customClass)], _defineProperty({}, styles$1h.marketplace, isBrandingMarketplace)),
    children: [children, !hideCrossButton && jsx("button", {
      type: "button",
      className: styles$1h['modal-close'],
      id: "testId-modal-close",
      onClick: function onClick() {
        dismissHandler(true);
      },
      children: "\u2715"
    })]
  });
};
PopOverWrapper.defaultProps = {
  hideCrossButton: false,
  size: 'large',
  customClass: ''
};
PopOverWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  dismissHandler: PropTypes.func.isRequired,
  hideCrossButton: PropTypes.bool,
  size: PropTypes.oneOf(['large', 'medium']),
  customClass: PropTypes.oneOf(['', 'success-modal', 'warning-modal', 'pressure-modal', 'reminder-modal']),
  isBrandingMarketplace: PropTypes.bool.isRequired
};
var PressureModal = function PressureModal(_ref2) {
  var dismissHandler = _ref2.dismissHandler,
    isBrandingMarketplace = _ref2.isBrandingMarketplace,
    notificationLife = _ref2.notificationLife;
  var labels = configs$3.labels;
  notificationTimeOut(dismissHandler, notificationLife);
  return jsxs(PopOverWrapper, {
    dismissHandler: dismissHandler,
    isBrandingMarketplace: isBrandingMarketplace,
    customClass: "pressure-modal",
    children: [jsx("span", {
      className: classNames(styles$1h['text-label'], styles$1h.highlighted),
      children: labels.PRESSURE_LABEL_1
    }), jsx("span", {
      className: classNames(styles$1h['text-label'], styles$1h.banner),
      children: labels.PRESSURE_LABEL_2
    })]
  });
};
PressureModal.propTypes = {
  dismissHandler: PropTypes.func.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  notificationLife: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var SuccessModal = function SuccessModal(_ref3) {
  var dismissHandler = _ref3.dismissHandler,
    isBrandingMarketplace = _ref3.isBrandingMarketplace,
    notificationLife = _ref3.notificationLife;
  var labels = configs$3.labels;
  notificationTimeOut(dismissHandler, notificationLife);
  return jsx(PopOverWrapper, {
    dismissHandler: dismissHandler,
    customClass: "success-modal",
    isBrandingMarketplace: isBrandingMarketplace,
    children: jsxs("div", {
      className: classNames(styles$1h['success-message-parent'], styles$1h['justify-from-start']),
      children: [jsx("div", {
        className: styles$1h['sucess-icon-wrapper'],
        children: jsx("i", {
          className: classNames(styles$1h['icon-success'], _defineProperty({}, styles$1h.marketplace, isBrandingMarketplace))
        })
      }), jsxs("div", {
        className: styles$1h['sucess-message-wrapper'],
        children: [jsx("span", {
          className: classNames(styles$1h['text-label'], styles$1h.highlighted),
          children: labels.SUCCESS_LABEL_1
        }), jsx("span", {
          className: classNames(styles$1h['text-label'], styles$1h.banner),
          children: labels.SUCCESS_LABEL_2
        })]
      })]
    })
  });
};
SuccessModal.propTypes = {
  dismissHandler: PropTypes.func.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  notificationLife: PropTypes.number.isRequired
};
({
  dismissHandler: PropTypes.func.isRequired,
  selectedLocation: PropTypes.string.isRequired,
  handleZoneChangeClick: PropTypes.func.isRequired,
  keepTheLocation: PropTypes.func.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired
});
var ReminderModal = function ReminderModal(_ref5) {
  var dismissHandler = _ref5.dismissHandler,
    type = _ref5.type,
    isBrandingMarketplace = _ref5.isBrandingMarketplace,
    notificationLife = _ref5.notificationLife;
  var labels = configs$3.labels,
    constants = configs$3.constants;
  notificationTimeOut(dismissHandler, notificationLife);
  var label = '';
  switch (type) {
    case constants.REMINDER_MODAL_TYPE.USER_LOGGED_IN:
      label = labels.REMINDER_USER_LOGGED_IN;
      break;
    case constants.REMINDER_MODAL_TYPE.INACTIVE:
      label = labels.REMINDER_USER_INACTIVE;
      break;
    default:
      label = 'No se encontro el tipo de notificacion';
      break;
  }
  return jsx(PopOverWrapper, {
    dismissHandler: dismissHandler,
    isBrandingMarketplace: isBrandingMarketplace,
    customClass: "reminder-modal",
    children: jsx("span", {
      className: classNames(styles$1h['text-label'], styles$1h.banner),
      children: label
    })
  });
};
ReminderModal.propTypes = {
  dismissHandler: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  notificationLife: PropTypes.number.isRequired
};

function ownKeys$x(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$x(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$x(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$x(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var extendedApiEndpoints = _objectSpread$x(_objectSpread$x({}, apiEndpoints), {}, {
  getComunaDetailsWithOptions: function getComunaDetailsWithOptions(politicalId, tenant, baseUrl, store, options) {
    var url = apiEndpoints.getComunaDetails(politicalId, tenant, baseUrl, store);
    if (!options) return url;
    var separator = url.includes('?') ? '&' : '?';
    var cleanOptions = options.startsWith('?') || options.startsWith('&') ? options.substring(1) : options;
    return "".concat(url).concat(separator).concat(cleanOptions);
  }
});
var extendedApiEndpoints$1 = extendedApiEndpoints;

var BRAND_CONFIG$2 = {
  sodimac: {
    brand_color: '#0072CE',
    brand_logo: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt14d15984f6f1452f/64e7549caf6c4b79b52d16e5/sodimac.svg',
    url: '#'
  },
  so_retail: {
    brand_color: '#0072CE',
    brand_logo: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt14d15984f6f1452f/64e7549caf6c4b79b52d16e5/sodimac.svg',
    url: '#'
  },
  linio: {
    brand_color: '#C300A2',
    brand_logo: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blta14044007f618d7c/64e8d88912188b3ba0712710/linio.svg',
    url: '#'
  },
  tottus: {
    brand_color: '#64a70b',
    brand_logo: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt70c4281f902c5f79/64e8d8ceb62c6f29b2c3b030/tottus.svg',
    url: '#'
  },
  homecenter: {
    brand_color: '#0072CE',
    brand_logo: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt74c5ad167ce7b7bc/64e8cefe1ab3c32dd103db0a/homecenter.svg',
    url: '#'
  }
};
var MARKETPLACE_LOGO_URL_DESKTOP = 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltd26bd771774314af/626b07662bec9b34ea68a177/falabella-com-desktop.svg';
var MARKETPLACE_LOGO_URL_MOBILE = 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltdb9822fdc4aa9da6/626b0766d2794936634f916f/falabella-com-mobile.svg';
var WISHLIST_ICON_URL = 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt07f3d77814036772/65b24dcc41400c07fd457368/heart_desktop_grey.svg';
var CART_ICON_URL = 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt930de827842bd280/65b24e36568d54f35735c426/carritodesk.svg';
var CART_ICON_URL_MOBILE = 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt20b73fbfd5cbd218/65b25b56568d54479835c453/Mobile_Cart_new.svg';
var ZONE_ICON_URL = 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt12bfc7a09b55ab55/6538d0cfd31953c6b30dbd57/gray_geofinder.svg';

var styles$1e = {"embeddedWrapper":"EmbeddedModal-module_embeddedWrapper__-WIEJ","embeddedContent":"EmbeddedModal-module_embeddedContent__uTDjG"};

var EmbeddedModal = function EmbeddedModal(_ref) {
  var content = _ref.content;
  return jsx("div", {
    className: styles$1e.embeddedWrapper,
    children: jsx("div", {
      className: styles$1e.embeddedContent,
      children: content({
        close: function close() {},
        setCustomHeader: function setCustomHeader() {},
        setBusy: function setBusy() {}
      })
    })
  });
};
EmbeddedModal.propTypes = {
  content: PropTypes.func.isRequired
};
var EmbeddedModal$1 = EmbeddedModal;

function ownKeys$w(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$w(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$w(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$w(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ZoneModal = function ZoneModal(_ref) {
  var _deliveryOptions$type, _geofinderConfigs$not, _geofinderConfigs$not2, _entry$geofinder$geoF, _entry$geofinder, _entry$geofinder$url, _entry$geofinder2;
  var deviceType = _ref.deviceType,
    tenant = _ref.tenant,
    handleRouteChange = _ref.handleRouteChange,
    isBrandingMarketplace = _ref.isBrandingMarketplace,
    entry = _ref.entry,
    isModalVisible = _ref.modalVisible,
    setIsModalVisible = _ref.setModalVisible,
    isOnboardingInProgress = _ref.isOnboardingInProgress,
    isDefaultComuna = _ref.isDefaultComuna,
    selectedZone = _ref.selectedZone,
    isPopOverVisible = _ref.isPopOverVisible,
    stockEnTienda = _ref.stockEnTienda,
    deliveryOptions = _ref.deliveryOptions,
    isUserLoggedIn = _ref.isUserLoggedIn,
    isProgramaticallyGeofinderEnabled = _ref.isProgramaticallyGeofinderEnabled,
    _ref$geofinderConfigs = _ref.geofinderConfigs,
    geofinderConfigs = _ref$geofinderConfigs === void 0 ? {} : _ref$geofinderConfigs,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder,
    _ref$isSodimacStandAl = _ref.isSodimacStandAlone,
    isSodimacStandAlone = _ref$isSodimacStandAl === void 0 ? false : _ref$isSodimacStandAl,
    _ref$isOrangeOrSISHea = _ref.isOrangeOrSISHeader,
    isOrangeOrSISHeader = _ref$isOrangeOrSISHea === void 0 ? false : _ref$isOrangeOrSISHea,
    _ref$isSISLevel2Heade = _ref.isSISLevel2Header,
    isSISLevel2Header = _ref$isSISLevel2Heade === void 0 ? true : _ref$isSISLevel2Heade,
    store = _ref.store,
    isTottusStandAlone = _ref.isTottusStandAlone,
    baseUrl = _ref.baseUrl,
    setShowLoginForm = _ref.setShowLoginForm,
    getStockEnTiendaData = _ref.getStockEnTiendaData,
    getDeliveryEstimatesV2Data = _ref.getDeliveryEstimatesV2Data,
    setZoneConfig = _ref.setZoneConfig,
    isError = _ref.isError,
    setScreen = _ref.setScreen,
    isPostalCodeEnabled = _ref.isPostalCodeEnabled,
    isCambiar = _ref.isCambiar;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    regions = _useState2[0],
    setRegions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    comunas = _useState4[0],
    setComunas = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    provinces = _useState6[0],
    setProvinces = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedRegion = _useState8[0],
    setSelectedRegion = _useState8[1];
  var _useState9 = useState(undefined),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedComuna = _useState0[0],
    setSelectedComuna = _useState0[1];
  var _useState1 = useState(undefined),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedProvince = _useState10[0],
    setSelectedProvince = _useState10[1];
  var _useState11 = useState(undefined),
    _useState12 = _slicedToArray(_useState11, 2),
    savedRegion = _useState12[0],
    setSavedRegion = _useState12[1];
  var _useState13 = useState(undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    savedComuna = _useState14[0],
    setSavedComuna = _useState14[1];
  var _useState15 = useState(undefined),
    _useState16 = _slicedToArray(_useState15, 2),
    savedProvince = _useState16[0],
    setSavedProvince = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    popOvervisible = _useState18[0],
    setPopOverVisible = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    modalVisible = _useState20[0],
    setModalVisible = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    regionInputValue = _useState22[0],
    setRegionInputValue = _useState22[1];
  var _useState23 = useState(''),
    _useState24 = _slicedToArray(_useState23, 2),
    comunaInputValue = _useState24[0],
    setComunaInputValue = _useState24[1];
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    provinceInputValue = _useState26[0],
    setProvinceInputValue = _useState26[1];
  var _useState27 = useState(''),
    _useState28 = _slicedToArray(_useState27, 2),
    postalCodeInputValue = _useState28[0],
    setPostalCodeInputValue = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2);
    _useState30[0];
    var setPostalCodeDetails = _useState30[1];
  var _useState31 = useState(true),
    _useState32 = _slicedToArray(_useState31, 2),
    postalCodeStatus = _useState32[0],
    setPostalCodeStatus = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    isSettingFromPostal = _useState34[0],
    setIsSettingFromPostal = _useState34[1];
  var _useState35 = useState(''),
    _useState36 = _slicedToArray(_useState35, 2),
    popModalType = _useState36[0],
    setPopModal = _useState36[1];
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    zoneSession = _useState38[0],
    setZoneSession = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    showSuccessModal = _useState40[0],
    setSuccessModal = _useState40[1];
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    showReminderModal = _useState42[0],
    setShowReminderModal = _useState42[1];
  var _useState43 = useState(null),
    _useState44 = _slicedToArray(_useState43, 2),
    reminderModalType = _useState44[0],
    setReminderModalType = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    isErrorNotification = _useState46[0],
    setErrorNotification = _useState46[1];
  var _useState47 = useState(true),
    _useState48 = _slicedToArray(_useState47, 2),
    isPostalActive = _useState48[0],
    setPostalActive = _useState48[1];
  var _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    isPostalExist = _useState50[0],
    setPostalExist = _useState50[1];
  var _useState51 = useState('floatBottomTransition'),
    _useState52 = _slicedToArray(_useState51, 2),
    mobileModalClass = _useState52[0],
    setMobileModalClass = _useState52[1];
  var isSodimacRe = isSodimacRetail$1(store);
  var _useState53 = useState({
      addressLine1: '',
      addressLine2: '',
      landmark: '',
      latitude: '',
      longitude: '',
      zones: []
    }),
    _useState54 = _slicedToArray(_useState53, 2),
    addressLinesData = _useState54[0],
    setAddressLinesData = _useState54[1];
  var _useState55 = useState(undefined),
    _useState56 = _slicedToArray(_useState55, 2),
    savedAddressLinesData = _useState56[0],
    setSavedAddressLinesData = _useState56[1];
  var labels = configs$3.labels,
    constants = configs$3.constants,
    DEFAULT_ZONES_VALUE = configs$3.DEFAULT_ZONES_VALUE;
  var isStockEnTiendaModal = !!Object.keys(stockEnTienda).length;
  var isDeliveryOptionsModal = !isEmpty(deliveryOptions);
  var isNewDeliveryOptionModal = isStockEnTiendaModal || isDeliveryOptionsModal;
  var isPickupInStore = ((_deliveryOptions$type = deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.type) !== null && _deliveryOptions$type !== void 0 ? _deliveryOptions$type : '') === constants.PICKUP_IN_STORE;
  var _useState57 = useState(false),
    _useState58 = _slicedToArray(_useState57, 2),
    enableEnter = _useState58[0],
    setEnableEnter = _useState58[1];
  var _useState59 = useState(false),
    _useState60 = _slicedToArray(_useState59, 2),
    pressureModalInteractionSession = _useState60[0],
    setPressureModalInteractionSession = _useState60[1];
  var notificationInactiveSession = (_geofinderConfigs$not = geofinderConfigs === null || geofinderConfigs === void 0 ? void 0 : geofinderConfigs.notification_inactive_session) !== null && _geofinderConfigs$not !== void 0 ? _geofinderConfigs$not : 12;
  var notificationLife = (_geofinderConfigs$not2 = geofinderConfigs === null || geofinderConfigs === void 0 ? void 0 : geofinderConfigs.notification_life) !== null && _geofinderConfigs$not2 !== void 0 ? _geofinderConfigs$not2 : 10000;
  var timer;
  var geoFinderIconMap = {
    desktop: 'icon_desktop',
    mobile: 'icon_mobile',
    tablet: 'icon_mobile'
  };
  var geoFinderIconURL = (_entry$geofinder$geoF = entry === null || entry === void 0 || (_entry$geofinder = entry.geofinder) === null || _entry$geofinder === void 0 || (_entry$geofinder = _entry$geofinder[geoFinderIconMap[deviceType]]) === null || _entry$geofinder === void 0 ? void 0 : _entry$geofinder.url) !== null && _entry$geofinder$geoF !== void 0 ? _entry$geofinder$geoF : '';
  var grayHeadergeoFinderIconURL = (_entry$geofinder$url = entry === null || entry === void 0 || (_entry$geofinder2 = entry.geofinder) === null || _entry$geofinder2 === void 0 || (_entry$geofinder2 = _entry$geofinder2["gray_".concat(geoFinderIconMap[deviceType])]) === null || _entry$geofinder2 === void 0 ? void 0 : _entry$geofinder2.url) !== null && _entry$geofinder$url !== void 0 ? _entry$geofinder$url : ZONE_ICON_URL;
  var cookieSetHelper = function cookieSetHelper(name, value) {
    CookieStorage$1.setCookie({
      name: name,
      value: value,
      regionCode: tenant
    });
  };
  var getSelectedOption = function getSelectedOption(list, key, opt) {
    var selectedOption = list.find(function (item) {
      return item[key].toLowerCase() === opt.toLowerCase();
    });
    selectedOption = capitalizeSelectedOption(selectedOption);
    return selectedOption;
  };
  var resetComuna = function resetComuna() {
    setComunas([]);
    setComunaInputValue('');
    setSelectedComuna('');
    setAddressLinesData({
      addressLine1: '',
      addressLine2: '',
      landmark: '',
      latitude: '',
      longitude: ''
    });
  };
  var resetPostalCode = function resetPostalCode() {
    setPostalCodeInputValue('');
  };
  var resetProvince = function resetProvince() {
    setProvinces([]);
    setProvinceInputValue('');
    setSelectedProvince('');
  };
  var getZoneOptions = isTottusStandAlone && 'getAllZones=true';
  var updateProvince = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(politicalId, provId) {
      var _response$data;
      var keyProvince,
        response,
        list,
        mutatedList,
        selectedProv,
        _args = arguments;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            keyProvince = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'id';
            _context.next = 1;
            return doFetch(apiEndpoints.getProvinceList(politicalId, tenant, baseUrl, store), {}, {
              triggerOnResponseError: true,
              triggerOnNetworkError: true
            });
          case 1:
            response = _context.sent;
            list = (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : [];
            mutatedList = list;
            try {
              mutatedList = capitalizeList(list);
              setProvinces(mutatedList);
            } catch (e) {
              setProvinces(list);
            }
            if (provId) {
              selectedProv = getSelectedOption(mutatedList, keyProvince, provId);
              setProvinceInputValue(selectedProv.name);
              setSavedProvince(selectedProv);
            }
            return _context.abrupt("return", mutatedList);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function updateProvince(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var updateComuna = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(politicalId, comId) {
      var keyComuna,
        list,
        response,
        mutatedList,
        selectedCom,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            keyComuna = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 'id';
            list = [];
            if (!politicalId) {
              _context2.next = 2;
              break;
            }
            _context2.next = 1;
            return doFetch(apiEndpoints.getCitylist(politicalId, tenant, baseUrl, store), {}, {
              triggerOnResponseError: true,
              triggerOnNetworkError: true
            });
          case 1:
            response = _context2.sent;
            list = response && response.data ? response.data : [];
            try {
              mutatedList = capitalizeList(list);
              setComunas(mutatedList);
            } catch (e) {
              setComunas(list);
            }
          case 2:
            if (!comId) {
              _context2.next = 3;
              break;
            }
            selectedCom = getSelectedOption(list, keyComuna, comId);
            setComunaInputValue(selectedCom.name);
            setSavedComuna(selectedCom);
            return _context2.abrupt("return", selectedCom);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function updateComuna(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getFromLocalStorage = function getFromLocalStorage(keyName) {
    var keyValue = WebStorage$1.getItem({
      name: keyName,
      fromPersistence: true
    });
    return keyValue && JSON.parse(keyValue) ? JSON.parse(keyValue) : undefined;
  };
  var updateDistrict = function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(politicalId, countyPoliticalId, disId) {
      var _response$data2;
      var keyDistrict,
        response,
        list,
        mutatedList,
        selectedCom,
        _args3 = arguments;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            keyDistrict = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : 'id';
            _context3.next = 1;
            return doFetch(apiEndpoints.getDistrictList(politicalId, countyPoliticalId, tenant, baseUrl, store), {}, {
              triggerOnResponseError: true,
              triggerOnNetworkError: true
            });
          case 1:
            response = _context3.sent;
            list = (_response$data2 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data2 !== void 0 ? _response$data2 : [];
            _context3.prev = 2;
            mutatedList = capitalizeList(list);
            setComunas(mutatedList);
            if (!isSodimacRe) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return", mutatedList);
          case 3:
            _context3.next = 5;
            break;
          case 4:
            _context3.prev = 4;
            _context3["catch"](2);
            setComunas(list);
          case 5:
            if (!disId) {
              _context3.next = 6;
              break;
            }
            selectedCom = getSelectedOption(list, keyDistrict, disId);
            setComunaInputValue(selectedCom.name);
            setSavedComuna(selectedCom);
            return _context3.abrupt("return", selectedCom);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 4]]);
    }));
    return function updateDistrict(_x5, _x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
  var setToLocalStorage = function setToLocalStorage(name, value) {
    var isString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (value) {
      var data = isString ? value : JSON.stringify(value);
      WebStorage$1.setItem({
        name: name,
        value: data,
        shouldPersist: true
      });
    }
  };
  var fetchSavedZoneDetails = function () {
    var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4() {
      var region, comuna, province, addressLines, addressLine1, addressLine2, landmark, longitude, latitude, USER_ZONE, POLITICAL_ID, REG_ID, COM_ID, PROV_ID, ADDRESS_LINES, isUserZone, politicalIdCookie, addressLineCookie, _addressLineCookie$sp, _addressLineCookie$sp2, getRegionDetailsFromComuna, getProvinceDetailsFromComuna, saveDistrictAPIresponse, _addressLines, _addressLines2, _addressLines3, _addressLines4, _addressLines5, notValidZones, response, savedZoneInfo;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            USER_ZONE = constants.USER_ZONE, POLITICAL_ID = constants.POLITICAL_ID, REG_ID = constants.REG_ID, COM_ID = constants.COM_ID, PROV_ID = constants.PROV_ID, ADDRESS_LINES = constants.ADDRESS_LINES;
            isUserZone = CookieStorage$1.getCookie(USER_ZONE) === 'userselected';
            politicalIdCookie = CookieStorage$1.getCookie(POLITICAL_ID);
            addressLineCookie = decodeURIComponent(CookieStorage$1.getCookie(ADDRESS_LINES)) || '';
            if (isTottusStandAlone) {
              _addressLineCookie$sp = addressLineCookie.split('*');
              _addressLineCookie$sp2 = _slicedToArray(_addressLineCookie$sp, 5);
              addressLine1 = _addressLineCookie$sp2[0];
              addressLine2 = _addressLineCookie$sp2[1];
              landmark = _addressLineCookie$sp2[2];
              latitude = _addressLineCookie$sp2[3];
              longitude = _addressLineCookie$sp2[4];
            }
            getRegionDetailsFromComuna = function getRegionDetailsFromComuna(cmna) {
              return {
                politicalId: cmna.parentStateId,
                name: cmna.parentStateName
              };
            };
            getProvinceDetailsFromComuna = function getProvinceDetailsFromComuna(cmna) {
              return {
                politicalId: cmna.parentPoliticalId,
                name: cmna.parentCountyName
              };
            };
            saveDistrictAPIresponse = function saveDistrictAPIresponse(apiData) {
              region = getRegionDetailsFromComuna(apiData);
              comuna = _objectSpread$w({}, apiData);
              if (!isPickupInStore && !isStockEnTiendaModal) {
                setToLocalStorage(REG_ID, region);
                setToLocalStorage(COM_ID, comuna);
                setToLocalStorage(ADDRESS_LINES, addressLinesData);
              }
              if (tenant !== 'cl') {
                province = getProvinceDetailsFromComuna(apiData);
                if (!isPickupInStore && !isStockEnTiendaModal) {
                  setToLocalStorage(PROV_ID, province);
                }
              }
            };
            if (selectedZone) {
              saveDistrictAPIresponse(selectedZone);
            } else {
              region = getFromLocalStorage(REG_ID);
              comuna = getFromLocalStorage(COM_ID);
              province = getFromLocalStorage(PROV_ID);
              addressLines = getFromLocalStorage(ADDRESS_LINES);
            }
            if (!addressLineCookie) {
              addressLines = getFromLocalStorage(ADDRESS_LINES);
              addressLine1 = (_addressLines = addressLines) === null || _addressLines === void 0 ? void 0 : _addressLines.addressLine1;
              addressLine2 = (_addressLines2 = addressLines) === null || _addressLines2 === void 0 ? void 0 : _addressLines2.addressLine2;
              landmark = (_addressLines3 = addressLines) === null || _addressLines3 === void 0 ? void 0 : _addressLines3.landmark;
              latitude = (_addressLines4 = addressLines) === null || _addressLines4 === void 0 ? void 0 : _addressLines4.latitude;
              longitude = (_addressLines5 = addressLines) === null || _addressLines5 === void 0 ? void 0 : _addressLines5.longitude;
            }
            if (!(isPickupInStore || isStockEnTiendaModal)) {
              _context4.next = 1;
              break;
            }
            return _context4.abrupt("return", {
              region: region,
              comuna: comuna,
              province: province
            });
          case 1:
            notValidZones = tenant !== 'cl' ? !region && !province && !comuna : !region && !comuna;
            if (!(notValidZones && isUserZone && politicalIdCookie || comuna && comuna.politicalId !== politicalIdCookie)) {
              _context4.next = 3;
              break;
            }
            _context4.next = 2;
            return doFetch("".concat(apiEndpoints.getComunaDetails(politicalIdCookie, tenant, baseUrl, store)));
          case 2:
            response = _context4.sent;
            savedZoneInfo = response === null || response === void 0 ? void 0 : response.data;
            if (savedZoneInfo && !response["default"]) {
              saveDistrictAPIresponse(savedZoneInfo);
            }
          case 3:
            return _context4.abrupt("return", {
              region: region,
              comuna: comuna,
              province: province,
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              landmark: landmark,
              latitude: latitude,
              longitude: longitude
            });
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function fetchSavedZoneDetails() {
      return _ref5.apply(this, arguments);
    };
  }();
  var registerUserLastSession = function registerUserLastSession() {
    setToLocalStorage(constants.USER_LAST_SESSION, new Date());
  };
  var geoFinderLastSession = function geoFinderLastSession(isZoneSelected) {
    var lastSessionString = getFromLocalStorage(constants.USER_LAST_SESSION);
    var lastSession = new Date(lastSessionString).getTime();
    var now = new Date().getTime();
    var inactiveSessionTime = Number(notificationInactiveSession);
    var showAgain = inactiveSessionTime * 60 * 60 * 1000;
    var userInactivity = now - lastSession;
    if (userInactivity > showAgain && isZoneSelected) {
      setReminderModalType(constants.REMINDER_MODAL_TYPE.INACTIVE);
      setShowReminderModal(true);
    }
    registerUserLastSession();
  };
  var getSavedZone = function () {
    var _ref6 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee5() {
      var initLoad,
        IS_PRESSURE_MODAL_INTERACTED,
        USER_ZONE,
        isDefaultZone,
        _yield$fetchSavedZone,
        region,
        comuna,
        province,
        addressLine1,
        addressLine2,
        landmark,
        latitude,
        longitude,
        IS_ZONE_SELECTED,
        _args5 = arguments;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            initLoad = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
            IS_PRESSURE_MODAL_INTERACTED = CookieStorage$1.getCookie(constants.IS_PRESSURE_MODAL_INTERACTED);
            setPressureModalInteractionSession(IS_PRESSURE_MODAL_INTERACTED === 'true');
            if (initLoad) {
              setPopModal('pressure');
              setPopOverVisible(true);
            }
            USER_ZONE = constants.USER_ZONE;
            isDefaultZone = CookieStorage$1.getCookie(USER_ZONE) === 'defaultZone';
            if (!(isDefaultComuna || isDefaultZone && !selectedZone)) {
              _context5.next = 1;
              break;
            }
            return _context5.abrupt("return");
          case 1:
            _context5.next = 2;
            return fetchSavedZoneDetails();
          case 2:
            _yield$fetchSavedZone = _context5.sent;
            region = _yield$fetchSavedZone.region;
            comuna = _yield$fetchSavedZone.comuna;
            province = _yield$fetchSavedZone.province;
            addressLine1 = _yield$fetchSavedZone.addressLine1;
            addressLine2 = _yield$fetchSavedZone.addressLine2;
            landmark = _yield$fetchSavedZone.landmark;
            latitude = _yield$fetchSavedZone.latitude;
            longitude = _yield$fetchSavedZone.longitude;
            IS_ZONE_SELECTED = CookieStorage$1.getCookie(constants.IS_ZONE_SELECTED);
            setZoneSession(IS_ZONE_SELECTED === 'true');
            if (region && !isEmpty(region) && typeof region !== 'string') {
              region = capitalizeSelectedOption(region);
              setRegionInputValue(region.name);
              setSavedRegion(region);
              if (tenant !== 'cl') {
                updateProvince(region.politicalId);
              } else {
                updateComuna(region.politicalId);
              }
            }
            setSavedAddressLinesData({
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              landmark: landmark,
              latitude: latitude || (selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude) || (savedComuna === null || savedComuna === void 0 ? void 0 : savedComuna.latitude) || '',
              longitude: longitude || (selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude) || (savedComuna === null || savedComuna === void 0 ? void 0 : savedComuna.longitude) || ''
            });
            setAddressLinesData({
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              landmark: landmark,
              latitude: latitude || (selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude) || (savedComuna === null || savedComuna === void 0 ? void 0 : savedComuna.latitude) || '',
              longitude: longitude || (selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude) || (savedComuna === null || savedComuna === void 0 ? void 0 : savedComuna.longitude) || ''
            });
            if (tenant !== 'cl' && province && !isEmpty(province) && typeof province !== 'string') {
              province = capitalizeSelectedOption(province);
              setProvinceInputValue(province.name);
              setSavedProvince(province);
              updateDistrict(region.politicalId, province.politicalId);
            }
            if (comuna && !isEmpty(comuna) && typeof comuna !== 'string') {
              comuna = capitalizeSelectedOption(comuna);
              setComunaInputValue(comuna.name);
              setSavedComuna(comuna);
            }
            if (initLoad) {
              geoFinderLastSession(IS_ZONE_SELECTED === 'true');
            }
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getSavedZone() {
      return _ref6.apply(this, arguments);
    };
  }();
  var resetOnModalClose = function resetOnModalClose() {
    setRegionInputValue('');
    setSelectedRegion(undefined);
    resetComuna();
    resetProvince();
    resetPostalCode();
  };
  var resetSavedDetails = function resetSavedDetails() {
    setSavedRegion(undefined);
    setSavedComuna(undefined);
    setSavedProvince(undefined);
    setSavedAddressLinesData(undefined);
  };
  var getRegionList = function () {
    var _ref7 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee6() {
      var response, list, mutatedList;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 1;
            return doFetch(apiEndpoints.getRegion(tenant, baseUrl, store), {}, {
              triggerOnResponseError: true,
              triggerOnNetworkError: true
            });
          case 1:
            response = _context6.sent;
            list = response && response.data ? response.data : [];
            _context6.prev = 2;
            mutatedList = capitalizeList(list);
            setRegions(mutatedList);
            return _context6.abrupt("return", mutatedList);
          case 3:
            _context6.prev = 3;
            _context6["catch"](2);
            setRegions(list);
            return _context6.abrupt("return", list);
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 3]]);
    }));
    return function getRegionList() {
      return _ref7.apply(this, arguments);
    };
  }();
  var setRegionAndProvinceInputs = function setRegionAndProvinceInputs(list) {
    var _list$, _list$2;
    setRegionInputValue(capitalizeWord(((_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.parentStateName) || ''));
    setProvinceInputValue(capitalizeWord(((_list$2 = list[0]) === null || _list$2 === void 0 ? void 0 : _list$2.parentCountyName) || ''));
  };
  var findRegionFromList = function findRegionFromList(fetchedRegions, list) {
    var _list$3;
    var regionNameU = (((_list$3 = list[0]) === null || _list$3 === void 0 ? void 0 : _list$3.parentStateName) || '').toUpperCase();
    return fetchedRegions === null || fetchedRegions === void 0 ? void 0 : fetchedRegions.find(function (reg) {
      var _reg$name;
      return (reg === null || reg === void 0 || (_reg$name = reg.name) === null || _reg$name === void 0 ? void 0 : _reg$name.toUpperCase()) === regionNameU;
    });
  };
  var setSelectedRegionAndProvince = function () {
    var _ref8 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee7(list) {
      var _list$4, _list$5;
      var fetchedRegions, region, provinceList, selectedProv;
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 1;
            return getRegionList();
          case 1:
            fetchedRegions = _context7.sent;
            region = findRegionFromList(fetchedRegions, list);
            setSelectedRegion(region);
            _context7.next = 2;
            return updateProvince(((_list$4 = list[0]) === null || _list$4 === void 0 ? void 0 : _list$4.parentStateId) || '');
          case 2:
            provinceList = _context7.sent;
            selectedProv = getSelectedOption(provinceList, 'name', ((_list$5 = list[0]) === null || _list$5 === void 0 ? void 0 : _list$5.parentCountyName) || '');
            setSelectedProvince(selectedProv);
            return _context7.abrupt("return", {
              selectedProv: selectedProv
            });
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function setSelectedRegionAndProvince(_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
  var findComunaByName = function findComunaByName(array, searchName) {
    return array.find(function (c) {
      var _c$name;
      return ((_c$name = c.name) === null || _c$name === void 0 ? void 0 : _c$name.toLowerCase()) === (searchName === null || searchName === void 0 ? void 0 : searchName.toLowerCase());
    }) || array[0];
  };
  var setSelectedComunaAndInput = function () {
    var _ref9 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee8(list, selectedProv) {
      var _list$6, _list$7;
      var searchName, selectedCom, comuna;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            searchName = (_list$6 = list[0]) === null || _list$6 === void 0 ? void 0 : _list$6.name;
            _context8.next = 1;
            return updateDistrict((_list$7 = list[0]) === null || _list$7 === void 0 ? void 0 : _list$7.parentStateId, selectedProv === null || selectedProv === void 0 ? void 0 : selectedProv.politicalId, searchName, 'name');
          case 1:
            selectedCom = _context8.sent;
            if (selectedCom) {
              _context8.next = 2;
              break;
            }
            return _context8.abrupt("return");
          case 2:
            comuna = Array.isArray(selectedCom) ? findComunaByName(selectedCom, searchName) : selectedCom;
            setSelectedComuna(comuna);
            setComunaInputValue(capitalizeWord(comuna === null || comuna === void 0 ? void 0 : comuna.name));
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function setSelectedComunaAndInput(_x9, _x0) {
      return _ref9.apply(this, arguments);
    };
  }();
  var updateLocationFromPostalCode = function () {
    var _ref0 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee9(list) {
      var _yield$setSelectedReg, selectedProv;
      return _regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            setRegionAndProvinceInputs(list);
            _context9.next = 1;
            return setSelectedRegionAndProvince(list);
          case 1:
            _yield$setSelectedReg = _context9.sent;
            selectedProv = _yield$setSelectedReg.selectedProv;
            _context9.next = 2;
            return setSelectedComunaAndInput(list, selectedProv);
          case 2:
            setIsSettingFromPostal(false);
          case 3:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function updateLocationFromPostalCode(_x1) {
      return _ref0.apply(this, arguments);
    };
  }();
  var setPostalWarning = function setPostalWarning(value) {
    setErrorNotification(value);
  };
  var getPostalCodeDetails = function () {
    var _ref1 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee0() {
      var response, list, filteredList;
      return _regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            if (!(postalCodeInputValue.length < 5)) {
              _context0.next = 1;
              break;
            }
            setPostalCodeStatus(true);
            setPostalWarning(false);
            return _context0.abrupt("return");
          case 1:
            _context0.next = 2;
            return doFetch(apiEndpoints.getPostalCodeDetails(postalCodeInputValue, tenant, baseUrl, store), {}, {
              data: geoFallbacks.postalCode[tenant],
              triggerOnResponseError: true,
              triggerOnNetworkError: true
            });
          case 2:
            response = _context0.sent;
            list = response && response.data ? response.data : [];
            _context0.prev = 3;
            if (list.length) {
              _context0.next = 4;
              break;
            }
            setPostalCodeStatus(false);
            setPostalExist(false);
            setPostalActive(false);
            return _context0.abrupt("return");
          case 4:
            filteredList = list.filter(function (district) {
              return district.active;
            });
            if (!(filteredList.length > 0)) {
              _context0.next = 6;
              break;
            }
            setPostalActive(true);
            setPostalExist(true);
            setPostalCodeDetails(filteredList);
            setIsSettingFromPostal(true);
            _context0.next = 5;
            return updateLocationFromPostalCode(filteredList);
          case 5:
            _context0.next = 7;
            break;
          case 6:
            setPostalCodeStatus(false);
            setPostalActive(false);
            setPostalExist(true);
          case 7:
            _context0.next = 9;
            break;
          case 8:
            _context0.prev = 8;
            _context0["catch"](3);
            setPostalCodeDetails(list);
          case 9:
          case "end":
            return _context0.stop();
        }
      }, _callee0, null, [[3, 8]]);
    }));
    return function getPostalCodeDetails() {
      return _ref1.apply(this, arguments);
    };
  }();
  useEffect(function () {
    getPostalCodeDetails();
  }, [postalCodeInputValue, isErrorNotification]);
  var regionChangeHandler = function () {
    var _ref10 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee1(opt) {
      var selectedReg;
      return _regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            if (opt) {
              _context1.next = 1;
              break;
            }
            resetOnModalClose();
            return _context1.abrupt("return");
          case 1:
            selectedReg = getSelectedOption(regions, 'name', opt);
            setSelectedRegion(selectedReg);
            setRegionInputValue(opt);
            setEnableEnter(false);
          case 2:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
    return function regionChangeHandler(_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
  var provinceChangeHandler = function () {
    var _ref11 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee10(opt) {
      var selectedProv;
      return _regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (opt) {
              _context10.next = 1;
              break;
            }
            setProvinceInputValue('');
            setSelectedProvince(undefined);
            resetComuna();
            return _context10.abrupt("return");
          case 1:
            selectedProv = getSelectedOption(provinces, 'name', opt);
            setSelectedProvince(selectedProv);
            setProvinceInputValue(opt);
            setEnableEnter(false);
          case 2:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function provinceChangeHandler(_x11) {
      return _ref11.apply(this, arguments);
    };
  }();
  var getZoneIDAndName = function getZoneIDAndName(zones, currentZoneName) {
    var zoneID;
    var zoneName;
    try {
      zoneID = zones.find(function (z) {
        return z;
      });
      zoneName = currentZoneName;
    } catch (error) {
      var _zones$slice = zones.slice(-1),
        _zones$slice2 = _slicedToArray(_zones$slice, 1),
        newZoneID = _zones$slice2[0];
      zoneID = newZoneID;
      zoneName = currentZoneName;
    }
    if (!zoneID) {
      var _zones$slice3 = zones.slice(-1),
        _zones$slice4 = _slicedToArray(_zones$slice3, 1),
        _newZoneID = _zones$slice4[0];
      zoneID = _newZoneID;
      zoneName = currentZoneName;
    }
    return {
      zoneID: zoneID,
      zoneName: zoneName
    };
  };
  var getInitialZonesDetailsForEvent = function getInitialZonesDetailsForEvent() {
    var zonesInfo = CookieStorage$1.getCookie(constants.ZONES);
    var politicalIdInfo = CookieStorage$1.getCookie(constants.POLITICAL_ID);
    var priceGroupIdInfo = CookieStorage$1.getCookie(constants.PRICE_GROUP_ID);
    var zonesList = CookieStorage$1.getCookie(constants.ZONES_LIST);
    var environment = getEnvironment() || 'production';
    if (zonesInfo && politicalIdInfo && priceGroupIdInfo && zonesList) {
      try {
        return new Promise(function (resolve) {
          resolve(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, constants.ZONES, JSON.parse(zonesInfo).join(',')), constants.POLITICAL_ID, politicalIdInfo), constants.PRICE_GROUP_ID, priceGroupIdInfo), constants.ZONES_LIST, zonesList));
        });
      } catch (error) {
        return new Promise(function (resolve) {
          var _DEFAULT_ZONES_VALUE$, _DEFAULT_ZONES_VALUE$2;
          resolve((_DEFAULT_ZONES_VALUE$ = DEFAULT_ZONES_VALUE === null || DEFAULT_ZONES_VALUE === void 0 || (_DEFAULT_ZONES_VALUE$2 = DEFAULT_ZONES_VALUE[environment]) === null || _DEFAULT_ZONES_VALUE$2 === void 0 ? void 0 : _DEFAULT_ZONES_VALUE$2[tenant]) !== null && _DEFAULT_ZONES_VALUE$ !== void 0 ? _DEFAULT_ZONES_VALUE$ : DEFAULT_ZONES_VALUE.production.cl);
        });
      }
    }
    return new Promise(function (resolve) {
      var _DEFAULT_ZONES_VALUE$3, _DEFAULT_ZONES_VALUE$4;
      resolve((_DEFAULT_ZONES_VALUE$3 = DEFAULT_ZONES_VALUE === null || DEFAULT_ZONES_VALUE === void 0 || (_DEFAULT_ZONES_VALUE$4 = DEFAULT_ZONES_VALUE[environment]) === null || _DEFAULT_ZONES_VALUE$4 === void 0 ? void 0 : _DEFAULT_ZONES_VALUE$4[tenant]) !== null && _DEFAULT_ZONES_VALUE$3 !== void 0 ? _DEFAULT_ZONES_VALUE$3 : DEFAULT_ZONES_VALUE.production.cl);
    });
  };
  var triggerComunaEvent = function () {
    var _ref12 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee11() {
      var zones,
        politicalId,
        priceGroupId,
        comunaDetails,
        comunaEvent,
        _args11 = arguments;
      return _regeneratorRuntime.wrap(function (_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            zones = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : '';
            politicalId = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : '';
            priceGroupId = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : '';
            comunaDetails = {};
            if (!(zones && politicalId && priceGroupId)) {
              _context11.next = 1;
              break;
            }
            comunaDetails = _defineProperty(_defineProperty(_defineProperty({}, constants.ZONES, JSON.parse(JSON.stringify(zones)).join(',')), constants.POLITICAL_ID, politicalId), constants.PRICE_GROUP_ID, priceGroupId);
            _context11.next = 3;
            break;
          case 1:
            _context11.next = 2;
            return getInitialZonesDetailsForEvent();
          case 2:
            comunaDetails = _context11.sent;
          case 3:
            comunaEvent = new CustomEvent('COMUNAHASPOPULATED', {
              detail: comunaDetails
            });
            window.dispatchEvent(comunaEvent);
          case 4:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function triggerComunaEvent() {
      return _ref12.apply(this, arguments);
    };
  }();
  var saveComunaDetails = function () {
    var _ref13 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee12(cmna) {
      var zones, currentZoneName, priceGroupId, politicalId, latitude, longitude, _getZoneIDAndName, zoneID, zoneName;
      return _regeneratorRuntime.wrap(function (_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            zones = cmna.zones, currentZoneName = cmna.name, priceGroupId = cmna.priceGroupId, politicalId = cmna.politicalId, latitude = cmna.latitude, longitude = cmna.longitude;
            _getZoneIDAndName = getZoneIDAndName(zones, currentZoneName), zoneID = _getZoneIDAndName.zoneID, zoneName = _getZoneIDAndName.zoneName;
            cookieSetHelper(constants.POLITICAL_ID, politicalId);
            cookieSetHelper(constants.PRICE_GROUP_ID, priceGroupId);
            cookieSetHelper(constants.ZONE_DATA, {
              zoneID: zoneID,
              zoneName: zoneName
            });
            cookieSetHelper(constants.USER_ZONE, 'userselected');
            if (!isTottusStandAlone) {
              cookieSetHelper(constants.ZONES, JSON.stringify(zones));
              cookieSetHelper(constants.ADDRESS_LINES, "***".concat(latitude, "*").concat(longitude));
            }
            triggerComunaEvent(zones, politicalId, priceGroupId);
          case 1:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function saveComunaDetails(_x12) {
      return _ref13.apply(this, arguments);
    };
  }();
  var checkForError = function checkForError() {
    var HomeDelivery = isError.HomeDelivery,
      PickupInStore = isError.PickupInStore,
      StockInStore = isError.StockInStore;
    return HomeDelivery.isError && PickupInStore.isError && StockInStore.isError;
  };
  var saveZone = function () {
    var _ref14 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee13(tottusComuna) {
      var hasError, comunaToSave, animationTimer, virtualZones, selectedZoneValidation;
      return _regeneratorRuntime.wrap(function (_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            hasError = isError && checkForError();
            if (!hasError) {
              _context13.next = 1;
              break;
            }
            setScreen('screen3');
            return _context13.abrupt("return");
          case 1:
            if (isDeliveryOptionsModal || isStockEnTiendaModal) {
              if (setZoneConfig && setZoneConfig instanceof Function) {
                setZoneConfig({
                  region: selectedRegion || savedRegion,
                  comuna: selectedComuna || savedComuna
                });
              }
            }
            setToLocalStorage(constants.REG_ID, selectedRegion || savedRegion);
            setToLocalStorage(constants.COM_ID, selectedComuna || savedComuna);
            if (tenant !== 'cl') {
              setToLocalStorage(constants.PROV_ID, selectedProvince || savedProvince);
            }
            cookieSetHelper(constants.IS_ZONE_SELECTED, 'true');
            if (!isStockEnTiendaModal && !isDeliveryOptionsModal) {
              if (deviceType === 'desktop') {
                if (isBrandingMarketplace) {
                  setIsModalVisible(false);
                } else {
                  setModalVisible(false);
                }
              } else {
                setMobileModalClass('floatBottomEndTransition');
                animationTimer = setTimeout(function () {
                  if (isBrandingMarketplace) {
                    setIsModalVisible(false);
                  } else {
                    setModalVisible(false);
                  }
                  clearTimeout(animationTimer);
                }, constants.MODAL_CLOSE_TIME);
              }
            }
            if (selectedRegion) {
              setSavedRegion(selectedRegion);
            }
            if (tenant !== 'cl' && selectedProvince) {
              setSavedProvince(selectedProvince);
            }
            if (!selectedComuna) {
              _context13.next = 4;
              break;
            }
            comunaToSave = selectedComuna;
            if (!isSodimacRe) {
              _context13.next = 3;
              break;
            }
            _context13.next = 2;
            return getVirtualZones$1({
              tenant: tenant,
              politicalId: selectedComuna.politicalId
            });
          case 2:
            virtualZones = _context13.sent;
            comunaToSave = _objectSpread$w(_objectSpread$w({}, selectedComuna), {}, {
              zones: virtualZones === null || virtualZones === void 0 ? void 0 : virtualZones.data
            });
            setToLocalStorage(constants.COM_ID, comunaToSave);
          case 3:
            setSavedComuna(comunaToSave);
            saveComunaDetails(comunaToSave);
          case 4:
            selectedZoneValidation = tenant !== 'cl' ? selectedComuna || selectedProvince || selectedRegion : selectedComuna || selectedRegion;
            if (isTottusStandAlone && tottusComuna) {
              setSavedComuna(tottusComuna);
              saveComunaDetails(tottusComuna);
              handleRouteChange(tottusComuna);
            } else if (selectedZoneValidation) {
              handleRouteChange(comunaToSave);
            }
            setSuccessModal(true);
          case 5:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return function saveZone(_x13) {
      return _ref14.apply(this, arguments);
    };
  }();
  var saveAdressData = function saveAdressData(address, customZones, comuna) {
    if (!customZones || (Array.isArray(customZones) ? customZones.length === 0 : Object.keys(customZones).length === 0)) {
      return;
    }
    var latitude = address.latitude,
      longitude = address.longitude,
      addressLine1 = address.addressLine1,
      addressLine2 = address.addressLine2;
    var landmark = (address === null || address === void 0 ? void 0 : address.landmark) || (address === null || address === void 0 ? void 0 : address.departmentNumber) || '';
    setSavedAddressLinesData(address);
    setAddressLinesData(address);
    setToLocalStorage(constants.ADDRESS_LINES, address);
    var addressCookieValue = "".concat(addressLine1.replaceAll('*', '#'), "*").concat(addressLine2.replaceAll('*', '#'), "*").concat(landmark.replaceAll('*', '#'), "*").concat(latitude, "*").concat(longitude);
    cookieSetHelper(constants.ADDRESS_LINES, encodeURIComponent(addressCookieValue));
    if (isTottusStandAlone) {
      var expressZones = customZones.expressZones,
        standardZones = customZones.standardZones;
      cookieSetHelper(constants.ZONES_LIST, btoa(JSON.stringify({
        expressZones: expressZones,
        standardZones: standardZones
      })));
      cookieSetHelper(constants.ZONES, JSON.stringify([].concat(_toConsumableArray(expressZones), _toConsumableArray(standardZones))));
    } else {
      cookieSetHelper(constants.ZONES, JSON.stringify(customZones));
    }
    if (address !== null && address !== void 0 && address.id) {
      cookieSetHelper(constants.ADDRESS_IDS, address === null || address === void 0 ? void 0 : address.id);
    }
    saveZone(comuna);
  };
  var setGeofinderProgramatically = function () {
    var _ref15 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee14(address) {
      var customInfo, stateCode, state, municipal, latitude, longitude, statePoliticalId, municipalPoliticalAreaId, comuna, zones, virtualZones, regionData;
      return _regeneratorRuntime.wrap(function (_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            if (!isEmpty(address)) {
              _context14.next = 1;
              break;
            }
            return _context14.abrupt("return");
          case 1:
            customInfo = address.customInfo, stateCode = address.stateCode, state = address.state, municipal = address.municipal, latitude = address.latitude, longitude = address.longitude;
            statePoliticalId = customInfo.find(function (info) {
              return info.name === 'statePoliticalAreaId';
            });
            municipalPoliticalAreaId = customInfo.find(function (info) {
              return info.name === 'municipalPoliticalAreaId';
            });
            _context14.next = 2;
            return updateComuna(statePoliticalId.value, municipalPoliticalAreaId.value, 'politicalId');
          case 2:
            comuna = _context14.sent;
            zones = (comuna === null || comuna === void 0 ? void 0 : comuna.zones) || [];
            if (!isTottusStandAlone) {
              _context14.next = 4;
              break;
            }
            _context14.next = 3;
            return getTottusZones$1({
              latitude: latitude,
              longitude: longitude,
              tenant: tenant,
              politicalId: municipalPoliticalAreaId === null || municipalPoliticalAreaId === void 0 ? void 0 : municipalPoliticalAreaId.value
            });
          case 3:
            zones = _context14.sent;
            _context14.next = 6;
            break;
          case 4:
            if (!isSodimacRe) {
              _context14.next = 6;
              break;
            }
            _context14.next = 5;
            return getVirtualZones$1({
              tenant: tenant,
              politicalId: municipalPoliticalAreaId === null || municipalPoliticalAreaId === void 0 ? void 0 : municipalPoliticalAreaId.value
            });
          case 5:
            virtualZones = _context14.sent;
            zones = (virtualZones === null || virtualZones === void 0 ? void 0 : virtualZones.data) || [];
          case 6:
            if (!(!zones || Object.keys(zones).length === 0)) {
              _context14.next = 7;
              break;
            }
            return _context14.abrupt("return");
          case 7:
            saveAdressData(address, zones, comuna);
            regionData = {
              code: stateCode,
              id: stateCode,
              name: state,
              politicalId: statePoliticalId.value,
              type: 'STATE'
            };
            setSelectedRegion(regionData);
            setSavedRegion(regionData);
            setRegionInputValue(state);
            setComunaInputValue(municipal);
            cookieSetHelper(constants.IS_ZONE_SELECTED, 'true');
            cookieSetHelper(constants.ADDRESS_IDS, address === null || address === void 0 ? void 0 : address.id);
            cookieSetHelper(constants.POLITICAL_ID, municipalPoliticalAreaId.value);
            cookieSetHelper(constants.PRICE_GROUP_ID, comuna.priceGroupId);
            cookieSetHelper(constants.USER_ZONE, 'userselected');
            handleRouteChange(comuna);
          case 8:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    return function setGeofinderProgramatically(_x14) {
      return _ref15.apply(this, arguments);
    };
  }();
  var setGeofinderProgramaticallyFAPE = function () {
    var _ref16 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee15(address) {
      var customInfo, stateCode, state, city, municipal, latitude, longitude, statePoliticalId, cityPoliticalAreaId, municipalPoliticalAreaId, district, regionData, zones, virtualZones;
      return _regeneratorRuntime.wrap(function (_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            customInfo = address.customInfo, stateCode = address.stateCode, state = address.state, city = address.city, municipal = address.municipal, latitude = address.latitude, longitude = address.longitude;
            statePoliticalId = customInfo.find(function (info) {
              return info.name === 'statePoliticalAreaId';
            });
            cityPoliticalAreaId = customInfo.find(function (info) {
              return info.name === 'cityPoliticalAreaId';
            });
            municipalPoliticalAreaId = customInfo.find(function (info) {
              return info.name === 'municipalPoliticalAreaId';
            });
            _context15.next = 1;
            return updateProvince(statePoliticalId.value, cityPoliticalAreaId.value, 'politicalId');
          case 1:
            _context15.next = 2;
            return updateDistrict(statePoliticalId.value, cityPoliticalAreaId.value, municipalPoliticalAreaId.value, 'politicalId');
          case 2:
            district = _context15.sent;
            regionData = {
              code: stateCode,
              id: stateCode,
              name: state,
              politicalId: statePoliticalId.value,
              type: 'STATE'
            };
            zones = (district === null || district === void 0 ? void 0 : district.zones) || [];
            if (!isTottusStandAlone) {
              _context15.next = 4;
              break;
            }
            _context15.next = 3;
            return getTottusZones$1({
              latitude: latitude,
              longitude: longitude,
              tenant: tenant,
              politicalId: municipalPoliticalAreaId === null || municipalPoliticalAreaId === void 0 ? void 0 : municipalPoliticalAreaId.value
            });
          case 3:
            zones = _context15.sent;
            _context15.next = 6;
            break;
          case 4:
            if (!isSodimacRe) {
              _context15.next = 6;
              break;
            }
            _context15.next = 5;
            return getVirtualZones$1({
              tenant: tenant,
              politicalId: municipalPoliticalAreaId === null || municipalPoliticalAreaId === void 0 ? void 0 : municipalPoliticalAreaId.value
            });
          case 5:
            virtualZones = _context15.sent;
            zones = (virtualZones === null || virtualZones === void 0 ? void 0 : virtualZones.data) || [];
          case 6:
            if (!(!zones || Object.keys(zones).length === 0)) {
              _context15.next = 7;
              break;
            }
            setSavedAddressLinesData(undefined);
            return _context15.abrupt("return");
          case 7:
            saveAdressData(address, zones, district);
            setSelectedRegion(regionData);
            setSavedRegion(regionData);
            setRegionInputValue(state);
            setProvinceInputValue(city);
            setComunaInputValue(municipal);
            cookieSetHelper(constants.IS_ZONE_SELECTED, 'true');
            cookieSetHelper(constants.ADDRESS_IDS, address === null || address === void 0 ? void 0 : address.id);
            cookieSetHelper(constants.POLITICAL_ID, municipalPoliticalAreaId.value);
            cookieSetHelper(constants.PRICE_GROUP_ID, district.priceGroupId);
            cookieSetHelper(constants.USER_ZONE, 'userselected');
            handleRouteChange(district);
          case 8:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return function setGeofinderProgramaticallyFAPE(_x15) {
      return _ref16.apply(this, arguments);
    };
  }();
  var getFavoriteAddress = function getFavoriteAddress(addresses) {
    var favorite = addresses.find(function (a) {
      return a.isDefaultAddress === true;
    });
    return favorite || addresses[0];
  };
  useEffect(function () {
    _asyncToGenerator(_regeneratorRuntime.mark(function _callee16() {
      var response, IS_ZONE_SELECTED_COOKIE, IS_ZONE_SELECTED, unescapeATGCookies, getCookie, cookieSID, cookieSIDStatus, _response, addresses, favoriteAddress, addressLine1, addressLine2, latitude, longitude, landmark, _t4;
      return _regeneratorRuntime.wrap(function (_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            if (isProgramaticallyGeofinderEnabled) {
              _context16.next = 1;
              break;
            }
            return _context16.abrupt("return");
          case 1:
            IS_ZONE_SELECTED_COOKIE = CookieStorage$1.getCookie(constants.IS_ZONE_SELECTED);
            IS_ZONE_SELECTED = IS_ZONE_SELECTED_COOKIE === 'true';
            if (!(isUserLoggedIn && !IS_ZONE_SELECTED)) {
              _context16.next = 13;
              break;
            }
            unescapeATGCookies = CookieStorage$1.unescapeATGCookies, getCookie = CookieStorage$1.getCookie;
            cookieSID = process.env.ENVIRONMENT === 'dev' ? process.env.TEST_COOKIE_SID : unescapeATGCookies(getCookie('sid'));
            cookieSIDStatus = getCookie('sidStatus');
            _context16.prev = 2;
            if (!(cookieSIDStatus === SID_STATUS.SOFTLOGIN)) {
              _context16.next = 4;
              break;
            }
            _context16.next = 3;
            return getUserAddressesCheckout(cookieSID, tenant, store);
          case 3:
            response = _context16.sent;
            _context16.next = 6;
            break;
          case 4:
            _context16.next = 5;
            return getUserAddresses(cookieSID, tenant, store);
          case 5:
            response = _context16.sent;
          case 6:
            if (!(response.errors && response.errors.length > 0)) {
              _context16.next = 7;
              break;
            }
            throw new Error("".concat(response.errors[0].message, " (").concat(response.errors[0].code, ")"));
          case 7:
            _response = response, addresses = _response.addresses;
            favoriteAddress = getFavoriteAddress(addresses);
            if (!isEmpty(favoriteAddress)) {
              _context16.next = 8;
              break;
            }
            return _context16.abrupt("return");
          case 8:
            if (!(tenant === 'cl')) {
              _context16.next = 10;
              break;
            }
            _context16.next = 9;
            return setGeofinderProgramatically(favoriteAddress);
          case 9:
            _context16.next = 11;
            break;
          case 10:
            _context16.next = 11;
            return setGeofinderProgramaticallyFAPE(favoriteAddress);
          case 11:
            addressLine1 = favoriteAddress.addressLine1, addressLine2 = favoriteAddress.addressLine2, latitude = favoriteAddress.latitude, longitude = favoriteAddress.longitude, landmark = favoriteAddress.landmark;
            setAddressLinesData({
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              landmark: landmark,
              latitude: latitude,
              longitude: longitude
            });
            setReminderModalType(constants.REMINDER_MODAL_TYPE.USER_LOGGED_IN);
            setShowReminderModal(true);
            _context16.next = 13;
            break;
          case 12:
            _context16.prev = 12;
            _t4 = _context16["catch"](2);
            console.log(_t4);
          case 13:
          case "end":
            return _context16.stop();
        }
      }, _callee16, null, [[2, 12]]);
    }))();
  }, [isUserLoggedIn]);
  useEffect(function () {
    if (selectedRegion) {
      if (isSettingFromPostal) return;
      if (tenant !== 'cl') {
        resetProvince();
        updateProvince(selectedRegion.politicalId);
      } else {
        resetComuna();
        updateComuna(selectedRegion.politicalId);
      }
    }
  }, [selectedRegion]);
  useEffect(function () {
    if (isSettingFromPostal) return;
    if (selectedProvince) {
      resetComuna();
      var _ref18 = selectedRegion || savedRegion,
        politicalId = _ref18.politicalId;
      updateDistrict(politicalId, selectedProvince.politicalId);
    }
  }, [selectedProvince]);
  function fetchComunaDefault() {
    return _fetchComunaDefault.apply(this, arguments);
  }
  function _fetchComunaDefault() {
    _fetchComunaDefault = _asyncToGenerator(_regeneratorRuntime.mark(function _callee19() {
      var forceDefault,
        url,
        comunaDefault,
        _comunaDefault$data,
        zones,
        currentZoneName,
        priceGroupId,
        politicalId,
        latitude,
        longitude,
        expressZones,
        standardZones,
        _getZoneIDAndName2,
        zoneID,
        zoneName,
        updatedZones,
        zoneInfo,
        virtualZones,
        hasExpressZones,
        hasStandardZones,
        zonesList,
        _args19 = arguments;
      return _regeneratorRuntime.wrap(function (_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            forceDefault = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : false;
            if (!(CookieStorage$1.getCookie(constants.POLITICAL_ID).length === 0 || forceDefault)) {
              _context19.next = 5;
              break;
            }
            url = extendedApiEndpoints$1.getComunaDetailsWithOptions('default', tenant, baseUrl, store, getZoneOptions);
            _context19.next = 1;
            return doFetch(url, {});
          case 1:
            comunaDefault = _context19.sent;
            if (!(comunaDefault && comunaDefault["default"])) {
              _context19.next = 4;
              break;
            }
            _comunaDefault$data = comunaDefault.data, zones = _comunaDefault$data.zones, currentZoneName = _comunaDefault$data.name, priceGroupId = _comunaDefault$data.priceGroupId, politicalId = _comunaDefault$data.politicalId, latitude = _comunaDefault$data.latitude, longitude = _comunaDefault$data.longitude, expressZones = _comunaDefault$data.expressZones, standardZones = _comunaDefault$data.standardZones;
            _getZoneIDAndName2 = getZoneIDAndName(zones, currentZoneName), zoneID = _getZoneIDAndName2.zoneID, zoneName = _getZoneIDAndName2.zoneName;
            updatedZones = zones;
            zoneInfo = CookieStorage$1.getCookie(constants.ZONES);
            if (!(isSodimacRe && (!zoneInfo || !Array.isArray(zoneInfo) || !(zoneInfo !== null && zoneInfo !== void 0 && zoneInfo.filter(Boolean).length)))) {
              _context19.next = 3;
              break;
            }
            _context19.next = 2;
            return getVirtualZones$1({
              tenant: tenant,
              politicalId: politicalId
            });
          case 2:
            virtualZones = _context19.sent;
            updatedZones = (virtualZones === null || virtualZones === void 0 ? void 0 : virtualZones.data) || [];
          case 3:
            cookieSetHelper(constants.POLITICAL_ID, politicalId);
            cookieSetHelper(constants.PRICE_GROUP_ID, priceGroupId);
            cookieSetHelper(constants.POLITICAL_ID_EXISTS, true);
            cookieSetHelper(constants.IS_ZONE_SELECTED, false);
            cookieSetHelper(constants.USER_ZONE, 'defaultZone');
            cookieSetHelper(constants.ZONES, JSON.stringify(updatedZones));
            cookieSetHelper(constants.ZONE_DATA, {
              zoneID: zoneID,
              zoneName: zoneName
            });
            hasExpressZones = Array.isArray(expressZones) && expressZones.length > 0;
            hasStandardZones = Array.isArray(standardZones) && standardZones.length > 0;
            if (hasExpressZones || hasStandardZones) {
              zonesList = {
                expressZones: hasExpressZones ? expressZones : [],
                standardZones: hasStandardZones ? standardZones : []
              };
              cookieSetHelper(constants.ZONES_LIST, btoa(JSON.stringify(zonesList)));
            }
            cookieSetHelper(constants.ADDRESS_LINES, "***".concat(latitude, "*").concat(longitude));
            if (forceDefault) {
              handleRouteChange(comunaDefault.data);
              resetSavedDetails();
              resetOnModalClose();
            }
            triggerComunaEvent(zones, politicalId, priceGroupId);
          case 4:
            _context19.next = 6;
            break;
          case 5:
            triggerComunaEvent();
          case 6:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
    return _fetchComunaDefault.apply(this, arguments);
  }
  useEffect(function () {
    var fetchComunaData = function () {
      var _ref19 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function (_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 1;
              return fetchComunaDefault();
            case 1:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      return function fetchComunaData() {
        return _ref19.apply(this, arguments);
      };
    }();
    fetchComunaData();
  }, []);
  var comunaChangeHandler = function () {
    var _ref20 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee18(opt) {
      var selectedCom;
      return _regeneratorRuntime.wrap(function (_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            if (opt) {
              _context18.next = 1;
              break;
            }
            return _context18.abrupt("return", setSelectedComuna(''));
          case 1:
            selectedCom = getSelectedOption(comunas, 'name', opt);
            setSelectedComuna(selectedCom);
            setComunaInputValue(opt);
            setEnableEnter(true);
            setAddressLinesData({
              addressLine1: '',
              addressLine2: '',
              landmark: '',
              latitude: '',
              longitude: ''
            });
            _context18.next = 2;
            return executeDataCallbacks$1(selectedCom, getStockEnTiendaData, getDeliveryEstimatesV2Data);
          case 2:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    }));
    return function comunaChangeHandler(_x16) {
      return _ref20.apply(this, arguments);
    };
  }();
  useEffect(function () {
    return function () {
      clearTimeout(timer);
    };
  }, [popModalType]);
  useEffect(function () {
    if ((modalVisible || isModalVisible) && regions.length === 0) {
      getRegionList();
    }
  }, [modalVisible, isModalVisible]);
  useEffect(function () {
    var initLoad = true;
    getSavedZone(initLoad);
    return function () {
      setPopOverVisible(false);
      setSuccessModal(false);
    };
  }, []);
  useEffect(function () {
    var USER_ZONE = constants.USER_ZONE;
    var isDefaultZone = CookieStorage$1.getCookie(USER_ZONE) === 'defaultZone';
    if (isDefaultComuna || isDefaultZone && !selectedZone) {
      setSavedRegion(undefined);
      setSavedComuna(undefined);
      setSavedAddressLinesData(undefined);
      if (!isPickupInStore) {
        WebStorage$1.removeItem({
          name: constants.REG_ID,
          fromPersistence: true
        });
        WebStorage$1.removeItem({
          name: constants.COM_ID,
          fromPersistence: true
        });
      }
      setSelectedRegion(undefined);
      setSelectedComuna(undefined);
      if (tenant !== 'cl') {
        setSavedProvince(undefined);
        if (!isPickupInStore) {
          WebStorage$1.removeItem({
            name: constants.PROV_ID,
            fromPersistence: true
          });
        }
        setSelectedProvince(undefined);
      }
    }
  }, [isDefaultComuna]);
  useEffect(function () {
    if (selectedZone && selectedZone.name) {
      getSavedZone(false);
    }
  }, [selectedZone]);
  var ModalLabelContent = function ModalLabelContent() {
    var pressureLabel = deviceType === 'desktop' ? labels.PRESSURE_DESKTOP_LABLE : labels.PRESSURE_MOBILE_LABLE;
    var selectedRegionLabel = !isTottusStandAlone ? labels.SELECTED_REGION_LABLE : labels.SELECTED_REGION_LABLE_TOTTUS;
    var isDefaultZone = isWindow$1() && CookieStorage$1.getCookie(constants.USER_ZONE) === 'defaultZone';
    var savedGeoValidation = tenant !== 'cl' ? savedRegion && savedProvince && savedComuna : savedRegion && savedComuna;
    if (savedGeoValidation && !isDefaultZone) {
      return jsxs("p", {
        className: classNames(styles$1h['zone-lable'], _defineProperty(_defineProperty(_defineProperty({}, styles$1h.marketplace, isBrandingMarketplace), styles$1h.store, isStore), styles$1h['new-zone-modal'], isTottusStandAlone)),
        children: [selectedRegionLabel, "\xA0", jsx("span", {
          className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$1h.marketplace, isBrandingMarketplace), styles$1h.comuna, !isTottusStandAlone), styles$1h['tottus-comuna'], isTottusStandAlone)),
          children: getTottusAddress(_objectSpread$w(_objectSpread$w({}, savedAddressLinesData), {}, {
            comuna: savedComuna.name
          }), isTottusStandAlone)
        })]
      });
    }
    return jsx("p", {
      className: classNames(styles$1h['zone-lable'], styles$1h.bold, _defineProperty(_defineProperty(_defineProperty({}, styles$1h.marketplace, isBrandingMarketplace), styles$1h.store, isStore), styles$1h.standalone, isSodimacStandAlone)),
      children: pressureLabel
    });
  };
  useEffect(function () {
    if (!isStockEnTiendaModal) {
      setToLocalStorage(constants.REG_ID, selectedRegion || savedRegion);
      setToLocalStorage(constants.COM_ID, selectedComuna || savedComuna);
    }
    if (tenant !== 'cl' && !isStockEnTiendaModal) {
      setToLocalStorage(constants.PROV_ID, selectedProvince || savedProvince);
    }
  }, [savedComuna, savedRegion, savedProvince]);
  var pressureModalDismissHandler = function pressureModalDismissHandler(interacted) {
    setPopOverVisible(false);
    if (interacted) {
      CookieStorage$1.setCookie({
        name: constants.IS_PRESSURE_MODAL_INTERACTED,
        value: 'true',
        regionCode: tenant
      });
    }
  };
  var PopOverContent = function PopOverContent() {
    if (!isPopOverVisible) {
      return jsx(React.Fragment, {});
    }
    if (zoneSession) {
      return jsx(React.Fragment, {});
    }
    if (!pressureModalInteractionSession && !zoneSession && popModalType === 'pressure') {
      return jsx(PressureModal, {
        dismissHandler: pressureModalDismissHandler,
        isBrandingMarketplace: isBrandingMarketplace,
        notificationLife: notificationLife
      });
    }
    return jsx(React.Fragment, {});
  };
  var closeOtherModals = function closeOtherModals() {
    setPopOverVisible(false);
    setSuccessModal(false);
  };
  var toggleModal = function toggleModal(visibility) {
    if (deviceType !== 'desktop') {
      if (!visibility) {
        setMobileModalClass('floatBottomEndTransition');
        var animationTimer = setTimeout(function () {
          if (isBrandingMarketplace) {
            setIsModalVisible(visibility);
          } else {
            setModalVisible(visibility);
          }
          clearTimeout(animationTimer);
        }, constants.MODAL_CLOSE_TIME);
      } else {
        setMobileModalClass('floatBottomTransition');
        if (isBrandingMarketplace) {
          setIsModalVisible(visibility);
        } else {
          setModalVisible(visibility);
        }
      }
    } else if (isBrandingMarketplace) {
      setIsModalVisible(visibility);
    } else {
      setModalVisible(visibility);
    }
  };
  var getModalHeight = function getModalHeight() {
    if (isTottusStandAlone) {
      return;
    }
    if (isSodimacRe && isPostalCodeEnabled) {
      if (isErrorNotification) {
        return deviceType === 'desktop' ? 671 : 699;
      }
      return deviceType === 'desktop' ? 627 : 623;
    }
    if (tenant !== 'cl' && !isDeliveryOptionsModal && !isStockEnTiendaModal) {
      return deviceType === 'desktop' ? 491 : 410;
    }
    if (isNewDeliveryOptionModal) {
      return deviceType === 'desktop' ? 220 : 330;
    }
    return deviceType === 'desktop' ? 403 : 330;
  };
  var getModalWidth = function getModalWidth() {
    if (isTottusStandAlone) {
      return deviceType === 'desktop' ? 400 : '100%';
    } else if (isNewDeliveryOptionModal) {
      return deviceType === 'desktop' ? 360 : '100%';
    }
    return 500;
  };
  useEffect(function () {
  }, [isErrorNotification]);
  var customBodyClass = function customBodyClass() {
    return isBrandingMarketplace ? 'zone-modal-body-marketplace' : 'zone-modal-body-retail';
  };
  var ModalComponent = isNewDeliveryOptionModal ? EmbeddedModal$1 : Modal;
  return jsxs("div", {
    className: classNames(styles$1h['modal-wrapper'], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$1h.marketplace, isBrandingMarketplace), styles$1h.retail, !isBrandingMarketplace), styles$1h.stockEnTiendaWrapper, !!isStockEnTiendaModal || !!isDeliveryOptionsModal), styles$1h.store, isStore)),
    id: "modal-wrapper",
    children: [jsx(ModalComponent, {
      toggleState: {
        visible: isBrandingMarketplace ? isModalVisible : modalVisible,
        setVisible: toggleModal
      },
      isNewDeliveryOptionModal: true,
      keepNoScroll: (deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.type) === constants.PICKUP_IN_STORE,
      content: function content(actions) {
        return jsx(ModalContent$1, {
          actions: actions,
          regionsSuggestion: regions,
          regionChangeHandler: regionChangeHandler,
          selectedRegion: selectedRegion || savedRegion,
          postalCodeStatus: postalCodeStatus,
          comunaSuggestion: comunas,
          selectedZone: selectedZone,
          comunaChangeHandler: comunaChangeHandler,
          addressLinesData: addressLinesData,
          setAddressLinesData: setAddressLinesData,
          setSavedAddressLinesData: setSavedAddressLinesData,
          store: store,
          selectedComuna: selectedRegion || selectedProvince || selectedComuna ? selectedComuna : savedComuna,
          setSelectedComuna: setSelectedComuna,
          provinceSuggestion: provinces,
          provinceChangeHandler: provinceChangeHandler,
          selectedProvince: selectedRegion || selectedProvince ? selectedProvince : savedProvince,
          deviceType: deviceType,
          tenant: tenant,
          saveZone: saveZone,
          setSelectedRegion: setSelectedRegion,
          getSavedZone: getSavedZone,
          regionInputValue: regionInputValue,
          setRegionInputValue: setRegionInputValue,
          provinceInputValue: provinceInputValue,
          postalCodeInputValue: postalCodeInputValue,
          setPostalCodeInputValue: setPostalCodeInputValue,
          isSettingFromPostal: isSettingFromPostal,
          isPostalCodeEnabled: isPostalCodeEnabled,
          isSodimacRe: isSodimacRe,
          setProvinceInputValue: setProvinceInputValue,
          comunaInputValue: comunaInputValue,
          setComunaInputValue: setComunaInputValue,
          setModalVisible: toggleModal,
          enableEnter: enableEnter,
          onFocus: function onFocus() {
            setEnableEnter(false);
          },
          branding: isBrandingMarketplace ? 'marketplace' : 'retail',
          stockEnTienda: isStockEnTiendaModal ? stockEnTienda : {},
          deliveryOptions: isDeliveryOptionsModal ? deliveryOptions : {},
          isDefaultComuna: isDefaultComuna,
          isStore: isStore,
          enableSisThemedBorder: enableSisThemedBorder,
          isSodimacStandAlone: isSodimacStandAlone,
          setGeofinderProgramatically: tenant === 'cl' ? setGeofinderProgramatically : setGeofinderProgramaticallyFAPE,
          isUserLoggedIn: isUserLoggedIn,
          resetHandler: resetOnModalClose,
          saveAdressData: saveAdressData,
          fetchComunaDefault: fetchComunaDefault,
          setShowLoginForm: setShowLoginForm,
          getStockEnTiendaData: getStockEnTiendaData,
          getDeliveryEstimatesV2Data: getDeliveryEstimatesV2Data,
          setPostalWarning: setPostalWarning,
          isPostalActive: isPostalActive,
          isCambiar: isCambiar,
          isPostalExist: isPostalExist,
          isErrorNotification: isErrorNotification
        });
      },
      isOverlayEnabled: !isNewDeliveryOptionModal,
      options: {
        width: getModalWidth(),
        height: getModalHeight(),
        disableOutsideClick: false,
        overflow: 'visible',
        borderRadius: deviceType === 'desktop' ? '3px' : '10px 10px 0px 0px',
        padding: deviceType === 'desktop' ? '' : !isStockEnTiendaModal && !isDeliveryOptionsModal && '10px 0px 0px 0px'
      },
      deviceType: deviceType,
      resetHandler: resetOnModalClose,
      withPadding: !isStockEnTiendaModal && !isDeliveryOptionsModal && !isTottusStandAlone,
      closeOtherModals: closeOtherModals,
      fullWidth: deviceType !== 'desktop',
      customClass: deviceType !== 'desktop' && !isStockEnTiendaModal && !isDeliveryOptionsModal ? mobileModalClass : '',
      showCloseButton: false,
      fullScreen: (!!isStockEnTiendaModal || !!isDeliveryOptionsModal) && deviceType !== 'desktop',
      customBodyClass: !!isStockEnTiendaModal || !!isDeliveryOptionsModal || !!isTottusStandAlone ? 'no-custom-class' : customBodyClass(),
      buttonOpenModalID: "geofinder-button-open",
      children: isStockEnTiendaModal || isDeliveryOptionsModal ? jsx("div", {}) : jsx("div", {
        className: styles$1h['zone-modal-container'],
        children: jsxs("div", {
          className: "".concat(styles$1h['zone-select-wrapper'], "  ").concat(!isSISLevel2Header && styles$1h['zone-select-wrapper-sis-level-header']),
          children: [jsx("i", {
            style: isBrandingMarketplace ? {
              backgroundImage: "url(".concat(isOrangeOrSISHeader ? geoFinderIconURL : grayHeadergeoFinderIconURL, ")")
            } : {},
            className: classNames(styles$1h['icon-location'], styles$1h.icon, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$1h.marketplace, isBrandingMarketplace), styles$1h.retail, !isBrandingMarketplace), styles$1h.storeIcon, isStore), styles$1h.storeIconWhite, !isSISLevel2Header)),
            children: jsx("span", {
              className: styles$1h['sr-only'],
              children: "location-icon"
            })
          }), jsx(ModalLabelContent, {})]
        })
      })
    }), popOvervisible && !isOnboardingInProgress && jsx(PopOverContent, {}), showSuccessModal && jsx(SuccessModal, {
      dismissHandler: function dismissHandler() {
        return setSuccessModal(false);
      },
      isBrandingMarketplace: isBrandingMarketplace,
      notificationLife: notificationLife
    }), showReminderModal && jsx(ReminderModal, {
      dismissHandler: function dismissHandler() {
        return setShowReminderModal(false);
      },
      type: reminderModalType,
      isBrandingMarketplace: isBrandingMarketplace,
      notificationLife: notificationLife
    })]
  });
};
ZoneModal.defaultProps = {
  deviceType: 'desktop',
  isDefaultComuna: false,
  selectedZone: undefined,
  isPopOverVisible: false,
  stockEnTienda: {},
  deliveryOptions: {},
  isUserLoggedIn: false,
  isProgramaticallyGeofinderEnabled: false,
  geofinderConfigs: {},
  isStore: false,
  enableSisThemedBorder: false,
  isSodimacStandAlone: false,
  isOrangeOrSISHeader: false,
  isSISLevel2Header: true,
  store: {},
  isTottusStandAlone: false,
  baseUrl: '',
  getStockEnTiendaData: function getStockEnTiendaData() {},
  getDeliveryEstimatesV2Data: function getDeliveryEstimatesV2Data() {},
  isPostalCodeEnabled: false
};
ZoneModal.propTypes = {
  deviceType: PropTypes.string,
  tenant: PropTypes.string.isRequired,
  handleRouteChange: PropTypes.func.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  entry: PropTypes.object.isRequired,
  modalVisible: PropTypes.bool.isRequired,
  setModalVisible: PropTypes.func.isRequired,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  isDefaultComuna: PropTypes.bool,
  selectedZone: PropTypes.object,
  isPopOverVisible: PropTypes.bool,
  stockEnTienda: PropTypes.object,
  deliveryOptions: PropTypes.object,
  isUserLoggedIn: PropTypes.bool,
  isProgramaticallyGeofinderEnabled: PropTypes.bool,
  geofinderConfigs: PropTypes.object,
  isStore: PropTypes.bool,
  enableSisThemedBorder: PropTypes.bool,
  isSodimacStandAlone: PropTypes.bool,
  isOrangeOrSISHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  store: PropTypes.object,
  isTottusStandAlone: PropTypes.bool,
  baseUrl: PropTypes.string,
  setShowLoginForm: PropTypes.func.isRequired,
  getStockEnTiendaData: PropTypes.func,
  getDeliveryEstimatesV2Data: PropTypes.func,
  isPostalCodeEnabled: PropTypes.bool
};
var ZoneModal$1 = ZoneModal;

var styles$1d = {"font-button":"MiniAccountWithLogin-module_font-button__PPuAe","container":"MiniAccountWithLogin-module_container__GY7Rp","buttons-container":"MiniAccountWithLogin-module_buttons-container__FpAl-","signin-button-mobile":"MiniAccountWithLogin-module_signin-button-mobile__49R9J","loggin-button-mobile":"MiniAccountWithLogin-module_loggin-button-mobile__mlVi5","signin-button":"MiniAccountWithLogin-module_signin-button__Mbuo-","wrapper":"MiniAccountWithLogin-module_wrapper__AJpY6","icon-container":"MiniAccountWithLogin-module_icon-container__b4TKm","text-container":"MiniAccountWithLogin-module_text-container__Xs-3E","button-base":"MiniAccountWithLogin-module_button-base__7BbZ1","loggin-button":"MiniAccountWithLogin-module_loggin-button__QfSVI","mobile-image-container":"MiniAccountWithLogin-module_mobile-image-container__R-j-j","mobile-icon":"MiniAccountWithLogin-module_mobile-icon__9hvCD","mobile-text":"MiniAccountWithLogin-module_mobile-text__rtGh1","mobile-second":"MiniAccountWithLogin-module_mobile-second__s1Csk"};

var objectWithoutPropertiesLoose$1 = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(objectWithoutPropertiesLoose$1);

var objectWithoutPropertiesLoose = objectWithoutPropertiesLoose$1;

var objectWithoutProperties = createCommonjsModule(function (module) {
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _objectWithoutProperties = unwrapExports(objectWithoutProperties);

function ownKeys$v(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$v(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$v(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$v(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var setBusy = function setBusy(_ref) {
  var load = _ref.load,
    setLoad = _ref.setLoad;
  return function (busy) {
    var updatedBusy = busy ? load + 1 : load - 1;
    setLoad(updatedBusy > 0 ? updatedBusy : 0);
  };
};
function useLoaderContextHook() {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    load = _useState2[0],
    setLoad = _useState2[1];
  return {
    load: load,
    setBusy: setBusy({
      load: load,
      setLoad: setLoad
    })
  };
}
var LoaderContext = createContainer(useLoaderContextHook);
var _LoaderContext = _slicedToArray(LoaderContext, 2),
  LoaderProvider = _LoaderContext[0],
  useLoaderContext = _LoaderContext[1];
var withLoader = function withLoader(WrappedComponent) {
  var getInitialProps = WrappedComponent.getInitialProps;
  var ComponentWithLoader = function ComponentWithLoader(props) {
    var loader = useLoaderContext();
    return jsx(WrappedComponent, _objectSpread$v(_objectSpread$v({}, props), loader));
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithLoader.getInitialProps = getInitialProps;
  }
  return ComponentWithLoader;
};

var styles$1c = {"loader":"Loader-module_loader__Ukoov"};

var Loader = function Loader(_ref) {
  var load = _ref.load;
  return jsx(Fragment, {
    children: load !== 0 && jsx("div", {
      className: styles$1c.loader,
      children: jsx(Spinner$1, {})
    })
  });
};
Loader.propTypes = {
  load: PropTypes.number.isRequired
};
var Loader$1 = withLoader(Loader);

function ownKeys$u(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$u(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$u(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$u(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var onResize = function onResize(device, setDeviceType) {
  return function () {
    var newDeviceType = 'desktop';
    if (isMobile()) {
      newDeviceType = deviceTypes.MOBILE;
    } else if (isIpadPotrait()) {
      newDeviceType = deviceTypes.TABLET;
    } else {
      newDeviceType = deviceTypes.DESKTOP;
    }
    setDeviceType(newDeviceType);
  };
};
var attachResizeListener = function attachResizeListener(device, setDeviceType) {
  return function () {
    if (isWindow()) {
      onResize(device, setDeviceType)();
      window.onresize = onResize(device, setDeviceType);
      window.addEventListener('resize', onResize(device, setDeviceType));
    }
  };
};
function useDeviceContextHook(_ref) {
  var initialDeviceType = _ref.deviceType;
  var initDevice = initialDeviceType || deviceTypes.DESKTOP;
  var _useState = useState(initDevice),
    _useState2 = _slicedToArray(_useState, 2),
    deviceType = _useState2[0],
    setDeviceType = _useState2[1];
  return {
    deviceType: deviceType,
    setDeviceType: setDeviceType,
    attachResizeListener: attachResizeListener(deviceType, setDeviceType)
  };
}
var DeviceContext = createContainer(useDeviceContextHook);
var _DeviceContext = _slicedToArray(DeviceContext, 2),
  DeviceProvider = _DeviceContext[0],
  useDeviceContext = _DeviceContext[1];
var withDevice = function withDevice(WrappedComponent) {
  var getInitialProps = WrappedComponent.getInitialProps;
  var ComponentWithUser = function ComponentWithUser(props) {
    var deviceProps = useDeviceContext();
    return jsx(WrappedComponent, _objectSpread$u(_objectSpread$u({}, props), deviceProps));
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithUser.getInitialProps = getInitialProps;
  }
  return ComponentWithUser;
};

var _excluded$3 = ["children"];
function ownKeys$t(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$t(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$t(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$t(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ContainerProvider = function ContainerProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var tenant = props.tenant,
    deviceType = props.deviceType,
    commerceOriginData = props.commerceOriginData;
  var validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
  return jsx(AppContext$1.Provider, {
    value: _objectSpread$t(_objectSpread$t({}, props), {}, {
      tenant: validTenant,
      commerceOriginData: commerceOriginData
    }),
    children: jsx(DeviceProvider, {
      deviceType: deviceType,
      children: jsxs(LoaderProvider, {
        children: [jsx(Loader$1, {}), jsx(UserProvider, {
          children: children
        })]
      })
    })
  });
};
ContainerProvider.defaultProps = {
  deviceType: deviceTypes.DESKTOP,
  isRebrandingEnabled: true,
  isSodimacStandAloneSite: false,
  isTottusStandAloneSite: false
};
ContainerProvider.propTypes = {
  children: PropTypes.any.isRequired,
  tenant: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  deviceType: PropTypes.string,
  isRebrandingEnabled: PropTypes.bool,
  commerceOriginData: PropTypes.object,
  isSodimacStandAloneSite: PropTypes.bool,
  isTottusStandAloneSite: PropTypes.bool
};
var ContainerProvider$1 = ContainerProvider;

var MiniAccountWithLogin = function MiniAccountWithLogin(_ref) {
  _ref.cmrPuntosUrl;
    _ref.isCmrPointsEnabled;
    var style = _ref.style,
    classes = _ref.classes,
    isUserLoggedIn = _ref.isUserLoggedIn,
    setUserLoggedIn = _ref.setUserLoggedIn,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate;
    _ref.onUserLogin;
    var atgBaseUrl = _ref.atgBaseUrl,
    catalystBaseUrl = _ref.catalystBaseUrl,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    setFirstName = _ref.setFirstName,
    setCartCount = _ref.setCartCount;
    _ref.enableAnalytics;
    var initDigitalData = _ref.initDigitalData,
    forceATG = _ref.forceATG,
    tenant = _ref.tenant,
    id = _ref.id,
    store = _ref.store,
    baseHostUrl = _ref.baseHostUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showLoginForm = _useState2[0],
    setShowLoginForm = _useState2[1];
  var _useState3 = useState(isMobile()),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobileView = _useState4[0],
    setIsMobileView = _useState4[1];
  var _useContext = useContext(AppContext$1);
    _useContext.isRebrandingEnabled;
    var baseUrl = _useContext.baseUrl;
  var _useState5 = useState({
      enabled: false,
      cartId: '',
      siteName: '',
      ecommName: '',
      defaultColor: '',
      multiSite: false
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    whiteLabelProp = _useState6[0],
    setWhiteLabelProp = _useState6[1];
  var envBaseUrl = baseHostUrl ? buildBaseUrlBetaEnv(baseHostUrl) : getEnvBaseUrl(tenant);
  var loginWizardBaseUrl = !unifiedLoginBaseUrl ? envBaseUrl : unifiedLoginBaseUrl;
  var toggleLoginForm = function toggleLoginForm() {
    setShowLoginForm(function (v) {
      return !v;
    });
  };
  var onLogin = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(response) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (response.loginStatus) {
              setUserLoggedIn(true);
              sendSatelliteTrackEvent('iniciarsesion_success');
            }
            initDigitalData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onLogin(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClose = function onClose() {
    toggleLoginForm();
  };
  useEffect(function () {
    var handleResize = function handleResize() {
      setIsMobileView(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(function () {
    var userCookie = CookieStorage$1.getUserDataCookieName();
    var userDetails = CookieStorage$1.unescapeATGCookies(CookieStorage$1.getCookie(userCookie) || '').split('*');
    setFirstName(isUserLoggedIn && decodeURIComponent(userDetails[0]));
    setCartCount(userDetails[1]);
    if (isUserLoggedIn) document.body.style.overflow = 'visible';
  }, [isUserLoggedIn]);
  var LoginButtons = function LoginButtons(_ref3) {
    var mobile = _ref3.mobile;
    var mobileClass = mobile === true ? '-mobile' : '';
    var singinUrl = "".concat(baseUrl, "/falabella-").concat(tenant, "/myaccount/registration");
    if (baseHostUrl && store && store.toLowerCase() === 'so_com') {
      singinUrl = "".concat(envBaseUrl, "/sodimac-").concat(tenant, "/myaccount/registration");
    }
    return jsxs(Fragment, {
      children: [jsx("a", {
        className: styles$1d["loggin-button".concat(mobileClass)],
        id: "mini-account-login",
        onClick: function onClick() {
          toggleLoginForm();
          sendSatelliteTrackEvent('iniciarsesion_click');
        },
        role: "button",
        title: "Iniciar sesi\xF3n",
        children: "Iniciar sesi\xF3n"
      }), jsx("a", {
        className: styles$1d["signin-button".concat(mobileClass)],
        id: "mini-account-singin",
        role: "button",
        href: singinUrl,
        title: "Crear Cuenta",
        children: "Crear Cuenta"
      })]
    });
  };
  var DesktopView = function DesktopView() {
    return jsxs(Fragment, {
      children: [jsxs("div", {
        className: styles$1d.wrapper,
        children: [jsx("div", {
          className: styles$1d['icon-container']
        }), jsx("div", {
          className: styles$1d['text-container'],
          children: jsx("span", {
            children: "Inicia sesi\xF3n para mejorar tu experiencia de compra"
          })
        })]
      }), jsx("div", {
        className: styles$1d['buttons-container'],
        children: jsx(LoginButtons, {
          mobile: isMobileView
        })
      })]
    });
  };
  var MobileView = function MobileView() {
    return jsxs(Fragment, {
      children: [jsxs("div", {
        className: styles$1d['mobile-image-container'],
        children: [jsx("div", {
          className: styles$1d['mobile-icon']
        }), jsx("div", {
          className: styles$1d['mobile-text'],
          children: "Inicia sesi\xF3n para mejorar tu experiencia de compra"
        })]
      }), jsx("div", {
        className: styles$1d['buttons-container'],
        children: jsx(LoginButtons, {
          mobile: isMobileView
        })
      })]
    });
  };
  var showComponent = function showComponent() {
    return isMobileView ? jsx(MobileView, {}) : jsx(DesktopView, {});
  };
  useEffect(function () {
    setWhiteLabelProp(generateWhiteLabelProps(store, tenant));
  }, []);
  return isUserLoggedIn ? null : jsx("div", {
    className: classNames(classes.join(' ')),
    style: style,
    id: id,
    "data-wrapper": "MA-MiniAccount",
    children: jsxs("div", {
      className: classNames(styles$1d.container),
      children: [jsx(LoginWizard, {
        atgBaseUrl: atgBaseUrl,
        catalystBaseUrl: catalystBaseUrl,
        onLogin: onLogin,
        onClose: onClose,
        show: showLoginForm,
        tenant: tenant,
        flowType: "header",
        doMergeCart: true,
        id: "testId-cc",
        isRebrandingEnabled: true,
        forceATG: forceATG,
        onComplete: onUserLoginComplete,
        onConsentsUpdate: onUserLoginConsentsUpdate,
        onPasswordUpdate: onUserLoginPasswordUpdate,
        baseUrl: loginWizardBaseUrl,
        whitelabel: whiteLabelProp
      }), showComponent()]
    })
  });
};
MiniAccountWithLogin.propTypes = {
  cmrPuntosUrl: PropTypes.string,
  isCmrPointsEnabled: PropTypes.bool,
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  deviceType: PropTypes.string,
  isUserLoggedIn: PropTypes.bool,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  atgBaseUrl: PropTypes.string.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  initDigitalData: PropTypes.func,
  setUserLoggedIn: PropTypes.func.isRequired,
  enableAnalytics: PropTypes.bool,
  tenant: PropTypes.string.isRequired,
  baseUrl: PropTypes.string,
  store: PropTypes.string,
  baseHostUrl: PropTypes.string
};
MiniAccountWithLogin.defaultProps = {
  classes: [],
  id: undefined,
  style: {},
  tenant: 'cl'
};
var MiniAccountWithLogin$1 = withUser(MiniAccountWithLogin);

var styles$1b = {"container":"SiSNavigationMenu-module_container__4xyuQ","item-name-with-double-lines":"SiSNavigationMenu-module_item-name-with-double-lines__bXzxs"};

var styles$1a = {"container-top-menu":"CategoryButton-module_container-top-menu__UKlTK","top-menu-line":"CategoryButton-module_top-menu-line__zjTJM","top-menu":"CategoryButton-module_top-menu__NwDsz","categoryWrapper":"CategoryButton-module_categoryWrapper__6rWll","categoryWrapper--to_com":"CategoryButton-module_categoryWrapper--to_com__SmQJd","with-menu":"CategoryButton-module_with-menu__G-xsV","hamburgerIcon":"CategoryButton-module_hamburgerIcon__MoZ3A","chevron-container":"CategoryButton-module_chevron-container__gfU4K","chevron-down":"CategoryButton-module_chevron-down__ErX00","chevron-down--to_com":"CategoryButton-module_chevron-down--to_com__vpXLq","active":"CategoryButton-module_active__ry6hm","name":"CategoryButton-module_name__d1Czd"};

function ownKeys$s(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$s(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$s(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$s(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CategoryButton = function CategoryButton(_ref) {
  var onItemWithSubCategoriesSelected = _ref.onItemWithSubCategoriesSelected,
    isOpen = _ref.isOpen,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    store = _ref.store,
    enableSISMenuV2 = _ref.enableSISMenuV2;
  var _getStandaloneSite = getStandaloneSite(store),
    isTottusStandalone = _getStandaloneSite.isTottusStandalone;
  var buttonText = enableSISMenuV2 ? 'Menú' : 'Categorías';
  return jsx("div", {
    className: styles$1a['container-top-menu'],
    "data-testid": "CategoryButton",
    children: jsx("div", {
      className: classNames(styles$1a['top-menu'], classes.join(' ')),
      style: _objectSpread$s({}, style),
      id: id,
      children: jsxs("div", {
        className: classNames(styles$1a.categoryWrapper, _defineProperty(_defineProperty({}, styles$1a['categoryWrapper--to_com'], isTottusStandalone), styles$1a['with-menu'], enableSISMenuV2)),
        onClick: function onClick() {
          return onItemWithSubCategoriesSelected(!isOpen);
        },
        children: [enableSISMenuV2 && jsx("i", {
          className: styles$1a.hamburgerIcon
        }), buttonText, !enableSISMenuV2 && jsx("div", {
          className: styles$1a['chevron-container'],
          children: jsx("i", {
            "aria-hidden": "true",
            className: classNames(styles$1a['chevron-down'], _defineProperty(_defineProperty({}, styles$1a['chevron-down--to_com'], isTottusStandalone), styles$1a.active, isOpen))
          })
        })]
      })
    })
  });
};
CategoryButton.propTypes = {
  brandLogo: PropTypes.shape({
    url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  }),
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.shape({
        href: PropTypes.string
      }),
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })).isRequired,
  onItemWithSubCategoriesSelected: PropTypes.func,
  isOpen: PropTypes.bool,
  store: PropTypes.string,
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string
};
CategoryButton.defaultProps = {
  categories: [],
  isOpen: false,
  classes: [],
  style: {},
  id: undefined
};
var CategoryButton$1 = CategoryButton;

var styles$19 = {"container":"SiSCategoryMenuDesktop-module_container__YRWUO","portal":"SiSCategoryMenuDesktop-module_portal__5Q-Qw","backdrop":"SiSCategoryMenuDesktop-module_backdrop__iTuKk"};

var Portal = function Portal(_ref) {
  var id = _ref.id,
    children = _ref.children,
    classes = _ref.classes,
    top = _ref.top;
  var ref = useRef(null);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    dynamic = _useState2[0],
    setDynamic = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mounted = _useState4[0],
    setMounted = _useState4[1];
  useEffect(function () {
    if (global.document) {
      if (!ref.current) {
        ref.current = document.getElementById(id) || document.createElement('div');
        setDynamic(ref);
      } else {
        ref.current.id = id;
        ref.current.classList.add(classes);
        if (top !== undefined && top !== null) {
          ref.current.style.top = typeof top === 'number' ? "".concat(top, "px") : top;
        }
        document.body.appendChild(ref.current);
      }
    }
    setMounted(true);
    return function () {
      var _ref$current;
      if ((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.parentElement) {
        ref.current.parentElement.removeChild(ref.current);
      }
    };
  }, [dynamic, id]);
  useEffect(function () {
    if (!mounted || !ref.current) return;
    if (classes) {
      ref.current.classList.add(classes);
    }
    ref.current.style.position = 'fixed';
    if (typeof top === 'string') {
      ref.current.style.top = top;
    } else if (typeof top === 'number') {
      ref.current.style.top = "".concat(top, "px");
    }
    ref.current.style.left = '0';
    ref.current.style.width = '100%';
  }, [classes, top, mounted]);
  return ref.current && createPortal(children, ref.current);
};
var Portal$1 = Portal;

var CSImageWrapper = function CSImageWrapper(_ref) {
  var lazyLoad = _ref.lazyLoad,
    children = _ref.children;
  return lazyLoad ? jsx(LazyLoad, {
    once: true,
    offset: 300,
    children: children
  }) : jsx(Fragment, {
    children: children
  });
};
CSImageWrapper.propTypes = {
  lazyLoad: PropTypes.bool
};
CSImageWrapper.defaultProps = {
  lazyLoad: true
};
var CSImageWrapper$1 = CSImageWrapper;

var _excluded$2 = ["id", "src", "resolution", "breakpoint", "alt", "height", "width", "format", "auto", "quality", "disable", "crop", "fit", "trim", "dpr", "lazyLoad", "autoMaxWidth", "callbackHeight"];
function ownKeys$r(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$r(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$r(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$r(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var breakpoints = {
  xs: '0',
  sm: '640px',
  md: '720px',
  lg: '1024px',
  xl: '1280px'
};
var CSImage = function CSImage(_ref) {
  var id = _ref.id,
    src = _ref.src,
    resolution = _ref.resolution,
    breakpoint = _ref.breakpoint,
    alt = _ref.alt,
    height = _ref.height,
    width = _ref.width,
    format = _ref.format,
    auto = _ref.auto,
    quality = _ref.quality,
    disable = _ref.disable,
    crop = _ref.crop,
    fit = _ref.fit,
    trim = _ref.trim,
    dpr = _ref.dpr,
    lazyLoad = _ref.lazyLoad,
    autoMaxWidth = _ref.autoMaxWidth,
    callbackHeight = _ref.callbackHeight,
    restProps = _objectWithoutProperties(_ref, _excluded$2);
  var url;
  try {
    url = new URL(src);
  } catch (error) {
    return null;
  }
  var imageHeight = useRef(null);
  var customWidth = null;
  var customDisable = null;
  if (autoMaxWidth && !width) {
    var maxWidth = resolution === 'mobile' && breakpoint ? breakpoints[breakpoint] : breakpoints.xl ;
    if (maxWidth) {
      maxWidth = maxWidth.replace('px', '');
      customWidth = +maxWidth > 0 ? maxWidth : null;
      customDisable = customWidth && !disable ? 'upscale' : disable;
    }
  } else {
    customWidth = width;
    customDisable = disable;
  }
  var searchParams = _objectSpread$r({
    width: customWidth,
    disable: customDisable,
    height: height,
    format: format,
    auto: auto,
    quality: quality,
    crop: crop,
    fit: fit,
    trim: trim,
    dpr: dpr
  }, url.searchParams);
  var search = stringify(searchParams, {
    skipNull: true
  });
  var uri;
  if (search) {
    uri = "".concat(url.origin).concat(url.pathname, "?").concat(search);
  } else {
    uri = "".concat(url.origin).concat(url.pathname);
  }
  var mediaSize = resolution === 'mobile' ? 'max' : 'min';
  return jsx(CSImageWrapper$1, {
    lazyLoad: lazyLoad,
    children: jsxs("picture", {
      children: [jsx("source", {
        "data-testid": "source-image",
        srcSet: uri,
        media: resolution && breakpoint ? "(".concat(mediaSize, "-width: ").concat(breakpoints[breakpoint], ")") : null
      }), !callbackHeight && jsx("img", _objectSpread$r({
        id: id,
        "data-testid": "cs-image",
        alt: alt
      }, restProps)), callbackHeight && jsx("img", _objectSpread$r(_objectSpread$r({
        id: id,
        "data-testid": "cs-image",
        alt: alt
      }, restProps), {}, {
        onLoad: function onLoad() {
          callbackHeight(imageHeight);
        },
        ref: imageHeight
      }))]
    })
  });
};
CSImage.propTypes = {
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  resolution: PropTypes.oneOf(['mobile', 'desktop']),
  breakpoint: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  alt: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  format: PropTypes.string,
  auto: PropTypes.string,
  quality: PropTypes.number,
  disable: PropTypes.string,
  crop: PropTypes.string,
  fit: PropTypes.string,
  trim: PropTypes.string,
  dpr: PropTypes.number,
  lazyLoad: PropTypes.bool,
  autoMaxWidth: PropTypes.bool
};
CSImage.defaultProps = {
  id: null,
  resolution: null,
  breakpoint: null,
  alt: null,
  height: null,
  width: null,
  format: null,
  auto: null,
  quality: null,
  disable: null,
  crop: null,
  fit: null,
  trim: null,
  dpr: null,
  lazyLoad: true,
  autoMaxWidth: true,
  callbackHeight: false
};
var CSImage$1 = CSImage;

var styles$18 = {"container":"Banners-module_container__CNHsL","banner-item":"Banners-module_banner-item__-wxnb","item-link":"Banners-module_item-link__50SM4","hover-effect":"Banners-module_hover-effect__WAmBw","title":"Banners-module_title__hoicd"};

var MIN_HIGHLIGHT_LEVEL_CATEGORIES = 6;
var MAX_CHARACTERES_BANNER_CAPTION = 50;
var MAX_CHARACTERES_TAG = 15;
var MAX_BANNERS = 6;
var NUMBER_OF_COLUMNS_FOR_CATEGORIES_AND_BANNERS = 6;
var MAX_HIGHLIGHTS = 8;
var PADDING_LEFT_AND_RIGHT_PERCENTAGE_FOR_PANEL = 0.0234375;
var MARGIN_RIGHT_FOR_ITEMS_INSIDE_PANEL = 0.09775390625;

var isVisibleColorLine = function isVisibleColorLine() {
  var highlightLevelCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var banners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var secondLevelCategories = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return highlightLevelCategories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES && (banners.length > 0 || secondLevelCategories.length > 0);
};
var showBannerDivider = function showBannerDivider() {
  var banners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var secondLevelCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return banners.length > 0 && secondLevelCategories.length > 0;
};
var formatTextWithShowMore = function formatTextWithShowMore(text, maxCharacters) {
  if (text.length > maxCharacters) {
    return "".concat(text.substring(0, maxCharacters), "...", ' ');
  }
  return text;
};
var cutText = function cutText(text, maxCharacters) {
  if (text.length > maxCharacters) {
    return text.substring(0, maxCharacters);
  }
  return text;
};
var wrapSubCategoryWithLink = function wrapSubCategoryWithLink(category, body) {
  var isForThirdLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var categoryColor = arguments.length > 3 ? arguments[3] : undefined;
  var enableSISMenuV2 = arguments.length > 4 ? arguments[4] : undefined;
  var style = arguments.length > 5 ? arguments[5] : undefined;
  var classnames = arguments.length > 6 ? arguments[6] : undefined;
  if (!category) return jsx(Fragment$1, {});
  return jsx("a", {
    "data-cta": "true",
    href: category.item_url,
    target: category.new_tab ? '_blank' : '_self',
    className: classnames(style['hover-effect'], _defineProperty(_defineProperty(_defineProperty({}, style['list-title'], !isForThirdLevel), style['list-item'], isForThirdLevel), style['secondary-list-title'], enableSISMenuV2)),
    rel: "noreferrer",
    style: {
      color: categoryColor
    },
    children: body
  });
};

var useSiSMenuHook = function useSiSMenuHook() {
  var _useState = useState(190),
    _useState2 = _slicedToArray(_useState, 2),
    widthPerElment = _useState2[0],
    setWidthPerElment = _useState2[1];
  var handleResize = function handleResize() {
    if (global.window && global.window.outerWidth) {
      var currentWidth = global.window.outerWidth;
      if (currentWidth > 720 && currentWidth <= 1279) {
        var paddingLeftAndRight = currentWidth * PADDING_LEFT_AND_RIGHT_PERCENTAGE_FOR_PANEL;
        var marginRightPerElement = currentWidth * MARGIN_RIGHT_FOR_ITEMS_INSIDE_PANEL;
        var calWidthPerElement = (currentWidth - paddingLeftAndRight - marginRightPerElement) / NUMBER_OF_COLUMNS_FOR_CATEGORIES_AND_BANNERS;
        setWidthPerElment(calWidthPerElement);
      } else if (currentWidth > 1024 && currentWidth <= 1280) {
        setWidthPerElment(142);
      } else {
        setWidthPerElment(190);
      }
    }
  };
  useEffect(function () {
    handleResize();
    if (global.window) {
      global.window.addEventListener('resize', handleResize);
    }
    return function () {
      if (global.window) {
        global.window.removeEventListener('resize', handleResize);
      }
    };
  }, []);
  return {
    widthPerElment: widthPerElment
  };
};
var useSiSMenuHook$1 = useSiSMenuHook;

var Banners = function Banners(_ref) {
  var banners = _ref.banners,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    dataWrapper = _ref.dataWrapper,
    firstLevelItem = _ref.firstLevelItem,
    currentCategoryIndex = _ref.currentCategoryIndex;
  var filteredBanners = banners.slice(0, MAX_BANNERS);
  var _useSiSMenuHook = useSiSMenuHook$1(),
    widthPerElment = _useSiSMenuHook.widthPerElment;
  var getContentForBanenr = function getContentForBanenr(banner) {
    return jsxs(Fragment$1, {
      children: [jsx("div", {
        className: styles$18.title,
        style: {
          width: !isIpadPotrait() ? "".concat(widthPerElment, "px") : '100%'
        },
        children: !isIpadPotrait() ? formatTextWithShowMore(banner.item_name, MAX_CHARACTERES_BANNER_CAPTION) : banner.item_name
      }), isIpadPotrait() ? jsx(CSImage$1, {
        src: banner.image.mobile.url,
        quality: 70,
        lazyLoad: false,
        auto: "webp",
        alt: banner.item_name
      }) : jsx(CSImage$1, {
        src: banner.image.desktop.url,
        quality: 70,
        auto: "webp",
        lazyLoad: false,
        alt: banner.item_name
      })]
    });
  };
  var wrapWithLink = function wrapWithLink(banner, body) {
    return jsx("a", {
      "data-cta": "true",
      href: banner.item_url.href,
      target: banner.new_tab ? '_blank' : '_self',
      className: classNames(styles$18['hover-effect'], styles$18['item-link']),
      rel: "noreferrer",
      children: body
    });
  };
  return jsx("div", {
    className: classNames(styles$18.container, classes.join(' ')),
    style: style,
    id: id,
    children: filteredBanners.map(function (banner, index) {
      return jsx("div", {
        className: styles$18['banner-item'],
        style: {
          width: !isIpadPotrait() ? "".concat(widthPerElment, "px") : '100%'
        },
        onClick: function onClick() {
          return updateDigitalDataCookies({
            firstLevelItem: firstLevelItem,
            secondLevelItem: "B ".concat(banner.item_name),
            thirdLevelItem: "B ".concat(banner.item_name),
            positionOne: currentCategoryIndex + 1,
            positionTwo: index + 1,
            positionThree: 0,
            tag: SIS_NAVIGATION,
            dataWrapper: dataWrapper
          });
        },
        children: banner.item_url && banner.item_url.href ? wrapWithLink(banner, getContentForBanenr(banner)) : jsx("div", {
          className: styles$18['item-link'],
          children: getContentForBanenr(banner)
        })
      }, index);
    })
  });
};
Banners.propTypes = {
  banners: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string,
    item_url: PropTypes.shape({
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  })),
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string
};
Banners.defaultProps = {
  classes: [],
  style: {},
  id: undefined
};
var Banners$1 = Banners;

var styles$17 = {"hlc-container":"HighlightLevelCategories-module_hlc-container__U9gqg","container":"HighlightLevelCategories-module_container__FKKet","item":"HighlightLevelCategories-module_item__pbNed","secondaryText":"HighlightLevelCategories-module_secondaryText__d4SWu","mobile-container":"HighlightLevelCategories-module_mobile-container__D5tRA","with-sidemenu":"HighlightLevelCategories-module_with-sidemenu__Q03P4"};

var styles$16 = {"carousel-indicators-container":"CarouselIndicators-module_carousel-indicators-container__kzN1g","active-indicator":"CarouselIndicators-module_active-indicator__k7UV4","indicator":"CarouselIndicators-module_indicator__0yXmy","carousel-indicators":"CarouselIndicators-module_carousel-indicators__MzNfY"};

var CarouselIndicators = function CarouselIndicators(_ref) {
  var pagesCount = _ref.pagesCount,
    activeIndex = _ref.activeIndex,
    onIndicatorClick = _ref.onIndicatorClick;
  var indicators = [];
  var _loop = function _loop(indicatorIndex) {
    indicators.push(jsx("li", {
      "data-testid": "carousel-indicator-".concat(indicatorIndex),
      onClick: function onClick() {
        return onIndicatorClick(indicatorIndex);
      },
      className: classNames(activeIndex === indicatorIndex ? styles$16['active-indicator'] : styles$16.indicator)
    }, indicatorIndex));
  };
  for (var indicatorIndex = 0; indicatorIndex < pagesCount; indicatorIndex += 1) {
    _loop(indicatorIndex);
  }
  return jsx("div", {
    className: classNames('carousel-indicators', 'w-100', 'd-flex', 'justify-content-center', 'mx-0', styles$16['carousel-indicators-container']),
    children: jsx("ol", {
      className: classNames(styles$16['carousel-indicators'], {
        'd-none': indicators.length < 2
      }, 'm-0 p-0'),
      children: indicators
    })
  });
};
CarouselIndicators.displayName = 'CarouselIndicators';
CarouselIndicators.propTypes = {
  pagesCount: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  onIndicatorClick: PropTypes.func
};
CarouselIndicators.defaultProps = {
  onIndicatorClick: function onIndicatorClick() {}
};
var CarouselIndicators$1 = CarouselIndicators;

var setSlideWidthToCards = (function (page, slideCenterWidth) {
  var children = page.props.children;
  var childrenToRender = children || page;
  return React.Children.map(childrenToRender, function (item) {
    var props = {
      screencenterx: slideCenterWidth
    };
    return React.cloneElement(item, props);
  });
});

var styles$15 = {"carousel-wrapper":"MobileCarousel-module_carousel-wrapper__akWwb","mobile-carousel":"MobileCarousel-module_mobile-carousel__gwcCE","slide-height-reference":"MobileCarousel-module_slide-height-reference__nby2w","carousel-row":"MobileCarousel-module_carousel-row__RqCaT"};

var MobileCarousel = function MobileCarousel(_ref) {
  var titleText = _ref.titleText,
    pages = _ref.pages,
    titleClassName = _ref.titleClassName,
    hideIndicators = _ref.hideIndicators,
    marginStyleIndicators = _ref.marginStyleIndicators;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    pagesCount = _useState4[0],
    setPagesCount = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    visibleWidth = _useState6[0],
    setVisibleWidth = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    centerPos = _useState8[0],
    setcenterPos = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2);
    _useState0[0];
    var setScrolledX = _useState0[1];
  var sliderRef = useRef(null);
  var visibleRef = useRef(null);
  useEffect(function () {
    if (sliderRef.current && visibleRef.current && pagesCount === 0) {
      var sliderW = sliderRef.current.scrollWidth;
      var visibleW = visibleRef.current.clientWidth;
      setPagesCount(Math.ceil(sliderW / visibleW));
      setVisibleWidth(visibleW);
      setcenterPos(visibleW * 0.5);
    }
  }, [visibleRef, sliderRef]);
  var handleScroll = function handleScroll(e) {
    var page = (e.target.scrollLeft + centerPos) / visibleWidth;
    var roundedPage = page < 1 ? 0 : Math.round(page);
    setActiveIndex(roundedPage === pagesCount ? pagesCount - 1 : roundedPage);
    setScrolledX(e.target.scrollLeft);
  };
  var referenceItem;
  if (pages[0]) {
    referenceItem = jsx("div", {
      className: styles$15['slide-height-reference'],
      children: pages[0]
    });
  }
  if (pages.length === 0) return jsx(Fragment, {});
  return jsxs("div", {
    ref: visibleRef,
    "data-testid": "mobile-carousel",
    className: classNames('mobile-carousel', styles$15['carousel-wrapper']),
    onScroll: handleScroll,
    children: [titleText && jsx("div", {
      className: titleClassName,
      children: titleText
    }), jsxs("div", {
      className: styles$15['mobile-carousel'],
      children: [referenceItem, jsx("div", {
        ref: sliderRef,
        "data-testid": "mobile-carousel-row",
        className: "".concat(styles$15['carousel-row'], " mobile-carousel-row"),
        children: React.Children.map(pages, function (item) {
          return setSlideWidthToCards(item, centerPos);
        })
      })]
    }), !hideIndicators && jsx(CarouselIndicators$1, {
      pagesCount: pagesCount,
      activeIndex: activeIndex,
      marginStyle: marginStyleIndicators
    })]
  });
};
MobileCarousel.propTypes = {
  titleText: PropTypes.string,
  titleClassName: PropTypes.string,
  pages: PropTypes.array.isRequired,
  hideIndicators: PropTypes.bool,
  marginStyleIndicators: PropTypes.string
};
MobileCarousel.defaultProps = {
  titleClassName: '',
  pages: [],
  hideIndicators: false,
  marginStyleIndicators: ''
};
var MobileCarousel$1 = MobileCarousel;

function ownKeys$q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$q(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MobileCard = function MobileCard(_ref) {
  var _itemImage$mobile$url, _itemImage$mobile;
  var isNewTab = _ref.isNewTab,
    itemName = _ref.itemName,
    itemUrl = _ref.itemUrl,
    itemImage = _ref.itemImage,
    dataWrapper = _ref.dataWrapper,
    firstLevelItem = _ref.firstLevelItem,
    currentCategoryIndex = _ref.currentCategoryIndex,
    index = _ref.index,
    itemColor = _ref.itemColor;
  return jsxs("a", _objectSpread$q(_objectSpread$q({
    className: styles$17.item,
    "data-cta": "true",
    target: isNewTab ? '_blank' : '_self',
    rel: "noreferrer"
  }, itemUrl ? {
    href: itemUrl
  } : {}), {}, {
    onClick: function onClick() {
      return updateDigitalDataCookies({
        firstLevelItem: firstLevelItem,
        secondLevelItem: "H ".concat(itemName),
        thirdLevelItem: "H ".concat(itemName),
        positionOne: currentCategoryIndex + 1,
        positionTwo: index + 1,
        positionThree: 0,
        tag: SIS_NAVIGATION,
        dataWrapper: dataWrapper
      });
    },
    children: [' ', jsx(CSImage$1, {
      src: (_itemImage$mobile$url = itemImage === null || itemImage === void 0 || (_itemImage$mobile = itemImage.mobile) === null || _itemImage$mobile === void 0 ? void 0 : _itemImage$mobile.url) !== null && _itemImage$mobile$url !== void 0 ? _itemImage$mobile$url : '',
      quality: 70,
      auto: "webp",
      alt: ''
    }), jsx("span", {
      style: itemColor ? {
        color: itemColor
      } : {},
      children: itemName
    })]
  }));
};
var HighlightLevelCategories = function HighlightLevelCategories(_ref2) {
  var highlightLevelCategories = _ref2.highlightLevelCategories,
    dataWrapper = _ref2.dataWrapper,
    currentCategoryIndex = _ref2.currentCategoryIndex,
    highLightedCategoryIndex = _ref2.highLightedCategoryIndex,
    firstLevelItem = _ref2.firstLevelItem,
    isOpen = _ref2.isOpen,
    highlightLevelCategoryColor = _ref2.highlightLevelCategoryColor,
    enableSISMenuV2 = _ref2.enableSISMenuV2,
    menuIndex = _ref2.menuIndex;
  var filteredHighlightLevelCategories = highlightLevelCategories.slice(0, MAX_HIGHLIGHTS);
  var getMobilePages = function getMobilePages() {
    return filteredHighlightLevelCategories.map(function (data, index) {
      return jsx(MobileCard, {
        className: styles$17['product-item'],
        index: index,
        isNewTab: data.new_tab,
        itemName: data.item_name,
        itemUrl: data.item_url,
        itemImage: data.item_image,
        dataWrapper: dataWrapper,
        firstLevelItem: firstLevelItem,
        itemColor: data.item_color,
        currentCategoryIndex: currentCategoryIndex
      }, "HLC_".concat(index, "_").concat(data.item_name));
    });
  };
  return jsx("div", {
    className: styles$17['hlc-container'],
    "data-testid": "HighlightLevelCategories",
    children: isIpadPotrait() ? jsx("div", {
      className: classNames(styles$17['mobile-container'], _defineProperty({}, styles$17['with-sidemenu'], enableSISMenuV2)),
      children: jsx(MobileCarousel$1, {
        pages: getMobilePages(),
        hideIndicators: false
      })
    }) : jsx("div", {
      className: styles$17.container,
      children: filteredHighlightLevelCategories.map(function (_ref3, index) {
        var _item_image$desktop$u, _item_image$desktop;
        var new_tab = _ref3.new_tab,
          item_name = _ref3.item_name,
          item_url = _ref3.item_url,
          item_image = _ref3.item_image,
          item_color = _ref3.item_color;
        return jsxs("a", _objectSpread$q(_objectSpread$q({
          className: styles$17.item,
          "data-cta": "true",
          target: new_tab ? '_blank' : '_self',
          rel: "noreferrer"
        }, item_url ? {
          href: item_url
        } : {}), {}, {
          onClick: function onClick() {
            return updateDigitalDataCookies({
              firstLevelItem: firstLevelItem,
              secondLevelItem: "H ".concat(item_name),
              thirdLevelItem: "H ".concat(item_name),
              positionOne: menuIndex + 1,
              positionTwo: index + 1,
              positionThree: 0,
              tag: SIS_NAVIGATION,
              dataWrapper: dataWrapper
            });
          },
          children: [' ', isOpen && currentCategoryIndex === highLightedCategoryIndex && jsx(CSImage$1, {
            "data-testid": "CSImageDesktop",
            src: (_item_image$desktop$u = item_image === null || item_image === void 0 || (_item_image$desktop = item_image.desktop) === null || _item_image$desktop === void 0 ? void 0 : _item_image$desktop.url) !== null && _item_image$desktop$u !== void 0 ? _item_image$desktop$u : '',
            quality: 70,
            width: "80p",
            auto: "webp",
            alt: '',
            lazyLoad: false
          }), jsx("span", {
            style: {
              color: getCategoryColor(highlightLevelCategoryColor, item_color)
            },
            className: classNames(_defineProperty({}, styles$17.secondaryText, enableSISMenuV2)),
            children: item_name
          })]
        }), "HLC_".concat(index, "_").concat(item_name));
      })
    })
  });
};
HighlightLevelCategories.propTypes = {
  highlightLevelCategories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string,
    item_url: PropTypes.string,
    new_tab: PropTypes.bool,
    item_image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      }),
      app: PropTypes.shape({
        url: PropTypes.string
      })
    })
  })),
  isOpen: PropTypes.bool,
  highlightLevelCategoryColor: PropTypes.string
};
HighlightLevelCategories.defaultProps = {
  isOpen: false,
  isSodimacStandalone: false
};
var HighlightLevelCategories$1 = HighlightLevelCategories;

var PROMOTION_TYPE = {
  TWO_BANNERS: '2-banners',
  THREE_BANNERS: '3-banners',
  RECOMMENDATIONCAROUSEL: 'recommendation-caraousel'
};
var TWO_BANNER_COUNT = 2;
var THREE_BANNER_COUNT = 3;

var styles$14 = {"container":"TwoBanners-module_container__5XrPa","banner-item":"TwoBanners-module_banner-item__7iJhS","hover-effect":"TwoBanners-module_hover-effect__NVsib","title":"TwoBanners-module_title__onpYf","item-link":"TwoBanners-module_item-link__Yp0EQ"};

var highlightLastWord = function highlightLastWord(name) {
  var words = name.trim().split(' ');
  return words.length === 1 ? name : "".concat(words.slice(0, -1).join(' '), " <strong>").concat(words.at(-1), "</strong>");
};
var highlightLastWord$1 = highlightLastWord;

var styles$13 = {"item-link":"LinkWrapper-module_item-link__3E9WE"};

var _excluded$1 = ["url", "newTab", "children", "className"];
function ownKeys$p(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$p(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$p(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$p(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LinkWrapper = function LinkWrapper(_ref) {
  var url = _ref.url,
    newTab = _ref.newTab,
    children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var combinedClassName = classNames(styles$13['item-link'], className);
  if (!url) {
    return jsx("div", _objectSpread$p(_objectSpread$p({
      className: combinedClassName
    }, rest), {}, {
      children: children
    }));
  }
  return jsx("a", _objectSpread$p(_objectSpread$p({
    href: url,
    target: newTab ? '_blank' : '_self',
    rel: "noreferrer",
    "data-cta": "true",
    className: combinedClassName
  }, rest), {}, {
    children: children
  }));
};
LinkWrapper.propTypes = {
  url: PropTypes.string,
  newTab: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};
LinkWrapper.defaultProps = {
  url: '',
  newTab: false,
  className: ''
};
var LinkWrapper$1 = LinkWrapper;

var TwoBanners = function TwoBanners(_ref) {
  var data = _ref.data,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    dataWrapper = _ref.dataWrapper,
    firstLevelItem = _ref.firstLevelItem,
    currentCategoryIndex = _ref.currentCategoryIndex,
    isService = _ref.isService;
  var _ref2 = data || {},
    _ref2$two_banners = _ref2.two_banners,
    two_banners = _ref2$two_banners === void 0 ? {} : _ref2$two_banners;
  var banners = Array.isArray(two_banners.banners) ? two_banners.banners.slice(0, TWO_BANNER_COUNT) : [];
  var firstLevelItemName = isService ? "SRV ".concat(firstLevelItem) : firstLevelItem;
  var getBannerContent = function getBannerContent(banner) {
    var _banner$image, _banner$image2;
    return jsxs(Fragment$1, {
      children: [jsx(CSImage$1, {
        src: isIpadPotrait() ? banner === null || banner === void 0 || (_banner$image = banner.image) === null || _banner$image === void 0 || (_banner$image = _banner$image.mobile) === null || _banner$image === void 0 ? void 0 : _banner$image.url : banner === null || banner === void 0 || (_banner$image2 = banner.image) === null || _banner$image2 === void 0 || (_banner$image2 = _banner$image2.desktop) === null || _banner$image2 === void 0 ? void 0 : _banner$image2.url,
        quality: 70,
        lazyLoad: false,
        auto: "webp",
        alt: banner === null || banner === void 0 ? void 0 : banner.title
      }), banner.title && jsx("div", {
        className: styles$14.title,
        dangerouslySetInnerHTML: {
          __html: highlightLastWord$1(banner.title)
        }
      })]
    });
  };
  return jsx("div", {
    className: classNames(styles$14.container, classes.join(' ')),
    style: style,
    id: id,
    children: banners.map(function (banner, index) {
      return jsx("div", {
        className: styles$14['banner-item'],
        onClick: function onClick() {
          return updateDigitalDataCookies({
            firstLevelItem: firstLevelItemName,
            secondLevelItem: "CB2 ".concat(banner.title),
            thirdLevelItem: "CB2 ".concat(banner.title),
            positionOne: currentCategoryIndex + 1,
            positionTwo: index + 1,
            positionThree: 0,
            tag: SIS_NAVIGATION,
            dataWrapper: dataWrapper
          });
        },
        children: jsx(LinkWrapper$1, {
          url: banner === null || banner === void 0 ? void 0 : banner.url,
          newTab: banner === null || banner === void 0 ? void 0 : banner.new_tab,
          className: classNames(_defineProperty({}, styles$14['hover-effect'], banner === null || banner === void 0 ? void 0 : banner.url)),
          children: getBannerContent(banner)
        })
      }, index);
    })
  });
};
TwoBanners.propTypes = {
  banners: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string,
    item_url: PropTypes.shape({
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  })),
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  isService: PropTypes.bool
};
TwoBanners.defaultProps = {
  classes: [],
  style: {},
  id: undefined,
  isService: false
};
var TwoBanners$1 = TwoBanners;

var styles$12 = {"container":"ThreeBanners-module_container__IhYEn","title":"ThreeBanners-module_title__dZv2S","banner-item":"ThreeBanners-module_banner-item__WQwLk","item-link":"ThreeBanners-module_item-link__BHZjD","hover-effect":"ThreeBanners-module_hover-effect__uYrEq"};

var ThreeBanners = function ThreeBanners(_ref) {
  var data = _ref.data,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    dataWrapper = _ref.dataWrapper,
    firstLevelItem = _ref.firstLevelItem,
    currentCategoryIndex = _ref.currentCategoryIndex,
    isService = _ref.isService;
  var _ref2 = data || {},
    _ref2$three_banners = _ref2.three_banners,
    three_banners = _ref2$three_banners === void 0 ? {} : _ref2$three_banners;
  var title = three_banners.title;
  var firstLevelItemName = isService ? "SRV ".concat(firstLevelItem) : firstLevelItem;
  var banners = Array.isArray(three_banners === null || three_banners === void 0 ? void 0 : three_banners.banners) ? three_banners.banners.slice(0, THREE_BANNER_COUNT) : [];
  var getBannerContent = function getBannerContent(banner) {
    var _banner$image, _banner$image2;
    return jsx(CSImage$1, {
      src: isIpadPotrait() ? banner === null || banner === void 0 || (_banner$image = banner.image) === null || _banner$image === void 0 || (_banner$image = _banner$image.mobile) === null || _banner$image === void 0 ? void 0 : _banner$image.url : banner === null || banner === void 0 || (_banner$image2 = banner.image) === null || _banner$image2 === void 0 || (_banner$image2 = _banner$image2.desktop) === null || _banner$image2 === void 0 ? void 0 : _banner$image2.url,
      quality: 70,
      lazyLoad: false,
      auto: "webp",
      alt: title
    });
  };
  return jsxs("div", {
    className: classNames(styles$12.container, classes.join(' ')),
    style: style,
    id: id,
    children: [title && jsx("div", {
      className: styles$12.title,
      dangerouslySetInnerHTML: {
        __html: highlightLastWord$1(title)
      }
    }), banners.map(function (banner, index) {
      return jsx("div", {
        className: styles$12['banner-item'],
        onClick: function onClick() {
          return updateDigitalDataCookies({
            firstLevelItem: firstLevelItemName,
            secondLevelItem: "CB3 ".concat(title),
            thirdLevelItem: "CB3 ".concat(title),
            positionOne: currentCategoryIndex + 1,
            positionTwo: index + 1,
            positionThree: 0,
            tag: SIS_NAVIGATION,
            dataWrapper: dataWrapper
          });
        },
        children: jsx(LinkWrapper$1, {
          url: banner === null || banner === void 0 ? void 0 : banner.url,
          newTab: banner === null || banner === void 0 ? void 0 : banner.new_tab,
          className: classNames(_defineProperty({}, styles$12['hover-effect'], banner === null || banner === void 0 ? void 0 : banner.url)),
          children: getBannerContent(banner)
        })
      }, index);
    })]
  });
};
ThreeBanners.propTypes = {
  banners: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string,
    item_url: PropTypes.shape({
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  })),
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  isService: PropTypes.bool
};
ThreeBanners.defaultProps = {
  classes: [],
  style: {},
  id: undefined,
  isService: false
};
var ThreeBanners$1 = ThreeBanners;

var styles$11 = {"container":"PromotionalCarousel-module_container__WXW-3","containerMobile":"PromotionalCarousel-module_containerMobile__AOKg6"};

var apiConfig$2 = {
  getSisHomeUrl: function getSisHomeUrl(_ref) {
    var tenant = _ref.tenant,
      store = _ref.store,
      env = _ref.env;
    var host = getHost(tenant, store, env);
    var storeName = STORE_MAP[tenant][store.toLowerCase()];
    var BU = storeName || 'falabella';
    return "".concat(host, "/").concat(BU, "-").concat(tenant);
  },
  getHomeUrl: function getHomeUrl(_ref2) {
    var tenant = _ref2.tenant,
      store = _ref2.store,
      env = _ref2.env;
    var _getStandaloneSite = getStandaloneSite(store),
      isStandaloneSite = _getStandaloneSite.isStandaloneSite,
      isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
    var isCustomSite = isStandaloneSite || isWhitelabelSite;
    var host = getHost(tenant, isCustomSite ? store : undefined, env);
    return "".concat(host, "/").concat(isCustomSite ? STORE_MAP[tenant][store] : 'falabella', "-").concat(tenant);
  },
  getTypeaheadUrl: function getTypeaheadUrl(term, tenant, isAndes, store) {
    var env = getEnvironment();
    if (!env) {
      env = 'production';
    }
    var subdomain = env === 'production' ? 'www' : env;
    var searchParams = new URLSearchParams({
      source: 'web'
    });
    if (isAndes) {
      searchParams.append('isAndes', 'true');
    }
    if (store) {
      searchParams.append('site', store);
    }
    return "https://".concat(subdomain, ".falabella.com/s/browse/v1/typeahead/").concat(tenant, "/").concat(term, "?").concat(searchParams.toString());
  },
  getRecommendationProducts: function getRecommendationProducts(_ref3) {
    var contextId = _ref3.contextId,
      pageType = _ref3.pageType,
      site = _ref3.site,
      slots = _ref3.slots,
      politicalId = _ref3.politicalId,
      priceGroupId = _ref3.priceGroupId,
      zones = _ref3.zones,
      channel = _ref3.channel,
      _ref3$bypassCache = _ref3.bypassCache,
      bypassCache = _ref3$bypassCache === void 0 ? true : _ref3$bypassCache,
      webCategoryId = _ref3.webCategoryId;
    var tenant = 'cl';
    var base = typeof window !== 'undefined' ? window.location.origin : getHost(tenant);
    var hostUrl = getStoreBaseUrl(tenant, base);
    return "".concat(hostUrl, "/s/browse/v2/recommended-products/").concat(tenant, "?channel=").concat(channel, "&site=").concat(site, "&pageType=").concat(pageType, "&bypass_cache=").concat(bypassCache, "&slots=").concat(slots, "&contextId=").concat(contextId, "&politicalId=").concat(politicalId, "&priceGroupId=").concat(priceGroupId, "&zones=").concat(zones, "&webCategoryId=").concat(webCategoryId);
  }
};

var PromotionalCarousel = function PromotionalCarousel(props) {
  var webCategoryId = props.webCategoryId,
    slots = props.slots,
    deviceType = props.deviceType,
    firstLevelItem = props.firstLevelItem,
    currentCategoryIndex = props.currentCategoryIndex,
    dataWrapper = props.dataWrapper,
    isProductButtonVisible = props.isProductButtonVisible;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    products = _useState2[0],
    setProducts = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showSkeleton = _useState4[0],
    setShowSkeleton = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    title = _useState6[0],
    setTitle = _useState6[1];
  var contextId = CookieStorage$1.getCookie('contextID');
  var politicalId = CookieStorage$1.getCookie('politicalId');
  var priceGroupId = CookieStorage$1.getCookie('priceGroupId');
  var zones = CookieStorage$1.getCookie('zones');
  var payload = {
    contextId: contextId,
    pageType: 'HOME',
    site: 'so_com',
    slots: slots,
    politicalId: politicalId,
    priceGroupId: priceGroupId,
    zones: zones,
    channel: 'standalone_web',
    bypass_cache: true,
    webCategoryId: webCategoryId
  };
  useEffect(function () {
    if (!slots || !webCategoryId) {
      setProducts([]);
      setShowSkeleton(false);
      return;
    }
    var url = apiConfig$2.getRecommendationProducts(payload);
    fetch(url).then(function (res) {
      return res.json();
    }).then(function (data) {
      setProducts(data.widgets[0].data);
      setTitle(data.widgets[0].name);
    }).then(function () {
      return setShowSkeleton(false);
    })["catch"](function (err) {
      console.error('Error fetching products:', err);
      setTimeout(function () {
        return setShowSkeleton(false);
      }, 1000);
      setProducts([]);
    });
  }, [contextId, politicalId, priceGroupId, zones, showSkeleton, slots, webCategoryId]);
  var maxProducts = 8;
  var visibleProducts = products.slice(0, maxProducts);
  return jsx("div", {
    children: ((products === null || products === void 0 ? void 0 : products.length) > 0 || showSkeleton) && jsx("div", {
      className: "".concat(styles$11.container, " ").concat(deviceType === 'mobile' ? styles$11.containerMobile : ''),
      children: jsx(Carousel, {
        analytics: {
          onRender: function onRender() {
            updateDigitalDataCookies({
              firstLevelItem: firstLevelItem,
              secondLevelItem: "PC ".concat(firstLevelItem),
              thirdLevelItem: "PC ".concat(firstLevelItem),
              positionOne: currentCategoryIndex + 1,
              positionTwo: currentCategoryIndex + 1,
              positionThree: 0,
              tag: SIS_NAVIGATION,
              dataWrapper: dataWrapper
            });
          }
        },
        deviceType: deviceType,
        labels: {
          podButtonText: 'Ver producto',
          sponsoredText: '',
          title: title
        },
        showPaginationMobile: true,
        enableAutoPlay: {
          isEnabled: true,
          timeout: 4000,
          resumeDelay: 6000
        },
        titleStyle: {
          fontSize: '16px'
        },
        products: visibleProducts,
        showSkeleton: showSkeleton,
        isProductButtonVisible: isProductButtonVisible
      })
    })
  });
};
PromotionalCarousel.propTypes = {
  webCategoryId: PropTypes.string,
  slots: PropTypes.string,
  firstLevelItem: PropTypes.string,
  deviceType: PropTypes.string,
  currentCategoryIndex: PropTypes.number,
  dataWrapper: PropTypes.string,
  isProductButtonVisible: PropTypes.bool
};
PromotionalCarousel.defaultProps = {
  webCategoryId: '',
  slots: ''
};
var PromotionalCarousel$1 = PromotionalCarousel;

function ownKeys$o(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$o(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$o(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$o(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PromotionalBanners = function PromotionalBanners(props) {
  var data = props.data;
  switch (data === null || data === void 0 ? void 0 : data.banner_type) {
    case PROMOTION_TYPE.TWO_BANNERS:
      return jsx(TwoBanners$1, _objectSpread$o({}, props));
    case PROMOTION_TYPE.THREE_BANNERS:
      return jsx(ThreeBanners$1, _objectSpread$o({}, props));
    case PROMOTION_TYPE.RECOMMENDATIONCAROUSEL:
      return jsx(PromotionalCarousel$1, _objectSpread$o({}, props));
    default:
      return jsx(TwoBanners$1, _objectSpread$o({}, props));
  }
};
PromotionalBanners.propTypes = {
  data: PropTypes.shape({
    banner_type: PropTypes.string
  }).isRequired
};
var PromotionalBanners$1 = PromotionalBanners;

function ownKeys$n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$n(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useCategoryState() {
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    currentCategoryIndex = _useState2[0],
    setCurrentCategoryIndex = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    firstLevelItem = _useState4[0],
    setFirstLevelItem = _useState4[1];
  var _useState5 = useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    index = _useState6[0],
    setIndex = _useState6[1];
  var handleSetCurrentCategoryIndex = function handleSetCurrentCategoryIndex(i) {
    return setCurrentCategoryIndex(i);
  };
  var handleSetFirstLevelItem = function handleSetFirstLevelItem(item) {
    return setFirstLevelItem(item);
  };
  var handleSetIndex = function handleSetIndex(i) {
    return setIndex(i);
  };
  return {
    currentCategoryIndex: currentCategoryIndex,
    firstLevelItem: firstLevelItem,
    index: index,
    handleSetCurrentCategoryIndex: handleSetCurrentCategoryIndex,
    handleSetFirstLevelItem: handleSetFirstLevelItem,
    handleSetIndex: handleSetIndex
  };
}
var CategoryContext = createContainer(useCategoryState);
var _CategoryContext = _slicedToArray(CategoryContext, 2),
  CategoryProvider = _CategoryContext[0],
  useCategoryContext = _CategoryContext[1];
var withCategoryState = function withCategoryState(WrappedComponent) {
  var ComponentWithCategory = function ComponentWithCategory(props) {
    var categoryState = useCategoryContext();
    return jsx(WrappedComponent, _objectSpread$n(_objectSpread$n({}, props), {}, {
      categoryState: categoryState
    }));
  };
  if (typeof WrappedComponent.getInitialProps === 'function') {
    ComponentWithCategory.getInitialProps = WrappedComponent.getInitialProps;
  }
  ComponentWithCategory.originalName = 'WrappedComponent';
  ComponentWithCategory.displayName = 'withCategoryState';
  return ComponentWithCategory;
};

var styles$10 = {"navigation":"SideMenu-module_navigation__6ct-4","r-wrap":"SideMenu-module_r-wrap__l7IA1","with-services":"SideMenu-module_with-services__BXXdO","title":"SideMenu-module_title__ENhdT","category-title":"SideMenu-module_category-title__ZA8fS","ruler":"SideMenu-module_ruler__Qm8I7","seperator":"SideMenu-module_seperator__W-BR5","item-container":"SideMenu-module_item-container__aX4SM","iconBox":"SideMenu-module_iconBox__nVYE0","icon":"SideMenu-module_icon__gsOQF","label":"SideMenu-module_label__lz9zD","itemWrapper":"SideMenu-module_itemWrapper__v14rv","with-icon":"SideMenu-module_with-icon__-yvxM","chevron-right":"SideMenu-module_chevron-right__94jOb"};

var useSideMenuData = function useSideMenuData(_ref) {
  var categories = _ref.categories,
    dataWrapper = _ref.dataWrapper,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor;
  var categorizedItems = useMemo(function () {
    return categories.map(function (item, originalIndex) {
      return {
        item: item,
        originalIndex: originalIndex
      };
    });
  }, [categories]);
  var serviceItems = categorizedItems.filter(function (_ref2) {
    var item = _ref2.item;
    return item.isService;
  });
  var categoryItems = categorizedItems.filter(function (_ref3) {
    var item = _ref3.item;
    return !item.isService;
  });
  var hasServices = serviceItems.length > 0;
  var hasCategories = categoryItems.length > 0;
  var hasBothSections = hasServices && hasCategories;
  var hightLightStyle = useMemo(function () {
    return {
      backgroundColor: hightlightColor,
      color: hightlightTextColor
    };
  }, [hightlightColor, hightlightTextColor]);
  var hasChildrenItems = function hasChildrenItems(category) {
    var _category$highlight_l, _category$second_leve, _category$banners;
    return ((_category$highlight_l = category.highlight_level_categories) === null || _category$highlight_l === void 0 ? void 0 : _category$highlight_l.length) > 0 || ((_category$second_leve = category.second_level_categories) === null || _category$second_leve === void 0 ? void 0 : _category$second_leve.length) > 0 || ((_category$banners = category.banners) === null || _category$banners === void 0 ? void 0 : _category$banners.length) > 0;
  };
  var handleClick = function handleClick(category, index) {
    if (!hasChildrenItems(category)) {
      var itemName = category !== null && category !== void 0 && category.isService ? "SRV ".concat(category.item_name) : category.item_name;
      updateDigitalDataCookies({
        firstLevelItem: itemName,
        secondLevelItem: itemName,
        thirdLevelItem: itemName,
        positionOne: index,
        positionTwo: 0,
        positionThree: 0,
        tag: SIS_NAVIGATION,
        dataWrapper: dataWrapper
      });
    }
  };
  return {
    categoryItems: categoryItems,
    serviceItems: serviceItems,
    hasBothSections: hasBothSections,
    hightLightStyle: hightLightStyle,
    hasChildrenItems: hasChildrenItems,
    handleClick: handleClick
  };
};
var useSideMenuData$1 = useSideMenuData;

var SideMenu = function SideMenu(_ref) {
  var categories = _ref.categories,
    isOpen = _ref.isOpen,
    onItemWithSubCategoriesSelected = _ref.onItemWithSubCategoriesSelected,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    dataWrapper = _ref.dataWrapper,
    levelOneCategoryColor = _ref.levelOneCategoryColor,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    categoryState = _ref.categoryState,
    showCategoryFirst = _ref.showCategoryFirst,
    categoryHeaderTitle = _ref.categoryHeaderTitle,
    serviceHeaderTitle = _ref.serviceHeaderTitle;
  var _useSideMenuData = useSideMenuData$1({
      categories: categories,
      dataWrapper: dataWrapper,
      hightlightColor: hightlightColor,
      hightlightTextColor: hightlightTextColor
    }),
    categoryItems = _useSideMenuData.categoryItems,
    serviceItems = _useSideMenuData.serviceItems,
    hasBothSections = _useSideMenuData.hasBothSections,
    hightLightStyle = _useSideMenuData.hightLightStyle,
    hasChildrenItems = _useSideMenuData.hasChildrenItems,
    handleClick = _useSideMenuData.handleClick;
  useEffect(function () {
    if (categories.length > 0) {
      onItemWithSubCategoriesSelected(isOpen, 0, categories[0].item_name);
    }
  }, [isOpen]);
  var renderItem = function renderItem(_ref2) {
    var _category$item_url, _category$tag, _category$tag2;
    var category = _ref2.item,
      originalIndex = _ref2.originalIndex;
    var isActive = isOpen && originalIndex === categoryState.currentCategoryIndex;
    var hasChildren = hasChildrenItems(category);
    var href = (_category$item_url = category.item_url) !== null && _category$item_url !== void 0 && _category$item_url.href && !hasChildren ? category.item_url.href : '#';
    var style = isActive ? hightLightStyle : {
      color: getCategoryColor(levelOneCategoryColor, category.item_color)
    };
    return jsxs("a", {
      "data-cta": "true",
      target: category.new_tab && !hasChildren ? '_blank' : '_self',
      rel: "noreferrer",
      href: href,
      onMouseEnter: function onMouseEnter() {
        return onItemWithSubCategoriesSelected(undefined, originalIndex, category.item_name, category.menuIndex);
      },
      onClick: function onClick() {
        return handleClick(category, category.menuIndex + 1);
      },
      className: classNames(styles$10.itemWrapper, _defineProperty({}, styles$10['with-icon'], enableSISMenuV2)),
      style: style,
      children: [jsxs("span", {
        className: styles$10['item-container'],
        children: [enableSISMenuV2 && !isEmpty(category === null || category === void 0 ? void 0 : category.icon) && jsx("div", {
          className: styles$10.iconBox,
          children: jsx("img", {
            className: styles$10.icon,
            src: category.icon.url,
            alt: category.item_name
          })
        }), jsx("span", {
          className: styles$10['item-name'],
          children: category.item_name
        })]
      }), jsxs("span", {
        className: styles$10['r-wrap'],
        children: [enableSISMenuV2 && (category === null || category === void 0 || (_category$tag = category.tag) === null || _category$tag === void 0 ? void 0 : _category$tag.show) && (category === null || category === void 0 || (_category$tag2 = category.tag) === null || _category$tag2 === void 0 ? void 0 : _category$tag2.text) && jsx("span", {
          className: styles$10.label,
          style: {
            color: category.tag.color,
            backgroundColor: category.tag.backgroundColor
          },
          children: category.tag.text
        }), hasChildren && jsx("i", {
          "aria-hidden": "true",
          className: styles$10['chevron-right']
        })]
      })]
    }, "L1_".concat(category.item_name, "_").concat(originalIndex));
  };
  var renderCategorySection = function renderCategorySection(title, items, isrenderSecond) {
    if (items.length === 0) return null;
    return jsxs(Fragment, {
      children: [enableSISMenuV2 && jsxs(Fragment$1, {
        children: [jsx("div", {
          className: classNames(styles$10.title, _defineProperty({}, styles$10['category-title'], isrenderSecond && hasBothSections)),
          children: title
        }), jsx("span", {
          className: classNames(styles$10.ruler)
        })]
      }), items.map(renderItem), enableSISMenuV2 && hasBothSections && !isrenderSecond && jsx("div", {
        className: styles$10.seperator
      })]
    });
  };
  return jsx("div", {
    className: classNames(styles$10.navigation, _defineProperty({}, styles$10['with-services'], enableSISMenuV2)),
    children: showCategoryFirst ? jsxs("div", {
      children: [renderCategorySection(categoryHeaderTitle, categoryItems, false), enableSISMenuV2 && renderCategorySection(serviceHeaderTitle, serviceItems, true)]
    }) : jsxs("div", {
      children: [enableSISMenuV2 && renderCategorySection(serviceHeaderTitle, serviceItems, false), renderCategorySection(categoryHeaderTitle, categoryItems, true)]
    })
  });
};
SideMenu.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string,
  onItemWithSubCategoriesSelected: PropTypes.func,
  isOpen: PropTypes.bool,
  levelOneCategoryColor: PropTypes.any,
  dataWrapper: PropTypes.string,
  enableSISMenuV2: PropTypes.bool
};
SideMenu.defaultProps = {
  categories: [],
  hightlightColor: '',
  hightlightTextColor: '',
  isOpen: false,
  onItemWithSubCategoriesSelected: function onItemWithSubCategoriesSelected() {},
  levelOneCategoryColor: undefined,
  dataWrapper: '',
  enableSISMenuV2: false
};
var SideMenu$1 = withCategoryState(SideMenu);

var styles$$ = {"fill-full-height":"SubCategories-module_fill-full-height__w5Iza","small-height":"SubCategories-module_small-height__AEbZ2","container":"SubCategories-module_container__skWjD","subcategories":"SubCategories-module_subcategories__ukDue","has-promotional-banner":"SubCategories-module_has-promotional-banner__bgRll","second-level-category-without-banners":"SubCategories-module_second-level-category-without-banners__nHJfB","five-columns":"SubCategories-module_five-columns__hM7Xb","four-columns":"SubCategories-module_four-columns__kB7bX","second-level-category-with-banners":"SubCategories-module_second-level-category-with-banners__5fQjM","list-item":"SubCategories-module_list-item__uq-8Y","list-title":"SubCategories-module_list-title__0IJqd","secondary-list-title":"SubCategories-module_secondary-list-title__5z--f","chevron-right":"SubCategories-module_chevron-right__Z7MNJ","content":"SubCategories-module_content__zWVnf","text":"SubCategories-module_text__frWMW","secondary-text":"SubCategories-module_secondary-text__e8ECq","hover-effect":"SubCategories-module_hover-effect__kvZDU","sodimac":"SubCategories-module_sodimac__ijPsa"};

var styles$_ = {"tag":"Tag-module_tag__RoQBY","mobile":"Tag-module_mobile__YkIW8","desktop":"Tag-module_desktop__gc42G"};

var Tag = function Tag(_ref) {
  var text = _ref.text,
    background_color = _ref.background_color,
    device = _ref.device;
  return jsx("div", {
    className: classNames(styles$_.tag, styles$_["".concat(device)]),
    style: {
      background: background_color
    },
    children: cutText(text, MAX_CHARACTERES_TAG)
  });
};
Tag.propTypes = {
  text: PropTypes.string.isRequired,
  background_color: PropTypes.string,
  device: PropTypes.string
};
Tag.defaultProps = {
  background_color: ''
};
var Tag$1 = Tag;

var styles$Z = {"tooltipParent":"Tooltip-module_tooltipParent__fjymQ","default":"Tooltip-module_default__WJvPk","static":"Tooltip-module_static__Xzj-m","pointer":"Tooltip-module_pointer__0smnG","tooltipContainer":"Tooltip-module_tooltipContainer__swkvM","bottom-static":"Tooltip-module_bottom-static__lF8eq","bottom":"Tooltip-module_bottom__p8610","bottom-left":"Tooltip-module_bottom-left__KrnZw","right":"Tooltip-module_right__1Ud4U","left":"Tooltip-module_left__bTiox","top":"Tooltip-module_top__7vcgj","top-left":"Tooltip-module_top-left__eY9HF","top-middle":"Tooltip-module_top-middle__GqrMT","top-caret-left":"Tooltip-module_top-caret-left__1g3j4","bottom-right":"Tooltip-module_bottom-right__2xnWb","bottom-right-mobile":"Tooltip-module_bottom-right-mobile__kzgWA","caret":"Tooltip-module_caret__Mgkvd","fullWidth":"Tooltip-module_fullWidth__PRJ-9","tooltipText":"Tooltip-module_tooltipText__gbxM0","medium":"Tooltip-module_medium__9EVij","small":"Tooltip-module_small__-p40P","verysmall":"Tooltip-module_verysmall__v6CKZ","verysmall-2":"Tooltip-module_verysmall-2__wGLZM"};

var TooltipText = function TooltipText(_ref) {
  var text = _ref.text,
    viewType = _ref.viewType,
    color = _ref.color;
  return jsx("p", {
    style: {
      color: color
    },
    className: classNames(styles$Z.tooltipText, styles$Z["".concat(viewType)]),
    children: text
  });
};
TooltipText.defaultProps = {
  viewType: 'default',
  color: ''
};
TooltipText.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  viewType: PropTypes.oneOf(['fullWidth', 'default', 'medium', 'verysmall', 'verysmall-2'])
};
var Tooltip = function Tooltip(_ref2) {
  var tooltipContent = _ref2.tooltipContent,
    children = _ref2.children,
    hasCaret = _ref2.hasCaret,
    position = _ref2.position,
    viewType = _ref2.viewType,
    showArrow = _ref2.showArrow,
    containerStyle = _ref2.containerStyle;
  return jsx(Fragment, {
    children: jsxs("div", {
      className: classNames(styles$Z.tooltipParent, styles$Z["".concat(viewType)]),
      children: [children, jsxs("div", {
        style: containerStyle,
        className: classNames(styles$Z.tooltipContainer, styles$Z["".concat(position)]),
        children: [hasCaret && jsx("div", {
          id: "caret",
          className: classNames(styles$Z.caret, styles$Z["".concat(position)])
        }), jsx("div", {
          className: styles$Z.tooltipContent,
          children: tooltipContent
        })]
      }), showArrow && jsx("div", {
        className: styles$Z.pointer
      })]
    })
  });
};
Tooltip.defaultProps = {
  hasCaret: false,
  viewType: 'default',
  showArrow: false
};
Tooltip.propTypes = {
  children: PropTypes.object.isRequired,
  tooltipContent: PropTypes.object.isRequired,
  hasCaret: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'right', 'bottom', 'top', 'top-left', 'top-middle', 'bottom-left', 'bottom-static']).isRequired,
  viewType: PropTypes.oneOf(['fullWidth', 'default', 'medium', 'small', 'verysmall', 'static']),
  showArrow: PropTypes.bool,
  containerStyle: PropTypes.object
};
var Tooltip$1 = Tooltip;

function ownKeys$m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$m(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SubCategories$2 = function SubCategories(_ref) {
  var fillFullHeight = _ref.fillFullHeight,
    secondLevelCategories = _ref.secondLevelCategories,
    hasBanner = _ref.hasBanner,
    dataWrapper = _ref.dataWrapper,
    levelTwoCategoryColor = _ref.levelTwoCategoryColor,
    levelThreeCategoryColor = _ref.levelThreeCategoryColor,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    categoryState = _ref.categoryState,
    enable_promotional_banners = _ref.enable_promotional_banners,
    isService = _ref.isService;
  var firstLevelItemName = isService ? "SRV ".concat(categoryState.firstLevelItem) : categoryState.firstLevelItem;
  var getChildContentForCategory = function getChildContentForCategory(category, isSecondLevelCategories) {
    var charactersRepresentedByStyles = 20 / 7.984;
    var charactersToDisplayTooltip = isSecondLevelCategories ? 21 : 27;
    var relativeTagSize = isSecondLevelCategories ? 0.95 : 1.22;
    var tooltipMarginTop = '28px';
    var categoryLength = (category.item_name && category.item_name.length) + (category.tag && category.tag.show && category.tag.text && category.tag.text.length * relativeTagSize - 1 + charactersRepresentedByStyles);
    return jsxs("div", {
      className: styles$$.content,
      children: [categoryLength <= charactersToDisplayTooltip ? jsxs("span", {
        className: classNames(styles$$.text, _defineProperty({}, styles$$['secondary-text'], enableSISMenuV2)),
        children: [category.item_name, enableSISMenuV2 && jsx("i", {
          "aria-hidden": "true",
          className: styles$$['chevron-right']
        })]
      }) : jsx(Tooltip$1, {
        viewType: "static",
        position: "bottom-static",
        containerStyle: {
          marginTop: tooltipMarginTop
        },
        tooltipContent: jsx(TooltipText, {
          color: "#495867",
          text: category.item_name,
          viewType: "verysmall-2"
        }),
        children: jsxs("span", {
          className: classNames(styles$$.text, _defineProperty({}, styles$$['secondary-text'], enableSISMenuV2)),
          children: [category.item_name, enableSISMenuV2 && jsx("i", {
            "aria-hidden": "true",
            className: styles$$['chevron-right']
          })]
        })
      }), category.tag && category.tag.show && jsx(Tag$1, _objectSpread$m(_objectSpread$m({}, category.tag), {}, {
        device: "desktop"
      }))]
    });
  };
  var wrapWithLink = function wrapWithLink(category, body) {
    var isForThirdLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var categoryColor = arguments.length > 3 ? arguments[3] : undefined;
    return jsx("a", {
      "data-cta": "true",
      href: category.item_url,
      target: category.new_tab ? '_blank' : '_self',
      className: classNames(styles$$['hover-effect'], _defineProperty(_defineProperty(_defineProperty({}, styles$$['list-title'], !isForThirdLevel), styles$$['list-item'], isForThirdLevel), styles$$['secondary-list-title'], enableSISMenuV2)),
      rel: "noreferrer",
      style: {
        color: categoryColor
      },
      children: body
    });
  };
  return jsx("div", {
    className: classNames(styles$$.container, _defineProperty(_defineProperty({}, styles$$['fill-full-height'], fillFullHeight), styles$$['small-height'], !fillFullHeight)),
    children: jsx("div", {
      className: classNames(styles$$.subcategories, _defineProperty({}, styles$$['has-promotional-banner'], enableSISMenuV2 && enable_promotional_banners && !hasBanner)),
      children: secondLevelCategories.map(function (subCategory, index) {
        return jsxs("ul", {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          className: classNames(styles$$['second-level-category-without-banners'], _defineProperty(_defineProperty(_defineProperty({}, styles$$['second-level-category-with-banners'], hasBanner), styles$$['five-columns'], enableSISMenuV2 && !enable_promotional_banners), styles$$['four-columns'], enableSISMenuV2 && enable_promotional_banners && !hasBanner)),
          children: [jsx("li", {
            onClick: function onClick() {
              return updateDigitalDataCookies({
                firstLevelItem: firstLevelItemName,
                secondLevelItem: subCategory.item_name,
                thirdLevelItem: subCategory.item_name,
                positionOne: categoryState.index + 1,
                positionTwo: index + 1,
                positionThree: 0,
                tag: SIS_NAVIGATION,
                dataWrapper: dataWrapper
              });
            },
            children: subCategory.item_url ? wrapWithLink(subCategory, getChildContentForCategory(subCategory, true), false, getCategoryColor(levelTwoCategoryColor, subCategory.item_color)) : jsx("div", {
              className: classNames(styles$$['list-title'], _defineProperty({}, styles$$['secondary-list-title'], enableSISMenuV2)),
              children: getChildContentForCategory(subCategory, true)
            })
          }), subCategory.third_level_categories && subCategory.third_level_categories.map(function (thirdLevelCategory, subindex) {
            return jsx("li", {
              onClick: function onClick() {
                return updateDigitalDataCookies({
                  firstLevelItem: firstLevelItemName,
                  secondLevelItem: subCategory.item_name,
                  thirdLevelItem: thirdLevelCategory.item_name,
                  positionOne: categoryState.index + 1,
                  positionTwo: index + 1,
                  positionThree: subindex + 1,
                  tag: SIS_NAVIGATION,
                  dataWrapper: dataWrapper
                });
              },
              children: thirdLevelCategory.item_url ? wrapWithLink(thirdLevelCategory, getChildContentForCategory(thirdLevelCategory), true, getCategoryColor(levelThreeCategoryColor, thirdLevelCategory.item_color)) : jsx("div", {
                className: styles$$['list-item'],
                children: getChildContentForCategory(thirdLevelCategory)
              })
            }, "third-level-category-".concat(subindex));
          })]
        }, "second-level-category-".concat(index));
      })
    })
  });
};
SubCategories$2.propTypes = {
  fillFullHeight: PropTypes.bool,
  secondLevelCategories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string,
    item_url: PropTypes.string,
    new_tab: PropTypes.bool,
    tag: PropTypes.shape({
      show: PropTypes.bool,
      text: PropTypes.string,
      background_color: PropTypes.string
    }),
    third_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      })
    }))
  })),
  hasBanner: PropTypes.bool,
  dataWrapper: PropTypes.string,
  levelTwoCategoryColor: PropTypes.string,
  levelThreeCategoryColor: PropTypes.string
};
SubCategories$2.defaultProps = {
  fillFullHeight: false
};
var SubCategories$3 = withCategoryState(SubCategories$2);

var styles$Y = {"body-wrapper":"Body-module_body-wrapper__JGSSr","body":"Body-module_body__0-II7","divider":"Body-module_divider__R5tfc","footer":"Body-module_footer__vCzvF","banners-without-second-level-categories":"Body-module_banners-without-second-level-categories__y6o4L","center-banners":"Body-module_center-banners__Z5fke","extra-padding-top":"Body-module_extra-padding-top__MFCE8","padding-height-default":"Body-module_padding-height-default__ht1sI","padding-height-with-only-banners":"Body-module_padding-height-with-only-banners__80kka","padding-height-with-only-hightlights":"Body-module_padding-height-with-only-hightlights__A9mLz","border":"Body-module_border__IK0qJ","isVisible":"Body-module_isVisible__1YCqA"};

var Body = function Body(_ref) {
  var categories = _ref.categories,
    onItemWithSubCategoriesSelected = _ref.onItemWithSubCategoriesSelected,
    isOpen = _ref.isOpen,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    dataWrapper = _ref.dataWrapper,
    colorLine = _ref.colorLine,
    defaultCategoryColors = _ref.defaultCategoryColors,
    isSodimacStandalone = _ref.isSodimacStandalone,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    categoryState = _ref.categoryState,
    showCategoryFirst = _ref.showCategoryFirst,
    categoryHeaderTitle = _ref.categoryHeaderTitle,
    serviceHeaderTitle = _ref.serviceHeaderTitle;
  if (isEmpty(categories)) {
    return jsx(React.Fragment, {});
  }
  var _ref2 = defaultCategoryColors || {},
    level_one_category_color = _ref2.level_one_category_color,
    level_two_category_color = _ref2.level_two_category_color,
    level_three_category_color = _ref2.level_three_category_color,
    highlight_level_category_color = _ref2.highlight_level_category_color;
  var getStyleForPanelWithPadding = function getStyleForPanelWithPadding(_ref3) {
    var banners = _ref3.banners,
      second_level_categories = _ref3.second_level_categories,
      highlight_level_categories = _ref3.highlight_level_categories;
    var panelClassList = [styles$Y['padding-height-default']];
    if (banners.length > 0 && second_level_categories.length === 0 && highlight_level_categories.length < MIN_HIGHLIGHT_LEVEL_CATEGORIES) {
      panelClassList = [styles$Y['padding-height-with-only-banners']];
    }
    if (banners.length === 6 && second_level_categories.length > 0 && highlight_level_categories.length < MIN_HIGHLIGHT_LEVEL_CATEGORIES) {
      panelClassList = [styles$Y['padding-height-with-only-banners']];
    }
    if (banners.length === 0 && second_level_categories.length === 0 && highlight_level_categories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES) {
      panelClassList = [styles$Y['padding-height-with-only-hightlights']];
    } else if (highlight_level_categories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES) {
      panelClassList.push(styles$Y['padding-height-with-only-hightlights']);
    }
    return panelClassList;
  };
  return jsxs("div", {
    className: classNames(styles$Y['body-wrapper'], _defineProperty({}, styles$Y.isVisible, isOpen)),
    children: [jsx(SideMenu$1, {
      categories: categories,
      onItemWithSubCategoriesSelected: onItemWithSubCategoriesSelected,
      isOpen: isOpen,
      hightlightColor: hightlightColor,
      hightlightTextColor: hightlightTextColor,
      dataWrapper: dataWrapper,
      levelOneCategoryColor: level_one_category_color,
      isSodimacStandalone: isSodimacStandalone,
      enableSISMenuV2: enableSISMenuV2,
      showCategoryFirst: showCategoryFirst,
      categoryHeaderTitle: categoryHeaderTitle,
      serviceHeaderTitle: serviceHeaderTitle
    }), categories.map(function (category, index) {
      var _category$promotional2, _category$promotional3;
      var _category$highlight_l = category.highlight_level_categories,
        highlight_level_categories = _category$highlight_l === void 0 ? [] : _category$highlight_l,
        _category$second_leve = category.second_level_categories,
        second_level_categories = _category$second_leve === void 0 ? [] : _category$second_leve,
        _category$banners = category.banners,
        banners = _category$banners === void 0 ? [] : _category$banners,
        _category$promotional = category.promotional,
        promotional = _category$promotional === void 0 ? {} : _category$promotional;
      var _promotional$enable_p = promotional.enable_promotional,
        enable_promotional = _promotional$enable_p === void 0 ? false : _promotional$enable_p;
      var showSubCategoryClass = categoryState.currentCategoryIndex === index ? styles$Y.isVisible : '';
      return jsxs("div", {
        className: classNames(styles$Y.body, getStyleForPanelWithPadding(category), showSubCategoryClass),
        children: [highlight_level_categories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES && jsx(HighlightLevelCategories$1, {
          highlightLevelCategories: highlight_level_categories,
          dataWrapper: dataWrapper,
          highLightedCategoryIndex: index,
          currentCategoryIndex: categoryState.currentCategoryIndex,
          menuIndex: categoryState.index,
          firstLevelItem: categoryState.firstLevelItem,
          isOpen: isOpen,
          highlightLevelCategoryColor: highlight_level_category_color,
          enableSISMenuV2: enableSISMenuV2
        }), isVisibleColorLine(highlight_level_categories, banners, second_level_categories) && jsx("hr", {
          className: styles$Y.divider,
          style: {
            borderColor: colorLine || 'white'
          }
        }), jsxs("div", {
          className: classNames(styles$Y.footer, _defineProperty(_defineProperty({}, styles$Y['extra-padding-top'], !highlight_level_categories), styles$Y['banners-without-second-level-categories'], !(second_level_categories.length > 0 && banners.length < MAX_BANNERS) && banners.length === MAX_BANNERS)),
          children: [second_level_categories.length > 0 && banners.length < 6 && jsx(SubCategories$3, {
            isService: category === null || category === void 0 ? void 0 : category.isService,
            secondLevelCategories: second_level_categories,
            fillFullHeight: highlight_level_categories.length < MIN_HIGHLIGHT_LEVEL_CATEGORIES,
            hasBanner: banners.length > 0,
            dataWrapper: dataWrapper,
            levelTwoCategoryColor: level_two_category_color,
            levelThreeCategoryColor: level_three_category_color,
            enableSISMenuV2: enableSISMenuV2,
            enable_promotional_banners: enable_promotional
          }), isOpen && enableSISMenuV2 && categoryState.currentCategoryIndex === index && enable_promotional && banners.length === 0 && jsx(PromotionalBanners$1, {
            data: promotional,
            dataWrapper: dataWrapper,
            firstLevelItem: categoryState.firstLevelItem,
            currentCategoryIndex: categoryState.index,
            isService: category.isService,
            webCategoryId: category === null || category === void 0 || (_category$promotional2 = category.promotional) === null || _category$promotional2 === void 0 ? void 0 : _category$promotional2.web_category_id,
            slots: category === null || category === void 0 || (_category$promotional3 = category.promotional) === null || _category$promotional3 === void 0 ? void 0 : _category$promotional3.slots,
            deviceType: "desktop",
            isProductButtonVisible: true
          }), isOpen && banners.length > 0 && categoryState.currentCategoryIndex === index && jsx(Banners$1, {
            banners: banners,
            dataWrapper: dataWrapper,
            firstLevelItem: categoryState.firstLevelItem,
            currentCategoryIndex: categoryState.index
          })]
        })]
      }, category === null || category === void 0 ? void 0 : category.item_name);
    }), jsx("div", {
      className: classNames(styles$Y.border),
      style: {
        backgroundColor: "".concat(colorLine)
      }
    })]
  });
};
Body.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  services: PropTypes.arrayOf(PropTypes.object),
  onItemWithSubCategoriesSelected: PropTypes.func,
  isOpen: PropTypes.bool,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string,
  dataWrapper: PropTypes.string,
  colorLine: PropTypes.string,
  defaultCategoryColors: PropTypes.object,
  enableSISMenuV2: PropTypes.bool
};
Body.defaultProps = {
  categories: [],
  services: [],
  enableSISMenuV2: false
};
var Body$1 = withCategoryState(Body);

var styles$X = {"menu-button-container":"HamburgerButton-module_menu-button-container__0xTt-","menuWrapper":"HamburgerButton-module_menuWrapper__nz1VF","hamburger-icon-container":"HamburgerButton-module_hamburger-icon-container__3ZOz9","hamburger-icon":"HamburgerButton-module_hamburger-icon__NBu--","name":"HamburgerButton-module_name__-w-yG"};

var HamburgerButton = function HamburgerButton(_ref) {
  var _menuConfig$deviceTyp, _menuConfig$deviceTyp2;
  var onButtonClick = _ref.onButtonClick,
    isOpen = _ref.isOpen,
    menuConfig = _ref.menuConfig,
    deviceType = _ref.deviceType;
  var menuLabel = "".concat((_menuConfig$deviceTyp = menuConfig[deviceType]) === null || _menuConfig$deviceTyp === void 0 ? void 0 : _menuConfig$deviceTyp.text);
  var hamburgerIcon = "".concat((_menuConfig$deviceTyp2 = menuConfig[deviceType]) === null || _menuConfig$deviceTyp2 === void 0 ? void 0 : _menuConfig$deviceTyp2.icon.url);
  var closeIcon = 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt47578a26a96c1f3f/67a067a1f6f9a688750cf724/close.svg';
  return jsx("div", {
    className: styles$X['menu-button-container'],
    "data-testid": "CategoryButton",
    children: jsx("div", {
      className: classNames(styles$X['menu-button-container']),
      children: jsxs("div", {
        className: classNames(styles$X.menuWrapper),
        onClick: function onClick() {
          return onButtonClick(!isOpen);
        },
        children: [jsx("div", {
          className: styles$X['hamburger-icon-container'],
          children: jsx("i", {
            "aria-hidden": "true",
            className: classNames(styles$X['hamburger-icon']),
            style: {
              maskImage: "url(".concat(isOpen ? closeIcon : hamburgerIcon, ")")
            }
          })
        }), menuLabel && menuLabel]
      })
    })
  });
};
HamburgerButton.propTypes = {
  onButtonClick: PropTypes.func,
  isOpen: PropTypes.bool,
  menuConfig: PropTypes.shape({
    desktop: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    }),
    mobile: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    })
  }),
  deviceType: PropTypes.string
};
HamburgerButton.defaultProps = {
  isOpen: false,
  deviceType: 'desktop'
};
var HamburgerButton$1 = HamburgerButton;

function ownKeys$l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$l(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SiSNavigationMenuDesktop = function SiSNavigationMenuDesktop(_ref) {
  var categories = _ref.categories,
    services = _ref.services,
    colorLine = _ref.colorLine,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    store = _ref.store,
    dataWrapper = _ref.dataWrapper,
    isSISLevel2Header = _ref.isSISLevel2Header,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    isVendorOrAgentLoggedIn = _ref.isVendorOrAgentLoggedIn,
    menuConfig = _ref.menuConfig,
    defaultCategoryColors = _ref.defaultCategoryColors,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    categoryState = _ref.categoryState,
    showCategoryFirst = _ref.showCategoryFirst,
    categoryHeaderTitle = _ref.categoryHeaderTitle,
    serviceHeaderTitle = _ref.serviceHeaderTitle;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var _getStandaloneSite = getStandaloneSite(store),
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone;
  var desktopCategories = categories.filter(function (c) {
    var _c$channel;
    return c === null || c === void 0 || (_c$channel = c.channel) === null || _c$channel === void 0 ? void 0 : _c$channel.desktop;
  });
  var desktopServices = services.filter(function (c) {
    var _c$channel2;
    return c === null || c === void 0 || (_c$channel2 = c.channel) === null || _c$channel2 === void 0 ? void 0 : _c$channel2.desktop;
  });
  var data = showCategoryFirst ? [].concat(_toConsumableArray(desktopCategories.map(function (c, i) {
    return _objectSpread$l(_objectSpread$l({}, c), {}, {
      isService: false,
      menuIndex: i
    });
  })), _toConsumableArray(enableSISMenuV2 ? desktopServices.map(function (s, i) {
    return _objectSpread$l(_objectSpread$l({}, s), {}, {
      isService: true,
      menuIndex: i
    });
  }) : [])) : [].concat(_toConsumableArray(enableSISMenuV2 ? desktopServices.map(function (s, i) {
    return _objectSpread$l(_objectSpread$l({}, s), {}, {
      isService: true,
      menuIndex: i
    });
  }) : []), _toConsumableArray(desktopCategories.map(function (c, i) {
    return _objectSpread$l(_objectSpread$l({}, c), {}, {
      isService: false,
      menuIndex: i
    });
  })));
  var closeNavigationMenu = function closeNavigationMenu() {
    setOpen(false);
  };
  var onItemWithSubCategoriesSelected = function onItemWithSubCategoriesSelected(hasItems) {
    var categoryIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var firstLevelItemName = arguments.length > 2 ? arguments[2] : undefined;
    var menuIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    categoryState.handleSetFirstLevelItem(firstLevelItemName);
    categoryState.handleSetCurrentCategoryIndex(categoryIndex);
    categoryState.handleSetIndex(menuIndex);
    if (typeof hasItems === 'boolean') {
      setOpen(hasItems);
    }
  };
  var getRelativeHeight = function getRelativeHeight() {
    if (isWhitelabel(store)) {
      return '145px';
    }
    if (!isSISLevel2Header) {
      if (isVendorOrAgentLoggedIn) {
        return '145px';
      }
      return '106px';
    } else {
      return '70px';
    }
  };
  return jsxs("div", {
    className: classNames(styles$19.container, classes.join(' ')),
    style: style,
    id: id,
    "data-testid": "SiSNavigationMenuDesktop",
    onMouseLeave: closeNavigationMenu,
    children: [isWhitelabel(store) ? jsx(HamburgerButton$1, {
      onButtonClick: onItemWithSubCategoriesSelected,
      isOpen: isOpen,
      menuConfig: menuConfig,
      deviceType: "desktop"
    }) : jsx(CategoryButton$1, {
      onItemWithSubCategoriesSelected: onItemWithSubCategoriesSelected,
      isOpen: isOpen,
      store: store,
      enableSISMenuV2: enableSISMenuV2
    }), isOpen && jsx(Portal$1, {
      id: "submen-backdrop",
      classes: styles$19.portal,
      top: getRelativeHeight(),
      children: jsx("span", {
        className: styles$19.backdrop,
        onClick: closeNavigationMenu,
        onMouseEnter: closeNavigationMenu
      })
    }), jsx(Body$1, {
      categories: data,
      onItemWithSubCategoriesSelected: onItemWithSubCategoriesSelected,
      isOpen: isOpen,
      hightlightColor: hightlightColor,
      hightlightTextColor: hightlightTextColor,
      dataWrapper: dataWrapper,
      colorLine: colorLine,
      defaultCategoryColors: defaultCategoryColors,
      isSodimacStandalone: isSodimacStandalone,
      enableSISMenuV2: enableSISMenuV2,
      showCategoryFirst: showCategoryFirst,
      categoryHeaderTitle: categoryHeaderTitle,
      serviceHeaderTitle: serviceHeaderTitle
    })]
  });
};
SiSNavigationMenuDesktop.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.object,
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })).isRequired,
  colorLine: PropTypes.string,
  categoryColor: PropTypes.string,
  store: PropTypes.string,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string,
  browseMainText: PropTypes.string.isRequired,
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  dataWrapper: PropTypes.string,
  isSISLevel2Header: PropTypes.bool,
  defaultCategoryColors: PropTypes.shape({})
};
SiSNavigationMenuDesktop.defaultProps = {
  colorLine: '',
  categoryColor: '',
  banners: [],
  classes: [],
  id: undefined,
  isVendorOrAgentLoggedIn: false
};
var SiSCategoryMenuDesktop = withCategoryState(SiSNavigationMenuDesktop);

var styles$W = {"container":"SiSCategoryMenuMobile-module_container__QclC2","top-menu-line":"SiSCategoryMenuMobile-module_top-menu-line__lJbdy","categoryWrapper":"SiSCategoryMenuMobile-module_categoryWrapper__4mJG8","categoryWrapper-text":"SiSCategoryMenuMobile-module_categoryWrapper-text__yvHAQ","homecenter":"SiSCategoryMenuMobile-module_homecenter__-j-m7","chevron-container":"SiSCategoryMenuMobile-module_chevron-container__I6Ga-","chevron-down":"SiSCategoryMenuMobile-module_chevron-down__tL1C9","chevron-down--to_com":"SiSCategoryMenuMobile-module_chevron-down--to_com__zoS-Z","active":"SiSCategoryMenuMobile-module_active__4N-gS","categoryWrapper--to_com":"SiSCategoryMenuMobile-module_categoryWrapper--to_com__Nv4U7","wrapper-modal":"SiSCategoryMenuMobile-module_wrapper-modal__skWep","nav-body":"SiSCategoryMenuMobile-module_nav-body__r45Jc","menu":"SiSCategoryMenuMobile-module_menu__nLQeC","nav-sub-head":"SiSCategoryMenuMobile-module_nav-sub-head__g4INz","nav-title":"SiSCategoryMenuMobile-module_nav-title__AK2CB","modal-close":"SiSCategoryMenuMobile-module_modal-close__QKGo5","sis-modal-close-button":"SiSCategoryMenuMobile-module_sis-modal-close-button__OYvM9","nav-sub-title":"SiSCategoryMenuMobile-module_nav-sub-title__f23Cy","sub-title":"SiSCategoryMenuMobile-module_sub-title__9JTd5","arrow-left":"SiSCategoryMenuMobile-module_arrow-left__FDzQe","parent-category-title":"SiSCategoryMenuMobile-module_parent-category-title__X5Wv8","nav-sub-content":"SiSCategoryMenuMobile-module_nav-sub-content__WObvw","divider":"SiSCategoryMenuMobile-module_divider__GLTsL","divider-gray":"SiSCategoryMenuMobile-module_divider-gray__UzxJ1","menu-item-wrapper":"SiSCategoryMenuMobile-module_menu-item-wrapper__qItl1","menu-item":"SiSCategoryMenuMobile-module_menu-item__vC5Xl","arrow-right":"SiSCategoryMenuMobile-module_arrow-right__1Cs1s","menu-item-second-wrapper":"SiSCategoryMenuMobile-module_menu-item-second-wrapper__1V5jQ","menu-item-third-wrapper":"SiSCategoryMenuMobile-module_menu-item-third-wrapper__oU563","menu-primary-enter":"SiSCategoryMenuMobile-module_menu-primary-enter__k-YO6","menu-primary-enter-active":"SiSCategoryMenuMobile-module_menu-primary-enter-active__raxEF","menu-primary-exit":"SiSCategoryMenuMobile-module_menu-primary-exit__V4g2K","menu-primary-exit-active":"SiSCategoryMenuMobile-module_menu-primary-exit-active__CFgaz","menu-secondary-enter":"SiSCategoryMenuMobile-module_menu-secondary-enter__wRDOe","menu-secondary-enter-active":"SiSCategoryMenuMobile-module_menu-secondary-enter-active__lHksY","menu-secondary-exit-active":"SiSCategoryMenuMobile-module_menu-secondary-exit-active__vUDTP","menu-tertiary-enter":"SiSCategoryMenuMobile-module_menu-tertiary-enter__I4mo9","menu-tertiary-enter-active":"SiSCategoryMenuMobile-module_menu-tertiary-enter-active__EoTnw","menu-tertiary-exit-active":"SiSCategoryMenuMobile-module_menu-tertiary-exit-active__eP9OC"};

function ownKeys$k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$k(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SiSNavigationMenuMobile = function SiSNavigationMenuMobile(_ref) {
  var categories = _ref.categories,
    browseMainText = _ref.browseMainText,
    colorLine = _ref.colorLine,
    store = _ref.store,
    dataWrapper = _ref.dataWrapper,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    menuConfig = _ref.menuConfig,
    defaultCategoryColors = _ref.defaultCategoryColors;
  var MAIN_MENU = 'main';
  var SECONDARY_MENU = 'secondary_menu';
  var THIRD_MENU = 'third_menu';
  var deviceType = 'mobile';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalVisible = _useState2[0],
    setIsModalVisible = _useState2[1];
  var _useState3 = useState(MAIN_MENU),
    _useState4 = _slicedToArray(_useState3, 2),
    activeMenu = _useState4[0],
    setActiveMenu = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    var setMenuHeight = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    menuMaxHeight = _useState8[0],
    setMenuMaxHeight = _useState8[1];
  var _useState9 = useState({}),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedSecondaryCategory = _useState0[0],
    setSelectedSecondaryCategory = _useState0[1];
  var _useState1 = useState({}),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedTertiaryCategory = _useState10[0],
    setSelectedTertiaryCategory = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    firstLevelCategoryIndex = _useState12[0],
    setFirstLevelCategoryIndex = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    secondLevelCategoryIndex = _useState14[0],
    setSecondLevelCategoryIndex = _useState14[1];
  var mobileModalClass = 'floatBottomTransition';
  var mobileBodyModalClass = 'flex';
  var mobileModalID = 'modal-sub-menu';
  var isMobileDevice = isMobile();
  var _getStandaloneSite = getStandaloneSite(store),
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var _ref2 = defaultCategoryColors || {},
    level_one_category_color = _ref2.level_one_category_color,
    level_two_category_color = _ref2.level_two_category_color,
    level_three_category_color = _ref2.level_three_category_color,
    highlight_level_category_color = _ref2.highlight_level_category_color;
  var filteredCategories = categories.filter(function (x) {
    return x.channel.mobile;
  });
  useEffect(function () {
    var height = window.innerHeight;
    setMenuMaxHeight(height * 0.7);
  }, []);
  var getCategoryStyle = function getCategoryStyle(defaultCategoryColor, category) {
    return category.item_color ? {
      color: category.item_color
    } : {
      color: defaultCategoryColor
    };
  };
  var calcHeight = function calcHeight() {
    var subCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var banners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var highlightLevelCategories = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var BASE_NAV_HEIGHT = 80;
    var categoriesSize = subCategories.length;
    var bannersSize = banners.length;
    var highlightLevelCategoriesSize = highlightLevelCategories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES ? 1 : 0;
    var dh = categoriesSize * 52 + bannersSize * 80 + highlightLevelCategoriesSize * 230 + BASE_NAV_HEIGHT;
    setMenuHeight(dh > menuMaxHeight ? menuMaxHeight : dh);
  };
  var itHasChildrenItems = function itHasChildrenItems(category, goToMenu) {
    var hasItems = false;
    switch (goToMenu) {
      case SECONDARY_MENU:
        hasItems = category.highlight_level_categories && category.highlight_level_categories.length > 0 || category.second_level_categories && category.second_level_categories.length > 0 || category.banners && category.banners.length > 0;
        break;
      case THIRD_MENU:
        hasItems = category.third_level_categories && category.third_level_categories.length > 0;
        break;
    }
    return hasItems;
  };
  var onMenuItemWithChildClick = function onMenuItemWithChildClick(_ref3) {
    var goToMenu = _ref3.goToMenu,
      category = _ref3.category,
      categoryIndex = _ref3.categoryIndex;
    if (goToMenu) {
      if (goToMenu === SECONDARY_MENU) {
        setFirstLevelCategoryIndex(categoryIndex);
        setSelectedSecondaryCategory(category);
        calcHeight(category.second_level_categories, category.banners, category.highlight_level_categories);
      }
      if (goToMenu === THIRD_MENU) {
        setSecondLevelCategoryIndex(categoryIndex);
        setSelectedTertiaryCategory(category);
        calcHeight(category.third_level_categories);
      }
      document.getElementById(mobileModalID).scrollTo(0, 0);
      setActiveMenu(goToMenu);
    }
  };
  var onMenuItemClick = function onMenuItemClick(_ref4) {
    var categoryIndex = _ref4.categoryIndex;
    if (activeMenu) {
      if (activeMenu === SECONDARY_MENU) {
        updateDigitalDataCookies({
          firstLevelItem: filteredCategories[firstLevelCategoryIndex].item_name,
          secondLevelItem: filteredCategories[firstLevelCategoryIndex].second_level_categories[categoryIndex].item_name,
          thirdLevelItem: filteredCategories[firstLevelCategoryIndex].second_level_categories[categoryIndex].item_name,
          positionOne: firstLevelCategoryIndex + 1,
          positionTwo: categoryIndex + 1,
          positionThree: 0,
          tag: SIS_NAVIGATION,
          dataWrapper: dataWrapper
        });
      }
      if (activeMenu === THIRD_MENU) {
        updateDigitalDataCookies({
          firstLevelItem: filteredCategories[firstLevelCategoryIndex].item_name,
          secondLevelItem: filteredCategories[firstLevelCategoryIndex].second_level_categories[secondLevelCategoryIndex].item_name,
          thirdLevelItem: filteredCategories[firstLevelCategoryIndex].second_level_categories[secondLevelCategoryIndex].third_level_categories[categoryIndex].item_name,
          positionOne: firstLevelCategoryIndex + 1,
          positionTwo: secondLevelCategoryIndex + 1,
          positionThree: categoryIndex + 1,
          tag: SIS_NAVIGATION,
          dataWrapper: dataWrapper
        });
      }
    }
  };
  var goBack = function goBack(goToMenu) {
    setActiveMenu(goToMenu);
    if (goToMenu === MAIN_MENU) {
      calcHeight(filteredCategories);
    }
    if (goToMenu === SECONDARY_MENU) {
      calcHeight(selectedSecondaryCategory.second_level_categories, selectedSecondaryCategory.banners, selectedSecondaryCategory.highlight_level_categories);
    }
  };
  var MenuItem = function MenuItem(props) {
    var _props$category = props.category,
      item_url = _props$category.item_url,
      new_tab = _props$category.new_tab;
    var url = props.goToMenu === SECONDARY_MENU ? item_url.href : item_url;
    return url ? jsx("a", {
      href: props.itHasChildren ? '#' : url,
      target: new_tab && !props.itHasChildren ? '_blank' : '_self',
      className: styles$W['menu-item-wrapper'],
      onClick: function onClick() {
        return props.itHasChildren ? onMenuItemWithChildClick(props) : onMenuItemClick(props);
      },
      rel: "noreferrer",
      children: props.children
    }) : jsx("div", {
      className: styles$W['menu-item-wrapper'],
      onClick: function onClick() {
        return props.itHasChildren ? onMenuItemWithChildClick(props) : onMenuItemClick(props);
      },
      children: props.children
    });
  };
  var NavBody = function NavBody(_ref5) {
    var actions = _ref5.actions;
    var visibleBannerDivider = showBannerDivider(selectedSecondaryCategory.banners, selectedSecondaryCategory.second_level_categories);
    var visibleCarouselDivider = isVisibleColorLine(selectedSecondaryCategory.highlight_level_categories, selectedSecondaryCategory.banners, selectedSecondaryCategory.second_level_categories);
    return jsxs("div", {
      className: styles$W['nav-body'],
      "data-testid": "SisCategoryMenuMobile-nav-body",
      children: [jsx(CSSTransition, {
        "in": activeMenu === MAIN_MENU,
        timeout: 500,
        classNames: "menu-primary",
        unmountOnExit: true,
        children: jsxs("div", {
          className: styles$W.menu,
          children: [jsx("div", {
            className: styles$W['nav-sub-head'],
            children: jsxs("div", {
              className: styles$W['nav-title'],
              children: [jsx("span", {
                children: browseMainText
              }), jsx("button", {
                type: "button",
                className: classNames(styles$W['modal-close'], styles$W['sis-modal-close-button']),
                id: "testId-modal-close",
                onClick: actions.close,
                children: jsx("i", {
                  className: classNames(styles$W['icon-danger'], styles$W['icon-big'])
                })
              })]
            })
          }), jsx("div", {
            className: styles$W['nav-sub-content'],
            children: filteredCategories.map(function (category, index) {
              return jsxs(MenuItem, {
                goToMenu: SECONDARY_MENU,
                category: category,
                categoryIndex: index,
                itHasChildren: itHasChildrenItems(category, SECONDARY_MENU),
                children: [jsx("div", {
                  className: styles$W['menu-item'],
                  style: getCategoryStyle(level_one_category_color, category),
                  children: category.item_name
                }), itHasChildrenItems(category, SECONDARY_MENU) && jsx("div", {
                  className: styles$W['arrow-right'],
                  children: jsx("i", {
                    "aria-hidden": "true"
                  })
                })]
              }, index);
            })
          })]
        })
      }), jsx(CSSTransition, {
        "in": activeMenu === SECONDARY_MENU,
        timeout: 500,
        classNames: "menu-secondary",
        unmountOnExit: true,
        children: jsxs("div", {
          className: styles$W.menu,
          children: [jsxs("div", {
            className: styles$W['nav-sub-head'],
            children: [jsxs("div", {
              className: styles$W['nav-sub-title'],
              onClick: function onClick() {
                goBack(MAIN_MENU);
              },
              children: [jsxs("div", {
                className: styles$W['sub-title'],
                children: [jsx("div", {
                  className: styles$W['arrow-left'],
                  children: jsx("i", {
                    "aria-hidden": "true"
                  })
                }), jsx("span", {
                  children: "".concat(browseMainText)
                })]
              }), jsx("button", {
                type: "button",
                className: classNames(styles$W['modal-close'], styles$W['sis-modal-close-button']),
                id: "testId-modal-close",
                onClick: actions.close,
                children: jsx("i", {
                  className: classNames(styles$W['icon-danger'], styles$W['icon-big'])
                })
              })]
            }), jsx("div", {
              className: styles$W['parent-category-title'],
              style: getCategoryStyle(level_one_category_color, selectedSecondaryCategory),
              children: selectedSecondaryCategory.item_name
            })]
          }), jsxs("div", {
            className: styles$W['nav-sub-content'],
            children: [selectedSecondaryCategory && selectedSecondaryCategory.highlight_level_categories && selectedSecondaryCategory.highlight_level_categories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES && jsx(HighlightLevelCategories$1, {
              highlightLevelCategories: selectedSecondaryCategory.highlight_level_categories,
              dataWrapper: dataWrapper,
              currentCategoryIndex: firstLevelCategoryIndex,
              firstLevelItem: filteredCategories[firstLevelCategoryIndex].item_name,
              highlightLevelCategoryColor: highlight_level_category_color
            }), colorLine && visibleCarouselDivider && jsx("hr", {
              className: styles$W.divider,
              style: {
                borderTopColor: colorLine
              }
            }), selectedSecondaryCategory && selectedSecondaryCategory.second_level_categories && selectedSecondaryCategory.second_level_categories.map(function (category, index) {
              return jsxs(MenuItem, {
                goToMenu: THIRD_MENU,
                category: category,
                categoryIndex: index,
                itHasChildren: itHasChildrenItems(category, THIRD_MENU),
                children: [jsxs("div", {
                  className: styles$W['menu-item-second-wrapper'],
                  children: [jsx("div", {
                    className: styles$W['menu-item'],
                    style: getCategoryStyle(level_two_category_color, category),
                    children: category.item_name
                  }), category.tag && category.tag.show && jsx(Tag$1, _objectSpread$k(_objectSpread$k({}, category.tag), {}, {
                    device: "mobile"
                  }))]
                }), itHasChildrenItems(category, THIRD_MENU) && jsx("div", {
                  className: styles$W['arrow-right'],
                  children: jsx("i", {
                    "aria-hidden": "true"
                  })
                })]
              }, index);
            }), visibleBannerDivider && jsx("hr", {
              className: classNames(styles$W.divider, styles$W['divider-gray'])
            }), selectedSecondaryCategory && selectedSecondaryCategory.banners && jsx(Banners$1, {
              banners: selectedSecondaryCategory.banners,
              style: {
                marginTop: visibleBannerDivider || visibleCarouselDivider ? '20px' : ''
              },
              dataWrapper: dataWrapper,
              currentCategoryIndex: firstLevelCategoryIndex,
              firstLevelItem: filteredCategories[firstLevelCategoryIndex].item_name
            })]
          })]
        })
      }), jsx(CSSTransition, {
        "in": activeMenu === THIRD_MENU,
        timeout: 500,
        classNames: "menu-tertiary",
        unmountOnExit: true,
        children: jsxs("div", {
          className: styles$W.menu,
          children: [jsxs("div", {
            className: styles$W['nav-sub-head'],
            children: [jsxs("div", {
              className: styles$W['nav-sub-title'],
              onClick: function onClick() {
                goBack(SECONDARY_MENU);
              },
              children: [jsxs("div", {
                className: styles$W['sub-title'],
                children: [jsx("div", {
                  className: styles$W['arrow-left'],
                  children: jsx("i", {
                    "aria-hidden": "true"
                  })
                }), jsx("span", {
                  style: getCategoryStyle(level_one_category_color, selectedSecondaryCategory),
                  children: "".concat(selectedSecondaryCategory.item_name)
                })]
              }), jsx("button", {
                type: "button",
                className: classNames(styles$W['modal-close'], styles$W['sis-modal-close-button']),
                id: "testId-modal-close",
                onClick: actions.close,
                children: jsx("i", {
                  className: classNames(styles$W['icon-danger'], styles$W['icon-big'])
                })
              })]
            }), jsx("div", {
              className: styles$W['parent-category-title'],
              children: jsx("a", {
                href: selectedTertiaryCategory.item_url ? selectedTertiaryCategory.item_url : '#',
                target: selectedTertiaryCategory.new_tab ? '_blank' : '_self',
                rel: "noreferrer",
                style: getCategoryStyle(level_two_category_color, selectedTertiaryCategory),
                children: selectedTertiaryCategory.item_name
              })
            })]
          }), jsx("div", {
            className: styles$W['nav-sub-content'],
            children: selectedTertiaryCategory && selectedTertiaryCategory.third_level_categories && selectedTertiaryCategory.third_level_categories.map(function (category, index) {
              return jsx(MenuItem, {
                itHasChildren: false,
                category: category,
                categoryIndex: index,
                children: jsxs("div", {
                  className: styles$W['menu-item-third-wrapper'],
                  children: [jsx("div", {
                    className: styles$W['menu-item'],
                    style: getCategoryStyle(level_three_category_color, category),
                    children: category.item_name
                  }), category.tag && category.tag.show && jsx(Tag$1, _objectSpread$k(_objectSpread$k({}, category.tag), {}, {
                    device: "mobile"
                  }))]
                })
              }, index);
            })
          })]
        })
      })]
    });
  };
  var toggleModal = function toggleModal() {
    setIsModalVisible(!isModalVisible);
    if (isModalVisible) {
      goBack(MAIN_MENU);
    }
  };
  return jsxs("div", {
    className: classNames(styles$W.container, classes.join(' ')),
    style: style,
    id: id,
    children: [isWhitelabelSite ? jsx(HamburgerButton$1, {
      onButtonClick: toggleModal,
      menuConfig: menuConfig,
      deviceType: deviceType,
      isOpen: isModalVisible
    }) : jsxs("div", {
      className: classNames(styles$W.categoryWrapper, styles$W[store], _defineProperty(_defineProperty({}, styles$W.active, !isMobileDevice && isModalVisible), styles$W['categoryWrapper--to_com'], isTottusStandalone)),
      onClick: function onClick() {
        toggleModal();
      },
      "data-testid": "SiSNavigationMenuMobile-toggleId",
      children: [jsx("div", {
        "data-testid": "category-text",
        className: classNames(styles$W['categoryWrapper-text'], styles$W[store]),
        children: "Categor\xEDas"
      }), jsx("div", {
        className: styles$W['chevron-container'],
        children: jsx("i", {
          "aria-hidden": "true",
          className: classNames(styles$W['chevron-down'], _defineProperty(_defineProperty({}, styles$W['chevron-down--to_com'], isTottusStandalone), styles$W.active, isModalVisible))
        })
      })]
    }), jsx("div", {
      className: styles$W['wrapper-modal'],
      children: jsx(Modal, {
        toggleState: {
          visible: isModalVisible,
          setVisible: toggleModal
        },
        content: function content(actions) {
          return jsx(NavBody, {
            actions: actions
          });
        },
        options: {
          width: 'auto',
          height: null,
          minHeight: '279px',
          maxHeight: '70vh',
          disableOutsideClick: false,
          borderRadius: '10px 10px 0 0',
          padding: '0',
          display: 'flex',
          bottom: '0',
          left: '0',
          position: 'absolute'
        },
        deviceType: deviceType,
        fullWidth: deviceType !== 'desktop',
        customClass: mobileModalClass,
        customID: mobileModalID,
        customBodyClass: mobileBodyModalClass,
        showCloseButton: false,
        withPadding: false
      })
    })]
  });
};
SiSNavigationMenuMobile.propTypes = {
  brandLogo: PropTypes.shape({
    url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  }),
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.object,
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })).isRequired,
  colorLine: PropTypes.string,
  categoryColor: PropTypes.string,
  browseMainText: PropTypes.string.isRequired,
  store: PropTypes.oneOf(['sodimac', 'tottus', 'linio', 'homecenter']),
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  menuConfig: PropTypes.shape({
    desktop: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    }),
    mobile: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    })
  }),
  defaultCategoryColors: PropTypes.shape({})
};
SiSNavigationMenuMobile.defaultProps = {
  colorLine: '',
  categoryColor: '',
  classes: [],
  id: undefined
};
var SiSCategoryMenuMobile = SiSNavigationMenuMobile;

var styles$V = {"container":"CategoriesAndServices-module_container__88B1l","header":"CategoriesAndServices-module_header__ldXvS","headerContent":"CategoriesAndServices-module_headerContent__5fi8P","title":"CategoriesAndServices-module_title__PsOft","wrapper":"CategoriesAndServices-module_wrapper__SGJiZ","mainContent":"CategoriesAndServices-module_mainContent__FF9On"};

var styles$U = {"container":"Services-module_container__ytjk1","title":"Services-module_title__CkTrT","serviceList":"Services-module_serviceList__jpkYQ","serviceItem":"Services-module_serviceItem__P2MvX","serviceTitle":"Services-module_serviceTitle__BNNof","serviceUrl":"Services-module_serviceUrl__AIdyd","serviceActions":"Services-module_serviceActions__hU75t"};

var styles$T = {"chevron-right":"NextButton-module_chevron-right__Zk5-o"};

var NextButton = function NextButton() {
  return jsx("i", {
    "aria-hidden": "true",
    className: styles$T['chevron-right']
  });
};
var NextButton$1 = NextButton;

var styles$S = {"content":"MostWatchedBadge-module_content__Re3aQ"};

var MostWatchedBadge = function MostWatchedBadge(_ref) {
  var _ref$badge = _ref.badge,
    badge = _ref$badge === void 0 ? {} : _ref$badge;
  var badgeStyle = {
    backgroundColor: (badge === null || badge === void 0 ? void 0 : badge.background_color) || '#FFEFE6'
  };
  return jsx("p", {
    className: styles$S.content,
    style: badgeStyle,
    children: "\uD83D\uDD25"
  });
};
MostWatchedBadge.propTypes = {
  badge: PropTypes.shape({
    background_color: PropTypes.string,
    color: PropTypes.string
  })
};
var MostWatchedBadge$1 = MostWatchedBadge;

function ownKeys$j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$j(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Services = function Services(_ref) {
  var onHeaderTitleChange = _ref.onHeaderTitleChange,
    onCategoriesAndServicesTypesOpen = _ref.onCategoriesAndServicesTypesOpen,
    onHighlightTypeSelect = _ref.onHighlightTypeSelect,
    onSecondLevelSelect = _ref.onSecondLevelSelect,
    services = _ref.services,
    onUpdateCookies = _ref.onUpdateCookies,
    handleSetPromotionalData = _ref.handleSetPromotionalData,
    setBanners = _ref.setBanners,
    setWebCategoryId = _ref.setWebCategoryId,
    setSlotId = _ref.setSlotId,
    serviceHeaderTitle = _ref.serviceHeaderTitle;
  var handleServiceType = function handleServiceType(service, index) {
    var _service$promotional;
    onUpdateCookies({
      firstLevelIndex: index,
      type: 'service'
    });
    setBanners(service === null || service === void 0 ? void 0 : service.banners);
    setSlotId(service === null || service === void 0 ? void 0 : service.slots);
    setWebCategoryId(service === null || service === void 0 || (_service$promotional = service.promotional) === null || _service$promotional === void 0 ? void 0 : _service$promotional.web_category_id);
    onHeaderTitleChange(service.item_name);
    onCategoriesAndServicesTypesOpen();
    onHighlightTypeSelect(service.highlight_level_categories);
    onSecondLevelSelect(service.second_level_categories.map(function (item) {
      return _objectSpread$j(_objectSpread$j({}, item), {}, {
        type: 'service'
      });
    }));
    if (service !== null && service !== void 0 && service.promotional) {
      handleSetPromotionalData(service.promotional);
    }
  };
  return jsx("div", {
    children: jsxs("div", {
      className: styles$U.container,
      children: [jsx("p", {
        className: styles$U.title,
        children: serviceHeaderTitle
      }), services === null || services === void 0 ? void 0 : services.map(function (service, index) {
        var _service$item_url;
        if (service !== null && service !== void 0 && (_service$item_url = service.item_url) !== null && _service$item_url !== void 0 && _service$item_url.href && (service === null || service === void 0 ? void 0 : service.highlight_level_categories.length) < 0 && (service === null || service === void 0 ? void 0 : service.second_level_categories.length) < 0) {
          var _service$item_url2, _service$tag;
          return jsx("a", {
            href: service === null || service === void 0 || (_service$item_url2 = service.item_url) === null || _service$item_url2 === void 0 ? void 0 : _service$item_url2.href,
            className: styles$U.serviceUrl,
            children: jsxs("div", {
              className: styles$U.serviceList,
              children: [jsx("div", {
                className: styles$U.serviceItem,
                children: service === null || service === void 0 ? void 0 : service.item_name
              }), jsx("div", {
                children: (service === null || service === void 0 || (_service$tag = service.tag) === null || _service$tag === void 0 ? void 0 : _service$tag.show) && jsx(MostWatchedBadge$1, {
                  badge: service === null || service === void 0 ? void 0 : service.tag
                })
              })]
            })
          }, index);
        } else {
          var _service$icon, _service$icon2, _service$tag2;
          return jsxs("div", {
            className: styles$U.serviceList,
            onClick: function onClick() {
              return handleServiceType(service, index);
            },
            children: [jsxs("div", {
              className: styles$U.serviceItem,
              children: [jsx("img", {
                src: service === null || service === void 0 || (_service$icon = service.icon) === null || _service$icon === void 0 ? void 0 : _service$icon.url,
                alt: service === null || service === void 0 || (_service$icon2 = service.icon) === null || _service$icon2 === void 0 ? void 0 : _service$icon2.title
              }), jsx("p", {
                className: styles$U.serviceTitle,
                children: service === null || service === void 0 ? void 0 : service.item_name
              })]
            }), jsxs("div", {
              className: styles$U.serviceActions,
              children: [(service === null || service === void 0 || (_service$tag2 = service.tag) === null || _service$tag2 === void 0 ? void 0 : _service$tag2.show) && jsx(MostWatchedBadge$1, {
                badge: service === null || service === void 0 ? void 0 : service.tag
              }), jsx(NextButton$1, {})]
            })]
          }, index);
        }
      })]
    })
  });
};
Services.propTypes = {
  onHeaderTitleChange: PropTypes.func.isRequired,
  onCategoriesAndServicesTypesOpen: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired
  })).isRequired,
  onHighlightTypeSelect: PropTypes.func.isRequired,
  onSecondLevelSelect: PropTypes.func.isRequired,
  onUpdateCookies: PropTypes.func.isRequired,
  services: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    }).isRequired,
    tag: PropTypes.shape({
      show: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.array,
    second_level_categories: PropTypes.array
  })).isRequired,
  serviceHeaderTitle: PropTypes.string
};
var Services$1 = Services;

var styles$R = {"backButton":"BackButton-module_backButton__rlv4y"};

var BackButton = function BackButton(_ref) {
  var onCategoriesAndServicesTypesOpen = _ref.onCategoriesAndServicesTypesOpen;
  var goBackToPreviousSection = function goBackToPreviousSection() {
    onCategoriesAndServicesTypesOpen();
  };
  return jsx("button", {
    role: "button",
    className: styles$R.backButton,
    onClick: goBackToPreviousSection
  });
};
BackButton.propTypes = {
  onCategoriesAndServicesTypesOpen: PropTypes.func.isRequired
};
var BackButton$1 = BackButton;

var styles$Q = {"container":"Categories-module_container__EIKLO","title":"Categories-module_title__uLcez","categoryList":"Categories-module_categoryList__yNacx","categoryItem":"Categories-module_categoryItem__348Fw","categoryTitle":"Categories-module_categoryTitle__60ud4","categoryUrl":"Categories-module_categoryUrl__x-5ye","categoryActions":"Categories-module_categoryActions__y-5qc"};

function ownKeys$i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$i(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Categories$2 = function Categories(_ref) {
  var onHeaderTitleChange = _ref.onHeaderTitleChange,
    onCategoriesAndServicesTypesOpen = _ref.onCategoriesAndServicesTypesOpen,
    categories = _ref.categories,
    onHighlightTypeSelect = _ref.onHighlightTypeSelect,
    onSecondLevelSelect = _ref.onSecondLevelSelect,
    onUpdateCookies = _ref.onUpdateCookies,
    handleSetPromotionalData = _ref.handleSetPromotionalData,
    setBanners = _ref.setBanners,
    setWebCategoryId = _ref.setWebCategoryId,
    setSlotId = _ref.setSlotId,
    categoryHeaderTitle = _ref.categoryHeaderTitle;
  var handleCategoryType = function handleCategoryType(category, index) {
    var _category$promotional, _category$promotional2;
    onHeaderTitleChange(category.title);
    onCategoriesAndServicesTypesOpen();
    onHighlightTypeSelect(category.highlight_level_categories);
    onSecondLevelSelect(category.second_level_categories.map(function (item) {
      return _objectSpread$i(_objectSpread$i({}, item), {}, {
        type: 'category'
      });
    }));
    if (category !== null && category !== void 0 && category.promotional) {
      handleSetPromotionalData(category.promotional);
    }
    setBanners(category === null || category === void 0 ? void 0 : category.banners);
    setWebCategoryId(category === null || category === void 0 || (_category$promotional = category.promotional) === null || _category$promotional === void 0 ? void 0 : _category$promotional.web_category_id);
    setSlotId(category === null || category === void 0 || (_category$promotional2 = category.promotional) === null || _category$promotional2 === void 0 ? void 0 : _category$promotional2.slots);
    onUpdateCookies({
      firstLevelIndex: index,
      type: 'category'
    });
  };
  return jsx("div", {
    children: jsxs("div", {
      className: styles$Q.container,
      children: [jsx("p", {
        className: styles$Q.title,
        children: categoryHeaderTitle
      }), categories.map(function (category, index) {
        var _category$tag, _category$icon, _category$icon2, _category$tag2;
        return category.item_url.href && (category === null || category === void 0 ? void 0 : category.second_level_categories.length) < 0 && (category === null || category === void 0 ? void 0 : category.highlight_level_categories.length) < 0 ? jsx("a", {
          href: category.item_url.href,
          className: styles$Q.categoryUrl,
          children: jsxs("div", {
            className: styles$Q.categoryList,
            children: [jsx("div", {
              className: styles$Q.categoryItem,
              children: category.title
            }), jsx("div", {
              children: (category === null || category === void 0 || (_category$tag = category.tag) === null || _category$tag === void 0 ? void 0 : _category$tag.show) && jsx(MostWatchedBadge$1, {
                badge: category === null || category === void 0 ? void 0 : category.tag
              })
            })]
          })
        }, index) : jsxs("div", {
          className: styles$Q.categoryList,
          onClick: function onClick() {
            return handleCategoryType(category, index);
          },
          children: [jsxs("div", {
            className: styles$Q.categoryItem,
            children: [jsx("img", {
              src: category === null || category === void 0 || (_category$icon = category.icon) === null || _category$icon === void 0 ? void 0 : _category$icon.url,
              alt: category === null || category === void 0 || (_category$icon2 = category.icon) === null || _category$icon2 === void 0 ? void 0 : _category$icon2.title
            }), jsx("p", {
              className: styles$Q.categoryTitle,
              children: category === null || category === void 0 ? void 0 : category.title
            })]
          }), jsxs("div", {
            className: styles$Q.categoryActions,
            children: [(category === null || category === void 0 || (_category$tag2 = category.tag) === null || _category$tag2 === void 0 ? void 0 : _category$tag2.show) && jsx(MostWatchedBadge$1, {
              badge: category === null || category === void 0 ? void 0 : category.tag
            }), jsx(NextButton$1, {})]
          })]
        }, index);
      })]
    })
  });
};
Categories$2.propTypes = {
  onHeaderTitleChange: PropTypes.func.isRequired,
  onCategoriesAndServicesTypesOpen: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired
  })).isRequired,
  onHighlightTypeSelect: PropTypes.func.isRequired,
  onSecondLevelSelect: PropTypes.func.isRequired,
  onUpdateCookies: PropTypes.func.isRequired,
  categoryHeaderTitle: PropTypes.string
};
var Categories$3 = Categories$2;

var styles$P = {"container":"Accordion-module_container__OfQFN","header":"Accordion-module_header__QfVou","title":"Accordion-module_title__4EdHl","subTitle":"Accordion-module_subTitle__3jm--","thirdLevelData":"Accordion-module_thirdLevelData__gPo0C","toggleButton":"Accordion-module_toggleButton__E4tZV","iconOpen":"Accordion-module_iconOpen__cZx45","iconClose":"Accordion-module_iconClose__fIDoD","content":"Accordion-module_content__p1cyA","slideDown":"Accordion-module_slideDown__ilKXE"};

var Accordion = function Accordion(_ref) {
  var secondLevelData = _ref.secondLevelData,
    isOpen = _ref.isOpen,
    onToggle = _ref.onToggle,
    onThirdLevelClick = _ref.onThirdLevelClick;
  var thirdLevelItems = (secondLevelData === null || secondLevelData === void 0 ? void 0 : secondLevelData.third_level_categories) || (secondLevelData === null || secondLevelData === void 0 ? void 0 : secondLevelData.third_level_services) || [];
  return jsxs("div", {
    className: styles$P.container,
    children: [jsxs("div", {
      className: styles$P.header,
      onClick: onToggle,
      children: [jsx("p", {
        className: styles$P.title,
        children: secondLevelData.item_name
      }), jsx("button", {
        className: "".concat(styles$P.toggleButton, " ").concat(isOpen ? styles$P.iconOpen : styles$P.iconClose)
      })]
    }), isOpen && jsx("div", {
      children: thirdLevelItems.map(function (thirdLevelData, index) {
        var _thirdLevelData$tag;
        return jsx("div", {
          className: styles$P.content,
          children: jsx("a", {
            className: styles$P.thirdLevelData,
            href: thirdLevelData === null || thirdLevelData === void 0 ? void 0 : thirdLevelData.item_url,
            style: thirdLevelData !== null && thirdLevelData !== void 0 && (_thirdLevelData$tag = thirdLevelData.tag) !== null && _thirdLevelData$tag !== void 0 && _thirdLevelData$tag.show ? {
              color: thirdLevelData.tag.text,
              fontWeight: 'bold'
            } : {},
            onClick: function onClick() {
              if (onThirdLevelClick) {
                onThirdLevelClick(index);
              }
            },
            children: thirdLevelData.item_name
          })
        }, index);
      })
    })]
  });
};
Accordion.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onThirdLevelClick: PropTypes.func,
  secondLevelData: PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.string.isRequired,
    third_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string.isRequired,
      item_url: PropTypes.string.isRequired
    })).isRequired,
    third_level_services: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string.isRequired,
      item_url: PropTypes.string.isRequired
    })).isRequired
  }).isRequired
};
var Accordion$1 = Accordion;

var styles$O = {"carausel":"CategoriesAndServiceTypes-module_carausel__aR8LB","content":"CategoriesAndServiceTypes-module_content__h9--u","divider":"CategoriesAndServiceTypes-module_divider__RP-z8","divider-gray":"CategoriesAndServiceTypes-module_divider-gray__I6R7P","subTitle":"CategoriesAndServiceTypes-module_subTitle__Okmnv","promotional":"CategoriesAndServiceTypes-module_promotional__PohyX"};

var CategoriesAndServiceType = function CategoriesAndServiceType(_ref) {
  var selectedHighlightLevelData = _ref.selectedHighlightLevelData,
    selectedSecondLevelData = _ref.selectedSecondLevelData,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    onUpdateCookies = _ref.onUpdateCookies,
    setThirdCatIndex = _ref.setThirdCatIndex,
    firstLevelItem = _ref.firstLevelItem,
    firstLevelCategoryIndex = _ref.firstLevelCategoryIndex,
    promotional = _ref.promotional,
    dataWrapper = _ref.dataWrapper,
    banners = _ref.banners,
    colorLine = _ref.colorLine,
    webCategoryId = _ref.webCategoryId,
    slots = _ref.slots;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    openIndex = _useState2[0],
    setOpenIndex = _useState2[1];
  var handleToggle = function handleToggle(index) {
    setOpenIndex(function (prevIndex) {
      return prevIndex === index ? null : index;
    });
    onUpdateCookies({
      secondCategoryIndex: index,
      type: selectedSecondLevelData[index].type
    });
  };
  var handleThirdLevelClick = function handleThirdLevelClick(thirdIndex) {
    onUpdateCookies({
      thirdLevelIndex: thirdIndex,
      type: selectedSecondLevelData[thirdIndex].type
    });
    setThirdCatIndex(thirdIndex);
  };
  return jsxs("div", {
    children: [(selectedHighlightLevelData === null || selectedHighlightLevelData === void 0 ? void 0 : selectedHighlightLevelData.length) > 0 && jsx("div", {
      className: styles$O.carausel,
      children: jsx(HighlightLevelCategories$1, {
        highlightLevelCategories: selectedHighlightLevelData,
        firstLevelItem: firstLevelItem,
        dataWrapper: "Sodimac",
        currentCategoryIndex: firstLevelCategoryIndex,
        isOpen: "true",
        enableSISMenuV2: enableSISMenuV2
      })
    }), banners.length > 0 && jsxs("div", {
      children: [jsx("hr", {
        className: styles$O.divider,
        style: {
          borderTopColor: colorLine
        }
      }), jsx(Banners$1, {
        banners: banners,
        style: {
          margin: '20px'
        },
        dataWrapper: dataWrapper,
        currentCategoryIndex: firstLevelCategoryIndex,
        firstLevelItem: firstLevelItem
      })]
    }), (selectedSecondLevelData === null || selectedSecondLevelData === void 0 ? void 0 : selectedSecondLevelData.length) > 0 && selectedSecondLevelData.map(function (subLevelData, index) {
      var _subLevelData$third_l;
      if ((subLevelData === null || subLevelData === void 0 || (_subLevelData$third_l = subLevelData.third_level_categories) === null || _subLevelData$third_l === void 0 ? void 0 : _subLevelData$third_l.length) > 0) {
        return jsx(Accordion$1, {
          secondLevelData: subLevelData,
          isOpen: openIndex === index,
          onToggle: function onToggle() {
            return handleToggle(index);
          },
          onThirdLevelClick: handleThirdLevelClick
        }, index);
      } else {
        return jsx("div", {
          className: styles$O.content,
          children: jsx("a", {
            className: styles$O.subTitle,
            href: subLevelData.item_url,
            children: subLevelData.item_name
          })
        }, index);
      }
    }), (promotional === null || promotional === void 0 ? void 0 : promotional.enable_promotional) && jsx("div", {
      className: classNames(styles$O.divider)
    }), (promotional === null || promotional === void 0 ? void 0 : promotional.enable_promotional) && jsx("div", {
      className: classNames(styles$O.promotional),
      children: jsx(PromotionalBanners$1, {
        data: promotional,
        dataWrapper: dataWrapper,
        currentCategoryIndex: firstLevelCategoryIndex,
        firstLevelItem: firstLevelItem,
        deviceType: "mobile",
        webCategoryId: webCategoryId,
        slots: slots,
        isProductButtonVisible: false
      })
    })]
  });
};
CategoriesAndServiceType.propTypes = {
  selectedHighlightLevelData: PropTypes.array,
  selectedSecondLevelData: PropTypes.array.isRequired,
  enableSISMenuV2: PropTypes.bool,
  onUpdateCookies: PropTypes.func,
  setThirdCatIndex: PropTypes.func.isRequired,
  setSecondCatIndex: PropTypes.func.isRequired,
  firstLevelItem: PropTypes.object,
  firstLevelCategoryIndex: PropTypes.number.isRequired,
  banners: PropTypes.array
};
CategoriesAndServiceType.defaultProps = {
  selectedHighlightLevelData: [],
  selectedSecondLevelData: []
};
var CategoriesAndServiceType$1 = CategoriesAndServiceType;

var CategoriesAndServices = function CategoriesAndServices(_ref) {
  var toggleCategoriesAndServices = _ref.toggleCategoriesAndServices,
    isCategoriesAndServicesOpen = _ref.isCategoriesAndServicesOpen,
    categories = _ref.categories,
    services = _ref.services,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    dataWrapper = _ref.dataWrapper,
    colorLine = _ref.colorLine,
    showCategoryFirst = _ref.showCategoryFirst,
    sideBarTitleMobile = _ref.sideBarTitleMobile,
    categoryHeaderTitle = _ref.categoryHeaderTitle,
    serviceHeaderTitle = _ref.serviceHeaderTitle;
  var INITIAL_HEADER_TITLE = sideBarTitleMobile;
  var _useState = useState(INITIAL_HEADER_TITLE),
    _useState2 = _slicedToArray(_useState, 2),
    headerTitle = _useState2[0],
    setHeaderTitle = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCatergoriesAndServicesTypesOpen = _useState4[0],
    setCategoriesAndServicesTypesOpen = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedHighlightLevelData = _useState6[0],
    setHighlightLevelData = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedSecondLevelData = _useState8[0],
    setSecondLevelCategoryData = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    firstLevelCategoryIndex = _useState0[0],
    setFirstLevelCategoryIndex = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    secondLevelCategoryIndex = _useState10[0],
    setSecondLevelCategoryIndex = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    thirdLevelCategoryIndex = _useState12[0],
    setThirdLevelCategoryIndex = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    firstItem = _useState14[0],
    setFirstLevelItem = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    banners = _useState16[0],
    setBanners = _useState16[1];
  var _useState17 = useState({}),
    _useState18 = _slicedToArray(_useState17, 2),
    promotional = _useState18[0],
    setPromotional = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    webCategoryId = _useState20[0],
    setWebCategoryId = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    slots = _useState22[0],
    setSlotId = _useState22[1];
  var toggleCategoriesAndServicesTypes = function toggleCategoriesAndServicesTypes() {
    if (isCatergoriesAndServicesTypesOpen) {
      setHeaderTitle(INITIAL_HEADER_TITLE);
      setFirstLevelCategoryIndex(null);
      setSecondLevelCategoryIndex(null);
      setThirdLevelCategoryIndex(null);
    }
    setCategoriesAndServicesTypesOpen(!isCatergoriesAndServicesTypesOpen);
  };
  var handleSetPromotionalData = function handleSetPromotionalData(data) {
    setPromotional(data);
  };
  var handleUpdateCookies = function handleUpdateCookies(_ref2) {
    var _ref2$secondCategoryI = _ref2.secondCategoryIndex,
      secondCategoryIndex = _ref2$secondCategoryI === void 0 ? null : _ref2$secondCategoryI,
      _ref2$firstLevelIndex = _ref2.firstLevelIndex,
      firstLevelIndex = _ref2$firstLevelIndex === void 0 ? null : _ref2$firstLevelIndex,
      _ref2$thirdLevelIndex = _ref2.thirdLevelIndex,
      thirdLevelIndex = _ref2$thirdLevelIndex === void 0 ? null : _ref2$thirdLevelIndex,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'category' : _ref2$type;
    if (firstLevelIndex !== null) {
      setFirstLevelCategoryIndex(firstLevelIndex);
    }
    if (secondCategoryIndex !== null) {
      setSecondLevelCategoryIndex(secondCategoryIndex);
    }
    if (thirdLevelIndex !== null) {
      setThirdLevelCategoryIndex(thirdLevelIndex);
    }
    var resolvedFirstIndex = firstLevelIndex !== null ? firstLevelIndex : firstLevelCategoryIndex;
    var resolvedSecondIndex = secondCategoryIndex !== null ? secondCategoryIndex : secondLevelCategoryIndex;
    var resolvedThirdIndex = thirdLevelIndex !== null ? thirdLevelIndex : thirdLevelCategoryIndex;
    var firstLevelItem;
    var secondLevelItem;
    var thirdLevelItem;
    if (type === 'category') {
      var _categories$resolvedF, _categories$resolvedF2, _categories$resolvedF3, _categories$resolvedF4, _categories$resolvedF5, _categories$resolvedF6;
      firstLevelItem = ((_categories$resolvedF = categories[resolvedFirstIndex]) === null || _categories$resolvedF === void 0 ? void 0 : _categories$resolvedF.item_name) || ((_categories$resolvedF2 = categories[resolvedFirstIndex]) === null || _categories$resolvedF2 === void 0 ? void 0 : _categories$resolvedF2.title);
      secondLevelItem = (_categories$resolvedF3 = (_categories$resolvedF4 = categories[resolvedFirstIndex]) === null || _categories$resolvedF4 === void 0 || (_categories$resolvedF4 = _categories$resolvedF4.second_level_categories) === null || _categories$resolvedF4 === void 0 || (_categories$resolvedF4 = _categories$resolvedF4[resolvedSecondIndex]) === null || _categories$resolvedF4 === void 0 ? void 0 : _categories$resolvedF4.item_name) !== null && _categories$resolvedF3 !== void 0 ? _categories$resolvedF3 : '';
      thirdLevelItem = (_categories$resolvedF5 = (_categories$resolvedF6 = categories[resolvedFirstIndex]) === null || _categories$resolvedF6 === void 0 || (_categories$resolvedF6 = _categories$resolvedF6.second_level_categories) === null || _categories$resolvedF6 === void 0 || (_categories$resolvedF6 = _categories$resolvedF6[resolvedSecondIndex]) === null || _categories$resolvedF6 === void 0 || (_categories$resolvedF6 = _categories$resolvedF6.third_level_categories) === null || _categories$resolvedF6 === void 0 || (_categories$resolvedF6 = _categories$resolvedF6[resolvedThirdIndex]) === null || _categories$resolvedF6 === void 0 ? void 0 : _categories$resolvedF6.item_name) !== null && _categories$resolvedF5 !== void 0 ? _categories$resolvedF5 : '';
    } else if (type === 'service') {
      var _services$resolvedFir, _services$resolvedFir2, _services$resolvedFir3, _services$resolvedFir4, _services$resolvedFir5;
      firstLevelItem = "SRV ".concat((_services$resolvedFir = services[resolvedFirstIndex]) === null || _services$resolvedFir === void 0 ? void 0 : _services$resolvedFir.item_name);
      secondLevelItem = (_services$resolvedFir2 = (_services$resolvedFir3 = services[resolvedFirstIndex]) === null || _services$resolvedFir3 === void 0 || (_services$resolvedFir3 = _services$resolvedFir3.second_level_categories) === null || _services$resolvedFir3 === void 0 || (_services$resolvedFir3 = _services$resolvedFir3[resolvedSecondIndex]) === null || _services$resolvedFir3 === void 0 ? void 0 : _services$resolvedFir3.item_name) !== null && _services$resolvedFir2 !== void 0 ? _services$resolvedFir2 : '';
      thirdLevelItem = (_services$resolvedFir4 = (_services$resolvedFir5 = services[resolvedFirstIndex]) === null || _services$resolvedFir5 === void 0 || (_services$resolvedFir5 = _services$resolvedFir5.second_level_categories) === null || _services$resolvedFir5 === void 0 || (_services$resolvedFir5 = _services$resolvedFir5[resolvedSecondIndex]) === null || _services$resolvedFir5 === void 0 || (_services$resolvedFir5 = _services$resolvedFir5.third_level_categories) === null || _services$resolvedFir5 === void 0 || (_services$resolvedFir5 = _services$resolvedFir5[resolvedThirdIndex]) === null || _services$resolvedFir5 === void 0 ? void 0 : _services$resolvedFir5.item_name) !== null && _services$resolvedFir4 !== void 0 ? _services$resolvedFir4 : '';
    }
    setFirstLevelItem(firstLevelItem);
    updateDigitalDataCookies({
      firstLevelItem: firstLevelItem,
      secondLevelItem: secondLevelItem,
      thirdLevelItem: thirdLevelItem,
      postionOne: resolvedFirstIndex + 1,
      postionTwo: resolvedSecondIndex !== null ? resolvedSecondIndex + 1 : '',
      postionThree: resolvedThirdIndex !== null ? resolvedThirdIndex + 1 : '',
      tag: SIS_NAVIGATION,
      dataWrapper: dataWrapper
    });
  };
  return jsxs("div", {
    className: styles$V.container,
    children: [jsx("div", {
      className: styles$V.header,
      children: jsxs("div", {
        className: styles$V.headerContent,
        children: [isCatergoriesAndServicesTypesOpen && jsx(BackButton$1, {
          onBack: toggleCategoriesAndServices,
          onCategoriesAndServicesTypesOpen: toggleCategoriesAndServicesTypes,
          isCategoriesAndServicesOpen: isCategoriesAndServicesOpen,
          isCatergoriesAndServicesTypesOpen: isCatergoriesAndServicesTypesOpen
        }), jsx("p", {
          className: styles$V.title,
          children: headerTitle
        })]
      })
    }), jsx("div", {
      className: styles$V.mainContent,
      children: !isCatergoriesAndServicesTypesOpen && isCategoriesAndServicesOpen ? jsx("div", {
        children: showCategoryFirst ? jsxs("div", {
          children: [categories.length > 0 && jsx(Categories$3, {
            onHeaderTitleChange: setHeaderTitle,
            onCategoriesAndServicesTypesOpen: toggleCategoriesAndServicesTypes,
            onHighlightTypeSelect: setHighlightLevelData,
            onSecondLevelSelect: setSecondLevelCategoryData,
            categories: categories,
            onUpdateCookies: handleUpdateCookies,
            setBanners: setBanners,
            handleSetPromotionalData: handleSetPromotionalData,
            setWebCategoryId: setWebCategoryId,
            setSlotId: setSlotId,
            categoryHeaderTitle: categoryHeaderTitle
          }), services.length > 0 && jsx("div", {
            className: services.length > 0 ? styles$V.wrapper : '',
            children: jsx(Services$1, {
              onHeaderTitleChange: setHeaderTitle,
              onCategoriesAndServicesTypesOpen: toggleCategoriesAndServicesTypes,
              onHighlightTypeSelect: setHighlightLevelData,
              onSecondLevelSelect: setSecondLevelCategoryData,
              services: services,
              onUpdateCookies: handleUpdateCookies,
              handleSetPromotionalData: handleSetPromotionalData,
              setBanners: setBanners,
              setWebCategoryId: setWebCategoryId,
              setSlotId: setSlotId,
              serviceHeaderTitle: serviceHeaderTitle
            })
          })]
        }) : jsxs("div", {
          children: [services.length > 0 && jsx(Services$1, {
            onHeaderTitleChange: setHeaderTitle,
            onCategoriesAndServicesTypesOpen: toggleCategoriesAndServicesTypes,
            onHighlightTypeSelect: setHighlightLevelData,
            onSecondLevelSelect: setSecondLevelCategoryData,
            services: services,
            onUpdateCookies: handleUpdateCookies,
            handleSetPromotionalData: handleSetPromotionalData,
            setBanners: setBanners,
            setWebCategoryId: setWebCategoryId,
            setSlotId: setSlotId,
            serviceHeaderTitle: serviceHeaderTitle
          }), categories.length > 0 && jsx("div", {
            className: services.length > 0 ? styles$V.wrapper : '',
            children: jsx(Categories$3, {
              onHeaderTitleChange: setHeaderTitle,
              onCategoriesAndServicesTypesOpen: toggleCategoriesAndServicesTypes,
              onHighlightTypeSelect: setHighlightLevelData,
              onSecondLevelSelect: setSecondLevelCategoryData,
              categories: categories,
              onUpdateCookies: handleUpdateCookies,
              setBanners: setBanners,
              handleSetPromotionalData: handleSetPromotionalData,
              setWebCategoryId: setWebCategoryId,
              setSlotId: setSlotId,
              categoryHeaderTitle: categoryHeaderTitle
            })
          })]
        })
      }) : jsx(CategoriesAndServiceType$1, {
        selectedSecondLevelData: selectedSecondLevelData,
        selectedHighlightLevelData: selectedHighlightLevelData,
        enableSISMenuV2: enableSISMenuV2,
        onUpdateCookies: handleUpdateCookies,
        setSecondCatIndex: setSecondLevelCategoryIndex,
        setThirdCatIndex: setThirdLevelCategoryIndex,
        firstLevelCategoryIndex: firstLevelCategoryIndex,
        firstLevelItem: firstItem,
        dataWrapper: dataWrapper,
        banners: banners,
        colorLine: colorLine,
        promotional: promotional,
        webCategoryId: webCategoryId,
        slots: slots
      })
    })]
  });
};
CategoriesAndServices.propTypes = {
  toggleCategoriesAndServices: PropTypes.func.isRequired,
  isCategoriesAndServicesOpen: PropTypes.bool.isRequired,
  enableSISMenuV2: PropTypes.bool,
  dataWrapper: PropTypes.string,
  categories: PropTypes.array.isRequired,
  services: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    }).isRequired,
    tag: PropTypes.shape({
      show: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.array,
    second_level_categories: PropTypes.array
  })).isRequired,
  showCategoryFirst: PropTypes.bool,
  sideBarTitleMobile: PropTypes.string,
  categoryHeaderTitle: PropTypes.string,
  serviceHeaderTitle: PropTypes.string
};
var CategoriesAndServices$1 = CategoriesAndServices;

var styles$N = {"drawer":"Drawer-module_drawer__RL6YM","open":"Drawer-module_open__4TRPQ","slideIn":"Drawer-module_slideIn__mLhAQ","close":"Drawer-module_close__zfgUe","slideOut":"Drawer-module_slideOut__ls3k2","drawerContent":"Drawer-module_drawerContent__56U7-","closeButton":"Drawer-module_closeButton__SIET5","content":"Drawer-module_content__RsRzm","overlay":"Drawer-module_overlay__nnw3C","fadeIn":"Drawer-module_fadeIn__ioeSd","fadeOut":"Drawer-module_fadeOut__hJwoT"};

var Drawer = function Drawer(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    children = _ref.children;
  var _useState = useState(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isDrawerOpen = _useState2[0],
    setIsDrawerOpen = _useState2[1];
  var handleDrawerClose = function handleDrawerClose() {
    setIsDrawerOpen(false);
    setTimeout(function () {
      return onClose();
    }, 700);
  };
  return jsx("div", {
    children: jsx("div", {
      className: "".concat(styles$N.overlay, " ").concat(isDrawerOpen ? styles$N.open : styles$N.close),
      children: jsx("div", {
        className: "".concat(styles$N.drawer, " ").concat(isDrawerOpen ? styles$N.open : styles$N.close),
        children: jsxs("div", {
          className: styles$N.drawerContent,
          children: [jsx("button", {
            className: styles$N.closeButton,
            onClick: handleDrawerClose
          }), jsx("div", {
            className: styles$N.content,
            children: children
          })]
        })
      })
    })
  });
};
Drawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  isSecondaryMenuOpen: PropTypes.bool
};
var Drawer$1 = Drawer;

var styles$M = {"menuButton":"SiSMenuMobile-module_menuButton__21P2q","hamburgerIcon":"SiSMenuMobile-module_hamburgerIcon__0exvF","hamburgerLine":"SiSMenuMobile-module_hamburgerLine__1ULnP"};

var SiSMenuMobile = function SiSMenuMobile(_ref) {
  var categories = _ref.categories,
    services = _ref.services,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    dataWrapper = _ref.dataWrapper,
    colorLine = _ref.colorLine,
    showCategoryFirst = _ref.showCategoryFirst,
    sideBarTitleMobile = _ref.sideBarTitleMobile,
    categoryHeaderTitle = _ref.categoryHeaderTitle,
    serviceHeaderTitle = _ref.serviceHeaderTitle;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var toggleDrawer = function toggleDrawer() {
    setIsOpen(!isOpen);
  };
  var filteredCategories = categories.filter(function (x) {
    var _x$channel;
    return x === null || x === void 0 || (_x$channel = x.channel) === null || _x$channel === void 0 ? void 0 : _x$channel.mobile;
  });
  var filteredServices = services.filter(function (x) {
    var _x$channel2;
    return x === null || x === void 0 || (_x$channel2 = x.channel) === null || _x$channel2 === void 0 ? void 0 : _x$channel2.mobile;
  });
  return jsxs("div", {
    children: [jsxs("div", {
      className: styles$M.menuButton,
      onClick: toggleDrawer,
      children: [jsxs("div", {
        className: styles$M.hamburgerIcon,
        children: [jsx("span", {
          className: styles$M.hamburgerLine
        }), jsx("span", {
          className: styles$M.hamburgerLine
        }), jsx("span", {
          className: styles$M.hamburgerLine
        })]
      }), jsx("p", {
        children: "Men\xFA"
      })]
    }), isOpen && jsx(Drawer$1, {
      isOpen: isOpen,
      onClose: toggleDrawer,
      children: jsx(CategoriesAndServices$1, {
        isCategoriesAndServicesOpen: isOpen,
        categories: filteredCategories,
        services: filteredServices,
        toggleCategoriesAndServices: toggleDrawer,
        dataWrapper: dataWrapper,
        enableSISMenuV2: enableSISMenuV2,
        colorLine: colorLine,
        showCategoryFirst: showCategoryFirst,
        sideBarTitleMobile: sideBarTitleMobile,
        categoryHeaderTitle: categoryHeaderTitle,
        serviceHeaderTitle: serviceHeaderTitle
      })
    })]
  });
};
SiSMenuMobile.propTypes = {
  categories: PropTypes.array.isRequired,
  dataWrapper: PropTypes.string,
  services: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    }).isRequired,
    tag: PropTypes.shape({
      show: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.array,
    second_level_categories: PropTypes.array
  })).isRequired,
  enableSISMenuV2: PropTypes.bool,
  showCategoryFirst: PropTypes.bool,
  sideBarTitleMobile: PropTypes.string,
  categoryHeaderTitle: PropTypes.string,
  serviceHeaderTitle: PropTypes.string
};
var SiSMenuMobile$1 = SiSMenuMobile;

var SiSNavigationMenu = function SiSNavigationMenu(_ref) {
  var menuConfig = _ref.menuConfig,
    categories = _ref.categories,
    services = _ref.services,
    colorLine = _ref.colorLine,
    categoryColor = _ref.categoryColor,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    browseMainText = _ref.browseMainText,
    isSISLevel2Header = _ref.isSISLevel2Header,
    dataWrapper = _ref.dataWrapper,
    store = _ref.store,
    style = _ref.style,
    classes = _ref.classes,
    id = _ref.id,
    isVendorOrAgentLoggedIn = _ref.isVendorOrAgentLoggedIn,
    defaultCategoryColors = _ref.defaultCategoryColors,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    showCategoryFirst = _ref.showCategoryFirst,
    sideBarTitleMobile = _ref.sideBarTitleMobile,
    categoryHeaderTitle = _ref.categoryHeaderTitle,
    serviceHeaderTitle = _ref.serviceHeaderTitle;
  if (!store) {
    return jsx(React.Fragment, {});
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobileVisible = _useState2[0],
    setIsMobileVisible = _useState2[1];
  useEffect(function () {
    setIsMobileVisible(isIpadPotrait());
  }, [isMobileVisible]);
  return jsx("div", {
    "data-wrapper": "MS-MenuSis_".concat(dataWrapper),
    className: classNames(styles$1b.container, classes.join(' ')),
    style: style,
    id: id,
    "data-testid": "SiSNavigationMenuId",
    children: isMobileVisible ? (store === 'so_com' || store === 'so_retail') && enableSISMenuV2 ? jsx(SiSMenuMobile$1, {
      categories: categories,
      services: services,
      colorLine: colorLine,
      browseMainText: browseMainText,
      categoryColor: categoryColor,
      store: store,
      dataWrapper: dataWrapper,
      menuConfig: menuConfig,
      defaultCategoryColors: defaultCategoryColors,
      enableSISMenuV2: enableSISMenuV2,
      showCategoryFirst: showCategoryFirst,
      sideBarTitleMobile: sideBarTitleMobile,
      categoryHeaderTitle: categoryHeaderTitle,
      serviceHeaderTitle: serviceHeaderTitle
    }) : jsx(SiSCategoryMenuMobile, {
      categories: categories,
      colorLine: colorLine,
      browseMainText: browseMainText,
      categoryColor: categoryColor,
      store: store,
      dataWrapper: dataWrapper,
      menuConfig: menuConfig,
      defaultCategoryColors: defaultCategoryColors,
      enableSISMenuV2: enableSISMenuV2
    }) : jsx(CategoryProvider, {
      children: jsx(SiSCategoryMenuDesktop, {
        categories: categories,
        services: services,
        browseMainText: browseMainText,
        colorLine: colorLine,
        categoryColor: categoryColor,
        hightlightColor: hightlightColor,
        hightlightTextColor: hightlightTextColor,
        store: store,
        dataWrapper: dataWrapper,
        isSISLevel2Header: isSISLevel2Header,
        isVendorOrAgentLoggedIn: isVendorOrAgentLoggedIn,
        menuConfig: menuConfig,
        defaultCategoryColors: defaultCategoryColors,
        enableSISMenuV2: enableSISMenuV2,
        showCategoryFirst: showCategoryFirst,
        categoryHeaderTitle: categoryHeaderTitle,
        serviceHeaderTitle: serviceHeaderTitle
      })
    })
  });
};
SiSNavigationMenu.propTypes = {
  brandLogo: PropTypes.shape({
    url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  }),
  menuConfig: PropTypes.shape({
    desktop: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    }),
    mobile: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    })
  }),
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.object,
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })),
  colorLine: PropTypes.string,
  categoryColor: PropTypes.string,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string,
  isSISLevel2Header: PropTypes.bool,
  browseMainText: PropTypes.string.isRequired,
  dataWrapper: PropTypes.string,
  store: PropTypes.string,
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  isVendorOrAgentLoggedIn: PropTypes.bool,
  defaultCategoryColors: PropTypes.arrayOf(PropTypes.string),
  services: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    }).isRequired,
    tag: PropTypes.shape({
      show: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.array,
    second_level_categories: PropTypes.array
  })).isRequired,
  enableSISMenuV2: PropTypes.bool,
  showCategoryFirst: PropTypes.bool,
  sideBarTitleMobile: PropTypes.string,
  categoryHeaderTitle: PropTypes.string,
  serviceHeaderTitle: PropTypes.string
};
SiSNavigationMenu.defaultProps = {
  classes: [],
  categories: [],
  services: [],
  id: undefined,
  isVendorOrAgentLoggedIn: false,
  style: {},
  dataWrapper: 'MS-MenuSis_',
  enableSISMenuV2: false,
  showCategoryFirst: false,
  categoryHeaderTitle: '',
  serviceHeaderTitle: '',
  sideBarTitleMobile: ''
};
var SiSNavigationMenu$1 = SiSNavigationMenu;

var styles$L = {"container":"Breadcrumbs-module_container__70HUT","dark-link":"Breadcrumbs-module_dark-link__59QTH","breadcrumb-container":"Breadcrumbs-module_breadcrumb-container__ioCRH","landing-page-container":"Breadcrumbs-module_landing-page-container__dsInq","breadcrumb":"Breadcrumbs-module_breadcrumb__b47ha","selected-bread-crumb":"Breadcrumbs-module_selected-bread-crumb__ZPj02"};

var styles$K = {"fallback":"MediaComponent-module_fallback__p8Hok","mobile-only":"MediaComponent-module_mobile-only__Dra1n","tablet-only":"MediaComponent-module_tablet-only__cY5S2","desktop-only":"MediaComponent-module_desktop-only__oZPJV","mobile-tablet":"MediaComponent-module_mobile-tablet__lzpul","mobile-desktop":"MediaComponent-module_mobile-desktop__t7J5y","tablet-desktop":"MediaComponent-module_tablet-desktop__9nJYW"};

var mediaConstants = {
  mobile: 'mobile',
  phablet: 'phablet',
  tablet: 'tablet',
  desktop: 'desktop'
};
var MediaComponent = function MediaComponent(_ref) {
  var from = _ref.from,
    to = _ref.to,
    children = _ref.children;
  var className;
  if (!to || from === to || from === mediaConstants.desktop) {
    className = "".concat(from, "-only");
  } else {
    className = "".concat(from, "-").concat(to);
  }
  className = from === mediaConstants.mobile ? classNames(styles$K.fallback, styles$K[className]) : styles$K[className];
  return jsx(Fragment, {
    children: jsx("div", {
      className: className,
      children: children
    })
  });
};
MediaComponent.propTypes = {
  from: PropTypes.string.isRequired,
  to: PropTypes.string,
  children: PropTypes.node
};
MediaComponent.defaultProps = {
  children: null,
  to: null
};
var MediaComponent$1 = MediaComponent;

var formatBreadcrumb = function formatBreadcrumb(items, productName) {
  var breadCrumbItems = items.slice();
  breadCrumbItems.reverse();
  var MAX_CATEGORY_LEVEL = 2;
  if (productName) {
    breadCrumbItems = breadCrumbItems.slice(0, MAX_CATEGORY_LEVEL);
  }
  return breadCrumbItems;
};
var getParams = function getParams(path) {
  var url = new URL("https://www.falabella.com".concat(path));
  return Object.fromEntries(url.searchParams.entries());
};
var getStore = function getStore(_ref) {
  var isPdpPage = _ref.isPdpPage,
    expParam = _ref.expParam,
    isLanding = _ref.isLanding,
    params = _ref.params,
    page = _ref.page;
  var store = STORE_MAP.MARKETPLACE;
  if (isPdpPage && expParam !== STORE_MAP.MARKETPLACE) {
    store = expParam;
  } else if (isLanding) {
    var pageStore = typeof page.store === 'string' ? page.store.toLowerCase() : '';
    store = getStoreName(pageStore === 'fa_com' ? '' : pageStore);
  } else {
    store = getStoreName(params.store);
  }
  return store;
};
var getEnvironmentName = function getEnvironmentName(text) {
  var envMatch = text.match(/(localhost|dev|staging|beta|uat)/);
  switch (envMatch && envMatch[0] || '') {
    case 'dev':
      return ENVIRONMENT.DEVELOPMEMT;
    case 'staging':
      return ENVIRONMENT.STAGING;
    case 'beta':
    case 'uat':
      return ENVIRONMENT.UAT;
    default:
      return ENVIRONMENT.PRODUCTION;
  }
};
var Breadcrumbs = function Breadcrumbs(_ref2) {
  var items = _ref2.items,
    tenant = _ref2.tenant,
    host = _ref2.host,
    path = _ref2.path,
    productName = _ref2.productName,
    isPdpPage = _ref2.isPdpPage,
    isLanding = _ref2.isLanding,
    page = _ref2.page;
  if (!host || !path) {
    return jsx(Fragment, {});
  }
  var breadCrumbsData = !isLanding ? formatBreadcrumb(items, productName) : [];
  var params = getParams(path);
  var expParam = isPdpPage ? getStoreName(params.store) : '';
  var store = getStore({
    isPdpPage: isPdpPage,
    isLanding: isLanding,
    expParam: expParam,
    params: params,
    page: page
  });
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var isSisExperience = isPdpPage && expParam !== STORE_MAP.MARKETPLACE || !isPdpPage && store !== STORE_MAP.MARKETPLACE;
  var env = getEnvironmentName(host);
  var homeUrl = apiConfig$2.getHomeUrl({
    tenant: tenant,
    store: store,
    env: env
  });
  var sisHomeUrl = apiConfig$2.getSisHomeUrl({
    tenant: tenant,
    store: store,
    env: env
  });
  var backHandler = function backHandler() {
    if (isLanding) {
      window.location.replace(sisHomeUrl);
    } else {
      var len = breadCrumbsData.length;
      var parent = breadCrumbsData[len - 2];
      var backUrl = "/".concat(isStandaloneSite || isWhitelabelSite ? STORE_MAP[tenant][store] : 'falabella', "-").concat(tenant).concat(parent.link);
      window.location.replace(backUrl);
    }
  };
  var parsePageName = function parsePageName(title) {
    var t = title.includes('|') ? title.split('|')[0] : title;
    return t.replace('-', ' ').trim();
  };
  return jsxs("div", {
    id: "breadcrumb",
    className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$L.container, true), styles$L['breadcrumb-container'], true), styles$L['landing-page-container'], isLanding)),
    "data-testid": "breadcrumbs",
    children: [jsx(MediaComponent$1, {
      from: "mobile",
      to: "desktop",
      children: (breadCrumbsData.length > 1 || isLanding) && jsx("button", {
        type: "button",
        onClick: backHandler,
        children: jsx("i", {
          className: "csicon-arrow-left2"
        })
      })
    }), jsxs("ol", {
      className: classNames(styles$L.breadcrumb),
      children: [jsx("li", {
        children: jsx("a", {
          href: homeUrl,
          children: "Home"
        })
      }, "breadcrumb-home"), (isSisExperience || isLanding) && ![STORE_MAP.MARKETPLACE, 'so_com', 'to_com', 'so_retail'].includes(store) && sisHomeUrl !== homeUrl ? jsx("li", {
        children: jsx("a", {
          href: sisHomeUrl,
          style: {
            textTransform: 'capitalize'
          },
          children: STORE_MAP[tenant][store]
        })
      }, "breadcrumb-".concat(store)) : null, isLanding ? jsx("li", {
        style: {
          textTransform: 'capitalize'
        },
        children: parsePageName(page.title)
      }, "breadcrumb-".concat(store, "-landing-page")) : null, !isLanding && breadCrumbsData.map(function (item, index) {
        var isLastItem = index === breadCrumbsData.length - 1;
        var link = "".concat(sisHomeUrl).concat(item.link || '');
        var itemLabel = item.label || '';
        if (isLastItem && isPdpPage) {
          return jsx("li", {
            children: jsx("a", {
              href: link,
              className: classNames(styles$L['selected-bread-crumb']),
              children: itemLabel
            })
          }, "breadcrumb-".concat(itemLabel));
        }
        return jsx("li", {
          children: isLastItem ? jsx(Fragment, {
            children: itemLabel
          }) : jsx("a", {
            href: link,
            children: itemLabel
          })
        }, "breadcrumb-".concat(itemLabel));
      })]
    })]
  });
};
Breadcrumbs.defaultProps = {
  tenant: 'cl',
  items: [],
  productName: undefined,
  isPdpPage: false,
  isLanding: false
};
Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string
  })),
  tenant: PropTypes.oneOf(['cl', 'ar', 'pe', 'co']),
  host: PropTypes.string,
  path: PropTypes.string,
  productName: PropTypes.string,
  isPdpPage: PropTypes.bool,
  isLanding: PropTypes.bool,
  page: PropTypes.object
};
var Breadcrumbs$1 = Breadcrumbs;

var _this = undefined;
var debounce = function debounce(func, wait) {
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var timeout = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var context = _this;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

var styles$J = {"rebranding":"FooterList-module_rebranding__1kKtK","titleContainer":"FooterList-module_titleContainer__RQxEJ","titleButtonContainer":"FooterList-module_titleButtonContainer__xzSpS","titleLine":"FooterList-module_titleLine__slV9h","footerList":"FooterList-module_footerList__XxcjZ","minimizeUl":"FooterList-module_minimizeUl__C83hU","expandUl":"FooterList-module_expandUl__RBquh","minimizeUlRebranded":"FooterList-module_minimizeUlRebranded__q8-bV","expandUlRebranded":"FooterList-module_expandUlRebranded__t3-7X"};

var FooterList = function FooterList(_ref) {
  var listTitle = _ref.listTitle,
    items = _ref.items,
    itemIndex = _ref.index,
    deviceType = _ref.deviceType,
    platform = _ref.platform,
    isRebrandingEnabled = _ref.isRebrandingEnabled,
    textColor = _ref.textColor;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var ulRef = useRef(null);
  var indexByDevice = 0;
  var toggleIsOpen = function toggleIsOpen() {
    if (ulRef) {
      var minimizeClass = isRebrandingEnabled ? styles$J.minimizeUlRebranded : styles$J.minimizeUl;
      var expandClass = isRebrandingEnabled ? styles$J.expandUlRebranded : styles$J.expandUl;
      if (isOpen) {
        ulRef.current.classList.remove(expandClass);
        ulRef.current.classList.add(minimizeClass);
        setIsOpen(false);
      }
      if (!isOpen) {
        ulRef.current.classList.remove(minimizeClass);
        ulRef.current.classList.add(expandClass);
        setIsOpen(true);
      }
    }
  };
  var itemTextColor = textColor ? {
    color: textColor
  } : {};
  var titleLineStyles = textColor ? {
    backgroundColor: textColor,
    border: "1px solid ".concat(textColor)
  } : {};
  return jsxs("nav", {
    className: isRebrandingEnabled ? "".concat(styles$J.footerList, " ").concat(styles$J.rebranding) : styles$J.footerList,
    id: "footer-top-column-".concat(itemIndex + 2, "-FooterList"),
    children: [jsx("input", {
      type: "checkbox",
      onClick: toggleIsOpen
    }), jsxs("div", {
      className: styles$J.titleContainer,
      children: [jsx("h3", {
        style: itemTextColor,
        children: listTitle
      }), jsxs("div", {
        className: styles$J.titleButtonContainer,
        children: [jsx("div", {
          className: styles$J.titleLine,
          style: titleLineStyles
        }), jsx("div", {
          className: styles$J.titleLine,
          style: titleLineStyles
        })]
      })]
    }), jsx("ul", {
      ref: ulRef,
      children: items.map(function (_ref2, index) {
        var url = _ref2.url,
          title = _ref2.title,
          image = _ref2.image,
          is_new_tab = _ref2.is_new_tab,
          icon_position = _ref2.icon_position,
          display_in = _ref2.display_in;
        if (!url) {
          return;
        }
        var shouldDisplay = function (_display_in$platform, _display_in$deviceTyp, _display_in$deviceTyp2) {
          if (deviceType === deviceTypes.MOBILE && ((_display_in$platform = display_in === null || display_in === void 0 ? void 0 : display_in[platform]) !== null && _display_in$platform !== void 0 ? _display_in$platform : false)) {
            return true;
          } else if (deviceType === deviceTypes.TABLET && ((_display_in$deviceTyp = display_in === null || display_in === void 0 ? void 0 : display_in[deviceType]) !== null && _display_in$deviceTyp !== void 0 ? _display_in$deviceTyp : false)) {
            return true;
          } else if (deviceType === deviceTypes.DESKTOP && ((_display_in$deviceTyp2 = display_in === null || display_in === void 0 ? void 0 : display_in[deviceType]) !== null && _display_in$deviceTyp2 !== void 0 ? _display_in$deviceTyp2 : false)) {
            return true;
          } else {
            return false;
          }
        }();
        if (!shouldDisplay) {
          return;
        }
        var imageUrl = image && image.url;
        var Image = function Image() {
          if (!imageUrl) {
            return;
          }
          return jsx("img", {
            className: styles$J['link-icon'],
            src: imageUrl,
            alt: title
          });
        };
        var Link = function Link(_ref3) {
          var children = _ref3.children;
          return jsx("a", {
            href: url,
            target: is_new_tab ? '_blank' : '_self',
            rel: "noopener noreferrer",
            style: itemTextColor,
            children: children
          });
        };
        var iconPosition = icon_position ? icon_position.toLowerCase() : 'left';
        indexByDevice += 1;
        return imageUrl ? jsx("li", {
          id: "testId-footerList-".concat(listTitle.replace(/ /g, '-'), "-").concat(indexByDevice),
          "data-id": indexByDevice,
          onClick: function onClick(eventLink) {
            var currentIndex = eventLink.currentTarget.getAttribute('data-id');
            updateDigitalDataCookies({
              firstLevelItem: 'N1',
              secondLevelItem: itemIndex + 1,
              thirdLevelItem: currentIndex,
              positionOne: listTitle,
              positionTwo: title,
              positionThree: getPageName(),
              tag: FOOTER
            });
          },
          children: jsxs(Link, {
            children: [iconPosition === 'left' ? jsx(Image, {}) : jsx(Fragment$1, {}), jsx("span", {
              children: title
            }), iconPosition === 'right' ? jsx(Image, {}) : jsx(Fragment$1, {})]
          })
        }, title.replace(/ /g, '-')) : jsx("li", {
          id: "testId-footerList-".concat(listTitle.replace(/ /g, '-'), "-").concat(indexByDevice),
          "data-id": indexByDevice,
          onClick: function onClick(eventLink) {
            var currentIndex = eventLink.currentTarget.getAttribute('data-id');
            updateDigitalDataCookies({
              firstLevelItem: 'N1',
              secondLevelItem: itemIndex + 1,
              thirdLevelItem: currentIndex,
              positionOne: listTitle,
              positionTwo: title,
              positionThree: getPageName(),
              tag: FOOTER
            });
          },
          children: jsx(Link, {
            children: title
          })
        }, title.replace(/ /g, '-'));
      })
    })]
  });
};
FooterList.propTypes = {
  listTitle: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    is_new_tab: PropTypes.bool.isRequired,
    icon_position: PropTypes.string.isRequired,
    image: PropTypes.oneOfType([PropTypes.object, PropTypes.shape({
      filename: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      tag: PropTypes.arrayOf(PropTypes.string).isRequired,
      url: PropTypes.string.isRequired
    })]),
    display_in: PropTypes.shape({
      desktop: PropTypes.bool.isRequired,
      tablet: PropTypes.bool.isRequired,
      mobile_android: PropTypes.bool.isRequired,
      mobile_ios: PropTypes.bool.isRequired
    }).isRequired
  }).isRequired).isRequired,
  deviceType: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
  isRebrandingEnabled: PropTypes.bool.isRequired,
  textColor: PropTypes.string
};
var FooterList$1 = FooterList;

var styles$I = {"rebranding":"SocialIcons-module_rebranding__PdJMi","icon":"SocialIcons-module_icon__5RLzP","icon-facebook":"SocialIcons-module_icon-facebook__ya23l","icon-twitter":"SocialIcons-module_icon-twitter__-iWDy","icon-instagram":"SocialIcons-module_icon-instagram__g9usF","icon-youtube":"SocialIcons-module_icon-youtube__I-TPU","socialIcons":"SocialIcons-module_socialIcons__v-t9j","icon-pinterest":"SocialIcons-module_icon-pinterest__0fIZf"};

var SocialIcons = function SocialIcons(_ref) {
  var icons = _ref.icons,
    isRebrandingEnabled = _ref.isRebrandingEnabled;
  return jsx("ul", {
    className: isRebrandingEnabled ? "".concat(styles$I.socialIcons, " ").concat(styles$I.rebranding) : styles$I.socialIcons,
    id: "footer-top-column-1-SocialIcons",
    children: icons.map(function (icon, index) {
      if (!icon.url) {
        return;
      }
      var socialMediaName = '';
      if (icon.url.includes('facebook')) {
        socialMediaName = 'facebook';
      } else if (icon.url.includes('instagram')) {
        socialMediaName = 'instagram';
      } else if (icon.url.includes('twitter')) {
        socialMediaName = 'twitter';
      } else if (icon.url.includes('youtube')) {
        socialMediaName = 'youtube';
      } else {
        return;
      }
      var iconBgColor = icon.icon_background_color || undefined;
      var iconHoverColor = icon.change_color_on_hover && icon.hover_color ? icon.hover_color : undefined;
      return jsx("li", {
        id: "footer-top-column-1-SocialIcons",
        children: jsx("a", {
          href: icon.url,
          className: "".concat(styles$I.icon, "\n                ").concat(styles$I["icon-".concat(socialMediaName)]),
          target: icon.is_new_tab ? '_blank' : '_self',
          rel: "noreferrer noopener",
          onClick: function onClick() {
            updateDigitalDataCookies({
              firstLevelItem: 'N2',
              secondLevelItem: index + 1,
              thirdLevelItem: 'X',
              positionOne: "SI_".concat(capitalizeWord(socialMediaName)),
              positionTwo: 'X',
              positionThree: getPageName(),
              tag: FOOTER
            });
          },
          style: {
            '--icon-bg-color': iconBgColor,
            '--icon-hover-color': iconHoverColor
          },
          children: jsx("i", {
            className: styles$I["icon-".concat(socialMediaName)]
          })
        })
      }, icon.url);
    })
  });
};
SocialIcons.propTypes = {
  icons: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
    is_new_tab: PropTypes.bool.isRequired,
    change_color_on_hover: PropTypes.bool.isRequired,
    hover_color: PropTypes.string.isRequired
  })).isRequired,
  isRebrandingEnabled: PropTypes.bool.isRequired
};
var SocialIcons$1 = SocialIcons;

var useOnScroll = function useOnScroll(_ref) {
  var handler = _ref.handler,
    effectListener = _ref.effectListener;
  useEffect(function () {
    window.addEventListener('scroll', handler);
    return function () {
      window.removeEventListener('scroll', handler);
    };
  }, [effectListener]);
};
var useOnScroll$1 = useOnScroll;

var footerLabels = {
  LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
  SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
  SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
  SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
  A11Y_BACKTOTOP: ''
};
var constants$1 = {
  FACET_MOBILE_CONTAINER_HEIGHT: 50,
  isCookieLegalBannerSelected: 'isCookieLegalBannerSelected'
};
var footerEndpoints = {
  getEmailSubcriptionUrl: function getEmailSubcriptionUrl(baseUrl) {
    return "".concat(baseUrl, "/rest/model/falabella/rest/common/CommonActor/subscribe-to-newsletter");
  }
};
var DataFiscal = 'data:image/png;base64,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';
var footerConfig = {
  labels: footerLabels,
  endpoints: footerEndpoints,
  images: {
    DataFiscal: DataFiscal
  },
  constants: constants$1
};
var footerConfig$1 = footerConfig;

var styles$H = {"rebranding":"Footer-module_rebranding__n7rZw","footer-secondary":"Footer-module_footer-secondary__YJB7Y","footer-secondary-container":"Footer-module_footer-secondary-container__Zrfdg","horizontal-links-container":"Footer-module_horizontal-links-container__j8ROT","footer-tertiary":"Footer-module_footer-tertiary__vBFyH","footer-tertiary-container":"Footer-module_footer-tertiary-container__dlG4d","copyright-container":"Footer-module_copyright-container__YGA1r","security-container":"Footer-module_security-container__BjV36","has-legal-banner":"Footer-module_has-legal-banner__jhvrD","hide-footer":"Footer-module_hide-footer__05xLX","footerContainer":"Footer-module_footerContainer__sVA53","footer-bottom":"Footer-module_footer-bottom__tP8X-","close-legal-banner":"Footer-module_close-legal-banner__Tuqyl","footer-primary":"Footer-module_footer-primary__UKKBc","footer-logo":"Footer-module_footer-logo__CADfC","footer-primary-container":"Footer-module_footer-primary-container__f-SGh","footer-links-column-container":"Footer-module_footer-links-column-container__Obcn0","social-media-container":"Footer-module_social-media-container__oi9gQ","filler-container":"Footer-module_filler-container__GT9xf","copyright-title":"Footer-module_copyright-title__FuS01","copyright-description":"Footer-module_copyright-description__xclcf","security-icon":"Footer-module_security-icon__gPoJ7","security-text":"Footer-module_security-text__-OhAQ","powered-by-container":"Footer-module_powered-by-container__JXjJK","powered-by-icon":"Footer-module_powered-by-icon__naPaM"};

var Footer = function Footer(_ref) {
  var _footer$bottom_banner, _footer$footerColumns, _footer$socialIcons, _footer$horizontalLin, _footer$copyright, _footer$copyright2, _footer$copyright3, _footer$copyright4, _footer$copyright5, _footer$poweredBy, _footer$poweredBy2, _footer$poweredBy3, _footer$security, _footer$security2, _footer$bottom_banner2, _footer$bottom_banner3, _footer$bottom_banner4, _footer$bottom_banner5, _footer$bottom_banner6, _footer$bottom_banner7, _footer$bottom_banner8;
  var data = _ref.data,
    deviceType = _ref.deviceType,
    attachResizeListener = _ref.attachResizeListener,
    store = _ref.store;
  var _useContext = useContext(AppContext$1),
    tenant = _useContext.tenant;
    _useContext.baseUrl;
    var isRebrandingEnabled = _useContext.isRebrandingEnabled,
    _useContext$MobileApp = _useContext.MobileAppWebView,
    MobileAppWebView = _useContext$MobileApp === void 0 ? false : _useContext$MobileApp;
  var constants = footerConfig$1.constants;
  var _useState = useState(buildFooterData(data)),
    _useState2 = _slicedToArray(_useState, 2),
    footer = _useState2[0];
    _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    platform = _useState4[0],
    setPlatform = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    legalBannerVisiblility = _useState6[0],
    setLegalBannerVisiblility = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    legalBannerCookie = _useState8[0],
    setLegalBannerCookie = _useState8[1];
  useEffect(function () {
    if (CookieStorage$1.getCookie(constants.isCookieLegalBannerSelected) !== 'true') {
      setLegalBannerVisiblility(true);
      setLegalBannerCookie(false);
    }
    attachResizeListener();
    if (window && window.navigator && window.navigator.userAgent) {
      setPlatform(getPlatformType(window.navigator.userAgent));
    }
    attachResizeListener();
  }, []);
  var footerRef = useRef();
  var handleWindowScroll = function handleWindowScroll() {
    if (deviceType === 'desktop') {
      return;
    }
    var topOffset = footerRef.current.getBoundingClientRect().top - constants.FACET_MOBILE_CONTAINER_HEIGHT;
    if (topOffset <= 0) {
      toggleBodyClass(true, 'footerVisible');
    } else {
      toggleBodyClass(false, 'footerVisible');
    }
  };
  useOnScroll$1({
    handler: debounce(handleWindowScroll, 10)
  });
  var securityIcon = function (_footer$key) {
    var key = '';
    if (isRebrandingEnabled) {
      key = deviceType === deviceTypes.MOBILE || deviceType === deviceTypes.TABLET ? 'security.iconMobileRebrandingOn' : 'security.iconDesktopRebrandingOn';
    } else {
      key = 'security.iconRebrandingOff';
    }
    return (_footer$key = footer === null || footer === void 0 ? void 0 : footer[key]) !== null && _footer$key !== void 0 ? _footer$key : {};
  }();
  var closeLegalBanner = function closeLegalBanner() {
    setLegalBannerVisiblility(false);
    CookieStorage$1.setCookie({
      name: constants.isCookieLegalBannerSelected,
      value: 'true',
      expiryDays: 30,
      regionCode: tenant
    });
  };
  var exitLegalBanner = function exitLegalBanner() {
    setLegalBannerVisiblility(false);
  };
  var primaryFooterStyles = isWhitelabel(store) ? {
    background: footer.primaryBackgroundColor
  } : undefined;
  var secondaryFooterStyles = isWhitelabel(store) ? {
    background: footer.secondaryBackgroundColor || footer.primaryBackgroundColor,
    borderBottom: '0px'
  } : undefined;
  var tertiaryFooterStyles = isWhitelabel(store) ? {
    background: footer.tertiaryBackgroundColor || footer.primaryBackgroundColor
  } : undefined;
  return jsx(Fragment$1, {
    children: jsxs("footer", {
      className: "".concat(MobileAppWebView ? styles$H['hide-footer'] : '', " ").concat(isRebrandingEnabled ? "".concat(styles$H.footerContainer, " ").concat(styles$H.rebranding) : styles$H.footerContainer, " ").concat(legalBannerVisiblility && !legalBannerCookie && footer !== null && footer !== void 0 && (_footer$bottom_banner = footer.bottom_banner) !== null && _footer$bottom_banner !== void 0 && _footer$bottom_banner.enabled ? styles$H['has-legal-banner'] : '', "\n          "),
      style: primaryFooterStyles,
      children: [jsxs("section", {
        className: styles$H['footer-primary'],
        ref: function ref(r) {
          footerRef.current = r;
        },
        children: [(footer === null || footer === void 0 ? void 0 : footer.logo) && deviceType === 'desktop' && jsx("div", {
          className: styles$H['footer-logo'],
          children: jsx("a", {
            href: "/",
            children: jsx("img", {
              src: footer === null || footer === void 0 ? void 0 : footer.logo,
              alt: "footer-logo"
            })
          })
        }), jsx("div", {
          className: styles$H['footer-primary-container'],
          children: (footer === null || footer === void 0 || (_footer$footerColumns = footer.footerColumns) === null || _footer$footerColumns === void 0 ? void 0 : _footer$footerColumns.length) > 0 && footer.footerColumns.map(function (fc, i) {
            return jsx("div", {
              className: styles$H['footer-links-column-container'],
              children: jsx(FooterList$1, {
                listTitle: fc.title,
                items: fc.items,
                textColor: isWhitelabel(store) ? fc.text_color : '',
                index: i,
                deviceType: deviceType,
                platform: platform,
                isRebrandingEnabled: isRebrandingEnabled
              })
            }, "".concat(fc.title, "_footer_column"));
          })
        })]
      }), jsx("section", {
        className: styles$H['footer-secondary'],
        style: secondaryFooterStyles,
        children: jsxs("div", {
          className: styles$H['footer-secondary-container'],
          children: [jsx("div", {
            className: styles$H['social-media-container'],
            children: (footer === null || footer === void 0 || (_footer$socialIcons = footer.socialIcons) === null || _footer$socialIcons === void 0 ? void 0 : _footer$socialIcons.length) > 0 && jsx(SocialIcons$1, {
              icons: footer === null || footer === void 0 ? void 0 : footer.socialIcons,
              isRebrandingEnabled: isRebrandingEnabled
            })
          }), jsx("div", {
            className: styles$H['horizontal-links-container'],
            children: (footer === null || footer === void 0 || (_footer$horizontalLin = footer.horizontalLinks) === null || _footer$horizontalLin === void 0 ? void 0 : _footer$horizontalLin.length) > 0 && (footer === null || footer === void 0 ? void 0 : footer.horizontalLinks.map(function (hz, index) {
              return jsx("a", {
                href: hz.url,
                className: styles$H['horizontal-link'],
                target: hz.is_new_tab ? '_blank' : '_self',
                rel: "noopener noreferrer",
                onClick: function onClick() {
                  var _footer$socialIcons2;
                  updateDigitalDataCookies({
                    firstLevelItem: 'N2',
                    secondLevelItem: "".concat((footer === null || footer === void 0 || (_footer$socialIcons2 = footer.socialIcons) === null || _footer$socialIcons2 === void 0 ? void 0 : _footer$socialIcons2.length) + index + 1),
                    thirdLevelItem: 'X',
                    positionOne: "HL_".concat(capitalizeWord(hz.title)),
                    positionTwo: 'X',
                    positionThree: getPageName(),
                    tag: FOOTER
                  });
                },
                style: isWhitelabel(store) ? {
                  color: hz.text_color
                } : {},
                children: hz.title
              }, "".concat(hz.title, "_").concat(hz.url));
            }))
          }), jsx("div", {
            className: styles$H['filler-container']
          })]
        })
      }), jsx("section", {
        className: styles$H['footer-tertiary'],
        style: tertiaryFooterStyles,
        children: jsxs("div", {
          className: styles$H['footer-tertiary-container'],
          style: isWhitelabel(store) ? {
            color: footer === null || footer === void 0 || (_footer$copyright = footer.copyright) === null || _footer$copyright === void 0 ? void 0 : _footer$copyright.textColor
          } : {},
          children: [jsxs("div", {
            className: styles$H['copyright-container'],
            children: [jsx("span", {
              className: styles$H['copyright-title'],
              children: footer === null || footer === void 0 || (_footer$copyright2 = footer.copyright) === null || _footer$copyright2 === void 0 ? void 0 : _footer$copyright2.title
            }), jsx("span", {
              className: styles$H['copyright-description'],
              children: deviceType === 'mobile' ? jsxs(Fragment$1, {
                children: [jsx("span", {
                  children: footer === null || footer === void 0 || (_footer$copyright3 = footer.copyright) === null || _footer$copyright3 === void 0 || (_footer$copyright3 = _footer$copyright3.description) === null || _footer$copyright3 === void 0 ? void 0 : _footer$copyright3.substring(0, 22)
                }), jsx("span", {
                  children: footer === null || footer === void 0 || (_footer$copyright4 = footer.copyright) === null || _footer$copyright4 === void 0 || (_footer$copyright4 = _footer$copyright4.description) === null || _footer$copyright4 === void 0 ? void 0 : _footer$copyright4.substring(23)
                })]
              }) : jsx("span", {
                children: footer === null || footer === void 0 || (_footer$copyright5 = footer.copyright) === null || _footer$copyright5 === void 0 ? void 0 : _footer$copyright5.description
              })
            })]
          }), jsxs("div", {
            children: [(footer === null || footer === void 0 || (_footer$poweredBy = footer.poweredBy) === null || _footer$poweredBy === void 0 || (_footer$poweredBy = _footer$poweredBy.icon) === null || _footer$poweredBy === void 0 ? void 0 : _footer$poweredBy.url) && jsxs("span", {
              className: styles$H['powered-by-container'],
              children: [jsx("p", {
                style: {
                  margin: '0'
                },
                children: footer === null || footer === void 0 || (_footer$poweredBy2 = footer.poweredBy) === null || _footer$poweredBy2 === void 0 ? void 0 : _footer$poweredBy2.label
              }), jsx("i", {
                className: styles$H['powered-by-icon'],
                style: {
                  backgroundImage: "url(".concat(footer === null || footer === void 0 || (_footer$poweredBy3 = footer.poweredBy) === null || _footer$poweredBy3 === void 0 || (_footer$poweredBy3 = _footer$poweredBy3.icon) === null || _footer$poweredBy3 === void 0 ? void 0 : _footer$poweredBy3.url, ")")
                }
              })]
            }), jsxs("a", {
              className: styles$H['security-container'],
              href: footer === null || footer === void 0 || (_footer$security = footer.security) === null || _footer$security === void 0 ? void 0 : _footer$security.url,
              rel: "noopener noreferrer",
              children: [jsx("img", {
                src: securityIcon.url,
                className: styles$H['security-icon'],
                alt: securityIcon.title
              }), jsx("span", {
                className: styles$H['security-text'],
                children: footer === null || footer === void 0 || (_footer$security2 = footer.security) === null || _footer$security2 === void 0 ? void 0 : _footer$security2.text
              })]
            })]
          })]
        })
      }), legalBannerVisiblility && !legalBannerCookie && footer !== null && footer !== void 0 && (_footer$bottom_banner2 = footer.bottom_banner) !== null && _footer$bottom_banner2 !== void 0 && _footer$bottom_banner2.enabled ? jsxs("section", {
        className: styles$H['footer-bottom'],
        style: {
          backgroundColor: "".concat(footer === null || footer === void 0 || (_footer$bottom_banner3 = footer.bottom_banner) === null || _footer$bottom_banner3 === void 0 || (_footer$bottom_banner3 = _footer$bottom_banner3.banner) === null || _footer$bottom_banner3 === void 0 ? void 0 : _footer$bottom_banner3.bgColor),
          color: "".concat(footer === null || footer === void 0 || (_footer$bottom_banner4 = footer.bottom_banner) === null || _footer$bottom_banner4 === void 0 || (_footer$bottom_banner4 = _footer$bottom_banner4.banner) === null || _footer$bottom_banner4 === void 0 ? void 0 : _footer$bottom_banner4.txtColor)
        },
        children: [jsx("span", {
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(footer === null || footer === void 0 || (_footer$bottom_banner5 = footer.bottom_banner) === null || _footer$bottom_banner5 === void 0 || (_footer$bottom_banner5 = _footer$bottom_banner5.banner) === null || _footer$bottom_banner5 === void 0 ? void 0 : _footer$bottom_banner5.content)
          }
        }), jsx("button", {
          id: "testId-accept-cookies-btn",
          style: {
            backgroundColor: "".concat(footer === null || footer === void 0 || (_footer$bottom_banner6 = footer.bottom_banner) === null || _footer$bottom_banner6 === void 0 || (_footer$bottom_banner6 = _footer$bottom_banner6.button) === null || _footer$bottom_banner6 === void 0 ? void 0 : _footer$bottom_banner6.bgColor),
            color: "".concat(footer === null || footer === void 0 || (_footer$bottom_banner7 = footer.bottom_banner) === null || _footer$bottom_banner7 === void 0 || (_footer$bottom_banner7 = _footer$bottom_banner7.button) === null || _footer$bottom_banner7 === void 0 ? void 0 : _footer$bottom_banner7.txtColor)
          },
          type: "button",
          onClick: closeLegalBanner,
          children: footer === null || footer === void 0 || (_footer$bottom_banner8 = footer.bottom_banner) === null || _footer$bottom_banner8 === void 0 ? void 0 : _footer$bottom_banner8.button.title
        }), jsx("div", {
          id: "testId-close-cookies-btn",
          className: styles$H['close-legal-banner'],
          onClick: exitLegalBanner
        })]
      }) : jsx(React.Fragment, {})]
    })
  });
};
Footer.defaultProps = {
  deviceType: 'desktop',
  MobileAppWebView: false
};
Footer.propTypes = {
  data: PropTypes.any,
  deviceType: PropTypes.string,
  attachResizeListener: PropTypes.func.isRequired,
  store: PropTypes.string,
  MobileAppWebView: PropTypes.bool
};
var Footer$1 = withDevice(Footer);

var styles$G = {"agentHeader":"AgentHeader-module_agentHeader__y-oVL","strong":"AgentHeader-module_strong__zP35f","labelsContainer":"AgentHeader-module_labelsContainer__surAR","vendorLogin":"AgentHeader-module_vendorLogin__LyU3z","vendorText":"AgentHeader-module_vendorText__LbPK0","vendorHomeContainer":"AgentHeader-module_vendorHomeContainer__t5DmZ","store":"AgentHeader-module_store__MoTjj","newCustomer":"AgentHeader-module_newCustomer__hTKM-","icon":"AgentHeader-module_icon__xXtXb","vendorHome":"AgentHeader-module_vendorHome__Ws7Ts","csicon-ham":"AgentHeader-module_csicon-ham__cJe41","csicon-icon-scan":"AgentHeader-module_csicon-icon-scan__5t5-m","agent-button-link":"AgentHeader-module_agent-button-link__JCZfB","agent-button-container":"AgentHeader-module_agent-button-container__qIiiT","agent-button":"AgentHeader-module_agent-button__jgDgL","agent-logout1":"AgentHeader-module_agent-logout1__1-xpD","clientName":"AgentHeader-module_clientName__-vnHg","agent-link":"AgentHeader-module_agent-link__3enMC"};

var agentLinks = function agentLinks(tenant) {
  var region = tenant === 'cl' ? '' : ".".concat(tenant);
  return [{
    text: 'Cambios y devoluciones',
    link: "https://www.falabella.com".concat(region, "/falabella-").concat(tenant, "/mi-cuenta/ordenes/solicitud-de-cambio/1")
  }, {
    text: 'Recepción de productos',
    link: "https://www.falabella.com".concat(region, "/falabella-").concat(tenant, "/CroConfirmation")
  }];
};
var endPoints$1 = function endPoints(tenantId) {
  return {
    AGENT_LOGOUT_URL: "/".concat(tenantId, "/includes/agentLogout.jsp"),
    NEW_AGENT_URL: "/".concat(tenantId, "/includes/agentCustomerLogout.jsp"),
    USER_LOGOUT_URL: '/includes/agentCustomerLogout.jsp'
  };
};
var catalystEndpoints$1 = function catalystEndpoints(tenantId) {
  return {
    NEW_AGENT_URL: "/".concat(tenantId, "/agent/search"),
    POST_LOGOUT_REDIRECTION: "/".concat(tenantId, "/agent/login?isLogout=true ")
  };
};
var labels$3 = {
  NEW_CUSTOMER_TEXT: 'Buscar nuevo cliente',
  CLOSE_SESSION: 'Cerrar Sesión',
  VENDOR_LABEL: 'Vendedor',
  CLIENT_LABEL: 'Cliente'
};
var AgentHeaderConfig = {
  agentLinks: agentLinks,
  labels: labels$3,
  endPoints: endPoints$1,
  catalystEndpoints: catalystEndpoints$1
};
var AgentHeaderConfig$1 = AgentHeaderConfig;

function ownKeys$h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$h(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AgentLinkButton = function AgentLinkButton(_ref) {
  var text = _ref.text,
    link = _ref.link;
  return jsx("a", {
    "data-cta": "true",
    rel: "noreferrer",
    target: "_blank",
    className: styles$G['agent-link'],
    href: link,
    children: jsx("button", {
      type: "button",
      className: styles$G['agent-button'],
      children: text.toUpperCase()
    })
  });
};
var renderAgentButtons = function renderAgentButtons(agentLinks) {
  return jsx("div", {
    className: styles$G['agent-button-container'],
    children: agentLinks.map(function (agentLink, i) {
      return createElement(AgentLinkButton, _objectSpread$h(_objectSpread$h({}, agentLink), {}, {
        key: "agentLink_".concat(i)
      }));
    })
  });
};
var AgentHeader = function AgentHeader(_ref2) {
  var agentCookie = _ref2.agentCookie,
    userName = _ref2.userName,
    onUserLogout = _ref2.onUserLogout,
    isCatalyst = _ref2.isCatalyst,
    tenant = _ref2.tenant,
    setIsAgentLoggedIn = _ref2.setIsAgentLoggedIn,
    agentBaseUrl = _ref2.agentBaseUrl,
    atgBaseUrl = _ref2.atgBaseUrl,
    catalystBaseUrl = _ref2.catalystBaseUrl,
    forceATG = _ref2.forceATG,
    store = _ref2.store;
  var labels = AgentHeaderConfig$1.labels,
    agentLinks = AgentHeaderConfig$1.agentLinks,
    endPoints = AgentHeaderConfig$1.endPoints,
    catalystEndpoints = AgentHeaderConfig$1.catalystEndpoints;
  var agentCookieParts = agentCookie.split('*');
  var agentId = agentCookieParts[0];
  var tenantId = store !== 'so_com' ? "falabella-".concat(tenant) : "sodimac-".concat(tenant);
  var catalystEndpointsObj = catalystEndpoints(tenantId);
  var endPointsObj = endPoints(tenantId);
  var agentLinksObj = agentLinks(tenant);
  var onAgentLogout = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(e) {
      var _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isCatalyst) {
              _context.next = 5;
              break;
            }
            _context.prev = 1;
            e.preventDefault();
            _context.next = 2;
            return agentLogout({
              tenantId: tenantId,
              agentBaseUrl: agentBaseUrl
            });
          case 2:
            setIsAgentLoggedIn(false);
            CookieStorage$1.removeCookie({
              name: CookieStorage$1.getAgentDataCookie()
            });
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            console.log('AGENT_LOGOUT_ERROR', _t);
          case 4:
            window.location.href = catalystEndpointsObj.POST_LOGOUT_REDIRECTION;
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function onAgentLogout(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var userLogout = function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(e) {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            _context2.next = 1;
            return logout({
              tenantId: "falabella-".concat(tenant),
              atgBaseUrl: atgBaseUrl,
              catalystBaseUrl: catalystBaseUrl,
              forceATG: forceATG
            });
          case 1:
            _context2.next = 2;
            return onUserLogout();
          case 2:
            window.location.href = catalystEndpointsObj.NEW_AGENT_URL;
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function userLogout(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var goToNewUrl = function () {
    var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(e) {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!userName) {
              _context3.next = 1;
              break;
            }
            _context3.next = 1;
            return userLogout(e);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function goToNewUrl(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
  return jsxs("div", {
    className: styles$G.agentHeader,
    id: "guided-selling-header-agent",
    "data-testid": "guided-selling-header",
    children: [jsxs("div", {
      className: styles$G.labelsContainer,
      children: [jsxs("div", {
        className: styles$G.vendorLogin,
        children: [jsxs("div", {
          className: styles$G.vendorText,
          children: [jsxs("span", {
            children: [jsx("strong", {
              className: styles$G.strong,
              children: labels.VENDOR_LABEL
            }), "\xA0", agentId, ":\xA0"]
          }), jsx("a", {
            onClick: onAgentLogout,
            href: endPointsObj.AGENT_LOGOUT_URL,
            children: labels.CLOSE_SESSION
          })]
        }), jsx("div", {
          className: styles$G.newCustomer,
          children: jsx("a", {
            onClick: goToNewUrl,
            className: styles$G['agent-logout1'],
            href: isCatalyst ? catalystEndpointsObj.NEW_AGENT_URL : endPointsObj.NEW_AGENT_URL,
            rel: "noreferrer noopener",
            children: labels.NEW_CUSTOMER_TEXT
          })
        })]
      }), userName && jsxs("div", {
        className: styles$G.clientName,
        children: [jsxs("div", {
          className: styles$G.clientText,
          children: [jsxs("span", {
            className: styles$G.strong,
            children: [labels.CLIENT_LABEL, "\xA0"]
          }), jsxs("span", {
            children: [userName, ":"]
          })]
        }), jsx("a", {
          className: styles$G['agent-logout2'],
          onClick: userLogout,
          href: endPointsObj.USER_LOGOUT_URL,
          children: labels.CLOSE_SESSION
        })]
      })]
    }), renderAgentButtons(agentLinksObj)]
  });
};
AgentHeader.defaultProps = {
  tenant: 'cl',
  isCatalyst: false
};
AgentHeader.propTypes = {
  agentCookie: PropTypes.string.isRequired,
  userName: PropTypes.string,
  onUserLogout: PropTypes.func,
  isCatalyst: PropTypes.bool,
  tenant: PropTypes.string,
  setIsAgentLoggedIn: PropTypes.func,
  agentBaseUrl: PropTypes.string,
  atgBaseUrl: PropTypes.string,
  catalystBaseUrl: PropTypes.string,
  forceATG: PropTypes.bool.isRequired
};
var AgentHeader$1 = AgentHeader;

var styles$F = {"errorDialog-container":"ErrorDialog-module_errorDialog-container__Ad8i3","header":"ErrorDialog-module_header__5LPOP","close":"ErrorDialog-module_close__6XKmk","title":"ErrorDialog-module_title__3idOl","content":"ErrorDialog-module_content__-LTuc"};

var noop = function noop() {};
var noop$1 = noop;

var ErrorDialog = function ErrorDialog(_ref) {
  var title = _ref.title,
    message = _ref.message,
    onClose = _ref.onClose;
  useEffect(function () {
    toggleBodyClass(true, 'FacetMobilePanel--open');
    return function () {
      toggleBodyClass(false, 'FacetMobilePanel--open');
    };
  }, []);
  return jsx("div", {
    className: styles$F['errorDialog-container'],
    children: jsxs(WithOutsideClick$1, {
      className: styles$F.errorDialog,
      onOutsideClick: function onOutsideClick() {
        onClose();
      },
      styles: {},
      children: [jsxs("div", {
        className: styles$F.header,
        children: [jsx("h2", {
          className: styles$F.title,
          children: title
        }), jsx("button", {
          type: "button",
          onClick: onClose,
          className: styles$F.close,
          children: ' '
        })]
      }), jsx("p", {
        className: styles$F.content,
        children: message
      })]
    })
  });
};
ErrorDialog.defaultProps = {
  title: '',
  message: '',
  onClose: noop$1
};
ErrorDialog.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func
};
var ErrorDialog$1 = ErrorDialog;

var styles$E = {"logo-main-wrapper":"Logo-module_logo-main-wrapper__8w8pq","logo-wrapper":"Logo-module_logo-wrapper__LoZiA","logo":"Logo-module_logo__5uE1G","mobile-logo":"Logo-module_mobile-logo__VKJdk","sis-logo-wrapper":"Logo-module_sis-logo-wrapper__yhDWJ","sis-logo-wrapper--so_com":"Logo-module_sis-logo-wrapper--so_com__BTDBt","sis-logo-wrapper--so_retail":"Logo-module_sis-logo-wrapper--so_retail__7p3AH","sis-logo-wrapper--to_com":"Logo-module_sis-logo-wrapper--to_com__EItuO","sodimac":"Logo-module_sodimac__Tzz-J","linio":"Logo-module_linio__BOsU5","tottus":"Logo-module_tottus__oX7j4","homecenter":"Logo-module_homecenter__o5-jk","so_com":"Logo-module_so_com__rwlgK","so_retail":"Logo-module_so_retail__tZEtE","to_com":"Logo-module_to_com__o9ndq","whitelabel":"Logo-module_whitelabel__3t9nU","horizontal_menu":"Logo-module_horizontal_menu__DTAmN"};

var Logo = function Logo(_ref) {
  var path = _ref.path,
    logoIcon = _ref.logoIcon,
    isMobile = _ref.isMobile,
    store = _ref.store,
    isHorizontalMenu = _ref.isHorizontalMenu;
  var _getStandaloneSite = getStandaloneSite(store),
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  return jsx("div", {
    className: classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$E['logo-main-wrapper'], !store), styles$E['mobile-logo'], !store && isMobile), styles$E['sis-logo-wrapper'], Boolean(store)), styles$E['sis-logo-wrapper--so_com'], isSodimacStandalone), styles$E['sis-logo-wrapper--to_com'], isTottusStandalone)),
    children: jsx("a", {
      id: "testId-logo-btn",
      href: path,
      name: "falabella-logo",
      className: classNames([styles$E['logo-wrapper']], styles$E[store], _defineProperty(_defineProperty({}, styles$E.whitelabel, isWhitelabelSite), styles$E.horizontal_menu, isHorizontalMenu)),
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: 'N1 - Home',
          tag: HEADER
        });
      },
      children: jsx("div", {
        style: {
          backgroundImage: "url(".concat(logoIcon, ")")
        },
        className: classNames(styles$E.logo)
      })
    })
  });
};
Logo.propTypes = {
  path: PropTypes.string.isRequired,
  logoIcon: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  store: PropTypes.string,
  isHorizontalMenu: PropTypes.bool
};
Logo.defaultProps = {
  isMobile: false,
  isHorizontalMenu: false
};
var Logo$1 = Logo;

var styles$D = {"mobileBar":"MobileBar-module_mobileBar__dlyoT","brand_logo":"MobileBar-module_brand_logo__zQNoB"};

var MobileBar = function MobileBar(_ref) {
  var url = _ref.url;
  return jsxs("a", {
    href: url,
    className: classNames(styles$D.mobileBar),
    children: ["Ir a", jsx("div", {
      className: classNames(styles$D.brand_logo)
    })]
  });
};
MobileBar.propTypes = {
  url: PropTypes.string.isRequired
};
MobileBar.defaultProps = {
  url: '#'
};
var MobileBar$1 = MobileBar;

var MatchMedia = function MatchMedia(_ref) {
  var content = _ref.content,
    deviceType = _ref.deviceType;
  return jsx(Fragment, {
    children: content[deviceType] && content[deviceType]()
  });
};
MatchMedia.defaultProps = {
  content: noop$2
};
MatchMedia.propTypes = {
  deviceType: PropTypes.string.isRequired,
  content: PropTypes.object
};
var MatchMedia$1 = withDevice(MatchMedia);

var styles$C = {"onboarding-modal-wrapper":"onboarding-module_onboarding-modal-wrapper__Ue-vM","modal-animation":"onboarding-module_modal-animation__O9lkw","onboarding-desktop-container":"onboarding-module_onboarding-desktop-container__V3HI-","onboarding-title":"onboarding-module_onboarding-title__1DrQR","pe":"onboarding-module_pe__aNNhn","description-container":"onboarding-module_description-container__MMntf","button-next":"onboarding-module_button-next__KGVzw","actions-container":"onboarding-module_actions-container__YWovN","action-step-1":"onboarding-module_action-step-1__UQYZr","pagination":"onboarding-module_pagination__W6eWF","current":"onboarding-module_current__Xwe2e"};

var OnboardingDesktop = function OnboardingDesktop(_ref) {
  var data = _ref.data,
    currentStep = _ref.currentStep,
    nextStep = _ref.nextStep,
    skip = _ref.skip;
    _ref.hasNextStep;
    var tenant = _ref.tenant;
  var onNext = function onNext() {
    nextStep();
  };
  var calculateTranslateProp = function calculateTranslateProp() {
    if (isWindow$1()) {
      var width = window.innerWidth / 2 - 289;
      var height = -window.innerHeight / 2 + 212;
      return {
        transform: "translate(".concat(width, "px, ").concat(height, "px)")
      };
    }
    return undefined;
  };
  return jsx("div", {
    className: styles$C['onboarding-modal-wrapper'],
    id: "onboarding-desktop-modal-wrapper",
    children: jsx(Modal, {
      toggleState: {
        visible: true,
        setVisible: function setVisible() {}
      },
      content: function content() {
        return jsxs("div", {
          className: styles$C['onboarding-desktop-container'],
          children: [currentStep === 0 && jsx("div", {
            className: "".concat(styles$C['onboarding-title'], " ").concat(styles$C[tenant]),
            dangerouslySetInnerHTML: {
              __html: DOMPurify.sanitize(data[currentStep].title)
            }
          }), jsx("div", {
            className: styles$C['description-container'],
            dangerouslySetInnerHTML: {
              __html: DOMPurify.sanitize(data[currentStep].description)
            }
          }), jsx("button", {
            id: "testId-onboarding-desktop-step-".concat(currentStep),
            className: styles$C['button-next'],
            onClick: onNext,
            children: data[currentStep].buttonText
          }), data.length > 1 && jsxs("div", {
            className: "".concat(styles$C['actions-container'], " ").concat(currentStep === 1 ? styles$C['action-step-1'] : ''),
            children: [jsx("button", {
              id: "testId-onboarding-desktop-skip",
              onClick: skip,
              children: data[currentStep].jumpButtonText
            }), jsxs("div", {
              className: styles$C['pagination'],
              children: [jsx("div", {
                className: currentStep === 0 && styles$C['current']
              }), jsx("div", {
                className: currentStep === 1 && styles$C['current']
              })]
            })]
          })]
        });
      },
      options: {
        width: 500,
        disableOutsideClick: false,
        overflow: 'visible',
        borderRadius: '12px',
        padding: '32px 24px 36px 24px',
        minWidth: 'auto',
        minHeight: 'auto'
      },
      customBodyClass: "onboarding-desktop-modal-body",
      deviceType: "desktop",
      resetHandler: function resetHandler() {},
      closeOtherModals: function closeOtherModals() {},
      customClass: 'floatBottomTransition',
      showCloseButton: false,
      modalAnimationClass: currentStep === 1 && styles$C['modal-animation'],
      modalTranslateStyle: currentStep === 1 && calculateTranslateProp(),
      withPadding: false,
      modalContainerZIndex: 9001
    })
  });
};
OnboardingDesktop.propTypes = {
  data: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
  nextStep: PropTypes.func.isRequired,
  skip: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired
};
var OnboardingDesktop$1 = OnboardingDesktop;

var styles$B = {"onboarding-modal-wrapper":"onboarding-module_onboarding-modal-wrapper__U5HD7","onboarding-mobile-container":"onboarding-module_onboarding-mobile-container__zT7kF","onboarding-animation-in":"onboarding-module_onboarding-animation-in__ltb9K","fadeIn":"onboarding-module_fadeIn__4w2Ec","onboarding-animation-out":"onboarding-module_onboarding-animation-out__iRQam","fadeOut":"onboarding-module_fadeOut__G7XRu","hide":"onboarding-module_hide__mGhPV","opacity-1":"onboarding-module_opacity-1__VbRAf","opacity-0":"onboarding-module_opacity-0__Vl4m6","title":"onboarding-module_title__66sHK","cl":"onboarding-module_cl__en5ED","step-0":"onboarding-module_step-0__zRbMD","step-1":"onboarding-module_step-1__j9lfK","pe":"onboarding-module_pe__QDfTG","description-container":"onboarding-module_description-container__9PHiK","button-next":"onboarding-module_button-next__RzmUa","actions-container":"onboarding-module_actions-container__wg-ZM","pagination":"onboarding-module_pagination__jJsk8","current":"onboarding-module_current__cNM-A"};

var OnboardingMobile = function OnboardingMobile(_ref) {
  var data = _ref.data,
    currentStep = _ref.currentStep,
    nextStep = _ref.nextStep,
    skip = _ref.skip,
    deviceType = _ref.deviceType,
    hasNextStep = _ref.hasNextStep,
    tenant = _ref.tenant;
  var _useState = useState('floatBottomTransition'),
    _useState2 = _slicedToArray(_useState, 2),
    animationClass = _useState2[0],
    setAnimationClass = _useState2[1];
  var hideModal = function hideModal(callback) {
    setAnimationClass('floatBottomEndTransitionOnboarding');
    var animationTimer = setTimeout(function () {
      callback();
      clearTimeout(animationTimer);
    }, 350);
  };
  var onSkip = function onSkip() {
    hideModal(skip);
  };
  var onNext = function onNext() {
    if (!hasNextStep) {
      hideModal(nextStep);
    } else {
      document.getElementsByClassName(styles$B['onboarding-mobile-container'])[0].classList.add(styles$B['onboarding-animation-out']);
      var animationTimer = setTimeout(function () {
        nextStep();
        document.getElementsByClassName(styles$B['onboarding-mobile-container'])[0].classList.add(styles$B['onboarding-animation-in']);
        clearTimeout(animationTimer);
      }, 10);
    }
  };
  var heightMap = {
    cl: window.innerWidth > 367 ? 389 : 412,
    pe: ''
  };
  return jsx("div", {
    className: styles$B['onboarding-modal-wrapper'],
    id: "onboarding-mobile-modal-wrapper",
    children: jsx(Modal, {
      toggleState: {
        visible: true,
        setVisible: function setVisible() {}
      },
      content: function content() {
        return jsxs("div", {
          className: "".concat(styles$B['onboarding-mobile-container'], " ").concat(currentStep === 1 ? styles$B['onboarding-animation'] : ''),
          children: [jsx("div", {
            className: "".concat(styles$B['title'], " ").concat(styles$B["".concat(tenant)], " ").concat(currentStep === 1 && styles$B['hide']),
            dangerouslySetInnerHTML: {
              __html: DOMPurify.sanitize(data[currentStep].title)
            }
          }), jsx("img", {
            src: data[0].image.url,
            alt: data[0].image.title,
            className: "\n                  ".concat(tenant, "\n                  ").concat(styles$B['step-0'], "\n                  ").concat(currentStep === 0 && styles$B['opacity-1'], "\n                "),
            style: {
              position: currentStep === 0 && 'relative'
            }
          }), data.length === 2 && jsx("img", {
            src: data[1].image.url,
            alt: data[1].image.title,
            className: "\n                              ".concat(styles$B['step-1'], "\n                              ").concat(currentStep === 1 && styles$B['opacity-1'], "\n                            "),
            style: {
              position: currentStep === 1 && 'relative'
            }
          }), jsx("div", {
            className: styles$B['description-container'],
            "data-step": currentStep,
            dangerouslySetInnerHTML: {
              __html: DOMPurify.sanitize(data[currentStep].description)
            }
          }), jsx("button", {
            id: "testId-onboarding-mobile-step-".concat(currentStep),
            className: styles$B['button-next'],
            onClick: onNext,
            children: jsx("span", {
              children: data[currentStep].buttonText
            })
          }), data.length > 1 && jsxs("div", {
            className: styles$B['actions-container'],
            children: [jsx("button", {
              id: "testId-onboarding-mobile-skip",
              onClick: onSkip,
              children: data[currentStep].jumpButtonText
            }), jsxs("div", {
              className: styles$B['pagination'],
              children: [jsx("div", {
                className: currentStep === 0 && styles$B['current']
              }), jsx("div", {
                className: currentStep === 1 && styles$B['current']
              })]
            })]
          })]
        });
      },
      options: {
        height: heightMap[tenant],
        disableOutsideClick: false,
        overflow: 'visible',
        borderRadius: '12px 12px 0px 0px',
        padding: '32px 16px 0',
        marginTop: deviceType === 'tablet' ? 'auto' : '0px',
        minWidth: 'auto'
      },
      deviceType: deviceType,
      resetHandler: function resetHandler() {},
      closeOtherModals: function closeOtherModals() {},
      customClass: animationClass,
      showCloseButton: false,
      customBodyClass: 'onboarding-mobile-modal-body',
      withPadding: false,
      zoneModalWrapStyles: {
        marginTop: 'auto'
      },
      modalContainerZIndex: 9001
    })
  });
};
OnboardingMobile.propTypes = {
  data: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
  nextStep: PropTypes.func.isRequired,
  skip: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired,
  hasNextStep: PropTypes.bool.isRequired,
  tenant: PropTypes.string.isRequired
};
var OnboardingMobile$1 = OnboardingMobile;

var buildOnboardingData = function buildOnboardingData(data) {
  var _data$mobile, _data$desktop;
  var mobile = ((_data$mobile = data === null || data === void 0 ? void 0 : data.mobile) !== null && _data$mobile !== void 0 ? _data$mobile : []).map(function (d) {
    var _d$title, _d$enabled, _d$description, _d$image$filename, _d$image, _d$image$title, _d$image2, _d$image$tags, _d$image3, _d$image$url, _d$image4, _d$button_text, _d$jump_button_text;
    return {
      title: (_d$title = d === null || d === void 0 ? void 0 : d.title) !== null && _d$title !== void 0 ? _d$title : '',
      enabled: (_d$enabled = d === null || d === void 0 ? void 0 : d.enabled) !== null && _d$enabled !== void 0 ? _d$enabled : false,
      description: (_d$description = d === null || d === void 0 ? void 0 : d.description) !== null && _d$description !== void 0 ? _d$description : '',
      image: {
        filename: (_d$image$filename = d === null || d === void 0 || (_d$image = d.image) === null || _d$image === void 0 ? void 0 : _d$image.filename) !== null && _d$image$filename !== void 0 ? _d$image$filename : '',
        title: (_d$image$title = d === null || d === void 0 || (_d$image2 = d.image) === null || _d$image2 === void 0 ? void 0 : _d$image2.title) !== null && _d$image$title !== void 0 ? _d$image$title : '',
        tags: (_d$image$tags = d === null || d === void 0 || (_d$image3 = d.image) === null || _d$image3 === void 0 ? void 0 : _d$image3.tags) !== null && _d$image$tags !== void 0 ? _d$image$tags : [],
        url: (_d$image$url = d === null || d === void 0 || (_d$image4 = d.image) === null || _d$image4 === void 0 ? void 0 : _d$image4.url) !== null && _d$image$url !== void 0 ? _d$image$url : ''
      },
      buttonText: (_d$button_text = d === null || d === void 0 ? void 0 : d.button_text) !== null && _d$button_text !== void 0 ? _d$button_text : '',
      jumpButtonText: (_d$jump_button_text = d === null || d === void 0 ? void 0 : d.jump_button_text) !== null && _d$jump_button_text !== void 0 ? _d$jump_button_text : ''
    };
  });
  var desktop = ((_data$desktop = data === null || data === void 0 ? void 0 : data.desktop) !== null && _data$desktop !== void 0 ? _data$desktop : []).map(function (d) {
    var _d$title2, _d$enabled2, _d$description2, _d$button_text2, _d$jump_button_text2;
    return {
      title: (_d$title2 = d === null || d === void 0 ? void 0 : d.title) !== null && _d$title2 !== void 0 ? _d$title2 : '',
      enabled: (_d$enabled2 = d === null || d === void 0 ? void 0 : d.enabled) !== null && _d$enabled2 !== void 0 ? _d$enabled2 : false,
      description: (_d$description2 = d === null || d === void 0 ? void 0 : d.description) !== null && _d$description2 !== void 0 ? _d$description2 : '',
      buttonText: (_d$button_text2 = d === null || d === void 0 ? void 0 : d.button_text) !== null && _d$button_text2 !== void 0 ? _d$button_text2 : '',
      jumpButtonText: (_d$jump_button_text2 = d === null || d === void 0 ? void 0 : d.jump_button_text) !== null && _d$jump_button_text2 !== void 0 ? _d$jump_button_text2 : ''
    };
  });
  return {
    desktop: desktop,
    mobile: mobile,
    tablet: mobile
  };
};
var onboardingCookieName = 'on_boarding';
var onboardingCookieValues = {
  SKIPPED: 'skipped',
  DONE: 'done'
};
var Onboarding = function Onboarding(_ref) {
  var _data$deviceType, _data$deviceType2;
  var deviceType = _ref.deviceType,
    onboardingData = _ref.onboardingData,
    currentStep = _ref.currentStep,
    setCurrentStep = _ref.setCurrentStep,
    tenant = _ref.tenant;
  if (!onboardingData || (deviceType === 'mobile' || deviceType === 'tablet') && isEmpty(onboardingData === null || onboardingData === void 0 ? void 0 : onboardingData.mobile) || deviceType === 'desktop' && isEmpty(onboardingData === null || onboardingData === void 0 ? void 0 : onboardingData.desktop) || isWindow$1() && CookieStorage$1.getCookie(onboardingCookieName) === onboardingCookieValues.DONE || currentStep > 1) {
    return null;
  }
  var data = buildOnboardingData(onboardingData);
  var isCurrentStepEnabled = data === null || data === void 0 || (_data$deviceType = data[deviceType]) === null || _data$deviceType === void 0 || (_data$deviceType = _data$deviceType[currentStep]) === null || _data$deviceType === void 0 ? void 0 : _data$deviceType.enabled;
  var hasNextStep = data === null || data === void 0 || (_data$deviceType2 = data[deviceType]) === null || _data$deviceType2 === void 0 || (_data$deviceType2 = _data$deviceType2[currentStep + 1]) === null || _data$deviceType2 === void 0 ? void 0 : _data$deviceType2.enabled;
  if (!isCurrentStepEnabled && currentStep === 0) {
    var _data$deviceType3;
    if (!(data !== null && data !== void 0 && (_data$deviceType3 = data[deviceType]) !== null && _data$deviceType3 !== void 0 && (_data$deviceType3 = _data$deviceType3[1]) !== null && _data$deviceType3 !== void 0 && _data$deviceType3.enabled)) {
      return null;
    }
    setCurrentStep(1);
  } else if (!isCurrentStepEnabled && currentStep === 1) {
    return null;
  }
  var disableOnboarding = function disableOnboarding() {
    var skipped = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var ended = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isWindow$1()) {
      var onboardingCookieValue = CookieStorage$1.getCookie(onboardingCookieName);
      if (onboardingCookieValue === onboardingCookieValues.SKIPPED || ended) {
        CookieStorage$1.setCookie({
          name: onboardingCookieName,
          value: onboardingCookieValues.DONE,
          regionCode: tenant
        });
      } else if (!onboardingCookieValue && skipped) {
        CookieStorage$1.setCookie({
          name: onboardingCookieName,
          value: onboardingCookieValues.SKIPPED,
          regionCode: tenant
        });
      }
    }
  };
  var nextStep = function nextStep() {
    if (currentStep === 0 && !hasNextStep || currentStep === 1) {
      disableOnboarding(false, true);
    }
    setCurrentStep(function (state) {
      return state + 1;
    });
  };
  var skip = function skip() {
    disableOnboarding(true, false);
    setCurrentStep(2);
  };
  return jsx(MatchMedia$1, {
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(OnboardingDesktop$1, {
          data: data.desktop,
          currentStep: currentStep,
          nextStep: nextStep,
          skip: skip,
          hasNextStep: hasNextStep,
          tenant: tenant
        });
      },
      tablet: function tablet() {
        return jsx(OnboardingMobile$1, {
          data: data.mobile,
          currentStep: currentStep,
          nextStep: nextStep,
          skip: skip,
          deviceType: "tablet",
          hasNextStep: hasNextStep,
          tenant: tenant
        });
      },
      mobile: function mobile() {
        return jsx(OnboardingMobile$1, {
          data: data.mobile,
          currentStep: currentStep,
          nextStep: nextStep,
          skip: skip,
          deviceType: "mobile",
          hasNextStep: hasNextStep,
          tenant: tenant
        });
      }
    }
  }, "onboarding-flow");
};
Onboarding.propTypes = {
  onboardingData: PropTypes.object.isRequired,
  deviceType: PropTypes.string.isRequired,
  tenant: PropTypes.string.isRequired,
  currentStep: PropTypes.number.isRequired,
  setCurrentStep: PropTypes.func.isRequired
};
var Onboarding$1 = Onboarding;

var CancelablePromise = function () {
  function CancelablePromise(promise) {
    _classCallCheck(this, CancelablePromise);
    this.promise = promise;
    this.isCanceled = false;
  }
  return _createClass(CancelablePromise, [{
    key: "cancel",
    value: function cancel() {
      this.isCanceled = true;
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return this.promise;
            case 1:
              result = _context.sent;
              if (!this.isCanceled) {
                _context.next = 2;
                break;
              }
              throw new Error('Promise is Cancelled');
            case 2:
              return _context.abrupt("return", result);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }]);
}();
var CancelablePromise$1 = CancelablePromise;

function ownKeys$g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$g(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var sortSuggestions = function sortSuggestions(suggestions) {
  return suggestions.sort(function (a, b) {
    return a.order > b.order ? 1 : -1;
  });
};
var handleSuggestionsCount = function handleSuggestionsCount(suggestions, count) {
  if (!count) return suggestions;
  return suggestions.slice(0, count || suggestions.length);
};
var SearchHelper = function SearchHelper(results, deviceType) {
  var _fileteredSuggestions, _fileteredSuggestions2;
  var suggestions = results.suggestions,
    _results$relatedBrand = results.relatedBrands,
    relatedBrands = _results$relatedBrand === void 0 ? [] : _results$relatedBrand,
    _results$relatedCateg = results.relatedCategories,
    relatedCategories = _results$relatedCateg === void 0 ? [] : _results$relatedCateg;
  var isMobile = deviceType === 'mobile';
  if (suggestions.length === 0) {
    return {};
  }
  var fileteredSuggestions = handleSuggestionsCount(suggestions, isMobile ? 5 : null);
  var filteredRelatedBrands = handleSuggestionsCount(relatedBrands, isMobile ? 4 : null);
  var filteredRelatedCategories = handleSuggestionsCount(relatedCategories, isMobile ? 4 : null);
  if (isMobile) {
    fileteredSuggestions[0].categoryScope = [];
  }
  var categoryScopeLength = (_fileteredSuggestions = fileteredSuggestions === null || fileteredSuggestions === void 0 || (_fileteredSuggestions2 = fileteredSuggestions[0]) === null || _fileteredSuggestions2 === void 0 || (_fileteredSuggestions2 = _fileteredSuggestions2.categoryScope) === null || _fileteredSuggestions2 === void 0 ? void 0 : _fileteredSuggestions2.length) !== null && _fileteredSuggestions !== void 0 ? _fileteredSuggestions : 0;
  var relatedBrandsIndex = fileteredSuggestions.length + categoryScopeLength;
  var relatedCategoriesIndex = fileteredSuggestions.length + categoryScopeLength + filteredRelatedBrands.length;
  var totalSuggestionsCount = fileteredSuggestions.length + categoryScopeLength + filteredRelatedBrands.length + filteredRelatedCategories.length;
  var categories = [{
    key: 'suggestions',
    listItems: fileteredSuggestions,
    listItemIndexStart: 0,
    order: 1
  }, {
    key: 'relatedBrands',
    listItems: filteredRelatedBrands,
    listItemIndexStart: relatedBrandsIndex,
    title: 'relatedBrands',
    order: isMobile ? 3 : 2
  }, {
    key: 'relatedCategories',
    listItems: filteredRelatedCategories,
    listItemIndexStart: relatedCategoriesIndex,
    title: 'relatedCategories',
    order: isMobile ? 2 : 3
  }];
  return {
    categories: sortSuggestions(categories),
    totalSuggestionsCount: totalSuggestionsCount + 1
  };
};
var getRecentSearchedStoredData = function getRecentSearchedStoredData(tenant) {
  return JSON.parse(WebStorage$1.getItem({
    name: "recent_searches_".concat(tenant),
    fromPersistence: true
  })) || {};
};
var setRecentSearchedValues = function setRecentSearchedValues(value, store, tenant) {
  var storedData = getRecentSearchedStoredData(tenant);
  var key = store || 'marketplace';
  var data = storedData[key] || [];
  if (data.find(function (val) {
    return value.url === val.url;
  })) {
    data = [value].concat(_toConsumableArray(data.filter(function (val) {
      return value.url !== val.url;
    })));
  } else {
    data = [value].concat(_toConsumableArray(data.slice(0, data.length - (data.length >= 15 ? 1 : 0))));
  }
  WebStorage$1.setItem({
    name: "recent_searches_".concat(tenant),
    value: JSON.stringify(_objectSpread$g(_objectSpread$g({}, storedData), {}, _defineProperty({}, key, data))),
    shouldPersist: true
  });
};
var getRecentSearchedValues = function getRecentSearchedValues(store, tenant, deviceType) {
  var _data;
  var storedData = getRecentSearchedStoredData(tenant);
  var key = store || 'marketplace';
  var data = (storedData[key] || []).slice(0, deviceType === 'mobile' ? 15 : 10);
  data = (_data = data) === null || _data === void 0 ? void 0 : _data.filter(function (val) {
    var _val$url;
    return !(val !== null && val !== void 0 && (_val$url = val.url) !== null && _val$url !== void 0 && _val$url.includes('}'));
  });
  return data;
};
var clearRecentSearchedValues = function clearRecentSearchedValues(store, tenant) {
  var storedData = getRecentSearchedStoredData(tenant);
  var key = store || 'marketplace';
  WebStorage$1.setItem({
    name: "recent_searches_".concat(tenant),
    value: JSON.stringify(_objectSpread$g(_objectSpread$g({}, storedData), {}, _defineProperty({}, key, []))),
    shouldPersist: true
  });
};
var destroyAllRecentSearchedValues = function destroyAllRecentSearchedValues(tenant) {
  WebStorage$1.removeItem({
    name: "recent_searches_".concat(tenant),
    fromPersistence: true
  });
};
var SearchHelper$1 = SearchHelper;

var styles$A = {"searchResults":"SearchList-module_searchResults__MeS7t","recentSearchResults":"SearchList-module_recentSearchResults__SFvqo","agent-loggedin":"SearchList-module_agent-loggedin__XyZco","vendor-loggedin":"SearchList-module_vendor-loggedin__UnuKN","searchResults__other_category":"SearchList-module_searchResults__other_category__5KNpF","searchResults__title":"SearchList-module_searchResults__title__8CS2B","storeTitle":"SearchList-module_storeTitle__2AZey","recentSearchResults__title__container":"SearchList-module_recentSearchResults__title__container__OK6mz","recentSearchResults__title":"SearchList-module_recentSearchResults__title__92LK8","recentSearchResults__clear":"SearchList-module_recentSearchResults__clear__Siksb","searchListItem":"SearchList-module_searchListItem__JYqjK","searchListItem__active":"SearchList-module_searchListItem__active__evqSW","storeAnchor":"SearchList-module_storeAnchor__CkEXB","recentSearchListItem":"SearchList-module_recentSearchListItem__o0eiH","recentSearchListItem__active":"SearchList-module_recentSearchListItem__active__klSRW"};

function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getURL$1 = function getURL(url, tenant, store) {
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  if (isWhitelabelSite) {
    return "".concat(getWhitelabelSiteBaseUrl(tenant, store)).concat(url);
  }
  if (isStandaloneSite) {
    return "".concat(getStandaloneSiteBaseUrl(tenant, store)).concat(url);
  }
  var baseUrl = getStoreBaseUrl(tenant, store);
  return "".concat(baseUrl).concat(url);
};
var SearchListItem = function SearchListItem(_ref) {
  var text = _ref.text,
    routingUrl = _ref.routingUrl,
    url = _ref.url,
    index = _ref.index,
    children = _ref.children,
    isActive = _ref.isActive,
    onMouseOver = _ref.onMouseOver,
    isCategoryItem = _ref.isCategoryItem,
    setActiveAnchorRef = _ref.setActiveAnchorRef,
    onSelect = _ref.onSelect,
    tenant = _ref.tenant,
    store = _ref.store,
    rawStore = _ref.rawStore,
    searchQuery = _ref.searchQuery,
    section = _ref.section,
    sectionSize = _ref.sectionSize,
    listItemIndexStart = _ref.listItemIndexStart,
    deviceType = _ref.deviceType,
    title = _ref.title,
    setSearchQuery = _ref.setSearchQuery,
    isStore = _ref.isStore,
    categoryItemSearchQuery = _ref.categoryItemSearchQuery;
  var itemText = text;
  if (isCategoryItem) {
    itemText = "<span>en</span> ".concat(text);
  }
  var anchorRef = useRef();
  if (isActive) {
    setActiveAnchorRef(anchorRef);
  }
  var handleArrowClick = function handleArrowClick() {
    setSearchQuery(anchorRef.current.innerText);
  };
  var handleMouseOver = function handleMouseOver() {
    onMouseOver(index);
  };
  var clickItem = function clickItem() {
    var itemClickedText = text.replace(/(<([^>]+)>)/gi, '');
    window.dispatchEvent(new CustomEvent('DDM_onSearching', {
      bubbles: true,
      detail: {
        value: itemClickedText,
        prefix: 'TA'
      }
    }));
    if (isXLPPage()) {
      var sectionClicked =
      section === 'suggestions' ? 'keyword' : section === 'relatedBrands' ? 'brand' : 'category';
      var position = listItemIndexStart ? index - listItemIndexStart : index;
      var subSection = isCategoryItem ? 'category' : 'x';
      var metrics = "".concat(searchQuery, "|").concat(itemClickedText, "|").concat(position, "/").concat(sectionSize, "|").concat(sectionClicked, "|").concat(subSection);
      saveTypeaheadMetrics(metrics);
    }
    onSelect();
    var nonCategoryItemText = url.includes('Ntt') ? "<b>".concat(itemClickedText, "</b>") : itemClickedText;
    setRecentSearchedValues({
      text: isCategoryItem ? "<b>".concat(categoryItemSearchQuery.replace(/(<([^>]+)>)/gi, ''), "</b> en ").concat(itemClickedText) : nonCategoryItemText,
      url: url
    }, rawStore, tenant);
  };
  var anchorProps = {
    className: classNames(_defineProperty(_defineProperty({}, styles$A.searchListItem__active, isActive), styles$A.storeAnchor, isStore)),
    tabIndex: '-1',
    ref: anchorRef,
    onMouseOver: handleMouseOver,
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize("".concat(itemText))
    },
    onClick: clickItem
  };
  return jsxs("li", {
    className: styles$A.searchListItem,
    children: [routingUrl ? jsx("a", {
      href: "".concat(routingUrl),
      onClick: clickItem,
      children: jsx("a", _objectSpread$f({}, anchorProps))
    }) : jsx("a", _objectSpread$f(_objectSpread$f({}, anchorProps), {}, {
      href: getURL$1(url, tenant, store)
    })), deviceType === 'mobile' && !title && jsx("i", {
      id: "suggestion-arrow",
      onClick: handleArrowClick
    }), children]
  }, "".concat(text, "-").concat(index));
};
SearchListItem.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  routingUrl: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isActive: PropTypes.bool.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  isCategoryItem: PropTypes.bool,
  setActiveAnchorRef: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired,
  store: PropTypes.string.isRequired,
  rawStore: PropTypes.string,
  deviceType: PropTypes.string.isRequired,
  title: PropTypes.string,
  searchQuery: PropTypes.string,
  section: PropTypes.string,
  sectionSize: PropTypes.number,
  listItemIndexStart: PropTypes.number,
  categoryItemSearchQuery: PropTypes.string
};
SearchListItem.defaultProps = {
  children: null,
  isCategoryItem: false,
  rawStore: null
};
var SearchListItem$1 = SearchListItem;

var minQueryLength = 2;
var minQueryLengthForSuggestion = 3;
var maxQueryLengthForSuggestion = 30;
var searchLabels = {
  relatedBrandsMobile: 'Marcas',
  relatedCategoriesMobile: 'Categorías',
  relatedBrands: 'Marcas relacionadas',
  relatedCategories: 'Categorías relacionadas',
  searchPlaceholder: '¿Qué buscas?',
  incorrectSearch: 'Busqueda Incorrecta',
  emptySearch: 'Busqueda Vacia',
  incorrectSearchBody: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
  emptySearchBody: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
  recentSearches: 'Buscaste recientemente',
  clear: 'Limpiar'
};
var searchByImageData = {
  badgeText: 'Nuevo',
  title: 'Búsqueda por imagen',
  description: 'Ahora puedes tomar una foto o subir una imagen para encontrar productos.',
  buttonText: 'Entendido'
};
var tooltipData = {
  message: 'Para mejores resultados, toma una foto enfocada, con fondo limpio y buena iluminación.',
  buttonText: 'Entendido',
  style: {
    right: '-28px',
    borderRadius: '8px',
    padding: '24px 16px 16px'
  }
};
var permissionDeniedPageData = {
  title: 'Buscar por imagen',
  description: 'Sube una imagen del producto. Si lo prefieres, puedes activar la cámara para próximas búsquedas.',
  uploadButtonLabel: 'Subir una imagen'
};
var errorData = {
  maxSize: 'El tamaño de la imagen supera los 20 MB.',
  unsupportedType: 'La imagen debe estar en formato JPG o PNG',
  unexpectedError: 'Ocurrió un error, por favor intenta nuevamente.'
};
var spinnerData = {
  cameraLoaderText: 'Esto puede tardar un momento.',
  submitImageText: 'Buscando productos similares…',
  submitImageDelayedText: 'Esto puede tardar un momento…'
};
var searchByImageTitle = 'Buscar por imagen';

var SearchList = function SearchList(_ref) {
  var cursor = _ref.cursor,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    onMouseOver = _ref.onMouseOver,
    onSelect = _ref.onSelect,
    deviceType = _ref.deviceType,
    results = _ref.results,
    setActiveAnchorRef = _ref.setActiveAnchorRef,
    tenant = _ref.tenant,
    store = _ref.store,
    searchInSis = _ref.searchInSis,
    searchQuery = _ref.searchQuery,
    setSearchQuery = _ref.setSearchQuery;
  var counter = 0;
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var _renderList = function renderList() {
    var isCategoryItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var list = arguments.length > 1 ? arguments[1] : undefined;
    var listItemIndexStart = arguments.length > 2 ? arguments[2] : undefined;
    var title = arguments.length > 3 ? arguments[3] : undefined;
    var section = arguments.length > 4 ? arguments[4] : undefined;
    var sectionSize = arguments.length > 5 ? arguments[5] : undefined;
    var categoryItemSearchQuery = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
    counter = listItemIndexStart || counter;
    var isCustomSite = isStandaloneSite || isWhitelabelSite;
    return list.map(function (_ref2) {
      var text = _ref2.text,
        url = _ref2.url,
        routingUrl = _ref2.routingUrl,
        categoryScope = _ref2.categoryScope;
      counter += 1;
      return jsx(SearchListItem$1, {
        text: text,
        url: url,
        routingUrl: routingUrl,
        onFocus: onMouseOver,
        onMouseOver: onMouseOver,
        isActive: counter === cursor,
        index: counter,
        isCategoryItem: isCategoryItem,
        setActiveAnchorRef: setActiveAnchorRef,
        onSelect: onSelect,
        tenant: tenant,
        store: searchInSis && title !== 'relatedBrands' || isCustomSite ? store : 'falabella',
        rawStore: store,
        searchQuery: searchQuery,
        setSearchQuery: setSearchQuery,
        section: section,
        sectionSize: sectionSize,
        listItemIndexStart: listItemIndexStart,
        title: title,
        deviceType: deviceType,
        isStore: !!store,
        categoryItemSearchQuery: categoryItemSearchQuery,
        children: categoryScope && jsx("ul", {
          children: _renderList(true, categoryScope, null, null, section, sectionSize, text)
        })
      }, "".concat(text, "-").concat(url));
    });
  };
  var isMobile = deviceType === 'mobile';
  return jsx("div", {
    className: classNames(styles$A.searchResults, styles$A["".concat(isAgentLoggedIn ? 'agent-loggedin' : isVendorLoggedIn && 'vendor-loggedin')]),
    children: results.categories.map(function (_ref3) {
      var key = _ref3.key,
        listItems = _ref3.listItems,
        listItemIndexStart = _ref3.listItemIndexStart,
        title = _ref3.title;
      var sectionSize = listItems.reduce(function (acc, next) {
        return next && next.categoryScope ? acc + next.categoryScope.length : acc;
      }, listItems.length);
      return jsx(Fragment, {
        children: listItems.length !== 0 && jsxs("section", {
          className: classNames(_defineProperty({}, styles$A.searchResults__other_category, title)),
          children: [title && jsx("h6", {
            className: classNames(styles$A.searchResults__title, _defineProperty({}, styles$A.storeTitle, store)),
            onClick: function onClick(e) {
              return e.preventDefault();
            },
            children: searchLabels[isMobile ? "".concat(title, "Mobile") : title] || title
          }), jsx("ul", {
            children: _renderList(false, listItems, listItemIndexStart, title, key, sectionSize)
          })]
        })
      }, key);
    })
  });
};
SearchList.propTypes = {
  cursor: PropTypes.number.isRequired,
  isAgentLoggedIn: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  onMouseOver: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  results: PropTypes.object,
  setActiveAnchorRef: PropTypes.func,
  tenant: PropTypes.string.isRequired,
  deviceType: PropTypes.string,
  isSearchBarTouched: PropTypes.bool,
  store: PropTypes.string.isRequired,
  searchInSis: PropTypes.bool,
  searchQuery: PropTypes.string
};
SearchList.defaultProps = {
  isAgentLoggedIn: false,
  isVendorLoggedIn: false,
  isSearchBarTouched: false,
  results: {},
  setActiveAnchorRef: noop$2,
  searchInSis: false
};
var SearchList$1 = SearchList;

function e$5(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

var e$4 = {};

var z;
function D$1() {
  if (z) return e$4;
  z = 1;
  var f = React;
  function C(i) {
    return i && typeof i == "object" && "default" in i ? i : { default: i };
  }
  var _ =  C(f);
  function b(i, n) {
    for (var s = 0; s < n.length; s++) {
      var e = n[s];
      e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(i, e.key, e);
    }
  }
  function j(i, n, s) {
    return n && b(i.prototype, n), i;
  }
  var p = typeof process < "u" && process.env && process.env.NODE_ENV === "production", S = function(i) {
    return Object.prototype.toString.call(i) === "[object String]";
  }, A =  (function() {
    function i(s) {
      var e = s === void 0 ? {} : s, t = e.name, r = t === void 0 ? "stylesheet" : t, o = e.optimizeForSpeed, u = o === void 0 ? p : o;
      l(S(r), "`name` must be a string"), this._name = r, this._deletedRulePlaceholder = "#" + r + "-deleted-rule____{}", l(typeof u == "boolean", "`optimizeForSpeed` must be a boolean"), this._optimizeForSpeed = u, this._serverSheet = void 0, this._tags = [], this._injected = !1, this._rulesCount = 0;
      var h = typeof window < "u" && document.querySelector('meta[property="csp-nonce"]');
      this._nonce = h ? h.getAttribute("content") : null;
    }
    var n = i.prototype;
    return n.setOptimizeForSpeed = function(e) {
      l(typeof e == "boolean", "`setOptimizeForSpeed` accepts a boolean"), l(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted"), this.flush(), this._optimizeForSpeed = e, this.inject();
    }, n.isOptimizeForSpeed = function() {
      return this._optimizeForSpeed;
    }, n.inject = function() {
      var e = this;
      if (l(!this._injected, "sheet already injected"), this._injected = !0, typeof window < "u" && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name), this._optimizeForSpeed = "insertRule" in this.getSheet(), this._optimizeForSpeed || (p || console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode."), this.flush(), this._injected = !0);
        return;
      }
      this._serverSheet = {
        cssRules: [],
        insertRule: function(t, r) {
          return typeof r == "number" ? e._serverSheet.cssRules[r] = {
            cssText: t
          } : e._serverSheet.cssRules.push({
            cssText: t
          }), r;
        },
        deleteRule: function(t) {
          e._serverSheet.cssRules[t] = null;
        }
      };
    }, n.getSheetForTag = function(e) {
      if (e.sheet)
        return e.sheet;
      for (var t = 0; t < document.styleSheets.length; t++)
        if (document.styleSheets[t].ownerNode === e)
          return document.styleSheets[t];
    }, n.getSheet = function() {
      return this.getSheetForTag(this._tags[this._tags.length - 1]);
    }, n.insertRule = function(e, t) {
      if (l(S(e), "`insertRule` accepts only strings"), typeof window > "u")
        return typeof t != "number" && (t = this._serverSheet.cssRules.length), this._serverSheet.insertRule(e, t), this._rulesCount++;
      if (this._optimizeForSpeed) {
        var r = this.getSheet();
        typeof t != "number" && (t = r.cssRules.length);
        try {
          r.insertRule(e, t);
        } catch {
          return p || console.warn(`StyleSheet: illegal rule: 

` + e + `

See https://stackoverflow.com/q/20007992 for more info`), -1;
        }
      } else {
        var o = this._tags[t];
        this._tags.push(this.makeStyleTag(this._name, e, o));
      }
      return this._rulesCount++;
    }, n.replaceRule = function(e, t) {
      if (this._optimizeForSpeed || typeof window > "u") {
        var r = typeof window < "u" ? this.getSheet() : this._serverSheet;
        if (t.trim() || (t = this._deletedRulePlaceholder), !r.cssRules[e])
          return e;
        r.deleteRule(e);
        try {
          r.insertRule(t, e);
        } catch {
          p || console.warn(`StyleSheet: illegal rule: 

` + t + `

See https://stackoverflow.com/q/20007992 for more info`), r.insertRule(this._deletedRulePlaceholder, e);
        }
      } else {
        var o = this._tags[e];
        l(o, "old rule at index `" + e + "` not found"), o.textContent = t;
      }
      return e;
    }, n.deleteRule = function(e) {
      if (typeof window > "u") {
        this._serverSheet.deleteRule(e);
        return;
      }
      if (this._optimizeForSpeed)
        this.replaceRule(e, "");
      else {
        var t = this._tags[e];
        l(t, "rule at index `" + e + "` not found"), t.parentNode.removeChild(t), this._tags[e] = null;
      }
    }, n.flush = function() {
      this._injected = !1, this._rulesCount = 0, typeof window < "u" ? (this._tags.forEach(function(e) {
        return e && e.parentNode.removeChild(e);
      }), this._tags = []) : this._serverSheet.cssRules = [];
    }, n.cssRules = function() {
      var e = this;
      return typeof window > "u" ? this._serverSheet.cssRules : this._tags.reduce(function(t, r) {
        return r ? t = t.concat(Array.prototype.map.call(e.getSheetForTag(r).cssRules, function(o) {
          return o.cssText === e._deletedRulePlaceholder ? null : o;
        })) : t.push(null), t;
      }, []);
    }, n.makeStyleTag = function(e, t, r) {
      t && l(S(t), "makeStyleTag accepts only strings as second parameter");
      var o = document.createElement("style");
      this._nonce && o.setAttribute("nonce", this._nonce), o.type = "text/css", o.setAttribute("data-" + e, ""), t && o.appendChild(document.createTextNode(t));
      var u = document.head || document.getElementsByTagName("head")[0];
      return r ? u.insertBefore(o, r) : u.appendChild(o), o;
    }, j(i, [
      {
        key: "length",
        get: function() {
          return this._rulesCount;
        }
      }
    ]), i;
  })();
  function l(i, n) {
    if (!i)
      throw new Error("StyleSheet: " + n + ".");
  }
  function T(i) {
    for (var n = 5381, s = i.length; s; )
      n = n * 33 ^ i.charCodeAt(--s);
    return n >>> 0;
  }
  var k = T, O = function(i) {
    return i.replace(/\/style/gi, "\\/style");
  }, a = {};
  function m(i, n) {
    if (!n)
      return "jsx-" + i;
    var s = String(n), e = i + s;
    return a[e] || (a[e] = "jsx-" + k(i + "-" + s)), a[e];
  }
  function g(i, n) {
    var s = /__jsx-style-dynamic-selector/g;
    typeof window > "u" && (n = O(n));
    var e = i + n;
    return a[e] || (a[e] = n.replace(s, i)), a[e];
  }
  function E(i, n) {
    return n === void 0 && (n = {}), i.map(function(s) {
      var e = s[0], t = s[1];
      return  _.default.createElement("style", {
        id: "__" + e,
        key: "__" + e,
        nonce: n.nonce ? n.nonce : void 0,
        dangerouslySetInnerHTML: {
          __html: t
        }
      });
    });
  }
  var I =  (function() {
    function i(s) {
      var e = s === void 0 ? {} : s, t = e.styleSheet, r = t === void 0 ? null : t, o = e.optimizeForSpeed, u = o === void 0 ? !1 : o;
      this._sheet = r || new A({
        name: "styled-jsx",
        optimizeForSpeed: u
      }), this._sheet.inject(), r && typeof u == "boolean" && (this._sheet.setOptimizeForSpeed(u), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }
    var n = i.prototype;
    return n.add = function(e) {
      var t = this;
      this._optimizeForSpeed === void 0 && (this._optimizeForSpeed = Array.isArray(e.children), this._sheet.setOptimizeForSpeed(this._optimizeForSpeed), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), typeof window < "u" && !this._fromServer && (this._fromServer = this.selectFromServer(), this._instancesCounts = Object.keys(this._fromServer).reduce(function(c, x) {
        return c[x] = 0, c;
      }, {}));
      var r = this.getIdAndRules(e), o = r.styleId, u = r.rules;
      if (o in this._instancesCounts) {
        this._instancesCounts[o] += 1;
        return;
      }
      var h = u.map(function(c) {
        return t._sheet.insertRule(c);
      }).filter(function(c) {
        return c !== -1;
      });
      this._indices[o] = h, this._instancesCounts[o] = 1;
    }, n.remove = function(e) {
      var t = this, r = this.getIdAndRules(e).styleId;
      if (N(r in this._instancesCounts, "styleId: `" + r + "` not found"), this._instancesCounts[r] -= 1, this._instancesCounts[r] < 1) {
        var o = this._fromServer && this._fromServer[r];
        o ? (o.parentNode.removeChild(o), delete this._fromServer[r]) : (this._indices[r].forEach(function(u) {
          return t._sheet.deleteRule(u);
        }), delete this._indices[r]), delete this._instancesCounts[r];
      }
    }, n.update = function(e, t) {
      this.add(t), this.remove(e);
    }, n.flush = function() {
      this._sheet.flush(), this._sheet.inject(), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }, n.cssRules = function() {
      var e = this, t = this._fromServer ? Object.keys(this._fromServer).map(function(o) {
        return [
          o,
          e._fromServer[o]
        ];
      }) : [], r = this._sheet.cssRules();
      return t.concat(Object.keys(this._indices).map(function(o) {
        return [
          o,
          e._indices[o].map(function(u) {
            return r[u].cssText;
          }).join(e._optimizeForSpeed ? "" : `
`)
        ];
      }).filter(function(o) {
        return !!o[1];
      }));
    }, n.styles = function(e) {
      return E(this.cssRules(), e);
    }, n.getIdAndRules = function(e) {
      var t = e.children, r = e.dynamic, o = e.id;
      if (r) {
        var u = m(o, r);
        return {
          styleId: u,
          rules: Array.isArray(t) ? t.map(function(h) {
            return g(u, h);
          }) : [
            g(u, t)
          ]
        };
      }
      return {
        styleId: m(o),
        rules: Array.isArray(t) ? t : [
          t
        ]
      };
    }, n.selectFromServer = function() {
      var e = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
      return e.reduce(function(t, r) {
        var o = r.id.slice(2);
        return t[o] = r, t;
      }, {});
    }, i;
  })();
  function N(i, n) {
    if (!i)
      throw new Error("StyleSheetRegistry: " + n + ".");
  }
  var y =  f.createContext(null);
  y.displayName = "StyleSheetContext";
  function v() {
    return new I();
  }
  function P(i) {
    var n = i.registry, s = i.children, e = f.useContext(y), t = f.useState(function() {
      return e || n || v();
    }), r = t[0];
    return  _.default.createElement(y.Provider, {
      value: r
    }, s);
  }
  function R() {
    return f.useContext(y);
  }
  var q = _.default.useInsertionEffect || _.default.useLayoutEffect, w = typeof window < "u" ? v() : void 0;
  function F(i) {
    var n = w || R();
    return n ? typeof window > "u" ? (n.add(i), null) : (q(function() {
      return n.add(i), function() {
        n.remove(i);
      };
    }, [
      i.id,
      String(i.dynamic)
    ]), null) : null;
  }
  return F.dynamic = function(i) {
    return i.map(function(n) {
      var s = n[0], e = n[1];
      return m(s, e);
    }).join(" ");
  }, e$4.StyleRegistry = P, e$4.createStyleRegistry = v, e$4.style = F, e$4.useStyleRegistry = R, e$4;
}

var e$3, r;
function u() {
  return r || (r = 1, e$3 = D$1().style), e$3;
}

var e$2 = u();
const a =  e$5(e$2);

const e$1 = "#0072ce", d = "#00335D", c$1 = "#E6F1FA", l$1 = "#343e49", D = "#505050", j = "#fefeff", m = "#333333";

const o = "'Lato', sans-serif";

const x = "14px";

const t$1 = 130, c = 150;

const l = [".coachmark.jsx-2477190181{position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-wrap:wrap;}", `.circles.jsx-2477190181{background:none;border:none;padding:0;position:relative;width:60px;aspect-ratio:1 / 1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;z-index:${c};}`, `.circle.jsx-2477190181{background-color:${e$1};aspect-ratio:1 / 1;border-radius:50%;position:absolute;-webkit-animation-duration:3s;animation-duration:3s;-webkit-animation-timing-function:ease;animation-timing-function:ease;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;}`, ".circle-1.jsx-2477190181{-webkit-animation-name:pulse-1-jsx-2477190181;animation-name:pulse-1-jsx-2477190181;}", "@-webkit-keyframes pulse-1-jsx-2477190181{0%{opacity:0.1;width:10px;}10%,40%{opacity:0.7;width:20px;}60%,100%{opacity:0.1;width:10px;}}", "@keyframes pulse-1-jsx-2477190181{0%{opacity:0.1;width:10px;}10%,40%{opacity:0.7;width:20px;}60%,100%{opacity:0.1;width:10px;}}", ".circle-2.jsx-2477190181{-webkit-animation-name:pulse-2-jsx-2477190181;animation-name:pulse-2-jsx-2477190181;}", "@-webkit-keyframes pulse-2-jsx-2477190181{0%,10%{opacity:0.05;width:30px;}20%,40%{opacity:0.4;width:40px;}60%,100%{opacity:0.05;width:30px;}}", "@keyframes pulse-2-jsx-2477190181{0%,10%{opacity:0.05;width:30px;}20%,40%{opacity:0.4;width:40px;}60%,100%{opacity:0.05;width:30px;}}", ".circle-3.jsx-2477190181{-webkit-animation-name:pulse-3-jsx-2477190181;animation-name:pulse-3-jsx-2477190181;}", "@-webkit-keyframes pulse-3-jsx-2477190181{0%,20%{width:50px;opacity:0.02;}30%,40%{width:60px;opacity:0.1;}60%,100%{width:50px;opacity:0.02;}}", "@keyframes pulse-3-jsx-2477190181{0%,20%{width:50px;opacity:0.02;}30%,40%{width:60px;opacity:0.1;}60%,100%{width:50px;opacity:0.02;}}", `.popover-recommended-products-ui.jsx-2477190181{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:280px;padding:16px;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;border-radius:12px;background:${j};z-index:${c};position:absolute;cursor:initial;box-shadow:1px 1px 17px -2px rgba(0,0,0,0.55);}`, `.title.jsx-2477190181{color:${m};font-family:${o};font-size:20px;font-style:normal;font-weight:normal;line-height:24px;margin:4px 0 8px;}`, `.description.jsx-2477190181{color:${D};font-family:${o};font-size:14px;font-style:normal;font-weight:400;line-height:20px;margin-bottom:16px;}`, ".buttons-container.jsx-2477190181{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;width:100%;}", ".skip-button-container.jsx-2477190181{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;width:50%;}", `.skip-button.jsx-2477190181{padding:0 32px;background:none;border:none;color:${l$1};font-family:${o};font-size:${x};line-height:16px;font-weight:700;justify-self:flex-end;cursor:pointer;}`, `.button.jsx-2477190181{width:112px;height:32px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:4px;color:${j};background:${e$1};border:none;font-family:${o};font-size:14px;line-height:16px;font-style:normal;font-weight:bold;margin-left:auto;cursor:pointer;}`, ".badge-content.jsx-2477190181{padding:2px 4px;font-weight:400;}"];
l.__hash = "2477190181";

const e = [`.badge.jsx-3188988714{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;padding:1px 4px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;font-family:${o};font-size:12px;line-height:14px;font-weight:bold;box-sizing:border-box;}`];
e.__hash = "3188988714";

const i = ({
  backgroundColor: r = "",
  textColor: a$1 = "",
  ...e$1
}) => {
  const o = {
    backgroundColor: r,
    color: a$1,
    ...e$1.style
  };
  return  jsxs(Fragment$1, { children: [
     jsx(a, { id: e.__hash, children: e }),
     jsx("span", { ...e$1, style: o, className: `jsx-${e.__hash} badge` })
  ] });
};

const t = [`.overlay-recommended-products-ui.jsx-3012942660{background-color:${m}b3;width:100svw;height:100svh;z-index:${t$1};position:fixed;top:0;left:0;}`];
t.__hash = "3012942660";

const p = ({
  onClick: e,
  allowPageBodyScroll: a$1 = !1
}) => {
  const o = (s) => {
    s.preventDefault(), s.stopPropagation(), e == null || e();
  };
  return  jsxs(Fragment$1, { children: [
     jsx(a, { id: t.__hash, children: t }),
    !a$1 &&  jsx("style", { children: "body {overflow: hidden;}" }),
     jsx("div", { onClick: o, "data-testid": "overlay", className: `jsx-${t.__hash} overlay-recommended-products-ui` })
  ] });
};

const w = ({
  badgeText: l$1 = "",
  title: r = "",
  description: i$1 = "",
  buttonText: h = "",
  onClickOnCircles: d$1,
  onClickOnButton: m,
  onClickOnOverlay: n,
  showOverlay: _ = !1,
  popoverPosition: p$1 = "bottom",
  separation: e = "10px",
  popoverStyle: x = {},
  skipButtonText: t,
  skipOnClick: o
}) => {
  const $ = {
    top: {
      bottom: `calc(100% + ${e})`
    },
    right: {
      left: `calc(100% + ${e})`
    },
    bottom: {
      top: `calc(100% + ${e})`
    },
    left: {
      right: `calc(100% + ${e})`
    }
  }[p$1];
  return  jsxs(Fragment$1, { children: [
     jsx(a, { id: l.__hash, children: l }),
    _ &&  jsx(p, { allowPageBodyScroll: !0, onClick: n }),
     jsxs("div", { className: `jsx-${l.__hash} coachmark`, children: [
       jsxs("div", { onClick: d$1, "data-testid": "coachmark-mark", className: `jsx-${l.__hash} circles`, children: [
         jsx("div", { className: `jsx-${l.__hash} circle circle-1` }),
         jsx("div", { className: `jsx-${l.__hash} circle circle-2` }),
         jsx("div", { className: `jsx-${l.__hash} circle circle-3` })
      ] }),
       jsxs("div", { style: {
        ...x,
        ...$
      }, "data-testid": "coachmark-popover", className: `jsx-${l.__hash} popover-recommended-products-ui`, children: [
         jsx(i, { backgroundColor: c$1, textColor: d, children:  jsx("span", { className: `jsx-${l.__hash} badge-content`, children: l$1 }) }),
         jsx("div", { className: `jsx-${l.__hash} title`, children: r }),
         jsx("div", { className: `jsx-${l.__hash} description`, children: i$1 }),
         jsxs("div", { className: `jsx-${l.__hash} buttons-container`, children: [
          t && o &&  jsx("div", { className: `jsx-${l.__hash} skip-button-container`, children:  jsx("button", { onClick: o, "data-testid": "skip-button", className: `jsx-${l.__hash} skip-button`, children: t }) }),
           jsx("button", { onClick: m, "data-testid": "popover-button", className: `jsx-${l.__hash} button`, children: h })
        ] })
      ] })
    ] })
  ] });
};

var useCoachmark = function useCoachmark() {
  var storageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'coachmarkDismissed';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showCoachmark = _useState2[0],
    setShowCoachmark = _useState2[1];
  useEffect(function () {
    var dismissed = getFromLocalStorage(storageKey);
    if (!dismissed) {
      setShowCoachmark(true);
    }
  }, [storageKey]);
  var dismissCoachmark = function dismissCoachmark() {
    setToLocalStorage(storageKey, true);
    setShowCoachmark(false);
  };
  return {
    showCoachmark: showCoachmark,
    dismissCoachmark: dismissCoachmark
  };
};
var useCoachmark$1 = useCoachmark;

var styles$z = {"searchBar":"SearchBar-module_searchBar__7KDA-","store_search_input_wrapper":"SearchBar-module_store_search_input_wrapper__cFPUH","store_search_input_wrapper--to_com":"SearchBar-module_store_search_input_wrapper--to_com__dYbi2","showOverlay":"SearchBar-module_showOverlay__bNShO","flatSearchCorners":"SearchBar-module_flatSearchCorners__bIJs2","searchBar--whitelabel":"SearchBar-module_searchBar--whitelabel__8vBYn","coachmark-wrapper":"SearchBar-module_coachmark-wrapper__-b6wp","searchBar__Icon":"SearchBar-module_searchBar__Icon__2-2RI","searchBar__Input":"SearchBar-module_searchBar__Input__NDqpk","searchBar__Close":"SearchBar-module_searchBar__Close__2-Aze","hidden":"SearchBar-module_hidden__2jA-R","hasCamera":"SearchBar-module_hasCamera__sBEgq","sr-only":"SearchBar-module_sr-only__sCJ5g","searchBtnIcon":"SearchBar-module_searchBtnIcon__YqTAF","searchIcon":"SearchBar-module_searchIcon__-gxub","searchBtnIcon--so_com":"SearchBar-module_searchBtnIcon--so_com__ROVw4","searchBtnIcon--to_com":"SearchBar-module_searchBtnIcon--to_com__X9bnX","searchBtnIcon--whitelabel":"SearchBar-module_searchBtnIcon--whitelabel__F5RoP","searchBtn":"SearchBar-module_searchBtn__mieN4","searchBarActive":"SearchBar-module_searchBarActive__xT76X","searchBarWrapper":"SearchBar-module_searchBarWrapper__NPHoF","store_search":"SearchBar-module_store_search__Kx3pd","store_search--to_com":"SearchBar-module_store_search--to_com__224OF","searchBarWrapper--to_com":"SearchBar-module_searchBarWrapper--to_com__EPrnS","searchBarWrapper--whitelabel":"SearchBar-module_searchBarWrapper--whitelabel__LyJ2o","overlap":"SearchBar-module_overlap__5JWUe","showFlatEdges":"SearchBar-module_showFlatEdges__rvQ-3","camera":"SearchBar-module_camera__L7QA5","has-coachmark":"SearchBar-module_has-coachmark__J3U6w"};

var useWindowLoaded = function useWindowLoaded() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    windowLoaded = _useState2[0],
    setWindowLoaded = _useState2[1];
  useEffect(function () {
    if (document.readyState === 'complete') {
      setWindowLoaded(true);
    } else {
      var handleLoad = function handleLoad() {
        return setWindowLoaded(true);
      };
      window.addEventListener('load', handleLoad);
      return function () {
        window.removeEventListener('load', handleLoad);
      };
    }
  }, []);
  return windowLoaded;
};
var useWindowLoaded$1 = useWindowLoaded;

function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Searchbar = function Searchbar(_ref) {
  var _searchbar$search_ico, _searchbar$search_ico2;
  var deviceType = _ref.deviceType,
    handleEnter = _ref.handleEnter,
    isTypeAheadActive = _ref.isTypeAheadActive,
    minQueryLength = _ref.minQueryLength,
    onSearchBarChange = _ref.onSearchBarChange,
    searchbar = _ref.searchbar,
    searchQuery = _ref.searchQuery,
    setSearchInputRef = _ref.setSearchInputRef,
    setSearchQuery = _ref.setSearchQuery,
    setIsSearchBarTouched = _ref.setIsSearchBarTouched,
    searchInSis = _ref.searchInSis,
    store = _ref.store,
    tenant = _ref.tenant,
    isSearchByImageEnable = _ref.isSearchByImageEnable,
    isCameraCoachmarkVisible = _ref.isCameraCoachmarkVisible,
    setOpenImageUploadModal = _ref.setOpenImageUploadModal,
    handleSearchByImageData = _ref.handleSearchByImageData,
    openCamera = _ref.openCamera,
    setOpenCamera = _ref.setOpenCamera,
    handleAbort = _ref.handleAbort,
    handleSearchByImageSateliteData = _ref.handleSearchByImageSateliteData;
  var _useCoachmark = useCoachmark$1('coachmarkSearchBar'),
    showCoachmark = _useCoachmark.showCoachmark,
    dismissCoachmark = _useCoachmark.dismissCoachmark;
  var _getStandaloneSite = getStandaloneSite(store),
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSearchBarActive = _useState2[0],
    setSearchBarActive = _useState2[1];
  var searchInputRef = useRef(null);
  var windowLoaded = useWindowLoaded$1();
  var isDesktop = deviceType === 'desktop';
  var showDesktopCamera = isSearchByImageEnable && isDesktop && isSodimacStandalone;
  var showDesktopCameraCoachmark = isSearchByImageEnable && showCoachmark && isCameraCoachmarkVisible && isDesktop && isSodimacStandalone;
  var showMobileCamera = isSearchByImageEnable && windowLoaded && isSodimacStandalone && !isDesktop;
  var showMobileCameraCoachmark = isSearchByImageEnable && windowLoaded && showCoachmark && isCameraCoachmarkVisible && !isDesktop && isSodimacStandalone;
  var toggleSearchByImage = function toggleSearchByImage() {
    setOpenCamera(!openCamera);
  };
  useEffect(function () {
    setSearchInputRef(searchInputRef);
  }, [setSearchInputRef]);
  var makeTypeAheadCall = function makeTypeAheadCall(value) {
    if (value.length >= minQueryLength) {
      onSearchBarChange(value);
    } else {
      onSearchBarChange();
    }
  };
  var getPlaceholder = function getPlaceholder(_ref2) {
    var type = _ref2.type;
    if (!store || isSodimacStandalone || isWhitelabelSite) {
      var _searchbar;
      return (_searchbar = searchbar === null || searchbar === void 0 ? void 0 : searchbar["".concat(type, "_placeholder")]) !== null && _searchbar !== void 0 ? _searchbar : '';
    }
    return "Buscar en ".concat(SIS_STORE_MAP === null || SIS_STORE_MAP === void 0 ? void 0 : SIS_STORE_MAP[store]);
  };
  var searchPlaceholder = getPlaceholder({
    type: 'desktop'
  });
  var searchPlaceholderMobile = getPlaceholder({
    type: 'mobile'
  });
  var debouncedTypeAhead = useCallback(debounce(makeTypeAheadCall, 200), [searchInSis, store]);
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    setSearchQuery(value);
    debouncedTypeAhead(value);
  };
  var clearSearch = function clearSearch() {
    setSearchQuery('');
    onSearchBarChange();
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };
  var rendeCrossIcon = function rendeCrossIcon() {
    return searchQuery.length ? jsx("i", {
      id: "testId-SearchBar-Close",
      className: classNames(styles$z.searchBar__Close, _defineProperty({}, styles$z.hasCamera, showDesktopCamera || showMobileCamera)),
      onClick: clearSearch
    }) : jsx(React.Fragment, {});
  };
  var handleOnBlur = function handleOnBlur(event) {
    if (!event.relatedTarget) {
      setIsSearchBarTouched(false);
      return;
    }
    if (event.relatedTarget && !event.relatedTarget.id.includes('searchCheckbox')) {
      setIsSearchBarTouched(false);
    }
  };
  var mobileCoachmarkStyle = {
    popoverPosition: 'bottom',
    popoverStyle: {
      right: '15%'
    },
    separation: '20px',
    showOverlay: true
  };
  return jsxs("div", {
    className: classNames(styles$z.searchBarWrapper, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$z.searchBarActive, isSearchBarActive), styles$z.store_search, store), styles$z['store_search--to_com'], isTottusStandalone), styles$z['searchBarWrapper--to_com'], isTottusStandalone), styles$z['searchBarWrapper--whitelabel'], isWhitelabelSite)),
    onFocus: function onFocus() {
      return setIsSearchBarTouched(true);
    },
    onBlur: function onBlur(e) {
      return handleOnBlur(e);
    },
    children: [jsxs("div", {
      className: classNames(styles$z.searchBar, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$z.showOverlay, isTypeAheadActive), styles$z.flatSearchCorners, !isSodimacStandalone && isTypeAheadActive), styles$z.store_search_input_wrapper, store), styles$z['store_search_input_wrapper--to_com'], isTottusStandalone), styles$z['searchBar--whitelabel'], isWhitelabelSite)),
      onFocus: function onFocus() {
        return isDesktop && setSearchBarActive(true);
      },
      onBlur: function onBlur() {
        return isDesktop && setSearchBarActive(false);
      },
      children: [jsx("label", {
        htmlFor: "testId-SearchBar-Input",
        className: styles$z['sr-only'],
        children: "Search Bar"
      }), jsx("input", {
        autoComplete: "off",
        className: styles$z.searchBar__Input,
        id: "testId-SearchBar-Input",
        onChange: handleChange,
        ref: searchInputRef,
        tabIndex: "-1",
        type: "text",
        value: searchQuery,
        placeholder: deviceType === 'desktop' ? searchPlaceholder : searchPlaceholderMobile,
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 13 && searchInputRef.current) {
            searchInputRef.current.blur();
          }
        },
        onBlur: function onBlur() {
          return updateDigitalDataCookies({
            firstLevelItem: 'N1 - Search Typeahead',
            tag: HEADER
          });
        }
      }), rendeCrossIcon()]
    }), showMobileCamera && jsx("div", {
      className: classNames(styles$z.camera, _defineProperty({}, styles$z['has-coachmark'], showCoachmark)),
      onClick: toggleSearchByImage
    }), showMobileCameraCoachmark && jsx("div", {
      className: styles$z['coachmark-wrapper'],
      children: jsx(w, _objectSpread$e({
        badgeText: searchByImageData.badgeText,
        title: searchByImageData.title,
        description: searchByImageData.description,
        buttonText: searchByImageData.buttonText,
        onClickOnButton: dismissCoachmark,
        onClickOnOverlay: dismissCoachmark
      }, mobileCoachmarkStyle), "search-coachmark")
    }), showDesktopCamera && jsx("div", {
      onClick: function onClick() {
        setOpenImageUploadModal(true);
      },
      className: classNames(styles$z.camera, _defineProperty({}, styles$z['has-coachmark'], showCoachmark))
    }), showDesktopCameraCoachmark && jsx("div", {
      className: styles$z['coachmark-wrapper'],
      children: jsx(w, {
        badgeText: searchByImageData.badgeText,
        title: searchByImageData.title,
        description: searchByImageData.description,
        buttonText: searchByImageData.buttonText,
        onClickOnButton: dismissCoachmark,
        onClickOnOverlay: dismissCoachmark,
        showOverlay: true
      })
    }), jsx("button", {
      onClick: handleEnter,
      className: classNames(styles$z.searchBtnIcon, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$z.showFlatEdges, !isSodimacStandalone && isTypeAheadActive), styles$z.overlap, isTypeAheadActive), styles$z['searchBtnIcon--so_com'], isSodimacStandalone && !isTypeAheadActive), styles$z['searchBtnIcon--to_com'], isTottusStandalone), styles$z['searchBtnIcon--whitelabel'], isWhitelabelSite)),
      children: jsx("img", {
        className: styles$z.searchIcon,
        src: (_searchbar$search_ico = searchbar === null || searchbar === void 0 || (_searchbar$search_ico2 = searchbar.search_icon) === null || _searchbar$search_ico2 === void 0 ? void 0 : _searchbar$search_ico2.url) !== null && _searchbar$search_ico !== void 0 ? _searchbar$search_ico : ''
      })
    }), isSodimacStandalone && !isDesktop && openCamera && jsx("div", {
      className: "camera--wrapper",
      children: jsx(SearchByImage, {
        modalTitle: searchByImageTitle,
        openCamera: openCamera,
        isMobile: true,
        toggleSearchByImage: toggleSearchByImage,
        tooltipData: tooltipData,
        permissionDeniedPageData: permissionDeniedPageData,
        errorMessageData: errorData,
        tenant: tenant,
        handleSearchByImageData: handleSearchByImageData,
        spinnerData: spinnerData,
        handleAbort: handleAbort,
        updateSateliteTrack: handleSearchByImageSateliteData
      })
    })]
  });
};
Searchbar.propTypes = {
  deviceType: PropTypes.string.isRequired,
  handleEnter: PropTypes.func.isRequired,
  isSisSodimacPdpEnabled: PropTypes.bool,
  isTypeAheadActive: PropTypes.bool.isRequired,
  labels: PropTypes.object,
  minQueryLength: PropTypes.number.isRequired,
  onSearchBarChange: PropTypes.func.isRequired,
  searchbar: PropTypes.object.isRequired,
  searchQuery: PropTypes.string.isRequired,
  setSearchInputRef: PropTypes.func.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  setIsSearchBarTouched: PropTypes.func,
  searchInSis: PropTypes.bool.isRequired,
  store: PropTypes.string,
  setOpenImageUploadModal: PropTypes.func,
  isSearchByImageEnable: PropTypes.bool
};
Searchbar.defaultProps = {
  setIsSearchBarTouched: noop$2,
  labels: {},
  store: null,
  tenant: 'cl',
  isSearchByImageEnable: false
};
var SearchBar = Searchbar;

var storeMap = {
  cl: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_america: 'americanino',
    fa_carters: 'carters',
    fa_aldo: 'aldo',
    fa_crabarr: 'crateandbarrel',
    fa_thedrop: 'thedropzone'
  },
  pe: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_carters: 'carters',
    fa_aldo: 'aldoshoes',
    fa_crabarr: 'crateandbarrel',
    fa_thedrop: 'thedropzone'
  },
  co: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    homecenter: 'homecenter',
    linio: 'linio',
    fa_crabarr: 'crateandbarrel',
    fa_thedrop: 'thedropzone'
  },
  mx: {
    so_retail: 'sodimac'
  }
};

var MarketplaceOverlay = function MarketplaceOverlay(_ref) {
  var handlers = _ref.handlers,
    backdropPosition = _ref.backdropPosition,
    setOverlayEnabled = _ref.setOverlayEnabled;
  React.useEffect(function () {
    setOverlayEnabled(true);
    toggleBodyClass(true, 'no-overlay-scroll');
    return function () {
      setOverlayEnabled(false);
      toggleBodyClass(false, 'no-overlay-scroll');
    };
  }, []);
  return jsxs(React.Fragment, {
    children: [jsx("div", {
      style: backdropPosition,
      className: "overlay",
      onClick: handlers
    }), jsx("style", {
      children: "\n          .overlay {\n            background: rgba(0, 0, 0, 0.7);\n            height: 100vh;\n            position: fixed;\n            left: 0;\n            top: 0;\n            width: 100%;\n            z-index: 100;\n            transition: background-color 0.5s;\n          }\n          .no-overlay-scroll {\n            position: fixed;\n            overflow-y: scroll;\n            inline-size: 100%;\n          }\n        "
    })]
  });
};
MarketplaceOverlay.propTypes = {
  handlers: PropTypes.func,
  backdropPosition: PropTypes.object,
  setOverlayEnabled: PropTypes.func.isRequired
};
MarketplaceOverlay.defaultProps = {
  handlers: noop$1,
  backdropPosition: {}
};
var MarketplaceOverlay$1 = withUser(MarketplaceOverlay);

function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function encodeNttParameter(url, baseUrl) {
  var nttParamIndex = url.indexOf('Ntt=');
  if (nttParamIndex === -1 || !url.split('Ntt=')[1]) return "".concat(baseUrl).concat(url);
  var _url$split = url.split('Ntt='),
    _url$split2 = _slicedToArray(_url$split, 2),
    path = _url$split2[0],
    value = _url$split2[1];
  return "".concat(baseUrl).concat(path, "Ntt=").concat(encodeURIComponent(value));
}
var getURL = function getURL(url, tenant, store) {
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var baseUrl;
  if (isWhitelabelSite) {
    baseUrl = getWhitelabelSiteBaseUrl(tenant, store);
  } else if (isStandaloneSite) {
    baseUrl = getStandaloneSiteBaseUrl(tenant, store);
  } else {
    baseUrl = getStoreBaseUrl(tenant, store);
  }
  return encodeNttParameter(url, baseUrl);
};
var RecentSearchListItem = function RecentSearchListItem(_ref) {
  var text = _ref.text,
    url = _ref.url,
    index = _ref.index,
    tenant = _ref.tenant,
    store = _ref.store,
    rawStore = _ref.rawStore;
  var clickItem = function clickItem() {
    window.dispatchEvent(new CustomEvent('DDM_onSearching', {
      bubbles: true,
      detail: {
        value: text.replace(/(<([^>]+)>)/gi, ''),
        prefix: 'RS'
      }
    }));
    setRecentSearchedValues({
      text: text,
      url: url
    }, rawStore, tenant);
  };
  var anchorProps = {
    tabIndex: '-1',
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(text)
    },
    onClick: clickItem
  };
  return jsx("li", {
    className: styles$A.recentSearchListItem,
    children: jsx("a", _objectSpread$d(_objectSpread$d({}, anchorProps), {}, {
      href: getURL(url, tenant, store)
    }))
  }, "".concat(text, "-").concat(index));
};
RecentSearchListItem.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  tenant: PropTypes.string.isRequired,
  store: PropTypes.string.isRequired,
  rawStore: PropTypes.string
};
var RecentSearchListItem$1 = RecentSearchListItem;

var RecentSearchList = function RecentSearchList(_ref) {
  var isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    results = _ref.results,
    tenant = _ref.tenant,
    store = _ref.store,
    handleClearRecentSearchedData = _ref.handleClearRecentSearchedData;
  var counter = 0;
  var renderList = function renderList(list, title) {
    return list.map(function (_ref2) {
      var text = _ref2.text,
        url = _ref2.url;
      counter += 1;
      return jsx(RecentSearchListItem$1, {
        text: text,
        url: url,
        index: counter,
        tenant: tenant,
        store: store && title !== 'relatedBrands' ? store : 'falabella',
        rawStore: store
      }, "".concat(text, "-").concat(url));
    });
  };
  return results.length && jsx("div", {
    className: classNames(styles$A.searchResults, styles$A.recentSearchResults, styles$A["".concat(isAgentLoggedIn ? 'agent-loggedin' : isVendorLoggedIn && 'vendor-loggedin')]),
    children: jsxs("section", {
      className: styles$A.recentSearchResults,
      children: [jsxs("div", {
        className: styles$A.recentSearchResults__title__container,
        children: [jsx("h6", {
          className: styles$A.recentSearchResults__title,
          onClick: function onClick(e) {
            return e.preventDefault();
          },
          children: searchLabels.recentSearches
        }), jsx("a", {
          className: styles$A.recentSearchResults__clear,
          onClick: handleClearRecentSearchedData,
          children: searchLabels.clear
        })]
      }), jsx("ul", {
        children: renderList(results, searchLabels.recentSearches)
      })]
    })
  });
};
RecentSearchList.propTypes = {
  isAgentLoggedIn: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  results: PropTypes.array,
  tenant: PropTypes.string.isRequired,
  store: PropTypes.string,
  handleClearRecentSearchedData: PropTypes.func.isRequired
};
RecentSearchList.defaultProps = {
  isAgentLoggedIn: false,
  isVendorLoggedIn: false,
  results: [],
  store: null
};
var RecentSearchList$1 = RecentSearchList;

var styles$y = {"search":"Search-module_search__m4Lzt","hasResults":"Search-module_hasResults__XC5L7","storeSearch":"Search-module_storeSearch__eypGr","search--to_com":"Search-module_search--to_com__hzBck","overlay":"Search-module_overlay__vfvU2","header":"Search-module_header__e7Itp","headerText":"Search-module_headerText__OhyH2","modalBody":"Search-module_modalBody__jdlZi","horizontal-menu":"Search-module_horizontal-menu__Kc-PN","imageUpload":"Search-module_imageUpload__u5OoR"};

function useImageSearch(_ref) {
  var isImageSearch = _ref.isImageSearch,
    handleEnter = _ref.handleEnter,
    tenant = _ref.tenant,
    searchByImageEndpoint = _ref.searchByImageEndpoint,
    searchByImageApiKey = _ref.searchByImageApiKey,
    setSearchQuery = _ref.setSearchQuery,
    setIsImageSearch = _ref.setIsImageSearch,
    store = _ref.store;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openImageUploadModal = _useState2[0],
    setOpenImageUploadModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openCamera = _useState4[0],
    setOpenCamera = _useState4[1];
  var abortControllerRef = useRef(null);
  var envBaseUrl = getStandaloneSiteBaseUrl(tenant, store);
  var storeName = STORE_MAP[tenant][store];
  var searchPath = 'noResult';
  var redirectURL = "".concat(envBaseUrl, "/").concat(storeName, "-").concat(tenant, "/").concat(searchPath, "?isImageSearch=true");
  useEffect(function () {
    if (isImageSearch) {
      handleEnter();
    }
  }, [isImageSearch]);
  useEffect(function () {
    if (openCamera || openImageUploadModal) {
      sendSatelliteTrackEvent('image_search_init');
    }
  }, [openCamera, openImageUploadModal]);
  var handleSearchByImageData = useCallback(function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(data) {
      var formData, timeoutId, response, searchTerm, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (data) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return", {
              status: 'error'
            });
          case 1:
            sendSatelliteTrackEvent('image_search');
            if (abortControllerRef.current) {
              abortControllerRef.current.abort();
            }
            abortControllerRef.current = new AbortController();
            formData = new FormData();
            formData.append('country_id', (tenant === null || tenant === void 0 ? void 0 : tenant.toUpperCase()) || 'CL');
            formData.append('image', data);
            timeoutId = setTimeout(function () {
              if (abortControllerRef.current) {
                abortControllerRef.current.abort();
              }
            }, 30000);
            _context.prev = 2;
            _context.next = 3;
            return doPost(searchByImageEndpoint, formData, {
              headers: {
                'X-API-Key': searchByImageApiKey
              },
              signal: abortControllerRef.current.signal
            });
          case 3:
            response = _context.sent;
            if (!(isEmpty(response) || isEmpty(response === null || response === void 0 ? void 0 : response.resultado))) {
              _context.next = 4;
              break;
            }
            updateDigitalDataCookies({
              firstLevelItem: 'No Results',
              tag: SEARCH_BY_IMAGE
            });
            window.location.href = redirectURL;
            return _context.abrupt("return", {
              status: 'success'
            });
          case 4:
            if (!isIpadPotrait()) setOpenImageUploadModal(false);
            searchTerm = response.resultado.join(',');
            setSearchQuery(searchTerm);
            setIsImageSearch(true);
            return _context.abrupt("return", {
              status: 'success'
            });
          case 5:
            _context.prev = 5;
            _t = _context["catch"](2);
            if (!((_t === null || _t === void 0 ? void 0 : _t.name) === 'AbortError')) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", {
              status: 'aborted'
            });
          case 6:
            return _context.abrupt("return", {
              status: 'error'
            });
          case 7:
            _context.prev = 7;
            clearTimeout(timeoutId);
            abortControllerRef.current = null;
            return _context.finish(7);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 5, 7, 8]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [tenant, searchByImageEndpoint, searchByImageApiKey, setOpenCamera, setOpenImageUploadModal, setSearchQuery, setIsImageSearch]);
  var handleModalClose = useCallback(function () {
    setOpenImageUploadModal(false);
  }, [setOpenImageUploadModal]);
  var handleAbort = useCallback(function () {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  }, []);
  return {
    handleSearchByImageData: handleSearchByImageData,
    handleModalClose: handleModalClose,
    openCamera: openCamera,
    setOpenCamera: setOpenCamera,
    openImageUploadModal: openImageUploadModal,
    setOpenImageUploadModal: setOpenImageUploadModal,
    handleAbort: handleAbort
  };
}

function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Search = function Search(_ref) {
  var currentSearchTerm = _ref.currentSearchTerm,
    deviceType = _ref.deviceType,
    getTypeaheadUrl = _ref.getTypeaheadUrl,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isAndes = _ref.isAndes,
    isSisSodimacPdpEnabled = _ref.isSisSodimacPdpEnabled,
    isSearchBarTouched = _ref.isSearchBarTouched,
    setIsSearchBarTouched = _ref.setIsSearchBarTouched,
    isSvsSearch = _ref.isSvsSearch,
    isTypeAheadEnabled = _ref.isTypeAheadEnabled,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    onLoadingStateChange = _ref.onLoadingStateChange,
    onSearch = _ref.onSearch,
    searchbar = _ref.searchbar,
    setHideMenuBar = _ref.setHideMenuBar,
    setSearchInputRef = _ref.setSearchInputRef,
    store = _ref.store,
    searchInSis = _ref.searchInSis,
    isRecentSearchesEnabled = _ref.isRecentSearchesEnabled,
    isSearchSpecialCharactersEnabled = _ref.isSearchSpecialCharactersEnabled,
    isSearchByImageEnable = _ref.isSearchByImageEnable,
    isCameraCoachmarkVisible = _ref.isCameraCoachmarkVisible,
    searchByImageEndpoint = _ref.searchByImageEndpoint,
    searchByImageApiKey = _ref.searchByImageApiKey,
    classes = _ref.classes;
  var _useContext = useContext(AppContext$1),
    tenant = _useContext.tenant;
  var _getStandaloneSite = getStandaloneSite(store),
    isTottusStandAloneSite = _getStandaloneSite.isTottusStandAloneSite,
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone;
  var initialState = {
    cursor: 0,
    results: {}
  };
  var initialRender = useRef(true);
  var searchContainerRef = useRef();
  var overlayRef = useRef();
  var _useState = useState(isSvsSearch ? '' : currentSearchTerm),
    _useState2 = _slicedToArray(_useState, 2),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    activeAnchorRef = _useState4[0],
    setActiveAnchorRef = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    recentSearchedData = _useState6[0],
    setRecentSearchedData = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isImageSearch = _useState8[0],
    setIsImageSearch = _useState8[1];
  var headerHeight = getHeaderHeight({
    isVendorLoggedIn: isVendorLoggedIn,
    isAgentLoggedIn: isAgentLoggedIn
  });
  var totalVisibleHeight = headerHeight.totalVisibleHeight;
  var _useState9 = useState((headerHeight === null || headerHeight === void 0 ? void 0 : headerHeight.totalVisibleHeight) || 0),
    _useState0 = _slicedToArray(_useState9, 2),
    totalHeight = _useState0[0],
    setTotalHeight = _useState0[1];
  useEffect(function () {
    setTotalHeight(totalVisibleHeight);
  }, [totalVisibleHeight]);
  var handleSearchByImageSateliteData = function handleSearchByImageSateliteData(data) {
    saveSearchByImageMetrics(data);
    sendSatelliteTrackEvent('ciam_error');
  };
  useEffect(function () {
    if (isRecentSearchesEnabled && isSearchBarTouched && !searchQuery) {
      setRecentSearchedData(getRecentSearchedValues(store, tenant, deviceType));
    }
    if (searchQuery) {
      setRecentSearchedData([]);
    }
    if (!isRecentSearchesEnabled) {
      destroyAllRecentSearchedValues(tenant);
    }
  }, [isSearchBarTouched, searchQuery]);
  var handleClearRecentSearchedData = function handleClearRecentSearchedData() {
    setRecentSearchedData([]);
    clearRecentSearchedValues(store, tenant);
  };
  useEffect(function () {
    setSearchQuery(isSvsSearch ? '' : currentSearchTerm);
  }, [currentSearchTerm]);
  var reducer = useReducer(function (state, action) {
    switch (action.type) {
      case 'RESULTS':
        return _objectSpread$c(_objectSpread$c({}, state), {}, {
          cursor: 0,
          results: action.payload
        });
      case 'NEXT':
        return _objectSpread$c(_objectSpread$c({}, state), {}, {
          cursor: (state.cursor + 1) % state.results.totalSuggestionsCount
        });
      case 'PREV':
        return _objectSpread$c(_objectSpread$c({}, state), {}, {
          cursor: (state.cursor - 1 + state.results.totalSuggestionsCount) % state.results.totalSuggestionsCount
        });
      case 'SET_CURSOR':
        return _objectSpread$c(_objectSpread$c({}, state), {}, {
          cursor: action.payload
        });
      default:
        throw new Error();
    }
  }, initialState);
  var _reducer = _slicedToArray(reducer, 2),
    state = _reducer[0],
    dispatch = _reducer[1];
  var lastPromise = useRef(null);
  var handleEnter = function handleEnter() {
    var newSearchTerm = processSearchQuery(searchQuery, isSearchSpecialCharactersEnabled, {
      isTottusStandalone: isTottusStandalone,
      isSodimacStandalone: isSodimacStandalone
    });
    if (newSearchTerm.length === 0 || newSearchTerm.length < minQueryLength) {
      return;
    }
    window.dispatchEvent(new CustomEvent('search_executed', {
      bubbles: true,
      detail: {}
    }));
    if (activeAnchorRef && activeAnchorRef.current) {
      activeAnchorRef.current.click();
    } else if (searchQuery) {
      onSearch(newSearchTerm, isImageSearch);
      setSearchQuery(newSearchTerm);
      if (lastPromise.current) {
        lastPromise.current.cancel();
      }
      dispatch({
        type: 'RESULTS',
        payload: {}
      });
      if (!isImageSearch) {
        setRecentSearchedValues({
          text: "<b>".concat(newSearchTerm, "</b>"),
          url: "/".concat(storeMap[tenant][store] || 'falabella', "-").concat(tenant, "/").concat(SEARCH_PATH[store] || 'search', "?Ntt=").concat(newSearchTerm)
        }, store, tenant);
      }
    }
  };
  var handleOnKeyDown = function handleOnKeyDown(e) {
    switch (e.key) {
      case 'ArrowDown':
        dispatch({
          type: 'NEXT'
        });
        break;
      case 'ArrowUp':
        dispatch({
          type: 'PREV'
        });
        break;
      case 'Enter':
        handleEnter();
        break;
    }
  };
  var handleSearchBarChange = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(val) {
      var validate;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isTypeAheadEnabled) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return", true);
          case 1:
            validate = function validate(v) {
              return v.trim && v.trim() && v.trim().length >= minQueryLengthForSuggestion && v.trim().length <= maxQueryLengthForSuggestion;
            };
            if (!(!val || !validate(val))) {
              _context.next = 2;
              break;
            }
            dispatch({
              type: 'RESULTS',
              payload: {}
            });
            return _context.abrupt("return", true);
          case 2:
            if (lastPromise.current) {
              lastPromise.current.cancel();
            }
            lastPromise.current = new CancelablePromise$1(doFetch(getTypeaheadUrl(val, tenant, isAndes, store)));
            lastPromise.current.start().then(function (data) {
              var results = val && data ? SearchHelper$1(data, deviceType) : {};
              dispatch({
                type: 'RESULTS',
                payload: results
              });
            })["catch"](noop$2);
            return _context.abrupt("return", true);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSearchBarChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      handleSearchBarChange(searchQuery);
    }
  }, [searchInSis]);
  var handleOuterClick = function handleOuterClick(e) {
    function clearResults() {
      dispatch({
        type: 'RESULTS',
        payload: {}
      });
    }
    var overlayNode = overlayRef === null || overlayRef === void 0 ? void 0 : overlayRef.current;
    var isOverlayClick = overlayNode && overlayNode.contains(e.target);
    var searchContainerNode = searchContainerRef === null || searchContainerRef === void 0 ? void 0 : searchContainerRef.current;
    var isSearchContainerClick = searchContainerNode.contains(e.target);
    if (isSearchContainerClick) {
      if (isOverlayClick) {
        clearResults();
        setRecentSearchedData([]);
      }
    } else {
      clearResults();
      setRecentSearchedData([]);
    }
  };
  var onSelect = function onSelect() {
    onLoadingStateChange(true);
    dispatch({
      type: 'RESULTS',
      payload: {}
    });
  };
  useEffect(function () {
    document.addEventListener('mousedown', handleOuterClick);
    return function () {
      document.removeEventListener('mousedown', handleOuterClick);
    };
  }, []);
  var handleMouseOver = function handleMouseOver(cursor) {
    dispatch({
      type: 'SET_CURSOR',
      payload: cursor
    });
  };
  var hasSearchResults = !!Object.keys(state.results).length;
  useEffect(function () {
    setHideMenuBar(hasSearchResults || !!recentSearchedData.length);
    toggleBodyClass(hasSearchResults || !!recentSearchedData.length, 'no-scroll-typeaheadOn');
  }, [hasSearchResults, recentSearchedData.length]);
  var _useImageSearch = useImageSearch({
      isImageSearch: isImageSearch,
      handleEnter: handleEnter,
      tenant: tenant,
      searchByImageEndpoint: searchByImageEndpoint,
      searchByImageApiKey: searchByImageApiKey,
      setSearchQuery: setSearchQuery,
      setIsImageSearch: setIsImageSearch,
      store: store
    }),
    handleSearchByImageData = _useImageSearch.handleSearchByImageData,
    handleModalClose = _useImageSearch.handleModalClose,
    openCamera = _useImageSearch.openCamera,
    setOpenCamera = _useImageSearch.setOpenCamera,
    openImageUploadModal = _useImageSearch.openImageUploadModal,
    setOpenImageUploadModal = _useImageSearch.setOpenImageUploadModal,
    handleAbort = _useImageSearch.handleAbort;
  return jsxs("div", {
    role: "button",
    tabIndex: "0",
    ref: searchContainerRef,
    className: classNames(styles$y.search, _defineProperty(_defineProperty({}, styles$y['search--to_com'], isTottusStandAloneSite), styles$y.storeSearch, store), classes),
    onKeyDown: handleOnKeyDown,
    id: "testId-search-wrapper",
    children: [(hasSearchResults || recentSearchedData.length > 0) && jsx("div", {
      className: styles$y.overlay,
      ref: overlayRef
    }), jsx(SearchBar, {
      deviceType: deviceType,
      handleEnter: handleEnter,
      isFocused: state.cursor === 0,
      isTypeAheadActive: hasSearchResults || recentSearchedData.length > 0,
      isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
      labels: searchLabels,
      minQueryLength: minQueryLengthForSuggestion,
      onSearch: onSearch,
      onSearchBarChange: handleSearchBarChange,
      searchbar: searchbar,
      searchQuery: searchQuery,
      setSearchInputRef: setSearchInputRef,
      setSearchQuery: setSearchQuery,
      setIsSearchBarTouched: setIsSearchBarTouched,
      searchInSis: searchInSis,
      store: store,
      tenant: tenant,
      isSearchByImageEnable: isSearchByImageEnable,
      setIsImageSearch: setIsImageSearch,
      isCameraCoachmarkVisible: isCameraCoachmarkVisible,
      setOpenImageUploadModal: setOpenImageUploadModal,
      handleSearchByImageData: handleSearchByImageData,
      openCamera: openCamera,
      setOpenCamera: setOpenCamera,
      handleAbort: handleAbort,
      handleSearchByImageSateliteData: handleSearchByImageSateliteData
    }), isSodimacStandalone && deviceType === deviceTypes.DESKTOP && openImageUploadModal ? jsx("div", {
      className: styles$y.imageUpload,
      children: jsx(SearchByImage, {
        title: "Buscar por imagen",
        contentText: "Sube una imagen en formato JPG o PNG.",
        correspondingText: "Verifica que la imagen est\xE9 enfocada y corresponda al producto.",
        sizeErrorText: "El tama\xF1o de la imagen supera los 20 MB.",
        typeErrorText: "La imagen debe estar en formato JPG o PNG.",
        unExpectedErrorText: "Ocurri\xF3 un error, por favor intenta nuevamente.",
        uploadText1: 'Arrastra una imagen o ',
        uploadText2: "sube un archivo.",
        uploadText3: "Tama\xF1o m\xE1ximo de 20 MB.",
        primaryButtonText: "Buscar productos",
        secondaryButtonText: "Volver",
        handleSearchByImageData: handleSearchByImageData,
        closeModal: handleModalClose,
        isMobile: false,
        spinnerData: spinnerData,
        updateSateliteTrack: handleSearchByImageSateliteData
      })
    }) : null, hasSearchResults && jsx(SearchList$1, {
      cursor: state.cursor,
      isAgentLoggedIn: isAgentLoggedIn,
      isVendorLoggedIn: isVendorLoggedIn,
      onFocus: handleMouseOver,
      onMouseOver: handleMouseOver,
      onSelect: onSelect,
      results: state.results,
      deviceType: deviceType,
      setActiveAnchorRef: setActiveAnchorRef,
      tenant: tenant,
      store: store,
      searchInSis: searchInSis,
      searchQuery: searchQuery,
      setSearchQuery: setSearchQuery
    }), !hasSearchResults && recentSearchedData.length > 0 && jsx(RecentSearchList$1, {
      cursor: state.cursor,
      isAgentLoggedIn: isAgentLoggedIn,
      isVendorLoggedIn: isVendorLoggedIn,
      onMouseOver: handleMouseOver,
      results: recentSearchedData,
      tenant: tenant,
      store: store,
      handleClearRecentSearchedData: handleClearRecentSearchedData
    }), jsx("style", {
      children: "\n          .no-scroll-typeaheadOn {\n            overflow: hidden;\n          }\n        "
    }), isSodimacStandalone && openImageUploadModal && deviceType === deviceTypes.DESKTOP && jsx(MarketplaceOverlay$1, {
      backdropPosition: {
        top: "".concat(totalHeight, "px")
      }
    })]
  });
};
Search.propTypes = {
  currentSearchTerm: PropTypes.string,
  deviceType: PropTypes.string.isRequired,
  getTypeaheadUrl: PropTypes.func.isRequired,
  isAgentLoggedIn: PropTypes.bool,
  isAndes: PropTypes.bool,
  isSisSodimacPdpEnabled: PropTypes.bool,
  isSvsSearch: PropTypes.bool,
  isTypeAheadEnabled: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  onLoadingStateChange: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
  searchbar: PropTypes.object.isRequired,
  setHideMenuBar: PropTypes.func,
  setSearchInputRef: PropTypes.func.isRequired,
  store: PropTypes.string,
  searchInSis: PropTypes.bool,
  setIsSearchBarTouched: PropTypes.func,
  isSearchBarTouched: PropTypes.bool,
  isSISExperience: PropTypes.bool,
  isRecentSearchesEnabled: PropTypes.bool.isRequired,
  isSearchSpecialCharactersEnabled: PropTypes.bool,
  searchByImageApiKey: PropTypes.object,
  isCameraCoachmarkVisible: PropTypes.bool,
  searchByImageEndpoint: PropTypes.string,
  classes: PropTypes.arrayOf(PropTypes.string)
};
Search.defaultProps = {
  currentSearchTerm: '',
  isAgentLoggedIn: false,
  isSisSodimacPdpEnabled: false,
  isSvsSearch: false,
  isTypeAheadEnabled: true,
  isVendorLoggedIn: false,
  onLoadingStateChange: noop$2,
  setHideMenuBar: noop$2,
  store: null,
  searchInSis: false,
  isSearchBarTouched: false,
  setIsSearchBarTouched: noop$2,
  isSISExperience: false,
  isSearchSpecialCharactersEnabled: false,
  searchByImageApiKey: {},
  isCameraCoachmarkVisible: false,
  searchByImageEndpoint: '',
  classes: []
};
Search.defaultProps = {};
var Search$1 = Search;

var styles$x = {"popover-container":"Popover-module_popover-container__shbez","bottom":"Popover-module_bottom__vf8Uo","popover":"Popover-module_popover__qUizo","bottom-caret-center":"Popover-module_bottom-caret-center__mXznG","bottom-caret-login":"Popover-module_bottom-caret-login__4a-90","bottom-caret-login-cmr":"Popover-module_bottom-caret-login-cmr__rXhx-","bottom-caret-notlogin":"Popover-module_bottom-caret-notlogin__RMJrF","left":"Popover-module_left__ub-Bl","compact":"Popover-module_compact__TsGjt","bottom-caret-stores-links":"Popover-module_bottom-caret-stores-links__DQyA3","bottom-caret-links":"Popover-module_bottom-caret-links__7kTTL","medium":"Popover-module_medium__KLPAH","wide":"Popover-module_wide__4HJgd","minimal":"Popover-module_minimal__TjyBj","doc-click-overlay":"Popover-module_doc-click-overlay__uJwDE","doc-click-overlay-relative":"Popover-module_doc-click-overlay-relative__zkuyP"};

function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var WithToggle = function WithToggle(WrappedComponent) {
  var ComponentWithToggle = function ComponentWithToggle(props) {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      toggle = _useState2[0],
      setToggle = _useState2[1];
    var toggleState = {
      visible: toggle,
      setVisible: function setVisible(bool) {
        return setToggle(bool);
      }
    };
    return jsx(WrappedComponent, _objectSpread$b(_objectSpread$b({}, props), {}, {
      toggleState: toggleState
    }));
  };
  ComponentWithToggle.originalName = 'WrappedComponent';
  ComponentWithToggle.displayName = 'WithToggle';
  return ComponentWithToggle;
};
var WithToggle$1 = WithToggle;

function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var WithTimeout = function WithTimeout(WrappedComponent, milliseconds) {
  var ComponentWithTimeout = function ComponentWithTimeout(props) {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      toggle = _useState2[0],
      setToggle = _useState2[1];
    useEffect(function () {
      var timer = setTimeout(function () {
        return setToggle(false);
      }, milliseconds);
      return function () {
        clearTimeout(timer);
      };
    }, [toggle]);
    return jsx(WrappedComponent, _objectSpread$a(_objectSpread$a({}, props), {}, {
      timer: {
        toggle: toggle,
        setToggle: setToggle
      }
    }));
  };
  return ComponentWithTimeout;
};
var WithTimeout$1 = WithTimeout;

var TIMEOUT_MS = 5000;
var Popover = function Popover(_ref) {
  var children = _ref.children,
    content = _ref.content,
    trigger = _ref.trigger,
    toggleState = _ref.toggleState,
    timer = _ref.timer,
    type = _ref.type,
    position = _ref.position,
    dismissOnOutsideClick = _ref.dismissOnOutsideClick,
    enableParentClick = _ref.enableParentClick,
    customClassForPopup = _ref.customClassForPopup,
    hasRelativePosition = _ref.hasRelativePosition,
    backdropPosition = _ref.backdropPosition,
    onHoverStyle = _ref.onHoverStyle,
    setMenuVisible = _ref.setMenuVisible;
  var visible = toggleState.visible,
    setVisible = toggleState.setVisible;
  var triggerPopoverHandler = function triggerPopoverHandler(eventType) {
    if (eventType === trigger) {
      setVisible(true);
      if (setMenuVisible && typeof setMenuVisible === 'function') {
        setMenuVisible(false);
      }
      timer.setToggle(true);
    }
  };
  var dismissHandler = function dismissHandler() {
    setVisible(false);
    timer.setToggle(false);
  };
  var popoverContent = function popoverContent(dismiss) {
    if (typeof content === 'function') {
      return content(dismiss);
    }
    return content;
  };
  var renderChildren = function renderChildren() {
    return React.Children.map(children, function (child) {
      return React.cloneElement(child);
    });
  };
  return jsxs(WithOutsideClick$1, {
    onOutsideClick: function onOutsideClick() {
      if (dismissOnOutsideClick) {
        dismissHandler();
      }
    },
    styles: {
      'doc-click-overlay': styles$x['doc-click-overlay'],
      'doc-click-overlay-relative': styles$x['doc-click-overlay-relative']
    },
    className: hasRelativePosition ? 'doc-click-overlay-relative' : '',
    children: [!enableParentClick && jsx("div", {
      className: classNames(_defineProperty({}, onHoverStyle, visible && timer.toggle)),
      children: children
    }), jsxs("div", {
      className: classNames(styles$x['popover-container'], styles$x["".concat(position)]),
      onKeyPress: noop$2,
      onClick: function onClick() {
        return triggerPopoverHandler('click');
      },
      onMouseEnter: function onMouseEnter() {
        return triggerPopoverHandler('hover');
      },
      onMouseLeave: function onMouseLeave() {
        return trigger === 'hover' && dismissHandler();
      },
      role: "menuitem",
      tabIndex: "0",
      children: [enableParentClick && renderChildren(), visible && timer.toggle && jsx("div", {
        className: classNames(styles$x.popover, styles$x["".concat(type)], customClassForPopup),
        children: popoverContent(dismissHandler)
      })]
    }), visible && timer.toggle && backdropPosition && jsx(MarketplaceOverlay$1, {
      backdropPosition: backdropPosition
    })]
  });
};
Popover.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  trigger: PropTypes.oneOf(['click', 'hover']),
  toggleState: PropTypes.object,
  timer: PropTypes.object,
  customClassForPopup: PropTypes.string,
  backdropPosition: PropTypes.object,
  type: PropTypes.oneOf(['default', 'compact', 'wide', 'medium']),
  position: PropTypes.oneOf(['bottom', 'right', 'bottom-caret-center', 'bottom-caret-login', 'bottom-caret-login-cmr', 'bottom-caret-notlogin', 'bottom-caret-stores-links', 'bottom-caret-links']),
  dismissOnOutsideClick: PropTypes.bool,
  enableParentClick: PropTypes.bool,
  onHoverStyle: PropTypes.string,
  hasRelativePosition: PropTypes.bool,
  setMenuVisible: PropTypes.func
};
Popover.defaultProps = {
  trigger: 'click',
  position: 'bottom',
  toggleState: null,
  timer: {
    setToggle: noop$2,
    toggle: true
  },
  type: 'default',
  customClassForPopup: '',
  backdropPosition: null,
  onHoverStyle: null,
  dismissOnOutsideClick: false,
  enableParentClick: false,
  hasRelativePosition: false
};
var PopoverWithToggle = WithToggle$1(Popover);
WithTimeout$1(PopoverWithToggle, TIMEOUT_MS);

var sisLinksIconData = {
  sodimac: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc77ca5e020314ff2/sodimac-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4c09611b59cb4ab4/sodimac_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt1bcf6f9731bb8aa5/sodimac_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc77ca5e020314ff2/sodimac-disabled.svg'
      }
    }
  },
  linio: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7ade53c9276480f9/linio-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt94ad9b607e6962c1/linio_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt65a907f9e974c0ca/linio_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7ade53c9276480f9/linio-disabled.svg'
      }
    }
  },
  tottus: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf096c948d3597c60/tottus-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt80cbc2d0aedde9ba/tottus_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4006f183a66e4b6e/tottus_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf096c948d3597c60/tottus-disabled.svg'
      }
    }
  },
  homecenter: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt55f993da75fa018d/homecenter-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4c09611b59cb4ab4/sodimac_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt1bcf6f9731bb8aa5/sodimac_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt55f993da75fa018d/homecenter-disabled.svg'
      }
    }
  },
  marketplace: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt422ee1291fbab2a2/marketplace-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt0ec8e7392f212ae9/main_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3d85d8338375406b/65562af1647c280cbd4e9275/main_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt422ee1291fbab2a2/marketplace-disabled.svg'
      }
    }
  }
};

var styles$w = {"container":"NavbarLinks-module_container__Kev9T","content-wrapper":"NavbarLinks-module_content-wrapper__-VOIL","content-wrapper-stores":"NavbarLinks-module_content-wrapper-stores__A4qrD","last-dropdown":"NavbarLinks-module_last-dropdown__nlE19","nav-link--so_com":"NavbarLinks-module_nav-link--so_com__avlAb","last-nav-link":"NavbarLinks-module_last-nav-link__UOtOL","onboarding-highlight":"NavbarLinks-module_onboarding-highlight__0X0rf","stores-wrapper":"NavbarLinks-module_stores-wrapper__m9k8W","stores-list-container":"NavbarLinks-module_stores-list-container__1T2Ym","display-none":"NavbarLinks-module_display-none__cOrRF","ours-stores-label":"NavbarLinks-module_ours-stores-label__R6th1","store-icon-wrapper":"NavbarLinks-module_store-icon-wrapper__t8r0q","last-store-icon":"NavbarLinks-module_last-store-icon__ZfYTc","stores-icon":"NavbarLinks-module_stores-icon__AEhdg","down-arrow":"NavbarLinks-module_down-arrow__iWtpH","has-dropdown":"NavbarLinks-module_has-dropdown__DjpVW","links-list-container":"NavbarLinks-module_links-list-container__XWlAw","links-dropdown":"NavbarLinks-module_links-dropdown__I67vu","links-style":"NavbarLinks-module_links-style__wOtMK","popover-on-hover":"NavbarLinks-module_popover-on-hover__uf61e","width-store-4":"NavbarLinks-module_width-store-4__eX6cW","width-store-3":"NavbarLinks-module_width-store-3__BI62x","stores-list-container-sis-new":"NavbarLinks-module_stores-list-container-sis-new__qbTvj","storeHighlightAnimation":"NavbarLinks-module_storeHighlightAnimation__bom7r"};

function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getHeaderBottom = function getHeaderBottom() {
  if (!isWindow$1()) return 0;
  var header = document.querySelector('header');
  if (!header) return 0;
  var _header$getBoundingCl = header.getBoundingClientRect(),
    bottom = _header$getBoundingCl.bottom;
  return Math.max(0, bottom);
};
var snapToDevicePixel = function snapToDevicePixel(value) {
  if (!isWindow$1()) return value;
  var dpr = window.devicePixelRatio || 1;
  return Math.round(value * dpr) / dpr;
};
var getOverlayTopPx = function getOverlayTopPx() {
  return "".concat(snapToDevicePixel(getHeaderBottom()), "px");
};
var contentMaker = function contentMaker(_ref) {
  var _ref$dropdownItem = _ref.dropdownItem,
    dropdownItem = _ref$dropdownItem === void 0 ? [] : _ref$dropdownItem,
    _ref$isStoresContent = _ref.isStoresContent,
    isStoresContent = _ref$isStoresContent === void 0 ? false : _ref$isStoresContent,
    _ref$lastItemStyle = _ref.lastItemStyle,
    lastItemStyle = _ref$lastItemStyle === void 0 ? false : _ref$lastItemStyle,
    index = _ref.index;
  return jsx("div", {
    className: isStoresContent ? styles$w['content-wrapper-stores'] : styles$w['content-wrapper'],
    children: dropdownItem.map(function (_ref2, i) {
      var _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title,
        is_new_tab = _ref2.is_new_tab,
        url = _ref2.url;
      return jsx("a", {
        id: "testId-bottom-header-links-".concat(index, "-").concat(i),
        className: lastItemStyle ? styles$w['last-dropdown'] : '',
        href: url,
        target: is_new_tab ? '_blank' : '',
        rel: "noreferrer",
        onClick: function onClick() {
          return updateDigitalDataCookies({
            firstLevelItem: "N2 - ".concat(title),
            tag: HEADER
          });
        },
        children: title
      }, title);
    })
  });
};
var Stores = function Stores(_ref3) {
  var storeList = _ref3.storeList,
    title = _ref3.title,
    isOnboardingInProgress = _ref3.isOnboardingInProgress,
    isNewNavigation = _ref3.isNewNavigation,
    deviceType = _ref3.deviceType,
    _ref3$currentPage = _ref3.currentPage,
    currentPage = _ref3$currentPage === void 0 ? '' : _ref3$currentPage;
  return jsxs("div", {
    className: "".concat(styles$w['stores-list-container'], " ").concat(isNewNavigation ? styles$w['stores-list-container-sis-new'] : null),
    children: [!isNewNavigation && title && jsx("p", {
      className: styles$w['ours-stores-label'],
      children: title
    }), jsx("div", {
      className: "".concat(styles$w['stores-wrapper'], " ").concat(isOnboardingInProgress ? styles$w['onboarding-highlight'] : null),
      children: storeList.map(function (store, i) {
        var _store$dropdown_items, _store$icon$title, _store$icon6;
        var dropdownItem = (_store$dropdown_items = store === null || store === void 0 ? void 0 : store.dropdown_items) !== null && _store$dropdown_items !== void 0 ? _store$dropdown_items : [];
        var isNotAllStores = storeList.length <= 4;
        if (dropdownItem.length) {
          var _store$icon$url, _store$icon;
          return jsx(PopoverWithToggle, {
            trigger: "hover",
            position: "bottom-caret-stores-links",
            hasRelativePosition: true,
            backdropPosition: {
              top: getOverlayTopPx()
            },
            content: contentMaker({
              dropdownItem: dropdownItem,
              isStoresContent: true,
              index: i
            }),
            children: jsxs("div", {
              className: "".concat(styles$w['store-icon-wrapper'], " ").concat(i === storeList.stores.length - 1 && styles$w['last-store-icon'], " "),
              children: [jsx("div", {
                style: {
                  backgroundImage: "url(".concat((_store$icon$url = store === null || store === void 0 || (_store$icon = store.icon) === null || _store$icon === void 0 ? void 0 : _store$icon.url) !== null && _store$icon$url !== void 0 ? _store$icon$url : '', ")")
                },
                className: "".concat(styles$w['stores-icon'], " ").concat(styles$w['has-dropdown'])
              }), jsx("div", {
                className: styles$w['down-arrow']
              })]
            }, "stores-list-".concat(i))
          }, "store-".concat(i));
        }
        var getStoreName = function getStoreName() {
          var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          var storeMatch = matchStoreName(text);
          if (storeMatch) {
            return SIS_STORE_MAP[storeMatch];
          }
          return 'marketplace';
        };
        var isActivePage = function isActivePage(url) {
          return getStoreName(url).toLowerCase() === currentPage.toLocaleLowerCase();
        };
        var addDataStoreAttr = function addDataStoreAttr() {
          return isNewNavigation && {
            'data-page-active': isActivePage(store.url.href)
          };
        };
        var setBackgroundImageUrl = function setBackgroundImageUrl() {
          var _store$icon$url2, _store$icon2, _store$url$href, _store$url;
          if (!isNewNavigation) return (_store$icon$url2 = store === null || store === void 0 || (_store$icon2 = store.icon) === null || _store$icon2 === void 0 ? void 0 : _store$icon2.url) !== null && _store$icon$url2 !== void 0 ? _store$icon$url2 : '';
          var storeUrl = (_store$url$href = store === null || store === void 0 || (_store$url = store.url) === null || _store$url === void 0 ? void 0 : _store$url.href) !== null && _store$url$href !== void 0 ? _store$url$href : '';
          var isActive = isActivePage(storeUrl);
          var storeName = getStoreName(storeUrl).toLocaleLowerCase();
          var _ref4 = sisLinksIconData[storeName] && isActive ? sisLinksIconData[storeName].icons[deviceType] : sisLinksIconData[storeName].icons[deviceType],
            enabled = _ref4.enabled,
            disabled = _ref4.disabled;
          if ((isActive || !isActive) && currentPage === 'marketplace') {
            var _store$icon$url3, _store$icon3;
            return deviceType !== 'mobile' ? (_store$icon$url3 = store === null || store === void 0 || (_store$icon3 = store.icon) === null || _store$icon3 === void 0 ? void 0 : _store$icon3.url) !== null && _store$icon$url3 !== void 0 ? _store$icon$url3 : '' : enabled;
          }
          if (isActive) {
            var _store$icon$url4, _store$icon4;
            return isActive && deviceType !== 'mobile' ? (_store$icon$url4 = store === null || store === void 0 || (_store$icon4 = store.icon) === null || _store$icon4 === void 0 ? void 0 : _store$icon4.url) !== null && _store$icon$url4 !== void 0 ? _store$icon$url4 : '' : enabled;
          }
          return disabled;
        };
        var getBackgroundImage = function getBackgroundImage() {
          var _store$icon$url5, _store$icon5;
          return isNewNavigation ? "url(".concat(setBackgroundImageUrl(), ")") : "url(".concat((_store$icon$url5 = store === null || store === void 0 || (_store$icon5 = store.icon) === null || _store$icon5 === void 0 ? void 0 : _store$icon5.url) !== null && _store$icon$url5 !== void 0 ? _store$icon$url5 : '', ")");
        };
        return jsx("div", _objectSpread$9(_objectSpread$9({
          className: "".concat(styles$w['store-icon-wrapper'], " ").concat(i === storeList.length - 1 && styles$w['last-store-icon'], " ").concat(isNotAllStores && isNewNavigation && styles$w["width-store-".concat(storeList.length)], " ")
        }, addDataStoreAttr()), {}, {
          children: jsx("a", {
            id: "testId-store-links-".concat(i),
            href: store.url.href,
            target: store.is_new_tab ? '_blank' : '',
            rel: "noreferrer",
            onClick: function onClick() {
              return updateDigitalDataCookies({
                firstLevelItem: "N".concat(isNewNavigation ? '0' : '2', " - Store ").concat(getStoreName(store.url.href)),
                tag: HEADER
              });
            },
            children: jsx("div", {
              style: {
                backgroundImage: getBackgroundImage(),
                width: "".concat(!isNewNavigation && getWidthForStoreIcon((_store$icon$title = store === null || store === void 0 || (_store$icon6 = store.icon) === null || _store$icon6 === void 0 ? void 0 : _store$icon6.title) !== null && _store$icon$title !== void 0 ? _store$icon$title : ''), "px")
              },
              className: "".concat(styles$w['stores-icon'])
            })
          })
        }), "stores-list-".concat(i));
      })
    })]
  });
};
Stores.propTypes = {
  storeList: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  isNewNavigation: PropTypes.bool,
  headerHeight: PropTypes.object
};
var AdditonalLinks = function AdditonalLinks(_ref5) {
  var links = _ref5.links;
    _ref5.topPosition;
    var store = _ref5.store;
  return jsx("div", {
    className: styles$w['links-list-container'],
    children: links.map(function (_ref6, i) {
      var _ref6$title = _ref6.title,
        title = _ref6$title === void 0 ? '' : _ref6$title,
        _ref6$url = _ref6.url,
        url = _ref6$url === void 0 ? '' : _ref6$url,
        _ref6$is_new_tab = _ref6.is_new_tab,
        is_new_tab = _ref6$is_new_tab === void 0 ? false : _ref6$is_new_tab,
        _ref6$last_item_style = _ref6.last_item_style,
        last_item_style = _ref6$last_item_style === void 0 ? false : _ref6$last_item_style,
        _ref6$dropdown_items = _ref6.dropdown_items,
        dropdown_items = _ref6$dropdown_items === void 0 ? [] : _ref6$dropdown_items;
      if (dropdown_items.length) {
        return jsx(PopoverWithToggle, {
          trigger: "hover",
          position: "bottom-caret-links",
          hasRelativePosition: true,
          onHoverStyle: styles$w['popover-on-hover'],
          customClassForPopup: classNames(_defineProperty(_defineProperty({}, styles$w['nav-link--so_com'], getStandaloneSite(store).isSodimacStandalone), styles$w['last-nav-link'], i === links.length - 1)),
          backdropPosition: {
            top: getOverlayTopPx()
          },
          content: contentMaker({
            dropdownItem: dropdown_items,
            lastItemStyle: last_item_style,
            index: i
          }),
          children: jsxs("div", {
            id: "testId-extra-links-dropdown-".concat(i),
            className: styles$w['links-dropdown'],
            children: [jsx("div", {
              children: title
            }), jsx("div", {
              className: styles$w['down-arrow']
            })]
          }, "links-list-".concat(i))
        }, title);
      }
      return jsx("a", {
        id: "testId-extra-links-".concat(i),
        className: styles$w['links-style'],
        href: url,
        target: is_new_tab ? '_blank' : '',
        rel: "noreferrer",
        onClick: function onClick() {
          return updateDigitalDataCookies({
            firstLevelItem: "N2 - ".concat(title),
            tag: HEADER
          });
        },
        children: title
      }, title);
    })
  });
};
AdditonalLinks.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
  topPosition: PropTypes.number.isRequired,
  store: PropTypes.string
};
var StoresAndLinks = function StoresAndLinks(_ref7) {
  var ourStores = _ref7.ourStores,
    additonalLinks = _ref7.additonalLinks,
    isOnboardingInProgress = _ref7.isOnboardingInProgress,
    isVendorLoggedIn = _ref7.isVendorLoggedIn,
    isAgentLoggedIn = _ref7.isAgentLoggedIn,
    isNewNavigation = _ref7.isNewNavigation,
    currentPage = _ref7.currentPage,
    deviceType = _ref7.deviceType,
    isStoreVisible = _ref7.isStoreVisible,
    store = _ref7.store;
  var headerHeight = getHeaderHeight({
    isVendorLoggedIn: isVendorLoggedIn,
    isAgentLoggedIn: isAgentLoggedIn
  });
  return jsxs("div", {
    className: styles$w.container,
    children: [ourStores.length >= 1 && isStoreVisible ? jsx(Stores, {
      isOnboardingInProgress: isOnboardingInProgress,
      storeList: ourStores,
      title: ourStores.title,
      isNewNavigation: isNewNavigation,
      deviceType: deviceType,
      currentPage: currentPage,
      headerHeight: headerHeight
    }) : null, additonalLinks.length ? jsx(AdditonalLinks, {
      topPosition: headerHeight.totalVisibleHeight,
      links: additonalLinks,
      store: store
    }) : null]
  });
};
StoresAndLinks.propTypes = {
  ourStores: PropTypes.arrayOf(PropTypes.object),
  additonalLinks: PropTypes.arrayOf(PropTypes.object),
  isOnboardingInProgress: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isNewNavigation: PropTypes.bool,
  currentPage: PropTypes.string,
  deviceType: PropTypes.string,
  isStoreVisible: PropTypes.bool,
  store: PropTypes.string
};
StoresAndLinks.defaultProps = {
  ourStores: [],
  additonalLinks: [],
  isOnboardingInProgress: false,
  isVendorLoggedIn: false,
  isAgentLoggedIn: false,
  isNewNavigation: false,
  currentPage: '',
  isStoreVisible: true
};
var NavbarLinks = StoresAndLinks;

var styles$v = {"container":"SISLinks-module_container__XM-J0"};

var SISLinks = function SISLinks(_ref) {
  var stores = _ref.stores,
    storeName = _ref.storeName,
    deviceType = _ref.deviceType,
    isOnboardingEnabled = _ref.isOnboardingEnabled,
    currentStep = _ref.currentStep,
    isOnboardingDisabledCookie = _ref.isOnboardingDisabledCookie,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn;
  return jsx("div", {
    id: "header-sis-links",
    className: classNames(styles$v.container),
    children: jsx(MatchMedia$1, {
      deviceType: deviceType,
      content: {
        desktop: function desktop() {
          return jsx(NavbarLinks, {
            ourStores: stores,
            isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 0,
            additonalLinks: [],
            isAgentLoggedIn: isAgentLoggedIn,
            isVendorLoggedIn: isVendorLoggedIn,
            isNewNavigation: true,
            currentPage: storeName === '' ? 'marketplace' : storeName,
            deviceType: deviceType
          });
        },
        mobile: function mobile() {
          return jsx(NavbarLinks, {
            ourStores: stores,
            isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 0,
            additonalLinks: [],
            isAgentLoggedIn: isAgentLoggedIn,
            isVendorLoggedIn: isVendorLoggedIn,
            isNewNavigation: true,
            currentPage: storeName === '' ? 'marketplace' : storeName,
            deviceType: deviceType
          });
        },
        tablet: function tablet() {
          return jsx(NavbarLinks, {
            ourStores: stores,
            isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 0,
            additonalLinks: [],
            isAgentLoggedIn: isAgentLoggedIn,
            isVendorLoggedIn: isVendorLoggedIn,
            isNewNavigation: true,
            currentPage: storeName === '' ? 'marketplace' : storeName,
            deviceType: deviceType
          });
        }
      }
    }, "sis-links-desktop")
  });
};
SISLinks.propTypes = {
  stores: PropTypes.arrayOf(PropTypes.object),
  storeName: PropTypes.string,
  deviceType: PropTypes.string,
  isOnboardingEnabled: PropTypes.bool,
  currentStep: PropTypes.number,
  isOnboardingDisabledCookie: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool
};
var SISLinks$1 = SISLinks;

var styles$u = {"container":"TernaryNavBar-module_container__AzCOx","promotionalSection":"TernaryNavBar-module_promotionalSection__e8i0C","left-wrapper":"TernaryNavBar-module_left-wrapper__0w3PD","ternary-nav-bar":"TernaryNavBar-module_ternary-nav-bar__7-5WT","searchCheckBox":"TernaryNavBar-module_searchCheckBox__OV5LW","ternary-nav-bar-sis-level-header":"TernaryNavBar-module_ternary-nav-bar-sis-level-header__tjgoc","ternary-nav-bar--so_com":"TernaryNavBar-module_ternary-nav-bar--so_com__GCA3b","ternary-nav-bar--to_com":"TernaryNavBar-module_ternary-nav-bar--to_com__yQakQ","with-quicklinks":"TernaryNavBar-module_with-quicklinks__LW6Zj","overshadow":"TernaryNavBar-module_overshadow__8B0Nu","zone-container":"TernaryNavBar-module_zone-container__BRai7","activity-lists":"TernaryNavBar-module_activity-lists__iThkF","activity-link":"TernaryNavBar-module_activity-link__C8CMK","activity-link-link":"TernaryNavBar-module_activity-link-link__pb7RA"};

var styles$t = {"wrapper":"QuickLinks-module_wrapper__zVf9k","quick-link":"QuickLinks-module_quick-link__GqATI","coachmark-wrapper":"QuickLinks-module_coachmark-wrapper__P9Y0V"};

var QUICK_LINKS_CONTENT = {
  badgeText: 'Nuevo',
  title: 'Descubre y compra el estilo completo',
  description: 'Ahora podrás explorar productos ideales para complementar tu proyecto.',
  buttonText: 'Entendido'
};

var QuickLinks = function QuickLinks(_ref) {
  var items = _ref.items,
    deviceType = _ref.deviceType,
    isCoachmarkVisible = _ref.isCoachmarkVisible;
  var _useCoachmark = useCoachmark$1(),
    showCoachmark = _useCoachmark.showCoachmark,
    dismissCoachmark = _useCoachmark.dismissCoachmark;
  var isDesktop = deviceType === 'desktop';
  if (!items || items.length === 0) {
    return null;
  }
  return jsxs("div", {
    className: classNames(styles$t.wrapper),
    children: [items.map(function (item) {
      return item.name && item.url && jsx("a", {
        href: item.url,
        className: classNames(styles$t['quick-link']),
        onClick: function onClick() {
          updateDigitalDataCookies({
            firstLevelItem: "N2 - ".concat(item.name),
            tag: HEADER
          });
        },
        children: item.name
      }, "quick-link-".concat(item.title));
    }), isCoachmarkVisible && showCoachmark && jsx("div", {
      className: styles$t['coachmark-wrapper'],
      children: jsx(w, {
        badgeText: QUICK_LINKS_CONTENT.badgeText,
        title: QUICK_LINKS_CONTENT.title,
        description: QUICK_LINKS_CONTENT.description,
        buttonText: QUICK_LINKS_CONTENT.buttonText,
        onClickOnButton: dismissCoachmark,
        popoverStyle: isDesktop ? {} : {
          left: '10px'
        }
      })
    })]
  });
};
QuickLinks.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
    title: PropTypes.string
  })).isRequired,
  isCoachmarkVisible: PropTypes.bool
};
QuickLinks.defaultProps = {
  isCoachmarkVisible: false
};
var QuickLinks$1 = withDevice(QuickLinks);

var TernaryNavBar = function TernaryNavBar(_ref) {
  var _entry$sis_configs$0$, _entry$sis_configs, _entry$bottom_right_l;
  var currentStep = _ref.currentStep,
    deviceType = _ref.deviceType,
    handleRouteChange = _ref.handleRouteChange,
    header = _ref.header,
    hideNavbar = _ref.hideNavbar,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isBrandingMarketplace = _ref.isBrandingMarketplace,
    isDefaultComuna = _ref.isDefaultComuna,
    isOnboardingDisabledCookie = _ref.isOnboardingDisabledCookie,
    isOnboardingEnabled = _ref.isOnboardingEnabled,
    isOverlayEnabled = _ref.isOverlayEnabled,
    isPopOverVisible = _ref.isPopOverVisible,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    isZoneModalEnabled = _ref.isZoneModalEnabled,
    modalVisible = _ref.modalVisible,
    selectedZone = _ref.selectedZone,
    setModalVisible = _ref.setModalVisible,
    tenant = _ref.tenant,
    storeName = _ref.storeName,
    isUserLoggedIn = _ref.isUserLoggedIn,
    isProgramaticallyGeofinderEnabled = _ref.isProgramaticallyGeofinderEnabled,
    geofinderConfigs = _ref.geofinderConfigs,
    isOrangeOrSISHeader = _ref.isOrangeOrSISHeader,
    isSISLevel2Header = _ref.isSISLevel2Header,
    store = _ref.store,
    baseUrl = _ref.baseUrl,
    setShowLoginForm = _ref.setShowLoginForm,
    quickLinks = _ref.quickLinks,
    isCoachmarkVisible = _ref.isCoachmarkVisible,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    isPostalCodeEnabled = _ref.isPostalCodeEnabled;
  if (!isZoneModalEnabled && deviceType === 'mobile' || hideNavbar) {
    return jsx(React.Fragment, {});
  }
  var _header$entry = header.entry,
    entry = _header$entry === void 0 ? {} : _header$entry;
  var ourStores = ((_entry$sis_configs$0$ = entry === null || entry === void 0 || (_entry$sis_configs = entry.sis_configs) === null || _entry$sis_configs === void 0 || (_entry$sis_configs = _entry$sis_configs[0]) === null || _entry$sis_configs === void 0 ? void 0 : _entry$sis_configs.stores) !== null && _entry$sis_configs$0$ !== void 0 ? _entry$sis_configs$0$ : []).filter(function (st) {
    return st.is_enable;
  }).sort(function (a, b) {
    return a.order - b.order;
  });
  var additonalLinks = (_entry$bottom_right_l = entry === null || entry === void 0 ? void 0 : entry.bottom_right_links) !== null && _entry$bottom_right_l !== void 0 ? _entry$bottom_right_l : [];
  var sisfilteredStores = getStoreNameFromSisPage(ourStores, storeName.toLowerCase());
  var _getStandaloneSite = getStandaloneSite(store),
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone;
  var isNewNavigation = !isSISLevel2Header;
  var showStore = !!(!isNewNavigation && true);
  return jsxs("nav", {
    className: classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$u['ternary-nav-bar'], true), styles$u.overshadow, !(modalVisible || isOverlayEnabled)), styles$u['ternary-nav-bar-sis-level-header'], !isSISLevel2Header), styles$u['ternary-nav-bar--so_com'], isSodimacStandalone), styles$u['ternary-nav-bar--to_com'], isTottusStandalone), styles$u['with-quicklinks'], enableSISMenuV2)),
    children: [jsxs("div", {
      className: classNames(styles$u['left-wrapper']),
      children: [isZoneModalEnabled && jsx("div", {
        className: classNames(styles$u.container, styles$u['zone-container']),
        children: jsx(React.Fragment, {
          children: jsx(ZoneModal$1, {
            deviceType: deviceType,
            tenant: tenant,
            isDefaultComuna: isDefaultComuna,
            selectedZone: selectedZone,
            handleRouteChange: handleRouteChange,
            isOnboardingInProgress: isOnboardingEnabled && currentStep <= 1 && !isOnboardingDisabledCookie,
            entry: entry,
            baseUrl: baseUrl,
            modalVisible: modalVisible,
            setModalVisible: setModalVisible,
            isBrandingMarketplace: isBrandingMarketplace,
            isPopOverVisible: isPopOverVisible,
            isUserLoggedIn: isUserLoggedIn,
            isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
            geofinderConfigs: geofinderConfigs,
            isStore: !!storeName,
            store: store,
            isOrangeOrSISHeader: isOrangeOrSISHeader,
            isSISLevel2Header: isSISLevel2Header,
            enableSisThemedBorder: !!isSodimacStandalone,
            isSodimacStandAlone: isSodimacStandalone,
            isTottusStandAlone: isTottusStandalone,
            setShowLoginForm: setShowLoginForm,
            isPostalCodeEnabled: isPostalCodeEnabled
          })
        })
      }), enableSISMenuV2 && jsx(MatchMedia$1, {
        deviceType: deviceType,
        content: {
          desktop: function desktop() {
            return jsx(QuickLinks$1, {
              items: quickLinks,
              isCoachmarkVisible: isCoachmarkVisible
            });
          },
          mobile: function mobile() {
            return jsx(React.Fragment, {});
          },
          tablet: function tablet() {
            return jsx(React.Fragment, {});
          }
        }
      }, "quicklink-desktop")]
    }), jsx(MatchMedia$1, {
      deviceType: deviceType,
      content: {
        desktop: function desktop() {
          return jsx(NavbarLinks, {
            ourStores: sisfilteredStores.stores,
            isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 0,
            additonalLinks: additonalLinks,
            isAgentLoggedIn: isAgentLoggedIn,
            isVendorLoggedIn: isVendorLoggedIn,
            isNewNavigation: isNewNavigation,
            isStoreVisible: showStore,
            store: store
          });
        },
        mobile: function mobile() {
          return jsx(React.Fragment, {});
        },
        tablet: function tablet() {
          return jsx(React.Fragment, {});
        }
      }
    }, "search-bar-desktop")]
  });
};
TernaryNavBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  deviceType: PropTypes.string.isRequired,
  handleRouteChange: PropTypes.func.isRequired,
  header: PropTypes.object,
  hideNavbar: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  isDefaultComuna: PropTypes.bool,
  isOnboardingDisabledCookie: PropTypes.bool,
  isOnboardingEnabled: PropTypes.bool.isRequired,
  isOverlayEnabled: PropTypes.bool,
  isPopOverVisible: PropTypes.bool,
  searchInSis: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  isZoneModalEnabled: PropTypes.bool,
  modalVisible: PropTypes.bool.isRequired,
  selectedZone: PropTypes.object,
  setModalVisible: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired,
  isSearchBarTouched: PropTypes.bool,
  storeName: PropTypes.string,
  isUserLoggedIn: PropTypes.bool,
  isProgramaticallyGeofinderEnabled: PropTypes.bool,
  geofinderConfigs: PropTypes.object,
  isOrangeOrSISHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  store: PropTypes.string
};
TernaryNavBar.defaultProps = {
  header: {},
  hideNavbar: false,
  isAgentLoggedIn: false,
  isDefaultComuna: false,
  isOnboardingDisabledCookie: false,
  isOverlayEnabled: false,
  isPopOverVisible: false,
  searchInSis: false,
  isVendorLoggedIn: false,
  isZoneModalEnabled: false,
  selectedZone: undefined,
  isSearchBarTouched: false,
  isUserLoggedIn: false,
  isProgramaticallyGeofinderEnabled: false,
  geofinderConfigs: {},
  isSISLevel2Header: true
};
var TernaryNavBar$1 = withUser(TernaryNavBar);

var labels$2 = {
  WELCOME_LABEL: 'Bienvenid@,',
  LOGIN_LABEL: 'Inicia Sesión',
  A11Y_USER_LABEL: 'user info',
  MY_ACCOUNT_LABEL: 'Mi Cuenta',
  NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
  BAG: 'Bolsa',
  ORDER_BY_DESKTOP: 'Ordenar por',
  HELP: 'ayuda',
  HAVE_LABEL: 'Tienes'
};
var endpoints = {
  getATGLoginUrl: function getATGLoginUrl(baseUrl) {
    return "".concat(baseUrl, "/myaccount/includes/loginForm.jsp");
  }
};
var UserActionConfig = {
  labels: labels$2,
  endpoints: endpoints
};
var UserActionConfig$1 = UserActionConfig;

var styles$s = {"options":"UserInfoPopup-module_options__lFGuj","options__item":"UserInfoPopup-module_options__item__hXucP","options__item--text":"UserInfoPopup-module_options__item--text__KN9CY","register-container":"UserInfoPopup-module_register-container__lo-WV","register--register":"UserInfoPopup-module_register--register__3NaR5","icon":"UserInfoPopup-module_icon__p420m","display1":"UserInfoPopup-module_display1__ekPrs","link":"UserInfoPopup-module_link__DjgG7","register--no-account":"UserInfoPopup-module_register--no-account__AcNkf","last-item-style":"UserInfoPopup-module_last-item-style__0eCzz","options-icon":"UserInfoPopup-module_options-icon__HAMNf","userinfo-list":"UserInfoPopup-module_userinfo-list__J0tpG","cmr-title":"UserInfoPopup-module_cmr-title__Cnwpr"};

function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var UserInfoPopup = function UserInfoPopup(_ref) {
  var _myAccountDesktop$ite7, _myAccountDesktop$ite8, _myAccountDesktop$ite9, _myAccountDesktop$ite0;
  var isLoggedIn = _ref.isLoggedIn,
    myAccountDesktop = _ref.myAccountDesktop,
    logoutHandler = _ref.logoutHandler,
    toggleLoginForm = _ref.toggleLoginForm,
    isCmrPointsEnabled = _ref.isCmrPointsEnabled,
    myAccountLabel = _ref.myAccountLabel,
    tenant = _ref.tenant,
    cmrPoints = _ref.cmrPoints,
    topPosition = _ref.topPosition;
  var loginOption = [];
  if (!isLoggedIn) {
    var _myAccountDesktop$ite, _myAccountDesktop$ite2;
    var items = (_myAccountDesktop$ite = myAccountDesktop === null || myAccountDesktop === void 0 || (_myAccountDesktop$ite2 = myAccountDesktop.items_logged_out) === null || _myAccountDesktop$ite2 === void 0 ? void 0 : _myAccountDesktop$ite2.items) !== null && _myAccountDesktop$ite !== void 0 ? _myAccountDesktop$ite : [];
    items.forEach(function (item, i) {
      var _item$login = item.login,
        login = _item$login === void 0 ? false : _item$login;
      loginOption.push(_objectSpread$8(_objectSpread$8({}, item), {}, {
        id: "testId-loggedout-item-".concat(i),
        handler: login ? toggleLoginForm : noop$2
      }));
    });
  } else {
    var _myAccountDesktop$ite3, _myAccountDesktop$ite4, _myAccountDesktop$ite5, _myAccountDesktop$ite6;
    var _items = (_myAccountDesktop$ite3 = myAccountDesktop === null || myAccountDesktop === void 0 || (_myAccountDesktop$ite4 = myAccountDesktop.items_logged_in) === null || _myAccountDesktop$ite4 === void 0 || (_myAccountDesktop$ite4 = _myAccountDesktop$ite4.items) === null || _myAccountDesktop$ite4 === void 0 ? void 0 : _myAccountDesktop$ite4.redirection_items) !== null && _myAccountDesktop$ite3 !== void 0 ? _myAccountDesktop$ite3 : [];
    var actionItems = (_myAccountDesktop$ite5 = myAccountDesktop === null || myAccountDesktop === void 0 || (_myAccountDesktop$ite6 = myAccountDesktop.items_logged_in) === null || _myAccountDesktop$ite6 === void 0 || (_myAccountDesktop$ite6 = _myAccountDesktop$ite6.items) === null || _myAccountDesktop$ite6 === void 0 ? void 0 : _myAccountDesktop$ite6.action_items) !== null && _myAccountDesktop$ite5 !== void 0 ? _myAccountDesktop$ite5 : {};
    _items.forEach(function (item, i) {
      loginOption.push(_objectSpread$8(_objectSpread$8({}, item), {}, {
        id: "testId-loggedin-item-".concat(i),
        handler: noop$2
      }));
    });
    Object.keys(actionItems).forEach(function (key, i) {
      if (key === 'cerrar_sesion') {
        loginOption.push(_objectSpread$8(_objectSpread$8({}, actionItems[key]), {}, {
          id: "testId-loggedin-action-item-".concat(i),
          handler: logoutHandler,
          type: 'actionLogOut'
        }));
      } else {
        loginOption.push(_objectSpread$8(_objectSpread$8({}, actionItems[key]), {}, {
          id: "testId-loggedin-action-item-".concat(i)
        }));
      }
    });
  }
  var initializeUrl = function initializeUrl(atgUrl, catalystUrl) {
    return CookieStorage$1.isCatalyst() ? catalystUrl : atgUrl;
  };
  var last_item_style_logged = (_myAccountDesktop$ite7 = myAccountDesktop === null || myAccountDesktop === void 0 || (_myAccountDesktop$ite8 = myAccountDesktop.items_logged_in) === null || _myAccountDesktop$ite8 === void 0 ? void 0 : _myAccountDesktop$ite8.last_item_style) !== null && _myAccountDesktop$ite7 !== void 0 ? _myAccountDesktop$ite7 : false;
  var last_item_style_not_logged = (_myAccountDesktop$ite9 = myAccountDesktop === null || myAccountDesktop === void 0 || (_myAccountDesktop$ite0 = myAccountDesktop.items_logged_out) === null || _myAccountDesktop$ite0 === void 0 ? void 0 : _myAccountDesktop$ite0.last_item_style) !== null && _myAccountDesktop$ite9 !== void 0 ? _myAccountDesktop$ite9 : false;
  var loggedlistClass = "".concat(styles$s['userinfo-list']);
  var unloggedlistClass = "".concat(styles$s['userinfo-list']);
  if (last_item_style_logged) {
    loggedlistClass = "".concat(styles$s['userinfo-list'], " ").concat(styles$s['last-item-style']);
  }
  if (last_item_style_not_logged) {
    unloggedlistClass = "".concat(styles$s['userinfo-list'], " ").concat(styles$s['last-item-style']);
  }
  var isMyAccount = function isMyAccount() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return title && title.toLowerCase() === myAccountLabel.toLowerCase();
  };
  var getLoggedInUserPopUp = function getLoggedInUserPopUp() {
    return jsx(React.Fragment, {
      children: jsx("ul", {
        className: loggedlistClass,
        children: loginOption.map(function (_ref2) {
          var title = _ref2.title,
            catalyst_url = _ref2.catalyst_url,
            atg_url = _ref2.atg_url,
            _ref2$is_new_tab = _ref2.is_new_tab,
            is_new_tab = _ref2$is_new_tab === void 0 ? false : _ref2$is_new_tab,
            _ref2$is_cmr = _ref2.is_cmr,
            is_cmr = _ref2$is_cmr === void 0 ? false : _ref2$is_cmr,
            _ref2$handler = _ref2.handler,
            handler = _ref2$handler === void 0 ? noop$2 : _ref2$handler,
            type = _ref2.type,
            id = _ref2.id;
          var href = initializeUrl(catalyst_url, atg_url);
          if (is_cmr) {
            return jsx("li", {
              id: id,
              className: classNames(styles$s.display1, styles$s['options__item--text']),
              children: jsx("ul", {
                children: jsx(CmrPuntosCategoryItem, {
                  cmrPuntosURL: href,
                  cmrText: jsx("p", {
                    className: styles$s['cmr-title'],
                    children: title
                  }),
                  isCmrPointsEnabled: isCmrPointsEnabled,
                  isLoggedIn: isLoggedIn,
                  isNewTab: is_new_tab,
                  isRebrandingEnabled: true,
                  tenantId: "falabella-".concat(tenant),
                  cmrPoints: cmrPoints
                })
              })
            }, id);
          }
          return jsx("li", {
            className: styles$s.options__item,
            children: type === 'actionLogOut' ? jsx("a", {
              id: id,
              className: classNames(styles$s.display1, styles$s['options__item--text']),
              href: "#",
              onClick: function onClick(e) {
                e.preventDefault();
                handler();
                updateDigitalDataCookies({
                  firstLevelItem: "N1 - ".concat(title),
                  tag: HEADER
                });
              },
              children: title
            }) : jsx("a", {
              className: classNames(styles$s.display1, styles$s['options__item--text']),
              style: isMyAccount(title) ? {
                fontWeight: 'bold'
              } : {},
              id: id,
              target: is_new_tab ? '_blank' : '',
              href: href,
              rel: "noreferrer",
              onClick: function onClick() {
                return updateDigitalDataCookies({
                  firstLevelItem: "N1 - ".concat(title),
                  tag: HEADER
                });
              },
              children: title
            })
          }, title);
        })
      })
    });
  };
  var getGuestUserPopup = function getGuestUserPopup() {
    return jsx(React.Fragment, {
      children: jsx("ul", {
        className: unloggedlistClass,
        children: loginOption.map(function (_ref3) {
          var title = _ref3.title,
            url = _ref3.url,
            _ref3$is_new_tab = _ref3.is_new_tab,
            is_new_tab = _ref3$is_new_tab === void 0 ? false : _ref3$is_new_tab,
            id = _ref3.id,
            login = _ref3.login,
            handler = _ref3.handler,
            icon = _ref3.icon;
          return jsxs("li", {
            className: styles$s.options__item,
            children: [(icon === null || icon === void 0 ? void 0 : icon.url) && jsx("i", {
              className: styles$s['options-icon'],
              style: {
                backgroundImage: "url(".concat(icon.url, ")")
              }
            }), login ? jsx("a", {
              id: id,
              className: classNames(styles$s.display1, styles$s['options__item--text']),
              onClick: function onClick(e) {
                e.preventDefault();
                handler();
                updateDigitalDataCookies({
                  firstLevelItem: "N1 - ".concat(title),
                  tag: HEADER
                });
              },
              children: title
            }) : jsx("a", {
              id: id,
              className: classNames(styles$s.display1, styles$s['options__item--text']),
              target: is_new_tab ? '_blank' : '',
              href: url,
              rel: "noreferrer",
              onClick: function onClick() {
                return updateDigitalDataCookies({
                  firstLevelItem: "N1 - ".concat(title),
                  tag: HEADER
                });
              },
              children: title
            })]
          }, title);
        })
      })
    });
  };
  return jsx("div", {
    id: isLoggedIn ? 'logged-in-options' : '',
    className: styles$s.options,
    "data-top-position": "".concat(topPosition, "px"),
    children: isLoggedIn ? getLoggedInUserPopUp() : getGuestUserPopup()
  });
};
UserInfoPopup.defaultProps = {
  cmrData: {},
  isCmrPointsEnabled: false,
  myAccountLabel: '',
  tenant: ''
};
UserInfoPopup.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  isCmrPointsEnabled: PropTypes.bool,
  noAccountLabel: PropTypes.string.isRequired,
  myAccountLabel: PropTypes.string.isRequired,
  myAccountDesktop: PropTypes.object.isRequired,
  cmrData: PropTypes.object,
  toggleLoginForm: PropTypes.func,
  logoutHandler: PropTypes.func.isRequired,
  tenant: PropTypes.string,
  cmrPoints: PropTypes.object,
  topPosition: PropTypes.number
};
var UserInfoPopup$1 = UserInfoPopup;

var styles$r = {"info":"UserInfo-module_info__-TRGm","account-content":"UserInfo-module_account-content__LEprg","info__icon":"UserInfo-module_info__icon__xPZmZ","info__name":"UserInfo-module_info__name__p9TGV","info__name--to_com":"UserInfo-module_info__name--to_com__QeLZk","onboarding-login-text":"UserInfo-module_onboarding-login-text__sPpET","label-secondary":"UserInfo-module_label-secondary__3MD-7","my-account-label":"UserInfo-module_my-account-label__UrVts","my-account-label--standalone":"UserInfo-module_my-account-label--standalone__CGSB9","my-account-label--to_com":"UserInfo-module_my-account-label--to_com__Tkm8e","my-account-label--whitelabel":"UserInfo-module_my-account-label--whitelabel__WbmFg","label-primary":"UserInfo-module_label-primary__g3d3j","flex":"UserInfo-module_flex__X0yNy","flexBox":"UserInfo-module_flexBox__L-1Jo","flexBoxWithHeight":"UserInfo-module_flexBoxWithHeight__8TuWt","icon-cmr-icon":"UserInfo-module_icon-cmr-icon__7nhP-","grayCMR":"UserInfo-module_grayCMR__ZHy-t","popover-wrapper":"UserInfo-module_popover-wrapper__prQvy","downArrowicon":"UserInfo-module_downArrowicon__Qs1NR","downArrowicon--to_com":"UserInfo-module_downArrowicon--to_com__xif6Z","downArrowicon1":"UserInfo-module_downArrowicon1__GFfMt","grayDownArrow":"UserInfo-module_grayDownArrow__NGKaz","loggedin-modal":"UserInfo-module_loggedin-modal__2kDue","label-secondary-cmr":"UserInfo-module_label-secondary-cmr__OP2E-","cmrWrapper":"UserInfo-module_cmrWrapper__P7ZOK","cmrFirstName":"UserInfo-module_cmrFirstName__56sNx","haveLabel":"UserInfo-module_haveLabel__oIFdU","icon":"UserInfo-module_icon__KErVJ","display1":"UserInfo-module_display1__XXsVP","display1--standalone":"UserInfo-module_display1--standalone__HAKDx","display1--to_com":"UserInfo-module_display1--to_com__UpKN7","display1--whitelabel":"UserInfo-module_display1--whitelabel__hKzr5","display2":"UserInfo-module_display2__xaqZb","sr-only":"UserInfo-module_sr-only__3Xzsj","icon-arrow_down_small":"UserInfo-module_icon-arrow_down_small__1291T","icon-user1":"UserInfo-module_icon-user1__3adRX","portal":"UserInfo-module_portal__1scRd","backdrop":"UserInfo-module_backdrop__X7pL0"};

var UserInfo = function UserInfo(_ref) {
  var _entry$header_configs, _entry$header_configs2, _cmrPoints$balancePoi;
  var isLoggedIn = _ref.isLoggedIn,
    userFirstName = _ref.userFirstName,
    myAccountLabel = _ref.myAccountLabel,
    noAccountLabel = _ref.noAccountLabel,
    myAccountDesktop = _ref.myAccountDesktop,
    logoutHandler = _ref.logoutHandler,
    isATGLoginEnabled = _ref.isATGLoginEnabled,
    isOnboardingInProgress = _ref.isOnboardingInProgress,
    anchorStyle = _ref.anchorStyle,
    toggleLoginForm = _ref.toggleLoginForm,
    entry = _ref.entry,
    tenant = _ref.tenant;
    _ref.isVendorLoggedIn;
    _ref.isAgentLoggedIn;
    var isOrangeOrSISHeader = _ref.isOrangeOrSISHeader,
    store = _ref.store;
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var _useContext = useContext(AppContext$1),
    baseUrl = _useContext.baseUrl;
  var endpoints = UserActionConfig$1.endpoints;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDropdownVisible = _useState2[0],
    setIsDropdownVisible = _useState2[1];
  var isCmrPointsEnabled = (_entry$header_configs = entry === null || entry === void 0 || (_entry$header_configs2 = entry.header_configs) === null || _entry$header_configs2 === void 0 || (_entry$header_configs2 = _entry$header_configs2[0]) === null || _entry$header_configs2 === void 0 || (_entry$header_configs2 = _entry$header_configs2.toggles) === null || _entry$header_configs2 === void 0 ? void 0 : _entry$header_configs2.iscmrenabled) !== null && _entry$header_configs !== void 0 ? _entry$header_configs : false;
  var cmrPoints = tenant === 'mx' ? {} : useCmrPoints("falabella-".concat(tenant), true, isLoggedIn);
  var updatedBalancePoints = (_cmrPoints$balancePoi = cmrPoints === null || cmrPoints === void 0 ? void 0 : cmrPoints.balancePoints) !== null && _cmrPoints$balancePoi !== void 0 ? _cmrPoints$balancePoi : -1;
  var isCMRUnavailable = !(updatedBalancePoints && updatedBalancePoints > 0) || !isCmrPointsEnabled;
  var showDropdownMenu = function showDropdownMenu() {
    return setIsDropdownVisible(true);
  };
  var hideDropdownMenu = function hideDropdownMenu() {
    return setIsDropdownVisible(false);
  };
  var getLoggedInUserComponent = function getLoggedInUserComponent() {
    if (updatedBalancePoints < 0) {
      return null;
    } else if (isCmrPointsEnabled) {
      return jsxs("div", {
        className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$r.flexBoxWithHeight, !isCMRUnavailable), styles$r.flexBox, isCMRUnavailable), styles$r.cmrWrapper, true)),
        children: [jsx("span", {
          className: classNames(styles$r['label-secondary-cmr']),
          children: formatPoints(updatedBalancePoints, tenant)
        }), jsx("div", {
          className: classNames(styles$r['icon-cmr-icon'], _defineProperty({}, styles$r.grayCMR, !isOrangeOrSISHeader || isStandaloneSite))
        })]
      });
    }
    return null;
  };
  var welcomeLabelComponent = function welcomeLabelComponent() {
    return jsxs("div", {
      className: classNames(_defineProperty(_defineProperty({}, styles$r.flexBoxWithHeight, isLoggedIn && !isCMRUnavailable), styles$r.flexBox, !isLoggedIn || isCMRUnavailable)),
      children: [jsxs("p", {
        className: classNames(styles$r.display1, _defineProperty(_defineProperty({}, styles$r['display1--to_com'], isTottusStandalone), styles$r['display1--whitelabel'], isWhitelabelSite)),
        children: [myAccountDesktop.hello_text, ", ", userFirstName]
      }), jsx("div", {
        className: classNames(styles$r.downArrowicon1, _defineProperty({}, styles$r.grayDownArrow, !isOrangeOrSISHeader))
      })]
    });
  };
  var getGuestUserComponent = function getGuestUserComponent() {
    return jsxs("div", {
      className: styles$r.flex,
      children: [jsx("p", {
        className: classNames(styles$r['my-account-label'], _defineProperty(_defineProperty(_defineProperty({}, styles$r['my-account-label--to_com'], isTottusStandalone), styles$r['my-account-label--whitelabel'], isWhitelabelSite), styles$r['my-account-label--standalone'], isStandaloneSite)),
        children: "Inicia sesi\xF3n"
      }), jsx("div", {
        className: classNames(styles$r.downArrowicon, _defineProperty(_defineProperty({}, styles$r.grayDownArrow, !isOrangeOrSISHeader), styles$r['downArrowicon--to_com'], isTottusStandalone))
      })]
    });
  };
  var getContentContainer = function getContentContainer(children) {
    return isATGLoginEnabled ? jsx("a", {
      href: endpoints.getATGLoginUrl(baseUrl),
      style: {
        textDecoration: 'none'
      },
      className: anchorStyle,
      children: children
    }) : children;
  };
  var content = function content() {
    var children = jsx("div", {
      id: "user-info",
      className: styles$r.info,
      children: jsxs("div", {
        className: classNames(styles$r.info__name, _defineProperty(_defineProperty({}, styles$r['onboarding-login-text'], isOnboardingInProgress), styles$r['info__name--to_com'], isTottusStandalone)),
        children: [jsx("div", {
          className: classNames(_defineProperty({}, styles$r['account-content'], isLoggedIn && !isCMRUnavailable)),
          children: isLoggedIn ? welcomeLabelComponent() : jsxs("p", {
            className: classNames(styles$r.display1, styles$r['label-primary'], _defineProperty(_defineProperty(_defineProperty({}, styles$r['display1--to_com'], isTottusStandalone), styles$r['display1--whitelabel'], isWhitelabelSite), styles$r['display1--standalone'], isStandaloneSite)),
            children: [myAccountDesktop.hello_text, ","]
          })
        }), isLoggedIn ? getLoggedInUserComponent() : getGuestUserComponent()]
      })
    });
    return getContentContainer(children);
  };
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    portalTop = _useState4[0],
    setPortalTop = _useState4[1];
  var userInfoRef = useRef(null);
  useEffect(function () {
    if (isDropdownVisible && userInfoRef.current) {
      var headerElement = userInfoRef.current.closest('header');
      if (headerElement) {
        var _headerElement$getBou = headerElement.getBoundingClientRect(),
          bottom = _headerElement$getBou.bottom;
        setPortalTop(bottom);
      } else {
        var _userInfoRef$current$ = userInfoRef.current.getBoundingClientRect(),
          _bottom = _userInfoRef$current$.bottom;
        setPortalTop(_bottom);
      }
    }
  }, [isDropdownVisible]);
  return jsxs("div", {
    ref: userInfoRef,
    id: "testId-UserAction-userinfo",
    className: classNames(_defineProperty({}, styles$r['account-content'], isLoggedIn && isCMRUnavailable)),
    onMouseEnter: showDropdownMenu,
    onMouseLeave: hideDropdownMenu,
    children: [content(), isDropdownVisible && jsx(Portal$1, {
      id: "mkp-popover-portal",
      classes: styles$r.portal,
      top: portalTop,
      children: jsx("span", {
        className: styles$r.backdrop,
        onMouseEnter: hideDropdownMenu
      })
    }), isDropdownVisible && jsx(UserInfoPopup$1, {
      myAccountDesktop: myAccountDesktop,
      logoutHandler: logoutHandler,
      isLoggedIn: isLoggedIn,
      noAccountLabel: noAccountLabel,
      toggleLoginForm: !isLoggedIn && !isATGLoginEnabled ? toggleLoginForm : noop$2,
      isCmrPointsEnabled: isCmrPointsEnabled,
      myAccountLabel: myAccountLabel,
      tenant: tenant,
      cmrPoints: cmrPoints,
      topPosition: portalTop
    })]
  });
};
UserInfo.propTypes = {
  a11yUserLabel: PropTypes.string.isRequired,
  anchorStyle: PropTypes.string,
  deviceType: PropTypes.string,
  entry: PropTypes.object,
  isAgentLoggedIn: PropTypes.bool,
  isATGLoginEnabled: PropTypes.bool,
  isLoggedIn: PropTypes.bool.isRequired,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  isVendorLoggedIn: PropTypes.bool,
  loginLabel: PropTypes.string.isRequired,
  logoutHandler: PropTypes.func.isRequired,
  myAccountDesktop: PropTypes.object.isRequired,
  myAccountLabel: PropTypes.string.isRequired,
  noAccountLabel: PropTypes.string.isRequired,
  onLoadingStateChange: PropTypes.func,
  setMenuVisible: PropTypes.func,
  tenant: PropTypes.string,
  toggleLoginForm: PropTypes.func.isRequired,
  userFirstName: PropTypes.string.isRequired,
  welcomeLabel: PropTypes.string.isRequired,
  isOrangeOrSISHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  store: PropTypes.string
};
UserInfo.defaultProps = {
  isAgentLoggedIn: false,
  isVendorLoggedIn: false,
  tenant: ''
};
var UserInfo$1 = UserInfo;

var styles$q = {"utils":"UserActions-module_utils__z981E","whitlabel":"UserActions-module_whitlabel__uP4GN","utils-ul":"UserActions-module_utils-ul__H8lyP","utils-list-mobile":"UserActions-module_utils-list-mobile__hT3ix","utils-list-mobile--so_com":"UserActions-module_utils-list-mobile--so_com__vSiBF","utils-list-mobile--to_com":"UserActions-module_utils-list-mobile--to_com__nOVDv","utils-list":"UserActions-module_utils-list__ijGNm","content-wrapper":"UserActions-module_content-wrapper__YmGyu","go-to-basket":"UserActions-module_go-to-basket__kqJJJ","content-wrapper--to_com":"UserActions-module_content-wrapper--to_com__OSD82","orders-content-wrapper":"UserActions-module_orders-content-wrapper__aJS9H","orders-content-wrapper--to_com":"UserActions-module_orders-content-wrapper--to_com__1QWN3","basket-icon":"UserActions-module_basket-icon__8lUE5","wishlist-icon--to_com":"UserActions-module_wishlist-icon--to_com__GYT6G","wishlist-icon":"UserActions-module_wishlist-icon__xIndL","utils-list--to_com":"UserActions-module_utils-list--to_com__RPHIo","utils-search":"UserActions-module_utils-search__fUC8b","user-info":"UserActions-module_user-info__UkbFV","onboarding-highlight":"UserActions-module_onboarding-highlight__MfnpF","loginTextFade":"UserActions-module_loginTextFade__5yNlk","utils-span":"UserActions-module_utils-span__cbMYg","utils-span--to_com":"UserActions-module_utils-span--to_com__Y9IAh","utils-span--whitelabel":"UserActions-module_utils-span--whitelabel__t-qI2","utils-span-lower":"UserActions-module_utils-span-lower__BiKMw","utils-span-lower--to_com":"UserActions-module_utils-span-lower--to_com__fDLDV","utils-span-lower--whitelabel":"UserActions-module_utils-span-lower--whitelabel__vjkRh","utils-anchor":"UserActions-module_utils-anchor__D0ptF","searchIcon":"UserActions-module_searchIcon__eDFap","closeIcon":"UserActions-module_closeIcon__yW3Ly","active":"UserActions-module_active__3iYqX","utilIcon":"UserActions-module_utilIcon__CMvmc","utilIcon--to_com":"UserActions-module_utilIcon--to_com__jLsH0","utilIcon--whitelabel":"UserActions-module_utilIcon--whitelabel__8YaGg","login-list":"UserActions-module_login-list__rKPGg","store_inicia":"UserActions-module_store_inicia__GsI-J","login-list--so_com":"UserActions-module_login-list--so_com__P5Fjr","login-list--to_com":"UserActions-module_login-list--to_com__SbuAT","login_list_store":"UserActions-module_login_list_store__4Z-2j","utilMobileIcon":"UserActions-module_utilMobileIcon__ZveCO","icon":"UserActions-module_icon__glj3B","account":"UserActions-module_account__PyGWN","orders":"UserActions-module_orders__H4DI0","orders-title":"UserActions-module_orders-title__uRvzm","has-count":"UserActions-module_has-count__bnjqn","store-stroke":"UserActions-module_store-stroke__mzoiX","has-count--so_com":"UserActions-module_has-count--so_com__Wqmo7","cart-container":"UserActions-module_cart-container__9ALty","cart-icon":"UserActions-module_cart-icon__x-S-l","cart-count-container":"UserActions-module_cart-count-container__AiupQ","cart-count-value":"UserActions-module_cart-count-value__jmkmN","cart-count-value--to_com":"UserActions-module_cart-count-value--to_com__FDUNC","cart-count-container--to_com":"UserActions-module_cart-count-container--to_com__t20M5","has-count-desktop":"UserActions-module_has-count-desktop__RAhhE","title":"UserActions-module_title__8eSYo","link":"UserActions-module_link__I-wJm","icon-bag":"UserActions-module_icon-bag__SJuUf","icon-user1":"UserActions-module_icon-user1__Peof6","icon-help":"UserActions-module_icon-help__uYHkE","icon-delivery":"UserActions-module_icon-delivery__hBt7T","icon-user1-mobile":"UserActions-module_icon-user1-mobile__oBfMf","icon-bag-mobile":"UserActions-module_icon-bag-mobile__8Tpnp","tracking-links-wrapper":"UserActions-module_tracking-links-wrapper__1sBM3","tracking":"UserActions-module_tracking__rfJQ2","tracking-item":"UserActions-module_tracking-item__ZdY-c","tracking-icon":"UserActions-module_tracking-icon__5FxW7","tracking-item-text":"UserActions-module_tracking-item-text__00iXx","tracking-btn":"UserActions-module_tracking-btn__37jxt"};

var WHITELABEL_CONFIG = {
  logo: {
    brandLogo: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blte519222fb2afb54e/679c7958e729222d0f536c25/carterslogo.svg',
    url: 'https://staging-carters.falabella.com'
  },
  header: {
    iconBackgroundColor: '#111',
    borderRadius: '80px',
    textColor: '#111',
    backgroundColor: '#fff'
  },
  menu: {
    menu_type: 'Button Menu',
    desktop: {
      icon: {
        url: 'https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt90792027e39db4dc/679c849c31e91973afa599ae/menuhamburger.svg'
      },
      text: 'Menú',
      background_color: ''
    },
    mobile: {
      icon: {
        url: 'https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt90792027e39db4dc/679c849c31e91973afa599ae/menuhamburger.svg'
      },
      text: 'Menú',
      background_color: ''
    },
    text_color: '#333',
    close_icon: {
      url: 'https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/bltdeb40ae1b6cb0114/67adecb3d4104e90845da3e6/Group_1.svg'
    },
    horizontalMenuBackgroundColor: '#222',
    horizontalMenuCategoryTitleTextColor: '#FFF',
    horizontalMenuSubCategoryTitleTextColor: '#495867'
  },
  searchbar: {
    desktop_placeholder: '¿Qué buscas?',
    mobile_placeholder: '¿Qué buscas?',
    icon: {
      close_icon: {},
      search_icon: {
        url: 'https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt9fbaac40a4afddc1/679867a717131c0e22b207c8/Shape.svg'
      },
      search_icon_background_color: '#333333'
    },
    search_placeholder_text_color: '#333333'
  }
};
var MENU_TYPE = {
  HORIZONTAL: 'Horizontal Menu',
  BUTTON: 'Button Menu'
};

var labels$1 = {
  EMPTY_SEARCH_ERROR_TITLE: '',
  EMPTY_SEARCH_ERROR_MESSAGE: '',
  INCORRECT_SEARCH_ERROR_TITLE: '',
  INCORRECT_SEARCH_ERROR_MESSAGE: ''
};
var constants = {
  MIN_SEARCH_TERM_LENGTH: '',
  ON_BOARDING_COOKIE: 'on_boarding',
  ORANGE_COLOR_AB: 'ORANGE_COLOR_AB'
};
var pageOffsetForAnimation = {
  desktop: 70,
  mobile: 96,
  tablet: 96
};
var configs = {
  labels: labels$1,
  constants: constants,
  pageOffsetForAnimation: pageOffsetForAnimation
};
var configs$1 = configs;

var extractHeaderConfig = function extractHeaderConfig(header, deviceType) {
  var _header$entry$header_, _header$entry, _header$entry$header_2, _header$entry2, _header$entry$header_3, _header$entry3, _header$entry$header_4, _header$entry4, _header$entry$header_5, _header$entry5, _header$entry$header_6, _header$entry6, _header$entry$header_7, _header$entry7, _header$entry$cross_b, _header$entry8, _crossBannerConfigs$b, _crossBannerConfigs$b2, _header$entry$searchb, _header$entry9, _searchConfigs$icon, _searchConfigs$icon2, _header$entry$brand_l, _header$entry0, _header$entry$brand_l2, _header$entry1, _header$entry$menu, _header$entry10, _header$entry$menu$te, _header$entry11, _header$entry$text_co, _header$entry12, _header$entry$text_co2, _header$entry13, _header$entry$header_8, _header$entry14, _header$entry$header_9, _header$entry15, _header$entry$header_0, _header$entry16, _header$entry$header_1, _header$entry17, _header$entry$header_10, _header$entry18, _header$entry$menu$ho, _header$entry19, _header$entry$menu$me, _header$entry20;
  var isOnboardingEnabled = (_header$entry$header_ = header === null || header === void 0 || (_header$entry = header.entry) === null || _header$entry === void 0 || (_header$entry = _header$entry.header_configs) === null || _header$entry === void 0 || (_header$entry = _header$entry[0]) === null || _header$entry === void 0 || (_header$entry = _header$entry.toggles) === null || _header$entry === void 0 ? void 0 : _header$entry.isonboardingenabled) !== null && _header$entry$header_ !== void 0 ? _header$entry$header_ : false;
  var isProgramaticallyGeofinderEnabled = (_header$entry$header_2 = header === null || header === void 0 || (_header$entry2 = header.entry) === null || _header$entry2 === void 0 || (_header$entry2 = _header$entry2.header_configs) === null || _header$entry2 === void 0 || (_header$entry2 = _header$entry2[0]) === null || _header$entry2 === void 0 || (_header$entry2 = _header$entry2.toggles) === null || _header$entry2 === void 0 ? void 0 : _header$entry2.isprogramaticallygeofinderenabled) !== null && _header$entry$header_2 !== void 0 ? _header$entry$header_2 : false;
  var geofinderConfigs = (_header$entry$header_3 = header === null || header === void 0 || (_header$entry3 = header.entry) === null || _header$entry3 === void 0 || (_header$entry3 = _header$entry3.header_configs) === null || _header$entry3 === void 0 || (_header$entry3 = _header$entry3[0]) === null || _header$entry3 === void 0 || (_header$entry3 = _header$entry3.property_configs) === null || _header$entry3 === void 0 ? void 0 : _header$entry3.geofinder) !== null && _header$entry$header_3 !== void 0 ? _header$entry$header_3 : {};
  var isRecentSearchesEnabled = (_header$entry$header_4 = header === null || header === void 0 || (_header$entry4 = header.entry) === null || _header$entry4 === void 0 || (_header$entry4 = _header$entry4.header_configs) === null || _header$entry4 === void 0 || (_header$entry4 = _header$entry4[0]) === null || _header$entry4 === void 0 || (_header$entry4 = _header$entry4.toggles) === null || _header$entry4 === void 0 ? void 0 : _header$entry4.isrecentsearchesenabled) !== null && _header$entry$header_4 !== void 0 ? _header$entry$header_4 : false;
  var isMyAccountEnabled = (_header$entry$header_5 = header === null || header === void 0 || (_header$entry5 = header.entry) === null || _header$entry5 === void 0 || (_header$entry5 = _header$entry5.header_configs) === null || _header$entry5 === void 0 || (_header$entry5 = _header$entry5[0]) === null || _header$entry5 === void 0 || (_header$entry5 = _header$entry5.toggles) === null || _header$entry5 === void 0 ? void 0 : _header$entry5.ismyaccountenabled) !== null && _header$entry$header_5 !== void 0 ? _header$entry$header_5 : false;
  var isMyOrdersEnabled = (_header$entry$header_6 = header === null || header === void 0 || (_header$entry6 = header.entry) === null || _header$entry6 === void 0 || (_header$entry6 = _header$entry6.header_configs) === null || _header$entry6 === void 0 || (_header$entry6 = _header$entry6[0]) === null || _header$entry6 === void 0 || (_header$entry6 = _header$entry6.toggles) === null || _header$entry6 === void 0 ? void 0 : _header$entry6.ismyordersenabled) !== null && _header$entry$header_6 !== void 0 ? _header$entry$header_6 : false;
  var isWishListEnabled = (_header$entry$header_7 = header === null || header === void 0 || (_header$entry7 = header.entry) === null || _header$entry7 === void 0 || (_header$entry7 = _header$entry7.header_configs) === null || _header$entry7 === void 0 || (_header$entry7 = _header$entry7[0]) === null || _header$entry7 === void 0 || (_header$entry7 = _header$entry7.toggles) === null || _header$entry7 === void 0 ? void 0 : _header$entry7.iswishlistenabled) !== null && _header$entry$header_7 !== void 0 ? _header$entry$header_7 : false;
  var crossBannerConfigs = (_header$entry$cross_b = header === null || header === void 0 || (_header$entry8 = header.entry) === null || _header$entry8 === void 0 ? void 0 : _header$entry8.cross_banner) !== null && _header$entry$cross_b !== void 0 ? _header$entry$cross_b : {};
  var crossBanner = {
    url: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : crossBannerConfigs.url) || '',
    openInNewTab: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : crossBannerConfigs.is_new_tab) || false,
    desktopImageUrl: (crossBannerConfigs === null || crossBannerConfigs === void 0 || (_crossBannerConfigs$b = crossBannerConfigs.banner_desktop_image) === null || _crossBannerConfigs$b === void 0 ? void 0 : _crossBannerConfigs$b.url) || '',
    mobileImageUrl: (crossBannerConfigs === null || crossBannerConfigs === void 0 || (_crossBannerConfigs$b2 = crossBannerConfigs.banner_mobile_image) === null || _crossBannerConfigs$b2 === void 0 ? void 0 : _crossBannerConfigs$b2.url) || '',
    position: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : crossBannerConfigs.banner_position) || 'top',
    isVisible: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : crossBannerConfigs.banner_visible) || false
  };
  var searchConfigs = (_header$entry$searchb = header === null || header === void 0 || (_header$entry9 = header.entry) === null || _header$entry9 === void 0 ? void 0 : _header$entry9.searchbar) !== null && _header$entry$searchb !== void 0 ? _header$entry$searchb : {};
  var searchbar = {
    desktop_placeholder: searchConfigs.desktop_placeholder || WHITELABEL_CONFIG.searchbar.desktop_placeholder,
    mobile_placeholder: searchConfigs.mobile_placeholder || WHITELABEL_CONFIG.searchbar.mobile_placeholder,
    search_placeholder_text_color: searchConfigs.search_placeholder_text_color || WHITELABEL_CONFIG.searchbar.search_placeholder_text_color,
    search_icon: ((_searchConfigs$icon = searchConfigs.icon) === null || _searchConfigs$icon === void 0 ? void 0 : _searchConfigs$icon.search_icon) || WHITELABEL_CONFIG.searchbar.icon.search_icon,
    search_icon_background_color: ((_searchConfigs$icon2 = searchConfigs.icon) === null || _searchConfigs$icon2 === void 0 ? void 0 : _searchConfigs$icon2.search_icon_background_color) || WHITELABEL_CONFIG.searchbar.icon.search_icon_background_color,
    searchBarBorderRadius: searchConfigs.border_radius || '80px',
    searchBarBorderColor: searchConfigs.border_color || WHITELABEL_CONFIG.searchbar.icon.search_icon_background_color
  };
  var mainLogoIcon = (_header$entry$brand_l = header === null || header === void 0 || (_header$entry0 = header.entry) === null || _header$entry0 === void 0 || (_header$entry0 = _header$entry0.brand_logo) === null || _header$entry0 === void 0 || (_header$entry0 = _header$entry0["".concat(deviceType, "_icon")]) === null || _header$entry0 === void 0 ? void 0 : _header$entry0.url) !== null && _header$entry$brand_l !== void 0 ? _header$entry$brand_l : WHITELABEL_CONFIG.logo.brandLogo;
  var logoURL = (_header$entry$brand_l2 = header === null || header === void 0 || (_header$entry1 = header.entry) === null || _header$entry1 === void 0 || (_header$entry1 = _header$entry1.brand_logo) === null || _header$entry1 === void 0 ? void 0 : _header$entry1.url) !== null && _header$entry$brand_l2 !== void 0 ? _header$entry$brand_l2 : WHITELABEL_CONFIG.logo.url;
  var menuConfig = (_header$entry$menu = header === null || header === void 0 || (_header$entry10 = header.entry) === null || _header$entry10 === void 0 ? void 0 : _header$entry10.menu) !== null && _header$entry$menu !== void 0 ? _header$entry$menu : WHITELABEL_CONFIG.menu;
  var menuTextColor = (_header$entry$menu$te = header === null || header === void 0 || (_header$entry11 = header.entry) === null || _header$entry11 === void 0 || (_header$entry11 = _header$entry11.menu) === null || _header$entry11 === void 0 ? void 0 : _header$entry11.text_color) !== null && _header$entry$menu$te !== void 0 ? _header$entry$menu$te : WHITELABEL_CONFIG.header.textColor;
  var myOrdersTextColor = (_header$entry$text_co = header === null || header === void 0 || (_header$entry12 = header.entry) === null || _header$entry12 === void 0 || (_header$entry12 = _header$entry12["myorders_".concat(deviceType)]) === null || _header$entry12 === void 0 ? void 0 : _header$entry12.text_color) !== null && _header$entry$text_co !== void 0 ? _header$entry$text_co : WHITELABEL_CONFIG.header.textColor;
  var myAccountTextColor = (_header$entry$text_co2 = header === null || header === void 0 || (_header$entry13 = header.entry) === null || _header$entry13 === void 0 || (_header$entry13 = _header$entry13["myaccount_".concat(deviceType)]) === null || _header$entry13 === void 0 ? void 0 : _header$entry13.text_color) !== null && _header$entry$text_co2 !== void 0 ? _header$entry$text_co2 : WHITELABEL_CONFIG.header.textColor;
  var topHeaderTextColor = (_header$entry$header_8 = header === null || header === void 0 || (_header$entry14 = header.entry) === null || _header$entry14 === void 0 || (_header$entry14 = _header$entry14.header_themes) === null || _header$entry14 === void 0 ? void 0 : _header$entry14.top_text_color) !== null && _header$entry$header_8 !== void 0 ? _header$entry$header_8 : WHITELABEL_CONFIG.header.textColor;
  var topHeaderBackgroundColor = (_header$entry$header_9 = header === null || header === void 0 || (_header$entry15 = header.entry) === null || _header$entry15 === void 0 || (_header$entry15 = _header$entry15.header_themes) === null || _header$entry15 === void 0 ? void 0 : _header$entry15.top_background_color) !== null && _header$entry$header_9 !== void 0 ? _header$entry$header_9 : WHITELABEL_CONFIG.header.backgroundColor;
  var bottomHeaderBackgroundColor = (_header$entry$header_0 = header === null || header === void 0 || (_header$entry16 = header.entry) === null || _header$entry16 === void 0 || (_header$entry16 = _header$entry16.header_themes) === null || _header$entry16 === void 0 ? void 0 : _header$entry16.bottom_background_color) !== null && _header$entry$header_0 !== void 0 ? _header$entry$header_0 : WHITELABEL_CONFIG.header.backgroundColor;
  var fontLink = (_header$entry$header_1 = header === null || header === void 0 || (_header$entry17 = header.entry) === null || _header$entry17 === void 0 || (_header$entry17 = _header$entry17.header_themes) === null || _header$entry17 === void 0 || (_header$entry17 = _header$entry17.font) === null || _header$entry17 === void 0 ? void 0 : _header$entry17.font_link) !== null && _header$entry$header_1 !== void 0 ? _header$entry$header_1 : '';
  var fontFamily = (_header$entry$header_10 = header === null || header === void 0 || (_header$entry18 = header.entry) === null || _header$entry18 === void 0 || (_header$entry18 = _header$entry18.header_themes) === null || _header$entry18 === void 0 || (_header$entry18 = _header$entry18.font) === null || _header$entry18 === void 0 ? void 0 : _header$entry18.font_family) !== null && _header$entry$header_10 !== void 0 ? _header$entry$header_10 : '';
  var horizontalMenuBackgroundColor = (_header$entry$menu$ho = header === null || header === void 0 || (_header$entry19 = header.entry) === null || _header$entry19 === void 0 || (_header$entry19 = _header$entry19.menu.horizontal_menu_type_config) === null || _header$entry19 === void 0 ? void 0 : _header$entry19.background_menu_color) !== null && _header$entry$menu$ho !== void 0 ? _header$entry$menu$ho : WHITELABEL_CONFIG.menu.horizontalMenuBackgroundColor;
  var menuType = (_header$entry$menu$me = header === null || header === void 0 || (_header$entry20 = header.entry) === null || _header$entry20 === void 0 || (_header$entry20 = _header$entry20.menu) === null || _header$entry20 === void 0 ? void 0 : _header$entry20.menu_type) !== null && _header$entry$menu$me !== void 0 ? _header$entry$menu$me : '';
  return {
    isOnboardingEnabled: isOnboardingEnabled,
    isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
    geofinderConfigs: geofinderConfigs,
    isRecentSearchesEnabled: isRecentSearchesEnabled,
    isWishListEnabled: isWishListEnabled,
    isMyAccountEnabled: isMyAccountEnabled,
    isMyOrdersEnabled: isMyOrdersEnabled,
    crossBanner: crossBanner,
    searchbar: searchbar,
    mainLogoIcon: mainLogoIcon,
    logoURL: logoURL,
    menuConfig: menuConfig,
    menuTextColor: menuTextColor,
    myOrdersTextColor: myOrdersTextColor,
    myAccountTextColor: myAccountTextColor,
    topHeaderTextColor: topHeaderTextColor,
    topHeaderBackgroundColor: topHeaderBackgroundColor,
    bottomHeaderBackgroundColor: bottomHeaderBackgroundColor,
    fontLink: fontLink,
    fontFamily: fontFamily,
    horizontalMenuBackgroundColor: horizontalMenuBackgroundColor,
    menuType: menuType
  };
};
var onSearchTermChange = function onSearchTermChange(_ref) {
  var searchTerm = _ref.searchTerm,
    setErrorMessage = _ref.setErrorMessage,
    store = _ref.store,
    tenant = _ref.tenant;
  var lables = configs$1.lables,
    constants = configs$1.constants;
  if (searchTerm.length === 0) {
    setErrorMessage({
      title: lables.emptySearchErrorTitle,
      msg: lables.emptySearchErrorMessage
    });
    return false;
  }
  if (searchTerm.length < constants.MIN_SEARCH_TERM_LENGTH) {
    setErrorMessage({
      title: lables.incorrectSearchErrorTitle,
      msg: lables.incorrectSearchErrorMessage
    });
    return false;
  }
  var termo = encodeURIComponent(searchTerm).replace(/%20/g, '+');
  window.dispatchEvent(new CustomEvent('DDM_onSearching', {
    bubbles: true,
    detail: {
      value: termo,
      prefix: 'BCR'
    }
  }));
  var envBaseUrl = getWhitelabelSiteBaseUrl(tenant, store);
  var storeName = STORE_MAP[tenant][store];
  var searchPath = SEARCH_PATH[store];
  window.location.href = "".concat(envBaseUrl, "/").concat(storeName, "-").concat(tenant, "/").concat(searchPath, "?Ntt=").concat(termo);
  setErrorMessage(undefined);
  return true;
};

var UserActionDesktop = function UserActionDesktop(_ref2) {
  var _myOrdersDesktop$butt, _myOrdersDesktop$url;
  var isLoggedIn = _ref2.isLoggedIn,
    userFirstName = _ref2.userFirstName,
    welcomeLabel = _ref2.welcomeLabel,
    loginLabel = _ref2.loginLabel,
    a11yUserLabel = _ref2.a11yUserLabel,
    myAccountLabel = _ref2.myAccountLabel,
    noAccountLabel = _ref2.noAccountLabel,
    utilBarButtons = _ref2.utilBarButtons,
    logoutHandler = _ref2.logoutHandler,
    onLoadingStateChange = _ref2.onLoadingStateChange,
    isOnboardingInProgress = _ref2.isOnboardingInProgress,
    deviceType = _ref2.deviceType,
    listStyle = _ref2.listStyle,
    anchorStyle = _ref2.anchorStyle,
    toggleLoginForm = _ref2.toggleLoginForm,
    headerData = _ref2.headerData,
    tenant = _ref2.tenant,
    setMenuVisible = _ref2.setMenuVisible,
    isVendorLoggedIn = _ref2.isVendorLoggedIn,
    isAgentLoggedIn = _ref2.isAgentLoggedIn,
    isOrangeOrSISHeader = _ref2.isOrangeOrSISHeader,
    isSISLevel2Header = _ref2.isSISLevel2Header,
    store = _ref2.store;
  var myOrdersDesktop = utilBarButtons.myOrdersDesktop,
    myAccountDesktop = utilBarButtons.myAccountDesktop;
  var myOrderBtnText = (_myOrdersDesktop$butt = myOrdersDesktop === null || myOrdersDesktop === void 0 ? void 0 : myOrdersDesktop.button_text) !== null && _myOrdersDesktop$butt !== void 0 ? _myOrdersDesktop$butt : 'Mis Compras';
  var myOrderBtnUrl = (_myOrdersDesktop$url = myOrdersDesktop === null || myOrdersDesktop === void 0 ? void 0 : myOrdersDesktop.url) !== null && _myOrdersDesktop$url !== void 0 ? _myOrdersDesktop$url : 'Mis Compras';
  var _getStandaloneSite = getStandaloneSite(store),
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var entry = headerData.entry;
  var _extractHeaderConfig = extractHeaderConfig(headerData, deviceType),
    isMyAccountEnabled = _extractHeaderConfig.isMyAccountEnabled,
    isMyOrdersEnabled = _extractHeaderConfig.isMyOrdersEnabled;
  return jsxs(Fragment, {
    children: [myAccountDesktop && (isWhitelabelSite ? isMyAccountEnabled : true) && jsx("li", {
      className: "".concat(styles$q['user-info'], " ").concat(listStyle, " ").concat(isOnboardingInProgress ? styles$q['onboarding-highlight'] : null),
      children: jsx(UserInfo$1, {
        isLoggedIn: isLoggedIn,
        entry: entry,
        tenant: tenant,
        myAccountDesktop: myAccountDesktop,
        userFirstName: userFirstName,
        welcomeLabel: welcomeLabel,
        loginLabel: loginLabel,
        a11yUserLabel: a11yUserLabel,
        isOnboardingInProgress: isOnboardingInProgress,
        myAccountLabel: myAccountLabel,
        noAccountLabel: noAccountLabel,
        logoutHandler: logoutHandler,
        onLoadingStateChange: onLoadingStateChange,
        deviceType: deviceType,
        anchorStyle: anchorStyle,
        toggleLoginForm: toggleLoginForm,
        setMenuVisible: setMenuVisible,
        isVendorLoggedIn: isVendorLoggedIn,
        isAgentLoggedIn: isAgentLoggedIn,
        isOrangeOrSISHeader: isOrangeOrSISHeader,
        isSISLevel2Header: isSISLevel2Header,
        store: store
      })
    }), myOrdersDesktop && (isWhitelabelSite ? isMyOrdersEnabled : true) && jsx("li", {
      className: classNames(styles$q.orders, styles$q.highlight, listStyle),
      children: jsxs("a", {
        id: "testId-userAction-orders",
        className: classNames(styles$q['content-wrapper'], _defineProperty({}, styles$q['content-wrapper--to_com'], isTottusStandalone)),
        href: myOrderBtnUrl,
        onClick: function onClick() {
          return updateDigitalDataCookies({
            firstLevelItem: 'N1 - Mis compras',
            tag: HEADER
          });
        },
        children: [jsx("span", {
          className: classNames(styles$q['utils-span'], _defineProperty(_defineProperty({}, styles$q['utils-span--to_com'], isTottusStandalone), styles$q['utils-span--whitelabel'], isWhitelabelSite)),
          children: myOrderBtnText.split(' ')[0]
        }), jsx("span", {
          className: classNames(styles$q['utils-span-lower'], _defineProperty(_defineProperty({}, styles$q['utils-span-lower--to_com'], isTottusStandalone), styles$q['utils-span-lower--whitelabel'], isWhitelabelSite)),
          children: myOrderBtnText.split(' ')[1]
        })]
      })
    })]
  });
};
UserActionDesktop.propTypes = {
  utilBarButtons: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  userFirstName: PropTypes.string.isRequired,
  welcomeLabel: PropTypes.string.isRequired,
  loginLabel: PropTypes.string.isRequired,
  a11yUserLabel: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  myAccountLabel: PropTypes.string.isRequired,
  noAccountLabel: PropTypes.string.isRequired,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  logoutHandler: PropTypes.func.isRequired,
  onLoadingStateChange: PropTypes.func.isRequired,
  listStyle: PropTypes.string.isRequired,
  headerData: PropTypes.object.isRequired,
  anchorStyle: PropTypes.string.isRequired,
  tenant: PropTypes.string.isRequired,
  toggleLoginForm: PropTypes.func.isRequired,
  setMenuVisible: PropTypes.func,
  isVendorLoggedIn: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isOrangeOrSISHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  store: PropTypes.string
};
UserActionDesktop.defaultProps = {
  isVendorLoggedIn: false,
  isAgentLoggedIn: false
};
var UserActionDesktop$1 = UserActionDesktop;

var styles$p = {"modal-wrapper":"LoggedinModal-module_modal-wrapper__QmSST","modalHeader":"LoggedinModal-module_modalHeader__S1D-p","username":"LoggedinModal-module_username__FtSym","closeIcon":"LoggedinModal-module_closeIcon__-9Mtq","icon-cmr-icon":"LoggedinModal-module_icon-cmr-icon__FN-1c","modalBody":"LoggedinModal-module_modalBody__KgYDt"};

function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LoggedinModal = function LoggedinModal(_ref) {
  var _loggedinItems$redire, _loggedinItems$action;
  var deviceType = _ref.deviceType,
    modalVisible = _ref.modalVisible,
    loggedinItems = _ref.loggedinItems,
    helloUserText = _ref.helloUserText,
    logoutHandler = _ref.logoutHandler,
    isUserLoggedIn = _ref.isUserLoggedIn,
    isCmrPointsEnabled = _ref.isCmrPointsEnabled,
    myAccountLabel = _ref.myAccountLabel,
    toggleModal = _ref.toggleModal,
    mobileModalClass = _ref.mobileModalClass,
    tenant = _ref.tenant;
  var loginOptions = [];
  var items = (_loggedinItems$redire = loggedinItems === null || loggedinItems === void 0 ? void 0 : loggedinItems.redirection_items) !== null && _loggedinItems$redire !== void 0 ? _loggedinItems$redire : [];
  var actionItems = (_loggedinItems$action = loggedinItems === null || loggedinItems === void 0 ? void 0 : loggedinItems.action_items) !== null && _loggedinItems$action !== void 0 ? _loggedinItems$action : {};
  items.forEach(function (item, i) {
    loginOptions.push(_objectSpread$7(_objectSpread$7({}, item), {}, {
      id: "testId-redirection-item-mobile-".concat(i, "}"),
      handler: noop$2
    }));
  });
  Object.keys(actionItems).forEach(function (key, i) {
    if (key === 'cerrar_sesion') {
      loginOptions.push(_objectSpread$7(_objectSpread$7({}, actionItems[key]), {}, {
        handler: logoutHandler,
        id: "testId-action-item-mobile-".concat(i),
        type: 'actionLogOut'
      }));
    } else {
      loginOptions.push(_objectSpread$7({
        id: "testId-action-item-mobile-".concat(i)
      }, actionItems[key]));
    }
  });
  var initializeUrl = function initializeUrl(atgUrl, catalystUrl) {
    return CookieStorage$1.isCatalyst() ? catalystUrl : atgUrl;
  };
  var isMyAccount = function isMyAccount() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return title && title.toLowerCase() === myAccountLabel.toLowerCase();
  };
  return jsx("div", {
    children: jsx(Modal, {
      toggleState: {
        visible: modalVisible,
        setVisible: toggleModal
      },
      isOverlayEnabled: false,
      content: function content(_ref2) {
        var close = _ref2.close;
        return jsxs("div", {
          className: styles$p['modal-wrapper'],
          children: [jsxs("div", {
            className: styles$p.modalHeader,
            children: [jsx("p", {
              className: styles$p.username,
              children: helloUserText
            }), jsx("i", {
              onClick: close,
              className: styles$p.closeIcon
            })]
          }), jsx("div", {
            className: styles$p.modalBody,
            children: jsx("ul", {
              children: loginOptions.map(function (_ref3) {
                var atg_url = _ref3.atg_url,
                  catalyst_url = _ref3.catalyst_url,
                  _ref3$handler = _ref3.handler,
                  handler = _ref3$handler === void 0 ? noop$2 : _ref3$handler,
                  icon = _ref3.icon,
                  is_cmr = _ref3.is_cmr,
                  is_new_tab = _ref3.is_new_tab,
                  title = _ref3.title,
                  type = _ref3.type,
                  id = _ref3.id;
                if (is_cmr) {
                  return jsx("li", {
                    children: jsx(CmrPuntosMenuMobile, {
                      cmrPuntosURL: initializeUrl(atg_url, catalyst_url),
                      cmrpuntosImageUrl: icon.url,
                      cmrText: title,
                      imageStyle: 'icon-cmr-icon',
                      isCmrPointsEnabled: isCmrPointsEnabled,
                      isLoggedIn: isUserLoggedIn,
                      isRebrandingEnabled: true,
                      tenantId: "falabella-".concat(tenant)
                    })
                  }, title);
                }
                return jsx("li", {
                  children: type === 'actionLogOut' ? jsx("a", {
                    id: id,
                    href: "#",
                    onClick: function onClick(e) {
                      e.preventDefault();
                      close();
                      handler();
                    },
                    children: title
                  }) : jsx("a", {
                    style: isMyAccount(title) ? {
                      fontWeight: 'bold'
                    } : {},
                    id: id,
                    target: is_new_tab ? '_blank' : '',
                    href: initializeUrl(catalyst_url, atg_url),
                    rel: "noreferrer",
                    children: title
                  })
                }, title);
              })
            })
          })]
        });
      },
      options: {
        width: 500,
        height: 331,
        disableOutsideClick: false,
        overflow: 'visible',
        borderRadius: '10px 10px 0px 0px',
        padding: '25px 27px 0 24px'
      },
      deviceType: deviceType,
      fullWidth: true,
      withPadding: false,
      customClass: mobileModalClass,
      showCloseButton: false
    })
  });
};
LoggedinModal.propTypes = {
  deviceType: PropTypes.string,
  tenant: PropTypes.string,
  modalVisible: PropTypes.bool.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  isCmrPointsEnabled: PropTypes.bool.isRequired,
  myAccountLabel: PropTypes.string,
  mobileModalClass: PropTypes.string,
  loggedinItems: PropTypes.object,
  helloUserText: PropTypes.any,
  logoutHandler: PropTypes.func,
  toggleModal: PropTypes.func.isRequired
};
LoggedinModal.defaultProps = {
  loggedinItems: {},
  helloUserText: null,
  logoutHandler: noop$2,
  myAccountLabel: '',
  mobileModalClass: '',
  tenant: ''
};
var LoggedinModal$1 = LoggedinModal;

function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isSmallScreenWidth = isWindow$1() && window.innerWidth < 335;
var fetchElemWidth = function fetchElemWidth() {
  return isSmallScreenWidth ? {
    width: '60px'
  } : {
    width: '70px'
  };
};
var UserActions = function UserActions(_ref) {
  var _myaccount_mobile$ite, _myaccount_mobile$ite2, _headerData$entry$hea, _headerData$entry, _myaccount_desktop$he, _cart$icon_desktop$ur, _cart$icon_desktop, _cart$gray_icon_deskt, _cart$gray_icon_deskt2, _cart$icon_mobile$url, _cart$icon_mobile, _cart$gray_icon_mobil, _cart$gray_icon_mobil2, _myaccount_mobile$ite3;
  var _ref$isUserLoggedIn = _ref.isUserLoggedIn,
    isUserLoggedIn = _ref$isUserLoggedIn === void 0 ? false : _ref$isUserLoggedIn,
    setUserLoggedIn = _ref.setUserLoggedIn,
    firstName = _ref.firstName,
    cartCount = _ref.cartCount,
    setFirstName = _ref.setFirstName,
    setCartCount = _ref.setCartCount,
    atgBaseUrl = _ref.atgBaseUrl,
    catalystBaseUrl = _ref.catalystBaseUrl,
    onLoadingStateChange = _ref.onLoadingStateChange,
    onUserLogout = _ref.onUserLogout,
    deviceType = _ref.deviceType,
    headerData = _ref.headerData,
    isOnboardingInProgress = _ref.isOnboardingInProgress,
    onUserLogin = _ref.onUserLogin,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    userCartCount = _ref.userCartCount,
    setHideMenuBar = _ref.setHideMenuBar,
    modalVisible = _ref.modalVisible,
    mobileModalClass = _ref.mobileModalClass,
    toggleModal = _ref.toggleModal,
    setMenuVisible = _ref.setMenuVisible,
    forceATG = _ref.forceATG,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isStore = _ref.isStore,
    _ref$isOrangeOrSISHea = _ref.isOrangeOrSISHeader,
    isOrangeOrSISHeader = _ref$isOrangeOrSISHea === void 0 ? false : _ref$isOrangeOrSISHea,
    isSISLevel2Header = _ref.isSISLevel2Header,
    store = _ref.store,
    showLoginForm = _ref.showLoginForm,
    setShowLoginForm = _ref.setShowLoginForm,
    getUserSegments = _ref.getUserSegments;
  var _useContext = useContext(AppContext$1),
    tenant = _useContext.tenant;
  var labels = UserActionConfig$1.labels;
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var _useState = useState({
      enabled: false,
      cartId: '',
      siteName: '',
      ecommName: '',
      defaultColor: '',
      multiSite: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    whiteLabelProp = _useState2[0],
    setWhiteLabelProp = _useState2[1];
  var envBaseUrl = getEnvBaseUrl(tenant);
  var loginWizardBaseUrl = !unifiedLoginBaseUrl ? envBaseUrl : unifiedLoginBaseUrl;
  var toggleLoginForm = useCallback(function () {
    setShowLoginForm(function (v) {
      setHideMenuBar(!v);
      return !v;
    });
  });
  useEffect(function () {
    if (userCartCount) {
      setCartCount(userCartCount);
    }
  }, [userCartCount]);
  useEffect(function () {
    var onCartCountUpdated = function onCartCountUpdated(e) {
      var _e$detail$count, _e$detail;
      return setCartCount(Number((_e$detail$count = e === null || e === void 0 || (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.count) !== null && _e$detail$count !== void 0 ? _e$detail$count : 0));
    };
    window.addEventListener('CART_COUNT_UPDATED', onCartCountUpdated);
    return function () {
      return window.removeEventListener('CART_COUNT_UPDATED', onCartCountUpdated);
    };
  }, []);
  var onLogin = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(response) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!response.loginStatus) {
              _context.next = 1;
              break;
            }
            setUserLoggedIn(true);
            _context.next = 1;
            return onUserLogin(response);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onLogin(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClose = function onClose() {
    toggleLoginForm();
  };
  var _ref3 = headerData.entry || {},
    _ref3$myaccount_deskt = _ref3.myaccount_desktop,
    myaccount_desktop = _ref3$myaccount_deskt === void 0 ? {} : _ref3$myaccount_deskt,
    _ref3$myorders_deskto = _ref3.myorders_desktop,
    myorders_desktop = _ref3$myorders_deskto === void 0 ? {} : _ref3$myorders_deskto,
    _ref3$myaccount_mobil = _ref3.myaccount_mobile,
    myaccount_mobile = _ref3$myaccount_mobil === void 0 ? {} : _ref3$myaccount_mobil,
    _ref3$cart = _ref3.cart,
    cart = _ref3$cart === void 0 ? {} : _ref3$cart,
    _ref3$wishlist = _ref3.wishlist,
    wishlist = _ref3$wishlist === void 0 ? {} : _ref3$wishlist;
  var _extractHeaderConfig = extractHeaderConfig(headerData, deviceType),
    isWishListEnabled = _extractHeaderConfig.isWishListEnabled,
    isMyAccountEnabled = _extractHeaderConfig.isMyAccountEnabled;
  var handleUserLogout = function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
      var _data$errors, _data$success;
      var data, errors, success;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            onLoadingStateChange(true);
            _context2.next = 1;
            return logout({
              tenantId: getEcommerceName(store, tenant),
              atgBaseUrl: atgBaseUrl,
              catalystBaseUrl: catalystBaseUrl,
              forceATG: forceATG,
              additionalInfo: isWhitelabelSite ? {
                whitelabel: whiteLabelProp
              } : {}
            });
          case 1:
            data = _context2.sent;
            errors = (_data$errors = data === null || data === void 0 ? void 0 : data.errors) !== null && _data$errors !== void 0 ? _data$errors : [];
            success = (_data$success = data === null || data === void 0 ? void 0 : data.success) !== null && _data$success !== void 0 ? _data$success : false;
            if (!(success || errors[0] && errors[0].code === 'SESSION_CONFIRMATION_NUMBER_MISMATCH_ERROR')) {
              _context2.next = 3;
              break;
            }
            setUserLoggedIn(false);
            _context2.next = 2;
            return onUserLogout();
          case 2:
            onLoadingStateChange(false);
            window.location.reload(true);
          case 3:
            _context2.prev = 3;
            if (!(errors.length >= 0)) {
              _context2.next = 4;
              break;
            }
            setUserLoggedIn(false);
            throw new Error('Logout POST request failed');
          case 4:
            setUserLoggedIn(false);
            throw new Error('Received error response for logout');
          case 5:
            _context2.next = 7;
            break;
          case 6:
            _context2.prev = 6;
            _context2["catch"](3);
            return _context2.abrupt("return", undefined);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 6]]);
    }));
    return function handleUserLogout() {
      return _ref4.apply(this, arguments);
    };
  }();
  var utilBarButtonsCopy = {
    myOrdersDesktop: _objectSpread$6({}, myorders_desktop),
    myAccountDesktop: _objectSpread$6({}, myaccount_desktop)
  };
  var loginText = (_myaccount_mobile$ite = myaccount_mobile === null || myaccount_mobile === void 0 || (_myaccount_mobile$ite2 = myaccount_mobile.items_logged_out) === null || _myaccount_mobile$ite2 === void 0 ? void 0 : _myaccount_mobile$ite2.login_text) !== null && _myaccount_mobile$ite !== void 0 ? _myaccount_mobile$ite : 'Inicia sesión';
  var isCmrPointsEnabled = (_headerData$entry$hea = headerData === null || headerData === void 0 || (_headerData$entry = headerData.entry) === null || _headerData$entry === void 0 || (_headerData$entry = _headerData$entry.header_configs) === null || _headerData$entry === void 0 || (_headerData$entry = _headerData$entry[0]) === null || _headerData$entry === void 0 || (_headerData$entry = _headerData$entry.toggles) === null || _headerData$entry === void 0 ? void 0 : _headerData$entry.iscmrenabled) !== null && _headerData$entry$hea !== void 0 ? _headerData$entry$hea : false;
  var helloText = (_myaccount_desktop$he = myaccount_desktop === null || myaccount_desktop === void 0 ? void 0 : myaccount_desktop.hello_text) !== null && _myaccount_desktop$he !== void 0 ? _myaccount_desktop$he : 'Hola';
  var cartIconSrc = {
    desktop: isOrangeOrSISHeader ? (_cart$icon_desktop$ur = cart === null || cart === void 0 || (_cart$icon_desktop = cart.icon_desktop) === null || _cart$icon_desktop === void 0 ? void 0 : _cart$icon_desktop.url) !== null && _cart$icon_desktop$ur !== void 0 ? _cart$icon_desktop$ur : '' : (_cart$gray_icon_deskt = cart === null || cart === void 0 || (_cart$gray_icon_deskt2 = cart.gray_icon_desktop) === null || _cart$gray_icon_deskt2 === void 0 ? void 0 : _cart$gray_icon_deskt2.url) !== null && _cart$gray_icon_deskt !== void 0 ? _cart$gray_icon_deskt : CART_ICON_URL,
    mobile: isOrangeOrSISHeader ? (_cart$icon_mobile$url = cart === null || cart === void 0 || (_cart$icon_mobile = cart.icon_mobile) === null || _cart$icon_mobile === void 0 ? void 0 : _cart$icon_mobile.url) !== null && _cart$icon_mobile$url !== void 0 ? _cart$icon_mobile$url : '' : (_cart$gray_icon_mobil = cart === null || cart === void 0 || (_cart$gray_icon_mobil2 = cart.gray_icon_mobile) === null || _cart$gray_icon_mobil2 === void 0 ? void 0 : _cart$gray_icon_mobil2.url) !== null && _cart$gray_icon_mobil !== void 0 ? _cart$gray_icon_mobil : CART_ICON_URL_MOBILE
  };
  var shouldRenderWishlistItem = wishlist.is_enable || isWhitelabelSite && isWishListEnabled;
  useEffect(function () {
    var userCookie = CookieStorage$1.getUserDataCookieName();
    var userDetails = CookieStorage$1.unescapeATGCookies(CookieStorage$1.getCookie(userCookie) || '').split('*');
    setFirstName(isUserLoggedIn && decodeURIComponent(userDetails[0]));
    setCartCount(userDetails[1]);
    getUserSegments();
  }, [isUserLoggedIn]);
  var handlePageShow = function handlePageShow(event) {
    if (event.persisted) {
      var userCookie = CookieStorage$1.getUserDataCookieName();
      var userDetails = CookieStorage$1.unescapeATGCookies(CookieStorage$1.getCookie(userCookie) || '').split('*');
      setFirstName(isUserLoggedIn && decodeURIComponent(userDetails === null || userDetails === void 0 ? void 0 : userDetails[0]));
      setCartCount((userDetails === null || userDetails === void 0 ? void 0 : userDetails[1]) || 0);
    }
  };
  useEffect(function () {
    setWhiteLabelProp(generateWhiteLabelProps(store, tenant));
    window.addEventListener('pageshow', handlePageShow);
    return function () {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);
  return jsxs(Fragment, {
    children: [jsx(LoginWizard, {
      atgBaseUrl: atgBaseUrl,
      catalystBaseUrl: catalystBaseUrl,
      onLogin: onLogin,
      onClose: onClose,
      show: showLoginForm,
      tenant: tenant,
      flowType: "header",
      doMergeCart: true,
      id: "testId-cc",
      isRebrandingEnabled: true,
      forceATG: forceATG,
      onComplete: onUserLoginComplete,
      onConsentsUpdate: onUserLoginConsentsUpdate,
      onPasswordUpdate: onUserLoginPasswordUpdate,
      baseUrl: loginWizardBaseUrl,
      whitelabel: whiteLabelProp
    }), jsxs("div", {
      className: classNames(styles$q.utils, _defineProperty({}, styles$q.whitlabel, isWhitelabelSite)),
      children: [jsxs("ul", {
        className: styles$q['utils-ul'],
        children: [jsx(MatchMedia$1, {
          content: {
            desktop: function desktop() {
              var _wishlist$icon_deskto, _wishlist$icon_deskto2, _wishlist$gray_icon_d, _wishlist$gray_icon_d2;
              return myaccount_desktop && jsxs(Fragment, {
                children: [jsx(UserActionDesktop$1, {
                  utilBarButtons: utilBarButtonsCopy,
                  isLoggedIn: isUserLoggedIn,
                  userFirstName: firstName,
                  headerData: headerData,
                  tenant: tenant,
                  isOnboardingInProgress: isOnboardingInProgress,
                  welcomeLabel: labels.WELCOME_LABEL,
                  loginLabel: labels.LOGIN_LABEL,
                  a11yUserLabel: labels.A11Y_USER_LABEL,
                  myAccountLabel: labels.MY_ACCOUNT_LABEL,
                  noAccountLabel: labels.NO_ACCOUNT_LABEL,
                  logoutHandler: handleUserLogout,
                  onLoadingStateChange: onLoadingStateChange,
                  deviceType: deviceType,
                  listStyle: styles$q['utils-list'],
                  anchorStyle: styles$q['utils-anchor'],
                  toggleLoginForm: toggleLoginForm,
                  setMenuVisible: setMenuVisible,
                  isVendorLoggedIn: isVendorLoggedIn,
                  isAgentLoggedIn: isAgentLoggedIn,
                  isOrangeOrSISHeader: isOrangeOrSISHeader,
                  isSISLevel2Header: isSISLevel2Header,
                  store: store
                }), shouldRenderWishlistItem && jsx("li", {
                  className: classNames(styles$q['utils-list'], styles$q['wishlist-icon'], _defineProperty({}, styles$q['wishlist-icon--to_com'], isTottusStandalone)),
                  children: jsx("div", {
                    children: jsx("a", {
                      id: "testId-UserAction-wishlist",
                      className: classNames(styles$q['utils-anchor']),
                      href: wishlist.url,
                      onClick: function onClick() {
                        return updateDigitalDataCookies({
                          firstLevelItem: 'N1 - Mis listas',
                          tag: HEADER
                        });
                      },
                      children: jsx("i", {
                        id: "wishlist-icon",
                        "data-icontype": "wishlist",
                        style: {
                          backgroundImage: "url(".concat(isOrangeOrSISHeader ? (_wishlist$icon_deskto = wishlist === null || wishlist === void 0 || (_wishlist$icon_deskto2 = wishlist.icon_desktop) === null || _wishlist$icon_deskto2 === void 0 ? void 0 : _wishlist$icon_deskto2.url) !== null && _wishlist$icon_deskto !== void 0 ? _wishlist$icon_deskto : '' : (_wishlist$gray_icon_d = wishlist === null || wishlist === void 0 || (_wishlist$gray_icon_d2 = wishlist.gray_icon_desktop) === null || _wishlist$gray_icon_d2 === void 0 ? void 0 : _wishlist$gray_icon_d2.url) !== null && _wishlist$gray_icon_d !== void 0 ? _wishlist$gray_icon_d : WISHLIST_ICON_URL, ")")
                        },
                        className: classNames(styles$q.utilIcon, _defineProperty({}, styles$q['utilIcon--to_com'], isTottusStandalone))
                      })
                    })
                  })
                }), jsx("li", {
                  className: classNames(styles$q['utils-list'], styles$q['basket-icon'], _defineProperty({}, styles$q['utils-list--to_com'], isTottusStandalone)),
                  children: jsxs("div", {
                    className: classNames(styles$q['orders-content-wrapper'], _defineProperty({}, styles$q['orders-content-wrapper--to_com'], isTottusStandalone)),
                    children: [jsx("a", {
                      id: "testId-UserAction-basket",
                      className: classNames(styles$q['utils-anchor']),
                      href: cart.url,
                      onClick: function onClick() {
                        return updateDigitalDataCookies({
                          firstLevelItem: 'N1 - Basket',
                          tag: HEADER
                        });
                      },
                      children: jsx("i", {
                        style: {
                          backgroundImage: "url(".concat(cartIconSrc.desktop, ")")
                        },
                        className: classNames(styles$q.utilIcon, _defineProperty({}, styles$q['utilIcon--whitelabel'], isWhitelabelSite))
                      })
                    }), jsx("span", {
                      className: classNames(styles$q['has-count-desktop'], isStore && styles$q['store-stroke']),
                      children: cartCount
                    })]
                  })
                })]
              });
            }
          }
        }), deviceType !== 'desktop' && cart && cart.icon_mobile && cart.icon_mobile.url && jsx(MediaComponent$1, {
          from: "mobile",
          to: "tablet",
          children: jsxs(React.Fragment, {
            children: [(isWhitelabelSite ? isMyAccountEnabled : true) && jsx("li", {
              className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$q['login-list'], true), styles$q['login-list--so_com'], isSodimacStandalone), styles$q['login-list--to_com'], isTottusStandalone)),
              children: isUserLoggedIn ? jsxs("div", {
                id: "testId-loggedin-user",
                className: classNames(_defineProperty({}, styles$q.login_list_store, isStore)),
                onClick: function onClick() {
                  return toggleModal(true);
                },
                children: [jsx("span", {
                  children: helloText
                }), jsx("p", {
                  style: firstName && firstName.length >= 10 ? fetchElemWidth() : {
                    width: 'auto'
                  },
                  children: firstName && firstName.length > 10 ? "".concat(firstName.slice(0, 10), "...") : firstName
                })]
              }) : jsx("p", {
                id: "testId-Inicia-sesi\xF3n",
                role: "button",
                onClick: toggleLoginForm,
                className: classNames(_defineProperty({}, styles$q.store_inicia, isStore)),
                children: loginText
              })
            }), jsx("li", {
              className: classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$q['utils-list-mobile'], true), styles$q['utils-list-mobile--so_com'], isSodimacStandalone), styles$q['utils-list-mobile--to_com'], isTottusStandalone), styles$q['basket-icon'], true)),
              children: jsx("div", {
                className: styles$q['content-wrapper'],
                children: jsx("a", {
                  id: "testId-UserAction-basket",
                  className: classNames(styles$q['utils-anchor']),
                  href: cart.url,
                  children: isStandaloneSite ? jsxs("div", {
                    className: styles$q['cart-container'],
                    children: [jsx("img", {
                      src: cartIconSrc.mobile,
                      alt: "cart-icon",
                      className: classNames(_defineProperty({}, styles$q['cart-icon'], true))
                    }), jsx("div", {
                      className: classNames(styles$q['cart-count-container'], _defineProperty({}, styles$q['cart-count-container--to_com'], isTottusStandalone)),
                      children: jsx("span", {
                        className: classNames(styles$q['cart-count-value'], _defineProperty({}, styles$q['cart-count-value--to_com'], isTottusStandalone)),
                        children: cartCount
                      })
                    })]
                  }) : jsx("i", {
                    style: {
                      backgroundImage: "url(".concat(cartIconSrc.mobile, ")")
                    },
                    className: classNames(styles$q.utilIcon, styles$q['has-count'], isStore && styles$q['store-stroke']),
                    "data-count": cartCount
                  })
                })
              })
            })]
          })
        })]
      }), deviceType !== 'desktop' && jsx(LoggedinModal$1, {
        modalVisible: modalVisible,
        toggleModal: toggleModal,
        mobileModalClass: mobileModalClass,
        loggedinItems: (_myaccount_mobile$ite3 = myaccount_mobile === null || myaccount_mobile === void 0 ? void 0 : myaccount_mobile.items_logged_in) !== null && _myaccount_mobile$ite3 !== void 0 ? _myaccount_mobile$ite3 : {},
        helloUserText: "".concat(helloText, ", ").concat(firstName),
        logoutHandler: handleUserLogout,
        isUserLoggedIn: isUserLoggedIn,
        isCmrPointsEnabled: isCmrPointsEnabled,
        myAccountLabel: labels.MY_ACCOUNT_LABEL,
        tenant: tenant,
        deviceType: deviceType
      })]
    })]
  });
};
UserActions.propTypes = {
  showSearchBar: PropTypes.bool.isRequired,
  setShowSearchBar: PropTypes.func.isRequired,
  cartCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  firstName: PropTypes.string.isRequired,
  labels: PropTypes.object,
  appCtx: PropTypes.object,
  isUserLoggedIn: PropTypes.bool.isRequired,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  setUserLoggedIn: PropTypes.func.isRequired,
  setFirstName: PropTypes.func,
  setCartCount: PropTypes.func,
  isATGLoginEnabled: PropTypes.bool,
  isInternetExplorer: PropTypes.bool,
  atgBaseUrl: PropTypes.string.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  onLoadingStateChange: PropTypes.func,
  onUserLogout: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired,
  headerData: PropTypes.object.isRequired,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  unifiedLoginBaseUrl: PropTypes.string,
  userCartCount: PropTypes.number,
  setHideMenuBar: PropTypes.func,
  modalVisible: PropTypes.bool,
  mobileModalClass: PropTypes.string,
  toggleModal: PropTypes.func,
  setMenuVisible: PropTypes.func,
  forceATG: PropTypes.bool.isRequired,
  isAgentLoggedIn: PropTypes.bool.isRequired,
  isVendorLoggedIn: PropTypes.bool.isRequired,
  isStore: PropTypes.bool,
  isOrangeOrSISHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  store: PropTypes.string,
  getUserSegments: PropTypes.func.isRequired
};
UserActions.defaultProps = {
  cartCount: 0,
  setFirstName: noop$2,
  setCartCount: noop$2,
  isATGLoginEnabled: false,
  isInternetExplorer: false,
  onLoadingStateChange: noop$2,
  onUserLogout: noop$2,
  onUserLogin: noop$2,
  onUserLoginComplete: noop$2,
  onUserLoginConsentsUpdate: noop$2,
  onUserLoginPasswordUpdate: noop$2,
  unifiedLoginBaseUrl: undefined,
  setHideMenuBar: noop$2,
  toggleModal: noop$2,
  modalVisible: false,
  isAgentLoggedIn: false,
  isVendorLoggedIn: false,
  mobileModalClass: '',
  isStore: false
};
var UserActions$1 = withUser(UserActions);

var liveStreamConfig = {
  inputStream: {
    type: 'LiveStream',
    constraints: {
      width: {
        min: 640
      },
      height: {
        min: 480
      },
      aspectRatio: {
        min: 1,
        max: 100
      },
      facingMode: 'environment'
    }
  },
  locator: {
    patchSize: 'medium',
    halfSample: true
  },
  numOfWorkers: 2,
  frequency: 10,
  decoder: {
    readers: [{
      format: 'ean_reader',
      config: {}
    }, {
      format: 'code_128_reader',
      config: {}
    }]
  },
  locate: true
};
function startQuaggaLivestream(detectedCallback) {
  Quagga.init(liveStreamConfig, function (err) {
    if (err) {
      return;
    }
    Quagga.start();
  });
  Quagga.onProcessed(function (result) {
    var drawingCtx = Quagga.canvas.ctx.overlay;
    var drawingCanvas = Quagga.canvas.dom.overlay;
    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width'), 10), parseInt(drawingCanvas.getAttribute('height'), 10));
        result.boxes.filter(function (box) {
          return box !== result.box;
        }).forEach(function (box) {
          Quagga.ImageDebug.drawPath(box, {
            x: 0,
            y: 1
          }, drawingCtx, {
            color: 'green',
            lineWidth: 2
          });
        });
      }
      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, {
          x: 0,
          y: 1
        }, drawingCtx, {
          color: '#00F',
          lineWidth: 2
        });
      }
      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(result.line, {
          x: 'x',
          y: 'y'
        }, drawingCtx, {
          color: 'red',
          lineWidth: 3
        });
      }
    }
  });
  Quagga.onDetected(detectedCallback);
}
function stopQuaggaLivestream() {
  Quagga.stop();
}

var generateInput = function generateInput() {
  var input = document.querySelector('.scanner-input');
  var inputContainer = document.querySelector('#interactive.viewport');
  if (inputContainer && !input) {
    input = document.createElement('input');
    input.classList.add('scanner-input');
    input.setAttribute('type', 'file');
    input.setAttribute('style', 'display:none;');
    inputContainer.appendChild(input);
  }
  return {
    input: input
  };
};
var removeInput = function removeInput() {
  var input = document.querySelector('.scanner-input');
  if (input) {
    input.parentElement.removeChild(input);
  }
};
var startQuaggaPicture = function startQuaggaPicture(detectedCallback) {
  var _generateInput = generateInput(),
    input = _generateInput.input;
  if (!input) {
    return;
  }
  input.addEventListener('change', function (e) {
    if (e.target && e.target.files) {
      Quagga.decodeSingle({
        inputStream: {
          singleChannel: false,
          size: 800
        },
        locator: {
          patchSize: 'medium',
          halfSample: true
        },
        decoder: {
          readers: ['upc_reader', 'code_128_reader', 'code_39_reader', 'code_39_vin_reader', 'ean_8_reader', 'ean_reader', 'upc_e_reader', 'codabar_reader']
        },
        locate: true,
        src: URL.createObjectURL(e.target.files[0])
      }, function (result) {
        detectedCallback(result);
      });
    }
  });
  input.click();
};
var stopQuaggaPicture = function stopQuaggaPicture() {
  removeInput();
};

var styles$o = {"video_overlays":"ProductScanner-module_video_overlays__vOIhs","topText__overlay":"ProductScanner-module_topText__overlay__dp7I2","centerSquare":"ProductScanner-module_centerSquare__z-uvT","maskTop":"ProductScanner-module_maskTop__gNe04","maskBottom":"ProductScanner-module_maskBottom__hex0b","interactive":"ProductScanner-module_interactive__AsxKF","guided-scan-container":"ProductScanner-module_guided-scan-container__1wcM8","portrait":"ProductScanner-module_portrait__ULDsn","landscape":"ProductScanner-module_landscape__tzOFr","bottomText__overlay":"ProductScanner-module_bottomText__overlay__-YUcZ","cancelButton":"ProductScanner-module_cancelButton__puxrI"};

var styles$n = {"scannerModalOverlay":"ScanModalOverlay-module_scannerModalOverlay__lQ1YC","modal-title":"ScanModalOverlay-module_modal-title__DsB40","modal-option":"ScanModalOverlay-module_modal-option__8iKMj"};

var ScanModalOverlay = function ScanModalOverlay(_ref) {
  var scanOtherProduct = _ref.scanOtherProduct,
    modalInformation = _ref.modalInformation,
    vendorProductAvailableLabel = _ref.vendorProductAvailableLabel,
    vendorPriceLabel = _ref.vendorPriceLabel,
    vendorStockLabel = _ref.vendorStockLabel,
    vendorScanAnotherProductLabel = _ref.vendorScanAnotherProductLabel,
    vendorInformationNotAvailableLabel = _ref.vendorInformationNotAvailableLabel;
  var _ref2 = modalInformation || {},
    displayName = _ref2.displayName,
    price = _ref2.price,
    message = _ref2.message;
  return jsxs("div", {
    className: styles$n.scannerModalOverlay,
    children: [displayName || price ? jsxs(Fragment, {
      children: [jsx("div", {
        className: styles$n['modal-title'],
        children: "".concat(vendorProductAvailableLabel, ": ").concat(displayName)
      }), jsx("div", {
        className: styles$n['modal-title'],
        children: "".concat(vendorPriceLabel, ": ").concat(price)
      }), jsx("div", {
        className: styles$n['modal-title'],
        children: "".concat(vendorStockLabel, ": disponible")
      })]
    }) : jsx("div", {
      className: styles$n['modal-title'],
      children: message || vendorInformationNotAvailableLabel
    }), jsx("button", {
      className: styles$n['modal-option'],
      type: "button",
      onClick: function onClick() {
        scanOtherProduct();
      },
      children: vendorScanAnotherProductLabel
    })]
  });
};
ScanModalOverlay.propTypes = {
  scanOtherProduct: PropTypes.func.isRequired,
  modalInformation: PropTypes.object.isRequired,
  vendorProductAvailableLabel: PropTypes.string,
  vendorPriceLabel: PropTypes.string,
  vendorStockLabel: PropTypes.string,
  vendorScanAnotherProductLabel: PropTypes.string,
  vendorInformationNotAvailableLabel: PropTypes.string
};
ScanModalOverlay.defaultProps = {
  vendorProductAvailableLabel: '',
  vendorPriceLabel: '',
  vendorStockLabel: '',
  vendorScanAnotherProductLabel: '',
  vendorInformationNotAvailableLabel: ''
};
var ScanModalOverlay$1 = ScanModalOverlay;

var ScanLoadingOverlay = function ScanLoadingOverlay(_ref) {
  var loadingLabel = _ref.loadingLabel;
  return jsx("div", {
    className: styles$n.scannerModalOverlay,
    children: jsx("div", {
      className: styles$n['modal-title'],
      children: loadingLabel
    })
  });
};
ScanLoadingOverlay.defaultProps = {
  loadingLabel: ''
};
ScanLoadingOverlay.propTypes = {
  loadingLabel: PropTypes.string
};
var ScanLoadingOverlay$1 = ScanLoadingOverlay;

var apiConfig = {
  getScanSkuDetailsUrl: function getScanSkuDetailsUrl(regionCode, productCode) {
    return "/s/browse/v1/scanSkuDetails/".concat(regionCode, "?{\"productCode\":").concat(productCode, ",\"flagScanner\":true,\"codeType\":\"EAN\"}");
  }
};
var apiConfig$1 = apiConfig;

var ProductScanner = function ProductScanner(_ref) {
  var _ref$regionCode = _ref.regionCode,
    regionCode = _ref$regionCode === void 0 ? 'cl' : _ref$regionCode,
    deviceType = _ref.deviceType,
    onScannerClose = _ref.onScannerClose;
  if (!global.window && !global.document) {
    return null;
  }
  var vendorInvalidCodeLabel = 'Lo sentimos, no hemos podido encontrar el producto escaneado.';
  var vendorBarcodeCenterLabel = 'Centra tu código de barras y evita mover tu teléfono.';
  var vendorScanInfoLabel = 'El escaneo es automático, evita brillos y reflejos.';
  var vendorCancelButtonLabel = 'CANCELAR';
  var vendorProductAvailableLabel = 'Producto disponible en tienda';
  var vendorPriceLabel = 'Precio';
  var vendorStockLabel = 'Stock';
  var vendorScanAnotherProductLabel = 'ESCANEAR OTRO PRODUCTO';
  var vendorInformationNotAvailableLabel = 'Informacion no disponible';
  var vendorLoadingLabel = 'Buscando..';
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setActive = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    modalData = _useState6[0],
    setModalData = _useState6[1];
  var clearInternalCanvas = function clearInternalCanvas() {
    var video = document.querySelector('#interactive video');
    var canvas = document.querySelector('#interactive canvas');
    if (video) {
      video.outerHTML = '';
    }
    if (canvas) {
      canvas.outerHTML = '';
    }
  };
  var _useState7 = useState('portrait'),
    _useState8 = _slicedToArray(_useState7, 2),
    deviceOrientation = _useState8[0],
    setDeviceOrientation = _useState8[1];
  useEffect(function () {
    if (process.browser) {
      if (global.window.innerHeight > global.window.innerWidth) {
        setDeviceOrientation('portrait');
      } else {
        setDeviceOrientation('landscape');
      }
    }
  }, [deviceType]);
  var getProductDetails = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(code) {
      var scanSkuDetailsUrl, response, _response$products$0$, url, id, displayName, prices, price;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            scanSkuDetailsUrl = apiConfig$1.getScanSkuDetailsUrl(regionCode, code);
            _context.prev = 1;
            _context.next = 2;
            return doFetch(scanSkuDetailsUrl);
          case 2:
            response = _context.sent;
            if (!(response && response.products && response.products.length > 0)) {
              _context.next = 4;
              break;
            }
            _response$products$0$ = response.products[0].product, url = _response$products$0$.url, id = _response$products$0$.id, displayName = _response$products$0$.displayName, prices = _response$products$0$.prices;
            setLoading(false);
            if (!(url && id)) {
              _context.next = 3;
              break;
            }
            global.window.location.assign(url.startsWith('/') ? url : "/".concat(url));
            return _context.abrupt("return");
          case 3:
            price = prices[0].originalPrice;
            setModalData({
              displayName: displayName,
              price: price
            });
            return _context.abrupt("return");
          case 4:
            setLoading(false);
            setModalData({
              message: vendorInvalidCodeLabel
            });
            _context.next = 6;
            break;
          case 5:
            _context.prev = 5;
            _context["catch"](1);
            setLoading(false);
            setModalData({
              message: vendorInformationNotAvailableLabel
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 5]]);
    }));
    return function getProductDetails(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var pictureCallback = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(result) {
      var code;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (result && result.codeResult && result.codeResult.code) {
              stopQuagga();
              clearInternalCanvas();
              setLoading(true);
              code = result.codeResult.code;
              getProductDetails(code);
            } else {
              setModalData(undefined);
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function pictureCallback(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var codeValues = {};
  var livestreamCallback = function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(result) {
      var _result$codeResult$co, code;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (result && result.codeResult) {
              _result$codeResult$co = result.codeResult.code, code = _result$codeResult$co === void 0 ? 0 : _result$codeResult$co;
              if (codeValues[code] > 3) {
                stopQuagga();
                clearInternalCanvas();
                setLoading(true);
                getProductDetails(code);
              } else {
                codeValues[code] = codeValues[code] ? codeValues[code] + 1 : 1;
              }
            }
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function livestreamCallback(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var mediaDevicesAvailable = navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function';
  var startQuagga = mediaDevicesAvailable ? function () {
    return startQuaggaLivestream(livestreamCallback);
  } : function () {
    return startQuaggaPicture(pictureCallback);
  };
  var stopQuagga = mediaDevicesAvailable ? stopQuaggaLivestream : stopQuaggaPicture;
  var scanOtherProduct = function scanOtherProduct() {
    setModalData(undefined);
    startQuagga();
  };
  var stopScanner = function stopScanner() {
    stopQuagga();
    setActive(false);
    clearInternalCanvas();
    setModalData(undefined);
    onScannerClose();
  };
  useEffect(function () {
    startQuagga();
  }, []);
  return jsxs("div", {
    className: "".concat(styles$o['guided-scan-container'], " ").concat(styles$o[deviceOrientation]),
    children: [jsx("div", {
      id: "interactive",
      className: "".concat(styles$o.interactive, " viewport ").concat(styles$o['gs-scan']),
      children: jsxs("div", {
        className: styles$o.videoOverlay,
        id: styles$o.video_overlays,
        children: [jsxs("div", {
          id: styles$o.centerSquare,
          children: [jsx("div", {
            id: styles$o.maskTop
          }), jsx("div", {
            id: styles$o.maskBottom
          })]
        }), jsxs("div", {
          id: styles$o.bottomText__overlay,
          children: [vendorBarcodeCenterLabel, jsx("br", {}), vendorScanInfoLabel]
        })]
      })
    }), jsx("button", {
      className: styles$o.cancelButton,
      type: "button",
      onClick: stopScanner,
      children: vendorCancelButtonLabel
    }), modalData && jsx(ScanModalOverlay$1, {
      vendorProductAvailableLabel: vendorProductAvailableLabel,
      vendorPriceLabel: vendorPriceLabel,
      vendorStockLabel: vendorStockLabel,
      vendorScanAnotherProductLabel: vendorScanAnotherProductLabel,
      vendorInformationNotAvailableLabel: vendorInformationNotAvailableLabel,
      scanOtherProduct: scanOtherProduct,
      modalInformation: modalData
    }), loading && jsx(ScanLoadingOverlay$1, {
      loadingLabel: vendorLoadingLabel
    })]
  });
};
ProductScanner.defaultProps = {
  onScannerClose: function onScannerClose() {},
  regionCode: '',
  deviceType: 'desktop'
};
ProductScanner.propTypes = {
  onScannerClose: PropTypes.func,
  regionCode: PropTypes.string,
  deviceType: PropTypes.string
};
var ProductScanner$1 = ProductScanner;

var styles$m = {"vendorHeader":"VendorHeader-module_vendorHeader__Q28vw","strong":"VendorHeader-module_strong__wG8gm","vendorLogin":"VendorHeader-module_vendorLogin__1d-rJ","vendor_logout":"VendorHeader-module_vendor_logout__NCinC","vendorHomeContainer":"VendorHeader-module_vendorHomeContainer__1maLy","store":"VendorHeader-module_store__-L6Qt","newCustomer":"VendorHeader-module_newCustomer__fHDMW","search_customer":"VendorHeader-module_search_customer__BbTPs","customer_logout":"VendorHeader-module_customer_logout__eyNLr","icon":"VendorHeader-module_icon__dhMca","vendorHome":"VendorHeader-module_vendorHome__Sd1us","vendor_home":"VendorHeader-module_vendor_home__Hn2Jj","csicon-icon-scan":"VendorHeader-module_csicon-icon-scan__fxiTA"};

var endPoints = {
  VENDOR_LOGOUT_URL: function VENDOR_LOGOUT_URL(tenant) {
    return "/".concat(tenant, "/includes/vendorLogout.jsp");
  },
  SEARCH_CUSTOMER_URL: '/agentLocal/search.jsp',
  CUSTOMER_LOGOUT_URL: function CUSTOMER_LOGOUT_URL(tenant, storeId, modulo) {
    return "/".concat(tenant, "/includes/vendorCustomerLogout.jsp").concat(storeId && modulo ? "?storeId=".concat(storeId, "&modulo=").concat(modulo) : '');
  },
  VENDOR_HOME_URL: function VENDOR_HOME_URL(tenant, pageId) {
    return "/".concat(tenant, "/page/Venta-Guiada?staticPageId=").concat(pageId);
  }
};
var catalystEndpoints = {
  VENDOR_LOGOUT_URL: '/s/auth/v1/agent/logout',
  SEARCH_CUSTOMER_URL: function SEARCH_CUSTOMER_URL(tenant) {
    return "/".concat(tenant, "/agent/search");
  },
  CUSTOMER_LOGOUT_URL: function CUSTOMER_LOGOUT_URL(tenant, storeId, modulo) {
    return "/".concat(tenant, "/agent/search?isLogout=true").concat(storeId && modulo ? "&storeId=".concat(storeId, "&modulo=").concat(modulo) : '');
  },
  POST_LOGOUT_URL: function POST_LOGOUT_URL(tenant, storeId, modulo) {
    return "/".concat(tenant, "/agentlocal/login?isLogout=true").concat(storeId && modulo ? "&storeId=".concat(storeId, "&modulo=").concat(modulo) : '');
  },
  POST_LOGIN_URL: function POST_LOGIN_URL(tenant, storeId, modulo) {
    return "/".concat(tenant, "/agentlocal/login").concat(storeId && modulo ? "?storeId=".concat(storeId, "&modulo=").concat(modulo) : '');
  }
};
var VendorHeaderConfig = {
  endPoints: endPoints,
  catalystEndpoints: catalystEndpoints
};
var VendorHeaderConfig$1 = VendorHeaderConfig;

var VendorHeader = function VendorHeader(_ref) {
  var isCatalyst = _ref.isCatalyst,
    tenant = _ref.tenant,
    setIsVendorLoggedIn = _ref.setIsVendorLoggedIn,
    vendorBaseUrl = _ref.vendorBaseUrl;
    _ref.atgBaseUrl;
    var catalystBaseUrl = _ref.catalystBaseUrl,
    onUserLogout = _ref.onUserLogout;
    _ref.forceATG;
    var store = _ref.store,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    whitelabel = _ref.whitelabel;
  var endPoints = VendorHeaderConfig$1.endPoints,
    catalystEndpoints = VendorHeaderConfig$1.catalystEndpoints;
  var tenantId = store !== 'so_com' ? "falabella-".concat(tenant) : "sodimac-".concat(tenant);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showScanner = _useState4[0],
    setShowScanner = _useState4[1];
  var vendorcookie = CookieStorage$1.getCookie(CookieStorage$1.getVendorDataCookie());
  var clientCookie = CookieStorage$1.getCookie(CookieStorage$1.getUserDataCookieName());
  var pageId = {
    cl: 26000001,
    co: 12600002,
    pe: 12200002
  };
  useEffect(function () {
    var _vendorValues$, _vendorValues$2;
    var vendorValues = vendorcookie.split('*');
    var vendorId = decodeURIComponent(decodeURIComponent((_vendorValues$ = vendorValues === null || vendorValues === void 0 ? void 0 : vendorValues[0]) !== null && _vendorValues$ !== void 0 ? _vendorValues$ : ''));
    var storeName = (_vendorValues$2 = vendorValues === null || vendorValues === void 0 ? void 0 : vendorValues[1]) !== null && _vendorValues$2 !== void 0 ? _vendorValues$2 : '';
    var channel = 'kiosk';
    var module = CookieStorage$1.getCookie(CookieStorage$1.getKioskoModuleCookieName());
    var storeId = CookieStorage$1.getCookie(CookieStorage$1.getKioskoStoreCookieName());
    if (storeId) {
      storeName = storeId;
    }
    var digitalData = global.window.digitalData ? global.window.digitalData : {
      login: {},
      page: {}
    };
    if (!digitalData.login) {
      digitalData.login = {};
    }
    if (!digitalData.page) {
      digitalData.page = {};
    }
    digitalData.login.vendorCode = vendorId;
    if (storeName) digitalData.login.localStoreName = storeName;
    digitalData.page.canal = channel;
    global.window.digitalData = digitalData;
    setState({
      vendorId: vendorId,
      usersName: decodeURIComponent(decodeURIComponent(clientCookie.split('*')[0])),
      module: module,
      storeName: storeName
    });
  }, [vendorcookie]);
  var onScanButtonClicked = function onScanButtonClicked() {
    toggleNotificationsPopUpVisibilty();
    setShowScanner(true);
  };
  var onVendorLogout = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(e) {
      var _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isCatalyst) {
              _context.next = 6;
              break;
            }
            if (!isVendorLoggedIn) {
              _context.next = 5;
              break;
            }
            _context.prev = 1;
            e.preventDefault();
            _context.next = 2;
            return agentLogout({
              tenantId: tenantId,
              vendorBaseUrl: vendorBaseUrl,
              additionalInfo: {
                whitelabel: whitelabel
              }
            });
          case 2:
            setIsVendorLoggedIn(false);
            CookieStorage$1.removeCookie({
              name: CookieStorage$1.getVendorDataCookie()
            });
            CookieStorage$1.removeCookie({
              name: CookieStorage$1.getKioskoStoreCookieName()
            });
            CookieStorage$1.removeCookie({
              name: CookieStorage$1.getKioskoModuleCookieName()
            });
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            console.log('KIOSKO_LOGOUT_ERROR', _t);
          case 4:
            window.location.href = VendorHeaderConfig$1.catalystEndpoints.POST_LOGOUT_URL(tenantId, state.storeName, state.module);
            _context.next = 6;
            break;
          case 5:
            CookieStorage$1.removeCookie({
              name: CookieStorage$1.getVendorDataCookie()
            });
            CookieStorage$1.removeCookie({
              name: CookieStorage$1.getKioskoStoreCookieName()
            });
            CookieStorage$1.removeCookie({
              name: CookieStorage$1.getKioskoModuleCookieName()
            });
            window.location.href = VendorHeaderConfig$1.catalystEndpoints.POST_LOGIN_URL(tenantId, state.storeName, state.module);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function onVendorLogout(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClientLogout = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(e) {
      var _t2;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isCatalyst) {
              _context2.next = 6;
              break;
            }
            e.preventDefault();
            _context2.prev = 1;
            _context2.next = 2;
            return logout({
              tenantId: tenantId,
              catalystBaseUrl: catalystBaseUrl,
              additionalInfo: {
                whitelabel: whitelabel
              }
            });
          case 2:
            _context2.next = 3;
            return onUserLogout();
          case 3:
            _context2.next = 5;
            break;
          case 4:
            _context2.prev = 4;
            _t2 = _context2["catch"](1);
            console.log('CLIENT_LOGOUT_ERROR', _t2);
          case 5:
            window.location.href = VendorHeaderConfig$1.catalystEndpoints.SEARCH_CUSTOMER_URL(tenantId);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 4]]);
    }));
    return function onClientLogout(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getCatalystLink = function getCatalystLink(loggedInUrl, notLoggedVendorUrl) {
    var url = isVendorLoggedIn ? loggedInUrl : notLoggedVendorUrl;
    if (state.storeName && state.module) {
      url = "".concat(url).concat(state.storeName && state.module ? "?storeId=".concat(state.storeName, "&modulo=").concat(state.module) : '');
    }
    return url;
  };
  var redirectLinks = function redirectLinks() {
    if (isCatalyst) {
      return getCatalystLink(catalystEndpoints.VENDOR_LOGOUT_URL, catalystEndpoints.POST_LOGIN_URL(tenantId));
    } else {
      return getCatalystLink(endPoints.VENDOR_LOGOUT_URL(tenantId), catalystEndpoints.POST_LOGIN_URL(tenantId));
    }
  };
  var redirectLinksSearch = function redirectLinksSearch() {
    if (isCatalyst) {
      return getCatalystLink(catalystEndpoints.SEARCH_CUSTOMER_URL(tenantId), catalystEndpoints.POST_LOGIN_URL(tenantId));
    } else {
      return getCatalystLink(endPoints.SEARCH_CUSTOMER_URL, catalystEndpoints.POST_LOGIN_URL(tenantId));
    }
  };
  return jsxs("div", {
    className: styles$m.vendorHeader,
    id: "guided-selling-header-vendor",
    "data-testid": "guided-selling-header",
    children: [showScanner && jsx(ProductScanner$1, {
      onScannerClose: function onScannerClose() {
        toggleNotificationsPopUpVisibilty();
        setShowScanner(false);
      },
      regionCode: tenant,
      deviceType: 'desktop'
    }), jsxs("div", {
      className: styles$m.vendorLogin,
      children: [jsx("b", {
        className: styles$m.strong,
        children: "Vendedor:"
      }), " ".concat(state.vendorId, " "), jsx("a", {
        className: styles$m.vendor_logout,
        onClick: onVendorLogout,
        href: redirectLinks(),
        children: isVendorLoggedIn ? '(Cerrar Sesión)' : '(Iniciar Sesión)'
      })]
    }), jsxs("div", {
      className: styles$m.newCustomer,
      children: [jsx("a", {
        className: styles$m.search_customer,
        onClick: state.usersName ? onClientLogout : undefined,
        href: redirectLinksSearch(),
        rel: "noreferrer noopener",
        children: 'Buscar nuevo cliente'
      }), jsx("br", {}), jsx("b", {
        className: styles$m.strong,
        children: "Cliente:"
      }), state.usersName && jsxs("span", {
        children: [" ".concat(state.usersName, " "), jsx("a", {
          className: styles$m.customer_logout,
          onClick: onClientLogout,
          href: isCatalyst ? catalystEndpoints.CUSTOMER_LOGOUT_URL(tenantId, state.storeName, state.module) : endPoints.CUSTOMER_LOGOUT_URL(tenantId, state.storeName, state.module),
          rel: "noreferrer noopener",
          children: '(Cerrar Sesión)'
        })]
      })]
    }), jsxs("div", {
      className: styles$m.store,
      children: [jsx("b", {
        className: styles$m.strong,
        children: "Tienda:"
      }), " (", state.storeName, ")", jsx("br", {}), jsx("b", {
        className: styles$m.strong,
        children: "Modulo:"
      }), " (", state.module, ")"]
    }), jsxs("div", {
      className: styles$m.vendorHomeContainer,
      children: [jsxs("div", {
        "data-testid": "scanButton",
        className: classNames(styles$m.vendorHome, 'scanButton'),
        onClick: onScanButtonClicked,
        children: [jsx("div", {
          className: styles$m['csicon-icon-scan']
        }), jsx("span", {
          children: 'Scan'
        })]
      }), endPoints.VENDOR_HOME_URL(tenantId) && jsx("a", {
        className: styles$m.vendor_home,
        href: endPoints.VENDOR_HOME_URL(tenantId, pageId[tenant]),
        children: 'VENDOR HOME'
      })]
    })]
  });
};
VendorHeader.defaultProps = {
  isCatalyst: false,
  tenant: 'cl',
  isVendorLoggedIn: false,
  whitelabel: {}
};
VendorHeader.propTypes = {
  isCatalyst: PropTypes.bool,
  tenant: PropTypes.string,
  setIsVendorLoggedIn: PropTypes.func,
  atgBaseUrl: PropTypes.string,
  catalystBaseUrl: PropTypes.string,
  onUserLogout: PropTypes.func,
  vendorBaseUrl: PropTypes.string,
  forceATG: PropTypes.bool.isRequired,
  isVendorLoggedIn: PropTypes.bool,
  whitelabel: PropTypes.object
};
var VendorHeader$1 = VendorHeader;

var regexCollection = {
  pdp: /\/product|\/articulo/,
  xlp: /\/(search|buscar|collection|seleccion|category|lista)/,
  basket: /\/basket/,
  home: /^(?!.*(?:\/product|\/articulo\/search\/buscar|\/collection|\/seleccion\/category|\/lista\/basket)).*$/
};
var transversalBannerIsEnabled = function transversalBannerIsEnabled(locationPathname, transversalBannerConfig) {
  if (!transversalBannerConfig) {
    return true;
  }
  var pathname = isClientSide() ? window.location.pathname : locationPathname;
  for (var key in regexCollection) {
    if (regexCollection[key].test(pathname)) {
      return transversalBannerConfig[key];
    }
  }
  return true;
};

var styles$l = {"transversalWrapper":"index-module_transversalWrapper__hh-7f"};

var TransversalBanner = function TransversalBanner(_ref) {
  var transversalBanner = _ref.transversalBanner,
    transversalBannerConfig = _ref.transversalBannerConfig,
    locationPathname = _ref.locationPathname;
  var isEnabled = transversalBannerIsEnabled(locationPathname, transversalBannerConfig);
  if (!transversalBanner || !isEnabled) {
    return jsx(React.Fragment, {});
  }
  return jsxs("div", {
    className: styles$l.transversalWrapper,
    id: "testId-transversalBanner",
    children: [jsx("div", {
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize("".concat(transversalBanner))
      }
    }), jsx("style", {
      children: "\n          html body {\n            position: relative;\n          }\n        "
    })]
  });
};
TransversalBanner.propTypes = {
  transversalBanner: PropTypes.string.isRequired,
  locationPathname: PropTypes.string,
  transversalBannerConfig: PropTypes.shape({
    home: PropTypes.bool,
    pdp: PropTypes.bool,
    xlp: PropTypes.bool,
    basket: PropTypes.bool
  })
};
var TransversalBanner$1 = TransversalBanner;

var styles$k = {"container":"Notification-module_container__jfCNj","close-btn-container":"Notification-module_close-btn-container__G53EV","main":"Notification-module_main__BOv1q","logo-container":"Notification-module_logo-container__ye05F","content-container":"Notification-module_content-container__VYhC-","title":"Notification-module_title__VUVZp","body":"Notification-module_body__Wxlxe"};

var Notification = function Notification(_ref) {
  var isVisible = _ref.isVisible,
    isWelcomeMessage = _ref.isWelcomeMessage,
    requireInteraction = _ref.requireInteraction,
    redirectUrl = _ref.redirectUrl,
    icon = _ref.icon,
    title = _ref.title,
    body = _ref.body,
    closeNotification = _ref.closeNotification;
  useEffect(function () {
    var timeoutId;
    if (isVisible && !requireInteraction) {
      timeoutId = setTimeout(function () {
        closeNotification();
      }, 10000);
    }
    return function () {
      clearTimeout(timeoutId);
    };
  }, [isVisible]);
  var onContainerClick = function onContainerClick() {
    if (redirectUrl) {
      window.location.assign(redirectUrl);
    }
  };
  var renderElement = function renderElement(value, Element) {
    if (value) {
      return Element;
    }
  };
  var iconSrc = function () {
    if (isWelcomeMessage) {
      return ICONS.F_LOGO;
    } else if (typeof icon === 'string') {
      return icon;
    } else {
      return '';
    }
  }();
  return jsxs("div", {
    id: "testId-notification",
    "data-testid": "testId-notification",
    className: styles$k.container,
    style: {
      visibility: isVisible ? 'visible' : 'hidden'
    },
    children: [jsxs("div", {
      className: styles$k.main,
      onClick: onContainerClick,
      children: [renderElement(iconSrc, jsx("div", {
        className: styles$k['logo-container'],
        children: jsx("img", {
          src: iconSrc
        })
      })), jsxs("div", {
        className: styles$k['content-container'],
        children: [renderElement(title, jsx("div", {
          className: styles$k.title,
          children: title
        })), renderElement(body, jsx("div", {
          className: styles$k.body,
          children: body
        }))]
      })]
    }), jsx("div", {
      className: styles$k['close-btn-container'],
      children: jsx("button", {
        id: "testId-notification-close-btn",
        "data-testid": "testId-notification-close-btn",
        onClick: closeNotification,
        children: "\u2573"
      })
    })]
  });
};
Notification.defaultProps = {
  isVisible: false
};
Notification.propTypes = {
  isMarketplace: PropTypes.bool,
  isVisible: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
  isWelcomeMessage: PropTypes.bool,
  requireInteraction: PropTypes.bool,
  redirectUrl: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string
};
var Notification$1 = Notification;

var _excluded = ["forceSSR"];
function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var nameHOC$1 = function nameHOC(Component) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "".concat(Component.originalName || Component.displayName || Component.name || 'Component').concat(suffix);
};
var SkipSSR = function SkipSSR(WrappedComponent) {
  var ComponentWithoutSSR = function ComponentWithoutSSR(props) {
    var _ref = props || {},
      _ref$forceSSR = _ref.forceSSR,
      forceSSR = _ref$forceSSR === void 0 ? false : _ref$forceSSR,
      rest = _objectWithoutProperties(_ref, _excluded);
    var _useState = useState(forceSSR),
      _useState2 = _slicedToArray(_useState, 2),
      render = _useState2[0],
      setRender = _useState2[1];
    useEffect(function () {
      setRender(true);
    }, []);
    return render ? jsx(WrappedComponent, _objectSpread$5({}, rest)) : jsx(Fragment, {});
  };
  ComponentWithoutSSR.originalName = nameHOC$1(WrappedComponent);
  ComponentWithoutSSR.displayName = nameHOC$1(WrappedComponent, 'WithoutSSR');
  return ComponentWithoutSSR;
};
var SkipSSR$1 = SkipSSR;

var optIn = function optIn() {
  return {
    i18n: {
      es: {
        title: '¿Quieres conocer las mejores ofertas?',
        message: 'Que nadie te lo cuente. Suscríbete y activa las notificaciones.',
        accept: 'Sí, amo las ofertas',
        deny: 'No, gracias'
      },
      en: {
        title: '¿Quieres conocer las mejores ofertas?',
        message: 'Que nadie te lo cuente. Suscríbete y activa las notificaciones.',
        accept: 'Sí, amo las ofertas',
        deny: 'No, gracias'
      }
    },
    logo: ICONS.F_LOGO
  };
};
var airshipHelpers = {
  optIn: optIn
};

var openOptInModal = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_ref) {
    var sdk, subdomain, tld, setPushNotificationData, config, optInOptions, optInStylesheetUrl, _config$ask_again_del, optInPlugin, isOptedIn, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sdk = _ref.sdk, subdomain = _ref.subdomain, tld = _ref.tld, setPushNotificationData = _ref.setPushNotificationData, config = _ref.config;
          optInOptions = airshipHelpers.optIn();
          optInStylesheetUrl = function () {
            if (isLocalhost()) {
              return 'airship-mkp.styles.css';
            }
            return "https://".concat(subdomain, ".falabella.com").concat(tld, "/airship-styles-mkp.css");
          }();
          _context.prev = 1;
          _context.next = 2;
          return sdk.plugins.load('html-prompt', 'https://aswpsdkus.com/notify/v1/ua-html-prompt.min.js', {
            UA: window.UA,
            stylesheet: optInStylesheetUrl,
            askAgainDelay: (_config$ask_again_del = config === null || config === void 0 ? void 0 : config.ask_again_delay) !== null && _config$ask_again_del !== void 0 ? _config$ask_again_del : 1209600,
            i18n: optInOptions.i18n,
            logo: optInOptions.logo
          });
        case 2:
          optInPlugin = _context.sent;
          _context.next = 3;
          return optInPlugin.prompt();
        case 3:
          isOptedIn = _context.sent;
          if (isOptedIn) {
            setTimeout(function () {
              document.querySelector('.airship-html-prompt-shadow').shadowRoot.querySelector('.airship-btn-accept').addEventListener('click', function () {
                setPushNotificationData({
                  isVisible: true,
                  body: '¡Listo! Recibirás notificaciones con las mejores ofertas y novedades 😀',
                  isWelcomeMessage: true
                });
              });
            }, 300);
          }
          _context.next = 5;
          break;
        case 4:
          _context.prev = 4;
          _t = _context["catch"](1);
          console.log('Airship error at loading html-prompt plugin', _t);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 4]]);
  }));
  return function openOptInModal(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var onServiceWokerLoaded = function () {
  var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_ref3) {
    var subdomain, tld, setPushNotificationData, config, sdk, channel, _t2, _t3;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          subdomain = _ref3.subdomain, tld = _ref3.tld, setPushNotificationData = _ref3.setPushNotificationData, config = _ref3.config;
          if (!(typeof window !== 'undefined' && _typeof(window.UA) === 'object')) {
            _context2.next = 8;
            break;
          }
          _context2.prev = 1;
          _context2.next = 2;
          return window.UA;
        case 2:
          sdk = _context2.sent;
          sdk.localeOverride.setLanguage('es');
          if (!sdk.channel) {
            _context2.next = 4;
            break;
          }
          _context2.next = 3;
          return sdk.getChannel();
        case 3:
          _t2 = _context2.sent;
          _context2.next = 5;
          break;
        case 4:
          _t2 = Promise.resolve({});
        case 5:
          channel = _t2;
          if (!((!sdk.channel || channel && !channel.opt_in) && sdk.canRegister)) {
            _context2.next = 6;
            break;
          }
          _context2.next = 6;
          return openOptInModal({
            sdk: sdk,
            subdomain: subdomain,
            tld: tld,
            setPushNotificationData: setPushNotificationData,
            config: config
          });
        case 6:
          _context2.next = 8;
          break;
        case 7:
          _context2.prev = 7;
          _t3 = _context2["catch"](1);
          console.log('Airship global object error:', _t3);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 7]]);
  }));
  return function onServiceWokerLoaded(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var loadServiceWorker = function () {
  var _ref6 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_ref5) {
    var environment, subdomain, tld, setPushNotificationData, config, isLoggingEnabled, registration, _t4;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          environment = _ref5.environment, subdomain = _ref5.subdomain, tld = _ref5.tld, setPushNotificationData = _ref5.setPushNotificationData, config = _ref5.config;
          isLoggingEnabled = environment !== 'production';
          if (!('serviceWorker' in global.navigator)) {
            _context3.next = 5;
            break;
          }
          _context3.prev = 1;
          _context3.next = 2;
          return global.navigator.serviceWorker.register('/acc_sw.js');
        case 2:
          registration = _context3.sent;
          if (isLoggingEnabled) {
            console.log('Airship notification service worker registration successful with scope: ', registration.scope);
          }
          _context3.next = 3;
          return onServiceWokerLoaded({
            subdomain: subdomain,
            tld: tld,
            setPushNotificationData: setPushNotificationData,
            config: config
          });
        case 3:
          _context3.next = 5;
          break;
        case 4:
          _context3.prev = 4;
          _t4 = _context3["catch"](1);
          if (isLoggingEnabled) {
            console.log('Airship notification service worker registration failed: ', _t4);
          }
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 4]]);
  }));
  return function loadServiceWorker(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var createAirshipScriptTag = function createAirshipScriptTag(_ref7) {
  var tenant = _ref7.tenant,
    environment = _ref7.environment,
    setPushNotificationData = _ref7.setPushNotificationData,
    config = _ref7.config;
  var allowedTenants = ['cl', 'co', 'pe'];
  var allowedEnvironments = ['dev', 'staging', 'beta', 'production'];
  if (!allowedTenants.includes(tenant) || !allowedEnvironments.includes(environment)) {
    return;
  }
  var subdomain = environment === 'production' ? 'www' : environment;
  var tld = tenant.toLowerCase() === 'cl' ? '' : ".".concat(tenant.toLowerCase());
  var headerScriptUrl = function () {
    return "https://".concat(subdomain, ".falabella.com").concat(tld, "/airship-header.js");
  }();
  var onLoad = function () {
    var _ref8 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 1;
            return loadServiceWorker({
              environment: environment,
              subdomain: subdomain,
              tld: tld,
              setPushNotificationData: setPushNotificationData,
              config: config
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function onLoad() {
      return _ref8.apply(this, arguments);
    };
  }();
  var script = createScriptTag({
    src: headerScriptUrl,
    type: 'text/javascript',
    id: 'airship-script',
    onLoad: onLoad,
    async: true
  });
  return script;
};
var loadAirshipScript = function loadAirshipScript(_ref9) {
  var tenant = _ref9.tenant,
    environment = _ref9.environment,
    setPushNotificationData = _ref9.setPushNotificationData,
    config = _ref9.config;
  if (getSISPageName()) {
    return;
  }
  var script = createAirshipScriptTag({
    tenant: tenant,
    environment: environment,
    setPushNotificationData: setPushNotificationData,
    config: config
  });
  if (script) {
    var appendScript = function appendScript() {
      return appendNodeToHead(script);
    };
    appendScript();
  }
};
var loadAirshipScript$1 = loadAirshipScript;

var loadExternalDependencies = function loadExternalDependencies(_ref) {
  var toggles = _ref.toggles,
    tenant = _ref.tenant,
    environment = _ref.environment,
    functions = _ref.functions,
    configs = _ref.configs;
  if (toggles.isWebPushNotificationEnabled) {
    loadAirshipScript$1({
      tenant: tenant,
      environment: environment,
      setPushNotificationData: functions.setPushNotificationData,
      config: configs.webPushNotificationConfigs
    });
  }
};
var loadExternalDependencies$1 = loadExternalDependencies;

var labels = {
  MENU: 'Menu',
  CATEGORIES: 'Categorías',
  MARKETPLACE_CATEGORIES: 'Menú'
};
var agentHeaderHeights = {
  tablet: '73px',
  mobile: '116px'
};
var HamburgerConfig = {
  labels: labels,
  agentHeaderHeights: agentHeaderHeights
};
var HamburgerConfig$1 = HamburgerConfig;

var styles$j = {"hamburgerBtn":"MarketplaceHamburgerBtn-module_hamburgerBtn__cfXxF","active":"MarketplaceHamburgerBtn-module_active__8ZKC8","openBtnStyle":"MarketplaceHamburgerBtn-module_openBtnStyle__bT1Yj","icon":"MarketplaceHamburgerBtn-module_icon__r2oRR","icon-container":"MarketplaceHamburgerBtn-module_icon-container__nCNAF","line":"MarketplaceHamburgerBtn-module_line__xQVGP","icon-container-active":"MarketplaceHamburgerBtn-module_icon-container-active__kRuPL","title":"MarketplaceHamburgerBtn-module_title__34MUP","navigationOpen":"MarketplaceHamburgerBtn-module_navigationOpen__xzRnP"};

var HamburgerBtn = function HamburgerBtn(_ref) {
  var onNavBtnClick = _ref.onNavBtnClick,
    showTaxonomy = _ref.showTaxonomy,
    deviceType = _ref.deviceType;
  var labels = HamburgerConfig$1.labels;
  var categoriesLabel = labels.MARKETPLACE_CATEGORIES;
  useEffect(function () {
    toggleBodyClass(showTaxonomy, styles$j.navigationOpen);
  }, [showTaxonomy]);
  return jsxs("button", {
    className: styles$j.hamburgerBtn,
    onClick: onNavBtnClick,
    type: "button",
    id: "testId-HamburgerBtn-toggle",
    children: [jsxs("div", {
      style: {
        paddingLeft: deviceType !== 'desktop' && showTaxonomy ? 0 : null
      },
      className: "".concat(styles$j.icon, " ").concat(showTaxonomy && deviceType === 'desktop' ? styles$j.openBtnStyle : ''),
      children: [showTaxonomy && jsx(MediaComponent$1, {
        from: "tablet",
        to: "desktop"
      }), jsx("div", {
        className: classNames(styles$j['icon-container'], _defineProperty({}, styles$j['icon-container-active'], showTaxonomy)),
        children: jsx("span", {
          className: styles$j.line
        })
      })]
    }), jsx(MediaComponent$1, {
      from: "tablet",
      to: "desktop",
      children: jsx("span", {
        className: styles$j.title,
        children: categoriesLabel
      })
    })]
  });
};
HamburgerBtn.defaultProps = {
  labels: {}
};
HamburgerBtn.propTypes = {
  onNavBtnClick: PropTypes.func.isRequired,
  showTaxonomy: PropTypes.bool.isRequired,
  deviceType: PropTypes.string.isRequired,
  labels: PropTypes.object
};
var HamburgerBtn$1 = HamburgerBtn;

var styles$i = {"TaxonomyDesktop":"TaxonomyDesktop-module_TaxonomyDesktop__Ihty-","sidebar":"TaxonomyDesktop-module_sidebar__1lDbW","sideBarTitle":"TaxonomyDesktop-module_sideBarTitle__bX-te","userName":"TaxonomyDesktop-module_userName__g-vsQ","text":"TaxonomyDesktop-module_text__L7-Ws","closeIcon":"TaxonomyDesktop-module_closeIcon__jH15I","scrollWrapper":"TaxonomyDesktop-module_scrollWrapper__sZu3u","Box":"TaxonomyDesktop-module_Box__z3WXc","categoryWrapper":"TaxonomyDesktop-module_categoryWrapper__F22OD","brandLogo":"TaxonomyDesktop-module_brandLogo__2bRzc","logo":"TaxonomyDesktop-module_logo__cegMg","overlay":"TaxonomyDesktop-module_overlay__tXbwp"};

var styles$h = {"taxonomy__overlay":"TaxonomyOverlay-module_taxonomy__overlay__O-Fnm","marketplace-overlay":"TaxonomyOverlay-module_marketplace-overlay__A7SCq","agent-loggedin":"TaxonomyOverlay-module_agent-loggedin__fC9XT","vendor-loggedin":"TaxonomyOverlay-module_vendor-loggedin__9T-3R","agent-loggedin-mkp":"TaxonomyOverlay-module_agent-loggedin-mkp__3OkT2","vendor-loggedin-mkp":"TaxonomyOverlay-module_vendor-loggedin-mkp__9N0To"};

var TaxonomyOverlay = function TaxonomyOverlay(_ref) {
  var hideMenu = _ref.hideMenu,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    isMarketPlace = _ref.isMarketPlace,
    _ref$backdropPosition = _ref.backdropPosition,
    backdropPosition = _ref$backdropPosition === void 0 ? null : _ref$backdropPosition,
    resetData = _ref.resetData,
    classes = _ref.classes;
  var overlayRef = useRef();
  var handleClick = function handleClick(e) {
    overlayRef.current.contains(e.target) && hideMenu();
    if (resetData) {
      resetData('categories');
      resetData('nextaccess');
    }
  };
  var vendorClass = isMarketPlace ? 'vendor-loggedin-mkp' : 'vendor-loggedin';
  var agentClass = isMarketPlace ? 'agent-loggedin-mkp' : 'agent-loggedin';
  return ReactDom.createPortal(jsx("div", {
    ref: overlayRef,
    onKeyDown: noop$2,
    tabIndex: "0",
    style: backdropPosition,
    role: "button",
    className: classNames(styles$h.taxonomy__overlay, styles$h["".concat(isAgentLoggedIn ? agentClass : '')], styles$h["".concat(isVendorLoggedIn ? vendorClass : '')], styles$h["".concat(isMarketPlace && 'marketplace-overlay')], classes),
    onClick: handleClick
  }), document.body);
};
var TaxonomyOverlay$1 = TaxonomyOverlay;

var NavigationRight = function NavigationRight(_ref) {
  var active = _ref.active;
  return jsx("svg", {
    width: "9",
    height: "16",
    viewBox: "0 0 9 16",
    children: jsx("path", {
      d: "M1 2.21355L1.88055 1.33301L8.54721 7.99967L1.88055 14.6663L1 13.7858L6.78612 7.99967L1 2.21355Z",
      fill: !active ? '#767676' : 'var(--primary-theme-color)',
      stroke: !active ? '#767676' : 'var(--primary-theme-color)',
      strokeWidth: "0.5"
    })
  });
};
NavigationRight.propTypes = {
  active: PropTypes.bool
};
NavigationRight.defaultProps = {
  active: false
};
var NavigationRight$1 = NavigationRight;

var hasTag = function hasTag(itemName, tag) {
  return !isEmpty(tag) ? "".concat(itemName, " - ").concat(tag) : itemName;
};
var hasTag$1 = hasTag;

var styles$g = {"categories":"FirstLevelCategories-module_categories__bZx-r","active":"FirstLevelCategories-module_active__nGbgS","categoryTitle":"FirstLevelCategories-module_categoryTitle__fqIfl","seasonal":"FirstLevelCategories-module_seasonal__zpLev","label":"FirstLevelCategories-module_label__-tsgC","chevronRightIcon":"FirstLevelCategories-module_chevronRightIcon__QUrOM"};

var FirstLevelCategories = function FirstLevelCategories(_ref) {
  var data = _ref.data,
    index = _ref.index,
    showMenuHover = _ref.showMenuHover,
    isSeasonalFlag = _ref.isSeasonalFlag,
    categoryDigitalDataIndex = _ref.categoryDigitalDataIndex;
  var itemName = data.item_name,
    secondLevelCategories = data.second_level_categories,
    tag = data.tag,
    itemUrl = data.item_url;
  var hasSubcategory = Array.isArray(secondLevelCategories) && secondLevelCategories.length > 0;
  return jsx(Fragment, {
    children: hasSubcategory ? jsx(Fragment, {
      children: itemName && jsx("div", {
        className: classNames(styles$g.categories, _defineProperty({}, styles$g.active, showMenuHover === index)),
        children: jsxs(Fragment, {
          children: [jsxs("div", {
            className: classNames(styles$g.categoryTitle, _defineProperty({}, styles$g.seasonal, isSeasonalFlag)),
            children: [itemName, !isEmpty(tag) && jsx("span", {
              className: styles$g.label,
              children: tag
            })]
          }), jsx("div", {
            className: styles$g.chevronRightIcon,
            children: jsx(NavigationRight$1, {
              active: showMenuHover === index
            })
          })]
        })
      })
    }) : jsx("a", {
      rel: "noreferrer noopener",
      target: "_self",
      className: classNames(styles$g.categories, _defineProperty({}, styles$g.active, showMenuHover === index)),
      href: itemUrl,
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: hasTag$1(itemName, tag),
          secondLevelItem: hasTag$1(itemName, tag),
          thirdLevelItem: hasTag$1(itemName, tag),
          positionOne: categoryDigitalDataIndex,
          positionTwo: 0,
          positionThree: 0,
          tag: NAVIGATION
        });
      },
      children: jsxs("div", {
        className: classNames(styles$g.categoryTitle, _defineProperty({}, styles$g.seasonal, isSeasonalFlag)),
        children: [itemName, !isEmpty(tag) && jsx("span", {
          className: styles$g.label,
          children: tag
        })]
      })
    })
  });
};
FirstLevelCategories.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number,
  showMenuHover: PropTypes.number,
  isSeasonalFlag: PropTypes.bool
};
FirstLevelCategories.defaultProps = {
  data: {}
};
var FirstLevelCategories$1 = FirstLevelCategories;

var styles$f = {"monetizeWrapper":"GlobalMonetizationBanners-module_monetizeWrapper__M2sIo","imageWrapper":"GlobalMonetizationBanners-module_imageWrapper__upL9r","image":"GlobalMonetizationBanners-module_image__4pDdb","medium":"GlobalMonetizationBanners-module_medium__TdJLm","small":"GlobalMonetizationBanners-module_small__JUgaW"};

var GlobalMonetizationBanners = function GlobalMonetizationBanners(_ref) {
  var monetizeBanners = _ref.monetizeBanners;
  var size = monetizeBanners.size,
    banner = monetizeBanners.banner;
  var count = size === 'small' ? 3 : [size === 'medium' ? 2 : 1];
  var banners = banner.slice(0, count);
  return jsx("div", {
    className: styles$f.monetizeWrapper,
    children: banners.map(function (_ref2, index) {
      var image = _ref2.image_desktop,
        isnewtab = _ref2.isnewtab,
        url = _ref2.url;
      return jsx("a", {
        className: classNames(styles$f.imageWrapper, styles$f["".concat(size)]),
        href: url,
        target: isnewtab ? '_blank' : '_self',
        rel: "noreferrer",
        onClick: function onClick() {
          var name = image.filename && "M ".concat(image.filename.replace(/\..+$/, ''));
          updateDigitalDataCookies({
            firstLevelItem: name,
            secondLevelItem: name,
            thirdLevelItem: name,
            positionOne: index + 1,
            positionTwo: 0,
            positionThree: 0,
            tag: NAVIGATION
          });
        },
        children: jsx("img", {
          className: styles$f.image,
          src: image.url
        })
      }, index);
    })
  });
};
GlobalMonetizationBanners.propTypes = {
  monetizeBanners: PropTypes.object
};
GlobalMonetizationBanners.defaultProps = {
  monetizeBanners: {}
};
var GlobalMonetizationBanners$1 = GlobalMonetizationBanners;

var styles$e = {"secondLevelMenuContainer":"SecondLevelCategories-module_secondLevelMenuContainer__I3RRy","scrollContainer":"SecondLevelCategories-module_scrollContainer__3kQqe","subCategoryContent":"SecondLevelCategories-module_subCategoryContent__c8yUJ","banners":"SecondLevelCategories-module_banners__nJvOF","purchaseGuide":"SecondLevelCategories-module_purchaseGuide__f0Bfo","purchaseText":"SecondLevelCategories-module_purchaseText__4rYcm","purchaseImage":"SecondLevelCategories-module_purchaseImage__Kmu7b","banner":"SecondLevelCategories-module_banner__T5RZx","small":"SecondLevelCategories-module_small__bd3hE","medium":"SecondLevelCategories-module_medium__6wSYG","large":"SecondLevelCategories-module_large__hpZFJ","bannerImage":"SecondLevelCategories-module_bannerImage__tmLFN","BottomPosition":"SecondLevelCategories-module_BottomPosition__BMZd0","bannerBox":"SecondLevelCategories-module_bannerBox__faIAN","secondLevelMenuItemsBox":"SecondLevelCategories-module_secondLevelMenuItemsBox__GUf9F","secondLevelMenuContain":"SecondLevelCategories-module_secondLevelMenuContain__pIlwM","secondLevelMenuItems":"SecondLevelCategories-module_secondLevelMenuItems__LKK2g","secondLevelCategory":"SecondLevelCategories-module_secondLevelCategory__NVToy","secondLevelCategoryTitle":"SecondLevelCategories-module_secondLevelCategoryTitle__Hg0zZ","link":"SecondLevelCategories-module_link__7Zshf","thirdLevelCategory":"SecondLevelCategories-module_thirdLevelCategory__0VfiO","verTodo":"SecondLevelCategories-module_verTodo__B6JPe","label":"SecondLevelCategories-module_label__Oi8PP","subCategoryMainTitleWrapper":"SecondLevelCategories-module_subCategoryMainTitleWrapper__7mxw-","vertodo":"SecondLevelCategories-module_vertodo__lmLBT","subCategoryMainTitle":"SecondLevelCategories-module_subCategoryMainTitle__X3kZG","title":"SecondLevelCategories-module_title__HhC8K","iconWrapper":"SecondLevelCategories-module_iconWrapper__v9lxV","icon":"SecondLevelCategories-module_icon__151Je"};

var ThirdLevelCategories = function ThirdLevelCategories(_ref) {
  var thirdLevelCategories = _ref.thirdLevelCategories,
    FirstCategoryTitle = _ref.FirstCategoryTitle,
    SecondCategoryTitle = _ref.SecondCategoryTitle,
    categoryDigitalDataIndex = _ref.categoryDigitalDataIndex,
    secondCategoryDigitalDataIndex = _ref.secondCategoryDigitalDataIndex;
  return thirdLevelCategories && thirdLevelCategories.map(function (_ref2, index) {
    var name = _ref2.item_name,
      url = _ref2.item_url,
      isVerTodo = _ref2.is_ver_todo,
      tag = _ref2.tag;
    return jsx("li", {
      className: classNames(styles$e.thirdLevelCategory, _defineProperty({}, styles$e.verTodo, isVerTodo)),
      children: jsxs("a", {
        rel: "noreferrer noopener",
        target: "_self",
        href: url,
        onClick: function onClick() {
          updateDigitalDataCookies({
            firstLevelItem: FirstCategoryTitle,
            secondLevelItem: SecondCategoryTitle,
            thirdLevelItem: hasTag$1(name, tag),
            positionOne: categoryDigitalDataIndex,
            positionTwo: secondCategoryDigitalDataIndex,
            positionThree: index + 1,
            tag: NAVIGATION
          });
        },
        children: [name, !isEmpty(tag) && jsx("span", {
          className: styles$e.label,
          children: tag
        })]
      })
    }, index);
  });
};
var ThirdLevelCategories$1 = ThirdLevelCategories;

var SecondLevelCategories = function SecondLevelCategories(_ref) {
  var number = _ref.number,
    data = _ref.data,
    categoryDigitalDataIndex = _ref.categoryDigitalDataIndex;
  var FirstCategoryTitle = data.item_name,
    FirstCategoryURL = data.item_url,
    firstLevelTag = data.tag,
    verTodo = data.ver_todo,
    image = data.image_web,
    subMonetizeBanners = data.monetization_banner,
    monetizeBannerPosition = data.position_bottom,
    subCategory = data.second_level_categories,
    purchaseGuides = data.gu_as_de_compra;
  var itemBox = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    categoryWidth = _useState2[0],
    setCategoryWidth = _useState2[1];
  useEffect(function () {
    if (itemBox) {
      setCategoryWidth(itemBox.current.scrollWidth);
    }
    return function () {
      setCategoryWidth(0);
    };
  }, [number]);
  return jsx("div", {
    className: styles$e.secondLevelMenuContainer,
    children: jsxs("div", {
      className: styles$e.scrollContainer,
      children: [jsxs("div", {
        className: styles$e.subCategoryMainTitleWrapper,
        children: [jsxs("div", {
          className: styles$e.subCategoryMainTitle,
          children: [jsx("div", {
            className: styles$e.iconWrapper,
            children: image.url && jsx("img", {
              className: styles$e.icon,
              src: image.url
            })
          }), FirstCategoryURL ? jsx("a", {
            rel: "noreferrer noopener",
            target: "_self",
            className: styles$e.title,
            href: FirstCategoryURL,
            onClick: function onClick() {
              var name = hasTag$1(FirstCategoryTitle, firstLevelTag);
              updateDigitalDataCookies({
                firstLevelItem: name,
                secondLevelItem: name,
                thirdLevelItem: name,
                positionOne: categoryDigitalDataIndex,
                positionTwo: 0,
                positionThree: 0,
                tag: NAVIGATION
              });
            },
            children: FirstCategoryTitle
          }) : jsx("div", {
            className: styles$e.title,
            children: FirstCategoryTitle
          })]
        }), verTodo.title && verTodo.href && jsx("a", {
          target: "_self",
          href: verTodo.href,
          className: styles$e.vertodo,
          onClick: function onClick() {
            updateDigitalDataCookies({
              firstLevelItem: hasTag$1(FirstCategoryTitle, firstLevelTag),
              secondLevelItem: verTodo.title,
              thirdLevelItem: verTodo.title,
              positionOne: categoryDigitalDataIndex,
              positionTwo: 0,
              positionThree: 0,
              tag: NAVIGATION
            });
          },
          children: verTodo.title
        })]
      }), jsxs("div", {
        className: classNames(styles$e.subCategoryContent, _defineProperty({}, styles$e.BottomPosition, monetizeBannerPosition)),
        children: [jsx("div", {
          ref: itemBox,
          style: {
            width: "".concat(categoryWidth + 32, "px")
          },
          className: classNames(styles$e.subCategoryInnerContent, styles$e.secondLevelMenuItemsBox),
          children: subCategory.map(function (_ref2, index) {
            var name = _ref2.item_name,
              url = _ref2.item_url,
              thirdLevelCategories = _ref2.third_level_categories;
            return jsxs("ul", {
              className: styles$e.secondLevelCategory,
              children: [jsx("li", {
                className: styles$e.secondLevelCategoryTitle,
                children: url ? jsx("a", {
                  rel: "noreferrer noopener",
                  target: "_self",
                  className: styles$e.link,
                  href: url,
                  onClick: function onClick() {
                    updateDigitalDataCookies({
                      firstLevelItem: hasTag$1(FirstCategoryTitle, firstLevelTag),
                      secondLevelItem: name,
                      thirdLevelItem: name,
                      positionOne: categoryDigitalDataIndex,
                      positionTwo: index + 1,
                      positionThree: 0,
                      tag: NAVIGATION
                    });
                  },
                  children: name
                }) : name
              }), jsx(ThirdLevelCategories$1, {
                thirdLevelCategories: thirdLevelCategories,
                FirstCategoryTitle: hasTag$1(FirstCategoryTitle, firstLevelTag),
                SecondCategoryTitle: name,
                categoryDigitalDataIndex: categoryDigitalDataIndex,
                secondCategoryDigitalDataIndex: index + 1
              }, index)]
            }, index);
          })
        }), (subMonetizeBanners && subMonetizeBanners.length > 0 || purchaseGuides && purchaseGuides.length > 0) && jsxs("div", {
          className: styles$e.banners,
          children: [purchaseGuides && purchaseGuides.length > 0 && purchaseGuides.map(function (guide, index) {
            return jsxs("a", {
              href: guide.url_desk,
              rel: "noreferrer noopener",
              target: "_self",
              className: styles$e.purchaseGuide,
              onClick: function onClick() {
                updateDigitalDataCookies({
                  firstLevelItem: hasTag$1(FirstCategoryTitle, firstLevelTag),
                  secondLevelItem: 'Guía de compra',
                  thirdLevelItem: 'Guía de compra',
                  positionOne: categoryDigitalDataIndex,
                  positionTwo: 0,
                  positionThree: 0,
                  tag: NAVIGATION
                });
              },
              children: [jsx("div", {
                className: styles$e.purchaseText,
                children: guide.text_desktop && guide.text_desktop
              }), jsx("img", {
                className: styles$e.purchaseImage,
                src: guide.image_desktop && guide.image_desktop.url
              })]
            }, index);
          }), subMonetizeBanners && subMonetizeBanners.length > 0 && jsx("div", {
            className: styles$e.bannerBox,
            children: subMonetizeBanners.map(function (_ref3, index) {
              var url = _ref3.url,
                monetizeImage = _ref3.image,
                size = _ref3.size;
              return jsx("a", {
                href: url,
                target: "_self",
                className: classNames(styles$e.banner, styles$e["".concat(size)]),
                onClick: function onClick() {
                  var name = monetizeImage.filename && "M ".concat(monetizeImage.filename.replace(/\..+$/, ''));
                  updateDigitalDataCookies({
                    firstLevelItem: hasTag$1(FirstCategoryTitle, firstLevelTag),
                    secondLevelItem: name,
                    thirdLevelItem: name,
                    positionOne: categoryDigitalDataIndex,
                    positionTwo: index + 1,
                    positionThree: 0,
                    tag: NAVIGATION
                  });
                },
                children: jsx("img", {
                  className: styles$e.bannerImage,
                  src: monetizeImage.url,
                  alt: monetizeImage.title
                })
              }, index);
            })
          })]
        })]
      })]
    })
  });
};
SecondLevelCategories.propTypes = {
  data: PropTypes.object,
  number: PropTypes.number
};
SecondLevelCategories.defaultProps = {
  data: {}
};
var SecondLevelCategories$1 = SecondLevelCategories;

var styles$d = {"categoryWrapper":"NextAccesses-module_categoryWrapper__oIsEK","nextCategoryMainTitle":"NextAccesses-module_nextCategoryMainTitle__M08vW","categories":"NextAccesses-module_categories__PeK4i","hasIcon":"NextAccesses-module_hasIcon__9Lb9P","iconBox":"NextAccesses-module_iconBox__bvhls","icon":"NextAccesses-module_icon__5Z-2g","active":"NextAccesses-module_active__lKIrC","categoryTitle":"NextAccesses-module_categoryTitle__tFxql","seasonal":"NextAccesses-module_seasonal__-D2PK","label":"NextAccesses-module_label__onWwV","chevronRightIcon":"NextAccesses-module_chevronRightIcon__Exnrh","childItems":"NextAccesses-module_childItems__noA0I","secondLevelAccess":"NextAccesses-module_secondLevelAccess__uV5KR"};

var NextAccesses$2 = function NextAccesses(_ref) {
  var data = _ref.data,
    showNextAccessMenu = _ref.showNextAccessMenu,
    parentIndex = _ref.parentIndex,
    showNextMenuHover = _ref.showNextMenuHover,
    nextDigitalDataIndex = _ref.nextDigitalDataIndex,
    globalIndexNext = _ref.globalIndexNext,
    globalNextParentName = _ref.globalNextParentName;
  var NextAccess = useRef(false);
  var parent = showNextMenuHover.parent,
    child = showNextMenuHover.child;
  var name = data.item_name,
    items = data.items;
  function checkNextAccessesPosition(index) {
    var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (NextAccess) {
      showNextAccessMenu(parentIndex, index, NextAccess.current.getBoundingClientRect().y, reset);
    }
  }
  return jsx(Fragment, {
    children: jsxs("div", {
      className: styles$d.categoryWrapper,
      children: [name && jsx("div", {
        className: styles$d.nextCategoryMainTitle,
        children: name
      }), Array.isArray(items) && items.length > 0 && jsx(Fragment, {
        children: items.map(function (item, index) {
          return item.second_level_access && item.second_level_access.length > 0 ? jsxs("div", {
            className: classNames(styles$d.categories, _defineProperty(_defineProperty({}, styles$d.active, parent === parentIndex && child === index), styles$d.hasIcon, item.icon && item.icon.url)),
            ref: NextAccess,
            onMouseOver: function onMouseOver() {
              globalIndexNext(nextDigitalDataIndex + index);
              globalNextParentName(item.item_name);
              checkNextAccessesPosition(index);
            },
            children: [jsxs("div", {
              className: styles$d.categoryTitle,
              children: [item.icon && item.icon.url && jsx("div", {
                className: styles$d.iconBox,
                children: jsx("img", {
                  className: styles$d.icon,
                  src: item.icon.url
                })
              }), item.item_name]
            }), jsx("div", {
              className: styles$d.chevronRightIcon,
              children: jsx(NavigationRight$1, {
                active: parent === parentIndex && child === index
              })
            })]
          }, "".concat(index, "-").concat(item.item_name)) : jsx("a", {
            rel: "noreferrer noopener",
            target: item.is_new_tab ? '_blank' : '_self',
            ref: NextAccess,
            className: classNames(styles$d.categories, _defineProperty(_defineProperty({}, styles$d.active, parent === parentIndex && child === index), styles$d.hasIcon, item.icon && item.icon.url)),
            href: item.url,
            onMouseOver: function onMouseOver() {
              globalIndexNext(nextDigitalDataIndex + index);
              globalNextParentName(item.item_name);
              checkNextAccessesPosition(index, true);
            },
            onClick: function onClick() {
              updateDigitalDataCookies({
                firstLevelItem: item.item_name,
                secondLevelItem: item.item_name,
                thirdLevelItem: item.item_name,
                positionOne: nextDigitalDataIndex + index,
                positionTwo: 0,
                positionThree: 0,
                tag: NAVIGATION
              });
            },
            children: jsxs("div", {
              className: styles$d.categoryTitle,
              children: [item.icon && item.icon.url && jsx("div", {
                className: styles$d.iconBox,
                children: jsx("img", {
                  className: styles$d.icon,
                  src: item.icon.url
                })
              }), item.item_name]
            })
          }, "".concat(index, "-").concat(item.item_name));
        })
      })]
    })
  });
};
NextAccesses$2.propTypes = {
  data: PropTypes.object,
  showNextAccessMenu: PropTypes.func.isRequired,
  parentIndex: PropTypes.number,
  showNextMenuHover: PropTypes.object
};
NextAccesses$2.defaultProps = {
  data: {}
};
var NextAccesses$3 = NextAccesses$2;

var styles$c = {"popupWrapper":"NextAccessesPopup-module_popupWrapper__5-2tL","container":"NextAccessesPopup-module_container__VJF-G","items":"NextAccessesPopup-module_items__kxVER"};

var NextAccessesPopup = function NextAccessesPopup(_ref) {
  var data = _ref.data,
    parentTopPosition = _ref.nextAccessTopPosition,
    hideMenuForSpecificArea = _ref.hideMenuForSpecificArea,
    globalNextParentName = _ref.globalNextParentName,
    nextDigitalDataIndex = _ref.nextDigitalDataIndex;
  var nextAccessHeight = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    popUpStyle = _useState2[0],
    setPopUpStyle = _useState2[1];
  useEffect(function () {
    var windowHeight = isWindow$1() ? window.innerHeight : {};
    var modifiedHeight = windowHeight - 59;
    var createPortion = windowHeight / 10;
    var topPortion = createPortion * 4;
    var middlePortion = topPortion + createPortion * 2;
    var parentMiddlePosition = parentTopPosition + 34;
    var subMenuHeight = nextAccessHeight && nextAccessHeight.current.scrollHeight;
    var halfOfSubMenuHeight = subMenuHeight / 2;
    if (parentMiddlePosition <= topPortion) {
      var space = parentTopPosition - 59 < halfOfSubMenuHeight;
      !space ? setPopUpStyle({
        top: "".concat(parentTopPosition - 64, "px"),
        transform: 'translateY(-30%)'
      }) : setPopUpStyle({
        top: '0px'
      });
    }
    if (parentMiddlePosition > topPortion && parentMiddlePosition <= middlePortion) {
      if (modifiedHeight < subMenuHeight) {
        setPopUpStyle({
          top: '0px'
        });
      } else {
        var _space = parentTopPosition > halfOfSubMenuHeight;
        var bottomPosition = Math.abs(modifiedHeight - parentTopPosition);
        _space ? setPopUpStyle({
          bottom: "".concat(bottomPosition, "px"),
          transform: 'translateY(50%)'
        }) : setPopUpStyle({
          top: '0px'
        });
      }
    }
    if (parentMiddlePosition > middlePortion) {
      if (subMenuHeight > modifiedHeight) {
        setPopUpStyle({
          top: '0px'
        });
      } else {
        var bottomSpaceCount = modifiedHeight - (parentTopPosition - 59);
        if (bottomSpaceCount <= 0) {
          setPopUpStyle({
            bottom: '0px'
          });
        } else {
          halfOfSubMenuHeight > bottomSpaceCount ? setPopUpStyle({
            bottom: "".concat(Math.abs(bottomSpaceCount), "px")
          }) : setPopUpStyle({
            bottom: "".concat(Math.abs(bottomSpaceCount), "px"),
            transform: 'translateY(50%)'
          });
        }
      }
    }
  }, [data, parentTopPosition]);
  return jsx("div", {
    className: classNames(styles$c.popupWrapper, 'popup-container'),
    onClick: function onClick(e) {
      return hideMenuForSpecificArea(e, 'popup-container');
    },
    children: jsx("div", {
      ref: nextAccessHeight,
      className: styles$c.container,
      style: popUpStyle,
      children: data.map(function (_ref2, index) {
        var name = _ref2.child_name,
          isNewTab = _ref2.is_new_tab,
          url = _ref2.url;
        return jsx("a", {
          className: styles$c.items,
          href: url,
          rel: "noreferrer noopener",
          target: isNewTab ? '_blank' : '_self',
          onClick: function onClick() {
            return updateDigitalDataCookies({
              firstLevelItem: globalNextParentName,
              secondLevelItem: name,
              thirdLevelItem: name,
              positionOne: nextDigitalDataIndex,
              positionTwo: index + 1,
              positionThree: 0,
              tag: NAVIGATION
            });
          },
          children: name
        }, index);
      })
    })
  });
};
var NextAccessesPopup$1 = NextAccessesPopup;

var TaxonomyDesktop = function TaxonomyDesktop(_ref) {
  var taxonomyData = _ref.taxonomyData,
    showTaxonomy = _ref.showTaxonomy,
    hideMenu = _ref.hideMenu,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    setMenuVisible = _ref.setMenuVisible,
    isUserLoggedIn = _ref.isUserLoggedIn,
    firstName = _ref.firstName;
  var CATEGOROIES = 'categories';
  var NEXTACCESS = 'nextaccess';
  var _taxonomyData$all_acc = taxonomyData.all_accesses,
    accesses = _taxonomyData$all_acc.accesses,
    categories = _taxonomyData$all_acc.categories,
    position = _taxonomyData$all_acc.category_position,
    logo = taxonomyData.logo,
    monetizationBanners = taxonomyData.monetization_banners;
  var offset = 0;
  var accessesIndex = [];
  var categoryIndex = 0;
  accesses.forEach(function (element, index) {
    if (index === position - 1) {
      categoryIndex = offset + 1;
      offset += categories.length;
    }
    accessesIndex.push(offset + 1);
    offset += element.items.length;
  });
  if (position === 4) {
    categoryIndex = offset + 1;
  }
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    globalIndex = _useState2[0],
    setGlobalIndex = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    globalNextParentName = _useState4[0],
    setGlobalNextParentName = _useState4[1];
  var _useState5 = useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    showMenuHover = _useState6[0],
    setShowMenuHover = _useState6[1];
  var _useState7 = useState(-1),
    _useState8 = _slicedToArray(_useState7, 2),
    number = _useState8[0],
    setNumber = _useState8[1];
  var _useState9 = useState({}),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedItem = _useState0[0],
    setSelectedItem = _useState0[1];
  var IS_SEASONAL_COUNT = 0;
  var _useState1 = useState({
      parent: -1,
      child: -1
    }),
    _useState10 = _slicedToArray(_useState1, 2),
    showNextMenuHover = _useState10[0],
    setShowNextMenuHover = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedNextAccesses = _useState12[0],
    setSelectedNextAccesses = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    nextAccessPosition = _useState14[0],
    setNextAccessPosition = _useState14[1];
  var resetData = function resetData(type) {
    switch (type) {
      case CATEGOROIES:
        setSelectedItem({});
        setNumber(-1);
        break;
      case NEXTACCESS:
        setNextAccessPosition(0);
        setSelectedNextAccesses([]);
        break;
    }
  };
  var showCategoryMenu = function showCategoryMenu(menuNumber) {
    var hasChild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setShowNextMenuHover(-1);
    setShowMenuHover(menuNumber);
    resetData(NEXTACCESS);
    if (hasChild) {
      setSelectedItem(categories[menuNumber]);
      setNumber(menuNumber);
    } else {
      resetData(CATEGOROIES);
    }
  };
  var isArray = selectedItem && Array.isArray(selectedItem.second_level_categories);
  var subCategory = isArray && selectedItem.second_level_categories.length > 0 && selectedItem.second_level_categories;
  var notHaveNextAccesses = selectedNextAccesses && selectedNextAccesses.length === 0;
  var hasMonetizeBanner = monetizationBanners && monetizationBanners.banner && monetizationBanners.banner.length > 0;
  function showNextAccessMenu(parentIndex, index, topPosition) {
    var reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    setShowMenuHover(-1);
    var hoverData = {
      parent: parentIndex,
      child: index
    };
    if (reset) {
      resetData(NEXTACCESS);
      setShowNextMenuHover(hoverData);
    }
    resetData(CATEGOROIES);
    setNextAccessPosition(topPosition);
    setSelectedNextAccesses(accesses[parentIndex].items[index].second_level_access);
    setShowNextMenuHover(hoverData);
  }
  var getCategory = function getCategory(category, index, isSeasonalFlag) {
    if (category && category.canal && category.canal.adddesktop) {
      var secondLevelCategories = category.second_level_categories;
      var hasSubcategory = Array.isArray(secondLevelCategories) && secondLevelCategories.length > 0;
      return jsx("div", {
        className: styles$i.categoryWrapper,
        onMouseOver: function onMouseOver() {
          setGlobalIndex(categoryIndex + index);
          showCategoryMenu(index, hasSubcategory);
        },
        children: jsx(FirstLevelCategories$1, {
          showMenuHover: showMenuHover,
          data: category,
          index: index,
          isSeasonalFlag: isSeasonalFlag,
          categoryDigitalDataIndex: globalIndex
        }, "category-".concat(index))
      }, "".concat(index, "_").concat(category.item_name));
    }
    return null;
  };
  var getCategoryData = function getCategoryData(accessIndex) {
    return jsx("div", {
      className: styles$i.Box,
      children: categories.map(function (category, index) {
        var isSeasonalFlag = false;
        if (category.is_seasonal) {
          IS_SEASONAL_COUNT += 1;
          isSeasonalFlag = IS_SEASONAL_COUNT <= 3;
        }
        return getCategory(category, index, isSeasonalFlag);
      })
    }, "accesses-insert-".concat(accessIndex));
  };
  var nextAccesses = accesses.map(function (access, index) {
    return jsx("div", {
      className: styles$i.Box,
      children: jsx(NextAccesses$3, {
        showNextMenuHover: showNextMenuHover,
        showNextAccessMenu: showNextAccessMenu,
        data: access,
        parentIndex: index,
        nextDigitalDataIndex: accessesIndex[index],
        globalIndexNext: setGlobalIndex,
        globalNextParentName: setGlobalNextParentName
      })
    }, "accesses-".concat(index));
  });
  nextAccesses.splice(position - 1, 0, getCategoryData(position));
  var hideMenuForSpecificArea = function hideMenuForSpecificArea(event, classes) {
    if (event.target.classList.contains(classes)) {
      setMenuVisible(false);
      setSelectedItem(undefined);
      setShowMenuHover(undefined);
      setSelectedNextAccesses([]);
    }
  };
  return jsxs(Fragment, {
    children: [jsx(CSSTransition, {
      "in": showTaxonomy,
      timeout: 600,
      classNames: "sidebar-open",
      unmountOnExit: true,
      children: jsxs("div", {
        className: styles$i.TaxonomyDesktop,
        onClick: function onClick(e) {
          return hideMenuForSpecificArea(e, 'sidebar-open-enter-done');
        },
        children: [jsxs("div", {
          className: styles$i.sidebar,
          children: [jsxs("div", {
            className: styles$i.sideBarTitle,
            children: [jsxs("div", {
              className: styles$i.text,
              children: ["\xA1Hola", isUserLoggedIn && jsxs(Fragment, {
                children: [',', jsx("span", {
                  className: styles$i.userName,
                  children: firstName
                })]
              }), "!"]
            }), jsx("div", {
              className: styles$i.closeIcon,
              onClick: function onClick() {
                setMenuVisible(false);
                setSelectedItem(undefined);
                setShowMenuHover(undefined);
              }
            })]
          }), jsxs("div", {
            className: styles$i.scrollWrapper,
            children: [nextAccesses, logo && logo.imagedesktop && (logo.url ? jsx("a", {
              rel: "noreferrer noopener",
              target: "_self",
              href: logo.url,
              className: styles$i.brandLogo,
              children: jsx("img", {
                className: styles$i.logo,
                src: logo.imagedesktop.url,
                alt: "falabella"
              })
            }) : jsx("div", {
              className: styles$i.brandLogo,
              children: jsx("img", {
                className: styles$i.logo,
                src: logo.imagedesktop.url,
                alt: "falabella"
              })
            }))]
          })]
        }), !subCategory && notHaveNextAccesses && showTaxonomy && hasMonetizeBanner && jsx(GlobalMonetizationBanners$1, {
          monetizeBanners: monetizationBanners
        }), subCategory && jsx(SecondLevelCategories$1, {
          data: selectedItem,
          number: number,
          categoryDigitalDataIndex: globalIndex
        }), selectedNextAccesses && selectedNextAccesses.length > 0 && jsx(NextAccessesPopup$1, {
          data: selectedNextAccesses,
          nextAccessTopPosition: nextAccessPosition,
          hideMenuForSpecificArea: hideMenuForSpecificArea,
          globalNextParentName: globalNextParentName,
          nextDigitalDataIndex: globalIndex
        })]
      })
    }), showTaxonomy && jsx(TaxonomyOverlay$1, {
      isMarketPlace: true,
      hideMenu: hideMenu,
      isAgentLoggedIn: isAgentLoggedIn,
      isVendorLoggedIn: isVendorLoggedIn,
      classes: styles$i.overlay,
      resetData: resetData
    })]
  });
};
TaxonomyDesktop.propTypes = {
  taxonomyData: PropTypes.object,
  showTaxonomy: PropTypes.bool,
  hideMenu: PropTypes.func.isRequired,
  isAgentLoggedIn: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  setMenuVisible: PropTypes.func,
  isUserLoggedIn: PropTypes.bool,
  firstName: PropTypes.string
};
TaxonomyDesktop.defaultProps = {
  showTaxonomy: false,
  taxonomyData: {
    all_accesses: {
      accesses: [],
      categories: [],
      category_position: 1
    },
    logo: '',
    monetization_banners: {}
  }
};
var TaxonomyDesktop$1 = withUser(TaxonomyDesktop);

var styles$b = {"categoryWrapper":"Categories-module_categoryWrapper__paFr3","categories":"Categories-module_categories__xIh-u","verTodo":"Categories-module_verTodo__AUzun","categoryTitle":"Categories-module_categoryTitle__wyVEG","seasonal":"Categories-module_seasonal__6aTtS","label":"Categories-module_label__qlsG-","chevronRightIcon":"Categories-module_chevronRightIcon__r747G"};

var Categories = function Categories(_ref) {
  var data = _ref.data,
    index = _ref.index,
    showMenu = _ref.showMenu,
    showMenuHover = _ref.showMenuHover,
    classes = _ref.classes,
    is_Seasonal_Flag = _ref.is_Seasonal_Flag,
    getCategoryDigitalData = _ref.getCategoryDigitalData,
    setGlobalPosition = _ref.setGlobalPosition,
    offset = _ref.offset;
  var item_name = data.item_name,
    subCategory = data.second_level_categories,
    third_level = data.third_level_categories,
    tag = data.tag,
    items = data.items,
    item_url = data.item_url,
    isVerTodo = data.is_ver_todo;
  var hasChildItems = Array.isArray(subCategory) && subCategory.length > 0 || Array.isArray(third_level) && third_level.length > 0 || Array.isArray(items) && items.length > 0;
  return jsx(Fragment, {
    children: item_name && jsx("div", {
      className: styles$b.categoryWrapper,
      onClick: function onClick(e) {
        hasChildItems && showMenu(index, undefined, undefined);
        if (offset && hasChildItems) {
          setGlobalPosition(offset + index);
        }
      },
      children: hasChildItems ? jsx(Fragment, {
        children: jsxs("div", {
          className: classNames(styles$b.categories, classes, _defineProperty({}, styles$b.active, showMenuHover === index)),
          children: [jsxs("div", {
            className: classNames(styles$b.categoryTitle, _defineProperty({}, styles$b.seasonal, is_Seasonal_Flag)),
            children: [item_name, !isEmpty(tag) && jsx("span", {
              className: styles$b.label,
              children: tag
            })]
          }), jsx("div", {
            className: styles$b.chevronRightIcon
          })]
        })
      }) : jsx("a", {
        rel: "noreferrer noopener",
        target: "_self",
        className: classNames(styles$b.categories, classes, _defineProperty(_defineProperty({}, styles$b.active, showMenuHover === index), styles$b.verTodo, isVerTodo)),
        href: item_url,
        onClick: function onClick() {
          return offset ? getCategoryDigitalData(offset + index) : getCategoryDigitalData(index + 1);
        },
        children: jsxs("div", {
          className: classNames(styles$b.categoryTitle, _defineProperty({}, styles$b.seasonal, is_Seasonal_Flag)),
          children: [item_name, !isEmpty(tag) && jsx("span", {
            className: styles$b.label,
            children: tag
          })]
        })
      })
    })
  });
};
Categories.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number,
  showMenu: PropTypes.func,
  showMenuHover: PropTypes.number,
  classes: PropTypes.string
};
Categories.defaultProps = {
  data: {},
  classes: ''
};
var Categories$1 = Categories;

var styles$a = {"TaxonomyMobile":"TaxonomyMobile-module_TaxonomyMobile__4OE6J","container":"TaxonomyMobile-module_container__p1Ahh","scrollWrapper":"TaxonomyMobile-module_scrollWrapper__muxU5","innerCategories":"TaxonomyMobile-module_innerCategories__74GLK","innerAccesses":"TaxonomyMobile-module_innerAccesses__yA7TE","wrapper":"TaxonomyMobile-module_wrapper__QuXaW","fastAccessesBox":"TaxonomyMobile-module_fastAccessesBox__-FlQg","categoryBox":"TaxonomyMobile-module_categoryBox__DT0Ad","verTodoBox":"TaxonomyMobile-module_verTodoBox__cOUQX","verTodo":"TaxonomyMobile-module_verTodo__FMYYy","purchaseGuides":"TaxonomyMobile-module_purchaseGuides__zyOQO","purchaseGuide":"TaxonomyMobile-module_purchaseGuide__bp2K2","purchaseText":"TaxonomyMobile-module_purchaseText__QoHJ4","purchaseImage":"TaxonomyMobile-module_purchaseImage__6sajv","subCategories":"TaxonomyMobile-module_subCategories__vJEqI","brandLogo":"TaxonomyMobile-module_brandLogo__ZwVhf","logoBox":"TaxonomyMobile-module_logoBox__D7Dxc","subCategoryMainTitle":"TaxonomyMobile-module_subCategoryMainTitle__nJj-I","thirdCategoryTitle":"TaxonomyMobile-module_thirdCategoryTitle__kVPln","iconWrapper":"TaxonomyMobile-module_iconWrapper__O1clW","icon":"TaxonomyMobile-module_icon__779fy","overlay":"TaxonomyMobile-module_overlay__Qpbtw","accesseswrapper":"TaxonomyMobile-module_accesseswrapper__nEx0a","accesses":"TaxonomyMobile-module_accesses__u78Os","accessesTitleWrapper":"TaxonomyMobile-module_accessesTitleWrapper__1W27D","iconBox":"TaxonomyMobile-module_iconBox__SI4TQ","accessesTitle":"TaxonomyMobile-module_accessesTitle__rJwmq"};

var styles$9 = {"categoryWrapper":"NextAccesses-module_categoryWrapper__uLzkJ","nextCategoryMainTitle":"NextAccesses-module_nextCategoryMainTitle__WXHmQ","categories":"NextAccesses-module_categories__t3V3b","iconBox":"NextAccesses-module_iconBox__hPvme","icon":"NextAccesses-module_icon__ZMyzx","active":"NextAccesses-module_active__auTzC","categoryTitle":"NextAccesses-module_categoryTitle__Bdfhv","seasonal":"NextAccesses-module_seasonal__aqmUZ","label":"NextAccesses-module_label__maolY","chevronRightIcon":"NextAccesses-module_chevronRightIcon__o0yQQ","childItems":"NextAccesses-module_childItems__JiD-n","secondLevelAccess":"NextAccesses-module_secondLevelAccess__U6bcK"};

var NextAccesses = function NextAccesses(_ref) {
  var data = _ref.data,
    showMenu = _ref.showMenu,
    itemIndex = _ref.itemIndex,
    setGlobalPosition = _ref.setGlobalPosition,
    offset = _ref.offset;
  var item_name = data.item_name,
    items = data.items;
  var NextAccess = useRef(false);
  return jsx(Fragment, {
    children: jsxs("div", {
      className: styles$9.categoryWrapper,
      children: [item_name && jsx("div", {
        className: styles$9.nextCategoryMainTitle,
        children: item_name
      }), Array.isArray(items) && items.length > 0 && jsx(Fragment, {
        children: items.map(function (item, index) {
          return item.second_level_access && item.second_level_access.length > 0 ? jsx(Fragment, {
            children: jsxs("div", {
              className: styles$9.categories,
              ref: NextAccess,
              onClick: function onClick() {
                showMenu(itemIndex, index, 'nextAccess');
                setGlobalPosition(offset + index);
              },
              children: [jsxs("div", {
                className: styles$9.categoryTitle,
                children: [item.icon && item.icon.url && jsx("div", {
                  className: styles$9.iconBox,
                  children: jsx("img", {
                    className: styles$9.icon,
                    src: item.icon.url
                  })
                }), item.item_name]
              }), jsx("div", {
                className: styles$9.chevronRightIcon
              })]
            }, item.url)
          }, item.url) : jsx("a", {
            rel: "noreferrer noopener",
            target: item.is_new_tab ? '_blank' : '_self',
            className: styles$9.categories,
            href: item.url,
            onClick: function onClick() {
              updateDigitalDataCookies({
                firstLevelItem: item.item_name,
                secondLevelItem: item.item_name,
                thirdLevelItem: item.item_name,
                positionOne: offset + index,
                positionTwo: 0,
                positionThree: 0,
                tag: NAVIGATION
              });
            },
            children: jsxs("div", {
              className: styles$9.categoryTitle,
              children: [item.icon && item.icon.url && jsx("div", {
                className: styles$9.iconBox,
                children: jsx("img", {
                  className: styles$9.icon,
                  src: item.icon.url
                })
              }), item.item_name]
            })
          }, item.url);
        })
      })]
    })
  });
};
NextAccesses.propTypes = {
  data: PropTypes.object,
  showMenu: PropTypes.func,
  itemIndex: PropTypes.number
};
NextAccesses.defaultProps = {
  data: {}
};
var NextAccesses$1 = NextAccesses;

var styles$8 = {"categoryWrapper":"FastAccesses-module_categoryWrapper__baU9J","nextCategoryMainTitle":"FastAccesses-module_nextCategoryMainTitle__LgkzW","categories":"FastAccesses-module_categories__rzZMU","iconBox":"FastAccesses-module_iconBox__zx-ob","icon":"FastAccesses-module_icon__-DQ1Y","active":"FastAccesses-module_active__zp3Lx","categoryTitle":"FastAccesses-module_categoryTitle__ZuFF3","seasonal":"FastAccesses-module_seasonal__FqMEm","label":"FastAccesses-module_label__CIJOR","chevronRightIcon":"FastAccesses-module_chevronRightIcon__8YKhi","childItems":"FastAccesses-module_childItems__RH-oL","secondLevelAccess":"FastAccesses-module_secondLevelAccess__fCY5T"};

var FastAccesses = function FastAccesses(_ref) {
  var data = _ref.data,
    showMenu = _ref.showMenu,
    isUserLoggedIn = _ref.isUserLoggedIn,
    isCmrPointsEnabled = _ref.isCmrPointsEnabled,
    tenant = _ref.tenant;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  useEffect(function () {
    isUserLoggedIn ? setItems(data.login_items) : setItems(data.not_logged_items);
  }, [isUserLoggedIn]);
  return jsx(Fragment, {
    children: items && items.length > 0 && items.map(function (item, itemIndex) {
      return jsx(Fragment, {
        children: jsx("div", {
          className: styles$8.categoryWrapper,
          children: item.child_items && item.child_items.length > 0 ? jsx(Fragment, {
            children: jsxs("div", {
              className: styles$8.categories,
              onClick: function onClick() {
                return showMenu(itemIndex, false, 'fastAccess');
              },
              children: [jsxs("div", {
                className: styles$8.categoryTitle,
                children: [item.icon && item.icon.url && jsx("div", {
                  className: styles$8.iconBox,
                  children: jsx("img", {
                    className: styles$8.icon,
                    src: item.icon.url
                  })
                }), !item.cmr_points_check_box && item.item_name, item.cmr_points_check_box && isCmrPointsEnabled && jsx(CmrPuntosMenuMobile, {
                  cmrPuntosURL: item.url,
                  cmrpuntosImageUrl: item.cmr_puntos_icon.url,
                  cmrText: item.item_name,
                  imageStyle: 'icon-cmr-icon',
                  isCmrPointsEnabled: isCmrPointsEnabled,
                  isLoggedIn: isUserLoggedIn,
                  isNewTab: item.is_new_tab,
                  tenantId: "falabella-".concat(tenant),
                  isNavigationMobileMenu: true,
                  isRebrandingEnabled: true,
                  section: "menu"
                })]
              }), jsx("div", {
                className: styles$8.chevronRightIcon
              })]
            })
          }) : jsx("a", {
            rel: "noreferrer noopener",
            target: item.is_new_tab ? '_blank' : '_self',
            className: styles$8.categories,
            href: item.url,
            onClick: function onClick() {
              updateDigitalDataCookies({
                firstLevelItem: item.item_name,
                secondLevelItem: item.item_name,
                thirdLevelItem: item.item_name,
                positionOne: 0,
                positionTwo: 0,
                positionThree: 0,
                tag: NAVIGATION
              });
            },
            children: jsxs("div", {
              className: styles$8.categoryTitle,
              children: [item.icon && item.icon.url && jsx("div", {
                className: styles$8.iconBox,
                children: jsx("img", {
                  className: styles$8.icon,
                  src: item.icon.url
                })
              }), !item.cmr_points_check_box && item.item_name, item.cmr_points_check_box && isCmrPointsEnabled && jsx(CmrPuntosMenuMobile, {
                cmrPuntosURL: item.url,
                cmrpuntosImageUrl: item.cmr_puntos_icon.url,
                cmrText: item.item_name,
                imageStyle: 'icon-cmr-icon',
                isCmrPointsEnabled: isCmrPointsEnabled,
                isLoggedIn: isUserLoggedIn,
                isNewTab: item.is_new_tab,
                isNavigationMobileMenu: true,
                tenantId: "falabella-".concat(tenant),
                isRebrandingEnabled: true,
                section: 'menu'
              })]
            })
          })
        })
      }, itemIndex);
    })
  });
};
FastAccesses.propTypes = {
  data: PropTypes.object,
  showMenu: PropTypes.func,
  isUserLoggedIn: PropTypes.bool,
  isCmrPointsEnabled: PropTypes.bool
};
FastAccesses.defaultProps = {
  data: {}
};
var FastAccesses$1 = FastAccesses;

var styles$7 = {"restAccesses":"RestAccesses-module_restAccesses__7sc2Y","download":"RestAccesses-module_download__veH1u","downloadIconBox":"RestAccesses-module_downloadIconBox__LSpEz","downloadIcon":"RestAccesses-module_downloadIcon__ERHUj","teleMarketingAndMonetizeBanner":"RestAccesses-module_teleMarketingAndMonetizeBanner__KcsVp","teleMarketingWrapper":"RestAccesses-module_teleMarketingWrapper__-n3ry","teleMarketingTitle":"RestAccesses-module_teleMarketingTitle__IpwWw","teleMarketingIconBox":"RestAccesses-module_teleMarketingIconBox__Zs8Hx","teleMarketingIcon":"RestAccesses-module_teleMarketingIcon__60vUC","teleMarketing":"RestAccesses-module_teleMarketing__ir59j","monetizeBanner":"RestAccesses-module_monetizeBanner__EnOeE","monetizeBannerImage":"RestAccesses-module_monetizeBannerImage__Lvv1L"};

var RestAccesses = function RestAccesses(_ref) {
  var downloadLink = _ref.downloadLink,
    telemarketing = _ref.telemarketing,
    banners = _ref.banners;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    platform = _useState2[0],
    setPlatform = _useState2[1];
  var item_name = downloadLink.item_name,
    icon = downloadLink.icon,
    url_ios = downloadLink.url_ios,
    url_android = downloadLink.url_android;
  var teleMarketingTitle = telemarketing.title,
    teleMarketingIcon = telemarketing.icon,
    number = telemarketing.number;
    telemarketing.link;
  var isIOS = platform === 'mobile_ios';
  useEffect(function () {
    if (window && window.navigator && window.navigator.userAgent) {
      setPlatform(getPlatformType(window.navigator.userAgent));
    }
  }, []);
  return jsxs("div", {
    className: styles$7.restAccesses,
    children: [downloadLink && jsxs("a", {
      rel: "noreferrer noopener",
      href: isIOS ? url_ios : url_android,
      target: "_blank",
      className: styles$7.download,
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: item_name,
          secondLevelItem: item_name,
          thirdLevelItem: item_name,
          positionOne: 0,
          positionTwo: 0,
          positionThree: 0,
          tag: NAVIGATION
        });
      },
      children: [icon && icon.url && jsx("div", {
        className: styles$7.downloadIconBox,
        children: jsx("img", {
          className: styles$7.downloadIcon,
          src: icon.url
        })
      }), item_name]
    }), jsxs("div", {
      className: styles$7.teleMarketingAndMonetizeBanner,
      children: [telemarketing && jsxs("div", {
        className: styles$7.teleMarketingWrapper,
        children: [jsx("div", {
          className: styles$7.teleMarketingTitle,
          children: teleMarketingTitle
        }), number && teleMarketingIcon && teleMarketingIcon.url && jsxs("a", {
          onClick: function onClick() {
            return teleMarketingTitle && updateDigitalDataCookies({
              firstLevelItem: teleMarketingTitle,
              secondLevelItem: teleMarketingTitle,
              thirdLevelItem: teleMarketingTitle,
              positionOne: 0,
              positionTwo: 0,
              positionThree: 0,
              tag: NAVIGATION
            });
          },
          className: styles$7.teleMarketing,
          href: "tel:".concat(number),
          children: [jsx("div", {
            className: styles$7.teleMarketingIconBox,
            children: jsx("img", {
              className: styles$7.teleMarketingIcon,
              src: teleMarketingIcon.url,
              alt: "teleMarketingIcon"
            })
          }), number]
        })]
      }), banners && banners.length > 0 && banners.map(function (_ref2, index) {
        var image_mobile = _ref2.image_mobile,
          isnewtab = _ref2.isnewtab,
          url = _ref2.url;
        return image_mobile && image_mobile.url && jsx("a", {
          href: url,
          rel: "noreferrer noopener",
          target: isnewtab ? '_blank' : '_self',
          className: styles$7.monetizeBanner,
          onClick: function onClick() {
            var name = image_mobile.filename && "M ".concat(image_mobile.filename.replace(/\..+$/, ''));
            updateDigitalDataCookies({
              firstLevelItem: name,
              secondLevelItem: name,
              thirdLevelItem: name,
              positionOne: index + 1,
              positionTwo: 0,
              positionThree: 0,
              tag: NAVIGATION
            });
          },
          children: jsx("img", {
            className: styles$7.monetizeBannerImage,
            src: image_mobile.url
          })
        }, "".concat(index, "_").concat(url));
      })]
    })]
  });
};
RestAccesses.propTypes = {
  downloadLink: PropTypes.object,
  telemarketing: PropTypes.object,
  banners: PropTypes.array
};
RestAccesses.defaultProps = {
  downloadLink: {},
  teleMarketing: {},
  banners: []
};
var RestAccesses$1 = RestAccesses;

var styles$6 = {"sideBarTitle":"SidebarTitle-module_sideBarTitle__cCCD6","text":"SidebarTitle-module_text__72hTU","lineClamp":"SidebarTitle-module_lineClamp__TJeR7","userName":"SidebarTitle-module_userName__R2dB0","backTitle":"SidebarTitle-module_backTitle__xpdOA","closeIcon":"SidebarTitle-module_closeIcon__zb9Ic","leftIcon":"SidebarTitle-module_leftIcon__35zEn"};

var SidebarTitle = function SidebarTitle(_ref) {
  var isMainMenu = _ref.isMainMenu,
    targetMenu = _ref.targetMenu,
    setActiveMenu = _ref.setActiveMenu,
    isUserLoggedIn = _ref.isUserLoggedIn,
    name = _ref.name,
    resetData = _ref.resetData;
  return isMainMenu ? jsxs("div", {
    className: styles$6.sideBarTitle,
    children: [jsxs("div", {
      className: classNames(styles$6.text, styles$6.lineClamp),
      children: ["\xA1Hola", isUserLoggedIn && jsxs(Fragment, {
        children: [',', jsx("span", {
          className: styles$6.userName,
          children: name
        })]
      }), "!"]
    }), jsx("div", {
      className: styles$6.closeIcon,
      onClick: function onClick() {
        return resetData();
      }
    })]
  }) : jsxs("div", {
    className: styles$6.sideBarTitle,
    children: [jsxs("div", {
      onClick: function onClick() {
        return setActiveMenu(targetMenu);
      },
      className: classNames(styles$6.text, styles$6.backTitle),
      children: [jsx("span", {
        className: styles$6.leftIcon
      }), "Volver al men\xFA principal"]
    }), jsx("div", {
      className: styles$6.closeIcon,
      onClick: function onClick() {
        return resetData();
      }
    })]
  });
};
SidebarTitle.propTypes = {
  isMainMenu: PropTypes.bool,
  targetMenu: PropTypes.string,
  setActiveMenu: PropTypes.func.isRequired,
  isUserLoggedIn: PropTypes.bool,
  name: PropTypes.string,
  resetData: PropTypes.func.isRequired
};
var SidebarTitle$1 = SidebarTitle;

var NEXTACCESS = 'nextAccess';
var FASTACCESS = 'fastAccess';
var MAIN_MENU = 'first-level-menu';
var SECOND_LEVEL_MENU = 'second-level-menu';
var THIRD_LEVEL_MENU = 'third-level-menu';
var THIRD_LEVEL_ACCESS = 'third-level-access';
var THIRD_LEVEL_FAST_ACCESS = 'third-level-fast-access';
var NEXT = 'next';
var GOBACK = 'goback';

var TaxonomyMobile = function TaxonomyMobile(_ref) {
  var _header$entry$header_, _header$entry;
  var taxonomyData = _ref.taxonomyData,
    showTaxonomy = _ref.showTaxonomy,
    hideMenu = _ref.hideMenu,
    header = _ref.header,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    setMenuVisible = _ref.setMenuVisible,
    isUserLoggedIn = _ref.isUserLoggedIn,
    firstName = _ref.firstName,
    tenant = _ref.tenant;
  header.entry;
  var isCmrPointsEnabled = (_header$entry$header_ = header === null || header === void 0 || (_header$entry = header.entry) === null || _header$entry === void 0 || (_header$entry = _header$entry.header_configs) === null || _header$entry === void 0 || (_header$entry = _header$entry[0]) === null || _header$entry === void 0 || (_header$entry = _header$entry.toggles) === null || _header$entry === void 0 ? void 0 : _header$entry.iscmrenabled) !== null && _header$entry$header_ !== void 0 ? _header$entry$header_ : false;
  var _taxonomyData$all_acc = taxonomyData.all_accesses,
    accesses = _taxonomyData$all_acc.accesses,
    categories = _taxonomyData$all_acc.categories,
    position = _taxonomyData$all_acc.category_position,
    _taxonomyData$logo = taxonomyData.logo,
    mobileLogo = _taxonomyData$logo.imagemobile,
    mobileLogoURL = _taxonomyData$logo.url,
    banner = taxonomyData.monetization_banners.banner,
    telemarketing = taxonomyData.ventatelef_nica,
    downloadLink = taxonomyData.app_item,
    fast_accesses = taxonomyData.fast_accesses;
  var _useState = useState(MAIN_MENU),
    _useState2 = _slicedToArray(_useState, 2),
    activeMenu = _useState2[0],
    setActiveMenu = _useState2[1];
  var _useState3 = useState(NEXT),
    _useState4 = _slicedToArray(_useState3, 2),
    menuHistory = _useState4[0],
    setMenuHistory = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    categoriesData = _useState6[0],
    setCategoriesData = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedSecondaryCategory = _useState8[0],
    setSelectedSecondaryCategory = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedTertiaryCategory = _useState0[0],
    setSelectedTertiaryCategory = _useState0[1];
  var _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    categoryNextIndex = _useState10[0],
    setCategoryNextIndex = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    categoryPrevIndex = _useState12[0],
    setCategoryPrevIndex = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedSecondaryAccess = _useState14[0],
    setSelectedSecondaryAccess = _useState14[1];
  var IS_SEASONAL_COUNT = 0;
  var purchaseGuides = selectedTertiaryCategory.gu_as_de_compra;
  var checkAccessORFastAccess = selectedSecondaryAccess.second_level_access || selectedSecondaryAccess.child_items;
  var data = [];
  var offset = 0;
  var accessesIndex = [];
  var categoryDigitalDataIndex = 0;
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    globalPosition = _useState16[0],
    setGlobalPosition = _useState16[1];
  var showMenu = function showMenu(index, childIndex, type) {
    if (activeMenu === MAIN_MENU && type === NEXTACCESS) {
      setSelectedSecondaryAccess(accesses[index].items[childIndex]);
      setMenuHistory(NEXT);
      setActiveMenu(THIRD_LEVEL_ACCESS);
    } else if (activeMenu === MAIN_MENU && type === FASTACCESS) {
      var isLogin = isUserLoggedIn ? 'login_items' : 'not_logged_items';
      setSelectedSecondaryAccess(fast_accesses[isLogin][index]);
      setMenuHistory(NEXT);
      setActiveMenu(THIRD_LEVEL_FAST_ACCESS);
    } else if (activeMenu === MAIN_MENU) {
      setCategoryPrevIndex(index);
      setSelectedSecondaryCategory(categories[index]);
      setMenuHistory(NEXT);
      setActiveMenu(SECOND_LEVEL_MENU);
    } else if (activeMenu === SECOND_LEVEL_MENU) {
      setCategoryNextIndex(index);
      setSelectedTertiaryCategory(selectedSecondaryCategory.second_level_categories[index]);
      setMenuHistory(GOBACK);
      setActiveMenu(THIRD_LEVEL_MENU);
    }
  };
  var resetData = function resetData() {
    setMenuVisible(false);
  };
  useEffect(function () {
    if (showTaxonomy) {
      setActiveMenu(MAIN_MENU);
    }
  }, [showTaxonomy]);
  var getCategoryDigitalData = function getCategoryDigitalData(index) {
    var isPurchaseGuide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (activeMenu === MAIN_MENU) {
      var indexOfMenu = index - categoryDigitalDataIndex;
      var name = hasTag$1(categories[indexOfMenu].item_name, categories[indexOfMenu].tag);
      updateDigitalDataCookies({
        firstLevelItem: name,
        secondLevelItem: name,
        thirdLevelItem: name,
        positionOne: index,
        positionTwo: 0,
        positionThree: 0,
        tag: NAVIGATION
      });
    }
    if (activeMenu === SECOND_LEVEL_MENU) {
      var _indexOfMenu = index - 1;
      var _name = selectedSecondaryCategory.second_level_categories[_indexOfMenu].item_name;
      updateDigitalDataCookies({
        firstLevelItem: categories[_indexOfMenu].item_name,
        secondLevelItem: _name,
        thirdLevelItem: _name,
        positionOne: globalPosition,
        positionTwo: index,
        positionThree: 0,
        tag: NAVIGATION
      });
    }
    if (activeMenu === THIRD_LEVEL_MENU) {
      var firstSelectedItem = hasTag$1(categories[categoryPrevIndex].item_name, categories[categoryPrevIndex].tag);
      var secondSelectedItem = selectedSecondaryCategory.second_level_categories[categoryNextIndex].item_name && selectedSecondaryCategory.second_level_categories[categoryNextIndex].item_name;
      var thirdSelectedItem;
      if (!isPurchaseGuide) {
        thirdSelectedItem = selectedTertiaryCategory && selectedTertiaryCategory.third_level_categories && selectedTertiaryCategory.third_level_categories.length > 0 && hasTag$1(selectedTertiaryCategory.third_level_categories[index - 1].item_name, selectedTertiaryCategory.third_level_categories[index - 1].tag);
      } else {
        thirdSelectedItem = 'Guía de compra';
      }
      var selondItemPosition = categoryNextIndex + 1;
      var thirdItemPosition = index;
      updateDigitalDataCookies({
        firstLevelItem: firstSelectedItem,
        secondLevelItem: secondSelectedItem,
        thirdLevelItem: thirdSelectedItem,
        positionOne: globalPosition,
        positionTwo: selondItemPosition,
        positionThree: thirdItemPosition,
        tag: NAVIGATION
      });
    }
  };
  useEffect(function () {
    accesses.forEach(function (element, index) {
      if (index === position - 1) {
        categoryDigitalDataIndex = offset + 1;
        offset += categories.length;
      }
      accessesIndex.push(offset + 1);
      offset += element.items.length;
    });
    if (position === 4) {
      categoryDigitalDataIndex = offset + 1;
    }
    var getCategoryData = function getCategoryData(accessIndex) {
      if (!categories || !categories.length) {
        return null;
      }
      return jsx("div", {
        className: styles$a.categoryBox,
        children: categories.map(function (y, index) {
          var is_Seasonal_Flag = false;
          if (y.is_seasonal) {
            IS_SEASONAL_COUNT += 1;
            is_Seasonal_Flag = IS_SEASONAL_COUNT <= 3;
          }
          return y && y.canal && y.canal.addmobile && jsx(Categories$1, {
            showMenu: showMenu,
            data: y,
            index: index,
            is_Seasonal_Flag: is_Seasonal_Flag,
            getCategoryDigitalData: getCategoryDigitalData,
            setGlobalPosition: setGlobalPosition,
            offset: categoryDigitalDataIndex
          }, "category-".concat(index));
        })
      }, "accesses-insert-".concat(accessIndex));
    };
    var nextAccesses = accesses.map(function (x, index) {
      return jsx("div", {
        className: styles$a.categoryBox,
        children: jsx(NextAccesses$1, {
          showMenu: showMenu,
          data: x,
          itemIndex: index,
          setGlobalPosition: setGlobalPosition,
          offset: accessesIndex[index]
        })
      }, "accesses-".concat(index));
    });
    nextAccesses.splice(position - 1, 0, getCategoryData(position));
    var categoryLevel = selectedTertiaryCategory && selectedTertiaryCategory.third_level_categories && selectedTertiaryCategory.third_level_categories.length > 0 && activeMenu === THIRD_LEVEL_MENU ? selectedTertiaryCategory.third_level_categories : selectedSecondaryCategory.second_level_categories && selectedSecondaryCategory.second_level_categories;
    activeMenu !== MAIN_MENU ? categoryLevel && categoryLevel.length > 0 && categoryLevel.map(function (y, index) {
      return data.push(jsx(Categories$1, {
        showMenu: showMenu,
        data: y,
        index: index,
        goToMenu: activeMenu,
        classes: styles$a.subCategories,
        getCategoryDigitalData: getCategoryDigitalData
      }, "category-".concat(index, "-").concat(activeMenu)));
    }) : [nextAccesses && data.push(nextAccesses)];
    setCategoriesData(data);
    return function () {
      setCategoriesData([]);
      data = [];
    };
  }, [activeMenu]);
  var getBrandLogo = function getBrandLogo() {
    return jsx("div", {
      className: styles$a.brandLogo,
      children: mobileLogo && jsx("a", {
        target: "_self",
        className: styles$a.logoBox,
        href: mobileLogoURL,
        children: jsx("img", {
          src: mobileLogo.url
        })
      })
    });
  };
  var getSidebarTitle = function getSidebarTitle() {
    return jsx(SidebarTitle$1, {
      isMainMenu: activeMenu === MAIN_MENU,
      targetMenu: activeMenu === THIRD_LEVEL_MENU ? SECOND_LEVEL_MENU : MAIN_MENU,
      setActiveMenu: setActiveMenu,
      setMenuVisible: setMenuVisible,
      isUserLoggedIn: isUserLoggedIn,
      name: firstName,
      resetData: resetData
    });
  };
  return jsx(CSSTransition, {
    "in": showTaxonomy,
    classNames: "container-open",
    appear: true,
    timeout: 0
    ,
    children: jsxs(Fragment, {
      children: [jsxs("div", {
        className: styles$a.TaxonomyMobile,
        children: [jsx(CSSTransition, {
          "in": activeMenu === MAIN_MENU,
          classNames: "left",
          unmountOnExit: true,
          timeout: 0
          ,
          children: jsxs("div", {
            className: styles$a.container,
            children: [getSidebarTitle(), jsxs("div", {
              className: styles$a.scrollWrapper,
              children: [jsx("div", {
                className: styles$a.fastAccessesBox,
                children: jsx(FastAccesses$1, {
                  data: fast_accesses,
                  showMenu: showMenu,
                  isCmrPointsEnabled: isCmrPointsEnabled,
                  isUserLoggedIn: isUserLoggedIn,
                  tenant: tenant
                })
              }), categoriesData && categoriesData, jsx(RestAccesses$1, {
                downloadLink: downloadLink,
                telemarketing: telemarketing,
                banners: banner
              }), getBrandLogo()]
            })]
          })
        }), jsx(CSSTransition, {
          "in": activeMenu === SECOND_LEVEL_MENU,
          classNames: menuHistory === NEXT ? 'right' : 'left',
          unmountOnExit: true,
          timeout: 0
          ,
          children: jsxs("div", {
            className: styles$a.container,
            children: [getSidebarTitle(), categories[categoryPrevIndex] && jsx("div", {
              className: styles$a.subCategoryMainTitle,
              children: categories[categoryPrevIndex].item_url ? jsxs("a", {
                href: categories[categoryPrevIndex].item_url,
                rel: "noreferrer noopener",
                target: "_self",
                onClick: function onClick() {
                  var name = hasTag$1(categories[categoryPrevIndex].item_name, categories[categoryPrevIndex].tag);
                  updateDigitalDataCookies({
                    firstLevelItem: name,
                    secondLevelItem: name,
                    thirdLevelItem: name,
                    positionOne: globalPosition,
                    positionTwo: 0,
                    positionThree: 0,
                    tag: NAVIGATION
                  });
                },
                children: [jsx("div", {
                  className: styles$a.iconWrapper,
                  children: categories[categoryPrevIndex].image_web && categories[categoryPrevIndex].image_web.url && jsx("img", {
                    className: styles$a.icon,
                    src: categories[categoryPrevIndex].image_web.url
                  })
                }), categories[categoryPrevIndex].item_name && categories[categoryPrevIndex].item_name]
              }) : jsxs(Fragment, {
                children: [jsx("div", {
                  className: styles$a.iconWrapper,
                  children: categories[categoryPrevIndex].image_web && categories[categoryPrevIndex].image_web.url && jsx("img", {
                    className: styles$a.icon,
                    src: categories[categoryPrevIndex].image_web.url
                  })
                }), categories[categoryPrevIndex].item_name && categories[categoryPrevIndex].item_name]
              })
            }), jsxs("div", {
              className: classNames(styles$a.scrollWrapper, styles$a.innerCategories),
              children: [jsxs("div", {
                className: styles$a.Wrapper,
                children: [categories[categoryPrevIndex] && categories[categoryPrevIndex].ver_todo && categories[categoryPrevIndex].ver_todo.title && jsx("div", {
                  className: styles$a.verTodoBox,
                  children: jsx("a", {
                    rel: "noreferrer noopener",
                    target: "_self",
                    className: styles$a.verTodo,
                    href: categories[categoryPrevIndex].ver_todo.href,
                    onClick: function onClick() {
                      updateDigitalDataCookies({
                        firstLevelItem: categories[categoryPrevIndex].item_name,
                        secondLevelItem: categories[categoryPrevIndex].ver_todo.title,
                        thirdLevelItem: categories[categoryPrevIndex].ver_todo.title,
                        positionOne: globalPosition,
                        positionTwo: 0,
                        positionThree: 0,
                        tag: NAVIGATION
                      });
                    },
                    children: categories[categoryPrevIndex].ver_todo.title
                  })
                }), categoriesData && categoriesData]
              }), jsx("div", {
                className: styles$a.Wrapper,
                children: getBrandLogo()
              })]
            })]
          })
        }), jsx(CSSTransition, {
          "in": activeMenu === THIRD_LEVEL_MENU,
          classNames: "right",
          unmountOnExit: true,
          timeout: 0
          ,
          children: jsxs("div", {
            className: styles$a.container,
            children: [getSidebarTitle(), jsx("div", {
              className: classNames(styles$a.subCategoryMainTitle, styles$a.thirdCategoryTitle),
              children: selectedSecondaryCategory && selectedSecondaryCategory.second_level_categories && selectedSecondaryCategory.second_level_categories[categoryNextIndex] && selectedSecondaryCategory.second_level_categories[categoryNextIndex].item_name && selectedSecondaryCategory.second_level_categories[categoryNextIndex].item_name
            }), jsxs("div", {
              className: classNames(styles$a.scrollWrapper, styles$a.innerCategories),
              children: [jsx("div", {
                className: styles$a.Wrapper,
                children: categoriesData && categoriesData
              }), jsxs("div", {
                className: styles$a.Wrapper,
                children: [purchaseGuides && purchaseGuides.length > 0 && jsx("div", {
                  className: styles$a.purchaseGuides,
                  children: purchaseGuides.map(function (_ref2, index) {
                    var url_mob = _ref2.url_mob,
                      text_mobile = _ref2.text_mobile,
                      image_mobile = _ref2.image_mobile;
                    return jsxs("a", {
                      href: url_mob,
                      rel: "noreferrer noopener",
                      target: "_self",
                      className: styles$a.purchaseGuide,
                      onClick: function onClick() {
                        getCategoryDigitalData(index + 1, true);
                      },
                      children: [jsx("div", {
                        className: styles$a.purchaseText,
                        children: text_mobile && text_mobile
                      }), jsx("img", {
                        className: styles$a.purchaseImage,
                        src: image_mobile && image_mobile.url
                      })]
                    }, index);
                  })
                }), getBrandLogo()]
              })]
            })]
          })
        }), jsx(CSSTransition, {
          "in": activeMenu === THIRD_LEVEL_ACCESS || activeMenu === THIRD_LEVEL_FAST_ACCESS,
          classNames: "right",
          unmountOnExit: true,
          timeout: 0
          ,
          children: jsxs("div", {
            className: styles$a.container,
            children: [getSidebarTitle(), jsx("div", {
              className: styles$a.accessesTitleWrapper,
              children: jsxs("div", {
                className: styles$a.accessesTitle,
                children: [selectedSecondaryAccess.icon && selectedSecondaryAccess.icon.url && jsx("div", {
                  className: styles$a.iconBox,
                  children: jsx("img", {
                    className: styles$a.icon,
                    src: selectedSecondaryAccess.icon.url
                  })
                }), selectedSecondaryAccess.item_name]
              })
            }), jsxs("div", {
              className: classNames(styles$a.scrollWrapper, styles$a.innerAccesses),
              children: [jsx("div", {
                className: styles$a.Wrapper,
                children: checkAccessORFastAccess && checkAccessORFastAccess.length > 0 && checkAccessORFastAccess.map(function (_ref3, index) {
                  var child_name = _ref3.child_name,
                    is_new_tab = _ref3.is_new_tab,
                    url = _ref3.url;
                  return jsx("div", {
                    className: styles$a.accesseswrapper,
                    children: jsx("a", {
                      rel: "noreferrer noopener",
                      target: is_new_tab ? '_blank' : '_self',
                      className: styles$a.accesses,
                      href: url,
                      onClick: function onClick() {
                        updateDigitalDataCookies({
                          firstLevelItem: selectedSecondaryAccess.item_name,
                          secondLevelItem: child_name,
                          thirdLevelItem: child_name,
                          positionOne: globalPosition,
                          positionTwo: index + 1,
                          positionThree: 0,
                          tag: NAVIGATION
                        });
                      },
                      children: child_name
                    })
                  }, index);
                })
              }), jsx("div", {
                className: styles$a.Wrapper,
                children: getBrandLogo()
              })]
            })]
          })
        })]
      }), showTaxonomy && jsx(TaxonomyOverlay$1, {
        isMarketPlace: true,
        hideMenu: hideMenu,
        isAgentLoggedIn: isAgentLoggedIn,
        isVendorLoggedIn: isVendorLoggedIn,
        classes: styles$a.overlay,
        allowScroll: false
      })]
    })
  });
};
TaxonomyMobile.defaultProps = {
  showTaxonomy: false,
  taxonomyData: {
    all_accesses: {
      accesses: [],
      categories: [],
      category_position: 1
    },
    logo: {
      imagemobile: {
        url: ''
      },
      url: ''
    },
    monetization_banners: {},
    ventatelef_nica: {
      title: ''
    },
    app_item: {},
    fast_accesses: {}
  },
  header: {}
};
TaxonomyMobile.propTypes = {
  hideMenu: PropTypes.func.isRequired,
  showTaxonomy: PropTypes.bool,
  header: PropTypes.object,
  firstName: PropTypes.string
};
var TaxonomyMobile$1 = withUser(TaxonomyMobile);

var styles$5 = {"HamburgerBtnWrapper":"Taxonomy-module_HamburgerBtnWrapper__oNEG4"};

var A11Y_LOCATION_LABEL = 'location';
var Taxonomy = function Taxonomy(_ref) {
  var headerData = _ref.headerData,
    data = _ref.data,
    currentLocation = _ref.currentLocation,
    isGeoLocationEnabled = _ref.isGeoLocationEnabled,
    deviceType = _ref.deviceType,
    hideMenuBar = _ref.hideMenuBar,
    isCatalyst = _ref.isCatalyst,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    isMenuVisible = _ref.isMenuVisible,
    setMenuVisible = _ref.setMenuVisible;
  var _useContext = useContext(AppContext$1),
    tenant = _useContext.tenant;
    _useContext.baseUrl;
  var taxonomyData = data.entry;
  var onNavBtnClick = function onNavBtnClick() {
    setMenuVisible(!isMenuVisible);
  };
  var hideMenu = function hideMenu() {
    setMenuVisible(false);
  };
  useEffect(function () {
    if (hideMenuBar) {
      hideMenu();
    }
  }, [hideMenuBar]);
  return jsxs("div", {
    className: styles$5.HamburgerBtnWrapper,
    children: [jsx(HamburgerBtn$1, {
      showTaxonomy: isMenuVisible,
      onNavBtnClick: onNavBtnClick,
      deviceType: deviceType
    }), jsx(MatchMedia$1, {
      content: {
        mobile: function mobile() {
          return jsx(TaxonomyMobile$1, {
            showTaxonomy: isMenuVisible,
            taxonomyData: taxonomyData,
            hideMenu: hideMenu,
            a11yLocationLabel: A11Y_LOCATION_LABEL,
            currentLocation: currentLocation,
            header: headerData,
            setMenuVisible: setMenuVisible,
            isGeoLocationEnabled: isGeoLocationEnabled,
            tenant: tenant,
            isCatalyst: isCatalyst
          });
        },
        tablet: function tablet() {
          return jsx(TaxonomyMobile$1, {
            showTaxonomy: isMenuVisible,
            taxonomyData: taxonomyData,
            hideMenu: hideMenu,
            a11yLocationLabel: A11Y_LOCATION_LABEL,
            currentLocation: currentLocation,
            header: headerData,
            setMenuVisible: setMenuVisible,
            isGeoLocationEnabled: isGeoLocationEnabled,
            tenant: tenant,
            isCatalyst: isCatalyst
          });
        },
        desktop: function desktop() {
          return jsx(TaxonomyDesktop$1, {
            showTaxonomy: isMenuVisible,
            taxonomyData: taxonomyData,
            setMenuVisible: setMenuVisible,
            hideMenu: hideMenu,
            isAgentLoggedIn: isAgentLoggedIn,
            isVendorLoggedIn: isVendorLoggedIn
          });
        }
      }
    })]
  });
};
Taxonomy.propTypes = {
  headerData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  firstName: PropTypes.string,
  currentLocation: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  isInternetExplorer: PropTypes.bool,
  isGeoLocationEnabled: PropTypes.bool,
  hideMenuBar: PropTypes.bool,
  isCatalyst: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isMenuVisible: PropTypes.bool,
  setMenuVisible: PropTypes.func
};
Taxonomy.defaultProps = {
  firstName: '',
  isInternetExplorer: false,
  isGeoLocationEnabled: false,
  hideMenuBar: false,
  isCatalyst: false,
  isAgentLoggedIn: false,
  isMenuVisible: false,
  setMenuVisible: noop$2
};
var getTaxonomyData = function getTaxonomyData(_ref2) {
  var tenant = _ref2.tenant,
    baseUrl = _ref2.baseUrl;
  var validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
  return doFetch(getTaxonomyDataUrl(baseUrl, validTenant, 'v2'), {}, {
    triggerOnResponseError: true,
    triggerOnNetworkError: true
  });
};
var Taxonomy$1 = withUser(Taxonomy);

var handleOnRouteChange = function handleOnRouteChange() {
  return '';
};
var OnboardingWithoutSSR$2 = SkipSSR$1(Onboarding$1);
var Header$4 = function Header(_ref) {
  var _data$header, _data$taxonomy, _data$sisNavigationMe, _header$entry$searchb, _header$entry, _header$entry$is_stic, _header$entry2, _header$entry$is_stic2, _header$entry3, _header$entry$is_stic3, _header$entry4, _header$entry$header_, _header$entry5, _header$entry$header_2, _header$entry6, _header$entry$header_3, _header$entry7, _header$entry$header_4, _header$entry8, _header$entry$header_5, _header$entry9, _header$entry$logo$de, _header$entry1, _header$entry$logo$mo, _header$entry10, _header$entry$themes$, _header$entry11, _header$entry$themes$2, _header$entry12, _header$entry$logo$ur, _header$entry13, _header$entry$sis_con, _header$entry14, _sisNavigationMenu$en, _sisNavigationMenu$en2, _header$entry$onboard, _header$entry15, _sisNavigationMenu$en17, _sisNavigationMenu$en18, _sisNavigationMenu$en19, _sisNavigationMenu$en20, _sisNavigationMenu$en21, _sisNavigationMenu$en22, _sisNavigationMenu$en23, _sisNavigationMenu$en24, _sisNavigationMenu$en25, _sisNavigationMenu$en26, _sisNavigationMenu$en27, _sisNavigationMenu$en28, _sisNavigationMenu$en29, _sisNavigationMenu$en30, _sisNavigationMenu$en31, _sisNavigationMenu$en32, _sisNavigationMenu$en33, _sisNavigationMenu$en34;
  var styles = _ref.styles,
    atgBaseUrl = _ref.atgBaseUrl,
    attachResizeListener = _ref.attachResizeListener,
    catalystBaseUrl = _ref.catalystBaseUrl,
    currentLocation = _ref.currentLocation,
    currentSearchTerm = _ref.currentSearchTerm,
    data = _ref.data,
    deviceType = _ref.deviceType,
    enableAnalyticsInfoCall = _ref.enableAnalyticsInfoCall,
    forceATG = _ref.forceATG,
    getTypeaheadUrl = _ref.getTypeaheadUrl,
    handleRouteChange = _ref.handleRouteChange,
    handleSoftRefresh = _ref.handleSoftRefresh,
    isATGLoginEnabled = _ref.isATGLoginEnabled,
    isDefaultComuna = _ref.isDefaultComuna,
    isGeoLocationEnabled = _ref.isGeoLocationEnabled,
    isPopOverVisible = _ref.isPopOverVisible,
    isTypeAheadEnabled = _ref.isTypeAheadEnabled,
    isZoneModalEnabled = _ref.isZoneModalEnabled,
    isWebPushNotificationEnabled = _ref.isWebPushNotificationEnabled,
    isSisSodimacPdpEnabled = _ref.isSisSodimacPdpEnabled,
    onUserLogin = _ref.onUserLogin,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate,
    onUserLogout = _ref.onUserLogout,
    selectedZone = _ref.selectedZone,
    setBusy = _ref.setBusy,
    store = _ref.store,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    userCartCount = _ref.userCartCount,
    transversalBannerConfig = _ref.transversalBannerConfig,
    locationPathname = _ref.locationPathname,
    isOrangeHeader = _ref.isOrangeHeader,
    isSISLevel2Header = _ref.isSISLevel2Header,
    MobileAppWebView = _ref.MobileAppWebView,
    hideZoneModalWebMobilePDP = _ref.hideZoneModalWebMobilePDP;
  var header = (_data$header = data === null || data === void 0 ? void 0 : data.header) !== null && _data$header !== void 0 ? _data$header : false;
  var taxonomyData = (_data$taxonomy = data === null || data === void 0 ? void 0 : data.taxonomy) !== null && _data$taxonomy !== void 0 ? _data$taxonomy : false;
  var sisNavigationMenu = (_data$sisNavigationMe = data === null || data === void 0 ? void 0 : data.sisNavigationMenu) !== null && _data$sisNavigationMe !== void 0 ? _data$sisNavigationMe : null;
  var labels = configs$1.labels,
    constants = configs$1.constants;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSearchBar = _useState2[0],
    setShowSearchBar = _useState2[1];
  var _useState3 = useState(store),
    _useState4 = _slicedToArray(_useState3, 2),
    site = _useState4[0],
    setSite = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(currentLocation),
    _useState8 = _slicedToArray(_useState7, 2),
    location = _useState8[0],
    setLocation = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isMenuVisible = _useState0[0],
    setMenuVisible = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isMobileApp = _useState10[0],
    setMobileApp = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    modalVisible = _useState12[0],
    setModalVisible = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isSearchBarTouched = _useState14[0],
    setIsSearchBarTouched = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    zoneModalVisible = _useState16[0],
    setZoneModalVisible = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    setSearchInputRef = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    currentStep = _useState20[0],
    setCurrentStep = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isOnboardingDisabledCookie = _useState22[0],
    setIsOnboardingDisabledCookie = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isVendorLoggedIn = _useState24[0],
    setIsVendorLoggedIn = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isAgentLoggedIn = _useState26[0],
    setIsAgentLoggedIn = _useState26[1];
  var _useState27 = useState({
      isVisible: false
    }),
    _useState28 = _slicedToArray(_useState27, 2),
    pushNotificationData = _useState28[0],
    setPushNotificationData = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    showLoginForm = _useState30[0],
    setShowLoginForm = _useState30[1];
  var emptySearchErrorTitle = labels.EMPTY_SEARCH_ERROR_TITLE;
  var emptySearchErrorMessage = labels.EMPTY_SEARCH_ERROR_MESSAGE;
  var incorrectSearchErrorTitle = labels.INCORRECT_SEARCH_ERROR_TITLE;
  var incorrectSearchErrorMessage = labels.INCORRECT_SEARCH_ERROR_MESSAGE;
  var _useContext = useContext(AppContext$1),
    tenant = _useContext.tenant,
    baseUrl = _useContext.baseUrl;
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isIE = _useState32[0],
    setIsIe = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    areCookiesPresent = _useState34[0],
    setAreCookiesPresent = _useState34[1];
  var isOrangeOrSISHeader = isOrangeHeader || site;
  var searchbar = (_header$entry$searchb = header === null || header === void 0 || (_header$entry = header.entry) === null || _header$entry === void 0 ? void 0 : _header$entry.searchbar) !== null && _header$entry$searchb !== void 0 ? _header$entry$searchb : {};
  var isStickyEnabled = {
    desktop: (_header$entry$is_stic = header === null || header === void 0 || (_header$entry2 = header.entry) === null || _header$entry2 === void 0 ? void 0 : _header$entry2.is_sticky_desktop) !== null && _header$entry$is_stic !== void 0 ? _header$entry$is_stic : false,
    mobile: (_header$entry$is_stic2 = header === null || header === void 0 || (_header$entry3 = header.entry) === null || _header$entry3 === void 0 ? void 0 : _header$entry3.is_sticky_mobile) !== null && _header$entry$is_stic2 !== void 0 ? _header$entry$is_stic2 : false,
    tablet: (_header$entry$is_stic3 = header === null || header === void 0 || (_header$entry4 = header.entry) === null || _header$entry4 === void 0 ? void 0 : _header$entry4.is_sticky_mobile) !== null && _header$entry$is_stic3 !== void 0 ? _header$entry$is_stic3 : false
  };
  var isOnboardingEnabled = (_header$entry$header_ = header === null || header === void 0 || (_header$entry5 = header.entry) === null || _header$entry5 === void 0 || (_header$entry5 = _header$entry5.header_configs) === null || _header$entry5 === void 0 || (_header$entry5 = _header$entry5[0]) === null || _header$entry5 === void 0 || (_header$entry5 = _header$entry5.toggles) === null || _header$entry5 === void 0 ? void 0 : _header$entry5.isonboardingenabled) !== null && _header$entry$header_ !== void 0 ? _header$entry$header_ : false;
  var isProgramaticallyGeofinderEnabled = (_header$entry$header_2 = header === null || header === void 0 || (_header$entry6 = header.entry) === null || _header$entry6 === void 0 || (_header$entry6 = _header$entry6.header_configs) === null || _header$entry6 === void 0 || (_header$entry6 = _header$entry6[0]) === null || _header$entry6 === void 0 || (_header$entry6 = _header$entry6.toggles) === null || _header$entry6 === void 0 ? void 0 : _header$entry6.isprogramaticallygeofinderenabled) !== null && _header$entry$header_2 !== void 0 ? _header$entry$header_2 : false;
  var _useState35 = useState(true),
    _useState36 = _slicedToArray(_useState35, 2),
    searchInSis = _useState36[0],
    setSearchInSis = _useState36[1];
  var geofinderConfigs = (_header$entry$header_3 = header === null || header === void 0 || (_header$entry7 = header.entry) === null || _header$entry7 === void 0 || (_header$entry7 = _header$entry7.header_configs) === null || _header$entry7 === void 0 || (_header$entry7 = _header$entry7[0]) === null || _header$entry7 === void 0 || (_header$entry7 = _header$entry7.property_configs) === null || _header$entry7 === void 0 ? void 0 : _header$entry7.geofinder) !== null && _header$entry$header_3 !== void 0 ? _header$entry$header_3 : {};
  var isRecentSearchesEnabled = (_header$entry$header_4 = header === null || header === void 0 || (_header$entry8 = header.entry) === null || _header$entry8 === void 0 || (_header$entry8 = _header$entry8.header_configs) === null || _header$entry8 === void 0 || (_header$entry8 = _header$entry8[0]) === null || _header$entry8 === void 0 || (_header$entry8 = _header$entry8.toggles) === null || _header$entry8 === void 0 ? void 0 : _header$entry8.isrecentsearchesenabled) !== null && _header$entry$header_4 !== void 0 ? _header$entry$header_4 : false;
  var isSearchSpecialCharactersEnabled = (_header$entry$header_5 = header === null || header === void 0 || (_header$entry9 = header.entry) === null || _header$entry9 === void 0 || (_header$entry9 = _header$entry9.header_configs) === null || _header$entry9 === void 0 || (_header$entry9 = _header$entry9[0]) === null || _header$entry9 === void 0 || (_header$entry9 = _header$entry9.toggles) === null || _header$entry9 === void 0 ? void 0 : _header$entry9.is_search_special_characters_enabled) !== null && _header$entry$header_5 !== void 0 ? _header$entry$header_5 : false;
  var closeNotification = function closeNotification() {
    setPushNotificationData({
      isVisible: false
    });
  };
  useEffect(function () {
    var onboardingCookie = CookieStorage$1.getCookie(constants.ON_BOARDING_COOKIE) === 'done';
    setIsOnboardingDisabledCookie(onboardingCookie);
  }, [currentStep]);
  useEffect(function () {
    function loadInitialData() {
      return _loadInitialData.apply(this, arguments);
    }
    function _loadInitialData() {
      _loadInitialData = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
        var onboardingCookie, ieRegex, urlParams, includeExternalDependencies, _header$entry$header_6, _header$entry0;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              onboardingCookie = CookieStorage$1.getCookie(constants.ON_BOARDING_COOKIE) === 'done';
              setIsOnboardingDisabledCookie(onboardingCookie);
              ieRegex = new RegExp(/MSIE|Trident.*rv/i);
              setIsIe(ieRegex.test(window.navigator.userAgent));
              if (!location) {
                setLocation(getCurrentLocation());
              }
              attachResizeListener();
              urlParams = new URLSearchParams(window.location.search);
              includeExternalDependencies = urlParams.get('includeExternalDependencies');
              if (includeExternalDependencies !== 'false') {
                loadExternalDependencies$1({
                  tenant: tenant,
                  environment: getEnvironment(),
                  toggles: {
                    isWebPushNotificationEnabled: isWebPushNotificationEnabled
                  },
                  functions: {
                    setPushNotificationData: setPushNotificationData
                  },
                  configs: {
                    webPushNotificationConfigs: (_header$entry$header_6 = header === null || header === void 0 || (_header$entry0 = header.entry) === null || _header$entry0 === void 0 || (_header$entry0 = _header$entry0.header_configs) === null || _header$entry0 === void 0 || (_header$entry0 = _header$entry0[0]) === null || _header$entry0 === void 0 || (_header$entry0 = _header$entry0.property_configs) === null || _header$entry0 === void 0 ? void 0 : _header$entry0.web_push_notifications) !== null && _header$entry$header_6 !== void 0 ? _header$entry$header_6 : {}
                  }
                });
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _loadInitialData.apply(this, arguments);
    }
    try {
      loadInitialData();
    } catch (error) {
      console.error(error);
    }
  }, []);
  useEffect(function () {
    var urlSearchParams = new URLSearchParams(window.location.search);
    var _Object$fromEntries = Object.fromEntries(urlSearchParams.entries()),
      externalSiteName = _Object$fromEntries.externalSiteName,
      sid = _Object$fromEntries.sid;
    if (externalSiteName === 'MobileApp' && sid === 'APPMOBILE') {
      setMobileApp(true);
    }
    var subDomain = getSubdomain();
    var expParam = getEXPParam();
    var isValidExpParam = function isValidExpParam() {
      return (isPdpPage() || !subDomain && isLandingPage()) && expParam;
    };
    var siteValue = isPdpPage() ? null : subDomain;
    setSite(store || (isValidExpParam() ? expParam : siteValue));
  }, []);
  useEffect(function () {
    if (isStickyEnabled[deviceType]) {
      var currScroll = 0;
      var prevScroll = 0;
      var currDirection = 0;
      var prevDirection = 0;
      var threshold = deviceType === 'desktop' ? 2000 : 1000;
      var toggled = false;
      var shouldStickyActivate = function shouldStickyActivate() {
        var _worldsMenuBar$offset, _filterSection$offset;
        var worldsMenuBar = document.querySelector('[data-wrapper="EM-Worldsapp"]');
        var filterSection = document.getElementById('testId-facets-mobile-container');
        return !!worldsMenuBar && currScroll + 70 > ((_worldsMenuBar$offset = worldsMenuBar === null || worldsMenuBar === void 0 ? void 0 : worldsMenuBar.offsetTop) !== null && _worldsMenuBar$offset !== void 0 ? _worldsMenuBar$offset : null) || !!filterSection && currScroll + 70 > ((_filterSection$offset = filterSection === null || filterSection === void 0 ? void 0 : filterSection.offsetTop) !== null && _filterSection$offset !== void 0 ? _filterSection$offset : null);
      };
      var toggleHeader = function toggleHeader() {
        toggled = true;
        var headerElement = document.getElementById('scrollable-content');
        var bottomHeaderElement = document.getElementById('bottom-header');
        headerElement.classList.remove("".concat(styles['header-scroll-styles']));
        bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
        if (currDirection === 2) {
          headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
        }
        if (currDirection === 2 && currScroll > threshold && !shouldStickyActivate()) {
          headerElement.classList.add("".concat(styles.hide));
        } else if (currDirection === 1 && currScroll > threshold && !shouldStickyActivate()
        ) {
          headerElement.classList.remove("".concat(styles.hide));
          headerElement.classList.add("".concat(styles['header-scroll-styles']));
          bottomHeaderElement.classList.add("".concat(styles['bottom-header']));
        } else {
          toggled = false;
          if (headerElement.classList.contains("".concat(styles.hide))) {
            headerElement.classList.remove("".concat(styles.hide));
          }
        }
        return toggled;
      };
      var checkScroll = function checkScroll() {
        var headerElement = document.getElementById('scrollable-content');
        var bottomHeaderElement = document.getElementById('bottom-header');
        currScroll = window.scrollY || document.documentElement.scrollTop;
        if (currScroll > prevScroll) {
          currDirection = 2;
        } else {
          currDirection = 1;
          if (currScroll <= 10) {
            if (isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent) {
              headerElement.classList.add("".concat(styles['header-scroll-styles2']));
            }
            headerElement.classList.remove("".concat(styles['header-scroll-styles']));
            bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
          }
          if (prevScroll < 5 && currScroll < prevScroll) {
            headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
            headerElement.classList.remove("".concat(styles['header-scroll-styles']));
            bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
          }
          if (prevScroll - currScroll >= 5) {
            headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
          }
        }
        if (currDirection !== prevDirection) {
          toggled = toggleHeader();
        }
        if (toggled) {
          prevDirection = currDirection;
        }
        prevScroll = currScroll;
      };
      window.onscroll = checkScroll;
    }
  }, [header]);
  useEffect(function () {
    if (currentLocation) {
      setLocation(currentLocation);
    }
  }, [currentLocation]);
  var onSearchTermChange = function onSearchTermChange(searchTerm) {
    if (searchTerm.length === 0) {
      setErrorMessage({
        title: emptySearchErrorTitle,
        msg: emptySearchErrorMessage
      });
      return false;
    }
    if (searchTerm.length < constants.MIN_SEARCH_TERM_LENGTH) {
      setErrorMessage({
        title: incorrectSearchErrorTitle,
        msg: incorrectSearchErrorMessage
      });
      return false;
    }
    var termo = encodeURIComponent(searchTerm).replace(/%20/g, '+');
    window.dispatchEvent(new CustomEvent('DDM_onSearching', {
      bubbles: true,
      detail: {
        value: termo,
        prefix: 'BCR'
      }
    }));
    if (handleRouteChange) {
      handleRouteChange(termo, store && searchInSis);
    } else {
      var searchingInSis = searchInSis && site;
      var envBaseUrl = searchingInSis ? getStoreBaseUrl(tenant, site) : getStoreBaseUrl(tenant);
      var expName = searchingInSis ? STORES[site.toUpperCase()] : 'falabella';
      console.log('Redirecting to ', "".concat(envBaseUrl, "/").concat(expName, "-").concat(tenant, "/search?Ntt=").concat(termo));
      window.location.href = "".concat(envBaseUrl, "/").concat(expName, "-").concat(tenant, "/search?Ntt=").concat(termo);
    }
    setErrorMessage(undefined);
    return true;
  };
  var onSearchDomainChange = function onSearchDomainChange() {
    setSearchInSis(!searchInSis);
  };
  var _useState37 = useState(''),
    _useState38 = _slicedToArray(_useState37, 2),
    agentCookieData = _useState38[0],
    setAgentCookieData = _useState38[1];
  var _useState39 = useState(''),
    _useState40 = _slicedToArray(_useState39, 2),
    userInformation = _useState40[0],
    setUserInformation = _useState40[1];
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    hideMenuBar = _useState42[0],
    setHideMenuBar = _useState42[1];
  var _useState43 = useState(false),
    _useState44 = _slicedToArray(_useState43, 2),
    isCatalyst = _useState44[0],
    setCatalyst = _useState44[1];
  var getCookie = CookieStorage$1.getCookie,
    setCookie = CookieStorage$1.setCookie,
    unescapeATGCookies = CookieStorage$1.unescapeATGCookies;
  var _useState45 = useState(''),
    _useState46 = _slicedToArray(_useState45, 2),
    mobileModalClass = _useState46[0],
    setMobileModalClass = _useState46[1];
  var toggleModal = function toggleModal(visibility) {
    if (deviceType !== 'desktop') {
      if (!visibility) {
        setMobileModalClass('floatBottomEndTransition');
        var animationTimer = setTimeout(function () {
          setModalVisible(visibility);
          clearTimeout(animationTimer);
        }, 350);
      } else {
        setMobileModalClass('floatBottomTransition');
        setModalVisible(visibility);
      }
    } else {
      setModalVisible(visibility);
    }
  };
  useEffect(function () {
    var params = new URLSearchParams(window.location.search);
    var storeIdQuery = params.get('storeId');
    var moduleQuery = params.get('modulo');
    var storeCookie = CookieStorage$1.getKioskoStoreCookieName();
    var moduleCookie = CookieStorage$1.getKioskoModuleCookieName();
    var storeId = getCookie(storeCookie);
    var module = getCookie(moduleCookie);
    if (storeIdQuery && storeId !== storeIdQuery) {
      setCookie({
        name: storeCookie,
        value: storeIdQuery
      });
      storeId = storeIdQuery;
    }
    if (moduleQuery && module !== moduleQuery) {
      setCookie({
        name: moduleCookie,
        value: moduleQuery
      });
      module = moduleQuery;
    }
    var vendorDataCookie = unescapeATGCookies(getCookie(CookieStorage$1.getVendorDataCookie()));
    var agentDataCookie = unescapeATGCookies(getCookie(CookieStorage$1.getAgentDataCookie()));
    var userCookie = CookieStorage$1.getUserDataCookieName();
    var userInformationCookie = unescapeATGCookies(getCookie(userCookie));
    if (vendorDataCookie) {
      setIsVendorLoggedIn(true);
    }
    if (storeId && module) {
      setAreCookiesPresent(true);
    }
    if (agentDataCookie) {
      setIsAgentLoggedIn(true);
      setAgentCookieData(agentDataCookie);
    }
    if (userInformationCookie) {
      setUserInformation(userInformationCookie);
    }
    setCatalyst(CookieStorage$1.isCatalyst());
  }, []);
  var isSvsSearch = getParameterByName('f.svs') === 'true';
  var handleUserLogout = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
      var userCookie;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            userCookie = CookieStorage$1.getUserDataCookieName();
            CookieStorage$1.removeCookie({
              name: userCookie
            });
            _context2.next = 1;
            return onUserLogout();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleUserLogout() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleUserLogin = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(userData) {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return onUserLogin(userData);
          case 1:
            if (enableAnalyticsInfoCall) {
              initDigitalData();
            }
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleUserLogin(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var marketPlaceLogoDesktop = isOrangeOrSISHeader ? MARKETPLACE_LOGO_URL_DESKTOP : (_header$entry$logo$de = header === null || header === void 0 || (_header$entry1 = header.entry) === null || _header$entry1 === void 0 || (_header$entry1 = _header$entry1.logo) === null || _header$entry1 === void 0 || (_header$entry1 = _header$entry1.desktop_icon) === null || _header$entry1 === void 0 ? void 0 : _header$entry1.url) !== null && _header$entry$logo$de !== void 0 ? _header$entry$logo$de : '';
  var marketPlaceLogoMobile = isOrangeOrSISHeader ? MARKETPLACE_LOGO_URL_MOBILE : (_header$entry$logo$mo = header === null || header === void 0 || (_header$entry10 = header.entry) === null || _header$entry10 === void 0 || (_header$entry10 = _header$entry10.logo) === null || _header$entry10 === void 0 || (_header$entry10 = _header$entry10.mobile_icon) === null || _header$entry10 === void 0 ? void 0 : _header$entry10.url) !== null && _header$entry$logo$mo !== void 0 ? _header$entry$logo$mo : '';
  var logoIconDesktop = !site ? marketPlaceLogoDesktop : (_header$entry$themes$ = header === null || header === void 0 || (_header$entry11 = header.entry) === null || _header$entry11 === void 0 || (_header$entry11 = _header$entry11.themes) === null || _header$entry11 === void 0 || (_header$entry11 = _header$entry11[site]) === null || _header$entry11 === void 0 || (_header$entry11 = _header$entry11.logos) === null || _header$entry11 === void 0 || (_header$entry11 = _header$entry11.desktop) === null || _header$entry11 === void 0 ? void 0 : _header$entry11.url) !== null && _header$entry$themes$ !== void 0 ? _header$entry$themes$ : BRAND_CONFIG$2["".concat(site)].brand_logo;
  var logoIconMobile = !site ? marketPlaceLogoMobile : (_header$entry$themes$2 = header === null || header === void 0 || (_header$entry12 = header.entry) === null || _header$entry12 === void 0 || (_header$entry12 = _header$entry12.themes) === null || _header$entry12 === void 0 || (_header$entry12 = _header$entry12[site]) === null || _header$entry12 === void 0 || (_header$entry12 = _header$entry12.logos) === null || _header$entry12 === void 0 || (_header$entry12 = _header$entry12.mobile) === null || _header$entry12 === void 0 ? void 0 : _header$entry12.url) !== null && _header$entry$themes$2 !== void 0 ? _header$entry$themes$2 : BRAND_CONFIG$2["".concat(site)].brand_logo;
  var mainLogoURL = (_header$entry$logo$ur = header === null || header === void 0 || (_header$entry13 = header.entry) === null || _header$entry13 === void 0 || (_header$entry13 = _header$entry13.logo) === null || _header$entry13 === void 0 ? void 0 : _header$entry13.url) !== null && _header$entry$logo$ur !== void 0 ? _header$entry$logo$ur : "".concat(isCatalyst ? catalystBaseUrl : atgBaseUrl, "/falabella-").concat(tenant);
  var logoURL = !site ? mainLogoURL : getNestedValue(header, "entry.themes.".concat(site, ".url"), BRAND_CONFIG$2["".concat(site)].url);
  var primaryThemeColor = getNestedValue(header, "entry.themes.".concat(site, ".color"), site ? BRAND_CONFIG$2[site].brand_color : '#AAD500');
  var secondaryThemeColor = getNestedValue(header, "entry.themes.".concat(site, ".secondary_color"), '#495867');
  var primaryColor = getNestedValue(header, "entry.themes.".concat(site, ".color"), site ? BRAND_CONFIG$2[site].brand_color : '#343E49');
  var secondaryColor = getNestedValue(header, "entry.themes.".concat(site, ".secondary_color"), '#343E49');
  var stores = ((_header$entry$sis_con = header === null || header === void 0 || (_header$entry14 = header.entry) === null || _header$entry14 === void 0 || (_header$entry14 = _header$entry14.sis_configs) === null || _header$entry14 === void 0 || (_header$entry14 = _header$entry14[0]) === null || _header$entry14 === void 0 ? void 0 : _header$entry14.stores) !== null && _header$entry$sis_con !== void 0 ? _header$entry$sis_con : []).filter(function (st) {
    return st.is_enable;
  }).sort(function (a, b) {
    return a.order - b.order;
  });
  var mobileBarRender = function mobileBarRender() {
    return isSISLevel2Header ? jsx(MobileBar$1, {
      url: mainLogoURL
    }) : jsx(React.Fragment, {});
  };
  var _getStandaloneSite = getStandaloneSite(store),
    isWhiteLabelSite = _getStandaloneSite.isWhiteLabelSite,
    isStandaloneSite = _getStandaloneSite.isStandaloneSite;
  var zoneModalVisibility = hideZoneModalWebMobilePDP && (!store || !(isStandaloneSite || isWhiteLabelSite)) && deviceType === 'mobile';
  return jsxs(Fragment$1, {
    children: [site && jsx(MatchMedia$1, {
      deviceType: deviceType,
      content: {
        desktop: function desktop() {
          return jsx(React.Fragment, {});
        },
        tablet: function tablet() {
          return mobileBarRender();
        },
        mobile: function mobile() {
          return mobileBarRender();
        }
      }
    }, "testId-taxonomy-mobile"), jsxs("header", {
      className: classNames(styles["".concat(isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent ? 'no-border' : '')], styles["".concat(MobileAppWebView ? 'hide-component' : '')]),
      children: [!isSISLevel2Header && stores.length > 0 && jsx(SISLinks$1, {
        stores: stores,
        storeName: !isEmpty(sisNavigationMenu) ? (_sisNavigationMenu$en = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en2 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en2 === void 0 ? void 0 : _sisNavigationMenu$en2.data_wrapper) !== null && _sisNavigationMenu$en !== void 0 ? _sisNavigationMenu$en : '' : '',
        deviceType: deviceType,
        isOnboardingEnabled: isOnboardingEnabled,
        isOnboardingDisabledCookie: isOnboardingDisabledCookie,
        currentStep: currentStep,
        isAgentLoggedIn: isAgentLoggedIn,
        isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
      }), errorMessage && jsx(ErrorDialog$1, {
        title: errorMessage.title,
        message: errorMessage.msg,
        onClose: function onClose() {
          setErrorMessage(undefined);
        }
      }), isAgentLoggedIn && jsx(AgentHeader$1, {
        agentCookie: agentCookieData,
        userName: userInformation.split('*')[0],
        agentBaseUrl: baseUrl,
        atgBaseUrl: atgBaseUrl,
        catalystBaseUrl: catalystBaseUrl,
        onUserLogout: handleUserLogout,
        isCatalyst: CookieStorage$1.isCatalyst(),
        tenant: tenant,
        isAgentLoggedIn: isAgentLoggedIn,
        setIsAgentLoggedIn: setIsAgentLoggedIn,
        forceATG: forceATG,
        store: store
      }), (isVendorLoggedIn || areCookiesPresent) && jsx(VendorHeader$1, {
        isCatalyst: CookieStorage$1.isCatalyst(),
        tenant: tenant,
        setIsVendorLoggedIn: setIsVendorLoggedIn,
        isVendorLoggedIn: isVendorLoggedIn,
        vendorBaseUrl: baseUrl,
        atgBaseUrl: atgBaseUrl,
        catalystBaseUrl: catalystBaseUrl,
        onUserLogout: handleUserLogout,
        forceATG: forceATG,
        store: store
      }), isOnboardingEnabled && !isMobileApp && jsx(OnboardingWithoutSSR$2, {
        deviceType: deviceType,
        currentStep: currentStep,
        setCurrentStep: setCurrentStep,
        onboardingData: (_header$entry$onboard = header === null || header === void 0 || (_header$entry15 = header.entry) === null || _header$entry15 === void 0 ? void 0 : _header$entry15.onboarding) !== null && _header$entry$onboard !== void 0 ? _header$entry$onboard : null,
        tenant: tenant
      }), jsxs("div", {
        id: "scrollable-content",
        style: {
          background: site && getNestedValue(header, "entry.themes.".concat(site, ".color"), BRAND_CONFIG$2[site].brand_color)
        },
        "data-testid": "header-util-bar",
        className: classNames("".concat(styles['header-util-bar'])),
        children: [jsxs("div", {
          className: classNames(styles.container, styles['header-container']),
          children: [!site && jsxs(Fragment$1, {
            children: [jsx(MatchMedia$1, {
              deviceType: deviceType,
              content: {
                desktop: function desktop() {
                  return jsx(React.Fragment, {});
                },
                tablet: function tablet() {
                  return jsx(React.Fragment, {});
                },
                mobile: function mobile() {
                  return jsx(Taxonomy$1, {
                    headerData: header,
                    data: taxonomyData,
                    currentLocation: location,
                    isInternetExplorer: isIE,
                    isMenuVisible: isMenuVisible,
                    setMenuVisible: setMenuVisible,
                    isGeoLocationEnabled: isGeoLocationEnabled,
                    deviceType: deviceType,
                    hideMenuBar: hideMenuBar,
                    isCatalyst: isCatalyst,
                    isAgentLoggedIn: isAgentLoggedIn,
                    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
                  });
                }
              }
            }, "testId-taxonomy-mobile"), jsx(MatchMedia$1, {
              deviceType: deviceType,
              content: {
                desktop: function desktop() {
                  return jsx(React.Fragment, {});
                },
                mobile: function mobile() {
                  return jsx(React.Fragment, {});
                },
                tablet: function tablet() {
                  return jsx(Taxonomy$1, {
                    headerData: header,
                    data: taxonomyData,
                    currentLocation: location,
                    isInternetExplorer: isIE,
                    isMenuVisible: isMenuVisible,
                    setMenuVisible: setMenuVisible,
                    isGeoLocationEnabled: isGeoLocationEnabled,
                    deviceType: deviceType,
                    hideMenuBar: hideMenuBar,
                    isCatalyst: isCatalyst,
                    isAgentLoggedIn: isAgentLoggedIn,
                    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
                  });
                }
              }
            }, "testId-taxonomy-tablet")]
          }), jsx(MatchMedia$1, {
            deviceType: deviceType,
            content: {
              desktop: function desktop() {
                return jsx(Logo$1, {
                  path: logoURL,
                  logoIcon: logoIconDesktop,
                  store: site
                });
              },
              mobile: function mobile() {
                return jsx(Logo$1, {
                  path: logoURL,
                  logoIcon: logoIconMobile,
                  isMobile: true,
                  store: site
                });
              },
              tablet: function tablet() {
                return jsx(Logo$1, {
                  path: logoURL,
                  logoIcon: logoIconMobile,
                  isMobile: true,
                  store: site
                });
              }
            }
          }, "testId-logo-link"), jsx(MatchMedia$1, {
            deviceType: deviceType,
            content: {
              mobile: function mobile() {
                return jsx(React.Fragment, {});
              },
              tablet: function tablet() {
                return jsx(React.Fragment, {});
              },
              desktop: function desktop() {
                var _sisNavigationMenu$en3, _sisNavigationMenu$en4, _sisNavigationMenu$en5, _sisNavigationMenu$en6, _sisNavigationMenu$en7, _sisNavigationMenu$en8, _sisNavigationMenu$en9, _sisNavigationMenu$en0, _sisNavigationMenu$en1, _sisNavigationMenu$en10, _sisNavigationMenu$en11, _sisNavigationMenu$en12, _sisNavigationMenu$en13, _sisNavigationMenu$en14, _sisNavigationMenu$en15, _sisNavigationMenu$en16;
                return jsx(SiSNavigationMenu$1, {
                  brandLogo: (_sisNavigationMenu$en3 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en4 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en4 === void 0 ? void 0 : _sisNavigationMenu$en4.brand_logo) !== null && _sisNavigationMenu$en3 !== void 0 ? _sisNavigationMenu$en3 : {},
                  categories: (_sisNavigationMenu$en5 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en6 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en6 === void 0 ? void 0 : _sisNavigationMenu$en6.categories) !== null && _sisNavigationMenu$en5 !== void 0 ? _sisNavigationMenu$en5 : [],
                  browseMainText: (_sisNavigationMenu$en7 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en8 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en8 === void 0 ? void 0 : _sisNavigationMenu$en8.browse_main_text) !== null && _sisNavigationMenu$en7 !== void 0 ? _sisNavigationMenu$en7 : '',
                  colorLine: (_sisNavigationMenu$en9 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en0 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en0 === void 0 ? void 0 : _sisNavigationMenu$en0.color_line) !== null && _sisNavigationMenu$en9 !== void 0 ? _sisNavigationMenu$en9 : '',
                  categoryColor: (_sisNavigationMenu$en1 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en10 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en10 === void 0 ? void 0 : _sisNavigationMenu$en10.category_color) !== null && _sisNavigationMenu$en1 !== void 0 ? _sisNavigationMenu$en1 : '',
                  hightlightColor: (_sisNavigationMenu$en11 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en12 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en12 === void 0 ? void 0 : _sisNavigationMenu$en12.hightlight_color) !== null && _sisNavigationMenu$en11 !== void 0 ? _sisNavigationMenu$en11 : '',
                  hightlightTextColor: (_sisNavigationMenu$en13 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en14 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en14 === void 0 ? void 0 : _sisNavigationMenu$en14.hightlight_text_color) !== null && _sisNavigationMenu$en13 !== void 0 ? _sisNavigationMenu$en13 : '',
                  dataWrapper: (_sisNavigationMenu$en15 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en16 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en16 === void 0 ? void 0 : _sisNavigationMenu$en16.data_wrapper) !== null && _sisNavigationMenu$en15 !== void 0 ? _sisNavigationMenu$en15 : '',
                  store: site,
                  isSISLevel2Header: isSISLevel2Header
                });
              }
            }
          }, "testId-store-menu"), !site && jsx(MatchMedia$1, {
            deviceType: deviceType,
            content: {
              mobile: function mobile() {
                return jsx(React.Fragment, {});
              },
              tablet: function tablet() {
                return jsx(React.Fragment, {});
              },
              desktop: function desktop() {
                return jsx(Taxonomy$1, {
                  currentLocation: location,
                  data: taxonomyData,
                  deviceType: deviceType,
                  headerData: header,
                  hideMenuBar: hideMenuBar,
                  isAgentLoggedIn: isAgentLoggedIn,
                  isCatalyst: isCatalyst,
                  isGeoLocationEnabled: isGeoLocationEnabled,
                  isInternetExplorer: isIE,
                  isMenuVisible: isMenuVisible,
                  isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
                  setMenuVisible: setMenuVisible
                });
              }
            }
          }, "testId-taxonomy-desktop"), jsx(MatchMedia$1, {
            deviceType: deviceType,
            content: {
              desktop: function desktop() {
                return jsx(Search$1, {
                  deviceType: deviceType,
                  getTypeaheadUrl: getTypeaheadUrl,
                  isAndes: isZoneModalEnabled,
                  searchInSis: searchInSis,
                  isSvsSearch: isSvsSearch,
                  isTypeAheadEnabled: isTypeAheadEnabled,
                  isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
                  onLoadingStateChange: setBusy,
                  onSearch: onSearchTermChange,
                  searchbar: searchbar,
                  setHideMenuBar: setHideMenuBar,
                  setSearchInputRef: setSearchInputRef,
                  isSearchBarTouched: isSearchBarTouched,
                  setIsSearchBarTouched: setIsSearchBarTouched,
                  showSearchBar: showSearchBar,
                  currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
                  store: site,
                  onSearchDomainChange: onSearchDomainChange,
                  isRecentSearchesEnabled: isRecentSearchesEnabled,
                  isSearchSpecialCharactersEnabled: isSearchSpecialCharactersEnabled
                });
              },
              mobile: function mobile() {
                return jsx(React.Fragment, {});
              },
              tablet: function tablet() {
                return jsx(React.Fragment, {});
              }
            }
          }, "search-bar-desktop"), jsx(UserActions$1, {
            showSearchBar: showSearchBar,
            setShowSearchBar: setShowSearchBar,
            isATGLoginEnabled: isATGLoginEnabled,
            isInternetExplorer: isIE,
            atgBaseUrl: atgBaseUrl,
            showLoginForm: showLoginForm,
            setShowLoginForm: setShowLoginForm,
            modalVisible: modalVisible,
            mobileModalClass: mobileModalClass,
            toggleModal: toggleModal,
            catalystBaseUrl: catalystBaseUrl,
            onLoadingStateChange: setBusy,
            onUserLogout: handleUserLogout,
            deviceType: deviceType,
            headerData: header,
            onUserLogin: handleUserLogin,
            onUserLoginComplete: onUserLoginComplete,
            onUserLoginConsentsUpdate: onUserLoginConsentsUpdate,
            onUserLoginPasswordUpdate: onUserLoginPasswordUpdate,
            unifiedLoginBaseUrl: unifiedLoginBaseUrl,
            userCartCount: userCartCount,
            isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 1,
            setHideMenuBar: setHideMenuBar,
            setMenuVisible: setMenuVisible,
            forceATG: forceATG,
            isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
            isAgentLoggedIn: isAgentLoggedIn,
            isStore: !!site,
            isOrangeOrSISHeader: isOrangeOrSISHeader,
            isSISLevel2Header: isSISLevel2Header
          })]
        }), deviceType !== 'desktop' && jsxs("div", {
          className: classNames(_defineProperty({}, styles.mobile_middle_wrapper, site)),
          children: [jsx(SiSNavigationMenu$1, {
            brandLogo: (_sisNavigationMenu$en17 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en18 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en18 === void 0 ? void 0 : _sisNavigationMenu$en18.brand_logo) !== null && _sisNavigationMenu$en17 !== void 0 ? _sisNavigationMenu$en17 : {},
            categories: (_sisNavigationMenu$en19 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en20 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en20 === void 0 ? void 0 : _sisNavigationMenu$en20.categories) !== null && _sisNavigationMenu$en19 !== void 0 ? _sisNavigationMenu$en19 : [],
            browseMainText: (_sisNavigationMenu$en21 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en22 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en22 === void 0 ? void 0 : _sisNavigationMenu$en22.browse_main_text) !== null && _sisNavigationMenu$en21 !== void 0 ? _sisNavigationMenu$en21 : '',
            colorLine: (_sisNavigationMenu$en23 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en24 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en24 === void 0 ? void 0 : _sisNavigationMenu$en24.color_line) !== null && _sisNavigationMenu$en23 !== void 0 ? _sisNavigationMenu$en23 : '',
            categoryColor: (_sisNavigationMenu$en25 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en26 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en26 === void 0 ? void 0 : _sisNavigationMenu$en26.category_color) !== null && _sisNavigationMenu$en25 !== void 0 ? _sisNavigationMenu$en25 : '',
            hightlightColor: (_sisNavigationMenu$en27 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en28 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en28 === void 0 ? void 0 : _sisNavigationMenu$en28.hightlight_color) !== null && _sisNavigationMenu$en27 !== void 0 ? _sisNavigationMenu$en27 : '',
            hightlightTextColor: (_sisNavigationMenu$en29 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en30 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en30 === void 0 ? void 0 : _sisNavigationMenu$en30.hightlight_text_color) !== null && _sisNavigationMenu$en29 !== void 0 ? _sisNavigationMenu$en29 : '',
            dataWrapper: (_sisNavigationMenu$en31 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en32 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en32 === void 0 ? void 0 : _sisNavigationMenu$en32.data_wrapper) !== null && _sisNavigationMenu$en31 !== void 0 ? _sisNavigationMenu$en31 : '',
            store: site
          }), jsx(Search$1, {
            deviceType: deviceType,
            onSearch: onSearchTermChange,
            currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
            isSvsSearch: isSvsSearch,
            isTypeAheadEnabled: isTypeAheadEnabled,
            isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
            getTypeaheadUrl: getTypeaheadUrl,
            onLoadingStateChange: setBusy,
            searchbar: searchbar,
            setHideMenuBar: setHideMenuBar,
            isAndes: isZoneModalEnabled,
            isAgentLoggedIn: isAgentLoggedIn,
            isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
            setSearchInputRef: setSearchInputRef,
            isSearchBarTouched: isSearchBarTouched,
            setIsSearchBarTouched: setIsSearchBarTouched,
            store: site,
            searchInSis: searchInSis,
            onSearchDomainChange: onSearchDomainChange,
            isRecentSearchesEnabled: isRecentSearchesEnabled,
            isSearchSpecialCharactersEnabled: isSearchSpecialCharactersEnabled
          })]
        })]
      }), !zoneModalVisibility && jsxs("div", {
        id: "bottom-header",
        className: classNames(_defineProperty({}, styles.hasBorder, !isOrangeOrSISHeader)),
        children: [jsx(TransversalBanner$1, {
          transversalBanner: header.transversalBannerHtml,
          transversalBannerConfig: transversalBannerConfig,
          locationPathname: locationPathname
        }, "transversalBanner"), jsx(TernaryNavBar$1, {
          currentStep: currentStep,
          deviceType: deviceType,
          handleRouteChange: handleSoftRefresh,
          header: header,
          isAgentLoggedIn: isAgentLoggedIn,
          baseUrl: catalystBaseUrl,
          isBrandingMarketplace: true,
          isDefaultComuna: isDefaultComuna,
          selectedZone: selectedZone,
          isPopOverVisible: isPopOverVisible,
          isOnboardingDisabledCookie: isOnboardingDisabledCookie,
          isOnboardingEnabled: isOnboardingEnabled,
          searchInSis: searchInSis,
          isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
          isZoneModalEnabled: isZoneModalEnabled,
          isSearchBarTouched: isSearchBarTouched,
          modalVisible: zoneModalVisible,
          setModalVisible: setZoneModalVisible,
          tenant: tenant,
          onSearchDomainChange: onSearchDomainChange,
          storeName: !isEmpty(sisNavigationMenu) ? (_sisNavigationMenu$en33 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en34 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en34 === void 0 ? void 0 : _sisNavigationMenu$en34.data_wrapper) !== null && _sisNavigationMenu$en33 !== void 0 ? _sisNavigationMenu$en33 : '' : '',
          isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
          geofinderConfigs: geofinderConfigs,
          isOrangeOrSISHeader: isOrangeOrSISHeader,
          isSISLevel2Header: isSISLevel2Header,
          setShowLoginForm: setShowLoginForm
        })]
      }), modalVisible && deviceType !== 'desktop' && jsx(MarketplaceOverlay$1, {
        handlers: function handlers(e) {
          e.preventDefault();
          toggleModal(false);
          setModalVisible(false);
        }
      }), pushNotificationData.isVisible && jsx(Notification$1, {
        requireInteraction: pushNotificationData.require_interaction,
        isVisible: pushNotificationData.isVisible,
        isWelcomeMessage: pushNotificationData.isWelcomeMessage,
        action: pushNotificationData.action,
        icon: pushNotificationData.icon,
        title: pushNotificationData.title,
        body: pushNotificationData.body,
        closeNotification: closeNotification
      }), pushNotificationData.isVisible && jsx(Notification$1, {
        requireInteraction: pushNotificationData.require_interaction,
        isVisible: pushNotificationData.isVisible,
        isWelcomeMessage: pushNotificationData.isWelcomeMessage,
        action: pushNotificationData.action,
        icon: pushNotificationData.icon,
        title: pushNotificationData.title,
        body: pushNotificationData.body,
        closeNotification: closeNotification
      })]
    }), site && jsxs("style", {
      children: [' ', "\n          :root {\n            --primary-color: ".concat(primaryColor, ";\n            --secondary-color: ").concat(secondaryColor, ";\n            --primary-theme-color: ").concat(primaryThemeColor, ";\n            --secondary-theme-color: ").concat(secondaryThemeColor, ";\n          }\n        ")]
    }), isOrangeOrSISHeader ? jsx("style", {
      children: "\n        :root {\n          --header-logo-background: linear-gradient(270.96deg, #ff6200 0%, #ff861b 95.09%);\n          --header-background: #ee5601;\n          --mobile-header-background: linear-gradient(17.56deg,#ff9401 63.22%,#ff7b01 105.58%,#ff6c01 144.92%);\n          --text-color: #fff;\n          --icon-background: #495867;\n          --hover-color: #FF6200;\n          --searchbar-box-shadow: 0px 0px 4px rgba(158, 160, 150, 0.5);\n          --cart-border-color: #ff9502;\n          --border-color: 255, 255, 255;\n          --header-primary-color: ".concat(primaryColor, ";\n          --header-zone-primary-color:#fff;\n          --sis-link-header-zone-whithe-icon: url(https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blte2bf633680a745d6/location_pin_white_sis.svg) !important;\n          --header-border-top:;\n          --search-bar-border-radius:35px;\n          --category-button-wrapper-border-radius:32px;\n          --search-bar-button-icon-border-radius:35px;\n          --category-button-wrapper-font-size:16px;\n          --category-button-wrapper-border-color: #fff;\n          --category-button-chevron-down-color:#fff;\n        }\n        ")
    }) : jsx("style", {
      children: "\n          :root {\n            --header-logo-background: transparent;\n            --header-background: #FAFAFA;\n            --mobile-header-background: #FAFAFA;\n            --text-color: #343E49;\n            --icon-background: #343E49;\n            --hover-color: transparent;\n            --searchbar-box-shadow: none;\n            --cart-border-color: #343E49;\n            --border-color: 73, 88, 103;\n            --border-top-desktop: #CAD1D9;\n            --border-top-mobile: #FAFAFA;\n            --primary-color: ".concat(primaryColor, ";\n            --secondary-color: ").concat(primaryColor, ";\n            --primary-theme-color: ").concat(primaryThemeColor, ";\n            --secondary-theme-color: ").concat(secondaryThemeColor, ";\n            --linear-gradient-1: linear-gradient(90deg, #668F00 0%, #8FCA00 100%);\n            --linear-gradient-2: #AAD500;\n            --navigation-title: #68717D;\n            --color-shade-1: #495867;\n            --header-primary-color:#FAFAFA;\n            --sis-link-header-zone-whithe-icon:url(https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt12bfc7a09b55ab55/6538d0cfd31953c6b30dbd57/gray_geofinder.svg) !important;\n            --header-border-top:").concat(!isSISLevel2Header ? '1px solid #EEEEEE;' : '', "\n            --search-bar-border-radius:35px;\n            --search-bar-button-icon-border-radius:35px;\n            --category-button-wrapper-border-radius:32px;\n            --category-button-wrapper-font-size:16px;\n          }\n        ")
    })]
  });
};
Header$4.defaultProps = {
  atgBaseUrl: '',
  catalystBaseUrl: '',
  currentLocation: '',
  currentSearchTerm: '',
  enableAnalyticsInfoCall: false,
  forceATG: false,
  handleSoftRefresh: noop$2,
  isATGLoginEnabled: false,
  isDefaultComuna: false,
  isGeoLocationEnabled: true,
  isPopOverVisible: false,
  isTypeAheadEnabled: true,
  isZoneModalEnabled: true,
  isWebPushNotificationEnabled: false,
  isSisSodimacPdpEnabled: false,
  onRouteChange: handleOnRouteChange,
  onUserLogin: noop$2,
  onUserLoginComplete: noop$2,
  onUserLoginConsentsUpdate: noop$2,
  onUserLoginPasswordUpdate: noop$2,
  onUserLogout: noop$2,
  parentRouter: null,
  selectedZone: undefined,
  store: null,
  unifiedLoginBaseUrl: undefined,
  userCartCount: undefined,
  locationPathname: undefined,
  getTypeaheadUrl: apiConfig$2.getTypeaheadUrl,
  isOrangeHeader: false,
  isSISLevel2Header: false,
  MobileAppWebView: false,
  hideZoneModalWebMobilePDP: false
};
Header$4.propTypes = {
  styles: PropTypes.object.isRequired,
  atgBaseUrl: PropTypes.string.isRequired,
  attachResizeListener: PropTypes.func.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  currentLocation: PropTypes.string,
  currentSearchTerm: PropTypes.string,
  data: PropTypes.any,
  deviceType: PropTypes.string.isRequired,
  enableAnalyticsInfoCall: PropTypes.bool,
  forceATG: PropTypes.bool,
  getTypeaheadUrl: PropTypes.func,
  handleRouteChange: PropTypes.any,
  handleSoftRefresh: PropTypes.func,
  isATGLoginEnabled: PropTypes.bool,
  isDefaultComuna: PropTypes.bool,
  isGeoLocationEnabled: PropTypes.bool,
  isPopOverVisible: PropTypes.bool,
  isTypeAheadEnabled: PropTypes.bool,
  isZoneModalEnabled: PropTypes.bool,
  isWebPushNotificationEnabled: PropTypes.bool,
  isSisSodimacPdpEnabled: PropTypes.bool,
  onRouteChange: PropTypes.func,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  onUserLogout: PropTypes.func,
  parentRouter: PropTypes.any,
  refreshUserData: PropTypes.func.isRequired,
  selectedZone: PropTypes.object,
  setAnalyticsInfo: PropTypes.func.isRequired,
  setBusy: PropTypes.func.isRequired,
  locationPathname: PropTypes.string,
  store: PropTypes.oneOf(['linio', 'sodimac', 'tottus', 'homecenter']),
  unifiedLoginBaseUrl: PropTypes.string,
  userCartCount: PropTypes.string,
  transversalBannerConfig: PropTypes.shape({
    home: PropTypes.bool,
    pdp: PropTypes.bool,
    xlp: PropTypes.bool,
    basket: PropTypes.bool
  }),
  isOrangeHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  MobileAppWebView: PropTypes.bool,
  hideZoneModalWebMobilePDP: PropTypes.bool
};
var MarketplaceHeader = withUser(withLoader(withDevice(Header$4)));

var styles$4 = {"hide":"Header-module_hide__293ao","bottom-header":"Header-module_bottom-header__wu5ES","hasBorder":"Header-module_hasBorder__RCj2a","header-scroll-styles":"Header-module_header-scroll-styles__RwZ-C","header-scroll-vendor":"Header-module_header-scroll-vendor__KqVqz","no-border":"Header-module_no-border__NKUF9","header-util-bar":"Header-module_header-util-bar__CMrVf","container":"Header-module_container__8x1TS","header-container":"Header-module_header-container__UoP9n","header-container--so_com":"Header-module_header-container--so_com__XylLD","header-container--to_com":"Header-module_header-container--to_com__3eIAQ","mobile_middle_wrapper":"Header-module_mobile_middle_wrapper__stC8S","mobile_middle_wrapper--to_com":"Header-module_mobile_middle_wrapper--to_com__FUGT9","hide-component":"Header-module_hide-component__DFJB9"};

var whitelabelStyles = {"hide":"WhitelabelHeader-module_hide__o1T21","hasBorder":"WhitelabelHeader-module_hasBorder__lo3ld","header-scroll-styles":"WhitelabelHeader-module_header-scroll-styles__ZJfaV","header-scroll-vendor":"WhitelabelHeader-module_header-scroll-vendor__zeewI","no-border":"WhitelabelHeader-module_no-border__ITmFD","header-util-bar":"WhitelabelHeader-module_header-util-bar__lYAfa","container":"WhitelabelHeader-module_container__QL96k","header-container":"WhitelabelHeader-module_header-container__lP9Y2","header-container-icon-center":"WhitelabelHeader-module_header-container-icon-center__sV6R1","logo-container-center":"WhitelabelHeader-module_logo-container-center__P2Oaa","width-center":"WhitelabelHeader-module_width-center__QuxMr","si":"WhitelabelHeader-module_si__urRDf","mobile_middle_wrapper":"WhitelabelHeader-module_mobile_middle_wrapper__JBTo5","mobile_middle_wrapper--to_com":"WhitelabelHeader-module_mobile_middle_wrapper--to_com__AMcvy","parent-container":"WhitelabelHeader-module_parent-container__n7ZIk","cross-banner-top":"WhitelabelHeader-module_cross-banner-top__bNuRm","cross-banner-center":"WhitelabelHeader-module_cross-banner-center__Q8hoN","cross-banner-bottom":"WhitelabelHeader-module_cross-banner-bottom__xXv2Z","top-header":"WhitelabelHeader-module_top-header__1GWDb","cross-banner":"WhitelabelHeader-module_cross-banner__f6Zjv","bottom-header":"WhitelabelHeader-module_bottom-header__z40br","hide-component":"WhitelabelHeader-module_hide-component__aOLXK","logo-horizontal-menu":"WhitelabelHeader-module_logo-horizontal-menu__zhMiI","horizontal-menu-searchbar":"WhitelabelHeader-module_horizontal-menu-searchbar__hjHm-"};

var trackMapping = {
  search: 'tag_new_slp',
  noResult: 'tag_new_slp_no_result',
  category: 'tag_new_plp',
  product: 'tag_new_pdp',
  error: 'error'
};
var track = function track(eventName) {
  var eventValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (window && window._satellite) {
    if (eventValue) {
      window._satellite.track(eventName, eventValue);
      return;
    }
    window._satellite.track(eventName);
  }
};
var pageBottom = function pageBottom() {
  if (window && window._satellite && window._satellite.pageBottom) {
    console.log('satellite is present');
    var eventToDigitalData = new CustomEvent('DDCCSatelliteIsPresent');
    window.dispatchEvent(eventToDigitalData);
    window._satellite.pageBottom();
  } else {
    console.log('satellite is not present');
  }
};
var updateData = function updateData() {
  updateDigitalData();
  var page = getPage(window.location.href);
  var event = trackMapping[page];
  track(event);
};
var initAnalitycs = function initAnalitycs(parentRouter) {
  return function () {
    if (parentRouter && parentRouter.events) {
      parentRouter.events.on('routeChangeComplete', function () {
        updateData();
      });
      parentRouter.events.on('routeChangeStart', function () {
        window.previousUrl = window.location.href;
      });
      pageBottom();
    }
  };
};
var loadAnalytics = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(parentRouter) {
    var country, env, isSodimacStandAloneSite, isTottusStandAloneSite, url, script;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return initDigitalData();
        case 1:
          country = getCountry();
          env = getEnvironment();
          isSodimacStandAloneSite = isCurrentUrlSodimacStandAlone();
          isTottusStandAloneSite = isCurrentUrlTottusStandAlone();
          if (isSodimacStandAloneSite) {
            url = analyticsInfo.tagManager[country].sodimac[env];
          } else if (isTottusStandAloneSite) {
            url = analyticsInfo.tagManager[country].tottus[env];
          } else {
            url = analyticsInfo.tagManager[country][env];
          }
          script = createScriptTag({
            src: url,
            onLoad: initAnalitycs(parentRouter)
          });
          appendNodeToHead(script);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadAnalytics(_x) {
    return _ref.apply(this, arguments);
  };
}();

function loadDigitalDataManager(args) {
  if (!args.isDDMInitializationEnabled) {
    return;
  }
  var env = getEnvironment();
  var digitalDataUrl = DIGITALDATA_CMS_URL[env];
  var script = createScriptTag({
    id: 'digital-data-manager-cc-script',
    src: digitalDataUrl,
    onLoad: function onLoad() {
      if (args.enableAnalyticsInfoCall) {
        loadAnalytics(args.parentRouter);
        if (typeof args.setAnalyticsInfo === 'function') {
          args.setAnalyticsInfo(true);
        }
      }
    }
  });
  appendNodeToHead(script);
  return script;
}

function loadVwoScript(args) {
  var _SCRIPT_URL$bu$args$t, _SCRIPT_URL$bu;
  if (!args.isVwoEnabled) {
    return;
  }
  var bu = getBusinessUnit(args.isSodimacStandAloneSite, args.isTottusStandAloneSite);
  var scriptUrl = (_SCRIPT_URL$bu$args$t = SCRIPT_URL$1 === null || SCRIPT_URL$1 === void 0 || (_SCRIPT_URL$bu = SCRIPT_URL$1[bu]) === null || _SCRIPT_URL$bu === void 0 ? void 0 : _SCRIPT_URL$bu[args.tenant]) !== null && _SCRIPT_URL$bu$args$t !== void 0 ? _SCRIPT_URL$bu$args$t : SCRIPT_URL$1.falabella[args.tenant];
  if (!scriptUrl) {
    return;
  }
  var link = createLinkTag({
    linkOptions: {
      href: 'https://dev.visualwebsiteoptimizer.com',
      rel: 'preconnect'
    }
  });
  var script = createScriptTag({
    id: 'vwo',
    src: scriptUrl,
    async: true
  });
  appendNodeToHead(link);
  appendNodeToHead(script);
}

var SCRIPT_URL = {
  dev: '',
  staging: 'https://assets-staging.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltb129496042c1a0f9/fingerprint-tracking.iife.js',
  beta: 'https://assets-uat.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt595922f660aed8d3/fingerprint-tracking.iife.js',
  production: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt810d8b9cff827359/fingerprint-tracking.iife.js'
};
function loadFingerprintTracking(args) {
  if (!args.isFingerprintTrackingEnabled) {
    return;
  }
  var env = getEnvironment();
  var fingerprintTrackingUrl = SCRIPT_URL[env];
  if (!fingerprintTrackingUrl) {
    return;
  }
  var script = createScriptTag({
    id: 'fp-t',
    src: fingerprintTrackingUrl,
    onLoad: function onLoad() {
      var _window$fingerprintTr, _window;
      var initialize = (_window$fingerprintTr = (_window = window) === null || _window === void 0 || (_window = _window.fingerprintTracking) === null || _window === void 0 || (_window = _window.methods) === null || _window === void 0 ? void 0 : _window.init) !== null && _window$fingerprintTr !== void 0 ? _window$fingerprintTr : noop$2;
      initialize();
    },
    onError: function onError() {
      var EventContextIDError = new CustomEvent('CONTEXTIDHASERROR');
      window.dispatchEvent(EventContextIDError);
      console.error('Failed loading fingerprintTracking script:');
    }
  });
  appendNodeToHead(script);
  return script;
}

var loadGoogleTagManager = function loadGoogleTagManager(args) {
  if (!args.isGoogleTagManagerEnabled) {
    return;
  }
  var env = getEnvironment();
  var country = getCountry();
  var businessUnit = 'FALABELLA';
  if (args.isSodimacStandAloneSite) {
    businessUnit = 'SODIMAC';
  } else if (args.isTottusStandAloneSite) {
    businessUnit = 'TOTTUS';
  } else if (args.isWhitelabelSite) {
    businessUnit = 'WHITELABEL';
  }
  var gtmID = gtmInfo[businessUnit][country][env];
  if (!gtmID) {
    console.error('GTM ID not found for the given BU, country, and environment.');
    return;
  }
  var scriptGTM = createScriptTag({
    async: true,
    src: "https://www.googletagmanager.com/gtm.js?id=".concat(gtmID),
    id: 'googletagmanager-script'
  });
  appendNodeToHead(scriptGTM);
  var scriptContent = "\n    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,'script','dataLayer','".concat(gtmID, "');\n  ");
  var scriptTag = createScriptTag({
    id: 'gtm-script'
  });
  scriptTag.innerHTML = scriptContent;
  appendNodeToHead(scriptTag);
  var noscript = document.createElement('noscript');
  noscript.innerHTML = "<iframe src=\"https://www.googletagmanager.com/ns.html?id=".concat(gtmID, "\"\n  height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>");
  document.body.appendChild(noscript);
};
var loadGoogleTagManager$1 = loadGoogleTagManager;

var loadMedallia = function loadMedallia(args) {
  if (!args.isTottusStandAloneSite) {
    return;
  }
  var country = getCountry();
  var businessUnit = args.isTottusStandAloneSite ? 'tottus' : 'falabella';
  var medalliaURL = analyticsInfo.medallia[businessUnit][country];
  if (!medalliaURL) {
    console.error('Madallia not found for the given BU and country.');
    return;
  }
  var scriptMedallia = createScriptTag({
    async: true,
    src: "".concat(medalliaURL)
  });
  appendNodeToHead(scriptMedallia);
};
var loadMedallia$1 = loadMedallia;

var HEX_COLORS = {
  '#343E49': '#343E49'
};
var cssVariables = {
  hexColors: HEX_COLORS,
  so_com: {
    'search-bar-border-radius': '4px',
    'search-bar-button-icon-border-radius': '0px',
    'category-button-wrapper-border-radius': '4px'
  },
  to_com: {
    'search-bar-border-radius': '80px',
    'search-bar-button-icon-border-radius': '80px',
    'category-button-wrapper-border-radius': '80px'
  },
  so_retail: {
    'search-bar-border-radius': '4px',
    'search-bar-button-icon-border-radius': '0px',
    'category-button-wrapper-border-radius': '4px'
  }
};

var useHeader = function useHeader(_ref) {
  var _data$header, _data$taxonomy, _data$sisNavigationMe, _stickyOverride$enabl, _header$entry$is_stic, _header$entry, _header$entry$is_stic2, _header$entry2, _header$entry$is_stic3, _header$entry3;
  var styles = _ref.styles,
    tenant = _ref.tenant;
    _ref.baseUrl;
    var store = _ref.store,
    data = _ref.data,
    isWebPushNotificationEnabled = _ref.isWebPushNotificationEnabled,
    setPushNotificationData = _ref.setPushNotificationData,
    currentStepValue = _ref.currentStepValue,
    attachResizeListener = _ref.attachResizeListener,
    deviceType = _ref.deviceType,
    currentLocation = _ref.currentLocation,
    stickyOverride = _ref.stickyOverride;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOnboardingDisabledCookie = _useState2[0],
    setIsOnboardingDisabledCookie = _useState2[1];
  var _useState3 = useState((_data$header = data === null || data === void 0 ? void 0 : data.header) !== null && _data$header !== void 0 ? _data$header : false),
    _useState4 = _slicedToArray(_useState3, 2),
    header = _useState4[0];
    _useState4[1];
  var _useState5 = useState((_data$taxonomy = data === null || data === void 0 ? void 0 : data.taxonomy) !== null && _data$taxonomy !== void 0 ? _data$taxonomy : false),
    _useState6 = _slicedToArray(_useState5, 2),
    taxonomyData = _useState6[0],
    setTaxonomyData = _useState6[1];
  var _useState7 = useState((_data$sisNavigationMe = data === null || data === void 0 ? void 0 : data.sisNavigationMenu) !== null && _data$sisNavigationMe !== void 0 ? _data$sisNavigationMe : null),
    _useState8 = _slicedToArray(_useState7, 2),
    sisNavigationMenu = _useState8[0],
    setSisNavigationMenu = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isIE = _useState0[0],
    setIsIe = _useState0[1];
  var _useState1 = useState(currentLocation),
    _useState10 = _slicedToArray(_useState1, 2),
    location = _useState10[0],
    setLocation = _useState10[1];
  var _useState11 = useState(currentStepValue),
    _useState12 = _slicedToArray(_useState11, 2),
    currentStep = _useState12[0],
    setCurrentStep = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isMobileApp = _useState14[0],
    setMobileApp = _useState14[1];
  var _useState15 = useState(store),
    _useState16 = _slicedToArray(_useState15, 2),
    site = _useState16[0],
    setSite = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isVendorLoggedIn = _useState18[0],
    setIsVendorLoggedIn = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isAgentLoggedIn = _useState20[0],
    setIsAgentLoggedIn = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    areCookiesPresent = _useState22[0],
    setAreCookiesPresent = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isCatalyst = _useState24[0],
    setCatalyst = _useState24[1];
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    userInformation = _useState26[0],
    setUserInformation = _useState26[1];
  var _useState27 = useState(''),
    _useState28 = _slicedToArray(_useState27, 2),
    agentCookieData = _useState28[0],
    setAgentCookieData = _useState28[1];
  var _useState29 = useState({
      enabled: false,
      cartId: '',
      siteName: '',
      ecommName: '',
      defaultColor: '',
      multiSite: false
    }),
    _useState30 = _slicedToArray(_useState29, 2),
    whiteLabelProp = _useState30[0],
    setWhiteLabelProp = _useState30[1];
  var constants = configs$1.constants;
  var getCookie = CookieStorage$1.getCookie,
    unescapeATGCookies = CookieStorage$1.unescapeATGCookies;
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone;
  var isMarketplace = !store;
  var isSis = store && !isStandaloneSite;
  var overrideEnabled = (_stickyOverride$enabl = stickyOverride === null || stickyOverride === void 0 ? void 0 : stickyOverride.enabled) !== null && _stickyOverride$enabl !== void 0 ? _stickyOverride$enabl : isTottusStandalone;
  var isStickyEnabled = {
    desktop: overrideEnabled || ((_header$entry$is_stic = header === null || header === void 0 || (_header$entry = header.entry) === null || _header$entry === void 0 ? void 0 : _header$entry.is_sticky_desktop) !== null && _header$entry$is_stic !== void 0 ? _header$entry$is_stic : false),
    mobile: overrideEnabled || ((_header$entry$is_stic2 = header === null || header === void 0 || (_header$entry2 = header.entry) === null || _header$entry2 === void 0 ? void 0 : _header$entry2.is_sticky_mobile) !== null && _header$entry$is_stic2 !== void 0 ? _header$entry$is_stic2 : false),
    tablet: overrideEnabled || ((_header$entry$is_stic3 = header === null || header === void 0 || (_header$entry3 = header.entry) === null || _header$entry3 === void 0 ? void 0 : _header$entry3.is_sticky_mobile) !== null && _header$entry$is_stic3 !== void 0 ? _header$entry$is_stic3 : false)
  };
  var setOnboardingCookie = function setOnboardingCookie() {
    var onboardingCookie = CookieStorage$1.getCookie(constants.ON_BOARDING_COOKIE) === 'done';
    setIsOnboardingDisabledCookie(onboardingCookie);
  };
  var setCurrentLocation = function setCurrentLocation() {
    if (!location) {
      setLocation(getCurrentLocation());
    }
  };
  var setIEUserAgent = function setIEUserAgent() {
    var ieRegex = new RegExp(/MSIE|Trident.*rv/i);
    setIsIe(ieRegex.test(window.navigator.userAgent));
  };
  var getExternalDependencies = function getExternalDependencies() {
    var urlParams = new URLSearchParams(window.location.search);
    var includeExternalDependencies = urlParams.get('includeExternalDependencies');
    if (includeExternalDependencies !== 'false') {
      var _header$entry$header_, _header$entry4;
      loadExternalDependencies$1({
        tenant: tenant,
        environment: getEnvironment(),
        isMarketplace: true,
        toggles: {
          isWebPushNotificationEnabled: isWebPushNotificationEnabled
        },
        functions: {
          setPushNotificationData: setPushNotificationData
        },
        configs: {
          webPushNotificationConfigs: (_header$entry$header_ = header === null || header === void 0 || (_header$entry4 = header.entry) === null || _header$entry4 === void 0 || (_header$entry4 = _header$entry4.header_configs) === null || _header$entry4 === void 0 || (_header$entry4 = _header$entry4[0]) === null || _header$entry4 === void 0 || (_header$entry4 = _header$entry4.property_configs) === null || _header$entry4 === void 0 ? void 0 : _header$entry4.web_push_notifications) !== null && _header$entry$header_ !== void 0 ? _header$entry$header_ : {}
        }
      });
    }
  };
  var setSticky = function setSticky() {
    if (isStickyEnabled[deviceType]) {
      var currScroll = 0;
      var prevScroll = 0;
      var currDirection = 0;
      var prevDirection = 0;
      var threshold = deviceType === 'desktop' ? 2000 : 1000;
      var toggled = false;
      var checkScroll = function checkScroll(e) {
        var headerElement = document.getElementById('scrollable-content');
        var bottomHeaderElement = document.getElementById('bottom-header');
        if (!headerElement || !bottomHeaderElement) {
          return;
        }
        currScroll = window.scrollY || document.documentElement.scrollTop;
        if (currScroll > prevScroll) {
          currDirection = 2;
        } else {
          currDirection = 1;
          if (currScroll <= 10) {
            if (isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent) {
              headerElement.classList.add("".concat(styles['header-scroll-styles2']));
            }
            headerElement.classList.remove("".concat(styles['header-scroll-styles']));
            bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
          }
          if (prevScroll < 5 && currScroll < prevScroll) {
            headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
            headerElement.classList.remove("".concat(styles['header-scroll-styles']));
            bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
          }
          if (prevScroll - currScroll >= 5) {
            headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
          }
        }
        if (currDirection !== prevDirection) {
          toggled = toggleHeader(currDirection, currScroll, threshold, styles);
        }
        if (toggled) {
          prevDirection = currDirection;
        }
        prevScroll = currScroll;
      };
      window.onscroll = checkScroll;
    }
  };
  var setCookies = function setCookies() {
    var params = new URLSearchParams(window.location.search);
    var storeIdQuery = params.get('storeId');
    var moduleQuery = params.get('modulo');
    var storeCookie = CookieStorage$1.getKioskoStoreCookieName();
    var moduleCookie = CookieStorage$1.getKioskoModuleCookieName();
    var storeId = getCookie(storeCookie);
    var module = getCookie(moduleCookie);
    if (storeIdQuery && storeId !== storeIdQuery) {
      CookieStorage$1.setCookie({
        name: storeCookie,
        value: storeIdQuery,
        regionCode: tenant
      });
      storeId = storeIdQuery;
    }
    if (moduleQuery && module !== moduleQuery) {
      CookieStorage$1.setCookie({
        name: moduleCookie,
        value: moduleQuery,
        regionCode: tenant
      });
      module = moduleQuery;
    }
    var vendorDataCookie = unescapeATGCookies(getCookie(CookieStorage$1.getVendorDataCookie()));
    var agentDataCookie = unescapeATGCookies(getCookie(CookieStorage$1.getAgentDataCookie()));
    var userCookie = CookieStorage$1.getUserDataCookieName();
    var userInformationCookie = unescapeATGCookies(getCookie(userCookie));
    if (vendorDataCookie) {
      setIsVendorLoggedIn(true);
    }
    if (storeId && module) {
      setAreCookiesPresent(true);
    }
    if (agentDataCookie) {
      setIsAgentLoggedIn(true);
      setAgentCookieData(agentDataCookie);
    }
    if (userInformationCookie) {
      setUserInformation(userInformationCookie);
    }
    setCatalyst(CookieStorage$1.isCatalyst());
  };
  useEffect(function () {
    var initData = function initData() {
      setOnboardingCookie();
      setCurrentLocation();
      attachResizeListener();
      getExternalDependencies();
      setIEUserAgent();
      setSite(siteValue(store));
      setCookies();
      setWhiteLabelProp(generateWhiteLabelProps(store, tenant));
      if (checkMobileApp()) {
        setMobileApp(true);
      }
    };
    initData();
  }, []);
  useEffect(function () {
    var _stickyOverride$thres;
    if (!overrideEnabled) return undefined;
    var headerElement = document.getElementById('scrollable-content');
    var bottomHeaderElement = document.getElementById('bottom-header');
    var thresholdPx = (_stickyOverride$thres = stickyOverride === null || stickyOverride === void 0 ? void 0 : stickyOverride.threshold) !== null && _stickyOverride$thres !== void 0 ? _stickyOverride$thres : 0;
    if (!headerElement) return undefined;
    var sentinel;
    var observer;
    var applyActive = function applyActive(active) {
      if (!headerElement) return;
      if (active) {
        headerElement.classList.add("".concat(styles['header-scroll-styles']));
        if (bottomHeaderElement) {
          bottomHeaderElement.classList.add("".concat(styles['bottom-header']));
        }
      } else {
        headerElement.classList.remove("".concat(styles['header-scroll-styles']));
        if (bottomHeaderElement) {
          bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
        }
      }
    };
    if ('IntersectionObserver' in window) {
      var _headerElement$parent;
      sentinel = document.createElement('div');
      sentinel.style.position = 'absolute';
      sentinel.style.top = '0';
      sentinel.style.left = '0';
      sentinel.style.width = '1px';
      sentinel.style.height = "".concat(thresholdPx, "px");
      sentinel.style.pointerEvents = 'none';
      (_headerElement$parent = headerElement.parentElement) === null || _headerElement$parent === void 0 || _headerElement$parent.insertBefore(sentinel, headerElement);
      observer = new IntersectionObserver(function (entries) {
        var _entries$;
        var topVisible = (_entries$ = entries[0]) === null || _entries$ === void 0 ? void 0 : _entries$.isIntersecting;
        applyActive(!topVisible);
      }, {
        root: null,
        threshold: 0
      });
      observer.observe(sentinel);
      return function () {
        if (observer) {
          observer.disconnect();
        }
        if (sentinel && sentinel.parentNode) {
          sentinel.parentNode.removeChild(sentinel);
        }
      };
    }
    var onScroll = function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      applyActive(y > thresholdPx);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [stickyOverride, styles]);
  useEffect(function () {
    var initData = function initData() {
      setOnboardingCookie();
      if (!overrideEnabled) {
        setSticky();
      }
      if (currentLocation) {
        setLocation(currentLocation);
      }
    };
    initData();
  }, [currentStep, header, currentLocation, stickyOverride]);
  return {
    isIE: isIE,
    location: location,
    isOnboardingDisabledCookie: isOnboardingDisabledCookie,
    header: header,
    currentStep: currentStep,
    setCurrentStep: setCurrentStep,
    taxonomyData: taxonomyData,
    sisNavigationMenu: sisNavigationMenu,
    setTaxonomyData: setTaxonomyData,
    setSisNavigationMenu: setSisNavigationMenu,
    isMobileApp: isMobileApp,
    site: site,
    isVendorLoggedIn: isVendorLoggedIn,
    setIsVendorLoggedIn: setIsVendorLoggedIn,
    isAgentLoggedIn: isAgentLoggedIn,
    setIsAgentLoggedIn: setIsAgentLoggedIn,
    currentLocation: currentLocation,
    isCatalyst: isCatalyst,
    userInformation: userInformation,
    agentCookieData: agentCookieData,
    areCookiesPresent: areCookiesPresent,
    whiteLabelProp: whiteLabelProp,
    isMarketplace: isMarketplace,
    isSis: isSis,
    isStandaloneSite: isStandaloneSite,
    isSodimacStandalone: isSodimacStandalone,
    isTottusStandalone: isTottusStandalone
  };
};

var BRAND_CONFIG = {
  so_com: {
    brand_color: '#0072CE',
    primary_color: '#ffffff',
    scrollable_header_background_color: '#ffffff',
    bottom_header_background_color: '#ffffff',
    brand_logo: 'https://images.falabella.com/v3/assets/blt6a203fe6c6a9b6dd/blt998f8642701056cb/664bb38e941bc88cfc9df692/logo-sodimac-header.svg',
    url: '#'
  },
  to_com: {
    brand_color: '#0072CE',
    primary_color: '#F1F1F1',
    scrollable_header_background_color: '#F1F1F1',
    bottom_header_background_color: '#F1F1F1',
    brand_logo: 'https://images.falabella.com/v3/assets/blt72431f7a08fe765a/bltff6f6b29157f3e3c/66bf709c77be39465aea7982/tottus-standalone-logo.svg',
    url: '#'
  },
  so_retail: {
    brand_color: '#0072CE',
    primary_color: '#ffffff',
    scrollable_header_background_color: '#ffffff',
    bottom_header_background_color: '#ffffff',
    brand_logo: 'https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt998f8642701056cb/664bb38e941bc88cfc9df692/logo-sodimac-header.svg',
    url: '#'
  }
};
var searchByImageAPI = 'https://productos-analiticos-bicorp-7803796y.uc.gateway.dev/buscar-productos';
var BRAND_CONFIG$1 = BRAND_CONFIG;

var OnboardingWithoutSSR$1 = SkipSSR$1(Onboarding$1);
var Header$3 = function Header(_ref) {
  var _header$entry$header_, _header$entry, _header$entry$header_2, _header$entry2, _header$entry$header_3, _header$entry3, _header$entry$header_4, _header$entry4, _header$entry$header_5, _header$entry5, _header$entry$header_6, _header$entry6, _header$entry$searchb, _header$entry7, _header$entry$logo$ur, _header$entry8, _BRAND_CONFIG$site, _header$entry$logo$ur2, _header$entry9, _header$entry$themes$, _header$entry0, _BRAND_CONFIG$site2, _header$entry$themes$2, _header$entry1, _BRAND_CONFIG$site3, _header$entry$themes$3, _header$entry10, _header$entry$themes$4, _header$entry11, _BRAND_CONFIG$site4, _header$entry$themes$5, _header$entry12, _sisNavigationMenu$en, _sisNavigationMenu$en2, _sisNavigationMenu$en3, _sisNavigationMenu$en4, _sisNavigationMenu$en5, _sisNavigationMenu$en6, _sisNavigationMenu$en7, _sisNavigationMenu$en8, _sisNavigationMenu$en9, _sisNavigationMenu$en0, _sisNavigationMenu$en1, _sisNavigationMenu$en10, _sisNavigationMenu$en11, _sisNavigationMenu$en12, _sisNavigationMenu$en13, _sisNavigationMenu$en14, _sisNavigationMenu$en15, _sisNavigationMenu$en16, _sisNavigationMenu$en17, _sisNavigationMenu$en18, _sisNavigationMenu$en19, _sisNavigationMenu$en20, _sisNavigationMenu$en21, _sisNavigationMenu$en22, _header$entry$onboard, _header$entry13, _header$entry$themes$6, _header$entry14, _BRAND_CONFIG$site5, _sisNavigationMenu$en39, _sisNavigationMenu$en40, _sisNavigationMenu$en41, _sisNavigationMenu$en42, _sisNavigationMenu$en43, _sisNavigationMenu$en44, _sisNavigationMenu$en45, _sisNavigationMenu$en46, _sisNavigationMenu$en47, _sisNavigationMenu$en48, _sisNavigationMenu$en49, _sisNavigationMenu$en50, _sisNavigationMenu$en51, _sisNavigationMenu$en52, _sisNavigationMenu$en53, _sisNavigationMenu$en54, _sisNavigationMenu$en55, _sisNavigationMenu$en56, _header$entry$themes$7, _header$entry15, _BRAND_CONFIG$site6, _sisNavigationMenu$en57, _sisNavigationMenu$en58, _cssVariables$site$se, _cssVariables$site, _cssVariables$site$se2, _cssVariables$site2, _cssVariables$site$ca, _cssVariables$site3;
  var styles = _ref.styles,
    atgBaseUrl = _ref.atgBaseUrl,
    attachResizeListener = _ref.attachResizeListener,
    catalystBaseUrl = _ref.catalystBaseUrl,
    currentLocation = _ref.currentLocation,
    currentSearchTerm = _ref.currentSearchTerm,
    data = _ref.data,
    deviceType = _ref.deviceType,
    enableAnalyticsInfoCall = _ref.enableAnalyticsInfoCall,
    forceATG = _ref.forceATG,
    getTypeaheadUrl = _ref.getTypeaheadUrl,
    handleRouteChange = _ref.handleRouteChange,
    handleSoftRefresh = _ref.handleSoftRefresh,
    isATGLoginEnabled = _ref.isATGLoginEnabled,
    isDefaultComuna = _ref.isDefaultComuna,
    isGeoLocationEnabled = _ref.isGeoLocationEnabled,
    isPopOverVisible = _ref.isPopOverVisible,
    isTypeAheadEnabled = _ref.isTypeAheadEnabled,
    isZoneModalEnabled = _ref.isZoneModalEnabled,
    isWebPushNotificationEnabled = _ref.isWebPushNotificationEnabled,
    isSisSodimacPdpEnabled = _ref.isSisSodimacPdpEnabled,
    onUserLogin = _ref.onUserLogin,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate,
    onUserLogout = _ref.onUserLogout,
    selectedZone = _ref.selectedZone,
    setBusy = _ref.setBusy,
    store = _ref.store,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    userCartCount = _ref.userCartCount,
    transversalBannerConfig = _ref.transversalBannerConfig,
    locationPathname = _ref.locationPathname,
    MobileAppWebView = _ref.MobileAppWebView,
    stickyOverride = _ref.stickyOverride;
  var _useContext = useContext(AppContext$1),
    tenant = _useContext.tenant,
    baseUrl = _useContext.baseUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSearchBar = _useState2[0],
    setShowSearchBar = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMenuVisible = _useState6[0],
    setMenuVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    modalVisible = _useState8[0],
    setModalVisible = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isSearchBarTouched = _useState0[0],
    setIsSearchBarTouched = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    zoneModalVisible = _useState10[0],
    setZoneModalVisible = _useState10[1];
  var _useState11 = useState(undefined),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    var setSearchInputRef = _useState12[1];
  var _useState13 = useState({
      isVisible: false
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    pushNotificationData = _useState14[0],
    setPushNotificationData = _useState14[1];
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    searchInSis = _useState16[0],
    setSearchInSis = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    hideMenuBar = _useState18[0],
    setHideMenuBar = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    mobileModalClass = _useState20[0],
    setMobileModalClass = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showLoginForm = _useState22[0],
    setShowLoginForm = _useState22[1];
  var labels = configs$1.labels,
    constants = configs$1.constants;
  var currentStepValue = 0;
  var isSvsSearch = getParameterByName('f.svs') === 'true';
  var emptySearchErrorTitle = labels.EMPTY_SEARCH_ERROR_TITLE;
  var emptySearchErrorMessage = labels.EMPTY_SEARCH_ERROR_MESSAGE;
  var incorrectSearchErrorTitle = labels.INCORRECT_SEARCH_ERROR_TITLE;
  var incorrectSearchErrorMessage = labels.INCORRECT_SEARCH_ERROR_MESSAGE;
  var _getStandaloneSite = getStandaloneSite(store),
    isTottusStandalonePre = _getStandaloneSite.isTottusStandalone;
  var stickyOverrideEffective = stickyOverride !== null && stickyOverride !== void 0 ? stickyOverride : isTottusStandalonePre ? {
    enabled: true,
    threshold: 0
  } : undefined;
  var _useHeader = useHeader({
      styles: styles,
      tenant: tenant,
      baseUrl: baseUrl,
      store: store,
      data: data,
      isWebPushNotificationEnabled: isWebPushNotificationEnabled,
      setPushNotificationData: setPushNotificationData,
      currentStepValue: currentStepValue,
      attachResizeListener: attachResizeListener,
      deviceType: deviceType,
      currentLocation: currentLocation,
      stickyOverride: stickyOverrideEffective
    }),
    isIE = _useHeader.isIE,
    location = _useHeader.location,
    isOnboardingDisabledCookie = _useHeader.isOnboardingDisabledCookie,
    header = _useHeader.header,
    currentStep = _useHeader.currentStep,
    setCurrentStep = _useHeader.setCurrentStep,
    taxonomyData = _useHeader.taxonomyData,
    sisNavigationMenu = _useHeader.sisNavigationMenu,
    isMobileApp = _useHeader.isMobileApp,
    site = _useHeader.site,
    isVendorLoggedIn = _useHeader.isVendorLoggedIn,
    setIsVendorLoggedIn = _useHeader.setIsVendorLoggedIn,
    isAgentLoggedIn = _useHeader.isAgentLoggedIn,
    setIsAgentLoggedIn = _useHeader.setIsAgentLoggedIn,
    isCatalyst = _useHeader.isCatalyst,
    userInformation = _useHeader.userInformation,
    agentCookieData = _useHeader.agentCookieData,
    areCookiesPresent = _useHeader.areCookiesPresent,
    whiteLabelProp = _useHeader.whiteLabelProp,
    isMarketplace = _useHeader.isMarketplace,
    isStandaloneSite = _useHeader.isStandaloneSite,
    isSodimacStandalone = _useHeader.isSodimacStandalone,
    isTottusStandalone = _useHeader.isTottusStandalone;
  var isOnboardingEnabled = (_header$entry$header_ = header === null || header === void 0 || (_header$entry = header.entry) === null || _header$entry === void 0 || (_header$entry = _header$entry.header_configs) === null || _header$entry === void 0 || (_header$entry = _header$entry[0]) === null || _header$entry === void 0 || (_header$entry = _header$entry.toggles) === null || _header$entry === void 0 ? void 0 : _header$entry.isonboardingenabled) !== null && _header$entry$header_ !== void 0 ? _header$entry$header_ : false;
  var isProgramaticallyGeofinderEnabled = (_header$entry$header_2 = header === null || header === void 0 || (_header$entry2 = header.entry) === null || _header$entry2 === void 0 || (_header$entry2 = _header$entry2.header_configs) === null || _header$entry2 === void 0 || (_header$entry2 = _header$entry2[0]) === null || _header$entry2 === void 0 || (_header$entry2 = _header$entry2.toggles) === null || _header$entry2 === void 0 ? void 0 : _header$entry2.isprogramaticallygeofinderenabled) !== null && _header$entry$header_2 !== void 0 ? _header$entry$header_2 : false;
  var geofinderConfigs = (_header$entry$header_3 = header === null || header === void 0 || (_header$entry3 = header.entry) === null || _header$entry3 === void 0 || (_header$entry3 = _header$entry3.header_configs) === null || _header$entry3 === void 0 || (_header$entry3 = _header$entry3[0]) === null || _header$entry3 === void 0 || (_header$entry3 = _header$entry3.property_configs) === null || _header$entry3 === void 0 ? void 0 : _header$entry3.geofinder) !== null && _header$entry$header_3 !== void 0 ? _header$entry$header_3 : {};
  var isRecentSearchesEnabled = (_header$entry$header_4 = header === null || header === void 0 || (_header$entry4 = header.entry) === null || _header$entry4 === void 0 || (_header$entry4 = _header$entry4.header_configs) === null || _header$entry4 === void 0 || (_header$entry4 = _header$entry4[0]) === null || _header$entry4 === void 0 || (_header$entry4 = _header$entry4.toggles) === null || _header$entry4 === void 0 ? void 0 : _header$entry4.isrecentsearchesenabled) !== null && _header$entry$header_4 !== void 0 ? _header$entry$header_4 : false;
  var isSearchSpecialCharactersEnabled = (_header$entry$header_5 = header === null || header === void 0 || (_header$entry5 = header.entry) === null || _header$entry5 === void 0 || (_header$entry5 = _header$entry5.header_configs) === null || _header$entry5 === void 0 || (_header$entry5 = _header$entry5[0]) === null || _header$entry5 === void 0 || (_header$entry5 = _header$entry5.toggles) === null || _header$entry5 === void 0 ? void 0 : _header$entry5.is_search_special_characters_enabled) !== null && _header$entry$header_5 !== void 0 ? _header$entry$header_5 : false;
  var isPostalCodeEnabled = (_header$entry$header_6 = header === null || header === void 0 || (_header$entry6 = header.entry) === null || _header$entry6 === void 0 || (_header$entry6 = _header$entry6.header_configs) === null || _header$entry6 === void 0 || (_header$entry6 = _header$entry6[0]) === null || _header$entry6 === void 0 || (_header$entry6 = _header$entry6.toggles) === null || _header$entry6 === void 0 ? void 0 : _header$entry6.ispostalcodeenabled) !== null && _header$entry$header_6 !== void 0 ? _header$entry$header_6 : false;
  var searchbar = (_header$entry$searchb = header === null || header === void 0 || (_header$entry7 = header.entry) === null || _header$entry7 === void 0 ? void 0 : _header$entry7.searchbar) !== null && _header$entry$searchb !== void 0 ? _header$entry$searchb : {};
  var mainLogoIcon = (_header$entry$logo$ur = header === null || header === void 0 || (_header$entry8 = header.entry) === null || _header$entry8 === void 0 || (_header$entry8 = _header$entry8.logo) === null || _header$entry8 === void 0 || (_header$entry8 = _header$entry8["".concat(deviceType, "_icon")]) === null || _header$entry8 === void 0 ? void 0 : _header$entry8.url) !== null && _header$entry$logo$ur !== void 0 ? _header$entry$logo$ur : (_BRAND_CONFIG$site = BRAND_CONFIG$1[site]) === null || _BRAND_CONFIG$site === void 0 ? void 0 : _BRAND_CONFIG$site.brand_logo;
  var mainLogoURL = (_header$entry$logo$ur2 = header === null || header === void 0 || (_header$entry9 = header.entry) === null || _header$entry9 === void 0 || (_header$entry9 = _header$entry9.logo) === null || _header$entry9 === void 0 ? void 0 : _header$entry9.url) !== null && _header$entry$logo$ur2 !== void 0 ? _header$entry$logo$ur2 : "".concat(HOME_URL["".concat(tenant, "__").concat(site)]);
  var logoURL = isMarketplace || isStandaloneSite ? mainLogoURL : (_header$entry$themes$ = header === null || header === void 0 || (_header$entry0 = header.entry) === null || _header$entry0 === void 0 || (_header$entry0 = _header$entry0.themes) === null || _header$entry0 === void 0 || (_header$entry0 = _header$entry0[site]) === null || _header$entry0 === void 0 ? void 0 : _header$entry0.url) !== null && _header$entry$themes$ !== void 0 ? _header$entry$themes$ : (_BRAND_CONFIG$site2 = BRAND_CONFIG$1[site]) === null || _BRAND_CONFIG$site2 === void 0 ? void 0 : _BRAND_CONFIG$site2.url;
  var primaryThemeColor = (_header$entry$themes$2 = header === null || header === void 0 || (_header$entry1 = header.entry) === null || _header$entry1 === void 0 || (_header$entry1 = _header$entry1.themes) === null || _header$entry1 === void 0 || (_header$entry1 = _header$entry1[site]) === null || _header$entry1 === void 0 ? void 0 : _header$entry1.color) !== null && _header$entry$themes$2 !== void 0 ? _header$entry$themes$2 : (_BRAND_CONFIG$site3 = BRAND_CONFIG$1[site]) === null || _BRAND_CONFIG$site3 === void 0 ? void 0 : _BRAND_CONFIG$site3.brand_color;
  var secondaryThemeColor = (_header$entry$themes$3 = header === null || header === void 0 || (_header$entry10 = header.entry) === null || _header$entry10 === void 0 || (_header$entry10 = _header$entry10.themes) === null || _header$entry10 === void 0 || (_header$entry10 = _header$entry10[site]) === null || _header$entry10 === void 0 ? void 0 : _header$entry10.secondary_color) !== null && _header$entry$themes$3 !== void 0 ? _header$entry$themes$3 : '#495867';
  var primaryColor = (_header$entry$themes$4 = header === null || header === void 0 || (_header$entry11 = header.entry) === null || _header$entry11 === void 0 || (_header$entry11 = _header$entry11.themes) === null || _header$entry11 === void 0 || (_header$entry11 = _header$entry11[site]) === null || _header$entry11 === void 0 ? void 0 : _header$entry11.color) !== null && _header$entry$themes$4 !== void 0 ? _header$entry$themes$4 : (_BRAND_CONFIG$site4 = BRAND_CONFIG$1[site]) === null || _BRAND_CONFIG$site4 === void 0 ? void 0 : _BRAND_CONFIG$site4.brand_color;
  var secondaryColor = (_header$entry$themes$5 = header === null || header === void 0 || (_header$entry12 = header.entry) === null || _header$entry12 === void 0 || (_header$entry12 = _header$entry12.themes) === null || _header$entry12 === void 0 || (_header$entry12 = _header$entry12[site]) === null || _header$entry12 === void 0 ? void 0 : _header$entry12.secondary_color) !== null && _header$entry$themes$5 !== void 0 ? _header$entry$themes$5 : cssVariables.hexColors['#343E49'];
  var services = (_sisNavigationMenu$en = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en2 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en2 === void 0 ? void 0 : _sisNavigationMenu$en2.services) !== null && _sisNavigationMenu$en !== void 0 ? _sisNavigationMenu$en : [];
  var quickLinks = (_sisNavigationMenu$en3 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en4 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en4 === void 0 ? void 0 : _sisNavigationMenu$en4.quick_links) !== null && _sisNavigationMenu$en3 !== void 0 ? _sisNavigationMenu$en3 : [];
  var enableSISMenuV2 = (_sisNavigationMenu$en5 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en6 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en6 === void 0 ? void 0 : _sisNavigationMenu$en6.enable_sismenu_v2) !== null && _sisNavigationMenu$en5 !== void 0 ? _sisNavigationMenu$en5 : false;
  var isCoachmarkVisible = (_sisNavigationMenu$en7 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en8 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en8 === void 0 ? void 0 : _sisNavigationMenu$en8.show_coachmark) !== null && _sisNavigationMenu$en7 !== void 0 ? _sisNavigationMenu$en7 : false;
  (_sisNavigationMenu$en9 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en0 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en0 === void 0 ? void 0 : _sisNavigationMenu$en0.enable_quick_links) !== null && _sisNavigationMenu$en9 !== void 0 ? _sisNavigationMenu$en9 : false;
  var showCategoryFirst = (_sisNavigationMenu$en1 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en10 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en10 === void 0 ? void 0 : _sisNavigationMenu$en10.show_categories_first) !== null && _sisNavigationMenu$en1 !== void 0 ? _sisNavigationMenu$en1 : false;
  var categoryHeaderTitle = (_sisNavigationMenu$en11 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en12 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en12 === void 0 ? void 0 : _sisNavigationMenu$en12.categories_header_title) !== null && _sisNavigationMenu$en11 !== void 0 ? _sisNavigationMenu$en11 : '';
  var serviceHeaderTitle = (_sisNavigationMenu$en13 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en14 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en14 === void 0 ? void 0 : _sisNavigationMenu$en14.services_header_title) !== null && _sisNavigationMenu$en13 !== void 0 ? _sisNavigationMenu$en13 : '';
  var isSearchByImageEnable = (_sisNavigationMenu$en15 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en16 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en16 === void 0 || (_sisNavigationMenu$en16 = _sisNavigationMenu$en16.search_by_image) === null || _sisNavigationMenu$en16 === void 0 ? void 0 : _sisNavigationMenu$en16.is_search_by_image_enable) !== null && _sisNavigationMenu$en15 !== void 0 ? _sisNavigationMenu$en15 : false;
  var isCameraCoachmarkVisible = (_sisNavigationMenu$en17 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en18 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en18 === void 0 || (_sisNavigationMenu$en18 = _sisNavigationMenu$en18.search_by_image) === null || _sisNavigationMenu$en18 === void 0 ? void 0 : _sisNavigationMenu$en18.show_camera_coachmark) !== null && _sisNavigationMenu$en17 !== void 0 ? _sisNavigationMenu$en17 : false;
  var searchByImageEndpoint = (_sisNavigationMenu$en19 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en20 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en20 === void 0 || (_sisNavigationMenu$en20 = _sisNavigationMenu$en20.search_by_image) === null || _sisNavigationMenu$en20 === void 0 ? void 0 : _sisNavigationMenu$en20.search_by_image_endpoint) !== null && _sisNavigationMenu$en19 !== void 0 ? _sisNavigationMenu$en19 : searchByImageAPI;
  var searchByImageApiKey = (_sisNavigationMenu$en21 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en22 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en22 === void 0 || (_sisNavigationMenu$en22 = _sisNavigationMenu$en22.search_by_image) === null || _sisNavigationMenu$en22 === void 0 ? void 0 : _sisNavigationMenu$en22.search_by_image_api_key) !== null && _sisNavigationMenu$en21 !== void 0 ? _sisNavigationMenu$en21 : '';
  var enableSearchByImage = isSearchByImageEnable && !isVendorLoggedIn && !isAgentLoggedIn && !areCookiesPresent;
  var closeNotification = function closeNotification() {
    setPushNotificationData({
      isVisible: false
    });
  };
  var onSearchTermChange = function onSearchTermChange(searchTerm) {
    var searchByImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (searchTerm.length === 0) {
      setErrorMessage({
        title: emptySearchErrorTitle,
        msg: emptySearchErrorMessage
      });
      return false;
    }
    if (searchTerm.length < constants.MIN_SEARCH_TERM_LENGTH) {
      setErrorMessage({
        title: incorrectSearchErrorTitle,
        msg: incorrectSearchErrorMessage
      });
      return false;
    }
    var termo = encodeURIComponent(searchTerm).replace(/%20/g, '+');
    window.dispatchEvent(new CustomEvent('DDM_onSearching', {
      bubbles: true,
      detail: {
        value: termo,
        prefix: 'BCR'
      }
    }));
    updateDigitalDataCookies({
      firstLevelItem: 'Success',
      tag: SEARCH_BY_IMAGE
    });
    if (handleRouteChange) {
      handleRouteChange(termo, store && searchInSis, searchByImage);
    } else {
      var envBaseUrl = getStandaloneSiteBaseUrl(tenant, store);
      var storeName = STORE_MAP[tenant][store];
      var searchPath = SEARCH_PATH[store];
      var redirectURL = "".concat(envBaseUrl, "/").concat(storeName, "-").concat(tenant, "/").concat(searchPath, "?Ntt=").concat(termo);
      window.location.href = searchByImage ? "".concat(redirectURL, "&isImageSearch=true") : redirectURL;
    }
    setErrorMessage(undefined);
    return true;
  };
  var onSearchDomainChange = function onSearchDomainChange() {
    setSearchInSis(!searchInSis);
  };
  var toggleModal = function toggleModal(visibility) {
    if (deviceType !== 'desktop') {
      if (!visibility) {
        setMobileModalClass('floatBottomEndTransition');
        var animationTimer = setTimeout(function () {
          setModalVisible(visibility);
          clearTimeout(animationTimer);
        }, 350);
      } else {
        setMobileModalClass('floatBottomTransition');
        setModalVisible(visibility);
      }
    } else {
      setModalVisible(visibility);
    }
  };
  var handleUserLogout = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var userCookie;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            userCookie = CookieStorage$1.getUserDataCookieName();
            CookieStorage$1.removeCookie({
              name: userCookie
            });
            _context.next = 1;
            return onUserLogout();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleUserLogout() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleUserLogin = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(userData) {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return onUserLogin(userData);
          case 1:
            if (enableAnalyticsInfoCall) {
              initDigitalData();
            }
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleUserLogin(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  if (!header) {
    return jsx(Fragment$1, {});
  }
  var isVendorOrAgentLoggedIn = isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent;
  return jsxs(Fragment$1, {
    children: [jsxs("header", {
      className: classNames(_defineProperty(_defineProperty({}, styles['no-border'], isVendorOrAgentLoggedIn), styles['hide-component'], MobileAppWebView)),
      children: [errorMessage && jsx(ErrorDialog$1, {
        title: errorMessage.title,
        message: errorMessage.msg,
        onClose: function onClose() {
          setErrorMessage(undefined);
        }
      }), isAgentLoggedIn && jsx(AgentHeader$1, {
        agentCookie: agentCookieData,
        userName: userInformation.split('*')[0],
        agentBaseUrl: baseUrl,
        atgBaseUrl: atgBaseUrl,
        catalystBaseUrl: catalystBaseUrl,
        onUserLogout: handleUserLogout,
        isCatalyst: CookieStorage$1.isCatalyst(),
        tenant: tenant,
        setIsAgentLoggedIn: setIsAgentLoggedIn,
        forceATG: forceATG,
        store: store
      }), (isVendorLoggedIn || areCookiesPresent) && jsx(VendorHeader$1, {
        isCatalyst: CookieStorage$1.isCatalyst(),
        tenant: tenant,
        setIsVendorLoggedIn: setIsVendorLoggedIn,
        vendorBaseUrl: baseUrl,
        isVendorLoggedIn: isVendorLoggedIn,
        atgBaseUrl: atgBaseUrl,
        catalystBaseUrl: catalystBaseUrl,
        onUserLogout: handleUserLogout,
        forceATG: forceATG,
        store: store,
        whitelabel: whiteLabelProp
      }), isOnboardingEnabled && !isMobileApp && jsx(OnboardingWithoutSSR$1, {
        deviceType: deviceType,
        currentStep: currentStep,
        setCurrentStep: setCurrentStep,
        onboardingData: (_header$entry$onboard = header === null || header === void 0 || (_header$entry13 = header.entry) === null || _header$entry13 === void 0 ? void 0 : _header$entry13.onboarding) !== null && _header$entry$onboard !== void 0 ? _header$entry$onboard : null,
        tenant: tenant
      }), jsxs("div", {
        id: "scrollable-content",
        style: {
          background: site && ((_header$entry$themes$6 = header === null || header === void 0 || (_header$entry14 = header.entry) === null || _header$entry14 === void 0 || (_header$entry14 = _header$entry14.themes) === null || _header$entry14 === void 0 || (_header$entry14 = _header$entry14[site]) === null || _header$entry14 === void 0 ? void 0 : _header$entry14.scrollable_header_background_color) !== null && _header$entry$themes$6 !== void 0 ? _header$entry$themes$6 : (_BRAND_CONFIG$site5 = BRAND_CONFIG$1[site]) === null || _BRAND_CONFIG$site5 === void 0 ? void 0 : _BRAND_CONFIG$site5.scrollable_header_background_color)
        },
        "data-testid": "header-util-bar",
        className: classNames("".concat(styles['header-util-bar'])),
        children: [jsxs("div", {
          className: classNames(styles.container, styles['header-container'], _defineProperty(_defineProperty({}, styles['header-container--so_com'], isSodimacStandalone), styles['header-container--to_com'], isTottusStandalone)),
          children: [!site && jsxs(Fragment$1, {
            children: [jsx(MatchMedia$1, {
              deviceType: deviceType,
              content: {
                desktop: function desktop() {
                  return jsx(React.Fragment, {});
                },
                tablet: function tablet() {
                  return jsx(React.Fragment, {});
                },
                mobile: function mobile() {
                  return jsx(Taxonomy$1, {
                    headerData: header,
                    data: taxonomyData,
                    currentLocation: location,
                    isInternetExplorer: isIE,
                    isMenuVisible: isMenuVisible,
                    setMenuVisible: setMenuVisible,
                    isGeoLocationEnabled: isGeoLocationEnabled,
                    deviceType: deviceType,
                    hideMenuBar: hideMenuBar,
                    isCatalyst: isCatalyst,
                    isAgentLoggedIn: isAgentLoggedIn,
                    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
                  });
                }
              }
            }, "testId-taxonomy-mobile"), jsx(MatchMedia$1, {
              deviceType: deviceType,
              content: {
                desktop: function desktop() {
                  return jsx(React.Fragment, {});
                },
                mobile: function mobile() {
                  return jsx(React.Fragment, {});
                },
                tablet: function tablet() {
                  return jsx(Taxonomy$1, {
                    headerData: header,
                    data: taxonomyData,
                    currentLocation: location,
                    isInternetExplorer: isIE,
                    isMenuVisible: isMenuVisible,
                    setMenuVisible: setMenuVisible,
                    isGeoLocationEnabled: isGeoLocationEnabled,
                    deviceType: deviceType,
                    hideMenuBar: hideMenuBar,
                    isCatalyst: isCatalyst,
                    isAgentLoggedIn: isAgentLoggedIn,
                    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
                  });
                }
              }
            }, "testId-taxonomy-tablet")]
          }), jsx(MatchMedia$1, {
            deviceType: deviceType,
            content: {
              desktop: function desktop() {
                return jsx(Logo$1, {
                  path: logoURL,
                  logoIcon: mainLogoIcon,
                  store: site
                });
              },
              mobile: function mobile() {
                return jsx(Logo$1, {
                  path: logoURL,
                  logoIcon: mainLogoIcon,
                  isMobile: true,
                  store: site
                });
              },
              tablet: function tablet() {
                return jsx(Logo$1, {
                  path: logoURL,
                  logoIcon: mainLogoIcon,
                  isMobile: true,
                  store: site
                });
              }
            }
          }, "testId-logo-link"), jsx(MatchMedia$1, {
            deviceType: deviceType,
            content: {
              mobile: function mobile() {
                return jsx(React.Fragment, {});
              },
              tablet: function tablet() {
                return jsx(React.Fragment, {});
              },
              desktop: function desktop() {
                var _sisNavigationMenu$en23, _sisNavigationMenu$en24, _sisNavigationMenu$en25, _sisNavigationMenu$en26, _sisNavigationMenu$en27, _sisNavigationMenu$en28, _sisNavigationMenu$en29, _sisNavigationMenu$en30, _sisNavigationMenu$en31, _sisNavigationMenu$en32, _sisNavigationMenu$en33, _sisNavigationMenu$en34, _sisNavigationMenu$en35, _sisNavigationMenu$en36, _sisNavigationMenu$en37, _sisNavigationMenu$en38;
                return jsx(SiSNavigationMenu$1, {
                  isVendorOrAgentLoggedIn: isVendorOrAgentLoggedIn,
                  brandLogo: (_sisNavigationMenu$en23 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en24 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en24 === void 0 ? void 0 : _sisNavigationMenu$en24.brand_logo) !== null && _sisNavigationMenu$en23 !== void 0 ? _sisNavigationMenu$en23 : {},
                  categories: (_sisNavigationMenu$en25 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en26 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en26 === void 0 ? void 0 : _sisNavigationMenu$en26.categories) !== null && _sisNavigationMenu$en25 !== void 0 ? _sisNavigationMenu$en25 : [],
                  services: services,
                  browseMainText: (_sisNavigationMenu$en27 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en28 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en28 === void 0 ? void 0 : _sisNavigationMenu$en28.browse_main_text) !== null && _sisNavigationMenu$en27 !== void 0 ? _sisNavigationMenu$en27 : '',
                  colorLine: (_sisNavigationMenu$en29 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en30 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en30 === void 0 ? void 0 : _sisNavigationMenu$en30.color_line) !== null && _sisNavigationMenu$en29 !== void 0 ? _sisNavigationMenu$en29 : '',
                  categoryColor: (_sisNavigationMenu$en31 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en32 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en32 === void 0 ? void 0 : _sisNavigationMenu$en32.category_color) !== null && _sisNavigationMenu$en31 !== void 0 ? _sisNavigationMenu$en31 : '',
                  hightlightColor: (_sisNavigationMenu$en33 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en34 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en34 === void 0 ? void 0 : _sisNavigationMenu$en34.hightlight_color) !== null && _sisNavigationMenu$en33 !== void 0 ? _sisNavigationMenu$en33 : '',
                  hightlightTextColor: (_sisNavigationMenu$en35 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en36 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en36 === void 0 ? void 0 : _sisNavigationMenu$en36.hightlight_text_color) !== null && _sisNavigationMenu$en35 !== void 0 ? _sisNavigationMenu$en35 : '',
                  dataWrapper: (_sisNavigationMenu$en37 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en38 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en38 === void 0 ? void 0 : _sisNavigationMenu$en38.data_wrapper) !== null && _sisNavigationMenu$en37 !== void 0 ? _sisNavigationMenu$en37 : '',
                  store: site,
                  isSISLevel2Header: false,
                  enableSISMenuV2: enableSISMenuV2,
                  showCategoryFirst: showCategoryFirst,
                  categoryHeaderTitle: categoryHeaderTitle,
                  serviceHeaderTitle: serviceHeaderTitle
                });
              }
            }
          }, "testId-store-menu"), !site && jsx(MatchMedia$1, {
            deviceType: deviceType,
            content: {
              mobile: function mobile() {
                return jsx(React.Fragment, {});
              },
              tablet: function tablet() {
                return jsx(React.Fragment, {});
              },
              desktop: function desktop() {
                return jsx(Taxonomy$1, {
                  currentLocation: location,
                  data: taxonomyData,
                  deviceType: deviceType,
                  headerData: header,
                  hideMenuBar: hideMenuBar,
                  isAgentLoggedIn: isAgentLoggedIn,
                  isCatalyst: isCatalyst,
                  isGeoLocationEnabled: isGeoLocationEnabled,
                  isInternetExplorer: isIE,
                  isMenuVisible: isMenuVisible,
                  isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
                  setMenuVisible: setMenuVisible
                });
              }
            }
          }, "testId-taxonomy-desktop"), jsx(MatchMedia$1, {
            deviceType: deviceType,
            content: {
              desktop: function desktop() {
                return jsx(Search$1, {
                  deviceType: deviceType,
                  getTypeaheadUrl: getTypeaheadUrl,
                  isAndes: isZoneModalEnabled,
                  searchInSis: searchInSis,
                  isSvsSearch: isSvsSearch,
                  isTypeAheadEnabled: isTypeAheadEnabled,
                  isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
                  onLoadingStateChange: setBusy,
                  onSearch: onSearchTermChange,
                  searchbar: searchbar,
                  setHideMenuBar: setHideMenuBar,
                  setSearchInputRef: setSearchInputRef,
                  isSearchBarTouched: isSearchBarTouched,
                  setIsSearchBarTouched: setIsSearchBarTouched,
                  showSearchBar: showSearchBar,
                  currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
                  store: site,
                  onSearchDomainChange: onSearchDomainChange,
                  isRecentSearchesEnabled: isRecentSearchesEnabled,
                  isSearchSpecialCharactersEnabled: isSearchSpecialCharactersEnabled,
                  isSearchByImageEnable: enableSearchByImage,
                  isCameraCoachmarkVisible: isCameraCoachmarkVisible,
                  searchByImageEndpoint: searchByImageEndpoint,
                  searchByImageApiKey: searchByImageApiKey,
                  isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
                  isAgentLoggedIn: isAgentLoggedIn
                });
              },
              mobile: function mobile() {
                return jsx(React.Fragment, {});
              },
              tablet: function tablet() {
                return jsx(React.Fragment, {});
              }
            }
          }, "search-bar-desktop"), jsx(UserActions$1, {
            showSearchBar: showSearchBar,
            setShowSearchBar: setShowSearchBar,
            isATGLoginEnabled: isATGLoginEnabled,
            isInternetExplorer: isIE,
            showLoginForm: showLoginForm,
            setShowLoginForm: setShowLoginForm,
            atgBaseUrl: atgBaseUrl,
            modalVisible: modalVisible,
            mobileModalClass: mobileModalClass,
            toggleModal: toggleModal,
            catalystBaseUrl: catalystBaseUrl,
            onLoadingStateChange: setBusy,
            onUserLogout: handleUserLogout,
            deviceType: deviceType,
            headerData: header,
            onUserLogin: handleUserLogin,
            onUserLoginComplete: onUserLoginComplete,
            onUserLoginConsentsUpdate: onUserLoginConsentsUpdate,
            onUserLoginPasswordUpdate: onUserLoginPasswordUpdate,
            unifiedLoginBaseUrl: unifiedLoginBaseUrl,
            userCartCount: userCartCount,
            isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 1,
            setHideMenuBar: setHideMenuBar,
            setMenuVisible: setMenuVisible,
            forceATG: forceATG,
            isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
            isAgentLoggedIn: isAgentLoggedIn,
            isStore: true,
            isOrangeOrSISHeader: true,
            isSISLevel2Header: false,
            store: store
          })]
        }), deviceType !== 'desktop' && jsxs("div", {
          className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles.mobile_middle_wrapper, site), styles['mobile_middle_wrapper--so_com'], isSodimacStandalone), styles['mobile_middle_wrapper--to_com'], isTottusStandalone)),
          children: [jsx(SiSNavigationMenu$1, {
            brandLogo: (_sisNavigationMenu$en39 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en40 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en40 === void 0 ? void 0 : _sisNavigationMenu$en40.brand_logo) !== null && _sisNavigationMenu$en39 !== void 0 ? _sisNavigationMenu$en39 : {},
            categories: (_sisNavigationMenu$en41 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en42 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en42 === void 0 ? void 0 : _sisNavigationMenu$en42.categories) !== null && _sisNavigationMenu$en41 !== void 0 ? _sisNavigationMenu$en41 : [],
            services: services,
            browseMainText: (_sisNavigationMenu$en43 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en44 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en44 === void 0 ? void 0 : _sisNavigationMenu$en44.browse_main_text) !== null && _sisNavigationMenu$en43 !== void 0 ? _sisNavigationMenu$en43 : '',
            colorLine: (_sisNavigationMenu$en45 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en46 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en46 === void 0 ? void 0 : _sisNavigationMenu$en46.color_line) !== null && _sisNavigationMenu$en45 !== void 0 ? _sisNavigationMenu$en45 : '',
            categoryColor: (_sisNavigationMenu$en47 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en48 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en48 === void 0 ? void 0 : _sisNavigationMenu$en48.category_color) !== null && _sisNavigationMenu$en47 !== void 0 ? _sisNavigationMenu$en47 : '',
            hightlightColor: (_sisNavigationMenu$en49 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en50 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en50 === void 0 ? void 0 : _sisNavigationMenu$en50.hightlight_color) !== null && _sisNavigationMenu$en49 !== void 0 ? _sisNavigationMenu$en49 : '',
            hightlightTextColor: (_sisNavigationMenu$en51 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en52 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en52 === void 0 ? void 0 : _sisNavigationMenu$en52.hightlight_text_color) !== null && _sisNavigationMenu$en51 !== void 0 ? _sisNavigationMenu$en51 : '',
            dataWrapper: (_sisNavigationMenu$en53 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en54 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en54 === void 0 ? void 0 : _sisNavigationMenu$en54.data_wrapper) !== null && _sisNavigationMenu$en53 !== void 0 ? _sisNavigationMenu$en53 : '',
            store: site,
            enableSISMenuV2: enableSISMenuV2,
            showCategoryFirst: showCategoryFirst,
            sideBarTitleMobile: (_sisNavigationMenu$en55 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en56 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en56 === void 0 ? void 0 : _sisNavigationMenu$en56.sidebar_title_mobile) !== null && _sisNavigationMenu$en55 !== void 0 ? _sisNavigationMenu$en55 : '',
            categoryHeaderTitle: categoryHeaderTitle,
            serviceHeaderTitle: serviceHeaderTitle
          }), jsx(Search$1, {
            deviceType: deviceType,
            onSearch: onSearchTermChange,
            currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
            isSvsSearch: isSvsSearch,
            isTypeAheadEnabled: isTypeAheadEnabled,
            isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
            getTypeaheadUrl: getTypeaheadUrl,
            onLoadingStateChange: setBusy,
            searchbar: searchbar,
            setHideMenuBar: setHideMenuBar,
            isAndes: isZoneModalEnabled,
            isAgentLoggedIn: isAgentLoggedIn,
            isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
            setSearchInputRef: setSearchInputRef,
            isSearchBarTouched: isSearchBarTouched,
            setIsSearchBarTouched: setIsSearchBarTouched,
            store: site,
            searchInSis: searchInSis,
            onSearchDomainChange: onSearchDomainChange,
            isRecentSearchesEnabled: isRecentSearchesEnabled,
            isSearchSpecialCharactersEnabled: isSearchSpecialCharactersEnabled,
            isSearchByImageEnable: enableSearchByImage,
            isCameraCoachmarkVisible: isCameraCoachmarkVisible,
            searchByImageEndpoint: searchByImageEndpoint,
            searchByImageApiKey: searchByImageApiKey
          })]
        })]
      }), jsxs("div", {
        id: "bottom-header",
        style: {
          background: site && ((_header$entry$themes$7 = header === null || header === void 0 || (_header$entry15 = header.entry) === null || _header$entry15 === void 0 || (_header$entry15 = _header$entry15.themes) === null || _header$entry15 === void 0 || (_header$entry15 = _header$entry15[site]) === null || _header$entry15 === void 0 ? void 0 : _header$entry15.bottom_header_background_color) !== null && _header$entry$themes$7 !== void 0 ? _header$entry$themes$7 : (_BRAND_CONFIG$site6 = BRAND_CONFIG$1[site]) === null || _BRAND_CONFIG$site6 === void 0 ? void 0 : _BRAND_CONFIG$site6.bottom_header_background_color)
        },
        children: [jsx(TransversalBanner$1, {
          transversalBanner: header.transversalBannerHtml,
          transversalBannerConfig: transversalBannerConfig,
          locationPathname: locationPathname
        }, "transversalBanner"), jsx(TernaryNavBar$1, {
          currentStep: currentStep,
          deviceType: deviceType,
          handleRouteChange: handleSoftRefresh,
          header: header,
          isAgentLoggedIn: isAgentLoggedIn,
          baseUrl: catalystBaseUrl,
          isBrandingMarketplace: true,
          isDefaultComuna: isDefaultComuna,
          selectedZone: selectedZone,
          isPopOverVisible: isPopOverVisible,
          isOnboardingDisabledCookie: isOnboardingDisabledCookie,
          isOnboardingEnabled: isOnboardingEnabled,
          searchInSis: searchInSis,
          isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
          isZoneModalEnabled: isZoneModalEnabled,
          isSearchBarTouched: isSearchBarTouched,
          modalVisible: zoneModalVisible,
          setModalVisible: setZoneModalVisible,
          tenant: tenant,
          onSearchDomainChange: onSearchDomainChange,
          storeName: !isEmpty(sisNavigationMenu) ? (_sisNavigationMenu$en57 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en58 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en58 === void 0 ? void 0 : _sisNavigationMenu$en58.data_wrapper) !== null && _sisNavigationMenu$en57 !== void 0 ? _sisNavigationMenu$en57 : '' : '',
          isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
          geofinderConfigs: geofinderConfigs,
          isOrangeOrSISHeader: true,
          isPostalCodeEnabled: isPostalCodeEnabled,
          isSISLevel2Header: false,
          store: store,
          setShowLoginForm: setShowLoginForm,
          quickLinks: quickLinks,
          isCoachmarkVisible: isCoachmarkVisible,
          enableSISMenuV2: enableSISMenuV2
        })]
      }), modalVisible && deviceType !== 'desktop' && jsx(MarketplaceOverlay$1, {
        handlers: function handlers(e) {
          e.preventDefault();
          toggleModal(false);
          setModalVisible(false);
        }
      }), pushNotificationData.isVisible && jsx(Notification$1, {
        isMarketplace: true,
        requireInteraction: pushNotificationData.require_interaction,
        isVisible: pushNotificationData.isVisible,
        isWelcomeMessage: pushNotificationData.isWelcomeMessage,
        action: pushNotificationData.action,
        icon: pushNotificationData.icon,
        title: pushNotificationData.title,
        body: pushNotificationData.body,
        closeNotification: closeNotification
      }), isStandaloneSite && enableSISMenuV2 && (quickLinks === null || quickLinks === void 0 ? void 0 : quickLinks.length) > 0 && deviceType !== 'desktop' && jsx(QuickLinks$1, {
        items: quickLinks,
        isCoachmarkVisible: isCoachmarkVisible
      })]
    }), jsx("style", {
      children: "\n          :root {\n            --primary-color: ".concat(primaryColor, ";\n            --secondary-color: ").concat(secondaryColor, ";\n            --primary-theme-color: ").concat(primaryThemeColor, ";\n            --secondary-theme-color: ").concat(secondaryThemeColor, ";\n            --header-primary-color: ").concat(primaryColor, ";\n            --header-logo-background: linear-gradient(270.96deg, #ff6200 0%, #ff861b 95.09%);\n            --header-background: #FFF;\n            --mobile-header-background: linear-gradient(17.56deg,#ff9401 63.22%,#ff7b01 105.58%,#ff6c01 144.92%);\n            --text-color: ").concat(cssVariables.hexColors['#343E49'], ";\n            --icon-background: ").concat(cssVariables.hexColors['#343E49'], ";\n            --searchbar-box-shadow: 0px 0px 4px rgba(158, 160, 150, 0.5);\n            --cart-border-color: #ff9502;\n            --border-color: 52, 62, 73;\n            --header-zone-primary-color: ").concat(cssVariables.hexColors['#343E49'], ";\n            --sis-link-header-zone-whithe-icon: url(https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt81992037b3a68062/64e8cbd72ca0795c4a0752e1/location_pin.svg) !important;\n            --search-bar-border-radius: ").concat((_cssVariables$site$se = (_cssVariables$site = cssVariables[site]) === null || _cssVariables$site === void 0 ? void 0 : _cssVariables$site['search-bar-border-radius']) !== null && _cssVariables$site$se !== void 0 ? _cssVariables$site$se : '', ";\n            --search-bar-button-icon-border-radius: ").concat((_cssVariables$site$se2 = (_cssVariables$site2 = cssVariables[site]) === null || _cssVariables$site2 === void 0 ? void 0 : _cssVariables$site2['search-bar-button-icon-border-radius']) !== null && _cssVariables$site$se2 !== void 0 ? _cssVariables$site$se2 : '', ";\n            --category-button-wrapper-border-radius: ").concat((_cssVariables$site$ca = (_cssVariables$site3 = cssVariables[site]) === null || _cssVariables$site3 === void 0 ? void 0 : _cssVariables$site3['category-button-wrapper-border-radius']) !== null && _cssVariables$site$ca !== void 0 ? _cssVariables$site$ca : '', ";\n            --category-button-wrapper-font-size:14px;\n            --category-button-wrapper-border-color: ").concat(cssVariables.hexColors['#343E49'], ";\n            --category-button-chevron-down-color: ").concat(cssVariables.hexColors['#343E49'], ";\n          }\n        ")
    })]
  });
};
Header$3.propTypes = {
  styles: PropTypes.object.isRequired,
  atgBaseUrl: PropTypes.string.isRequired,
  attachResizeListener: PropTypes.func.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  currentLocation: PropTypes.string,
  currentSearchTerm: PropTypes.string,
  data: PropTypes.any,
  deviceType: PropTypes.string.isRequired,
  enableAnalyticsInfoCall: PropTypes.bool,
  forceATG: PropTypes.bool,
  getTypeaheadUrl: PropTypes.func,
  handleRouteChange: PropTypes.any,
  handleSoftRefresh: PropTypes.func,
  isATGLoginEnabled: PropTypes.bool,
  isDefaultComuna: PropTypes.bool,
  isGeoLocationEnabled: PropTypes.bool,
  isPopOverVisible: PropTypes.bool,
  isTypeAheadEnabled: PropTypes.bool,
  isZoneModalEnabled: PropTypes.bool,
  isWebPushNotificationEnabled: PropTypes.bool,
  isSisSodimacPdpEnabled: PropTypes.bool,
  onRouteChange: PropTypes.func,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  onUserLogout: PropTypes.func,
  refreshUserData: PropTypes.func.isRequired,
  selectedZone: PropTypes.object,
  setBusy: PropTypes.func.isRequired,
  locationPathname: PropTypes.string,
  store: PropTypes.string,
  unifiedLoginBaseUrl: PropTypes.string,
  userCartCount: PropTypes.string,
  transversalBannerConfig: PropTypes.shape({
    home: PropTypes.bool,
    pdp: PropTypes.bool,
    xlp: PropTypes.bool,
    basket: PropTypes.bool
  }),
  MobileAppWebView: PropTypes.bool,
  isCoachmarkVisible: PropTypes.bool,
  enableSISMenuV2: PropTypes.bool,
  showCategoryFirst: PropTypes.bool,
  stickyOverride: PropTypes.shape({
    enabled: PropTypes.bool,
    mode: PropTypes.oneOf(['simple', 'auto']),
    threshold: PropTypes.number
  })
};
Header$3.defaultProps = {
  atgBaseUrl: '',
  catalystBaseUrl: '',
  currentLocation: '',
  currentSearchTerm: '',
  enableAnalyticsInfoCall: false,
  forceATG: false,
  handleSoftRefresh: noop$1,
  isATGLoginEnabled: false,
  isDefaultComuna: false,
  isGeoLocationEnabled: true,
  isPopOverVisible: false,
  isTypeAheadEnabled: true,
  isZoneModalEnabled: true,
  isWebPushNotificationEnabled: false,
  isSisSodimacPdpEnabled: false,
  onRouteChange: noop$1,
  onUserLogin: noop$1,
  onUserLoginComplete: noop$1,
  onUserLoginConsentsUpdate: noop$1,
  onUserLoginPasswordUpdate: noop$1,
  onUserLogout: noop$1,
  parentRouter: null,
  selectedZone: undefined,
  unifiedLoginBaseUrl: undefined,
  userCartCount: undefined,
  locationPathname: undefined,
  getTypeaheadUrl: apiConfig$2.getTypeaheadUrl,
  MobileAppWebView: false,
  isCoachmarkVisible: false,
  enableSISMenuV2: false,
  showCategoryFirst: true,
  categoryHeaderTitle: '',
  serviceHeaderTitle: '',
  sideBarTitleMobile: '',
  stickyOverride: undefined
};
var StandaloneHeader = withUser(withLoader(withDevice(Header$3)));

var styles$3 = {"cross-banner":"CrossBanner-module_cross-banner__Api4r","banner-image":"CrossBanner-module_banner-image__4-bDZ"};

function CrossBanner(_ref) {
  var crossBanner = _ref.crossBanner,
    deviceType = _ref.deviceType;
  if (!(crossBanner !== null && crossBanner !== void 0 && crossBanner.isVisible)) return null;
  var url = crossBanner.url,
    openInNewTab = crossBanner.openInNewTab,
    desktopImageUrl = crossBanner.desktopImageUrl,
    mobileImageUrl = crossBanner.mobileImageUrl;
  var imageUrl = deviceType === 'desktop' ? desktopImageUrl : mobileImageUrl || desktopImageUrl;
  return jsx("div", {
    className: styles$3['cross-banner'],
    id: "cross-banner",
    children: jsx("a", {
      href: url,
      target: openInNewTab ? '_blank' : '_self',
      rel: "noopener noreferrer",
      children: jsx("img", {
        src: imageUrl,
        alt: "Cross Banner",
        className: styles$3['banner-image']
      })
    })
  });
}
CrossBanner.defaultProps = {
  crossBanner: {
    isVisible: false,
    url: '',
    openInNewTab: false,
    desktopImageUrl: '',
    mobileImageUrl: ''
  },
  deviceType: 'desktop'
};
CrossBanner.propTypes = {
  crossBanner: PropTypes.shape({
    isVisible: PropTypes.bool,
    url: PropTypes.string,
    openInNewTab: PropTypes.bool,
    desktopImageUrl: PropTypes.string.isRequired,
    mobileImageUrl: PropTypes.string
  }).isRequired,
  deviceType: PropTypes.string.isRequired
};

var styles$2 = {"container":"CategoryMenu-module_container__hUFnR","categories-container":"CategoryMenu-module_categories-container__7ZOd5","category-title":"CategoryMenu-module_category-title__A2m9N","category-title-href":"CategoryMenu-module_category-title-href__LJAaM"};

var styles$1 = {"sub-category-container":"SubCategories-module_sub-category-container__fVHi-","subcategories":"SubCategories-module_subcategories__6-CxK","second-level-category-container":"SubCategories-module_second-level-category-container__H-QB6","hover-effect":"SubCategories-module_hover-effect__8-usq","list-title":"SubCategories-module_list-title__BdpSx","list-title-space":"SubCategories-module_list-title-space__4Ra00","images-container":"SubCategories-module_images-container__M4NTj","list-item-no-link":"SubCategories-module_list-item-no-link__cqwyt"};

function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SubCategories = function SubCategories(_ref) {
  var fillFullHeight = _ref.fillFullHeight,
    secondLevelCategories = _ref.secondLevelCategories,
    dataWrapper = _ref.dataWrapper,
    levelTwoCategoryColor = _ref.levelTwoCategoryColor,
    levelThreeCategoryColor = _ref.levelThreeCategoryColor,
    categoryState = _ref.categoryState,
    isService = _ref.isService,
    banners = _ref.banners;
  var firstLevelItemName = isService ? "SRV ".concat(categoryState.firstLevelItem) : categoryState.firstLevelItem;
  var getChildContentForCategory = function getChildContentForCategory(category, isSecondLevelCategories) {
    var charactersRepresentedByStyles = 20 / 7.984;
    var charactersToDisplayTooltip = isSecondLevelCategories ? 200 : 210;
    var relativeTagSize = isSecondLevelCategories ? 0.95 : 1.22;
    var tooltipMarginTop = '28px';
    var categoryLength = (category.item_name && category.item_name.length) + (category.tag && category.tag.show && category.tag.text && category.tag.text.length * relativeTagSize - 1 + charactersRepresentedByStyles);
    return jsxs("div", {
      className: styles$1.content,
      children: [categoryLength <= charactersToDisplayTooltip ? jsx("span", {
        className: classNames(styles$1.text),
        children: category.item_name
      }) : jsx(Tooltip$1, {
        viewType: "static",
        position: "bottom-static",
        containerStyle: {
          marginTop: tooltipMarginTop
        },
        tooltipContent: jsx(TooltipText, {
          color: "#495867",
          text: category.item_name,
          viewType: "verysmall-2"
        }),
        children: jsx("span", {
          className: classNames(styles$1.text),
          children: category.item_name
        })
      }), category.tag && category.tag.show && jsx(Tag$1, _objectSpread$4(_objectSpread$4({}, category.tag), {}, {
        device: "desktop"
      }))]
    });
  };
  return jsx("div", {
    className: classNames([styles$1['sub-category-container']], _defineProperty(_defineProperty({}, styles$1['fill-full-height'], fillFullHeight), styles$1['small-height'], !fillFullHeight)),
    children: jsx("div", {
      children: jsxs("div", {
        className: classNames(styles$1.subcategories),
        children: [secondLevelCategories.map(function (subCategory, index) {
          return jsxs("ul", {
            "data-index": "second-level-category-".concat(index),
            onClick: function onClick(e) {
              return e.stopPropagation();
            },
            className: classNames(styles$1['second-level-category-container']),
            children: [jsx("li", {
              className: classNames(styles$1['list-title-space']),
              onClick: function onClick() {
                return updateDigitalDataCookies({
                  firstLevelItem: firstLevelItemName,
                  secondLevelItem: subCategory.item_name,
                  thirdLevelItem: subCategory.item_name,
                  positionOne: categoryState.index + 1,
                  positionTwo: index + 1,
                  positionThree: 0,
                  tag: SIS_NAVIGATION,
                  dataWrapper: dataWrapper
                });
              },
              children: subCategory.item_url ? wrapSubCategoryWithLink(subCategory, getChildContentForCategory(subCategory, true), false, getCategoryColor(levelTwoCategoryColor, subCategory.item_color), false, styles$1, classNames) : jsx("div", {
                className: classNames(styles$1['list-item-no-link']),
                style: {
                  color: levelTwoCategoryColor
                },
                children: getChildContentForCategory(subCategory, true)
              })
            }), subCategory.third_level_categories && subCategory.third_level_categories.map(function (thirdLevelCategory, subindex) {
              return jsx("li", {
                onClick: function onClick() {
                  return updateDigitalDataCookies({
                    firstLevelItem: firstLevelItemName,
                    secondLevelItem: subCategory.item_name,
                    thirdLevelItem: thirdLevelCategory.item_name,
                    positionOne: categoryState.index + 1,
                    positionTwo: index + 1,
                    positionThree: subindex + 1,
                    tag: SIS_NAVIGATION,
                    dataWrapper: dataWrapper
                  });
                },
                children: thirdLevelCategory.item_url ? wrapSubCategoryWithLink(thirdLevelCategory, getChildContentForCategory(thirdLevelCategory), true, getCategoryColor(levelThreeCategoryColor, thirdLevelCategory.item_color), false, styles$1, classNames) : jsx("div", {
                  className: styles$1['list-item-no-link'],
                  children: getChildContentForCategory(thirdLevelCategory)
                })
              }, "third-level-category-".concat(subindex));
            })]
          }, "second-level-category-".concat(index));
        }), banners.length > 0 && jsx("div", {
          className: classNames(styles$1['images-container']),
          children: jsx(Banners$1, {
            banners: banners,
            dataWrapper: dataWrapper,
            firstLevelItem: categoryState.firstLevelItem,
            currentCategoryIndex: categoryState.index
          })
        })]
      })
    })
  });
};
SubCategories.PropTypes = {
  fillFullHeight: PropTypes.bool,
  secondLevelCategories: PropTypes.arrayOf(PropTypes.object),
  banners: PropTypes.arrayOf(PropTypes.object),
  dataWrapper: PropTypes.string,
  levelTwoCategoryColor: PropTypes.string,
  levelThreeCategoryColor: PropTypes.string,
  isService: PropTypes.bool
};
var SubCategories$1 = withCategoryState(SubCategories);

var DEFAULT_CATEGORY_COLORS = {
  levelOneColor: '#FFF',
  levelTwoColor: '#666',
  levelThreeColor: '#666',
  highlightCategoryColor: '#666'
};

var CategoryMenu = function CategoryMenu(_ref) {
  var categories = _ref.categories,
    classes = _ref.classes,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    dataWrapper = _ref.dataWrapper,
    defaultCategoryColors = _ref.defaultCategoryColors,
    categoryState = _ref.categoryState,
    menuBackgroundColor = _ref.menuBackgroundColor;
  if (!categories || categories.length === 0) {
    return jsx(Fragment$1, {});
  }
  var getCategoryColors = function getCategoryColors() {
    var colors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref2 = colors || {},
      levelOneCategoryColor = _ref2.level_one_category_color,
      levelTwoCategoryColor = _ref2.level_two_category_color,
      levelThreeCategoryColor = _ref2.level_three_category_color,
      highlightCategoryColor = _ref2.highlight_level_category_color;
    return {
      levelOneColor: levelOneCategoryColor || DEFAULT_CATEGORY_COLORS.levelOneColor,
      levelTwoColor: levelTwoCategoryColor || DEFAULT_CATEGORY_COLORS.levelTwoColor,
      levelThreeColor: levelThreeCategoryColor || DEFAULT_CATEGORY_COLORS.levelThreeColor,
      highlightCategoryColor: highlightCategoryColor || DEFAULT_CATEGORY_COLORS.highlightCategoryColor
    };
  };
  var defaultColors = getCategoryColors(defaultCategoryColors);
  var _useSideMenuData = useSideMenuData$1({
      categories: categories,
      dataWrapper: dataWrapper,
      hightlightColor: hightlightColor,
      hightlightTextColor: hightlightTextColor
    }),
    categoryItems = _useSideMenuData.categoryItems;
    _useSideMenuData.serviceItems;
    _useSideMenuData.hasBothSections;
    _useSideMenuData.hightLightStyle;
    var hasChildrenItems = _useSideMenuData.hasChildrenItems;
    _useSideMenuData.handleClick;
  return jsx("nav", {
    className: classNames(styles$2.container, classes.join(' ')),
    style: menuBackgroundColor ? {
      backgroundColor: menuBackgroundColor
    } : {},
    children: jsx("ul", {
      className: styles$2['categories-container'],
      children: categoryItems.map(function (category, index) {
        var _ref3 = category.item || {},
          _ref3$highlight_level = _ref3.highlight_level_categories,
          highlightLevelCategories = _ref3$highlight_level === void 0 ? [] : _ref3$highlight_level,
          _ref3$second_level_ca = _ref3.second_level_categories,
          secondLevelCategories = _ref3$second_level_ca === void 0 ? [] : _ref3$second_level_ca,
          _ref3$banners = _ref3.banners,
          banners = _ref3$banners === void 0 ? [] : _ref3$banners,
          isService = _ref3.isService,
          itemName = _ref3.item_name,
          itemUrl = _ref3.item_url;
        var hasSubCategories = secondLevelCategories && secondLevelCategories.length > 0;
        var hasChildren = hasChildrenItems(category.item);
        var href = itemUrl !== null && itemUrl !== void 0 && itemUrl.href && !hasChildren ? itemUrl.href : '#';
        return jsxs("li", {
          className: styles$2['category-title'],
          children: [highlightLevelCategories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES && null, jsx("a", {
            "data-cta": "true",
            target: category.new_tab && !hasChildren ? '_blank' : '_self',
            rel: "noreferrer",
            href: href,
            className: styles$2['category-title-href'],
            children: jsx("span", {
              style: {
                color: defaultColors.levelOneColor
              },
              children: itemName
            })
          }, "L1_".concat(itemName, "_").concat(index)), hasSubCategories && jsx(SubCategories$1, {
            isService: isService,
            secondLevelCategories: secondLevelCategories,
            fillFullHeight: highlightLevelCategories.length < MIN_HIGHLIGHT_LEVEL_CATEGORIES,
            dataWrapper: dataWrapper,
            levelTwoCategoryColor: defaultColors.levelTwoColor,
            levelThreeCategoryColor: defaultColors.levelThreeColor,
            banners: banners,
            categoryState: categoryState
          })]
        }, index);
      })
    })
  });
};
CategoryMenu.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  dataWrapper: PropTypes.string,
  defaultCategoryColors: PropTypes.object,
  menuBackgroundColor: PropTypes.string,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string
};
CategoryMenu.defaultProps = {
  categories: [],
  classes: [],
  defaultCategoryColors: []
};
var CategoryMenu$1 = CategoryMenu;

var styles = {"container":"SisNavigationMenuHorizontal-module_container__RC-g6"};

function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SiSNavigationMenuHorizontal = function SiSNavigationMenuHorizontal(_ref) {
  var categories = _ref.categories,
    services = _ref.services,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    dataWrapper = _ref.dataWrapper,
    style = _ref.style,
    classes = _ref.classes,
    id = _ref.id,
    defaultCategoryColors = _ref.defaultCategoryColors,
    enableSISMenuV2 = _ref.enableSISMenuV2,
    showCategoryFirst = _ref.showCategoryFirst,
    menuBackgroundColor = _ref.menuBackgroundColor;
  var desktopCategories = categories.filter(function (c) {
    var _c$channel;
    return c === null || c === void 0 || (_c$channel = c.channel) === null || _c$channel === void 0 ? void 0 : _c$channel.desktop;
  });
  var desktopServices = services.filter(function (c) {
    var _c$channel2;
    return c === null || c === void 0 || (_c$channel2 = c.channel) === null || _c$channel2 === void 0 ? void 0 : _c$channel2.desktop;
  });
  var data = showCategoryFirst ? [].concat(_toConsumableArray(desktopCategories.map(function (c, i) {
    return _objectSpread$3(_objectSpread$3({}, c), {}, {
      isService: false,
      menuIndex: i
    });
  })), _toConsumableArray(enableSISMenuV2 ? desktopServices.map(function (s, i) {
    return _objectSpread$3(_objectSpread$3({}, s), {}, {
      isService: true,
      menuIndex: i
    });
  }) : [])) : [].concat(_toConsumableArray(enableSISMenuV2 ? desktopServices.map(function (s, i) {
    return _objectSpread$3(_objectSpread$3({}, s), {}, {
      isService: true,
      menuIndex: i
    });
  }) : []), _toConsumableArray(desktopCategories.map(function (c, i) {
    return _objectSpread$3(_objectSpread$3({}, c), {}, {
      isService: false,
      menuIndex: i
    });
  })));
  return jsx("div", {
    "data-wrapper": "MS-MenuSis_Horizontal_".concat(dataWrapper),
    className: classNames(styles.container, classes.join(' ')),
    style: _objectSpread$3(_objectSpread$3({}, menuBackgroundColor ? {
      backgroundColor: menuBackgroundColor
    } : {}), style),
    id: id,
    "data-testid": "SiSNavigationMenuIdHorizontal",
    children: jsx(CategoryMenu$1, {
      categories: data,
      menuBackgroundColor: menuBackgroundColor,
      defaultCategoryColors: defaultCategoryColors,
      hightlightColor: hightlightColor,
      hightlightTextColor: hightlightTextColor
    })
  });
};
SiSNavigationMenuHorizontal.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.object,
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })),
  services: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    }).isRequired,
    tag: PropTypes.shape({
      show: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.array,
    second_level_categories: PropTypes.array
  })).isRequired,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string,
  dataWrapper: PropTypes.string,
  style: PropTypes.object,
  classes: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string,
  defaultCategoryColors: PropTypes.shape({}),
  enableSISMenuV2: PropTypes.bool,
  showCategoryFirst: PropTypes.bool,
  menuBackgroundColor: PropTypes.string
};
SiSNavigationMenuHorizontal.defaultProps = {
  colorLine: '',
  categoryColor: '',
  banners: [],
  classes: [],
  id: undefined,
  isVendorOrAgentLoggedIn: false,
  services: []
};
var SiSNavigationMenuHorizontal$1 = SiSNavigationMenuHorizontal;

var HorizontalTypeContent = function HorizontalTypeContent(_ref) {
  var deviceType = _ref.deviceType,
    renderSearch = _ref.renderSearch,
    renderLogo = _ref.renderLogo;
  return jsxs(Fragment$1, {
    children: [jsx(MatchMedia$1, {
      deviceType: deviceType,
      content: {
        desktop: function desktop() {
          return renderSearch();
        },
        mobile: function mobile() {
          return jsx(React.Fragment, {});
        },
        tablet: function tablet() {
          return jsx(React.Fragment, {});
        }
      }
    }, "search-bar-desktop"), renderLogo()]
  });
};
var ButtonTypeContent = function ButtonTypeContent(_ref2) {
  var deviceType = _ref2.deviceType,
    renderSearch = _ref2.renderSearch,
    renderLogo = _ref2.renderLogo,
    renderNavigationMenu = _ref2.renderNavigationMenu;
  return jsxs(Fragment$1, {
    children: [jsx(MatchMedia$1, {
      deviceType: deviceType,
      content: {
        desktop: function desktop() {
          return jsx(React.Fragment, {});
        },
        mobile: function mobile() {
          return renderNavigationMenu();
        },
        tablet: function tablet() {
          return renderNavigationMenu();
        }
      }
    }, "testId-store-menu"), renderLogo(), jsx(MatchMedia$1, {
      deviceType: deviceType,
      content: {
        desktop: function desktop() {
          return renderNavigationMenu();
        },
        mobile: function mobile() {
          return jsx(React.Fragment, {});
        },
        tablet: function tablet() {
          return jsx(React.Fragment, {});
        }
      }
    }, "testId-store-menu"), jsx(MatchMedia$1, {
      deviceType: deviceType,
      content: {
        desktop: function desktop() {
          return renderSearch();
        },
        mobile: function mobile() {
          return jsx(React.Fragment, {});
        },
        tablet: function tablet() {
          return jsx(React.Fragment, {});
        }
      }
    }, "search-bar-desktop")]
  });
};
var HeaderContentByType = function HeaderContentByType(_ref3) {
  var deviceType = _ref3.deviceType,
    menuType = _ref3.menuType,
    renderSearch = _ref3.renderSearch,
    renderLogo = _ref3.renderLogo,
    renderNavigationMenu = _ref3.renderNavigationMenu;
  if (menuType === MENU_TYPE.HORIZONTAL && deviceType === 'desktop') return jsx(HorizontalTypeContent, {
    deviceType: deviceType,
    renderSearch: renderSearch,
    renderLogo: renderLogo
  });
  return jsx(ButtonTypeContent, {
    deviceType: deviceType,
    menuType: menuType,
    renderSearch: renderSearch,
    renderLogo: renderLogo,
    renderNavigationMenu: renderNavigationMenu
  });
};
HeaderContentByType.propTypes = {
  deviceType: PropTypes.string.isRequired,
  menuType: PropTypes.oneOf([MENU_TYPE.HORIZONTAL, MENU_TYPE.BUTTON]).isRequired,
  renderSearch: PropTypes.func.isRequired,
  renderLogo: PropTypes.func.isRequired,
  renderNavigationMenu: PropTypes.func
};
var HeaderContentByType$1 = HeaderContentByType;

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var OnboardingWithoutSSR = SkipSSR$1(Onboarding$1);
var Header$2 = function Header(_ref) {
  var _sisNavigationMenu$en, _sisNavigationMenu$en2, _header$entry$onboard, _header$entry3, _sisNavigationMenu$en18, _sisNavigationMenu$en19;
  var styles = _ref.styles,
    atgBaseUrl = _ref.atgBaseUrl,
    attachResizeListener = _ref.attachResizeListener,
    catalystBaseUrl = _ref.catalystBaseUrl,
    currentLocation = _ref.currentLocation,
    currentSearchTerm = _ref.currentSearchTerm,
    data = _ref.data,
    deviceType = _ref.deviceType,
    enableAnalyticsInfoCall = _ref.enableAnalyticsInfoCall,
    forceATG = _ref.forceATG,
    getTypeaheadUrl = _ref.getTypeaheadUrl,
    handleSoftRefresh = _ref.handleSoftRefresh,
    isATGLoginEnabled = _ref.isATGLoginEnabled,
    isDefaultComuna = _ref.isDefaultComuna,
    isPopOverVisible = _ref.isPopOverVisible,
    isTypeAheadEnabled = _ref.isTypeAheadEnabled,
    isZoneModalEnabled = _ref.isZoneModalEnabled,
    isWebPushNotificationEnabled = _ref.isWebPushNotificationEnabled,
    isSisSodimacPdpEnabled = _ref.isSisSodimacPdpEnabled,
    onUserLogin = _ref.onUserLogin,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate,
    onUserLogout = _ref.onUserLogout,
    selectedZone = _ref.selectedZone,
    setBusy = _ref.setBusy,
    store = _ref.store,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    userCartCount = _ref.userCartCount,
    MobileAppWebView = _ref.MobileAppWebView;
  var _useContext = useContext(AppContext$1),
    tenant = _useContext.tenant,
    baseUrl = _useContext.baseUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSearchBar = _useState2[0],
    setShowSearchBar = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    modalVisible = _useState6[0],
    setModalVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSearchBarTouched = _useState8[0],
    setIsSearchBarTouched = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    zoneModalVisible = _useState0[0],
    setZoneModalVisible = _useState0[1];
  var _useState1 = useState(undefined),
    _useState10 = _slicedToArray(_useState1, 2);
    _useState10[0];
    var setSearchInputRef = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    var setHideMenuBar = _useState12[1];
  var _useState13 = useState({
      isVisible: false
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    pushNotificationData = _useState14[0],
    setPushNotificationData = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    mobileModalClass = _useState16[0],
    setMobileModalClass = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showLoginForm = _useState18[0],
    setShowLoginForm = _useState18[1];
  var currentStepValue = 0;
  var _useHeader = useHeader({
      styles: styles,
      tenant: tenant,
      baseUrl: baseUrl,
      store: store,
      data: data,
      isWebPushNotificationEnabled: isWebPushNotificationEnabled,
      setPushNotificationData: setPushNotificationData,
      currentStepValue: currentStepValue,
      attachResizeListener: attachResizeListener,
      deviceType: deviceType,
      currentLocation: currentLocation
    }),
    isIE = _useHeader.isIE,
    isOnboardingDisabledCookie = _useHeader.isOnboardingDisabledCookie,
    currentStep = _useHeader.currentStep,
    header = _useHeader.header,
    setCurrentStep = _useHeader.setCurrentStep,
    sisNavigationMenu = _useHeader.sisNavigationMenu,
    isMobileApp = _useHeader.isMobileApp,
    site = _useHeader.site,
    isVendorLoggedIn = _useHeader.isVendorLoggedIn,
    setIsVendorLoggedIn = _useHeader.setIsVendorLoggedIn,
    isAgentLoggedIn = _useHeader.isAgentLoggedIn,
    areCookiesPresent = _useHeader.areCookiesPresent,
    whiteLabelProp = _useHeader.whiteLabelProp;
  var _extractHeaderConfig = extractHeaderConfig(header, deviceType),
    isOnboardingEnabled = _extractHeaderConfig.isOnboardingEnabled,
    isProgramaticallyGeofinderEnabled = _extractHeaderConfig.isProgramaticallyGeofinderEnabled,
    geofinderConfigs = _extractHeaderConfig.geofinderConfigs,
    isRecentSearchesEnabled = _extractHeaderConfig.isRecentSearchesEnabled,
    searchbar = _extractHeaderConfig.searchbar,
    mainLogoIcon = _extractHeaderConfig.mainLogoIcon,
    logoURL = _extractHeaderConfig.logoURL,
    menuConfig = _extractHeaderConfig.menuConfig,
    menuTextColor = _extractHeaderConfig.menuTextColor,
    myAccountTextColor = _extractHeaderConfig.myAccountTextColor,
    myOrdersTextColor = _extractHeaderConfig.myOrdersTextColor,
    topHeaderTextColor = _extractHeaderConfig.topHeaderTextColor,
    topHeaderBackgroundColor = _extractHeaderConfig.topHeaderBackgroundColor,
    bottomHeaderBackgroundColor = _extractHeaderConfig.bottomHeaderBackgroundColor,
    fontLink = _extractHeaderConfig.fontLink,
    fontFamily = _extractHeaderConfig.fontFamily,
    crossBanner = _extractHeaderConfig.crossBanner,
    horizontalMenuBackgroundColor = _extractHeaderConfig.horizontalMenuBackgroundColor,
    menuType = _extractHeaderConfig.menuType;
  var iconAlignment = (_sisNavigationMenu$en = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en2 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en2 === void 0 || (_sisNavigationMenu$en2 = _sisNavigationMenu$en2.menu) === null || _sisNavigationMenu$en2 === void 0 || (_sisNavigationMenu$en2 = _sisNavigationMenu$en2.mobile) === null || _sisNavigationMenu$en2 === void 0 ? void 0 : _sisNavigationMenu$en2.icon_alignment) !== null && _sisNavigationMenu$en !== void 0 ? _sisNavigationMenu$en : 'center';
  var isHorizontalMenu = menuType === MENU_TYPE.HORIZONTAL && deviceType === 'desktop';
  var closeNotification = function closeNotification() {
    setPushNotificationData({
      isVisible: false
    });
  };
  var handleSearchTermChange = function handleSearchTermChange(searchTerm) {
    onSearchTermChange({
      searchTerm: searchTerm,
      setErrorMessage: setErrorMessage,
      store: site,
      tenant: tenant
    });
  };
  var toggleModal = function toggleModal(visibility) {
    if (deviceType !== 'desktop') {
      if (!visibility) {
        setMobileModalClass('floatBottomEndTransition');
        var animationTimer = setTimeout(function () {
          setModalVisible(visibility);
          clearTimeout(animationTimer);
        }, 350);
      } else {
        setMobileModalClass('floatBottomTransition');
        setModalVisible(visibility);
      }
    } else {
      setModalVisible(visibility);
    }
  };
  var handleUserLogout = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var userCookie;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            userCookie = CookieStorage$1.getUserDataCookieName();
            CookieStorage$1.removeCookie({
              name: userCookie
            });
            _context.next = 1;
            return onUserLogout();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleUserLogout() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleUserLogin = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(userData) {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return onUserLogin(userData);
          case 1:
            if (enableAnalyticsInfoCall) {
              initDigitalData();
            }
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleUserLogin(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var renderLogo = function renderLogo() {
    return jsx("div", {
      className: classNames(styles["logo-container-".concat(iconAlignment)], _defineProperty({}, styles['logo-horizontal-menu'], isHorizontalMenu)),
      children: jsx(MatchMedia$1, {
        deviceType: deviceType,
        content: {
          desktop: function desktop() {
            return jsx(Logo$1, {
              path: logoURL,
              logoIcon: mainLogoIcon,
              store: site,
              isHorizontalMenu: isHorizontalMenu
            });
          },
          mobile: function mobile() {
            return jsx(Logo$1, {
              path: logoURL,
              logoIcon: mainLogoIcon,
              isMobile: true,
              store: site
            });
          },
          tablet: function tablet() {
            return jsx(Logo$1, {
              path: logoURL,
              logoIcon: mainLogoIcon,
              isMobile: true,
              store: site
            });
          }
        }
      }, "testId-logo-link")
    });
  };
  var renderNavigationMenu = function renderNavigationMenu() {
    var _header$entry$menu, _header$entry, _sisNavigationMenu$en3, _sisNavigationMenu$en4, _sisNavigationMenu$en5, _sisNavigationMenu$en6, _sisNavigationMenu$en7, _sisNavigationMenu$en8, _sisNavigationMenu$en9, _sisNavigationMenu$en0, _sisNavigationMenu$en1, _sisNavigationMenu$en10, _sisNavigationMenu$en11, _sisNavigationMenu$en12, _sisNavigationMenu$en13, _sisNavigationMenu$en14, _sisNavigationMenu$en15, _sisNavigationMenu$en16;
    if (isHorizontalMenu && deviceType === 'desktop') return null;
    return jsx(SiSNavigationMenu$1, {
      menuConfig: (_header$entry$menu = header === null || header === void 0 || (_header$entry = header.entry) === null || _header$entry === void 0 ? void 0 : _header$entry.menu) !== null && _header$entry$menu !== void 0 ? _header$entry$menu : menuConfig,
      categories: (_sisNavigationMenu$en3 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en4 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en4 === void 0 ? void 0 : _sisNavigationMenu$en4.categories) !== null && _sisNavigationMenu$en3 !== void 0 ? _sisNavigationMenu$en3 : [],
      browseMainText: (_sisNavigationMenu$en5 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en6 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en6 === void 0 ? void 0 : _sisNavigationMenu$en6.browse_main_text) !== null && _sisNavigationMenu$en5 !== void 0 ? _sisNavigationMenu$en5 : '',
      colorLine: (_sisNavigationMenu$en7 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en8 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en8 === void 0 ? void 0 : _sisNavigationMenu$en8.color_line) !== null && _sisNavigationMenu$en7 !== void 0 ? _sisNavigationMenu$en7 : '',
      categoryColor: (_sisNavigationMenu$en9 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en0 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en0 === void 0 ? void 0 : _sisNavigationMenu$en0.category_color) !== null && _sisNavigationMenu$en9 !== void 0 ? _sisNavigationMenu$en9 : '',
      hightlightColor: (_sisNavigationMenu$en1 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en10 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en10 === void 0 ? void 0 : _sisNavigationMenu$en10.hightlight_color) !== null && _sisNavigationMenu$en1 !== void 0 ? _sisNavigationMenu$en1 : '',
      hightlightTextColor: (_sisNavigationMenu$en11 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en12 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en12 === void 0 ? void 0 : _sisNavigationMenu$en12.hightlight_text_color) !== null && _sisNavigationMenu$en11 !== void 0 ? _sisNavigationMenu$en11 : '',
      dataWrapper: (_sisNavigationMenu$en13 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en14 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en14 === void 0 ? void 0 : _sisNavigationMenu$en14.data_wrapper) !== null && _sisNavigationMenu$en13 !== void 0 ? _sisNavigationMenu$en13 : '',
      defaultCategoryColors: (_sisNavigationMenu$en15 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en16 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en16 === void 0 ? void 0 : _sisNavigationMenu$en16.default_category_colors) !== null && _sisNavigationMenu$en15 !== void 0 ? _sisNavigationMenu$en15 : {},
      store: site,
      classes: [styles["width-".concat(iconAlignment)]]
    });
  };
  var renderNavigationMenuHorizontal = function renderNavigationMenuHorizontal() {
    var _sisNavigationMenu$en17, _header$entry2, _headerEntry$menu;
    var entry = (_sisNavigationMenu$en17 = sisNavigationMenu === null || sisNavigationMenu === void 0 ? void 0 : sisNavigationMenu.entry) !== null && _sisNavigationMenu$en17 !== void 0 ? _sisNavigationMenu$en17 : {};
    var headerEntry = (_header$entry2 = header === null || header === void 0 ? void 0 : header.entry) !== null && _header$entry2 !== void 0 ? _header$entry2 : {};
    var _entry$categories = entry.categories,
      categories = _entry$categories === void 0 ? [] : _entry$categories,
      _entry$browse_main_te = entry.browse_main_text,
      browse_main_text = _entry$browse_main_te === void 0 ? '' : _entry$browse_main_te,
      _entry$color_line = entry.color_line,
      color_line = _entry$color_line === void 0 ? '' : _entry$color_line,
      _entry$category_color = entry.category_color,
      category_color = _entry$category_color === void 0 ? '' : _entry$category_color,
      _entry$hightlight_col = entry.hightlight_color,
      hightlight_color = _entry$hightlight_col === void 0 ? '' : _entry$hightlight_col,
      _entry$hightlight_tex = entry.hightlight_text_color,
      hightlight_text_color = _entry$hightlight_tex === void 0 ? '' : _entry$hightlight_tex,
      _entry$data_wrapper = entry.data_wrapper,
      data_wrapper = _entry$data_wrapper === void 0 ? '' : _entry$data_wrapper,
      _entry$default_catego = entry.default_category_colors,
      default_category_colors = _entry$default_catego === void 0 ? {} : _entry$default_catego;
    var props = {
      menuConfig: (_headerEntry$menu = headerEntry.menu) !== null && _headerEntry$menu !== void 0 ? _headerEntry$menu : menuConfig,
      categories: categories,
      browseMainText: browse_main_text,
      colorLine: color_line,
      categoryColor: category_color,
      hightlightColor: hightlight_color,
      hightlightTextColor: hightlight_text_color,
      dataWrapper: data_wrapper,
      defaultCategoryColors: default_category_colors,
      menuBackgroundColor: horizontalMenuBackgroundColor,
      store: site,
      classes: [styles["width-".concat(iconAlignment)]]
    };
    return isHorizontalMenu ? jsx(SiSNavigationMenuHorizontal$1, _objectSpread$2({}, props)) : null;
  };
  var renderSearch = function renderSearch() {
    return jsx(Search$1, {
      deviceType: deviceType,
      onSearch: handleSearchTermChange,
      currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
      isTypeAheadEnabled: isTypeAheadEnabled,
      isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
      getTypeaheadUrl: getTypeaheadUrl,
      onLoadingStateChange: setBusy,
      searchbar: searchbar,
      setHideMenuBar: setHideMenuBar,
      isAndes: isZoneModalEnabled,
      isAgentLoggedIn: isAgentLoggedIn,
      isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
      setSearchInputRef: setSearchInputRef,
      isSearchBarTouched: isSearchBarTouched,
      setIsSearchBarTouched: setIsSearchBarTouched,
      searchInSis: false,
      store: site,
      isRecentSearchesEnabled: isRecentSearchesEnabled,
      classes: classNames(_defineProperty({}, styles['horizontal-menu-searchbar'], isHorizontalMenu))
    });
  };
  useEffect(function () {
    if (!fontLink) return;
    var existingLink = document.querySelector('link[data-font]');
    if (existingLink) {
      existingLink.href = fontLink;
    } else {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = fontLink;
      link.setAttribute('data-font', 'true');
      document.head.appendChild(link);
    }
  }, [fontLink]);
  if (!header) {
    return jsx(Fragment$1, {});
  }
  return jsxs(Fragment$1, {
    children: [jsxs("header", {
      className: classNames(styles['parent-container'], styles["cross-banner-".concat(crossBanner.position)], _defineProperty(_defineProperty({}, styles['no-border'], isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent), styles['hide-component'], MobileAppWebView)),
      children: [errorMessage && jsx(ErrorDialog$1, {
        title: errorMessage.title,
        message: errorMessage.msg,
        onClose: function onClose() {
          setErrorMessage(undefined);
        }
      }), (isVendorLoggedIn || areCookiesPresent) && jsx(VendorHeader$1, {
        isCatalyst: CookieStorage$1.isCatalyst(),
        tenant: tenant,
        setIsVendorLoggedIn: setIsVendorLoggedIn,
        vendorBaseUrl: baseUrl,
        isVendorLoggedIn: isVendorLoggedIn,
        atgBaseUrl: atgBaseUrl,
        catalystBaseUrl: catalystBaseUrl,
        onUserLogout: handleUserLogout,
        forceATG: forceATG,
        store: store,
        whitelabel: whiteLabelProp
      }), isOnboardingEnabled && !isMobileApp && jsx(OnboardingWithoutSSR, {
        deviceType: deviceType,
        currentStep: currentStep,
        setCurrentStep: setCurrentStep,
        onboardingData: (_header$entry$onboard = header === null || header === void 0 || (_header$entry3 = header.entry) === null || _header$entry3 === void 0 ? void 0 : _header$entry3.onboarding) !== null && _header$entry$onboard !== void 0 ? _header$entry$onboard : null,
        tenant: tenant
      }), jsx(CrossBanner, {
        crossBanner: crossBanner,
        deviceType: deviceType,
        className: styles['cross-banner']
      }), jsxs("div", {
        id: "scrollable-content",
        style: {
          background: topHeaderBackgroundColor
        },
        "data-testid": "header-util-bar",
        className: classNames(styles['header-util-bar'], styles['top-header']),
        children: [jsxs("div", {
          className: classNames(styles.container, styles['header-container'], styles["header-container-icon-".concat(iconAlignment)]),
          children: [jsx(HeaderContentByType$1, {
            deviceType: deviceType,
            menuType: menuType,
            renderSearch: renderSearch,
            renderLogo: renderLogo,
            renderNavigationMenu: renderNavigationMenu
          }), jsx(UserActions$1, {
            showSearchBar: showSearchBar,
            setShowSearchBar: setShowSearchBar,
            isATGLoginEnabled: isATGLoginEnabled,
            isInternetExplorer: isIE,
            showLoginForm: showLoginForm,
            setShowLoginForm: setShowLoginForm,
            atgBaseUrl: atgBaseUrl,
            modalVisible: modalVisible,
            mobileModalClass: mobileModalClass,
            toggleModal: toggleModal,
            catalystBaseUrl: catalystBaseUrl,
            onLoadingStateChange: setBusy,
            onUserLogout: handleUserLogout,
            deviceType: deviceType,
            headerData: header,
            onUserLogin: handleUserLogin,
            onUserLoginComplete: onUserLoginComplete,
            onUserLoginConsentsUpdate: onUserLoginConsentsUpdate,
            onUserLoginPasswordUpdate: onUserLoginPasswordUpdate,
            unifiedLoginBaseUrl: unifiedLoginBaseUrl,
            userCartCount: userCartCount,
            isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 1,
            forceATG: forceATG,
            isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
            isAgentLoggedIn: isAgentLoggedIn,
            isStore: true,
            isOrangeOrSISHeader: true,
            isSISLevel2Header: false,
            store: store
          })]
        }), deviceType !== 'desktop' && jsx("div", {
          className: classNames(_defineProperty({}, styles.mobile_middle_wrapper, site)),
          children: renderSearch()
        })]
      }), jsxs("div", {
        id: "bottom-header",
        style: {
          background: site && bottomHeaderBackgroundColor,
          borderTop: '1px solid #CAD1D9'
        },
        className: styles['bottom-header'],
        children: [jsx("div", {
          id: "div-menu-horizontal",
          children: jsx(MatchMedia$1, {
            deviceType: deviceType,
            content: {
              desktop: function desktop() {
                return renderNavigationMenuHorizontal();
              },
              mobile: function mobile() {
                return jsx(React.Fragment, {});
              },
              tablet: function tablet() {
                return jsx(React.Fragment, {});
              }
            }
          }, "testId-store-menu")
        }), jsx(TernaryNavBar$1, {
          currentStep: currentStep,
          deviceType: deviceType,
          handleRouteChange: handleSoftRefresh,
          header: header,
          isAgentLoggedIn: isAgentLoggedIn,
          baseUrl: catalystBaseUrl,
          isBrandingMarketplace: true,
          isDefaultComuna: isDefaultComuna,
          selectedZone: selectedZone,
          isPopOverVisible: isPopOverVisible,
          isOnboardingDisabledCookie: isOnboardingDisabledCookie,
          isOnboardingEnabled: isOnboardingEnabled,
          isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
          isZoneModalEnabled: isZoneModalEnabled,
          isSearchBarTouched: isSearchBarTouched,
          modalVisible: zoneModalVisible,
          setModalVisible: setZoneModalVisible,
          tenant: tenant,
          storeName: !isEmpty(sisNavigationMenu) ? (_sisNavigationMenu$en18 = sisNavigationMenu === null || sisNavigationMenu === void 0 || (_sisNavigationMenu$en19 = sisNavigationMenu.entry) === null || _sisNavigationMenu$en19 === void 0 ? void 0 : _sisNavigationMenu$en19.data_wrapper) !== null && _sisNavigationMenu$en18 !== void 0 ? _sisNavigationMenu$en18 : '' : '',
          isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
          geofinderConfigs: geofinderConfigs,
          isOrangeOrSISHeader: true,
          isSISLevel2Header: false,
          store: store,
          setShowLoginForm: setShowLoginForm
        })]
      }), modalVisible && deviceType !== 'desktop' && jsx(MarketplaceOverlay$1, {
        handlers: function handlers(e) {
          e.preventDefault();
          toggleModal(false);
          setModalVisible(false);
        }
      }), pushNotificationData.isVisible && jsx(Notification$1, {
        isMarketplace: true,
        requireInteraction: pushNotificationData.require_interaction,
        isVisible: pushNotificationData.isVisible,
        isWelcomeMessage: pushNotificationData.isWelcomeMessage,
        action: pushNotificationData.action,
        icon: pushNotificationData.icon,
        title: pushNotificationData.title,
        body: pushNotificationData.body,
        closeNotification: closeNotification
      })]
    }), jsx("style", {
      children: "\n          :root {\n           ".concat(topHeaderTextColor ? "--text-color: ".concat(topHeaderTextColor, ";") : '', "\n            ").concat(searchbar !== null && searchbar !== void 0 && searchbar.search_icon_background_color ? "--search-icon-background: ".concat(searchbar.search_icon_background_color, ";") : '', "\n            --icon-background: #333;\n            --border-color: 52, 62, 73;\n            ").concat(searchbar !== null && searchbar !== void 0 && searchbar.searchBarBorderRadius ? "--search-bar-border-radius: ".concat(searchbar.searchBarBorderRadius, ";") : '', "\n            ").concat(searchbar !== null && searchbar !== void 0 && searchbar.searchBarBorderRadius ? "--search-bar-button-icon-border-radius: ".concat(searchbar.searchBarBorderRadius, ";") : '', "\n            ").concat(searchbar !== null && searchbar !== void 0 && searchbar.searchBarBorderColor ? "--search-bar-border-color: ".concat(searchbar.searchBarBorderColor, ";") : '', "\n            ").concat(menuTextColor ? "--menu-text-color: ".concat(menuTextColor, ";") : '', "\n            ").concat(menuTextColor ? "--hamburger-menu-icon-color: ".concat(menuTextColor, ";") : '', "\n            ").concat(myOrdersTextColor ? "--my-orders-text-color: ".concat(myOrdersTextColor, ";") : '', "\n            ").concat(myAccountTextColor ? "--my-account-text-color: ".concat(myAccountTextColor, ";") : '', "\n            ").concat(fontFamily ? "--whitelabel-font-family: ".concat(fontFamily, ";") : '', "\n                  }\n        ")
    })]
  });
};
Header$2.propTypes = {
  styles: PropTypes.object.isRequired,
  atgBaseUrl: PropTypes.string.isRequired,
  attachResizeListener: PropTypes.func.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  currentLocation: PropTypes.string,
  currentSearchTerm: PropTypes.string,
  data: PropTypes.any,
  deviceType: PropTypes.string.isRequired,
  enableAnalyticsInfoCall: PropTypes.bool,
  forceATG: PropTypes.bool,
  getTypeaheadUrl: PropTypes.func,
  handleRouteChange: PropTypes.any,
  handleSoftRefresh: PropTypes.func,
  isATGLoginEnabled: PropTypes.bool,
  isDefaultComuna: PropTypes.bool,
  isGeoLocationEnabled: PropTypes.bool,
  isPopOverVisible: PropTypes.bool,
  isTypeAheadEnabled: PropTypes.bool,
  isZoneModalEnabled: PropTypes.bool,
  isWebPushNotificationEnabled: PropTypes.bool,
  isSisSodimacPdpEnabled: PropTypes.bool,
  onRouteChange: PropTypes.func,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  onUserLogout: PropTypes.func,
  refreshUserData: PropTypes.func.isRequired,
  selectedZone: PropTypes.object,
  setBusy: PropTypes.func.isRequired,
  locationPathname: PropTypes.string,
  store: PropTypes.string,
  unifiedLoginBaseUrl: PropTypes.string,
  userCartCount: PropTypes.string,
  transversalBannerConfig: PropTypes.shape({
    home: PropTypes.bool,
    pdp: PropTypes.bool,
    xlp: PropTypes.bool,
    basket: PropTypes.bool
  }),
  MobileAppWebView: PropTypes.bool
};
Header$2.defaultProps = {
  atgBaseUrl: '',
  catalystBaseUrl: '',
  currentLocation: '',
  currentSearchTerm: '',
  enableAnalyticsInfoCall: false,
  forceATG: false,
  handleSoftRefresh: noop$1,
  isATGLoginEnabled: false,
  isDefaultComuna: false,
  isGeoLocationEnabled: true,
  isPopOverVisible: false,
  isTypeAheadEnabled: true,
  isZoneModalEnabled: true,
  isWebPushNotificationEnabled: false,
  isSisSodimacPdpEnabled: false,
  onRouteChange: noop$1,
  onUserLogin: noop$1,
  onUserLoginComplete: noop$1,
  onUserLoginConsentsUpdate: noop$1,
  onUserLoginPasswordUpdate: noop$1,
  onUserLogout: noop$1,
  parentRouter: null,
  selectedZone: undefined,
  unifiedLoginBaseUrl: undefined,
  userCartCount: undefined,
  locationPathname: undefined,
  getTypeaheadUrl: apiConfig$2.getTypeaheadUrl,
  MobileAppWebView: false
};
var WhitelabelHeader = withUser(withLoader(withDevice(Header$2)));

var loadGoogleSiteVerification = function loadGoogleSiteVerification(_ref) {
  var tenant = _ref.tenant,
    store = _ref.store;
  if (!tenant || !store) {
    console.warn('GSV missing tenant or store');
    return null;
  }
  if (!GOOGLE_VERIFICATION_CODES[tenant]) {
    console.warn('GSV no codes found for tenant');
    return null;
  }
  var normalizedTenant = tenant.toLowerCase();
  var normalizedStore = store.toLowerCase();
  var googleVerificationCode = GOOGLE_VERIFICATION_CODES[normalizedTenant][normalizedStore];
  if (!googleVerificationCode) {
    console.warn('GSV tenat and store does not exist in config');
    return null;
  }
  var metaTag = document.createElement('meta');
  metaTag.setAttribute('name', 'google-site-verification');
  metaTag.setAttribute('content', googleVerificationCode);
  document.head.appendChild(metaTag);
};
var loadGoogleSiteVerification$1 = loadGoogleSiteVerification;

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Header = function Header(props) {
  var appCtx = useContext(AppContext$1);
  var _appCtx$MobileAppWebV = appCtx.MobileAppWebView,
    MobileAppWebView = _appCtx$MobileAppWebV === void 0 ? false : _appCtx$MobileAppWebV;
  var _useState = useState(appCtx.isSodimacStandAloneSite || props.isSodimacStandAloneSite),
    _useState2 = _slicedToArray(_useState, 2),
    isSodimacStandAloneSite = _useState2[0],
    setIsSodimacStandAloneSite = _useState2[1];
  var _useState3 = useState(appCtx.isTottusStandAloneSite || props.isTottusStandAloneSite),
    _useState4 = _slicedToArray(_useState3, 2),
    isTottusStandAloneSite = _useState4[0],
    setIsTottusStandAloneSite = _useState4[1];
  var _getStandaloneSite = getStandaloneSite(props.store),
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var checkIsSodimacStandalone = function checkIsSodimacStandalone() {
    if (isSodimacStandAloneSite) {
      return;
    }
    setIsSodimacStandAloneSite(isCurrentUrlSodimacStandAlone());
  };
  var checkIsTottusStandalone = function checkIsTottusStandalone() {
    if (isTottusStandAloneSite) {
      return;
    }
    setIsTottusStandAloneSite(isCurrentUrlTottusStandAlone());
  };
  useEffect(function () {
    checkIsSodimacStandalone();
    checkIsTottusStandalone();
    loadDigitalDataManager(props);
    loadVwoScript({
      isVwoEnabled: props.isVwoEnabled,
      tenant: appCtx.tenant || '',
      isSodimacStandAloneSite: isSodimacStandAloneSite,
      isTottusStandAloneSite: isTottusStandAloneSite
    });
    loadGoogleTagManager$1(_objectSpread$1(_objectSpread$1({}, props), {}, {
      isWhitelabelSite: isWhitelabelSite
    }));
    loadFingerprintTracking(props);
    loadMedallia$1(props);
    saveDigitalDataCookies();
    generateMetaTagsAPP(isSodimacStandAloneSite, isTottusStandAloneSite);
    loadGoogleSiteVerification$1({
      tenant: appCtx.tenant,
      store: props.store
    });
  }, []);
  var headerProps = _objectSpread$1(_objectSpread$1({}, props), {}, {
    styles: isWhitelabelSite ? whitelabelStyles : styles$4,
    MobileAppWebView: MobileAppWebView
  });
  if (isWhitelabelSite) {
    return jsx(WhitelabelHeader, _objectSpread$1({}, headerProps));
  }
  if (isSodimacStandAloneSite || isTottusStandAloneSite) {
    return jsx(StandaloneHeader, _objectSpread$1({}, headerProps));
  }
  return jsx(MarketplaceHeader, _objectSpread$1({}, headerProps));
};
Header.propTypes = {
  isRebrandingEnabled: PropTypes.bool,
  isDDMInitializationEnabled: PropTypes.bool,
  isVwoEnabled: PropTypes.bool,
  isFingerprintTrackingEnabled: PropTypes.bool,
  isGoogleTagManagerEnabled: PropTypes.bool,
  isSodimacStandAloneSite: PropTypes.bool,
  isTottusStandAloneSite: PropTypes.bool,
  MobileAppWebView: PropTypes.bool,
  store: PropTypes.string
};
Header.defaultProps = {
  isRebrandingEnabled: true,
  isDDMInitializationEnabled: true,
  isVwoEnabled: true,
  isFingerprintTrackingEnabled: true,
  isGoogleTagManagerEnabled: false,
  isSodimacStandAloneSite: false,
  isTottusStandAloneSite: false,
  MobileAppWebView: false
};
var Header$1 = Header;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var nameHOC = hocUtils$1.nameHOC;
var getDefaultTheme = function getDefaultTheme() {
  return {
    color: '#343E49',
    secondary_color: '#343E49'
  };
};
var useThemeContextHook = function useThemeContextHook(_ref) {
  var themes = _ref.themes,
    store = _ref.store;
  if (themes && store && themes[store] !== undefined && themes[store].color !== undefined) {
    return {
      theme: themes[store]
    };
  }
  if (themes && store && isWhitelabel(store) && themes.styles !== undefined) {
    return {
      theme: themes.styles
    };
  }
  return {
    theme: getDefaultTheme()
  };
};
var ThemeContext = createContainer(useThemeContextHook);
var withTheme = function withTheme(WrappedComponent) {
  var getInitialProps = WrappedComponent.getInitialProps;
  var ComponentWithTheme = function ComponentWithTheme(props) {
    var _ThemeContext = _slicedToArray(ThemeContext, 2);
      _ThemeContext[0];
      var useThemeContext = _ThemeContext[1];
    var _useThemeContext = useThemeContext(),
      theme = _useThemeContext.theme;
    return jsx(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
      theme: theme
    }));
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithTheme.getInitialProps = getInitialProps;
  }
  ComponentWithTheme.originalName = nameHOC(WrappedComponent);
  ComponentWithTheme.displayName = nameHOC(WrappedComponent, 'WithTheme');
  return ComponentWithTheme;
};

var getFooterData = function getFooterData(_ref) {
  var tenant = _ref.tenant,
    baseUrl = _ref.baseUrl,
    store = _ref.store;
  var validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
  return doFetch(getFooterDataUrl(baseUrl, validTenant, 'v3', store), {}, {
    triggerOnResponseError: true,
    triggerOnNetworkError: true
  });
};

export { Breadcrumbs$1 as Breadcrumbs, Favicons, Footer$1 as Footer, GoogleMaps$1 as GoogleMaps, Header$1 as Header, LoginModal$1 as LoginModal, MiniAccountWithLogin$1 as MiniAccountWithLogin, ContainerProvider$1 as Provider, SiSNavigationMenu$1 as SiSNavigationMenu, ThemeContext, UserContext$1 as UserContext, ZoneModal$1 as ZoneModal, getFooterData, getHeaderData, getSisNavigationMenu, getTaxonomyData, getTransversalData, withTheme, withUser };
